var n2 = Object.defineProperty;
var i2 = (e, r, o) => r in e ? n2(e, r, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[r] = o;
var Nc = (e, r, o) => (i2(e, typeof r != "symbol" ? r + "" : r, o), o);
import { utils as vt, BaseDocument as Ka, applyMixins as a2, actions as o2 } from "document-model/document";
import { z as he } from "./account-snapshot.js";
const s2 = {
  id: "makerdao/rwa-portfolio",
  name: "RealWorldAssets",
  extension: "",
  description: "",
  author: {
    name: "",
    website: ""
  },
  specifications: [
    {
      version: 1,
      changeLog: [],
      state: {
        global: {
          schema: `type RealWorldAssetsState {
    accounts: [Account!]!
    principalLenderAccountId: ID!
    spvs: [Spv!]!
    serviceProviderFeeTypes: [ServiceProviderFeeType!]!
    fixedIncomeTypes: [FixedIncomeType!]!
    portfolio: [Asset!]!
    transactions: [GroupTransaction!]!
}

union Asset = FixedIncome | Cash

type FixedIncome {
    id: ID!
 type: AssetType!    fixedIncomeTypeId: ID!
    name: String!
    spvId: ID!
    maturity: DateTime
    purchaseDate: DateTime!
    notional: Float!
    assetProceeds: Float!
    purchaseProceeds: Float!
    salesProceeds: Float!
    purchasePrice: Float!
    totalDiscount: Float!
    realizedSurplus: Float!
    ISIN: String
    CUSIP: String
    coupon: Float
}

type Cash {
    id: ID!
  type: AssetType!  spvId: ID!
    currency: String!
    balance: Float!
}

type FixedIncomeType {
    id: ID!
    name: String!
}

type Spv {
    id: ID!
    name: String!
}

enum AssetType { Cash FixedIncome }

type BaseTransaction {
    id: ID!
 assetType: AssetType!
    assetId: ID!
    amount: Float!
    entryTime: DateTime!
    tradeTime: DateTime
    settlementTime: DateTime
   accountId: ID
    counterPartyAccountId: ID
}

type Account {
    id: ID!
    reference: String!
    label: String
}

type TransactionFee {
    id: ID!
    serviceProviderFeeTypeId: ID!
    amount: Float!
}

type GroupTransaction {
    id: ID!
    type: GroupTransactionType!
    entryTime: DateTime!
    unitPrice: Float
    cashBalanceChange: Float!
    fees: [TransactionFee!]
    cashTransaction: BaseTransaction!
    fixedIncomeTransaction: BaseTransaction
 serviceProviderFeeTypeId: ID
 txRef: String 
}

enum GroupTransactionType {
    PrincipalDraw
    PrincipalReturn
    AssetPurchase
    AssetSale
 InterestIncome
    InterestPayment
  FeesIncome
  FeesPayment
}

type ServiceProviderFeeType {
    id: ID!
    name: String!
    feeType: String!
    accountId: ID!
}

scalar DateTime`,
          initialValue: '"{\\"accounts\\":[{\\"id\\":\\"principal-lender-account-id\\",\\"reference\\":\\"0x\\",\\"label\\":\\"Principal Lender\\"}],\\"principalLenderAccountId\\":\\"principal-lender-account-id\\",\\"spvs\\":[],\\"serviceProviderFeeTypes\\":[{\\"id\\":\\"principal-fee-type-id\\",\\"name\\":\\"Principal\\",\\"feeType\\":\\"Principal\\",\\"accountId\\":\\"principal-lender-account-id\\"}],\\"fixedIncomeTypes\\":[{\\"id\\":\\"treasury-bill\\",\\"name\\":\\"Treasury Bill\\"}],\\"portfolio\\":[{\\"id\\":\\"principal-asset-id\\",\\"type\\":\\"Cash\\",\\"spvId\\":\\"1\\",\\"currency\\":\\"USD\\",\\"balance\\":0}],\\"transactions\\":[]}"',
          examples: []
        },
        local: {
          schema: "",
          initialValue: '""',
          examples: []
        }
      },
      modules: [
        {
          id: "Yl/ZEXfD4sPUOGFuwNkNSnw8jaI=",
          name: "general",
          description: "",
          operations: [
            {
              id: "OSkSsemxe9jYh+/AGXsxUdEFnM4=",
              name: "CREATE_SPV",
              description: "",
              schema: `input CreateSpvInput {
    	id: ID!
  name: String!
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "DRF21J8LbR0FVeq5DvX+CnQaFZo=",
              name: "EDIT_SPV",
              description: "",
              schema: `input EditSpvInput {
    id: ID!
    name: String
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "lKR/ln4O+KeVAht2JyK9KGszlsQ=",
              name: "DELETE_SPV",
              description: "",
              schema: `input DeleteSpvInput {
    id: ID!
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "Q9FxdKfya8ND+MFhh3p7dzhW6/4=",
              name: "CREATE_SERVICE_PROVIDER_FEE_TYPE",
              description: "",
              schema: `input CreateServiceProviderFeeTypeInput {
    	id: ID!
	name: String!
	feeType: String!
	accountId: ID!
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "D2Zkwm89QJ8yeF1LOaNdlnh6mgk=",
              name: "EDIT_SERVICE_PROVIDER_FEE_TYPE",
              description: "",
              schema: `input EditServiceProviderFeeTypeInput {
   	id: ID!
	name: String
	feeType: String
	accountId:ID
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "VNIpnLnET2frJhUbA+rlP9W2Zgw=",
              name: "DELETE_SERVICE_PROVIDER_FEE_TYPE",
              description: "",
              schema: `input DeleteServiceProviderFeeTypeInput {
    id: ID!
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "YxZkL4RYFLjMp15BLCewmXiung4=",
              name: "CREATE_ACCOUNT",
              description: "",
              schema: `input CreateAccountInput {
    	id: ID!
	reference: String!
	label: String
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "SXWANm1SEXlrr9Mt+AUF8ZeJnv8=",
              name: "EDIT_ACCOUNT",
              description: "",
              schema: `input EditAccountInput {
    	id: ID!
	reference: String
	label: String
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "/bI2dshTNE+VO8yURiuofMaBSnk=",
              name: "DELETE_ACCOUNT",
              description: "",
              schema: `input DeleteAccountInput {
    	id: ID!
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            }
          ]
        },
        {
          id: "S6LkZyJzDgDLyvsPY3dg5omH4Kc=",
          name: "portfolio",
          description: "",
          operations: [
            {
              id: "5HsCtlGGDGgoNqDtvcVycSuJ7nQ=",
              name: "CREATE_FIXED_INCOME_TYPE",
              description: "",
              schema: `input CreateFixedIncomeTypeInput {
    id: ID!
    name: String!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "nKGLGOHqaxtn382PRYgMni6JKyo=",
              name: "EDIT_FIXED_INCOME_TYPE",
              description: "",
              schema: `input EditFixedIncomeTypeInput {
    id: ID!
    name: String
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "Ja0ufhN/5mYl2PUfvbEf58jeeJE=",
              name: "DELETE_FIXED_INCOME_TYPE",
              description: "",
              schema: `input DeleteFixedIncomeTypeInput {
    id: ID!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "nKGLGOHqaxtn382PRYgMni6JKyo=",
              name: "CREATE_FIXED_INCOME_ASSET",
              description: "",
              schema: `input EditFixedIncomeAssetInput {
    id: ID!
    fixedIncomeTypeId: ID # RwaFixedIncomeType.id
    spvId: ID # Spv.id
    name: String
    ISIN: String
    CUSIP: String
    coupon: Float
    maturity: DateTime
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "SsPBD1U5nYqTCRFu4g0+grvif8o=",
              name: "CREATE_CASH_ASSET",
              description: "",
              schema: `input CreateCashAssetInput {
		id: ID!
spvId: ID! # Spv.id
  currency: String! # Will always be "USD" for version 1
 balance: Float!}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "I2Cu0ePD1yWfsRBCKOVte4mI8JU=",
              name: "EDIT_FIXED_INCOME_ASSET",
              description: "",
              schema: `input EditFixedIncomeAssetInput {
    id: ID!
    fixedIncomeTypeId: ID # RwaFixedIncomeType.id
    spvId: ID # Spv.id
    name: String
    ISIN: String
    CUSIP: String
    coupon: Float
    maturity: DateTime
    purchaseDate: DateTime # Weighted average of underlying transactions
    notional: Float # Face value sum of the underlying transactions
    purchasePrice: Float # purchaseProceeds / notional
    purchaseProceeds: Float # Total cash outflow spent on purchases
    totalDiscount: Float # notional - purchaseProceeds
    marketValue: Float #
    annualizedYield: Float # (Purchase Price / ( Notional - Purchase Price)) x (365 / Days to Maturity ) * 100
    realizedSurplus: Float
    totalSurplus: Float
    ISIN: String
    CUSIP: String
    coupon: Float
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "s01BdyXEkcBm32feRrFd0BTQ+aM=",
              name: "EDIT_CASH_ASSET",
              description: "",
              schema: `input EditCashAssetInput {
	id: ID!
	spv: ID # Spv.id
  currency: String # Will always be "USD" for version 1
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "WiIOGpzs1TowDkkCvEM/IttAoJ8=",
              name: "DELETE_FIXED_INCOME_ASSET",
              description: "",
              schema: `input DeleteFixedIncomeAssetInput {
    id: ID!
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "oOuY9WG2Fb/i+LcI8r20LGEzEJQ=",
              name: "DELETE_CASH_ASSET",
              description: "",
              schema: `input DeleteCashAssetInput {
    id: ID!
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            }
          ]
        },
        {
          id: "aZsq8U7Vp3YLkmISdadGmXTVVNs=",
          name: "transactions",
          description: "",
          operations: [
            {
              id: "T3gWYNoqdT/tPrczgdpaCcQz5BI=",
              name: "CREATE_GROUP_TRANSACTION",
              description: "",
              schema: `input CreateGroupTransactionInput {
    id: ID!
    type: GroupTransactionType!
    entryTime: DateTime!
 fees: [TransactionFee!]
 cashTransaction: BaseTransaction!
    fixedIncomeTransaction: BaseTransaction
 serviceProviderFeeTypeId: ID
 txRef: String 
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "Wg49korUNLaDgD8nhiOYd88S+6g=",
              name: "EDIT_GROUP_TRANSACTION",
              description: "",
              schema: `input EditGroupTransactionInput {
    id: ID!
    type: GroupTransactionType
    entryTime: DateTime
 cashTransaction: BaseTransaction!
    fixedIncomeTransaction: BaseTransaction
 serviceProviderFeeTypeId: ID
 txRef: String 
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "NNmjlg5iSEA2ScWxm/ntnKakUdY=",
              name: "ADD_FEES_TO_GROUP_TRANSACTION",
              description: "",
              schema: `input AddFeesToGroupTransactionInput {
    id: ID!
    fees: [TransactionFee!]
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "5v8G77y68sc8EdQ3fYOszMyioUg=",
              name: "EDIT_GROUP_TRANSACTION_FEES",
              description: "",
              schema: `input EditTransactionFeeInput {
    serviceProviderFeeTypeId: ID
    amount: Float
}
 input EditGroupTransactionFeesInput {
    id: ID!
    fees: [EditTransactionFeeInput!]
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "jTpx/3AhIs6kvbCWQYVQpdDBLBo=",
              name: "REMOVE_FEES_FROM_GROUP_TRANSACTION",
              description: "",
              schema: `input RemoveFeesFromGroupTransactionInput {
    id: ID!
    feeIds: [ID!]
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "sVzG0QHIjUwD4IffaZ+47riwIVM=",
              name: "DELETE_GROUP_TRANSACTION",
              description: "",
              schema: `input DeleteGroupTransactionInput {
    id: ID!
}
`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            }
          ]
        }
      ]
    }
  ]
}, Um = (e) => e != null, u2 = he.any().refine((e) => Um(e)), Di = he.enum(["Cash", "FixedIncome"]), Za = he.enum(["AssetPurchase", "AssetSale", "FeesIncome", "FeesPayment", "InterestIncome", "InterestPayment", "PrincipalDraw", "PrincipalReturn"]);
function km() {
  return he.object({
    __typename: he.literal("Account").optional(),
    id: he.string(),
    label: he.string().nullable(),
    reference: he.string()
  });
}
function tf() {
  return he.object({
    fees: he.array(ja()).nullish(),
    id: he.string()
  });
}
function Hm() {
  return he.union([Gm(), Wm()]);
}
function mi() {
  return he.object({
    __typename: he.literal("BaseTransaction").optional(),
    accountId: he.string().nullable(),
    amount: he.number(),
    assetId: he.string(),
    assetType: Di,
    counterPartyAccountId: he.string().nullable(),
    entryTime: he.string().datetime(),
    id: he.string(),
    settlementTime: he.string().datetime().nullable(),
    tradeTime: he.string().datetime().nullable()
  });
}
function Iu() {
  return he.object({
    accountId: he.string().nullish(),
    amount: he.number().nullish(),
    assetId: he.string().nullish(),
    assetType: Di.nullish(),
    counterPartyAccountId: he.string().nullish(),
    entryTime: he.string().datetime().nullish(),
    id: he.string(),
    settlementTime: he.string().datetime().nullish(),
    tradeTime: he.string().datetime().nullish()
  });
}
function Gm() {
  return he.object({
    __typename: he.literal("Cash").optional(),
    balance: he.number(),
    currency: he.string(),
    id: he.string(),
    spvId: he.string(),
    type: Di
  });
}
function nf() {
  return he.object({
    id: he.string(),
    label: he.string().nullish(),
    reference: he.string()
  });
}
function af() {
  return he.object({
    balance: he.number(),
    currency: he.string(),
    id: he.string(),
    spvId: he.string()
  });
}
function of() {
  return he.object({
    CUSIP: he.string().nullish(),
    ISIN: he.string().nullish(),
    coupon: he.number().nullish(),
    fixedIncomeTypeId: he.string(),
    id: he.string(),
    maturity: he.string().datetime().nullish(),
    name: he.string(),
    spvId: he.string()
  });
}
function sf() {
  return he.object({
    id: he.string(),
    name: he.string()
  });
}
function uf() {
  return he.object({
    cashTransaction: mi(),
    entryTime: he.string().datetime(),
    fees: he.array(ja()).nullish(),
    fixedIncomeTransaction: mi().nullish(),
    id: he.string(),
    serviceProviderFeeTypeId: he.string().nullish(),
    txRef: he.string().nullish(),
    type: Za
  });
}
function ff() {
  return he.object({
    accountId: he.string(),
    feeType: he.string(),
    id: he.string(),
    name: he.string()
  });
}
function cf() {
  return he.object({
    id: he.string(),
    name: he.string()
  });
}
function lf() {
  return he.object({
    id: he.string()
  });
}
function df() {
  return he.object({
    id: he.string()
  });
}
function hf() {
  return he.object({
    id: he.string()
  });
}
function pf() {
  return he.object({
    id: he.string()
  });
}
function vf() {
  return he.object({
    id: he.string()
  });
}
function mf() {
  return he.object({
    id: he.string()
  });
}
function gf() {
  return he.object({
    id: he.string()
  });
}
function bf() {
  return he.object({
    id: he.string(),
    label: he.string().nullish(),
    reference: he.string().nullish()
  });
}
function yf() {
  return he.object({
    currency: he.string().nullish(),
    id: he.string(),
    spvId: he.string().nullish()
  });
}
function wf() {
  return he.object({
    CUSIP: he.string().nullish(),
    ISIN: he.string().nullish(),
    coupon: he.number().nullish(),
    fixedIncomeTypeId: he.string().nullish(),
    id: he.string(),
    maturity: he.string().datetime().nullish(),
    name: he.string().nullish(),
    spvId: he.string().nullish()
  });
}
function xf() {
  return he.object({
    id: he.string(),
    name: he.string().nullish()
  });
}
function Ef() {
  return he.object({
    fees: he.array(he.lazy(() => Vm())).nullish(),
    id: he.string()
  });
}
function Af() {
  return he.object({
    cashTransaction: he.lazy(() => Iu().nullish()),
    entryTime: he.string().datetime().nullish(),
    fixedIncomeTransaction: he.lazy(() => Iu().nullish()),
    id: he.string(),
    serviceProviderFeeTypeId: he.string().nullish(),
    txRef: he.string().nullish(),
    type: Za.nullish()
  });
}
function Sf() {
  return he.object({
    accountId: he.string().nullish(),
    feeType: he.string().nullish(),
    id: he.string(),
    name: he.string().nullish()
  });
}
function Df() {
  return he.object({
    id: he.string(),
    name: he.string().nullish()
  });
}
function Vm() {
  return he.object({
    amount: he.number().nullish(),
    id: he.string().nullish(),
    serviceProviderFeeTypeId: he.string().nullish()
  });
}
function Wm() {
  return he.object({
    __typename: he.literal("FixedIncome").optional(),
    CUSIP: he.string().nullable(),
    ISIN: he.string().nullable(),
    assetProceeds: he.number(),
    coupon: he.number().nullable(),
    fixedIncomeTypeId: he.string(),
    id: he.string(),
    maturity: he.string().datetime().nullable(),
    name: he.string(),
    notional: he.number(),
    purchaseDate: he.string().datetime(),
    purchasePrice: he.number(),
    purchaseProceeds: he.number(),
    realizedSurplus: he.number(),
    salesProceeds: he.number(),
    spvId: he.string(),
    totalDiscount: he.number(),
    type: Di
  });
}
function Km() {
  return he.object({
    __typename: he.literal("FixedIncomeType").optional(),
    id: he.string(),
    name: he.string()
  });
}
function Zm() {
  return he.object({
    __typename: he.literal("GroupTransaction").optional(),
    cashBalanceChange: he.number(),
    cashTransaction: mi(),
    entryTime: he.string().datetime(),
    fees: he.array(ja()).nullable(),
    fixedIncomeTransaction: mi().nullable(),
    id: he.string(),
    serviceProviderFeeTypeId: he.string().nullable(),
    txRef: he.string().nullable(),
    type: Za,
    unitPrice: he.number().nullable()
  });
}
function f2() {
  return he.object({
    __typename: he.literal("RealWorldAssetsState").optional(),
    accounts: he.array(km()),
    fixedIncomeTypes: he.array(Km()),
    portfolio: he.array(Hm()),
    principalLenderAccountId: he.string(),
    serviceProviderFeeTypes: he.array(jm()),
    spvs: he.array(Ym()),
    transactions: he.array(Zm())
  });
}
function Nf() {
  return he.object({
    feeIds: he.array(he.string()).nullish(),
    id: he.string()
  });
}
function jm() {
  return he.object({
    __typename: he.literal("ServiceProviderFeeType").optional(),
    accountId: he.string(),
    feeType: he.string(),
    id: he.string(),
    name: he.string()
  });
}
function Ym() {
  return he.object({
    __typename: he.literal("Spv").optional(),
    id: he.string(),
    name: he.string()
  });
}
function ja() {
  return he.object({
    __typename: he.literal("TransactionFee").optional(),
    amount: he.number(),
    id: he.string(),
    serviceProviderFeeTypeId: he.string()
  });
}
const fP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountSchema: km,
  AddFeesToGroupTransactionInputSchema: tf,
  AssetSchema: Hm,
  AssetTypeSchema: Di,
  BaseTransactionInputSchema: Iu,
  BaseTransactionSchema: mi,
  CashSchema: Gm,
  CreateAccountInputSchema: nf,
  CreateCashAssetInputSchema: af,
  CreateFixedIncomeAssetInputSchema: of,
  CreateFixedIncomeTypeInputSchema: sf,
  CreateGroupTransactionInputSchema: uf,
  CreateServiceProviderFeeTypeInputSchema: ff,
  CreateSpvInputSchema: cf,
  DeleteAccountInputSchema: lf,
  DeleteCashAssetInputSchema: df,
  DeleteFixedIncomeAssetInputSchema: hf,
  DeleteFixedIncomeTypeInputSchema: pf,
  DeleteGroupTransactionInputSchema: vf,
  DeleteServiceProviderFeeTypeInputSchema: mf,
  DeleteSpvInputSchema: gf,
  EditAccountInputSchema: bf,
  EditCashAssetInputSchema: yf,
  EditFixedIncomeAssetInputSchema: wf,
  EditFixedIncomeTypeInputSchema: xf,
  EditGroupTransactionFeesInputSchema: Ef,
  EditGroupTransactionInputSchema: Af,
  EditServiceProviderFeeTypeInputSchema: Sf,
  EditSpvInputSchema: Df,
  EditTransactionFeeInputSchema: Vm,
  FixedIncomeSchema: Wm,
  FixedIncomeTypeSchema: Km,
  GroupTransactionSchema: Zm,
  GroupTransactionTypeSchema: Za,
  RealWorldAssetsStateSchema: f2,
  RemoveFeesFromGroupTransactionInputSchema: Nf,
  ServiceProviderFeeTypeSchema: jm,
  SpvSchema: Ym,
  TransactionFeeSchema: ja,
  definedNonNullAnySchema: u2,
  isDefinedNonNullAny: Um
}, Symbol.toStringTag, { value: "Module" })), qt = {
  createSpvOperation(e, r, o) {
    if (!r.input.id)
      throw new Error("SPV must have an id");
    if (!r.input.name)
      throw new Error("SPV must have a name");
    if (e.spvs.find((n) => n.id === r.input.id))
      throw new Error(`SPV with id ${r.input.id} already exists!`);
    e.spvs.push(r.input);
  },
  editSpvOperation(e, r, o) {
    if (!r.input.id)
      throw new Error("SPV must have an id");
    if (!e.spvs.find((i) => i.id === r.input.id))
      throw new Error(`SPV with id ${r.input.id} does not exist!`);
    e.spvs = e.spvs.map(
      (i) => i.id === r.input.id ? {
        ...i,
        ...r.input
      } : i
    );
  },
  deleteSpvOperation(e, r, o) {
    const n = r.input.id;
    if (!n)
      throw new Error("SPV must have an id");
    if (!e.spvs.find((u) => u.id === n))
      throw new Error(`SPV with id ${n} does not exist!`);
    if (e.portfolio.filter((u) => u.spvId === n).length !== 0)
      throw new Error(
        "Cannot delete SPV because it has assets that depend on it. Please change or delete those assets first."
      );
    e.spvs = e.spvs.filter((u) => u.id !== n);
  },
  createServiceProviderFeeTypeOperation(e, r, o) {
    if (!r.input.id)
      throw new Error("Service provider must have an id");
    if (!r.input.name)
      throw new Error("Service provider must have a name");
    if (!r.input.feeType)
      throw new Error("Service provider must have a fee type");
    if (!r.input.accountId)
      throw new Error(
        "Service provider must have an associated account id"
      );
    if (!e.accounts.find(
      (n) => n.id === r.input.accountId
    ))
      throw new Error(
        `Account with id ${r.input.accountId} does not exist!`
      );
    if (e.serviceProviderFeeTypes.find(
      (n) => n.id === r.input.id
    ))
      throw new Error(
        `Service provider with id ${r.input.id} already exists!`
      );
    e.serviceProviderFeeTypes.push(r.input);
  },
  editServiceProviderFeeTypeOperation(e, r, o) {
    if (!r.input.id)
      throw new Error("Service provider must have an id");
    if (!e.serviceProviderFeeTypes.find(
      (i) => i.id === r.input.id
    ))
      throw new Error(
        `Service provider with id ${r.input.id} does not exist!`
      );
    if (r.input.accountId && !e.accounts.find(
      (i) => i.id === r.input.accountId
    ))
      throw new Error(
        `Account with id ${r.input.accountId} does not exist!`
      );
    e.serviceProviderFeeTypes = e.serviceProviderFeeTypes.map(
      (i) => i.id === r.input.id ? {
        ...i,
        ...r.input
      } : i
    );
  },
  deleteServiceProviderFeeTypeOperation(e, r, o) {
    const n = r.input.id;
    if (!n)
      throw new Error("Service provider fee type must have an id");
    if (!e.serviceProviderFeeTypes.find(
      (u) => u.id === n
    ))
      throw new Error(`Service provider with id ${n} does not exist!`);
    if (e.transactions.filter(
      (u) => {
        var l;
        return (l = u.fees) == null ? void 0 : l.some((f) => f.serviceProviderFeeTypeId === n);
      }
    ).length !== 0)
      throw new Error(
        "Cannot delete service provider fee type because it has transactions that depend on it. Please change or delete those transactions first."
      );
    e.serviceProviderFeeTypes = e.serviceProviderFeeTypes.filter(
      (u) => u.id !== n
    );
  },
  createAccountOperation(e, r, o) {
    if (!r.input.id)
      throw new Error("Account must have an id");
    if (!r.input.reference)
      throw new Error("Account must have a reference");
    if (e.accounts.find((n) => n.id === r.input.id))
      throw new Error(
        `Account with id ${r.input.id} already exists!`
      );
    e.accounts.push(r.input);
  },
  editAccountOperation(e, r, o) {
    if (!r.input.id)
      throw new Error("Account must have an id");
    if (!e.accounts.find(
      (i) => i.id === r.input.id
    ))
      throw new Error(
        `Account with id ${r.input.id} does not exist!`
      );
    e.accounts = e.accounts.map(
      (i) => i.id === r.input.id ? {
        ...i,
        ...r.input
      } : i
    );
  },
  deleteAccountOperation(e, r, o) {
    const n = r.input.id;
    if (!n)
      throw new Error("Account must have an id");
    if (n === e.principalLenderAccountId)
      throw new Error("Cannot delete principal lender account.");
    if (!e.accounts.find((l) => l.id === n))
      throw new Error(`Account with id ${n} does not exist!`);
    if (e.serviceProviderFeeTypes.filter((l) => l.accountId === n).length !== 0)
      throw new Error(
        "Cannot delete account because it has service provider fee types that depend on it. Please change or delete those service provider fee types first."
      );
    if (e.transactions.filter(
      (l) => {
        var f;
        return ((f = l.fixedIncomeTransaction) == null ? void 0 : f.accountId) === n || l.cashTransaction.accountId === n;
      }
    ).length !== 0)
      throw new Error(
        "Cannot delete account because it has transactions that depend on it. Please change or delete those transactions first."
      );
    e.accounts = e.accounts.filter((l) => l.id !== n);
  }
};
function kr() {
  return kr = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var o = arguments[r];
      for (var n in o)
        ({}).hasOwnProperty.call(o, n) && (e[n] = o[n]);
    }
    return e;
  }, kr.apply(null, arguments);
}
var Xm = {
  // minimum relative difference between two compared values,
  // used by all comparison functions
  relTol: 1e-12,
  // minimum absolute difference between two compared values,
  // used by all comparison functions
  absTol: 1e-15,
  // type of default matrix output. Choose 'matrix' (default) or 'array'
  matrix: "Matrix",
  // type of default number output. Choose 'number' (default) 'BigNumber', 'bigint', or 'Fraction'
  number: "number",
  // type of fallback used for config { number: 'bigint' } when a value cannot be represented
  // in the configured numeric type. Choose 'number' (default) or 'BigNumber'.
  numberFallback: "number",
  // number of significant digits in BigNumbers
  precision: 64,
  // predictable output type of functions. When true, output type depends only
  // on the input types. When false (default), output type can vary depending
  // on input values. For example `math.sqrt(-4)` returns `complex('2i')` when
  // predictable is false, and returns `NaN` when true.
  predictable: !1,
  // random seed for seeded pseudo random number generation
  // null = randomly seed
  randomSeed: null
};
function $e(e) {
  return typeof e == "number";
}
function Re(e) {
  return !e || typeof e != "object" || typeof e.constructor != "function" ? !1 : e.isBigNumber === !0 && typeof e.constructor.prototype == "object" && e.constructor.prototype.isBigNumber === !0 || typeof e.constructor.isDecimal == "function" && e.constructor.isDecimal(e) === !0;
}
function Jm(e) {
  return typeof e == "bigint";
}
function yt(e) {
  return e && typeof e == "object" && Object.getPrototypeOf(e).isComplex === !0 || !1;
}
function An(e) {
  return e && typeof e == "object" && Object.getPrototypeOf(e).isFraction === !0 || !1;
}
function jr(e) {
  return e && e.constructor.prototype.isUnit === !0 || !1;
}
function qr(e) {
  return typeof e == "string";
}
var ar = Array.isArray;
function Fe(e) {
  return e && e.constructor.prototype.isMatrix === !0 || !1;
}
function nt(e) {
  return Array.isArray(e) || Fe(e);
}
function gi(e) {
  return e && e.isDenseMatrix && e.constructor.prototype.isMatrix === !0 || !1;
}
function en(e) {
  return e && e.isSparseMatrix && e.constructor.prototype.isMatrix === !0 || !1;
}
function Ya(e) {
  return e && e.constructor.prototype.isRange === !0 || !1;
}
function Ni(e) {
  return e && e.constructor.prototype.isIndex === !0 || !1;
}
function Qm(e) {
  return typeof e == "boolean";
}
function e1(e) {
  return e && e.constructor.prototype.isResultSet === !0 || !1;
}
function Mf(e) {
  return e && e.constructor.prototype.isHelp === !0 || !1;
}
function r1(e) {
  return typeof e == "function";
}
function t1(e) {
  return e instanceof Date;
}
function n1(e) {
  return e instanceof RegExp;
}
function Mi(e) {
  return !!(e && typeof e == "object" && e.constructor === Object && !yt(e) && !An(e));
}
function i1(e) {
  return e === null;
}
function a1(e) {
  return e === void 0;
}
function nn(e) {
  return e && e.isAccessorNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function tt(e) {
  return e && e.isArrayNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function o1(e) {
  return e && e.isAssignmentNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function s1(e) {
  return e && e.isBlockNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function u1(e) {
  return e && e.isConditionalNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function rr(e) {
  return e && e.isConstantNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Ou(e) {
  return rr(e) || Cr(e) && e.args.length === 1 && rr(e.args[0]) && "-+~".includes(e.op);
}
function Yn(e) {
  return e && e.isFunctionAssignmentNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Gt(e) {
  return e && e.isFunctionNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Sn(e) {
  return e && e.isIndexNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function or(e) {
  return e && e.isNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function _i(e) {
  return e && e.isObjectNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Cr(e) {
  return e && e.isOperatorNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Dt(e) {
  return e && e.isParenthesisNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function f1(e) {
  return e && e.isRangeNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function c1(e) {
  return e && e.isRelationalNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function Br(e) {
  return e && e.isSymbolNode === !0 && e.constructor.prototype.isNode === !0 || !1;
}
function _f(e) {
  return e && e.constructor.prototype.isChain === !0 || !1;
}
function fr(e) {
  var r = typeof e;
  return r === "object" ? e === null ? "null" : Re(e) ? "BigNumber" : e.constructor && e.constructor.name ? e.constructor.name : "Object" : r;
}
function Ie(e) {
  var r = typeof e;
  if (r === "number" || r === "bigint" || r === "string" || r === "boolean" || e === null || e === void 0)
    return e;
  if (typeof e.clone == "function")
    return e.clone();
  if (Array.isArray(e))
    return e.map(function(o) {
      return Ie(o);
    });
  if (e instanceof Date)
    return new Date(e.valueOf());
  if (Re(e))
    return e;
  if (Mi(e))
    return c2(e, Ie);
  throw new TypeError("Cannot clone: unknown type of value (value: ".concat(e, ")"));
}
function c2(e, r) {
  var o = {};
  for (var n in e)
    De(e, n) && (o[n] = r(e[n]));
  return o;
}
function l1(e, r) {
  for (var o in r)
    De(r, o) && (e[o] = r[o]);
  return e;
}
function d1(e, r) {
  if (Array.isArray(r))
    throw new TypeError("Arrays are not supported by deepExtend");
  for (var o in r)
    if (De(r, o) && !(o in Object.prototype) && !(o in Function.prototype))
      if (r[o] && r[o].constructor === Object)
        e[o] === void 0 && (e[o] = {}), e[o] && e[o].constructor === Object ? d1(e[o], r[o]) : e[o] = r[o];
      else {
        if (Array.isArray(r[o]))
          throw new TypeError("Arrays are not supported by deepExtend");
        e[o] = r[o];
      }
  return e;
}
function Vt(e, r) {
  var o, n, i;
  if (Array.isArray(e)) {
    if (!Array.isArray(r) || e.length !== r.length)
      return !1;
    for (n = 0, i = e.length; n < i; n++)
      if (!Vt(e[n], r[n]))
        return !1;
    return !0;
  } else {
    if (typeof e == "function")
      return e === r;
    if (e instanceof Object) {
      if (Array.isArray(r) || !(r instanceof Object))
        return !1;
      for (o in e)
        if (!(o in r) || !Vt(e[o], r[o]))
          return !1;
      for (o in r)
        if (!(o in e))
          return !1;
      return !0;
    } else
      return e === r;
  }
}
function l2(e) {
  var r = {};
  return h1(e, r), r;
}
function h1(e, r) {
  for (var o in e)
    if (De(e, o)) {
      var n = e[o];
      typeof n == "object" && n !== null ? h1(n, r) : r[o] = n;
    }
}
function ga(e, r, o) {
  var n = !0, i;
  Object.defineProperty(e, r, {
    get: function() {
      return n && (i = o(), n = !1), i;
    },
    set: function(u) {
      i = u, n = !1;
    },
    configurable: !0,
    enumerable: !0
  });
}
function De(e, r) {
  return e && Object.hasOwnProperty.call(e, r);
}
function d2(e) {
  return e && typeof e.factory == "function";
}
function h2(e, r) {
  for (var o = {}, n = 0; n < r.length; n++) {
    var i = r[n], t = e[i];
    t !== void 0 && (o[i] = t);
  }
  return o;
}
var Mc = ["Matrix", "Array"], _c = ["number", "BigNumber", "Fraction"];
function p2(e, r) {
  function o(n) {
    if (n) {
      if (n.epsilon !== void 0) {
        console.warn('Warning: The configuration option "epsilon" is deprecated. Use "relTol" and "absTol" instead.');
        var i = Ie(n);
        return i.relTol = n.epsilon, i.absTol = n.epsilon * 1e-3, delete i.epsilon, o(i);
      }
      var t = Ie(e);
      Cc(n, "matrix", Mc), Cc(n, "number", _c), d1(e, n);
      var u = Ie(e), l = Ie(n);
      return r("config", u, t, l), u;
    } else
      return Ie(e);
  }
  return o.MATRIX_OPTIONS = Mc, o.NUMBER_OPTIONS = _c, Object.keys(Xm).forEach((n) => {
    Object.defineProperty(o, n, {
      get: () => e[n],
      enumerable: !0,
      configurable: !0
    });
  }), o;
}
function Cc(e, r, o) {
  e[r] !== void 0 && !o.includes(e[r]) && console.warn('Warning: Unknown value "' + e[r] + '" for configuration option "' + r + '". Available options: ' + o.map((n) => JSON.stringify(n)).join(", ") + ".");
}
function Tc() {
  return !0;
}
function ot() {
  return !1;
}
function _n() {
}
const Bc = "Argument is not a typed-function.";
function p1() {
  function e(Z) {
    return typeof Z == "object" && Z !== null && Z.constructor === Object;
  }
  const r = [{
    name: "number",
    test: function(Z) {
      return typeof Z == "number";
    }
  }, {
    name: "string",
    test: function(Z) {
      return typeof Z == "string";
    }
  }, {
    name: "boolean",
    test: function(Z) {
      return typeof Z == "boolean";
    }
  }, {
    name: "Function",
    test: function(Z) {
      return typeof Z == "function";
    }
  }, {
    name: "Array",
    test: Array.isArray
  }, {
    name: "Date",
    test: function(Z) {
      return Z instanceof Date;
    }
  }, {
    name: "RegExp",
    test: function(Z) {
      return Z instanceof RegExp;
    }
  }, {
    name: "Object",
    test: e
  }, {
    name: "null",
    test: function(Z) {
      return Z === null;
    }
  }, {
    name: "undefined",
    test: function(Z) {
      return Z === void 0;
    }
  }], o = {
    name: "any",
    test: Tc,
    isAny: !0
  };
  let n, i, t = 0, u = {
    createCount: 0
  };
  function l(Z) {
    const X = n.get(Z);
    if (X)
      return X;
    let oe = 'Unknown type "' + Z + '"';
    const ce = Z.toLowerCase();
    let le;
    for (le of i)
      if (le.toLowerCase() === ce) {
        oe += '. Did you mean "' + le + '" ?';
        break;
      }
    throw new TypeError(oe);
  }
  function f(Z) {
    let X = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "any";
    const oe = X ? l(X).index : i.length, ce = [];
    for (let ve = 0; ve < Z.length; ++ve) {
      if (!Z[ve] || typeof Z[ve].name != "string" || typeof Z[ve].test != "function")
        throw new TypeError("Object with properties {name: string, test: function} expected");
      const ge = Z[ve].name;
      if (n.has(ge))
        throw new TypeError('Duplicate type name "' + ge + '"');
      ce.push(ge), n.set(ge, {
        name: ge,
        test: Z[ve].test,
        isAny: Z[ve].isAny,
        index: oe + ve,
        conversionsTo: []
        // Newly added type can't have any conversions to it
      });
    }
    const le = i.slice(oe);
    i = i.slice(0, oe).concat(ce).concat(le);
    for (let ve = oe + ce.length; ve < i.length; ++ve)
      n.get(i[ve]).index = ve;
  }
  function s() {
    n = /* @__PURE__ */ new Map(), i = [], t = 0, f([o], !1);
  }
  s(), f(r);
  function a() {
    let Z;
    for (Z of i)
      n.get(Z).conversionsTo = [];
    t = 0;
  }
  function c(Z) {
    const X = i.filter((oe) => {
      const ce = n.get(oe);
      return !ce.isAny && ce.test(Z);
    });
    return X.length ? X : ["any"];
  }
  function d(Z) {
    return Z && typeof Z == "function" && "_typedFunctionData" in Z;
  }
  function h(Z, X, oe) {
    if (!d(Z))
      throw new TypeError(Bc);
    const ce = oe && oe.exact, le = Array.isArray(X) ? X.join(",") : X, ve = E(le), ge = g(ve);
    if (!ce || ge in Z.signatures) {
      const Ae = Z._typedFunctionData.signatureMap.get(ge);
      if (Ae)
        return Ae;
    }
    const me = ve.length;
    let we;
    if (ce) {
      we = [];
      let Ae;
      for (Ae in Z.signatures)
        we.push(Z._typedFunctionData.signatureMap.get(Ae));
    } else
      we = Z._typedFunctionData.signatures;
    for (let Ae = 0; Ae < me; ++Ae) {
      const _e = ve[Ae], Se = [];
      let Me;
      for (Me of we) {
        const H = O(Me.params, Ae);
        if (!(!H || _e.restParam && !H.restParam)) {
          if (!H.hasAny) {
            const ae = y(H);
            if (_e.types.some((de) => !ae.has(de.name)))
              continue;
          }
          Se.push(Me);
        }
      }
      if (we = Se, we.length === 0)
        break;
    }
    let be;
    for (be of we)
      if (be.params.length <= me)
        return be;
    throw new TypeError("Signature not found (signature: " + (Z.name || "unnamed") + "(" + g(ve, ", ") + "))");
  }
  function p(Z, X, oe) {
    return h(Z, X, oe).implementation;
  }
  function v(Z, X) {
    const oe = l(X);
    if (oe.test(Z))
      return Z;
    const ce = oe.conversionsTo;
    if (ce.length === 0)
      throw new Error("There are no conversions to " + X + " defined.");
    for (let le = 0; le < ce.length; le++)
      if (l(ce[le].from).test(Z))
        return ce[le].convert(Z);
    throw new Error("Cannot convert " + Z + " to " + X);
  }
  function g(Z) {
    let X = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    return Z.map((oe) => oe.name).join(X);
  }
  function m(Z) {
    const X = Z.indexOf("...") === 0, ce = (X ? Z.length > 3 ? Z.slice(3) : "any" : Z).split("|").map((me) => l(me.trim()));
    let le = !1, ve = X ? "..." : "";
    return {
      types: ce.map(function(me) {
        return le = me.isAny || le, ve += me.name + "|", {
          name: me.name,
          typeIndex: me.index,
          test: me.test,
          isAny: me.isAny,
          conversion: null,
          conversionIndex: -1
        };
      }),
      name: ve.slice(0, -1),
      // remove trailing '|' from above
      hasAny: le,
      hasConversion: !1,
      restParam: X
    };
  }
  function x(Z) {
    const X = Z.types.map((ge) => ge.name), oe = _(X);
    let ce = Z.hasAny, le = Z.name;
    const ve = oe.map(function(ge) {
      const me = l(ge.from);
      return ce = me.isAny || ce, le += "|" + ge.from, {
        name: ge.from,
        typeIndex: me.index,
        test: me.test,
        isAny: me.isAny,
        conversion: ge,
        conversionIndex: ge.index
      };
    });
    return {
      types: Z.types.concat(ve),
      name: le,
      hasAny: ce,
      hasConversion: ve.length > 0,
      restParam: Z.restParam
    };
  }
  function y(Z) {
    return Z.typeSet || (Z.typeSet = /* @__PURE__ */ new Set(), Z.types.forEach((X) => Z.typeSet.add(X.name))), Z.typeSet;
  }
  function E(Z) {
    const X = [];
    if (typeof Z != "string")
      throw new TypeError("Signatures must be strings");
    const oe = Z.trim();
    if (oe === "")
      return X;
    const ce = oe.split(",");
    for (let le = 0; le < ce.length; ++le) {
      const ve = m(ce[le].trim());
      if (ve.restParam && le !== ce.length - 1)
        throw new SyntaxError('Unexpected rest parameter "' + ce[le] + '": only allowed for the last parameter');
      if (ve.types.length === 0)
        return null;
      X.push(ve);
    }
    return X;
  }
  function N(Z) {
    const X = ne(Z);
    return X ? X.restParam : !1;
  }
  function S(Z) {
    if (!Z || Z.types.length === 0)
      return Tc;
    if (Z.types.length === 1)
      return l(Z.types[0].name).test;
    if (Z.types.length === 2) {
      const X = l(Z.types[0].name).test, oe = l(Z.types[1].name).test;
      return function(le) {
        return X(le) || oe(le);
      };
    } else {
      const X = Z.types.map(function(oe) {
        return l(oe.name).test;
      });
      return function(ce) {
        for (let le = 0; le < X.length; le++)
          if (X[le](ce))
            return !0;
        return !1;
      };
    }
  }
  function R(Z) {
    let X, oe, ce;
    if (N(Z)) {
      X = te(Z).map(S);
      const le = X.length, ve = S(ne(Z)), ge = function(me) {
        for (let we = le; we < me.length; we++)
          if (!ve(me[we]))
            return !1;
        return !0;
      };
      return function(we) {
        for (let be = 0; be < X.length; be++)
          if (!X[be](we[be]))
            return !1;
        return ge(we) && we.length >= le + 1;
      };
    } else
      return Z.length === 0 ? function(ve) {
        return ve.length === 0;
      } : Z.length === 1 ? (oe = S(Z[0]), function(ve) {
        return oe(ve[0]) && ve.length === 1;
      }) : Z.length === 2 ? (oe = S(Z[0]), ce = S(Z[1]), function(ve) {
        return oe(ve[0]) && ce(ve[1]) && ve.length === 2;
      }) : (X = Z.map(S), function(ve) {
        for (let ge = 0; ge < X.length; ge++)
          if (!X[ge](ve[ge]))
            return !1;
        return ve.length === X.length;
      });
  }
  function O(Z, X) {
    return X < Z.length ? Z[X] : N(Z) ? ne(Z) : null;
  }
  function B(Z, X) {
    const oe = O(Z, X);
    return oe ? y(oe) : /* @__PURE__ */ new Set();
  }
  function $(Z) {
    return Z.conversion === null || Z.conversion === void 0;
  }
  function F(Z, X) {
    const oe = /* @__PURE__ */ new Set();
    return Z.forEach((ce) => {
      const le = B(ce.params, X);
      let ve;
      for (ve of le)
        oe.add(ve);
    }), oe.has("any") ? ["any"] : Array.from(oe);
  }
  function w(Z, X, oe) {
    let ce, le;
    const ve = Z || "unnamed";
    let ge = oe, me;
    for (me = 0; me < X.length; me++) {
      const _e = [];
      if (ge.forEach((Se) => {
        const Me = O(Se.params, me), H = S(Me);
        (me < Se.params.length || N(Se.params)) && H(X[me]) && _e.push(Se);
      }), _e.length === 0) {
        if (le = F(ge, me), le.length > 0) {
          const Se = c(X[me]);
          return ce = new TypeError("Unexpected type of argument in function " + ve + " (expected: " + le.join(" or ") + ", actual: " + Se.join(" | ") + ", index: " + me + ")"), ce.data = {
            category: "wrongType",
            fn: ve,
            index: me,
            actual: Se,
            expected: le
          }, ce;
        }
      } else
        ge = _e;
    }
    const we = ge.map(function(_e) {
      return N(_e.params) ? 1 / 0 : _e.params.length;
    });
    if (X.length < Math.min.apply(null, we))
      return le = F(ge, me), ce = new TypeError("Too few arguments in function " + ve + " (expected: " + le.join(" or ") + ", index: " + X.length + ")"), ce.data = {
        category: "tooFewArgs",
        fn: ve,
        index: X.length,
        expected: le
      }, ce;
    const be = Math.max.apply(null, we);
    if (X.length > be)
      return ce = new TypeError("Too many arguments in function " + ve + " (expected: " + be + ", actual: " + X.length + ")"), ce.data = {
        category: "tooManyArgs",
        fn: ve,
        index: X.length,
        expectedLength: be
      }, ce;
    const Ae = [];
    for (let _e = 0; _e < X.length; ++_e)
      Ae.push(c(X[_e]).join("|"));
    return ce = new TypeError('Arguments of type "' + Ae.join(", ") + '" do not match any of the defined signatures of function ' + ve + "."), ce.data = {
      category: "mismatch",
      actual: Ae
    }, ce;
  }
  function A(Z) {
    let X = i.length + 1;
    for (let oe = 0; oe < Z.types.length; oe++)
      $(Z.types[oe]) && (X = Math.min(X, Z.types[oe].typeIndex));
    return X;
  }
  function b(Z) {
    let X = t + 1;
    for (let oe = 0; oe < Z.types.length; oe++)
      $(Z.types[oe]) || (X = Math.min(X, Z.types[oe].conversionIndex));
    return X;
  }
  function D(Z, X) {
    if (Z.hasAny) {
      if (!X.hasAny)
        return 1;
    } else if (X.hasAny)
      return -1;
    if (Z.restParam) {
      if (!X.restParam)
        return 1;
    } else if (X.restParam)
      return -1;
    if (Z.hasConversion) {
      if (!X.hasConversion)
        return 1;
    } else if (X.hasConversion)
      return -1;
    const oe = A(Z) - A(X);
    if (oe < 0)
      return -1;
    if (oe > 0)
      return 1;
    const ce = b(Z) - b(X);
    return ce < 0 ? -1 : ce > 0 ? 1 : 0;
  }
  function M(Z, X) {
    const oe = Z.params, ce = X.params, le = ne(oe), ve = ne(ce), ge = N(oe), me = N(ce);
    if (ge && le.hasAny) {
      if (!me || !ve.hasAny)
        return 1;
    } else if (me && ve.hasAny)
      return -1;
    let we = 0, be = 0, Ae;
    for (Ae of oe)
      Ae.hasAny && ++we, Ae.hasConversion && ++be;
    let _e = 0, Se = 0;
    for (Ae of ce)
      Ae.hasAny && ++_e, Ae.hasConversion && ++Se;
    if (we !== _e)
      return we - _e;
    if (ge && le.hasConversion) {
      if (!me || !ve.hasConversion)
        return 1;
    } else if (me && ve.hasConversion)
      return -1;
    if (be !== Se)
      return be - Se;
    if (ge) {
      if (!me)
        return 1;
    } else if (me)
      return -1;
    const Me = (oe.length - ce.length) * (ge ? -1 : 1);
    if (Me !== 0)
      return Me;
    const H = [];
    let ae = 0;
    for (let ye = 0; ye < oe.length; ++ye) {
      const Ne = D(oe[ye], ce[ye]);
      H.push(Ne), ae += Ne;
    }
    if (ae !== 0)
      return ae;
    let de;
    for (de of H)
      if (de !== 0)
        return de;
    return 0;
  }
  function _(Z) {
    if (Z.length === 0)
      return [];
    const X = Z.map(l);
    Z.length > 1 && X.sort((le, ve) => le.index - ve.index);
    let oe = X[0].conversionsTo;
    if (Z.length === 1)
      return oe;
    oe = oe.concat([]);
    const ce = new Set(Z);
    for (let le = 1; le < X.length; ++le) {
      let ve;
      for (ve of X[le].conversionsTo)
        ce.has(ve.from) || (oe.push(ve), ce.add(ve.from));
    }
    return oe;
  }
  function q(Z, X) {
    let oe = X;
    if (Z.some((le) => le.hasConversion)) {
      const le = N(Z), ve = Z.map(C);
      oe = function() {
        const me = [], we = le ? arguments.length - 1 : arguments.length;
        for (let be = 0; be < we; be++)
          me[be] = ve[be](arguments[be]);
        return le && (me[we] = arguments[we].map(ve[we])), X.apply(this, me);
      };
    }
    let ce = oe;
    if (N(Z)) {
      const le = Z.length - 1;
      ce = function() {
        return oe.apply(this, ue(arguments, 0, le).concat([ue(arguments, le)]));
      };
    }
    return ce;
  }
  function C(Z) {
    let X, oe, ce, le;
    const ve = [], ge = [];
    switch (Z.types.forEach(function(me) {
      me.conversion && (ve.push(l(me.conversion.from).test), ge.push(me.conversion.convert));
    }), ge.length) {
      case 0:
        return function(we) {
          return we;
        };
      case 1:
        return X = ve[0], ce = ge[0], function(we) {
          return X(we) ? ce(we) : we;
        };
      case 2:
        return X = ve[0], oe = ve[1], ce = ge[0], le = ge[1], function(we) {
          return X(we) ? ce(we) : oe(we) ? le(we) : we;
        };
      default:
        return function(we) {
          for (let be = 0; be < ge.length; be++)
            if (ve[be](we))
              return ge[be](we);
          return we;
        };
    }
  }
  function T(Z) {
    function X(oe, ce, le) {
      if (ce < oe.length) {
        const ve = oe[ce];
        let ge = [];
        if (ve.restParam) {
          const me = ve.types.filter($);
          me.length < ve.types.length && ge.push({
            types: me,
            name: "..." + me.map((we) => we.name).join("|"),
            hasAny: me.some((we) => we.isAny),
            hasConversion: !1,
            restParam: !0
          }), ge.push(ve);
        } else
          ge = ve.types.map(function(me) {
            return {
              types: [me],
              name: me.name,
              hasAny: me.isAny,
              hasConversion: me.conversion,
              restParam: !1
            };
          });
        return W(ge, function(me) {
          return X(oe, ce + 1, le.concat([me]));
        });
      } else
        return [le];
    }
    return X(Z, 0, []);
  }
  function z(Z, X) {
    const oe = Math.max(Z.length, X.length);
    for (let me = 0; me < oe; me++) {
      const we = B(Z, me), be = B(X, me);
      let Ae = !1, _e;
      for (_e of be)
        if (we.has(_e)) {
          Ae = !0;
          break;
        }
      if (!Ae)
        return !1;
    }
    const ce = Z.length, le = X.length, ve = N(Z), ge = N(X);
    return ve ? ge ? ce === le : le >= ce : ge ? ce >= le : ce === le;
  }
  function I(Z) {
    return Z.map((X) => L(X) ? Y(X.referToSelf.callback) : k(X) ? pe(X.referTo.references, X.referTo.callback) : X);
  }
  function U(Z, X, oe) {
    const ce = [];
    let le;
    for (le of Z) {
      let ve = oe[le];
      if (typeof ve != "number")
        throw new TypeError('No definition for referenced signature "' + le + '"');
      if (ve = X[ve], typeof ve != "function")
        return !1;
      ce.push(ve);
    }
    return ce;
  }
  function ee(Z, X, oe) {
    const ce = I(Z), le = new Array(ce.length).fill(!1);
    let ve = !0;
    for (; ve; ) {
      ve = !1;
      let ge = !0;
      for (let me = 0; me < ce.length; ++me) {
        if (le[me])
          continue;
        const we = ce[me];
        if (L(we))
          ce[me] = we.referToSelf.callback(oe), ce[me].referToSelf = we.referToSelf, le[me] = !0, ge = !1;
        else if (k(we)) {
          const be = U(we.referTo.references, ce, X);
          be ? (ce[me] = we.referTo.callback.apply(this, be), ce[me].referTo = we.referTo, le[me] = !0, ge = !1) : ve = !0;
        }
      }
      if (ge && ve)
        throw new SyntaxError("Circular reference detected in resolving typed.referTo");
    }
    return ce;
  }
  function se(Z) {
    const X = /\bthis(\(|\.signatures\b)/;
    Object.keys(Z).forEach((oe) => {
      const ce = Z[oe];
      if (X.test(ce.toString()))
        throw new SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
    });
  }
  function K(Z, X) {
    if (u.createCount++, Object.keys(X).length === 0)
      throw new SyntaxError("No signatures provided");
    u.warnAgainstDeprecatedThis && se(X);
    const oe = [], ce = [], le = {}, ve = [];
    let ge;
    for (ge in X) {
      if (!Object.prototype.hasOwnProperty.call(X, ge))
        continue;
      const er = E(ge);
      if (!er)
        continue;
      oe.forEach(function(Qr) {
        if (z(Qr, er))
          throw new TypeError('Conflicting signatures "' + g(Qr) + '" and "' + g(er) + '".');
      }), oe.push(er);
      const _r = ce.length;
      ce.push(X[ge]);
      const Rt = er.map(x);
      let at;
      for (at of T(Rt)) {
        const Qr = g(at);
        ve.push({
          params: at,
          name: Qr,
          fn: _r
        }), at.every((Pt) => !Pt.hasConversion) && (le[Qr] = _r);
      }
    }
    ve.sort(M);
    const me = ee(ce, le, Jr);
    let we;
    for (we in le)
      Object.prototype.hasOwnProperty.call(le, we) && (le[we] = me[le[we]]);
    const be = [], Ae = /* @__PURE__ */ new Map();
    for (we of ve)
      Ae.has(we.name) || (we.fn = me[we.fn], be.push(we), Ae.set(we.name, we));
    const _e = be[0] && be[0].params.length <= 2 && !N(be[0].params), Se = be[1] && be[1].params.length <= 2 && !N(be[1].params), Me = be[2] && be[2].params.length <= 2 && !N(be[2].params), H = be[3] && be[3].params.length <= 2 && !N(be[3].params), ae = be[4] && be[4].params.length <= 2 && !N(be[4].params), de = be[5] && be[5].params.length <= 2 && !N(be[5].params), ye = _e && Se && Me && H && ae && de;
    for (let er = 0; er < be.length; ++er)
      be[er].test = R(be[er].params);
    const Ne = _e ? S(be[0].params[0]) : ot, Ee = Se ? S(be[1].params[0]) : ot, Qe = Me ? S(be[2].params[0]) : ot, dr = H ? S(be[3].params[0]) : ot, Le = ae ? S(be[4].params[0]) : ot, mr = de ? S(be[5].params[0]) : ot, gr = _e ? S(be[0].params[1]) : ot, Ue = Se ? S(be[1].params[1]) : ot, br = Me ? S(be[2].params[1]) : ot, yr = H ? S(be[3].params[1]) : ot, ke = ae ? S(be[4].params[1]) : ot, wr = de ? S(be[5].params[1]) : ot;
    for (let er = 0; er < be.length; ++er)
      be[er].implementation = q(be[er].params, be[er].fn);
    const xr = _e ? be[0].implementation : _n, He = Se ? be[1].implementation : _n, Er = Me ? be[2].implementation : _n, Ar = H ? be[3].implementation : _n, Ge = ae ? be[4].implementation : _n, Sr = de ? be[5].implementation : _n, Dr = _e ? be[0].params.length : -1, Ve = Se ? be[1].params.length : -1, Nr = Me ? be[2].params.length : -1, pr = H ? be[3].params.length : -1, vr = ae ? be[4].params.length : -1, Ct = de ? be[5].params.length : -1, Tt = ye ? 6 : 0, Bt = be.length, Ft = be.map((er) => er.test), It = be.map((er) => er.implementation), Ot = function() {
      for (let _r = Tt; _r < Bt; _r++)
        if (Ft[_r](arguments))
          return It[_r].apply(this, arguments);
      return u.onMismatch(Z, arguments, be);
    };
    function Jr(er, _r) {
      return arguments.length === Dr && Ne(er) && gr(_r) ? xr.apply(this, arguments) : arguments.length === Ve && Ee(er) && Ue(_r) ? He.apply(this, arguments) : arguments.length === Nr && Qe(er) && br(_r) ? Er.apply(this, arguments) : arguments.length === pr && dr(er) && yr(_r) ? Ar.apply(this, arguments) : arguments.length === vr && Le(er) && ke(_r) ? Ge.apply(this, arguments) : arguments.length === Ct && mr(er) && wr(_r) ? Sr.apply(this, arguments) : Ot.apply(this, arguments);
    }
    try {
      Object.defineProperty(Jr, "name", {
        value: Z
      });
    } catch {
    }
    return Jr.signatures = le, Jr._typedFunctionData = {
      signatures: be,
      signatureMap: Ae
    }, Jr;
  }
  function J(Z, X, oe) {
    throw w(Z, X, oe);
  }
  function te(Z) {
    return ue(Z, 0, Z.length - 1);
  }
  function ne(Z) {
    return Z[Z.length - 1];
  }
  function ue(Z, X, oe) {
    return Array.prototype.slice.call(Z, X, oe);
  }
  function V(Z, X) {
    for (let oe = 0; oe < Z.length; oe++)
      if (X(Z[oe]))
        return Z[oe];
  }
  function W(Z, X) {
    return Array.prototype.concat.apply([], Z.map(X));
  }
  function fe() {
    const Z = te(arguments).map((oe) => g(E(oe))), X = ne(arguments);
    if (typeof X != "function")
      throw new TypeError("Callback function expected as last argument");
    return pe(Z, X);
  }
  function pe(Z, X) {
    return {
      referTo: {
        references: Z,
        callback: X
      }
    };
  }
  function Y(Z) {
    if (typeof Z != "function")
      throw new TypeError("Callback function expected as first argument");
    return {
      referToSelf: {
        callback: Z
      }
    };
  }
  function k(Z) {
    return Z && typeof Z.referTo == "object" && Array.isArray(Z.referTo.references) && typeof Z.referTo.callback == "function";
  }
  function L(Z) {
    return Z && typeof Z.referToSelf == "object" && typeof Z.referToSelf.callback == "function";
  }
  function P(Z, X) {
    if (!Z)
      return X;
    if (X && X !== Z) {
      const oe = new Error("Function names do not match (expected: " + Z + ", actual: " + X + ")");
      throw oe.data = {
        actual: X,
        expected: Z
      }, oe;
    }
    return Z;
  }
  function G(Z) {
    let X;
    for (const oe in Z)
      Object.prototype.hasOwnProperty.call(Z, oe) && (d(Z[oe]) || typeof Z[oe].signature == "string") && (X = P(X, Z[oe].name));
    return X;
  }
  function j(Z, X) {
    let oe;
    for (oe in X)
      if (Object.prototype.hasOwnProperty.call(X, oe)) {
        if (oe in Z && X[oe] !== Z[oe]) {
          const ce = new Error('Signature "' + oe + '" is defined twice');
          throw ce.data = {
            signature: oe,
            sourceFunction: X[oe],
            destFunction: Z[oe]
          }, ce;
        }
        Z[oe] = X[oe];
      }
  }
  const re = u;
  u = function(Z) {
    const X = typeof Z == "string", oe = X ? 1 : 0;
    let ce = X ? Z : "";
    const le = {};
    for (let ve = oe; ve < arguments.length; ++ve) {
      const ge = arguments[ve];
      let me = {}, we;
      if (typeof ge == "function" ? (we = ge.name, typeof ge.signature == "string" ? me[ge.signature] = ge : d(ge) && (me = ge.signatures)) : e(ge) && (me = ge, X || (we = G(ge))), Object.keys(me).length === 0) {
        const be = new TypeError("Argument to 'typed' at index " + ve + " is not a (typed) function, nor an object with signatures as keys and functions as values.");
        throw be.data = {
          index: ve,
          argument: ge
        }, be;
      }
      X || (ce = P(ce, we)), j(le, me);
    }
    return K(ce || "", le);
  }, u.create = p1, u.createCount = re.createCount, u.onMismatch = J, u.throwMismatchError = J, u.createError = w, u.clear = s, u.clearConversions = a, u.addTypes = f, u._findType = l, u.referTo = fe, u.referToSelf = Y, u.convert = v, u.findSignature = h, u.find = p, u.isTypedFunction = d, u.warnAgainstDeprecatedThis = !0, u.addType = function(Z, X) {
    let oe = "any";
    X !== !1 && n.has("Object") && (oe = "Object"), u.addTypes([Z], oe);
  };
  function ie(Z) {
    if (!Z || typeof Z.from != "string" || typeof Z.to != "string" || typeof Z.convert != "function")
      throw new TypeError("Object with properties {from: string, to: string, convert: function} expected");
    if (Z.to === Z.from)
      throw new SyntaxError('Illegal to define conversion from "' + Z.from + '" to itself.');
  }
  return u.addConversion = function(Z) {
    let X = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      override: !1
    };
    ie(Z);
    const oe = l(Z.to), ce = oe.conversionsTo.find((le) => le.from === Z.from);
    if (ce)
      if (X && X.override)
        u.removeConversion({
          from: ce.from,
          to: Z.to,
          convert: ce.convert
        });
      else
        throw new Error('There is already a conversion from "' + Z.from + '" to "' + oe.name + '"');
    oe.conversionsTo.push({
      from: Z.from,
      convert: Z.convert,
      index: t++
    });
  }, u.addConversions = function(Z, X) {
    Z.forEach((oe) => u.addConversion(oe, X));
  }, u.removeConversion = function(Z) {
    ie(Z);
    const X = l(Z.to), oe = V(X.conversionsTo, (le) => le.from === Z.from);
    if (!oe)
      throw new Error("Attempt to remove nonexistent conversion from " + Z.from + " to " + Z.to);
    if (oe.convert !== Z.convert)
      throw new Error("Conversion to remove does not match existing conversion");
    const ce = X.conversionsTo.indexOf(oe);
    X.conversionsTo.splice(ce, 1);
  }, u.resolve = function(Z, X) {
    if (!d(Z))
      throw new TypeError(Bc);
    const oe = Z._typedFunctionData.signatures;
    for (let ce = 0; ce < oe.length; ++ce)
      if (oe[ce].test(X))
        return oe[ce];
    return null;
  }, u;
}
const wn = p1();
function Te(e) {
  return typeof e == "boolean" ? !0 : isFinite(e) ? e === Math.round(e) : !1;
}
function v2(e) {
  return /^-?\d+$/.test(e);
}
function sn(e, r) {
  return r.number === "bigint" && !v2(e) ? r.numberFallback : r.number;
}
var rn = Math.sign || function(e) {
  return e > 0 ? 1 : e < 0 ? -1 : 0;
}, m2 = Math.log2 || function(r) {
  return Math.log(r) / Math.LN2;
}, g2 = Math.log10 || function(r) {
  return Math.log(r) / Math.LN10;
}, b2 = Math.log1p || function(e) {
  return Math.log(e + 1);
}, y2 = Math.cbrt || function(r) {
  if (r === 0)
    return r;
  var o = r < 0, n;
  return o && (r = -r), isFinite(r) ? (n = Math.exp(Math.log(r) / 3), n = (r / (n * n) + 2 * n) / 3) : n = r, o ? -n : n;
}, w2 = Math.expm1 || function(r) {
  return r >= 2e-4 || r <= -2e-4 ? Math.exp(r) - 1 : r + r * r / 2 + r * r * r / 6;
};
function bo(e, r, o) {
  var n = {
    2: "0b",
    8: "0o",
    16: "0x"
  }, i = n[r], t = "";
  if (o) {
    if (o < 1)
      throw new Error("size must be in greater than 0");
    if (!Te(o))
      throw new Error("size must be an integer");
    if (e > 2 ** (o - 1) - 1 || e < -(2 ** (o - 1)))
      throw new Error("Value must be in range [-2^".concat(o - 1, ", 2^").concat(o - 1, "-1]"));
    if (!Te(e))
      throw new Error("Value must be an integer");
    e < 0 && (e = e + 2 ** o), t = "i".concat(o);
  }
  var u = "";
  return e < 0 && (e = -e, u = "-"), "".concat(u).concat(i).concat(e.toString(r)).concat(t);
}
function xn(e, r) {
  if (typeof r == "function")
    return r(e);
  if (e === 1 / 0)
    return "Infinity";
  if (e === -1 / 0)
    return "-Infinity";
  if (isNaN(e))
    return "NaN";
  var {
    notation: o,
    precision: n,
    wordSize: i
  } = v1(r);
  switch (o) {
    case "fixed":
      return m1(e, n);
    case "exponential":
      return g1(e, n);
    case "engineering":
      return x2(e, n);
    case "bin":
      return bo(e, 2, i);
    case "oct":
      return bo(e, 8, i);
    case "hex":
      return bo(e, 16, i);
    case "auto":
      return E2(e, n, r).replace(/((\.\d*?)(0+))($|e)/, function() {
        var t = arguments[2], u = arguments[4];
        return t !== "." ? t + u : u;
      });
    default:
      throw new Error('Unknown notation "' + o + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function v1(e) {
  var r = "auto", o, n;
  if (e !== void 0)
    if ($e(e))
      o = e;
    else if (Re(e))
      o = e.toNumber();
    else if (Mi(e))
      e.precision !== void 0 && (o = Fc(e.precision, () => {
        throw new Error('Option "precision" must be a number or BigNumber');
      })), e.wordSize !== void 0 && (n = Fc(e.wordSize, () => {
        throw new Error('Option "wordSize" must be a number or BigNumber');
      })), e.notation && (r = e.notation);
    else
      throw new Error("Unsupported type of options, number, BigNumber, or object expected");
  return {
    notation: r,
    precision: o,
    wordSize: n
  };
}
function Ci(e) {
  var r = String(e).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
  if (!r)
    throw new SyntaxError("Invalid number " + e);
  var o = r[1], n = r[2], i = parseFloat(r[4] || "0"), t = n.indexOf(".");
  i += t !== -1 ? t - 1 : n.length - 1;
  var u = n.replace(".", "").replace(/^0*/, function(l) {
    return i -= l.length, "";
  }).replace(/0*$/, "").split("").map(function(l) {
    return parseInt(l);
  });
  return u.length === 0 && (u.push(0), i++), {
    sign: o,
    coefficients: u,
    exponent: i
  };
}
function x2(e, r) {
  if (isNaN(e) || !isFinite(e))
    return String(e);
  var o = Ci(e), n = Xa(o, r), i = n.exponent, t = n.coefficients, u = i % 3 === 0 ? i : i < 0 ? i - 3 - i % 3 : i - i % 3;
  if ($e(r))
    for (; r > t.length || i - u + 1 > t.length; )
      t.push(0);
  else
    for (var l = Math.abs(i - u) - (t.length - 1), f = 0; f < l; f++)
      t.push(0);
  for (var s = Math.abs(i - u), a = 1; s > 0; )
    a++, s--;
  var c = t.slice(a).join(""), d = $e(r) && c.length || c.match(/[1-9]/) ? "." + c : "", h = t.slice(0, a).join("") + d + "e" + (i >= 0 ? "+" : "") + u.toString();
  return n.sign + h;
}
function m1(e, r) {
  if (isNaN(e) || !isFinite(e))
    return String(e);
  var o = Ci(e), n = typeof r == "number" ? Xa(o, o.exponent + 1 + r) : o, i = n.coefficients, t = n.exponent + 1, u = t + (r || 0);
  return i.length < u && (i = i.concat($n(u - i.length))), t < 0 && (i = $n(-t + 1).concat(i), t = 1), t < i.length && i.splice(t, 0, t === 0 ? "0." : "."), n.sign + i.join("");
}
function g1(e, r) {
  if (isNaN(e) || !isFinite(e))
    return String(e);
  var o = Ci(e), n = r ? Xa(o, r) : o, i = n.coefficients, t = n.exponent;
  i.length < r && (i = i.concat($n(r - i.length)));
  var u = i.shift();
  return n.sign + u + (i.length > 0 ? "." + i.join("") : "") + "e" + (t >= 0 ? "+" : "") + t;
}
function E2(e, r, o) {
  if (isNaN(e) || !isFinite(e))
    return String(e);
  var n = Ic(o == null ? void 0 : o.lowerExp, -3), i = Ic(o == null ? void 0 : o.upperExp, 5), t = Ci(e), u = r ? Xa(t, r) : t;
  if (u.exponent < n || u.exponent >= i)
    return g1(e, r);
  var l = u.coefficients, f = u.exponent;
  l.length < r && (l = l.concat($n(r - l.length))), l = l.concat($n(f - l.length + 1 + (l.length < r ? r - l.length : 0))), l = $n(-f).concat(l);
  var s = f > 0 ? f : 0;
  return s < l.length - 1 && l.splice(s + 1, 0, "."), u.sign + l.join("");
}
function Xa(e, r) {
  for (var o = {
    sign: e.sign,
    coefficients: e.coefficients,
    exponent: e.exponent
  }, n = o.coefficients; r <= 0; )
    n.unshift(0), o.exponent++, r++;
  if (n.length > r) {
    var i = n.splice(r, n.length - r);
    if (i[0] >= 5) {
      var t = r - 1;
      for (n[t]++; n[t] === 10; )
        n.pop(), t === 0 && (n.unshift(0), o.exponent++, t++), t--, n[t]++;
    }
  }
  return o;
}
function $n(e) {
  for (var r = [], o = 0; o < e; o++)
    r.push(0);
  return r;
}
function A2(e) {
  return e.toExponential().replace(/e.*$/, "").replace(/^0\.?0*|\./, "").length;
}
function zr(e, r) {
  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-8, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (o <= 0)
    throw new Error("Relative tolerance must be greater than 0");
  if (n < 0)
    throw new Error("Absolute tolerance must be at least 0");
  return isNaN(e) || isNaN(r) ? !1 : !isFinite(e) || !isFinite(r) ? e === r : e === r ? !0 : Math.abs(e - r) <= Math.max(o * Math.max(Math.abs(e), Math.abs(r)), n);
}
var S2 = Math.acosh || function(e) {
  return Math.log(Math.sqrt(e * e - 1) + e);
}, D2 = Math.asinh || function(e) {
  return Math.log(Math.sqrt(e * e + 1) + e);
}, N2 = Math.atanh || function(e) {
  return Math.log((1 + e) / (1 - e)) / 2;
}, M2 = Math.cosh || function(e) {
  return (Math.exp(e) + Math.exp(-e)) / 2;
}, _2 = Math.sinh || function(e) {
  return (Math.exp(e) - Math.exp(-e)) / 2;
}, C2 = Math.tanh || function(e) {
  var r = Math.exp(2 * e);
  return (r - 1) / (r + 1);
};
function T2(e, r) {
  var o = e > 0 ? !0 : e < 0 ? !1 : 1 / e === 1 / 0, n = r > 0 ? !0 : r < 0 ? !1 : 1 / r === 1 / 0;
  return o ^ n ? -e : e;
}
function Fc(e, r) {
  if ($e(e))
    return e;
  if (Re(e))
    return e.toNumber();
  r();
}
function Ic(e, r) {
  return $e(e) ? e : Re(e) ? e.toNumber() : r;
}
function Q(e, r, o, n) {
  function i(t) {
    var u = h2(t, r.map(b1));
    return B2(e, r, t), o(u);
  }
  return i.isFactory = !0, i.fn = e, i.dependencies = r.slice().sort(), n && (i.meta = n), i;
}
function pi(e) {
  return typeof e == "function" && typeof e.fn == "string" && Array.isArray(e.dependencies);
}
function B2(e, r, o) {
  var n = r.filter((t) => !F2(t)).every((t) => o[t] !== void 0);
  if (!n) {
    var i = r.filter((t) => o[t] === void 0);
    throw new Error('Cannot create function "'.concat(e, '", ') + "some dependencies are missing: ".concat(i.map((t) => '"'.concat(t, '"')).join(", "), "."));
  }
}
function F2(e) {
  return e && e[0] === "?";
}
function b1(e) {
  return e && e[0] === "?" ? e.slice(1) : e;
}
function Vr(e, r) {
  if (w1(e) && y1(e, r))
    return e[r];
  throw typeof e[r] == "function" && Cf(e, r) ? new Error('Cannot access method "' + r + '" as a property') : new Error('No access to property "' + r + '"');
}
function Un(e, r, o) {
  if (w1(e) && y1(e, r))
    return e[r] = o, o;
  throw new Error('No access to property "' + r + '"');
}
function I2(e, r) {
  return r in e;
}
function y1(e, r) {
  return !e || typeof e != "object" ? !1 : De(R2, r) ? !0 : !(r in Object.prototype || r in Function.prototype);
}
function O2(e, r) {
  if (!Cf(e, r))
    throw new Error('No access to method "' + r + '"');
  return e[r];
}
function Cf(e, r) {
  return e == null || typeof e[r] != "function" || De(e, r) && Object.getPrototypeOf && r in Object.getPrototypeOf(e) ? !1 : De(P2, r) ? !0 : !(r in Object.prototype || r in Function.prototype);
}
function w1(e) {
  return typeof e == "object" && e && e.constructor === Object;
}
var R2 = {
  length: !0,
  name: !0
}, P2 = {
  toString: !0,
  valueOf: !0,
  toLocaleString: !0
};
class Ja {
  constructor(r) {
    this.wrappedObject = r, this[Symbol.iterator] = this.entries;
  }
  keys() {
    return Object.keys(this.wrappedObject).values();
  }
  get(r) {
    return Vr(this.wrappedObject, r);
  }
  set(r, o) {
    return Un(this.wrappedObject, r, o), this;
  }
  has(r) {
    return I2(this.wrappedObject, r);
  }
  entries() {
    return E1(this.keys(), (r) => [r, this.get(r)]);
  }
  forEach(r) {
    for (var o of this.keys())
      r(this.get(o), o, this);
  }
  delete(r) {
    delete this.wrappedObject[r];
  }
  clear() {
    for (var r of this.keys())
      this.delete(r);
  }
  get size() {
    return Object.keys(this.wrappedObject).length;
  }
}
class x1 {
  /**
   * @param {Map} a
   * @param {Map} b
   * @param {Set} bKeys
   */
  constructor(r, o, n) {
    this.a = r, this.b = o, this.bKeys = n, this[Symbol.iterator] = this.entries;
  }
  get(r) {
    return this.bKeys.has(r) ? this.b.get(r) : this.a.get(r);
  }
  set(r, o) {
    return this.bKeys.has(r) ? this.b.set(r, o) : this.a.set(r, o), this;
  }
  has(r) {
    return this.b.has(r) || this.a.has(r);
  }
  keys() {
    return (/* @__PURE__ */ new Set([...this.a.keys(), ...this.b.keys()]))[Symbol.iterator]();
  }
  entries() {
    return E1(this.keys(), (r) => [r, this.get(r)]);
  }
  forEach(r) {
    for (var o of this.keys())
      r(this.get(o), o, this);
  }
  delete(r) {
    return this.bKeys.has(r) ? this.b.delete(r) : this.a.delete(r);
  }
  clear() {
    this.a.clear(), this.b.clear();
  }
  get size() {
    return [...this.keys()].length;
  }
}
function E1(e, r) {
  return {
    next: () => {
      var o = e.next();
      return o.done ? o : {
        value: r(o.value),
        done: !1
      };
    }
  };
}
function bi() {
  return /* @__PURE__ */ new Map();
}
function zn(e) {
  if (!e)
    return bi();
  if (A1(e))
    return e;
  if (Mi(e))
    return new Ja(e);
  throw new Error("createMap can create maps from objects or Maps");
}
function q2(e) {
  if (e instanceof Ja)
    return e.wrappedObject;
  var r = {};
  for (var o of e.keys()) {
    var n = e.get(o);
    Un(r, o, n);
  }
  return r;
}
function A1(e) {
  return e ? e instanceof Map || e instanceof Ja || typeof e.set == "function" && typeof e.get == "function" && typeof e.keys == "function" && typeof e.has == "function" : !1;
}
var S1 = function() {
  return S1 = wn.create, wn;
}, $2 = ["?BigNumber", "?Complex", "?DenseMatrix", "?Fraction"], z2 = /* @__PURE__ */ Q("typed", $2, function(r) {
  var {
    BigNumber: o,
    Complex: n,
    DenseMatrix: i,
    Fraction: t
  } = r, u = S1();
  return u.clear(), u.addTypes([
    {
      name: "number",
      test: $e
    },
    {
      name: "Complex",
      test: yt
    },
    {
      name: "BigNumber",
      test: Re
    },
    {
      name: "bigint",
      test: Jm
    },
    {
      name: "Fraction",
      test: An
    },
    {
      name: "Unit",
      test: jr
    },
    // The following type matches a valid variable name, i.e., an alphanumeric
    // string starting with an alphabetic character. It is used (at least)
    // in the definition of the derivative() function, as the argument telling
    // what to differentiate over must (currently) be a variable.
    {
      name: "identifier",
      test: (l) => qr && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])*$/.test(l)
    },
    {
      name: "string",
      test: qr
    },
    {
      name: "Chain",
      test: _f
    },
    {
      name: "Array",
      test: ar
    },
    {
      name: "Matrix",
      test: Fe
    },
    {
      name: "DenseMatrix",
      test: gi
    },
    {
      name: "SparseMatrix",
      test: en
    },
    {
      name: "Range",
      test: Ya
    },
    {
      name: "Index",
      test: Ni
    },
    {
      name: "boolean",
      test: Qm
    },
    {
      name: "ResultSet",
      test: e1
    },
    {
      name: "Help",
      test: Mf
    },
    {
      name: "function",
      test: r1
    },
    {
      name: "Date",
      test: t1
    },
    {
      name: "RegExp",
      test: n1
    },
    {
      name: "null",
      test: i1
    },
    {
      name: "undefined",
      test: a1
    },
    {
      name: "AccessorNode",
      test: nn
    },
    {
      name: "ArrayNode",
      test: tt
    },
    {
      name: "AssignmentNode",
      test: o1
    },
    {
      name: "BlockNode",
      test: s1
    },
    {
      name: "ConditionalNode",
      test: u1
    },
    {
      name: "ConstantNode",
      test: rr
    },
    {
      name: "FunctionNode",
      test: Gt
    },
    {
      name: "FunctionAssignmentNode",
      test: Yn
    },
    {
      name: "IndexNode",
      test: Sn
    },
    {
      name: "Node",
      test: or
    },
    {
      name: "ObjectNode",
      test: _i
    },
    {
      name: "OperatorNode",
      test: Cr
    },
    {
      name: "ParenthesisNode",
      test: Dt
    },
    {
      name: "RangeNode",
      test: f1
    },
    {
      name: "RelationalNode",
      test: c1
    },
    {
      name: "SymbolNode",
      test: Br
    },
    {
      name: "Map",
      test: A1
    },
    {
      name: "Object",
      test: Mi
    }
    // order 'Object' last, it matches on other classes too
  ]), u.addConversions([{
    from: "number",
    to: "BigNumber",
    convert: function(f) {
      if (o || qi(f), A2(f) > 15)
        throw new TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: " + f + "). Use function bignumber(x) to convert to BigNumber.");
      return new o(f);
    }
  }, {
    from: "number",
    to: "Complex",
    convert: function(f) {
      return n || $i(f), new n(f, 0);
    }
  }, {
    from: "BigNumber",
    to: "Complex",
    convert: function(f) {
      return n || $i(f), new n(f.toNumber(), 0);
    }
  }, {
    from: "bigint",
    to: "number",
    convert: function(f) {
      if (f > Number.MAX_SAFE_INTEGER)
        throw new TypeError("Cannot implicitly convert bigint to number: value exceeds the max safe integer value (value: " + f + ")");
      return Number(f);
    }
  }, {
    from: "bigint",
    to: "BigNumber",
    convert: function(f) {
      return o || qi(f), new o(f.toString());
    }
  }, {
    from: "bigint",
    to: "Fraction",
    convert: function(f) {
      return t || zi(f), new t(f.toString());
    }
  }, {
    from: "Fraction",
    to: "BigNumber",
    convert: function(f) {
      throw new TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.");
    }
  }, {
    from: "Fraction",
    to: "Complex",
    convert: function(f) {
      return n || $i(f), new n(f.valueOf(), 0);
    }
  }, {
    from: "number",
    to: "Fraction",
    convert: function(f) {
      t || zi(f);
      var s = new t(f);
      if (s.valueOf() !== f)
        throw new TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: " + f + "). Use function fraction(x) to convert to Fraction.");
      return s;
    }
  }, {
    // FIXME: add conversion from Fraction to number, for example for `sqrt(fraction(1,3))`
    //  from: 'Fraction',
    //  to: 'number',
    //  convert: function (x) {
    //    return x.valueOf()
    //  }
    // }, {
    from: "string",
    to: "number",
    convert: function(f) {
      var s = Number(f);
      if (isNaN(s))
        throw new Error('Cannot convert "' + f + '" to a number');
      return s;
    }
  }, {
    from: "string",
    to: "BigNumber",
    convert: function(f) {
      o || qi(f);
      try {
        return new o(f);
      } catch {
        throw new Error('Cannot convert "' + f + '" to BigNumber');
      }
    }
  }, {
    from: "string",
    to: "bigint",
    convert: function(f) {
      try {
        return BigInt(f);
      } catch {
        throw new Error('Cannot convert "' + f + '" to BigInt');
      }
    }
  }, {
    from: "string",
    to: "Fraction",
    convert: function(f) {
      t || zi(f);
      try {
        return new t(f);
      } catch {
        throw new Error('Cannot convert "' + f + '" to Fraction');
      }
    }
  }, {
    from: "string",
    to: "Complex",
    convert: function(f) {
      n || $i(f);
      try {
        return new n(f);
      } catch {
        throw new Error('Cannot convert "' + f + '" to Complex');
      }
    }
  }, {
    from: "boolean",
    to: "number",
    convert: function(f) {
      return +f;
    }
  }, {
    from: "boolean",
    to: "BigNumber",
    convert: function(f) {
      return o || qi(f), new o(+f);
    }
  }, {
    from: "boolean",
    to: "bigint",
    convert: function(f) {
      return BigInt(+f);
    }
  }, {
    from: "boolean",
    to: "Fraction",
    convert: function(f) {
      return t || zi(f), new t(+f);
    }
  }, {
    from: "boolean",
    to: "string",
    convert: function(f) {
      return String(f);
    }
  }, {
    from: "Array",
    to: "Matrix",
    convert: function(f) {
      return i || L2(), new i(f);
    }
  }, {
    from: "Matrix",
    to: "Array",
    convert: function(f) {
      return f.valueOf();
    }
  }]), u.onMismatch = (l, f, s) => {
    var a = u.createError(l, f, s);
    if (["wrongType", "mismatch"].includes(a.data.category) && f.length === 1 && nt(f[0]) && // check if the function can be unary:
    s.some((d) => !d.params.includes(","))) {
      var c = new TypeError("Function '".concat(l, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(l, ")'."));
      throw c.data = a.data, c;
    }
    throw a;
  }, u.onMismatch = (l, f, s) => {
    var a = u.createError(l, f, s);
    if (["wrongType", "mismatch"].includes(a.data.category) && f.length === 1 && nt(f[0]) && // check if the function can be unary:
    s.some((d) => !d.params.includes(","))) {
      var c = new TypeError("Function '".concat(l, "' doesn't apply to matrices. To call it ") + "elementwise on a matrix 'M', try 'map(M, ".concat(l, ")'."));
      throw c.data = a.data, c;
    }
    throw a;
  }, u;
});
function qi(e) {
  throw new Error("Cannot convert value ".concat(e, " into a BigNumber: no class 'BigNumber' provided"));
}
function $i(e) {
  throw new Error("Cannot convert value ".concat(e, " into a Complex number: no class 'Complex' provided"));
}
function L2() {
  throw new Error("Cannot convert array into a Matrix: no class 'DenseMatrix' provided");
}
function zi(e) {
  throw new Error("Cannot convert value ".concat(e, " into a Fraction, no class 'Fraction' provided."));
}
var U2 = "ResultSet", k2 = [], H2 = /* @__PURE__ */ Q(U2, k2, () => {
  function e(r) {
    if (!(this instanceof e))
      throw new SyntaxError("Constructor must be called with the new operator");
    this.entries = r || [];
  }
  return e.prototype.type = "ResultSet", e.prototype.isResultSet = !0, e.prototype.valueOf = function() {
    return this.entries;
  }, e.prototype.toString = function() {
    return "[" + this.entries.join(", ") + "]";
  }, e.prototype.toJSON = function() {
    return {
      mathjs: "ResultSet",
      entries: this.entries
    };
  }, e.fromJSON = function(r) {
    return new e(r.entries);
  }, e;
}, {
  isClass: !0
});
/*!
 *  decimal.js v10.4.3
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 */
var Rn = 9e15, un = 1e9, Ru = "0123456789abcdef", Ea = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", Aa = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", Pu = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -Rn,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: Rn,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: !1
  // true/false
}, D1, Ut, Pe = !0, Qa = "[DecimalError] ", an = Qa + "Invalid argument: ", N1 = Qa + "Precision limit exceeded", M1 = Qa + "crypto unavailable", _1 = "[object Decimal]", Hr = Math.floor, Tr = Math.pow, G2 = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, V2 = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, W2 = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, C1 = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, wt = 1e7, Oe = 7, K2 = 9007199254740991, Z2 = Ea.length - 1, qu = Aa.length - 1, xe = { toStringTag: _1 };
xe.absoluteValue = xe.abs = function() {
  var e = new this.constructor(this);
  return e.s < 0 && (e.s = 1), Be(e);
};
xe.ceil = function() {
  return Be(new this.constructor(this), this.e + 1, 2);
};
xe.clampedTo = xe.clamp = function(e, r) {
  var o, n = this, i = n.constructor;
  if (e = new i(e), r = new i(r), !e.s || !r.s)
    return new i(NaN);
  if (e.gt(r))
    throw Error(an + r);
  return o = n.cmp(e), o < 0 ? e : n.cmp(r) > 0 ? r : new i(n);
};
xe.comparedTo = xe.cmp = function(e) {
  var r, o, n, i, t = this, u = t.d, l = (e = new t.constructor(e)).d, f = t.s, s = e.s;
  if (!u || !l)
    return !f || !s ? NaN : f !== s ? f : u === l ? 0 : !u ^ f < 0 ? 1 : -1;
  if (!u[0] || !l[0])
    return u[0] ? f : l[0] ? -s : 0;
  if (f !== s)
    return f;
  if (t.e !== e.e)
    return t.e > e.e ^ f < 0 ? 1 : -1;
  for (n = u.length, i = l.length, r = 0, o = n < i ? n : i; r < o; ++r)
    if (u[r] !== l[r])
      return u[r] > l[r] ^ f < 0 ? 1 : -1;
  return n === i ? 0 : n > i ^ f < 0 ? 1 : -1;
};
xe.cosine = xe.cos = function() {
  var e, r, o = this, n = o.constructor;
  return o.d ? o.d[0] ? (e = n.precision, r = n.rounding, n.precision = e + Math.max(o.e, o.sd()) + Oe, n.rounding = 1, o = j2(n, O1(n, o)), n.precision = e, n.rounding = r, Be(Ut == 2 || Ut == 3 ? o.neg() : o, e, r, !0)) : new n(1) : new n(NaN);
};
xe.cubeRoot = xe.cbrt = function() {
  var e, r, o, n, i, t, u, l, f, s, a = this, c = a.constructor;
  if (!a.isFinite() || a.isZero())
    return new c(a);
  for (Pe = !1, t = a.s * Tr(a.s * a, 1 / 3), !t || Math.abs(t) == 1 / 0 ? (o = $r(a.d), e = a.e, (t = (e - o.length + 1) % 3) && (o += t == 1 || t == -2 ? "0" : "00"), t = Tr(o, 1 / 3), e = Hr((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2)), t == 1 / 0 ? o = "5e" + e : (o = t.toExponential(), o = o.slice(0, o.indexOf("e") + 1) + e), n = new c(o), n.s = a.s) : n = new c(t.toString()), u = (e = c.precision) + 3; ; )
    if (l = n, f = l.times(l).times(l), s = f.plus(a), n = hr(s.plus(a).times(l), s.plus(f), u + 2, 1), $r(l.d).slice(0, u) === (o = $r(n.d)).slice(0, u))
      if (o = o.slice(u - 3, u + 1), o == "9999" || !i && o == "4999") {
        if (!i && (Be(l, e + 1, 0), l.times(l).times(l).eq(a))) {
          n = l;
          break;
        }
        u += 4, i = 1;
      } else {
        (!+o || !+o.slice(1) && o.charAt(0) == "5") && (Be(n, e + 1, 1), r = !n.times(n).times(n).eq(a));
        break;
      }
  return Pe = !0, Be(n, e, c.rounding, r);
};
xe.decimalPlaces = xe.dp = function() {
  var e, r = this.d, o = NaN;
  if (r) {
    if (e = r.length - 1, o = (e - Hr(this.e / Oe)) * Oe, e = r[e], e)
      for (; e % 10 == 0; e /= 10)
        o--;
    o < 0 && (o = 0);
  }
  return o;
};
xe.dividedBy = xe.div = function(e) {
  return hr(this, new this.constructor(e));
};
xe.dividedToIntegerBy = xe.divToInt = function(e) {
  var r = this, o = r.constructor;
  return Be(hr(r, new o(e), 0, 1, 1), o.precision, o.rounding);
};
xe.equals = xe.eq = function(e) {
  return this.cmp(e) === 0;
};
xe.floor = function() {
  return Be(new this.constructor(this), this.e + 1, 3);
};
xe.greaterThan = xe.gt = function(e) {
  return this.cmp(e) > 0;
};
xe.greaterThanOrEqualTo = xe.gte = function(e) {
  var r = this.cmp(e);
  return r == 1 || r === 0;
};
xe.hyperbolicCosine = xe.cosh = function() {
  var e, r, o, n, i, t = this, u = t.constructor, l = new u(1);
  if (!t.isFinite())
    return new u(t.s ? 1 / 0 : NaN);
  if (t.isZero())
    return l;
  o = u.precision, n = u.rounding, u.precision = o + Math.max(t.e, t.sd()) + 4, u.rounding = 1, i = t.d.length, i < 32 ? (e = Math.ceil(i / 3), r = (1 / ro(4, e)).toString()) : (e = 16, r = "2.3283064365386962890625e-10"), t = kn(u, 1, t.times(r), new u(1), !0);
  for (var f, s = e, a = new u(8); s--; )
    f = t.times(t), t = l.minus(f.times(a.minus(f.times(a))));
  return Be(t, u.precision = o, u.rounding = n, !0);
};
xe.hyperbolicSine = xe.sinh = function() {
  var e, r, o, n, i = this, t = i.constructor;
  if (!i.isFinite() || i.isZero())
    return new t(i);
  if (r = t.precision, o = t.rounding, t.precision = r + Math.max(i.e, i.sd()) + 4, t.rounding = 1, n = i.d.length, n < 3)
    i = kn(t, 2, i, i, !0);
  else {
    e = 1.4 * Math.sqrt(n), e = e > 16 ? 16 : e | 0, i = i.times(1 / ro(5, e)), i = kn(t, 2, i, i, !0);
    for (var u, l = new t(5), f = new t(16), s = new t(20); e--; )
      u = i.times(i), i = i.times(l.plus(u.times(f.times(u).plus(s))));
  }
  return t.precision = r, t.rounding = o, Be(i, r, o, !0);
};
xe.hyperbolicTangent = xe.tanh = function() {
  var e, r, o = this, n = o.constructor;
  return o.isFinite() ? o.isZero() ? new n(o) : (e = n.precision, r = n.rounding, n.precision = e + 7, n.rounding = 1, hr(o.sinh(), o.cosh(), n.precision = e, n.rounding = r)) : new n(o.s);
};
xe.inverseCosine = xe.acos = function() {
  var e, r = this, o = r.constructor, n = r.abs().cmp(1), i = o.precision, t = o.rounding;
  return n !== -1 ? n === 0 ? r.isNeg() ? bt(o, i, t) : new o(0) : new o(NaN) : r.isZero() ? bt(o, i + 4, t).times(0.5) : (o.precision = i + 6, o.rounding = 1, r = r.asin(), e = bt(o, i + 4, t).times(0.5), o.precision = i, o.rounding = t, e.minus(r));
};
xe.inverseHyperbolicCosine = xe.acosh = function() {
  var e, r, o = this, n = o.constructor;
  return o.lte(1) ? new n(o.eq(1) ? 0 : NaN) : o.isFinite() ? (e = n.precision, r = n.rounding, n.precision = e + Math.max(Math.abs(o.e), o.sd()) + 4, n.rounding = 1, Pe = !1, o = o.times(o).minus(1).sqrt().plus(o), Pe = !0, n.precision = e, n.rounding = r, o.ln()) : new n(o);
};
xe.inverseHyperbolicSine = xe.asinh = function() {
  var e, r, o = this, n = o.constructor;
  return !o.isFinite() || o.isZero() ? new n(o) : (e = n.precision, r = n.rounding, n.precision = e + 2 * Math.max(Math.abs(o.e), o.sd()) + 6, n.rounding = 1, Pe = !1, o = o.times(o).plus(1).sqrt().plus(o), Pe = !0, n.precision = e, n.rounding = r, o.ln());
};
xe.inverseHyperbolicTangent = xe.atanh = function() {
  var e, r, o, n, i = this, t = i.constructor;
  return i.isFinite() ? i.e >= 0 ? new t(i.abs().eq(1) ? i.s / 0 : i.isZero() ? i : NaN) : (e = t.precision, r = t.rounding, n = i.sd(), Math.max(n, e) < 2 * -i.e - 1 ? Be(new t(i), e, r, !0) : (t.precision = o = n - i.e, i = hr(i.plus(1), new t(1).minus(i), o + e, 1), t.precision = e + 4, t.rounding = 1, i = i.ln(), t.precision = e, t.rounding = r, i.times(0.5))) : new t(NaN);
};
xe.inverseSine = xe.asin = function() {
  var e, r, o, n, i = this, t = i.constructor;
  return i.isZero() ? new t(i) : (r = i.abs().cmp(1), o = t.precision, n = t.rounding, r !== -1 ? r === 0 ? (e = bt(t, o + 4, n).times(0.5), e.s = i.s, e) : new t(NaN) : (t.precision = o + 6, t.rounding = 1, i = i.div(new t(1).minus(i.times(i)).sqrt().plus(1)).atan(), t.precision = o, t.rounding = n, i.times(2)));
};
xe.inverseTangent = xe.atan = function() {
  var e, r, o, n, i, t, u, l, f, s = this, a = s.constructor, c = a.precision, d = a.rounding;
  if (s.isFinite()) {
    if (s.isZero())
      return new a(s);
    if (s.abs().eq(1) && c + 4 <= qu)
      return u = bt(a, c + 4, d).times(0.25), u.s = s.s, u;
  } else {
    if (!s.s)
      return new a(NaN);
    if (c + 4 <= qu)
      return u = bt(a, c + 4, d).times(0.5), u.s = s.s, u;
  }
  for (a.precision = l = c + 10, a.rounding = 1, o = Math.min(28, l / Oe + 2 | 0), e = o; e; --e)
    s = s.div(s.times(s).plus(1).sqrt().plus(1));
  for (Pe = !1, r = Math.ceil(l / Oe), n = 1, f = s.times(s), u = new a(s), i = s; e !== -1; )
    if (i = i.times(f), t = u.minus(i.div(n += 2)), i = i.times(f), u = t.plus(i.div(n += 2)), u.d[r] !== void 0)
      for (e = r; u.d[e] === t.d[e] && e--; )
        ;
  return o && (u = u.times(2 << o - 1)), Pe = !0, Be(u, a.precision = c, a.rounding = d, !0);
};
xe.isFinite = function() {
  return !!this.d;
};
xe.isInteger = xe.isInt = function() {
  return !!this.d && Hr(this.e / Oe) > this.d.length - 2;
};
xe.isNaN = function() {
  return !this.s;
};
xe.isNegative = xe.isNeg = function() {
  return this.s < 0;
};
xe.isPositive = xe.isPos = function() {
  return this.s > 0;
};
xe.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
xe.lessThan = xe.lt = function(e) {
  return this.cmp(e) < 0;
};
xe.lessThanOrEqualTo = xe.lte = function(e) {
  return this.cmp(e) < 1;
};
xe.logarithm = xe.log = function(e) {
  var r, o, n, i, t, u, l, f, s = this, a = s.constructor, c = a.precision, d = a.rounding, h = 5;
  if (e == null)
    e = new a(10), r = !0;
  else {
    if (e = new a(e), o = e.d, e.s < 0 || !o || !o[0] || e.eq(1))
      return new a(NaN);
    r = e.eq(10);
  }
  if (o = s.d, s.s < 0 || !o || !o[0] || s.eq(1))
    return new a(o && !o[0] ? -1 / 0 : s.s != 1 ? NaN : o ? 0 : 1 / 0);
  if (r)
    if (o.length > 1)
      t = !0;
    else {
      for (i = o[0]; i % 10 === 0; )
        i /= 10;
      t = i !== 1;
    }
  if (Pe = !1, l = c + h, u = tn(s, l), n = r ? Sa(a, l + 10) : tn(e, l), f = hr(u, n, l, 1), yi(f.d, i = c, d))
    do
      if (l += 10, u = tn(s, l), n = r ? Sa(a, l + 10) : tn(e, l), f = hr(u, n, l, 1), !t) {
        +$r(f.d).slice(i + 1, i + 15) + 1 == 1e14 && (f = Be(f, c + 1, 0));
        break;
      }
    while (yi(f.d, i += 10, d));
  return Pe = !0, Be(f, c, d);
};
xe.minus = xe.sub = function(e) {
  var r, o, n, i, t, u, l, f, s, a, c, d, h = this, p = h.constructor;
  if (e = new p(e), !h.d || !e.d)
    return !h.s || !e.s ? e = new p(NaN) : h.d ? e.s = -e.s : e = new p(e.d || h.s !== e.s ? h : NaN), e;
  if (h.s != e.s)
    return e.s = -e.s, h.plus(e);
  if (s = h.d, d = e.d, l = p.precision, f = p.rounding, !s[0] || !d[0]) {
    if (d[0])
      e.s = -e.s;
    else if (s[0])
      e = new p(h);
    else
      return new p(f === 3 ? -0 : 0);
    return Pe ? Be(e, l, f) : e;
  }
  if (o = Hr(e.e / Oe), a = Hr(h.e / Oe), s = s.slice(), t = a - o, t) {
    for (c = t < 0, c ? (r = s, t = -t, u = d.length) : (r = d, o = a, u = s.length), n = Math.max(Math.ceil(l / Oe), u) + 2, t > n && (t = n, r.length = 1), r.reverse(), n = t; n--; )
      r.push(0);
    r.reverse();
  } else {
    for (n = s.length, u = d.length, c = n < u, c && (u = n), n = 0; n < u; n++)
      if (s[n] != d[n]) {
        c = s[n] < d[n];
        break;
      }
    t = 0;
  }
  for (c && (r = s, s = d, d = r, e.s = -e.s), u = s.length, n = d.length - u; n > 0; --n)
    s[u++] = 0;
  for (n = d.length; n > t; ) {
    if (s[--n] < d[n]) {
      for (i = n; i && s[--i] === 0; )
        s[i] = wt - 1;
      --s[i], s[n] += wt;
    }
    s[n] -= d[n];
  }
  for (; s[--u] === 0; )
    s.pop();
  for (; s[0] === 0; s.shift())
    --o;
  return s[0] ? (e.d = s, e.e = eo(s, o), Pe ? Be(e, l, f) : e) : new p(f === 3 ? -0 : 0);
};
xe.modulo = xe.mod = function(e) {
  var r, o = this, n = o.constructor;
  return e = new n(e), !o.d || !e.s || e.d && !e.d[0] ? new n(NaN) : !e.d || o.d && !o.d[0] ? Be(new n(o), n.precision, n.rounding) : (Pe = !1, n.modulo == 9 ? (r = hr(o, e.abs(), 0, 3, 1), r.s *= e.s) : r = hr(o, e, 0, n.modulo, 1), r = r.times(e), Pe = !0, o.minus(r));
};
xe.naturalExponential = xe.exp = function() {
  return $u(this);
};
xe.naturalLogarithm = xe.ln = function() {
  return tn(this);
};
xe.negated = xe.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s, Be(e);
};
xe.plus = xe.add = function(e) {
  var r, o, n, i, t, u, l, f, s, a, c = this, d = c.constructor;
  if (e = new d(e), !c.d || !e.d)
    return !c.s || !e.s ? e = new d(NaN) : c.d || (e = new d(e.d || c.s === e.s ? c : NaN)), e;
  if (c.s != e.s)
    return e.s = -e.s, c.minus(e);
  if (s = c.d, a = e.d, l = d.precision, f = d.rounding, !s[0] || !a[0])
    return a[0] || (e = new d(c)), Pe ? Be(e, l, f) : e;
  if (t = Hr(c.e / Oe), n = Hr(e.e / Oe), s = s.slice(), i = t - n, i) {
    for (i < 0 ? (o = s, i = -i, u = a.length) : (o = a, n = t, u = s.length), t = Math.ceil(l / Oe), u = t > u ? t + 1 : u + 1, i > u && (i = u, o.length = 1), o.reverse(); i--; )
      o.push(0);
    o.reverse();
  }
  for (u = s.length, i = a.length, u - i < 0 && (i = u, o = a, a = s, s = o), r = 0; i; )
    r = (s[--i] = s[i] + a[i] + r) / wt | 0, s[i] %= wt;
  for (r && (s.unshift(r), ++n), u = s.length; s[--u] == 0; )
    s.pop();
  return e.d = s, e.e = eo(s, n), Pe ? Be(e, l, f) : e;
};
xe.precision = xe.sd = function(e) {
  var r, o = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0)
    throw Error(an + e);
  return o.d ? (r = T1(o.d), e && o.e + 1 > r && (r = o.e + 1)) : r = NaN, r;
};
xe.round = function() {
  var e = this, r = e.constructor;
  return Be(new r(e), e.e + 1, r.rounding);
};
xe.sine = xe.sin = function() {
  var e, r, o = this, n = o.constructor;
  return o.isFinite() ? o.isZero() ? new n(o) : (e = n.precision, r = n.rounding, n.precision = e + Math.max(o.e, o.sd()) + Oe, n.rounding = 1, o = X2(n, O1(n, o)), n.precision = e, n.rounding = r, Be(Ut > 2 ? o.neg() : o, e, r, !0)) : new n(NaN);
};
xe.squareRoot = xe.sqrt = function() {
  var e, r, o, n, i, t, u = this, l = u.d, f = u.e, s = u.s, a = u.constructor;
  if (s !== 1 || !l || !l[0])
    return new a(!s || s < 0 && (!l || l[0]) ? NaN : l ? u : 1 / 0);
  for (Pe = !1, s = Math.sqrt(+u), s == 0 || s == 1 / 0 ? (r = $r(l), (r.length + f) % 2 == 0 && (r += "0"), s = Math.sqrt(r), f = Hr((f + 1) / 2) - (f < 0 || f % 2), s == 1 / 0 ? r = "5e" + f : (r = s.toExponential(), r = r.slice(0, r.indexOf("e") + 1) + f), n = new a(r)) : n = new a(s.toString()), o = (f = a.precision) + 3; ; )
    if (t = n, n = t.plus(hr(u, t, o + 2, 1)).times(0.5), $r(t.d).slice(0, o) === (r = $r(n.d)).slice(0, o))
      if (r = r.slice(o - 3, o + 1), r == "9999" || !i && r == "4999") {
        if (!i && (Be(t, f + 1, 0), t.times(t).eq(u))) {
          n = t;
          break;
        }
        o += 4, i = 1;
      } else {
        (!+r || !+r.slice(1) && r.charAt(0) == "5") && (Be(n, f + 1, 1), e = !n.times(n).eq(u));
        break;
      }
  return Pe = !0, Be(n, f, a.rounding, e);
};
xe.tangent = xe.tan = function() {
  var e, r, o = this, n = o.constructor;
  return o.isFinite() ? o.isZero() ? new n(o) : (e = n.precision, r = n.rounding, n.precision = e + 10, n.rounding = 1, o = o.sin(), o.s = 1, o = hr(o, new n(1).minus(o.times(o)).sqrt(), e + 10, 0), n.precision = e, n.rounding = r, Be(Ut == 2 || Ut == 4 ? o.neg() : o, e, r, !0)) : new n(NaN);
};
xe.times = xe.mul = function(e) {
  var r, o, n, i, t, u, l, f, s, a = this, c = a.constructor, d = a.d, h = (e = new c(e)).d;
  if (e.s *= a.s, !d || !d[0] || !h || !h[0])
    return new c(!e.s || d && !d[0] && !h || h && !h[0] && !d ? NaN : !d || !h ? e.s / 0 : e.s * 0);
  for (o = Hr(a.e / Oe) + Hr(e.e / Oe), f = d.length, s = h.length, f < s && (t = d, d = h, h = t, u = f, f = s, s = u), t = [], u = f + s, n = u; n--; )
    t.push(0);
  for (n = s; --n >= 0; ) {
    for (r = 0, i = f + n; i > n; )
      l = t[i] + h[n] * d[i - n - 1] + r, t[i--] = l % wt | 0, r = l / wt | 0;
    t[i] = (t[i] + r) % wt | 0;
  }
  for (; !t[--u]; )
    t.pop();
  return r ? ++o : t.shift(), e.d = t, e.e = eo(t, o), Pe ? Be(e, c.precision, c.rounding) : e;
};
xe.toBinary = function(e, r) {
  return Tf(this, 2, e, r);
};
xe.toDecimalPlaces = xe.toDP = function(e, r) {
  var o = this, n = o.constructor;
  return o = new n(o), e === void 0 ? o : (Yr(e, 0, un), r === void 0 ? r = n.rounding : Yr(r, 0, 8), Be(o, e + o.e + 1, r));
};
xe.toExponential = function(e, r) {
  var o, n = this, i = n.constructor;
  return e === void 0 ? o = Nt(n, !0) : (Yr(e, 0, un), r === void 0 ? r = i.rounding : Yr(r, 0, 8), n = Be(new i(n), e + 1, r), o = Nt(n, !0, e + 1)), n.isNeg() && !n.isZero() ? "-" + o : o;
};
xe.toFixed = function(e, r) {
  var o, n, i = this, t = i.constructor;
  return e === void 0 ? o = Nt(i) : (Yr(e, 0, un), r === void 0 ? r = t.rounding : Yr(r, 0, 8), n = Be(new t(i), e + i.e + 1, r), o = Nt(n, !1, e + n.e + 1)), i.isNeg() && !i.isZero() ? "-" + o : o;
};
xe.toFraction = function(e) {
  var r, o, n, i, t, u, l, f, s, a, c, d, h = this, p = h.d, v = h.constructor;
  if (!p)
    return new v(h);
  if (s = o = new v(1), n = f = new v(0), r = new v(n), t = r.e = T1(p) - h.e - 1, u = t % Oe, r.d[0] = Tr(10, u < 0 ? Oe + u : u), e == null)
    e = t > 0 ? r : s;
  else {
    if (l = new v(e), !l.isInt() || l.lt(s))
      throw Error(an + l);
    e = l.gt(r) ? t > 0 ? r : s : l;
  }
  for (Pe = !1, l = new v($r(p)), a = v.precision, v.precision = t = p.length * Oe * 2; c = hr(l, r, 0, 1, 1), i = o.plus(c.times(n)), i.cmp(e) != 1; )
    o = n, n = i, i = s, s = f.plus(c.times(i)), f = i, i = r, r = l.minus(c.times(i)), l = i;
  return i = hr(e.minus(o), n, 0, 1, 1), f = f.plus(i.times(s)), o = o.plus(i.times(n)), f.s = s.s = h.s, d = hr(s, n, t, 1).minus(h).abs().cmp(hr(f, o, t, 1).minus(h).abs()) < 1 ? [s, n] : [f, o], v.precision = a, Pe = !0, d;
};
xe.toHexadecimal = xe.toHex = function(e, r) {
  return Tf(this, 16, e, r);
};
xe.toNearest = function(e, r) {
  var o = this, n = o.constructor;
  if (o = new n(o), e == null) {
    if (!o.d)
      return o;
    e = new n(1), r = n.rounding;
  } else {
    if (e = new n(e), r === void 0 ? r = n.rounding : Yr(r, 0, 8), !o.d)
      return e.s ? o : e;
    if (!e.d)
      return e.s && (e.s = o.s), e;
  }
  return e.d[0] ? (Pe = !1, o = hr(o, e, 0, r, 1).times(e), Pe = !0, Be(o)) : (e.s = o.s, o = e), o;
};
xe.toNumber = function() {
  return +this;
};
xe.toOctal = function(e, r) {
  return Tf(this, 8, e, r);
};
xe.toPower = xe.pow = function(e) {
  var r, o, n, i, t, u, l = this, f = l.constructor, s = +(e = new f(e));
  if (!l.d || !e.d || !l.d[0] || !e.d[0])
    return new f(Tr(+l, s));
  if (l = new f(l), l.eq(1))
    return l;
  if (n = f.precision, t = f.rounding, e.eq(1))
    return Be(l, n, t);
  if (r = Hr(e.e / Oe), r >= e.d.length - 1 && (o = s < 0 ? -s : s) <= K2)
    return i = B1(f, l, o, n), e.s < 0 ? new f(1).div(i) : Be(i, n, t);
  if (u = l.s, u < 0) {
    if (r < e.d.length - 1)
      return new f(NaN);
    if (e.d[r] & 1 || (u = 1), l.e == 0 && l.d[0] == 1 && l.d.length == 1)
      return l.s = u, l;
  }
  return o = Tr(+l, s), r = o == 0 || !isFinite(o) ? Hr(s * (Math.log("0." + $r(l.d)) / Math.LN10 + l.e + 1)) : new f(o + "").e, r > f.maxE + 1 || r < f.minE - 1 ? new f(r > 0 ? u / 0 : 0) : (Pe = !1, f.rounding = l.s = 1, o = Math.min(12, (r + "").length), i = $u(e.times(tn(l, n + o)), n), i.d && (i = Be(i, n + 5, 1), yi(i.d, n, t) && (r = n + 10, i = Be($u(e.times(tn(l, r + o)), r), r + 5, 1), +$r(i.d).slice(n + 1, n + 15) + 1 == 1e14 && (i = Be(i, n + 1, 0)))), i.s = u, Pe = !0, f.rounding = t, Be(i, n, t));
};
xe.toPrecision = function(e, r) {
  var o, n = this, i = n.constructor;
  return e === void 0 ? o = Nt(n, n.e <= i.toExpNeg || n.e >= i.toExpPos) : (Yr(e, 1, un), r === void 0 ? r = i.rounding : Yr(r, 0, 8), n = Be(new i(n), e, r), o = Nt(n, e <= n.e || n.e <= i.toExpNeg, e)), n.isNeg() && !n.isZero() ? "-" + o : o;
};
xe.toSignificantDigits = xe.toSD = function(e, r) {
  var o = this, n = o.constructor;
  return e === void 0 ? (e = n.precision, r = n.rounding) : (Yr(e, 1, un), r === void 0 ? r = n.rounding : Yr(r, 0, 8)), Be(new n(o), e, r);
};
xe.toString = function() {
  var e = this, r = e.constructor, o = Nt(e, e.e <= r.toExpNeg || e.e >= r.toExpPos);
  return e.isNeg() && !e.isZero() ? "-" + o : o;
};
xe.truncated = xe.trunc = function() {
  return Be(new this.constructor(this), this.e + 1, 1);
};
xe.valueOf = xe.toJSON = function() {
  var e = this, r = e.constructor, o = Nt(e, e.e <= r.toExpNeg || e.e >= r.toExpPos);
  return e.isNeg() ? "-" + o : o;
};
function $r(e) {
  var r, o, n, i = e.length - 1, t = "", u = e[0];
  if (i > 0) {
    for (t += u, r = 1; r < i; r++)
      n = e[r] + "", o = Oe - n.length, o && (t += Xt(o)), t += n;
    u = e[r], n = u + "", o = Oe - n.length, o && (t += Xt(o));
  } else if (u === 0)
    return "0";
  for (; u % 10 === 0; )
    u /= 10;
  return t + u;
}
function Yr(e, r, o) {
  if (e !== ~~e || e < r || e > o)
    throw Error(an + e);
}
function yi(e, r, o, n) {
  var i, t, u, l;
  for (t = e[0]; t >= 10; t /= 10)
    --r;
  return --r < 0 ? (r += Oe, i = 0) : (i = Math.ceil((r + 1) / Oe), r %= Oe), t = Tr(10, Oe - r), l = e[i] % t | 0, n == null ? r < 3 ? (r == 0 ? l = l / 100 | 0 : r == 1 && (l = l / 10 | 0), u = o < 4 && l == 99999 || o > 3 && l == 49999 || l == 5e4 || l == 0) : u = (o < 4 && l + 1 == t || o > 3 && l + 1 == t / 2) && (e[i + 1] / t / 100 | 0) == Tr(10, r - 2) - 1 || (l == t / 2 || l == 0) && (e[i + 1] / t / 100 | 0) == 0 : r < 4 ? (r == 0 ? l = l / 1e3 | 0 : r == 1 ? l = l / 100 | 0 : r == 2 && (l = l / 10 | 0), u = (n || o < 4) && l == 9999 || !n && o > 3 && l == 4999) : u = ((n || o < 4) && l + 1 == t || !n && o > 3 && l + 1 == t / 2) && (e[i + 1] / t / 1e3 | 0) == Tr(10, r - 3) - 1, u;
}
function ba(e, r, o) {
  for (var n, i = [0], t, u = 0, l = e.length; u < l; ) {
    for (t = i.length; t--; )
      i[t] *= r;
    for (i[0] += Ru.indexOf(e.charAt(u++)), n = 0; n < i.length; n++)
      i[n] > o - 1 && (i[n + 1] === void 0 && (i[n + 1] = 0), i[n + 1] += i[n] / o | 0, i[n] %= o);
  }
  return i.reverse();
}
function j2(e, r) {
  var o, n, i;
  if (r.isZero())
    return r;
  n = r.d.length, n < 32 ? (o = Math.ceil(n / 3), i = (1 / ro(4, o)).toString()) : (o = 16, i = "2.3283064365386962890625e-10"), e.precision += o, r = kn(e, 1, r.times(i), new e(1));
  for (var t = o; t--; ) {
    var u = r.times(r);
    r = u.times(u).minus(u).times(8).plus(1);
  }
  return e.precision -= o, r;
}
var hr = /* @__PURE__ */ function() {
  function e(n, i, t) {
    var u, l = 0, f = n.length;
    for (n = n.slice(); f--; )
      u = n[f] * i + l, n[f] = u % t | 0, l = u / t | 0;
    return l && n.unshift(l), n;
  }
  function r(n, i, t, u) {
    var l, f;
    if (t != u)
      f = t > u ? 1 : -1;
    else
      for (l = f = 0; l < t; l++)
        if (n[l] != i[l]) {
          f = n[l] > i[l] ? 1 : -1;
          break;
        }
    return f;
  }
  function o(n, i, t, u) {
    for (var l = 0; t--; )
      n[t] -= l, l = n[t] < i[t] ? 1 : 0, n[t] = l * u + n[t] - i[t];
    for (; !n[0] && n.length > 1; )
      n.shift();
  }
  return function(n, i, t, u, l, f) {
    var s, a, c, d, h, p, v, g, m, x, y, E, N, S, R, O, B, $, F, w, A = n.constructor, b = n.s == i.s ? 1 : -1, D = n.d, M = i.d;
    if (!D || !D[0] || !M || !M[0])
      return new A(
        // Return NaN if either NaN, or both Infinity or 0.
        !n.s || !i.s || (D ? M && D[0] == M[0] : !M) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          D && D[0] == 0 || !M ? b * 0 : b / 0
        )
      );
    for (f ? (h = 1, a = n.e - i.e) : (f = wt, h = Oe, a = Hr(n.e / h) - Hr(i.e / h)), F = M.length, B = D.length, m = new A(b), x = m.d = [], c = 0; M[c] == (D[c] || 0); c++)
      ;
    if (M[c] > (D[c] || 0) && a--, t == null ? (S = t = A.precision, u = A.rounding) : l ? S = t + (n.e - i.e) + 1 : S = t, S < 0)
      x.push(1), p = !0;
    else {
      if (S = S / h + 2 | 0, c = 0, F == 1) {
        for (d = 0, M = M[0], S++; (c < B || d) && S--; c++)
          R = d * f + (D[c] || 0), x[c] = R / M | 0, d = R % M | 0;
        p = d || c < B;
      } else {
        for (d = f / (M[0] + 1) | 0, d > 1 && (M = e(M, d, f), D = e(D, d, f), F = M.length, B = D.length), O = F, y = D.slice(0, F), E = y.length; E < F; )
          y[E++] = 0;
        w = M.slice(), w.unshift(0), $ = M[0], M[1] >= f / 2 && ++$;
        do
          d = 0, s = r(M, y, F, E), s < 0 ? (N = y[0], F != E && (N = N * f + (y[1] || 0)), d = N / $ | 0, d > 1 ? (d >= f && (d = f - 1), v = e(M, d, f), g = v.length, E = y.length, s = r(v, y, g, E), s == 1 && (d--, o(v, F < g ? w : M, g, f))) : (d == 0 && (s = d = 1), v = M.slice()), g = v.length, g < E && v.unshift(0), o(y, v, E, f), s == -1 && (E = y.length, s = r(M, y, F, E), s < 1 && (d++, o(y, F < E ? w : M, E, f))), E = y.length) : s === 0 && (d++, y = [0]), x[c++] = d, s && y[0] ? y[E++] = D[O] || 0 : (y = [D[O]], E = 1);
        while ((O++ < B || y[0] !== void 0) && S--);
        p = y[0] !== void 0;
      }
      x[0] || x.shift();
    }
    if (h == 1)
      m.e = a, D1 = p;
    else {
      for (c = 1, d = x[0]; d >= 10; d /= 10)
        c++;
      m.e = c + a * h - 1, Be(m, l ? t + m.e + 1 : t, u, p);
    }
    return m;
  };
}();
function Be(e, r, o, n) {
  var i, t, u, l, f, s, a, c, d, h = e.constructor;
  e:
    if (r != null) {
      if (c = e.d, !c)
        return e;
      for (i = 1, l = c[0]; l >= 10; l /= 10)
        i++;
      if (t = r - i, t < 0)
        t += Oe, u = r, a = c[d = 0], f = a / Tr(10, i - u - 1) % 10 | 0;
      else if (d = Math.ceil((t + 1) / Oe), l = c.length, d >= l)
        if (n) {
          for (; l++ <= d; )
            c.push(0);
          a = f = 0, i = 1, t %= Oe, u = t - Oe + 1;
        } else
          break e;
      else {
        for (a = l = c[d], i = 1; l >= 10; l /= 10)
          i++;
        t %= Oe, u = t - Oe + i, f = u < 0 ? 0 : a / Tr(10, i - u - 1) % 10 | 0;
      }
      if (n = n || r < 0 || c[d + 1] !== void 0 || (u < 0 ? a : a % Tr(10, i - u - 1)), s = o < 4 ? (f || n) && (o == 0 || o == (e.s < 0 ? 3 : 2)) : f > 5 || f == 5 && (o == 4 || n || o == 6 && // Check whether the digit to the left of the rounding digit is odd.
      (t > 0 ? u > 0 ? a / Tr(10, i - u) : 0 : c[d - 1]) % 10 & 1 || o == (e.s < 0 ? 8 : 7)), r < 1 || !c[0])
        return c.length = 0, s ? (r -= e.e + 1, c[0] = Tr(10, (Oe - r % Oe) % Oe), e.e = -r || 0) : c[0] = e.e = 0, e;
      if (t == 0 ? (c.length = d, l = 1, d--) : (c.length = d + 1, l = Tr(10, Oe - t), c[d] = u > 0 ? (a / Tr(10, i - u) % Tr(10, u) | 0) * l : 0), s)
        for (; ; )
          if (d == 0) {
            for (t = 1, u = c[0]; u >= 10; u /= 10)
              t++;
            for (u = c[0] += l, l = 1; u >= 10; u /= 10)
              l++;
            t != l && (e.e++, c[0] == wt && (c[0] = 1));
            break;
          } else {
            if (c[d] += l, c[d] != wt)
              break;
            c[d--] = 0, l = 1;
          }
      for (t = c.length; c[--t] === 0; )
        c.pop();
    }
  return Pe && (e.e > h.maxE ? (e.d = null, e.e = NaN) : e.e < h.minE && (e.e = 0, e.d = [0])), e;
}
function Nt(e, r, o) {
  if (!e.isFinite())
    return I1(e);
  var n, i = e.e, t = $r(e.d), u = t.length;
  return r ? (o && (n = o - u) > 0 ? t = t.charAt(0) + "." + t.slice(1) + Xt(n) : u > 1 && (t = t.charAt(0) + "." + t.slice(1)), t = t + (e.e < 0 ? "e" : "e+") + e.e) : i < 0 ? (t = "0." + Xt(-i - 1) + t, o && (n = o - u) > 0 && (t += Xt(n))) : i >= u ? (t += Xt(i + 1 - u), o && (n = o - i - 1) > 0 && (t = t + "." + Xt(n))) : ((n = i + 1) < u && (t = t.slice(0, n) + "." + t.slice(n)), o && (n = o - u) > 0 && (i + 1 === u && (t += "."), t += Xt(n))), t;
}
function eo(e, r) {
  var o = e[0];
  for (r *= Oe; o >= 10; o /= 10)
    r++;
  return r;
}
function Sa(e, r, o) {
  if (r > Z2)
    throw Pe = !0, o && (e.precision = o), Error(N1);
  return Be(new e(Ea), r, 1, !0);
}
function bt(e, r, o) {
  if (r > qu)
    throw Error(N1);
  return Be(new e(Aa), r, o, !0);
}
function T1(e) {
  var r = e.length - 1, o = r * Oe + 1;
  if (r = e[r], r) {
    for (; r % 10 == 0; r /= 10)
      o--;
    for (r = e[0]; r >= 10; r /= 10)
      o++;
  }
  return o;
}
function Xt(e) {
  for (var r = ""; e--; )
    r += "0";
  return r;
}
function B1(e, r, o, n) {
  var i, t = new e(1), u = Math.ceil(n / Oe + 4);
  for (Pe = !1; ; ) {
    if (o % 2 && (t = t.times(r), Rc(t.d, u) && (i = !0)), o = Hr(o / 2), o === 0) {
      o = t.d.length - 1, i && t.d[o] === 0 && ++t.d[o];
      break;
    }
    r = r.times(r), Rc(r.d, u);
  }
  return Pe = !0, t;
}
function Oc(e) {
  return e.d[e.d.length - 1] & 1;
}
function F1(e, r, o) {
  for (var n, i = new e(r[0]), t = 0; ++t < r.length; )
    if (n = new e(r[t]), n.s)
      i[o](n) && (i = n);
    else {
      i = n;
      break;
    }
  return i;
}
function $u(e, r) {
  var o, n, i, t, u, l, f, s = 0, a = 0, c = 0, d = e.constructor, h = d.rounding, p = d.precision;
  if (!e.d || !e.d[0] || e.e > 17)
    return new d(e.d ? e.d[0] ? e.s < 0 ? 0 : 1 / 0 : 1 : e.s ? e.s < 0 ? 0 : e : NaN);
  for (r == null ? (Pe = !1, f = p) : f = r, l = new d(0.03125); e.e > -2; )
    e = e.times(l), c += 5;
  for (n = Math.log(Tr(2, c)) / Math.LN10 * 2 + 5 | 0, f += n, o = t = u = new d(1), d.precision = f; ; ) {
    if (t = Be(t.times(e), f, 1), o = o.times(++a), l = u.plus(hr(t, o, f, 1)), $r(l.d).slice(0, f) === $r(u.d).slice(0, f)) {
      for (i = c; i--; )
        u = Be(u.times(u), f, 1);
      if (r == null)
        if (s < 3 && yi(u.d, f - n, h, s))
          d.precision = f += 10, o = t = l = new d(1), a = 0, s++;
        else
          return Be(u, d.precision = p, h, Pe = !0);
      else
        return d.precision = p, u;
    }
    u = l;
  }
}
function tn(e, r) {
  var o, n, i, t, u, l, f, s, a, c, d, h = 1, p = 10, v = e, g = v.d, m = v.constructor, x = m.rounding, y = m.precision;
  if (v.s < 0 || !g || !g[0] || !v.e && g[0] == 1 && g.length == 1)
    return new m(g && !g[0] ? -1 / 0 : v.s != 1 ? NaN : g ? 0 : v);
  if (r == null ? (Pe = !1, a = y) : a = r, m.precision = a += p, o = $r(g), n = o.charAt(0), Math.abs(t = v.e) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && o.charAt(1) > 3; )
      v = v.times(e), o = $r(v.d), n = o.charAt(0), h++;
    t = v.e, n > 1 ? (v = new m("0." + o), t++) : v = new m(n + "." + o.slice(1));
  } else
    return s = Sa(m, a + 2, y).times(t + ""), v = tn(new m(n + "." + o.slice(1)), a - p).plus(s), m.precision = y, r == null ? Be(v, y, x, Pe = !0) : v;
  for (c = v, f = u = v = hr(v.minus(1), v.plus(1), a, 1), d = Be(v.times(v), a, 1), i = 3; ; ) {
    if (u = Be(u.times(d), a, 1), s = f.plus(hr(u, new m(i), a, 1)), $r(s.d).slice(0, a) === $r(f.d).slice(0, a))
      if (f = f.times(2), t !== 0 && (f = f.plus(Sa(m, a + 2, y).times(t + ""))), f = hr(f, new m(h), a, 1), r == null)
        if (yi(f.d, a - p, x, l))
          m.precision = a += p, s = u = v = hr(c.minus(1), c.plus(1), a, 1), d = Be(v.times(v), a, 1), i = l = 1;
        else
          return Be(f, m.precision = y, x, Pe = !0);
      else
        return m.precision = y, f;
    f = s, i += 2;
  }
}
function I1(e) {
  return String(e.s * e.s / 0);
}
function zu(e, r) {
  var o, n, i;
  for ((o = r.indexOf(".")) > -1 && (r = r.replace(".", "")), (n = r.search(/e/i)) > 0 ? (o < 0 && (o = n), o += +r.slice(n + 1), r = r.substring(0, n)) : o < 0 && (o = r.length), n = 0; r.charCodeAt(n) === 48; n++)
    ;
  for (i = r.length; r.charCodeAt(i - 1) === 48; --i)
    ;
  if (r = r.slice(n, i), r) {
    if (i -= n, e.e = o = o - n - 1, e.d = [], n = (o + 1) % Oe, o < 0 && (n += Oe), n < i) {
      for (n && e.d.push(+r.slice(0, n)), i -= Oe; n < i; )
        e.d.push(+r.slice(n, n += Oe));
      r = r.slice(n), n = Oe - r.length;
    } else
      n -= i;
    for (; n--; )
      r += "0";
    e.d.push(+r), Pe && (e.e > e.constructor.maxE ? (e.d = null, e.e = NaN) : e.e < e.constructor.minE && (e.e = 0, e.d = [0]));
  } else
    e.e = 0, e.d = [0];
  return e;
}
function Y2(e, r) {
  var o, n, i, t, u, l, f, s, a;
  if (r.indexOf("_") > -1) {
    if (r = r.replace(/(\d)_(?=\d)/g, "$1"), C1.test(r))
      return zu(e, r);
  } else if (r === "Infinity" || r === "NaN")
    return +r || (e.s = NaN), e.e = NaN, e.d = null, e;
  if (V2.test(r))
    o = 16, r = r.toLowerCase();
  else if (G2.test(r))
    o = 2;
  else if (W2.test(r))
    o = 8;
  else
    throw Error(an + r);
  for (t = r.search(/p/i), t > 0 ? (f = +r.slice(t + 1), r = r.substring(2, t)) : r = r.slice(2), t = r.indexOf("."), u = t >= 0, n = e.constructor, u && (r = r.replace(".", ""), l = r.length, t = l - t, i = B1(n, new n(o), t, t * 2)), s = ba(r, o, wt), a = s.length - 1, t = a; s[t] === 0; --t)
    s.pop();
  return t < 0 ? new n(e.s * 0) : (e.e = eo(s, a), e.d = s, Pe = !1, u && (e = hr(e, i, l * 4)), f && (e = e.times(Math.abs(f) < 54 ? Tr(2, f) : on.pow(2, f))), Pe = !0, e);
}
function X2(e, r) {
  var o, n = r.d.length;
  if (n < 3)
    return r.isZero() ? r : kn(e, 2, r, r);
  o = 1.4 * Math.sqrt(n), o = o > 16 ? 16 : o | 0, r = r.times(1 / ro(5, o)), r = kn(e, 2, r, r);
  for (var i, t = new e(5), u = new e(16), l = new e(20); o--; )
    i = r.times(r), r = r.times(t.plus(i.times(u.times(i).minus(l))));
  return r;
}
function kn(e, r, o, n, i) {
  var t, u, l, f, s = e.precision, a = Math.ceil(s / Oe);
  for (Pe = !1, f = o.times(o), l = new e(n); ; ) {
    if (u = hr(l.times(f), new e(r++ * r++), s, 1), l = i ? n.plus(u) : n.minus(u), n = hr(u.times(f), new e(r++ * r++), s, 1), u = l.plus(n), u.d[a] !== void 0) {
      for (t = a; u.d[t] === l.d[t] && t--; )
        ;
      if (t == -1)
        break;
    }
    t = l, l = n, n = u, u = t;
  }
  return Pe = !0, u.d.length = a + 1, u;
}
function ro(e, r) {
  for (var o = e; --r; )
    o *= e;
  return o;
}
function O1(e, r) {
  var o, n = r.s < 0, i = bt(e, e.precision, 1), t = i.times(0.5);
  if (r = r.abs(), r.lte(t))
    return Ut = n ? 4 : 1, r;
  if (o = r.divToInt(i), o.isZero())
    Ut = n ? 3 : 2;
  else {
    if (r = r.minus(o.times(i)), r.lte(t))
      return Ut = Oc(o) ? n ? 2 : 3 : n ? 4 : 1, r;
    Ut = Oc(o) ? n ? 1 : 4 : n ? 3 : 2;
  }
  return r.minus(i).abs();
}
function Tf(e, r, o, n) {
  var i, t, u, l, f, s, a, c, d, h = e.constructor, p = o !== void 0;
  if (p ? (Yr(o, 1, un), n === void 0 ? n = h.rounding : Yr(n, 0, 8)) : (o = h.precision, n = h.rounding), !e.isFinite())
    a = I1(e);
  else {
    for (a = Nt(e), u = a.indexOf("."), p ? (i = 2, r == 16 ? o = o * 4 - 3 : r == 8 && (o = o * 3 - 2)) : i = r, u >= 0 && (a = a.replace(".", ""), d = new h(1), d.e = a.length - u, d.d = ba(Nt(d), 10, i), d.e = d.d.length), c = ba(a, 10, i), t = f = c.length; c[--f] == 0; )
      c.pop();
    if (!c[0])
      a = p ? "0p+0" : "0";
    else {
      if (u < 0 ? t-- : (e = new h(e), e.d = c, e.e = t, e = hr(e, d, o, n, 0, i), c = e.d, t = e.e, s = D1), u = c[o], l = i / 2, s = s || c[o + 1] !== void 0, s = n < 4 ? (u !== void 0 || s) && (n === 0 || n === (e.s < 0 ? 3 : 2)) : u > l || u === l && (n === 4 || s || n === 6 && c[o - 1] & 1 || n === (e.s < 0 ? 8 : 7)), c.length = o, s)
        for (; ++c[--o] > i - 1; )
          c[o] = 0, o || (++t, c.unshift(1));
      for (f = c.length; !c[f - 1]; --f)
        ;
      for (u = 0, a = ""; u < f; u++)
        a += Ru.charAt(c[u]);
      if (p) {
        if (f > 1)
          if (r == 16 || r == 8) {
            for (u = r == 16 ? 4 : 3, --f; f % u; f++)
              a += "0";
            for (c = ba(a, i, r), f = c.length; !c[f - 1]; --f)
              ;
            for (u = 1, a = "1."; u < f; u++)
              a += Ru.charAt(c[u]);
          } else
            a = a.charAt(0) + "." + a.slice(1);
        a = a + (t < 0 ? "p" : "p+") + t;
      } else if (t < 0) {
        for (; ++t; )
          a = "0" + a;
        a = "0." + a;
      } else if (++t > f)
        for (t -= f; t--; )
          a += "0";
      else
        t < f && (a = a.slice(0, t) + "." + a.slice(t));
    }
    a = (r == 16 ? "0x" : r == 2 ? "0b" : r == 8 ? "0o" : "") + a;
  }
  return e.s < 0 ? "-" + a : a;
}
function Rc(e, r) {
  if (e.length > r)
    return e.length = r, !0;
}
function J2(e) {
  return new this(e).abs();
}
function Q2(e) {
  return new this(e).acos();
}
function ew(e) {
  return new this(e).acosh();
}
function rw(e, r) {
  return new this(e).plus(r);
}
function tw(e) {
  return new this(e).asin();
}
function nw(e) {
  return new this(e).asinh();
}
function iw(e) {
  return new this(e).atan();
}
function aw(e) {
  return new this(e).atanh();
}
function ow(e, r) {
  e = new this(e), r = new this(r);
  var o, n = this.precision, i = this.rounding, t = n + 4;
  return !e.s || !r.s ? o = new this(NaN) : !e.d && !r.d ? (o = bt(this, t, 1).times(r.s > 0 ? 0.25 : 0.75), o.s = e.s) : !r.d || e.isZero() ? (o = r.s < 0 ? bt(this, n, i) : new this(0), o.s = e.s) : !e.d || r.isZero() ? (o = bt(this, t, 1).times(0.5), o.s = e.s) : r.s < 0 ? (this.precision = t, this.rounding = 1, o = this.atan(hr(e, r, t, 1)), r = bt(this, t, 1), this.precision = n, this.rounding = i, o = e.s < 0 ? o.minus(r) : o.plus(r)) : o = this.atan(hr(e, r, t, 1)), o;
}
function sw(e) {
  return new this(e).cbrt();
}
function uw(e) {
  return Be(e = new this(e), e.e + 1, 2);
}
function fw(e, r, o) {
  return new this(e).clamp(r, o);
}
function cw(e) {
  if (!e || typeof e != "object")
    throw Error(Qa + "Object expected");
  var r, o, n, i = e.defaults === !0, t = [
    "precision",
    1,
    un,
    "rounding",
    0,
    8,
    "toExpNeg",
    -Rn,
    0,
    "toExpPos",
    0,
    Rn,
    "maxE",
    0,
    Rn,
    "minE",
    -Rn,
    0,
    "modulo",
    0,
    9
  ];
  for (r = 0; r < t.length; r += 3)
    if (o = t[r], i && (this[o] = Pu[o]), (n = e[o]) !== void 0)
      if (Hr(n) === n && n >= t[r + 1] && n <= t[r + 2])
        this[o] = n;
      else
        throw Error(an + o + ": " + n);
  if (o = "crypto", i && (this[o] = Pu[o]), (n = e[o]) !== void 0)
    if (n === !0 || n === !1 || n === 0 || n === 1)
      if (n)
        if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
          this[o] = !0;
        else
          throw Error(M1);
      else
        this[o] = !1;
    else
      throw Error(an + o + ": " + n);
  return this;
}
function lw(e) {
  return new this(e).cos();
}
function dw(e) {
  return new this(e).cosh();
}
function R1(e) {
  var r, o, n;
  function i(t) {
    var u, l, f, s = this;
    if (!(s instanceof i))
      return new i(t);
    if (s.constructor = i, Pc(t)) {
      s.s = t.s, Pe ? !t.d || t.e > i.maxE ? (s.e = NaN, s.d = null) : t.e < i.minE ? (s.e = 0, s.d = [0]) : (s.e = t.e, s.d = t.d.slice()) : (s.e = t.e, s.d = t.d ? t.d.slice() : t.d);
      return;
    }
    if (f = typeof t, f === "number") {
      if (t === 0) {
        s.s = 1 / t < 0 ? -1 : 1, s.e = 0, s.d = [0];
        return;
      }
      if (t < 0 ? (t = -t, s.s = -1) : s.s = 1, t === ~~t && t < 1e7) {
        for (u = 0, l = t; l >= 10; l /= 10)
          u++;
        Pe ? u > i.maxE ? (s.e = NaN, s.d = null) : u < i.minE ? (s.e = 0, s.d = [0]) : (s.e = u, s.d = [t]) : (s.e = u, s.d = [t]);
        return;
      } else if (t * 0 !== 0) {
        t || (s.s = NaN), s.e = NaN, s.d = null;
        return;
      }
      return zu(s, t.toString());
    } else if (f !== "string")
      throw Error(an + t);
    return (l = t.charCodeAt(0)) === 45 ? (t = t.slice(1), s.s = -1) : (l === 43 && (t = t.slice(1)), s.s = 1), C1.test(t) ? zu(s, t) : Y2(s, t);
  }
  if (i.prototype = xe, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.EUCLID = 9, i.config = i.set = cw, i.clone = R1, i.isDecimal = Pc, i.abs = J2, i.acos = Q2, i.acosh = ew, i.add = rw, i.asin = tw, i.asinh = nw, i.atan = iw, i.atanh = aw, i.atan2 = ow, i.cbrt = sw, i.ceil = uw, i.clamp = fw, i.cos = lw, i.cosh = dw, i.div = hw, i.exp = pw, i.floor = vw, i.hypot = mw, i.ln = gw, i.log = bw, i.log10 = ww, i.log2 = yw, i.max = xw, i.min = Ew, i.mod = Aw, i.mul = Sw, i.pow = Dw, i.random = Nw, i.round = Mw, i.sign = _w, i.sin = Cw, i.sinh = Tw, i.sqrt = Bw, i.sub = Fw, i.sum = Iw, i.tan = Ow, i.tanh = Rw, i.trunc = Pw, e === void 0 && (e = {}), e && e.defaults !== !0)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], r = 0; r < n.length; )
      e.hasOwnProperty(o = n[r++]) || (e[o] = this[o]);
  return i.config(e), i;
}
function hw(e, r) {
  return new this(e).div(r);
}
function pw(e) {
  return new this(e).exp();
}
function vw(e) {
  return Be(e = new this(e), e.e + 1, 3);
}
function mw() {
  var e, r, o = new this(0);
  for (Pe = !1, e = 0; e < arguments.length; )
    if (r = new this(arguments[e++]), r.d)
      o.d && (o = o.plus(r.times(r)));
    else {
      if (r.s)
        return Pe = !0, new this(1 / 0);
      o = r;
    }
  return Pe = !0, o.sqrt();
}
function Pc(e) {
  return e instanceof on || e && e.toStringTag === _1 || !1;
}
function gw(e) {
  return new this(e).ln();
}
function bw(e, r) {
  return new this(e).log(r);
}
function yw(e) {
  return new this(e).log(2);
}
function ww(e) {
  return new this(e).log(10);
}
function xw() {
  return F1(this, arguments, "lt");
}
function Ew() {
  return F1(this, arguments, "gt");
}
function Aw(e, r) {
  return new this(e).mod(r);
}
function Sw(e, r) {
  return new this(e).mul(r);
}
function Dw(e, r) {
  return new this(e).pow(r);
}
function Nw(e) {
  var r, o, n, i, t = 0, u = new this(1), l = [];
  if (e === void 0 ? e = this.precision : Yr(e, 1, un), n = Math.ceil(e / Oe), this.crypto)
    if (crypto.getRandomValues)
      for (r = crypto.getRandomValues(new Uint32Array(n)); t < n; )
        i = r[t], i >= 429e7 ? r[t] = crypto.getRandomValues(new Uint32Array(1))[0] : l[t++] = i % 1e7;
    else if (crypto.randomBytes) {
      for (r = crypto.randomBytes(n *= 4); t < n; )
        i = r[t] + (r[t + 1] << 8) + (r[t + 2] << 16) + ((r[t + 3] & 127) << 24), i >= 214e7 ? crypto.randomBytes(4).copy(r, t) : (l.push(i % 1e7), t += 4);
      t = n / 4;
    } else
      throw Error(M1);
  else
    for (; t < n; )
      l[t++] = Math.random() * 1e7 | 0;
  for (n = l[--t], e %= Oe, n && e && (i = Tr(10, Oe - e), l[t] = (n / i | 0) * i); l[t] === 0; t--)
    l.pop();
  if (t < 0)
    o = 0, l = [0];
  else {
    for (o = -1; l[0] === 0; o -= Oe)
      l.shift();
    for (n = 1, i = l[0]; i >= 10; i /= 10)
      n++;
    n < Oe && (o -= Oe - n);
  }
  return u.e = o, u.d = l, u;
}
function Mw(e) {
  return Be(e = new this(e), e.e + 1, this.rounding);
}
function _w(e) {
  return e = new this(e), e.d ? e.d[0] ? e.s : 0 * e.s : e.s || NaN;
}
function Cw(e) {
  return new this(e).sin();
}
function Tw(e) {
  return new this(e).sinh();
}
function Bw(e) {
  return new this(e).sqrt();
}
function Fw(e, r) {
  return new this(e).sub(r);
}
function Iw() {
  var e = 0, r = arguments, o = new this(r[e]);
  for (Pe = !1; o.s && ++e < r.length; )
    o = o.plus(r[e]);
  return Pe = !0, Be(o, this.precision, this.rounding);
}
function Ow(e) {
  return new this(e).tan();
}
function Rw(e) {
  return new this(e).tanh();
}
function Pw(e) {
  return Be(e = new this(e), e.e + 1, 1);
}
xe[Symbol.for("nodejs.util.inspect.custom")] = xe.toString;
xe[Symbol.toStringTag] = "Decimal";
var on = xe.constructor = R1(Pu);
Ea = new on(Ea);
Aa = new on(Aa);
var qw = "BigNumber", $w = ["?on", "config"], zw = /* @__PURE__ */ Q(qw, $w, (e) => {
  var {
    on: r,
    config: o
  } = e, n = on.clone({
    precision: o.precision,
    modulo: on.EUCLID
  });
  return n.prototype = Object.create(n.prototype), n.prototype.type = "BigNumber", n.prototype.isBigNumber = !0, n.prototype.toJSON = function() {
    return {
      mathjs: "BigNumber",
      value: this.toString()
    };
  }, n.fromJSON = function(i) {
    return new n(i.value);
  }, r && r("config", function(i, t) {
    i.precision !== t.precision && n.config({
      precision: i.precision
    });
  }), n;
}, {
  isClass: !0
}), Xe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ti(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Lw(e) {
  if (e.__esModule)
    return e;
  var r = e.default;
  if (typeof r == "function") {
    var o = function n() {
      return this instanceof n ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    o.prototype = r.prototype;
  } else
    o = {};
  return Object.defineProperty(o, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(o, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), o;
}
var P1 = { exports: {} };
/**
 * @license Complex.js v2.1.1 12/05/2020
 *
 * Copyright (c) 2020, Robert Eisele (robert@xarg.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/
(function(e, r) {
  (function(o) {
    var n = Math.cosh || function(c) {
      return Math.abs(c) < 1e-9 ? 1 - c : (Math.exp(c) + Math.exp(-c)) * 0.5;
    }, i = Math.sinh || function(c) {
      return Math.abs(c) < 1e-9 ? c : (Math.exp(c) - Math.exp(-c)) * 0.5;
    }, t = function(c) {
      var d = Math.PI / 4;
      if (-d > c || c > d)
        return Math.cos(c) - 1;
      var h = c * c;
      return h * (h * (h * (h * (h * (h * (h * (h / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 1 / 2);
    }, u = function(c, d) {
      var h = Math.abs(c), p = Math.abs(d);
      return h < 3e3 && p < 3e3 ? Math.sqrt(h * h + p * p) : (h < p ? (h = p, p = c / d) : p = d / c, h * Math.sqrt(1 + p * p));
    }, l = function() {
      throw SyntaxError("Invalid Param");
    };
    function f(c, d) {
      var h = Math.abs(c), p = Math.abs(d);
      return c === 0 ? Math.log(p) : d === 0 ? Math.log(h) : h < 3e3 && p < 3e3 ? Math.log(c * c + d * d) * 0.5 : (c = c / 2, d = d / 2, 0.5 * Math.log(c * c + d * d) + Math.LN2);
    }
    var s = function(c, d) {
      var h = { re: 0, im: 0 };
      if (c == null)
        h.re = h.im = 0;
      else if (d !== void 0)
        h.re = c, h.im = d;
      else
        switch (typeof c) {
          case "object":
            if ("im" in c && "re" in c)
              h.re = c.re, h.im = c.im;
            else if ("abs" in c && "arg" in c) {
              if (!Number.isFinite(c.abs) && Number.isFinite(c.arg))
                return a.INFINITY;
              h.re = c.abs * Math.cos(c.arg), h.im = c.abs * Math.sin(c.arg);
            } else if ("r" in c && "phi" in c) {
              if (!Number.isFinite(c.r) && Number.isFinite(c.phi))
                return a.INFINITY;
              h.re = c.r * Math.cos(c.phi), h.im = c.r * Math.sin(c.phi);
            } else
              c.length === 2 ? (h.re = c[0], h.im = c[1]) : l();
            break;
          case "string":
            h.im = /* void */
            h.re = 0;
            var p = c.match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g), v = 1, g = 0;
            p === null && l();
            for (var m = 0; m < p.length; m++) {
              var x = p[m];
              x === " " || x === "	" || x === `
` || (x === "+" ? v++ : x === "-" ? g++ : x === "i" || x === "I" ? (v + g === 0 && l(), p[m + 1] !== " " && !isNaN(p[m + 1]) ? (h.im += parseFloat((g % 2 ? "-" : "") + p[m + 1]), m++) : h.im += parseFloat((g % 2 ? "-" : "") + "1"), v = g = 0) : ((v + g === 0 || isNaN(x)) && l(), p[m + 1] === "i" || p[m + 1] === "I" ? (h.im += parseFloat((g % 2 ? "-" : "") + x), m++) : h.re += parseFloat((g % 2 ? "-" : "") + x), v = g = 0));
            }
            v + g > 0 && l();
            break;
          case "number":
            h.im = 0, h.re = c;
            break;
          default:
            l();
        }
      return isNaN(h.re) || isNaN(h.im), h;
    };
    function a(c, d) {
      if (!(this instanceof a))
        return new a(c, d);
      var h = s(c, d);
      this.re = h.re, this.im = h.im;
    }
    a.prototype = {
      re: 0,
      im: 0,
      /**
       * Calculates the sign of a complex number, which is a normalized complex
       *
       * @returns {Complex}
       */
      sign: function() {
        var c = this.abs();
        return new a(
          this.re / c,
          this.im / c
        );
      },
      /**
       * Adds two complex numbers
       *
       * @returns {Complex}
       */
      add: function(c, d) {
        var h = new a(c, d);
        return this.isInfinite() && h.isInfinite() ? a.NAN : this.isInfinite() || h.isInfinite() ? a.INFINITY : new a(
          this.re + h.re,
          this.im + h.im
        );
      },
      /**
       * Subtracts two complex numbers
       *
       * @returns {Complex}
       */
      sub: function(c, d) {
        var h = new a(c, d);
        return this.isInfinite() && h.isInfinite() ? a.NAN : this.isInfinite() || h.isInfinite() ? a.INFINITY : new a(
          this.re - h.re,
          this.im - h.im
        );
      },
      /**
       * Multiplies two complex numbers
       *
       * @returns {Complex}
       */
      mul: function(c, d) {
        var h = new a(c, d);
        return this.isInfinite() && h.isZero() || this.isZero() && h.isInfinite() ? a.NAN : this.isInfinite() || h.isInfinite() ? a.INFINITY : h.im === 0 && this.im === 0 ? new a(this.re * h.re, 0) : new a(
          this.re * h.re - this.im * h.im,
          this.re * h.im + this.im * h.re
        );
      },
      /**
       * Divides two complex numbers
       *
       * @returns {Complex}
       */
      div: function(c, d) {
        var h = new a(c, d);
        if (this.isZero() && h.isZero() || this.isInfinite() && h.isInfinite())
          return a.NAN;
        if (this.isInfinite() || h.isZero())
          return a.INFINITY;
        if (this.isZero() || h.isInfinite())
          return a.ZERO;
        c = this.re, d = this.im;
        var p = h.re, v = h.im, g, m;
        return v === 0 ? new a(c / p, d / p) : Math.abs(p) < Math.abs(v) ? (m = p / v, g = p * m + v, new a(
          (c * m + d) / g,
          (d * m - c) / g
        )) : (m = v / p, g = v * m + p, new a(
          (c + d * m) / g,
          (d - c * m) / g
        ));
      },
      /**
       * Calculate the power of two complex numbers
       *
       * @returns {Complex}
       */
      pow: function(c, d) {
        var h = new a(c, d);
        if (c = this.re, d = this.im, h.isZero())
          return a.ONE;
        if (h.im === 0) {
          if (d === 0 && c > 0)
            return new a(Math.pow(c, h.re), 0);
          if (c === 0)
            switch ((h.re % 4 + 4) % 4) {
              case 0:
                return new a(Math.pow(d, h.re), 0);
              case 1:
                return new a(0, Math.pow(d, h.re));
              case 2:
                return new a(-Math.pow(d, h.re), 0);
              case 3:
                return new a(0, -Math.pow(d, h.re));
            }
        }
        if (c === 0 && d === 0 && h.re > 0 && h.im >= 0)
          return a.ZERO;
        var p = Math.atan2(d, c), v = f(c, d);
        return c = Math.exp(h.re * v - h.im * p), d = h.im * v + h.re * p, new a(
          c * Math.cos(d),
          c * Math.sin(d)
        );
      },
      /**
       * Calculate the complex square root
       *
       * @returns {Complex}
       */
      sqrt: function() {
        var c = this.re, d = this.im, h = this.abs(), p, v;
        if (c >= 0) {
          if (d === 0)
            return new a(Math.sqrt(c), 0);
          p = 0.5 * Math.sqrt(2 * (h + c));
        } else
          p = Math.abs(d) / Math.sqrt(2 * (h - c));
        return c <= 0 ? v = 0.5 * Math.sqrt(2 * (h - c)) : v = Math.abs(d) / Math.sqrt(2 * (h + c)), new a(p, d < 0 ? -v : v);
      },
      /**
       * Calculate the complex exponent
       *
       * @returns {Complex}
       */
      exp: function() {
        var c = Math.exp(this.re);
        return this.im, new a(
          c * Math.cos(this.im),
          c * Math.sin(this.im)
        );
      },
      /**
       * Calculate the complex exponent and subtracts one.
       *
       * This may be more accurate than `Complex(x).exp().sub(1)` if
       * `x` is small.
       *
       * @returns {Complex}
       */
      expm1: function() {
        var c = this.re, d = this.im;
        return new a(
          Math.expm1(c) * Math.cos(d) + t(d),
          Math.exp(c) * Math.sin(d)
        );
      },
      /**
       * Calculate the natural log
       *
       * @returns {Complex}
       */
      log: function() {
        var c = this.re, d = this.im;
        return new a(
          f(c, d),
          Math.atan2(d, c)
        );
      },
      /**
       * Calculate the magnitude of the complex number
       *
       * @returns {number}
       */
      abs: function() {
        return u(this.re, this.im);
      },
      /**
       * Calculate the angle of the complex number
       *
       * @returns {number}
       */
      arg: function() {
        return Math.atan2(this.im, this.re);
      },
      /**
       * Calculate the sine of the complex number
       *
       * @returns {Complex}
       */
      sin: function() {
        var c = this.re, d = this.im;
        return new a(
          Math.sin(c) * n(d),
          Math.cos(c) * i(d)
        );
      },
      /**
       * Calculate the cosine
       *
       * @returns {Complex}
       */
      cos: function() {
        var c = this.re, d = this.im;
        return new a(
          Math.cos(c) * n(d),
          -Math.sin(c) * i(d)
        );
      },
      /**
       * Calculate the tangent
       *
       * @returns {Complex}
       */
      tan: function() {
        var c = 2 * this.re, d = 2 * this.im, h = Math.cos(c) + n(d);
        return new a(
          Math.sin(c) / h,
          i(d) / h
        );
      },
      /**
       * Calculate the cotangent
       *
       * @returns {Complex}
       */
      cot: function() {
        var c = 2 * this.re, d = 2 * this.im, h = Math.cos(c) - n(d);
        return new a(
          -Math.sin(c) / h,
          i(d) / h
        );
      },
      /**
       * Calculate the secant
       *
       * @returns {Complex}
       */
      sec: function() {
        var c = this.re, d = this.im, h = 0.5 * n(2 * d) + 0.5 * Math.cos(2 * c);
        return new a(
          Math.cos(c) * n(d) / h,
          Math.sin(c) * i(d) / h
        );
      },
      /**
       * Calculate the cosecans
       *
       * @returns {Complex}
       */
      csc: function() {
        var c = this.re, d = this.im, h = 0.5 * n(2 * d) - 0.5 * Math.cos(2 * c);
        return new a(
          Math.sin(c) * n(d) / h,
          -Math.cos(c) * i(d) / h
        );
      },
      /**
       * Calculate the complex arcus sinus
       *
       * @returns {Complex}
       */
      asin: function() {
        var c = this.re, d = this.im, h = new a(
          d * d - c * c + 1,
          -2 * c * d
        ).sqrt(), p = new a(
          h.re - d,
          h.im + c
        ).log();
        return new a(p.im, -p.re);
      },
      /**
       * Calculate the complex arcus cosinus
       *
       * @returns {Complex}
       */
      acos: function() {
        var c = this.re, d = this.im, h = new a(
          d * d - c * c + 1,
          -2 * c * d
        ).sqrt(), p = new a(
          h.re - d,
          h.im + c
        ).log();
        return new a(Math.PI / 2 - p.im, p.re);
      },
      /**
       * Calculate the complex arcus tangent
       *
       * @returns {Complex}
       */
      atan: function() {
        var c = this.re, d = this.im;
        if (c === 0) {
          if (d === 1)
            return new a(0, 1 / 0);
          if (d === -1)
            return new a(0, -1 / 0);
        }
        var h = c * c + (1 - d) * (1 - d), p = new a(
          (1 - d * d - c * c) / h,
          -2 * c / h
        ).log();
        return new a(-0.5 * p.im, 0.5 * p.re);
      },
      /**
       * Calculate the complex arcus cotangent
       *
       * @returns {Complex}
       */
      acot: function() {
        var c = this.re, d = this.im;
        if (d === 0)
          return new a(Math.atan2(1, c), 0);
        var h = c * c + d * d;
        return h !== 0 ? new a(
          c / h,
          -d / h
        ).atan() : new a(
          c !== 0 ? c / 0 : 0,
          d !== 0 ? -d / 0 : 0
        ).atan();
      },
      /**
       * Calculate the complex arcus secant
       *
       * @returns {Complex}
       */
      asec: function() {
        var c = this.re, d = this.im;
        if (c === 0 && d === 0)
          return new a(0, 1 / 0);
        var h = c * c + d * d;
        return h !== 0 ? new a(
          c / h,
          -d / h
        ).acos() : new a(
          c !== 0 ? c / 0 : 0,
          d !== 0 ? -d / 0 : 0
        ).acos();
      },
      /**
       * Calculate the complex arcus cosecans
       *
       * @returns {Complex}
       */
      acsc: function() {
        var c = this.re, d = this.im;
        if (c === 0 && d === 0)
          return new a(Math.PI / 2, 1 / 0);
        var h = c * c + d * d;
        return h !== 0 ? new a(
          c / h,
          -d / h
        ).asin() : new a(
          c !== 0 ? c / 0 : 0,
          d !== 0 ? -d / 0 : 0
        ).asin();
      },
      /**
       * Calculate the complex sinh
       *
       * @returns {Complex}
       */
      sinh: function() {
        var c = this.re, d = this.im;
        return new a(
          i(c) * Math.cos(d),
          n(c) * Math.sin(d)
        );
      },
      /**
       * Calculate the complex cosh
       *
       * @returns {Complex}
       */
      cosh: function() {
        var c = this.re, d = this.im;
        return new a(
          n(c) * Math.cos(d),
          i(c) * Math.sin(d)
        );
      },
      /**
       * Calculate the complex tanh
       *
       * @returns {Complex}
       */
      tanh: function() {
        var c = 2 * this.re, d = 2 * this.im, h = n(c) + Math.cos(d);
        return new a(
          i(c) / h,
          Math.sin(d) / h
        );
      },
      /**
       * Calculate the complex coth
       *
       * @returns {Complex}
       */
      coth: function() {
        var c = 2 * this.re, d = 2 * this.im, h = n(c) - Math.cos(d);
        return new a(
          i(c) / h,
          -Math.sin(d) / h
        );
      },
      /**
       * Calculate the complex coth
       *
       * @returns {Complex}
       */
      csch: function() {
        var c = this.re, d = this.im, h = Math.cos(2 * d) - n(2 * c);
        return new a(
          -2 * i(c) * Math.cos(d) / h,
          2 * n(c) * Math.sin(d) / h
        );
      },
      /**
       * Calculate the complex sech
       *
       * @returns {Complex}
       */
      sech: function() {
        var c = this.re, d = this.im, h = Math.cos(2 * d) + n(2 * c);
        return new a(
          2 * n(c) * Math.cos(d) / h,
          -2 * i(c) * Math.sin(d) / h
        );
      },
      /**
       * Calculate the complex asinh
       *
       * @returns {Complex}
       */
      asinh: function() {
        var c = this.im;
        this.im = -this.re, this.re = c;
        var d = this.asin();
        return this.re = -this.im, this.im = c, c = d.re, d.re = -d.im, d.im = c, d;
      },
      /**
       * Calculate the complex acosh
       *
       * @returns {Complex}
       */
      acosh: function() {
        var c = this.acos();
        if (c.im <= 0) {
          var d = c.re;
          c.re = -c.im, c.im = d;
        } else {
          var d = c.im;
          c.im = -c.re, c.re = d;
        }
        return c;
      },
      /**
       * Calculate the complex atanh
       *
       * @returns {Complex}
       */
      atanh: function() {
        var c = this.re, d = this.im, h = c > 1 && d === 0, p = 1 - c, v = 1 + c, g = p * p + d * d, m = g !== 0 ? new a(
          (v * p - d * d) / g,
          (d * p + v * d) / g
        ) : new a(
          c !== -1 ? c / 0 : 0,
          d !== 0 ? d / 0 : 0
        ), x = m.re;
        return m.re = f(m.re, m.im) / 2, m.im = Math.atan2(m.im, x) / 2, h && (m.im = -m.im), m;
      },
      /**
       * Calculate the complex acoth
       *
       * @returns {Complex}
       */
      acoth: function() {
        var c = this.re, d = this.im;
        if (c === 0 && d === 0)
          return new a(0, Math.PI / 2);
        var h = c * c + d * d;
        return h !== 0 ? new a(
          c / h,
          -d / h
        ).atanh() : new a(
          c !== 0 ? c / 0 : 0,
          d !== 0 ? -d / 0 : 0
        ).atanh();
      },
      /**
       * Calculate the complex acsch
       *
       * @returns {Complex}
       */
      acsch: function() {
        var c = this.re, d = this.im;
        if (d === 0)
          return new a(
            c !== 0 ? Math.log(c + Math.sqrt(c * c + 1)) : 1 / 0,
            0
          );
        var h = c * c + d * d;
        return h !== 0 ? new a(
          c / h,
          -d / h
        ).asinh() : new a(
          c !== 0 ? c / 0 : 0,
          d !== 0 ? -d / 0 : 0
        ).asinh();
      },
      /**
       * Calculate the complex asech
       *
       * @returns {Complex}
       */
      asech: function() {
        var c = this.re, d = this.im;
        if (this.isZero())
          return a.INFINITY;
        var h = c * c + d * d;
        return h !== 0 ? new a(
          c / h,
          -d / h
        ).acosh() : new a(
          c !== 0 ? c / 0 : 0,
          d !== 0 ? -d / 0 : 0
        ).acosh();
      },
      /**
       * Calculate the complex inverse 1/z
       *
       * @returns {Complex}
       */
      inverse: function() {
        if (this.isZero())
          return a.INFINITY;
        if (this.isInfinite())
          return a.ZERO;
        var c = this.re, d = this.im, h = c * c + d * d;
        return new a(c / h, -d / h);
      },
      /**
       * Returns the complex conjugate
       *
       * @returns {Complex}
       */
      conjugate: function() {
        return new a(this.re, -this.im);
      },
      /**
       * Gets the negated complex number
       *
       * @returns {Complex}
       */
      neg: function() {
        return new a(-this.re, -this.im);
      },
      /**
       * Ceils the actual complex number
       *
       * @returns {Complex}
       */
      ceil: function(c) {
        return c = Math.pow(10, c || 0), new a(
          Math.ceil(this.re * c) / c,
          Math.ceil(this.im * c) / c
        );
      },
      /**
       * Floors the actual complex number
       *
       * @returns {Complex}
       */
      floor: function(c) {
        return c = Math.pow(10, c || 0), new a(
          Math.floor(this.re * c) / c,
          Math.floor(this.im * c) / c
        );
      },
      /**
       * Ceils the actual complex number
       *
       * @returns {Complex}
       */
      round: function(c) {
        return c = Math.pow(10, c || 0), new a(
          Math.round(this.re * c) / c,
          Math.round(this.im * c) / c
        );
      },
      /**
       * Compares two complex numbers
       *
       * **Note:** new Complex(Infinity).equals(Infinity) === false
       *
       * @returns {boolean}
       */
      equals: function(c, d) {
        var h = new a(c, d);
        return Math.abs(h.re - this.re) <= a.EPSILON && Math.abs(h.im - this.im) <= a.EPSILON;
      },
      /**
       * Clones the actual object
       *
       * @returns {Complex}
       */
      clone: function() {
        return new a(this.re, this.im);
      },
      /**
       * Gets a string of the actual complex number
       *
       * @returns {string}
       */
      toString: function() {
        var c = this.re, d = this.im, h = "";
        return this.isNaN() ? "NaN" : this.isInfinite() ? "Infinity" : (Math.abs(c) < a.EPSILON && (c = 0), Math.abs(d) < a.EPSILON && (d = 0), d === 0 ? h + c : (c !== 0 ? (h += c, h += " ", d < 0 ? (d = -d, h += "-") : h += "+", h += " ") : d < 0 && (d = -d, h += "-"), d !== 1 && (h += d), h + "i"));
      },
      /**
       * Returns the actual number as a vector
       *
       * @returns {Array}
       */
      toVector: function() {
        return [this.re, this.im];
      },
      /**
       * Returns the actual real value of the current object
       *
       * @returns {number|null}
       */
      valueOf: function() {
        return this.im === 0 ? this.re : null;
      },
      /**
       * Determines whether a complex number is not on the Riemann sphere.
       *
       * @returns {boolean}
       */
      isNaN: function() {
        return isNaN(this.re) || isNaN(this.im);
      },
      /**
       * Determines whether or not a complex number is at the zero pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      isZero: function() {
        return this.im === 0 && this.re === 0;
      },
      /**
       * Determines whether a complex number is not at the infinity pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      isFinite: function() {
        return isFinite(this.re) && isFinite(this.im);
      },
      /**
       * Determines whether or not a complex number is at the infinity pole of the
       * Riemann sphere.
       *
       * @returns {boolean}
       */
      isInfinite: function() {
        return !(this.isNaN() || this.isFinite());
      }
    }, a.ZERO = new a(0, 0), a.ONE = new a(1, 0), a.I = new a(0, 1), a.PI = new a(Math.PI, 0), a.E = new a(Math.E, 0), a.INFINITY = new a(1 / 0, 1 / 0), a.NAN = new a(NaN, NaN), a.EPSILON = 1e-15, Object.defineProperty(a, "__esModule", { value: !0 }), a.default = a, a.Complex = a, e.exports = a;
  })();
})(P1);
var Uw = P1.exports;
const Pr = /* @__PURE__ */ Ti(Uw);
var kw = "Complex", Hw = [], Gw = /* @__PURE__ */ Q(kw, Hw, () => (Object.defineProperty(Pr, "name", {
  value: "Complex"
}), Pr.prototype.constructor = Pr, Pr.prototype.type = "Complex", Pr.prototype.isComplex = !0, Pr.prototype.toJSON = function() {
  return {
    mathjs: "Complex",
    re: this.re,
    im: this.im
  };
}, Pr.prototype.toPolar = function() {
  return {
    r: this.abs(),
    phi: this.arg()
  };
}, Pr.prototype.format = function(e) {
  var r = "", o = this.im, n = this.re, i = xn(this.re, e), t = xn(this.im, e), u = $e(e) ? e : e ? e.precision : null;
  if (u !== null) {
    var l = Math.pow(10, -u);
    Math.abs(n / o) < l && (n = 0), Math.abs(o / n) < l && (o = 0);
  }
  return o === 0 ? r = i : n === 0 ? o === 1 ? r = "i" : o === -1 ? r = "-i" : r = t + "i" : o < 0 ? o === -1 ? r = i + " - i" : r = i + " - " + t.substring(1) + "i" : o === 1 ? r = i + " + i" : r = i + " + " + t + "i", r;
}, Pr.fromPolar = function(e) {
  switch (arguments.length) {
    case 1: {
      var r = arguments[0];
      if (typeof r == "object")
        return Pr(r);
      throw new TypeError("Input has to be an object with r and phi keys.");
    }
    case 2: {
      var o = arguments[0], n = arguments[1];
      if ($e(o)) {
        if (jr(n) && n.hasBase("ANGLE") && (n = n.toNumber("rad")), $e(n))
          return new Pr({
            r: o,
            phi: n
          });
        throw new TypeError("Phi is not a number nor an angle unit.");
      } else
        throw new TypeError("Radius r is not a number.");
    }
    default:
      throw new SyntaxError("Wrong number of arguments in function fromPolar");
  }
}, Pr.prototype.valueOf = Pr.prototype.toString, Pr.fromJSON = function(e) {
  return new Pr(e);
}, Pr.compare = function(e, r) {
  return e.re > r.re ? 1 : e.re < r.re ? -1 : e.im > r.im ? 1 : e.im < r.im ? -1 : 0;
}, Pr), {
  isClass: !0
});
/**
 * @license Fraction.js v4.3.7 31/08/2023
 * https://www.xarg.org/2014/03/rational-numbers-in-javascript/
 *
 * Copyright (c) 2023, Robert Eisele (robert@raw.org)
 * Dual licensed under the MIT or GPL Version 2 licenses.
 **/
var Vw = 2e3, Ce = {
  s: 1,
  n: 0,
  d: 1
};
function $t(e, r) {
  if (isNaN(e = parseInt(e, 10)))
    throw ya();
  return e * r;
}
function Mr(e, r) {
  if (r === 0)
    throw Bf();
  var o = Object.create(Ur.prototype);
  o.s = e < 0 ? -1 : 1, e = e < 0 ? -e : e;
  var n = Pn(e, r);
  return o.n = e / n, o.d = r / n, o;
}
function qc(e) {
  for (var r = {}, o = e, n = 2, i = 4; i <= o; ) {
    for (; o % n === 0; )
      o /= n, r[n] = (r[n] || 0) + 1;
    i += 1 + 2 * n++;
  }
  return o !== e ? o > 1 && (r[o] = (r[o] || 0) + 1) : r[e] = (r[e] || 0) + 1, r;
}
var rt = function(e, r) {
  var o = 0, n = 1, i = 1, t = 0, u = 0, l = 0, f = 1, s = 1, a = 0, c = 1, d = 1, h = 1, p = 1e7, v;
  if (e != null)
    if (r !== void 0) {
      if (o = e, n = r, i = o * n, o % 1 !== 0 || n % 1 !== 0)
        throw jw();
    } else
      switch (typeof e) {
        case "object": {
          if ("d" in e && "n" in e)
            o = e.n, n = e.d, "s" in e && (o *= e.s);
          else if (0 in e)
            o = e[0], 1 in e && (n = e[1]);
          else
            throw ya();
          i = o * n;
          break;
        }
        case "number": {
          if (e < 0 && (i = e, e = -e), e % 1 === 0)
            o = e;
          else if (e > 0) {
            for (e >= 1 && (s = Math.pow(10, Math.floor(1 + Math.log(e) / Math.LN10)), e /= s); c <= p && h <= p; )
              if (v = (a + d) / (c + h), e === v) {
                c + h <= p ? (o = a + d, n = c + h) : h > c ? (o = d, n = h) : (o = a, n = c);
                break;
              } else
                e > v ? (a += d, c += h) : (d += a, h += c), c > p ? (o = d, n = h) : (o = a, n = c);
            o *= s;
          } else
            (isNaN(e) || isNaN(r)) && (n = o = NaN);
          break;
        }
        case "string": {
          if (c = e.match(/\d+|./g), c === null)
            throw ya();
          if (c[a] === "-" ? (i = -1, a++) : c[a] === "+" && a++, c.length === a + 1 ? u = $t(c[a++], i) : c[a + 1] === "." || c[a] === "." ? (c[a] !== "." && (t = $t(c[a++], i)), a++, (a + 1 === c.length || c[a + 1] === "(" && c[a + 3] === ")" || c[a + 1] === "'" && c[a + 3] === "'") && (u = $t(c[a], i), f = Math.pow(10, c[a].length), a++), (c[a] === "(" && c[a + 2] === ")" || c[a] === "'" && c[a + 2] === "'") && (l = $t(c[a + 1], i), s = Math.pow(10, c[a + 1].length) - 1, a += 3)) : c[a + 1] === "/" || c[a + 1] === ":" ? (u = $t(c[a], i), f = $t(c[a + 2], 1), a += 3) : c[a + 3] === "/" && c[a + 1] === " " && (t = $t(c[a], i), u = $t(c[a + 2], i), f = $t(c[a + 4], 1), a += 5), c.length <= a) {
            n = f * s, i = /* void */
            o = l + n * t + s * u;
            break;
          }
        }
        default:
          throw ya();
      }
  if (n === 0)
    throw Bf();
  Ce.s = i < 0 ? -1 : 1, Ce.n = Math.abs(o), Ce.d = Math.abs(n);
};
function Ww(e, r, o) {
  for (var n = 1; r > 0; e = e * e % o, r >>= 1)
    r & 1 && (n = n * e % o);
  return n;
}
function Kw(e, r) {
  for (; r % 2 === 0; r /= 2)
    ;
  for (; r % 5 === 0; r /= 5)
    ;
  if (r === 1)
    return 0;
  for (var o = 10 % r, n = 1; o !== 1; n++)
    if (o = o * 10 % r, n > Vw)
      return 0;
  return n;
}
function Zw(e, r, o) {
  for (var n = 1, i = Ww(10, o, r), t = 0; t < 300; t++) {
    if (n === i)
      return t;
    n = n * 10 % r, i = i * 10 % r;
  }
  return 0;
}
function Pn(e, r) {
  if (!e)
    return r;
  if (!r)
    return e;
  for (; ; ) {
    if (e %= r, !e)
      return r;
    if (r %= e, !r)
      return e;
  }
}
function Ur(e, r) {
  if (rt(e, r), this instanceof Ur)
    e = Pn(Ce.d, Ce.n), this.s = Ce.s, this.n = Ce.n / e, this.d = Ce.d / e;
  else
    return Mr(Ce.s * Ce.n, Ce.d);
}
var Bf = function() {
  return new Error("Division by Zero");
}, ya = function() {
  return new Error("Invalid argument");
}, jw = function() {
  return new Error("Parameters must be integer");
};
Ur.prototype = {
  s: 1,
  n: 0,
  d: 1,
  /**
   * Calculates the absolute value
   *
   * Ex: new Fraction(-4).abs() => 4
   **/
  abs: function() {
    return Mr(this.n, this.d);
  },
  /**
   * Inverts the sign of the current fraction
   *
   * Ex: new Fraction(-4).neg() => 4
   **/
  neg: function() {
    return Mr(-this.s * this.n, this.d);
  },
  /**
   * Adds two rational numbers
   *
   * Ex: new Fraction({n: 2, d: 3}).add("14.9") => 467 / 30
   **/
  add: function(e, r) {
    return rt(e, r), Mr(
      this.s * this.n * Ce.d + Ce.s * this.d * Ce.n,
      this.d * Ce.d
    );
  },
  /**
   * Subtracts two rational numbers
   *
   * Ex: new Fraction({n: 2, d: 3}).add("14.9") => -427 / 30
   **/
  sub: function(e, r) {
    return rt(e, r), Mr(
      this.s * this.n * Ce.d - Ce.s * this.d * Ce.n,
      this.d * Ce.d
    );
  },
  /**
   * Multiplies two rational numbers
   *
   * Ex: new Fraction("-17.(345)").mul(3) => 5776 / 111
   **/
  mul: function(e, r) {
    return rt(e, r), Mr(
      this.s * Ce.s * this.n * Ce.n,
      this.d * Ce.d
    );
  },
  /**
   * Divides two rational numbers
   *
   * Ex: new Fraction("-17.(345)").inverse().div(3)
   **/
  div: function(e, r) {
    return rt(e, r), Mr(
      this.s * Ce.s * this.n * Ce.d,
      this.d * Ce.n
    );
  },
  /**
   * Clones the actual object
   *
   * Ex: new Fraction("-17.(345)").clone()
   **/
  clone: function() {
    return Mr(this.s * this.n, this.d);
  },
  /**
   * Calculates the modulo of two rational numbers - a more precise fmod
   *
   * Ex: new Fraction('4.(3)').mod([7, 8]) => (13/3) % (7/8) = (5/6)
   **/
  mod: function(e, r) {
    if (isNaN(this.n) || isNaN(this.d))
      return new Ur(NaN);
    if (e === void 0)
      return Mr(this.s * this.n % this.d, 1);
    if (rt(e, r), Ce.n === 0 && this.d === 0)
      throw Bf();
    return Mr(
      this.s * (Ce.d * this.n) % (Ce.n * this.d),
      Ce.d * this.d
    );
  },
  /**
   * Calculates the fractional gcd of two rational numbers
   *
   * Ex: new Fraction(5,8).gcd(3,7) => 1/56
   */
  gcd: function(e, r) {
    return rt(e, r), Mr(Pn(Ce.n, this.n) * Pn(Ce.d, this.d), Ce.d * this.d);
  },
  /**
   * Calculates the fractional lcm of two rational numbers
   *
   * Ex: new Fraction(5,8).lcm(3,7) => 15
   */
  lcm: function(e, r) {
    return rt(e, r), Ce.n === 0 && this.n === 0 ? Mr(0, 1) : Mr(Ce.n * this.n, Pn(Ce.n, this.n) * Pn(Ce.d, this.d));
  },
  /**
   * Calculates the ceil of a rational number
   *
   * Ex: new Fraction('4.(3)').ceil() => (5 / 1)
   **/
  ceil: function(e) {
    return e = Math.pow(10, e || 0), isNaN(this.n) || isNaN(this.d) ? new Ur(NaN) : Mr(Math.ceil(e * this.s * this.n / this.d), e);
  },
  /**
   * Calculates the floor of a rational number
   *
   * Ex: new Fraction('4.(3)').floor() => (4 / 1)
   **/
  floor: function(e) {
    return e = Math.pow(10, e || 0), isNaN(this.n) || isNaN(this.d) ? new Ur(NaN) : Mr(Math.floor(e * this.s * this.n / this.d), e);
  },
  /**
   * Rounds a rational number
   *
   * Ex: new Fraction('4.(3)').round() => (4 / 1)
   **/
  round: function(e) {
    return e = Math.pow(10, e || 0), isNaN(this.n) || isNaN(this.d) ? new Ur(NaN) : Mr(Math.round(e * this.s * this.n / this.d), e);
  },
  /**
   * Rounds a rational number to a multiple of another rational number
   *
   * Ex: new Fraction('0.9').roundTo("1/8") => 7 / 8
   **/
  roundTo: function(e, r) {
    return rt(e, r), Mr(this.s * Math.round(this.n * Ce.d / (this.d * Ce.n)) * Ce.n, Ce.d);
  },
  /**
   * Gets the inverse of the fraction, means numerator and denominator are exchanged
   *
   * Ex: new Fraction([-3, 4]).inverse() => -4 / 3
   **/
  inverse: function() {
    return Mr(this.s * this.d, this.n);
  },
  /**
   * Calculates the fraction to some rational exponent, if possible
   *
   * Ex: new Fraction(-1,2).pow(-3) => -8
   */
  pow: function(e, r) {
    if (rt(e, r), Ce.d === 1)
      return Ce.s < 0 ? Mr(Math.pow(this.s * this.d, Ce.n), Math.pow(this.n, Ce.n)) : Mr(Math.pow(this.s * this.n, Ce.n), Math.pow(this.d, Ce.n));
    if (this.s < 0)
      return null;
    var o = qc(this.n), n = qc(this.d), i = 1, t = 1;
    for (var u in o)
      if (u !== "1") {
        if (u === "0") {
          i = 0;
          break;
        }
        if (o[u] *= Ce.n, o[u] % Ce.d === 0)
          o[u] /= Ce.d;
        else
          return null;
        i *= Math.pow(u, o[u]);
      }
    for (var u in n)
      if (u !== "1") {
        if (n[u] *= Ce.n, n[u] % Ce.d === 0)
          n[u] /= Ce.d;
        else
          return null;
        t *= Math.pow(u, n[u]);
      }
    return Ce.s < 0 ? Mr(t, i) : Mr(i, t);
  },
  /**
   * Check if two rational numbers are the same
   *
   * Ex: new Fraction(19.6).equals([98, 5]);
   **/
  equals: function(e, r) {
    return rt(e, r), this.s * this.n * Ce.d === Ce.s * Ce.n * this.d;
  },
  /**
   * Check if two rational numbers are the same
   *
   * Ex: new Fraction(19.6).equals([98, 5]);
   **/
  compare: function(e, r) {
    rt(e, r);
    var o = this.s * this.n * Ce.d - Ce.s * Ce.n * this.d;
    return (0 < o) - (o < 0);
  },
  simplify: function(e) {
    if (isNaN(this.n) || isNaN(this.d))
      return this;
    e = e || 1e-3;
    for (var r = this.abs(), o = r.toContinued(), n = 1; n < o.length; n++) {
      for (var i = Mr(o[n - 1], 1), t = n - 2; t >= 0; t--)
        i = i.inverse().add(o[t]);
      if (Math.abs(i.sub(r).valueOf()) < e)
        return i.mul(this.s);
    }
    return this;
  },
  /**
   * Check if two rational numbers are divisible
   *
   * Ex: new Fraction(19.6).divisible(1.5);
   */
  divisible: function(e, r) {
    return rt(e, r), !(!(Ce.n * this.d) || this.n * Ce.d % (Ce.n * this.d));
  },
  /**
   * Returns a decimal representation of the fraction
   *
   * Ex: new Fraction("100.'91823'").valueOf() => 100.91823918239183
   **/
  valueOf: function() {
    return this.s * this.n / this.d;
  },
  /**
   * Returns a string-fraction representation of a Fraction object
   *
   * Ex: new Fraction("1.'3'").toFraction(true) => "4 1/3"
   **/
  toFraction: function(e) {
    var r, o = "", n = this.n, i = this.d;
    return this.s < 0 && (o += "-"), i === 1 ? o += n : (e && (r = Math.floor(n / i)) > 0 && (o += r, o += " ", n %= i), o += n, o += "/", o += i), o;
  },
  /**
   * Returns a latex representation of a Fraction object
   *
   * Ex: new Fraction("1.'3'").toLatex() => "\frac{4}{3}"
   **/
  toLatex: function(e) {
    var r, o = "", n = this.n, i = this.d;
    return this.s < 0 && (o += "-"), i === 1 ? o += n : (e && (r = Math.floor(n / i)) > 0 && (o += r, n %= i), o += "\\frac{", o += n, o += "}{", o += i, o += "}"), o;
  },
  /**
   * Returns an array of continued fraction elements
   *
   * Ex: new Fraction("7/8").toContinued() => [0,1,7]
   */
  toContinued: function() {
    var e, r = this.n, o = this.d, n = [];
    if (isNaN(r) || isNaN(o))
      return n;
    do
      n.push(Math.floor(r / o)), e = r % o, r = o, o = e;
    while (r !== 1);
    return n;
  },
  /**
   * Creates a string representation of a fraction with all digits
   *
   * Ex: new Fraction("100.'91823'").toString() => "100.(91823)"
   **/
  toString: function(e) {
    var r = this.n, o = this.d;
    if (isNaN(r) || isNaN(o))
      return "NaN";
    e = e || 15;
    var n = Kw(r, o), i = Zw(r, o, n), t = this.s < 0 ? "-" : "";
    if (t += r / o | 0, r %= o, r *= 10, r && (t += "."), n) {
      for (var u = i; u--; )
        t += r / o | 0, r %= o, r *= 10;
      t += "(";
      for (var u = n; u--; )
        t += r / o | 0, r %= o, r *= 10;
      t += ")";
    } else
      for (var u = e; r && u--; )
        t += r / o | 0, r %= o, r *= 10;
    return t;
  }
};
var Yw = "Fraction", Xw = [], Jw = /* @__PURE__ */ Q(Yw, Xw, () => (Object.defineProperty(Ur, "name", {
  value: "Fraction"
}), Ur.prototype.constructor = Ur, Ur.prototype.type = "Fraction", Ur.prototype.isFraction = !0, Ur.prototype.toJSON = function() {
  return {
    mathjs: "Fraction",
    n: this.s * this.n,
    d: this.d
  };
}, Ur.fromJSON = function(e) {
  return new Ur(e);
}, Ur), {
  isClass: !0
}), Qw = "Range", ex = [], rx = /* @__PURE__ */ Q(Qw, ex, () => {
  function e(r, o, n) {
    if (!(this instanceof e))
      throw new SyntaxError("Constructor must be called with the new operator");
    var i = r != null, t = o != null, u = n != null;
    if (i) {
      if (Re(r))
        r = r.toNumber();
      else if (typeof r != "number")
        throw new TypeError("Parameter start must be a number");
    }
    if (t) {
      if (Re(o))
        o = o.toNumber();
      else if (typeof o != "number")
        throw new TypeError("Parameter end must be a number");
    }
    if (u) {
      if (Re(n))
        n = n.toNumber();
      else if (typeof n != "number")
        throw new TypeError("Parameter step must be a number");
    }
    this.start = i ? parseFloat(r) : 0, this.end = t ? parseFloat(o) : 0, this.step = u ? parseFloat(n) : 1;
  }
  return e.prototype.type = "Range", e.prototype.isRange = !0, e.parse = function(r) {
    if (typeof r != "string")
      return null;
    var o = r.split(":"), n = o.map(function(t) {
      return parseFloat(t);
    }), i = n.some(function(t) {
      return isNaN(t);
    });
    if (i)
      return null;
    switch (n.length) {
      case 2:
        return new e(n[0], n[1]);
      case 3:
        return new e(n[0], n[2], n[1]);
      default:
        return null;
    }
  }, e.prototype.clone = function() {
    return new e(this.start, this.end, this.step);
  }, e.prototype.size = function() {
    var r = 0, o = this.start, n = this.step, i = this.end, t = i - o;
    return rn(n) === rn(t) ? r = Math.ceil(t / n) : t === 0 && (r = 0), isNaN(r) && (r = 0), [r];
  }, e.prototype.min = function() {
    var r = this.size()[0];
    if (r > 0)
      return this.step > 0 ? this.start : this.start + (r - 1) * this.step;
  }, e.prototype.max = function() {
    var r = this.size()[0];
    if (r > 0)
      return this.step > 0 ? this.start + (r - 1) * this.step : this.start;
  }, e.prototype.forEach = function(r) {
    var o = this.start, n = this.step, i = this.end, t = 0;
    if (n > 0)
      for (; o < i; )
        r(o, [t], this), o += n, t++;
    else if (n < 0)
      for (; o > i; )
        r(o, [t], this), o += n, t++;
  }, e.prototype.map = function(r) {
    var o = [];
    return this.forEach(function(n, i, t) {
      o[i[0]] = r(n, i, t);
    }), o;
  }, e.prototype.toArray = function() {
    var r = [];
    return this.forEach(function(o, n) {
      r[n[0]] = o;
    }), r;
  }, e.prototype.valueOf = function() {
    return this.toArray();
  }, e.prototype.format = function(r) {
    var o = xn(this.start, r);
    return this.step !== 1 && (o += ":" + xn(this.step, r)), o += ":" + xn(this.end, r), o;
  }, e.prototype.toString = function() {
    return this.format();
  }, e.prototype.toJSON = function() {
    return {
      mathjs: "Range",
      start: this.start,
      end: this.end,
      step: this.step
    };
  }, e.fromJSON = function(r) {
    return new e(r.start, r.end, r.step);
  }, e;
}, {
  isClass: !0
}), tx = "Matrix", nx = [], ix = /* @__PURE__ */ Q(tx, nx, () => {
  function e() {
    if (!(this instanceof e))
      throw new SyntaxError("Constructor must be called with the new operator");
  }
  return e.prototype.type = "Matrix", e.prototype.isMatrix = !0, e.prototype.storage = function() {
    throw new Error("Cannot invoke storage on a Matrix interface");
  }, e.prototype.datatype = function() {
    throw new Error("Cannot invoke datatype on a Matrix interface");
  }, e.prototype.create = function(r, o) {
    throw new Error("Cannot invoke create on a Matrix interface");
  }, e.prototype.subset = function(r, o, n) {
    throw new Error("Cannot invoke subset on a Matrix interface");
  }, e.prototype.get = function(r) {
    throw new Error("Cannot invoke get on a Matrix interface");
  }, e.prototype.set = function(r, o, n) {
    throw new Error("Cannot invoke set on a Matrix interface");
  }, e.prototype.resize = function(r, o) {
    throw new Error("Cannot invoke resize on a Matrix interface");
  }, e.prototype.reshape = function(r, o) {
    throw new Error("Cannot invoke reshape on a Matrix interface");
  }, e.prototype.clone = function() {
    throw new Error("Cannot invoke clone on a Matrix interface");
  }, e.prototype.size = function() {
    throw new Error("Cannot invoke size on a Matrix interface");
  }, e.prototype.map = function(r, o) {
    throw new Error("Cannot invoke map on a Matrix interface");
  }, e.prototype.forEach = function(r) {
    throw new Error("Cannot invoke forEach on a Matrix interface");
  }, e.prototype[Symbol.iterator] = function() {
    throw new Error("Cannot iterate a Matrix interface");
  }, e.prototype.toArray = function() {
    throw new Error("Cannot invoke toArray on a Matrix interface");
  }, e.prototype.valueOf = function() {
    throw new Error("Cannot invoke valueOf on a Matrix interface");
  }, e.prototype.format = function(r) {
    throw new Error("Cannot invoke format on a Matrix interface");
  }, e.prototype.toString = function() {
    throw new Error("Cannot invoke toString on a Matrix interface");
  }, e;
}, {
  isClass: !0
});
function yo(e, r, o) {
  var n = e.constructor, i = new n(2), t = "";
  if (o) {
    if (o < 1)
      throw new Error("size must be in greater than 0");
    if (!Te(o))
      throw new Error("size must be an integer");
    if (e.greaterThan(i.pow(o - 1).sub(1)) || e.lessThan(i.pow(o - 1).mul(-1)))
      throw new Error("Value must be in range [-2^".concat(o - 1, ", 2^").concat(o - 1, "-1]"));
    if (!e.isInteger())
      throw new Error("Value must be an integer");
    e.lessThan(0) && (e = e.add(i.pow(o))), t = "i".concat(o);
  }
  switch (r) {
    case 2:
      return "".concat(e.toBinary()).concat(t);
    case 8:
      return "".concat(e.toOctal()).concat(t);
    case 16:
      return "".concat(e.toHexadecimal()).concat(t);
    default:
      throw new Error("Base ".concat(r, " not supported "));
  }
}
function ax(e, r) {
  if (typeof r == "function")
    return r(e);
  if (!e.isFinite())
    return e.isNaN() ? "NaN" : e.gt(0) ? "Infinity" : "-Infinity";
  var {
    notation: o,
    precision: n,
    wordSize: i
  } = v1(r);
  switch (o) {
    case "fixed":
      return sx(e, n);
    case "exponential":
      return $c(e, n);
    case "engineering":
      return ox(e, n);
    case "bin":
      return yo(e, 2, i);
    case "oct":
      return yo(e, 8, i);
    case "hex":
      return yo(e, 16, i);
    case "auto": {
      var t = zc(r == null ? void 0 : r.lowerExp, -3), u = zc(r == null ? void 0 : r.upperExp, 5);
      if (e.isZero())
        return "0";
      var l, f = e.toSignificantDigits(n), s = f.e;
      return s >= t && s < u ? l = f.toFixed() : l = $c(e, n), l.replace(/((\.\d*?)(0+))($|e)/, function() {
        var a = arguments[2], c = arguments[4];
        return a !== "." ? a + c : c;
      });
    }
    default:
      throw new Error('Unknown notation "' + o + '". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.');
  }
}
function ox(e, r) {
  var o = e.e, n = o % 3 === 0 ? o : o < 0 ? o - 3 - o % 3 : o - o % 3, i = e.mul(Math.pow(10, -n)), t = i.toPrecision(r);
  if (t.includes("e")) {
    var u = e.constructor;
    t = new u(t).toFixed();
  }
  return t + "e" + (o >= 0 ? "+" : "") + n.toString();
}
function $c(e, r) {
  return r !== void 0 ? e.toExponential(r - 1) : e.toExponential();
}
function sx(e, r) {
  return e.toFixed(r);
}
function zc(e, r) {
  return $e(e) ? e : Re(e) ? e.toNumber() : r;
}
function ux(e, r) {
  var o = e.length - r.length, n = e.length;
  return e.substring(o, n) === r;
}
function Ze(e, r) {
  var o = fx(e, r);
  return r && typeof r == "object" && "truncate" in r && o.length > r.truncate ? o.substring(0, r.truncate - 3) + "..." : o;
}
function fx(e, r) {
  if (typeof e == "number")
    return xn(e, r);
  if (Re(e))
    return ax(e, r);
  if (cx(e))
    return !r || r.fraction !== "decimal" ? e.s * e.n + "/" + e.d : e.toString();
  if (Array.isArray(e))
    return q1(e, r);
  if (qr(e))
    return qn(e);
  if (typeof e == "function")
    return e.syntax ? String(e.syntax) : "function";
  if (e && typeof e == "object") {
    if (typeof e.format == "function")
      return e.format(r);
    if (e && e.toString(r) !== {}.toString())
      return e.toString(r);
    var o = Object.keys(e).map((n) => qn(n) + ": " + Ze(e[n], r));
    return "{" + o.join(", ") + "}";
  }
  return String(e);
}
function qn(e) {
  for (var r = String(e), o = "", n = 0; n < r.length; ) {
    var i = r.charAt(n);
    o += i in Lc ? Lc[i] : i, n++;
  }
  return '"' + o + '"';
}
var Lc = {
  '"': '\\"',
  "\\": "\\\\",
  "\b": "\\b",
  "\f": "\\f",
  "\n": "\\n",
  "\r": "\\r",
  "	": "\\t"
};
function ct(e) {
  var r = String(e);
  return r = r.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), r;
}
function q1(e, r) {
  if (Array.isArray(e)) {
    for (var o = "[", n = e.length, i = 0; i < n; i++)
      i !== 0 && (o += ", "), o += q1(e[i], r);
    return o += "]", o;
  } else
    return Ze(e, r);
}
function cx(e) {
  return e && typeof e == "object" && typeof e.s == "number" && typeof e.n == "number" && typeof e.d == "number" || !1;
}
function Lu(e, r) {
  if (!qr(e))
    throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + fr(e) + ", index: 0)");
  if (!qr(r))
    throw new TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: " + fr(r) + ", index: 1)");
  return e === r ? 0 : e > r ? 1 : -1;
}
function We(e, r, o) {
  if (!(this instanceof We))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.actual = e, this.expected = r, this.relation = o, this.message = "Dimension mismatch (" + (Array.isArray(e) ? "[" + e.join(", ") + "]" : e) + " " + (this.relation || "!=") + " " + (Array.isArray(r) ? "[" + r.join(", ") + "]" : r) + ")", this.stack = new Error().stack;
}
We.prototype = new RangeError();
We.prototype.constructor = RangeError;
We.prototype.name = "DimensionError";
We.prototype.isDimensionError = !0;
function dt(e, r, o) {
  if (!(this instanceof dt))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.index = e, arguments.length < 3 ? (this.min = 0, this.max = r) : (this.min = r, this.max = o), this.min !== void 0 && this.index < this.min ? this.message = "Index out of range (" + this.index + " < " + this.min + ")" : this.max !== void 0 && this.index >= this.max ? this.message = "Index out of range (" + this.index + " > " + (this.max - 1) + ")" : this.message = "Index out of range (" + this.index + ")", this.stack = new Error().stack;
}
dt.prototype = new RangeError();
dt.prototype.constructor = RangeError;
dt.prototype.name = "IndexError";
dt.prototype.isIndexError = !0;
function ze(e) {
  for (var r = []; Array.isArray(e); )
    r.push(e.length), e = e[0];
  return r;
}
function $1(e, r, o) {
  var n, i = e.length;
  if (i !== r[o])
    throw new We(i, r[o]);
  if (o < r.length - 1) {
    var t = o + 1;
    for (n = 0; n < i; n++) {
      var u = e[n];
      if (!Array.isArray(u))
        throw new We(r.length - 1, r.length, "<");
      $1(e[n], r, t);
    }
  } else
    for (n = 0; n < i; n++)
      if (Array.isArray(e[n]))
        throw new We(r.length + 1, r.length, ">");
}
function Uc(e, r) {
  var o = r.length === 0;
  if (o) {
    if (Array.isArray(e))
      throw new We(e.length, 0);
  } else
    $1(e, r, 0);
}
function Da(e, r) {
  var o = e.isMatrix ? e._size : ze(e), n = r._sourceSize;
  n.forEach((i, t) => {
    if (i !== null && i !== o[t])
      throw new We(i, o[t]);
  });
}
function sr(e, r) {
  if (e !== void 0) {
    if (!$e(e) || !Te(e))
      throw new TypeError("Index must be an integer (value: " + e + ")");
    if (e < 0 || typeof r == "number" && e >= r)
      throw new dt(e, r);
  }
}
function Hn(e) {
  for (var r = 0; r < e._dimensions.length; ++r) {
    var o = e._dimensions[r];
    if (o._data && ar(o._data)) {
      if (o._size[0] === 0)
        return !0;
    } else if (o.isRange) {
      if (o.start === o.end)
        return !0;
    } else if (qr(o) && o.length === 0)
      return !0;
  }
  return !1;
}
function Gn(e, r, o) {
  if (!Array.isArray(r))
    throw new TypeError("Array expected");
  if (r.length === 0)
    throw new Error("Resizing to scalar is not supported");
  r.forEach(function(i) {
    if (!$e(i) || !Te(i) || i < 0)
      throw new TypeError("Invalid size, must contain positive integers (size: " + Ze(r) + ")");
  }), ($e(e) || Re(e)) && (e = [e]);
  var n = o !== void 0 ? o : 0;
  return Uu(e, r, 0, n), e;
}
function Uu(e, r, o, n) {
  var i, t, u = e.length, l = r[o], f = Math.min(u, l);
  if (e.length = l, o < r.length - 1) {
    var s = o + 1;
    for (i = 0; i < f; i++)
      t = e[i], Array.isArray(t) || (t = [t], e[i] = t), Uu(t, r, s, n);
    for (i = f; i < l; i++)
      t = [], e[i] = t, Uu(t, r, s, n);
  } else {
    for (i = 0; i < f; i++)
      for (; Array.isArray(e[i]); )
        e[i] = e[i][0];
    for (i = f; i < l; i++)
      e[i] = n;
  }
}
function Ff(e, r) {
  var o = ir(e), n = o.length;
  if (!Array.isArray(e) || !Array.isArray(r))
    throw new TypeError("Array expected");
  if (r.length === 0)
    throw new We(0, n, "!=");
  r = If(r, n);
  var i = z1(r);
  if (n !== i)
    throw new We(i, n, "!=");
  try {
    return lx(o, r);
  } catch (t) {
    throw t instanceof We ? new We(i, n, "!=") : t;
  }
}
function If(e, r) {
  var o = z1(e), n = e.slice(), i = -1, t = e.indexOf(i), u = e.indexOf(i, t + 1) >= 0;
  if (u)
    throw new Error("More than one wildcard in sizes");
  var l = t >= 0, f = r % o === 0;
  if (l)
    if (f)
      n[t] = -r / o;
    else
      throw new Error("Could not replace wildcard, since " + r + " is no multiple of " + -o);
  return n;
}
function z1(e) {
  return e.reduce((r, o) => r * o, 1);
}
function lx(e, r) {
  for (var o = e, n, i = r.length - 1; i > 0; i--) {
    var t = r[i];
    n = [];
    for (var u = o.length / t, l = 0; l < u; l++)
      n.push(o.slice(l * t, (l + 1) * t));
    o = n;
  }
  return o;
}
function Na(e, r) {
  for (var o = r || ze(e); Array.isArray(e) && e.length === 1; )
    e = e[0], o.shift();
  for (var n = o.length; o[n - 1] === 1; )
    n--;
  return n < o.length && (e = L1(e, n, 0), o.length = n), e;
}
function L1(e, r, o) {
  var n, i;
  if (o < r) {
    var t = o + 1;
    for (n = 0, i = e.length; n < i; n++)
      e[n] = L1(e[n], r, t);
  } else
    for (; Array.isArray(e); )
      e = e[0];
  return e;
}
function U1(e, r, o, n) {
  var i = n || ze(e);
  if (o)
    for (var t = 0; t < o; t++)
      e = [e], i.unshift(1);
  for (e = k1(e, r, 0); i.length < r; )
    i.push(1);
  return e;
}
function k1(e, r, o) {
  var n, i;
  if (Array.isArray(e)) {
    var t = o + 1;
    for (n = 0, i = e.length; n < i; n++)
      e[n] = k1(e[n], r, t);
  } else
    for (var u = o; u < r; u++)
      e = [e];
  return e;
}
function ir(e) {
  if (!Array.isArray(e))
    return e;
  var r = [];
  return e.forEach(function o(n) {
    Array.isArray(n) ? n.forEach(o) : r.push(n);
  }), r;
}
function Ht(e, r) {
  return Array.prototype.map.call(e, r);
}
function to(e, r) {
  Array.prototype.forEach.call(e, r);
}
function H1(e, r) {
  if (ze(e).length !== 1)
    throw new Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(e, r);
}
function Ma(e, r) {
  if (ze(e).length !== 1)
    throw new Error("Only one dimensional matrices supported");
  return Array.prototype.filter.call(e, (o) => r.test(o));
}
function kc(e, r) {
  return Array.prototype.join.call(e, r);
}
function Vn(e) {
  if (!Array.isArray(e))
    throw new TypeError("Array input expected");
  if (e.length === 0)
    return e;
  var r = [], o = 0;
  r[0] = {
    value: e[0],
    identifier: 0
  };
  for (var n = 1; n < e.length; n++)
    e[n] === e[n - 1] ? o++ : o = 0, r.push({
      value: e[n],
      identifier: o
    });
  return r;
}
function _a(e) {
  if (!Array.isArray(e))
    throw new TypeError("Array input expected");
  if (e.length === 0)
    return e;
  for (var r = [], o = 0; o < e.length; o++)
    r.push(e[o].value);
  return r;
}
function wi(e, r) {
  for (var o, n = 0, i = 0; i < e.length; i++) {
    var t = e[i], u = Array.isArray(t);
    if (i === 0 && u && (n = t.length), u && t.length !== n)
      return;
    var l = u ? wi(t, r) : r(t);
    if (o === void 0)
      o = l;
    else if (o !== l)
      return "mixed";
  }
  return o;
}
function G1(e, r, o, n) {
  if (n < o) {
    if (e.length !== r.length)
      throw new We(e.length, r.length);
    for (var i = [], t = 0; t < e.length; t++)
      i[t] = G1(e[t], r[t], o, n + 1);
    return i;
  } else
    return e.concat(r);
}
function V1() {
  var e = Array.prototype.slice.call(arguments, 0, -1), r = Array.prototype.slice.call(arguments, -1);
  if (e.length === 1)
    return e[0];
  if (e.length > 1)
    return e.slice(1).reduce(function(o, n) {
      return G1(o, n, r, 0);
    }, e[0]);
  throw new Error("Wrong number of arguments in function concat");
}
function W1() {
  for (var e = arguments.length, r = new Array(e), o = 0; o < e; o++)
    r[o] = arguments[o];
  for (var n = r.map((d) => d.length), i = Math.max(...n), t = new Array(i).fill(null), u = 0; u < r.length; u++)
    for (var l = r[u], f = n[u], s = 0; s < f; s++) {
      var a = i - f + s;
      l[s] > t[a] && (t[a] = l[s]);
    }
  for (var c = 0; c < r.length; c++)
    K1(r[c], t);
  return t;
}
function K1(e, r) {
  for (var o = r.length, n = e.length, i = 0; i < n; i++) {
    var t = o - n + i;
    if (e[i] < r[t] && e[i] > 1 || e[i] > r[t])
      throw new Error("shape missmatch: missmatch is found in arg with shape (".concat(e, ") not possible to broadcast dimension ").concat(n, " with size ").concat(e[i], " to size ").concat(r[t]));
  }
}
function ku(e, r) {
  var o = ze(e);
  if (Vt(o, r))
    return e;
  K1(o, r);
  var n = W1(o, r), i = n.length, t = [...Array(i - o.length).fill(1), ...o], u = hx(e);
  o.length < i && (u = Ff(u, t), o = ze(u));
  for (var l = 0; l < i; l++)
    o[l] < n[l] && (u = dx(u, n[l], l), o = ze(u));
  return u;
}
function dx(e, r, o) {
  return V1(...Array(r).fill(e), o);
}
function hx(e) {
  return kr([], e);
}
function px(e) {
  var r = 0, o = 1, n = /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null), t = 0, u = function(f) {
    var s = i[f];
    if (s && (delete n[s], delete i[f], --r, o === s)) {
      if (!r) {
        t = 0, o = 1;
        return;
      }
      for (; !Object.prototype.hasOwnProperty.call(n, ++o); )
        ;
    }
  };
  return e = Math.abs(e), {
    hit: function(f) {
      var s = i[f], a = ++t;
      if (n[a] = f, i[f] = a, !s)
        return ++r, r <= e ? void 0 : (f = n[o], u(f), f);
      if (delete n[s], o === s)
        for (; !Object.prototype.hasOwnProperty.call(n, ++o); )
          ;
    },
    delete: u,
    clear: function() {
      r = t = 0, o = 1, n = /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null);
    }
  };
}
function Bi(e) {
  var {
    hasher: r,
    limit: o
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return o = o ?? Number.POSITIVE_INFINITY, r = r ?? JSON.stringify, function n() {
    typeof n.cache != "object" && (n.cache = {
      values: /* @__PURE__ */ new Map(),
      lru: px(o || Number.POSITIVE_INFINITY)
    });
    for (var i = [], t = 0; t < arguments.length; t++)
      i[t] = arguments[t];
    var u = r(i);
    if (n.cache.values.has(u))
      return n.cache.lru.hit(u), n.cache.values.get(u);
    var l = e.apply(e, i);
    return n.cache.values.set(u, l), n.cache.values.delete(n.cache.lru.hit(u)), l;
  };
}
function Z1(e) {
  return Object.keys(e.signatures || {}).reduce(function(r, o) {
    var n = (o.match(/,/g) || []).length + 1;
    return Math.max(r, n);
  }, -1);
}
var vx = "DenseMatrix", mx = ["Matrix"], gx = /* @__PURE__ */ Q(vx, mx, (e) => {
  var {
    Matrix: r
  } = e;
  function o(a, c) {
    if (!(this instanceof o))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (c && !qr(c))
      throw new Error("Invalid datatype: " + c);
    if (Fe(a))
      a.type === "DenseMatrix" ? (this._data = Ie(a._data), this._size = Ie(a._size), this._datatype = c || a._datatype) : (this._data = a.toArray(), this._size = a.size(), this._datatype = c || a._datatype);
    else if (a && ar(a.data) && ar(a.size))
      this._data = a.data, this._size = a.size, Uc(this._data, this._size), this._datatype = c || a.datatype;
    else if (ar(a))
      this._data = s(a), this._size = ze(this._data), Uc(this._data, this._size), this._datatype = c;
    else {
      if (a)
        throw new TypeError("Unsupported type of data (" + fr(a) + ")");
      this._data = [], this._size = [0], this._datatype = c;
    }
  }
  o.prototype = new r(), o.prototype.createDenseMatrix = function(a, c) {
    return new o(a, c);
  }, Object.defineProperty(o, "name", {
    value: "DenseMatrix"
  }), o.prototype.constructor = o, o.prototype.type = "DenseMatrix", o.prototype.isDenseMatrix = !0, o.prototype.getDataType = function() {
    return wi(this._data, fr);
  }, o.prototype.storage = function() {
    return "dense";
  }, o.prototype.datatype = function() {
    return this._datatype;
  }, o.prototype.create = function(a, c) {
    return new o(a, c);
  }, o.prototype.subset = function(a, c, d) {
    switch (arguments.length) {
      case 1:
        return n(this, a);
      case 2:
      case 3:
        return t(this, a, c, d);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, o.prototype.get = function(a) {
    if (!ar(a))
      throw new TypeError("Array expected");
    if (a.length !== this._size.length)
      throw new We(a.length, this._size.length);
    for (var c = 0; c < a.length; c++)
      sr(a[c], this._size[c]);
    for (var d = this._data, h = 0, p = a.length; h < p; h++) {
      var v = a[h];
      sr(v, d.length), d = d[v];
    }
    return d;
  }, o.prototype.set = function(a, c, d) {
    if (!ar(a))
      throw new TypeError("Array expected");
    if (a.length < this._size.length)
      throw new We(a.length, this._size.length, "<");
    var h, p, v, g = a.map(function(x) {
      return x + 1;
    });
    f(this, g, d);
    var m = this._data;
    for (h = 0, p = a.length - 1; h < p; h++)
      v = a[h], sr(v, m.length), m = m[v];
    return v = a[a.length - 1], sr(v, m.length), m[v] = c, this;
  };
  function n(a, c) {
    if (!Ni(c))
      throw new TypeError("Invalid index");
    var d = c.isScalar();
    if (d)
      return a.get(c.min());
    var h = c.size();
    if (h.length !== a._size.length)
      throw new We(h.length, a._size.length);
    for (var p = c.min(), v = c.max(), g = 0, m = a._size.length; g < m; g++)
      sr(p[g], a._size[g]), sr(v[g], a._size[g]);
    return new o(i(a._data, c, h.length, 0), a._datatype);
  }
  function i(a, c, d, h) {
    var p = h === d - 1, v = c.dimension(h);
    return p ? v.map(function(g) {
      return sr(g, a.length), a[g];
    }).valueOf() : v.map(function(g) {
      sr(g, a.length);
      var m = a[g];
      return i(m, c, d, h + 1);
    }).valueOf();
  }
  function t(a, c, d, h) {
    if (!c || c.isIndex !== !0)
      throw new TypeError("Invalid index");
    var p = c.size(), v = c.isScalar(), g;
    if (Fe(d) ? (g = d.size(), d = d.valueOf()) : g = ze(d), v) {
      if (g.length !== 0)
        throw new TypeError("Scalar expected");
      a.set(c.min(), d, h);
    } else {
      if (!Vt(g, p))
        try {
          g.length === 0 ? d = ku([d], p) : d = ku(d, p), g = ze(d);
        } catch {
        }
      if (p.length < a._size.length)
        throw new We(p.length, a._size.length, "<");
      if (g.length < p.length) {
        for (var m = 0, x = 0; p[m] === 1 && g[m] === 1; )
          m++;
        for (; p[m] === 1; )
          x++, m++;
        d = U1(d, p.length, x, g);
      }
      if (!Vt(p, g))
        throw new We(p, g, ">");
      var y = c.max().map(function(S) {
        return S + 1;
      });
      f(a, y, h);
      var E = p.length, N = 0;
      u(a._data, c, d, E, N);
    }
    return a;
  }
  function u(a, c, d, h, p) {
    var v = p === h - 1, g = c.dimension(p);
    v ? g.forEach(function(m, x) {
      sr(m), a[m] = d[x[0]];
    }) : g.forEach(function(m, x) {
      sr(m), u(a[m], c, d[x[0]], h, p + 1);
    });
  }
  o.prototype.resize = function(a, c, d) {
    if (!nt(a))
      throw new TypeError("Array or Matrix expected");
    var h = a.valueOf().map((v) => Array.isArray(v) && v.length === 1 ? v[0] : v), p = d ? this.clone() : this;
    return l(p, h, c);
  };
  function l(a, c, d) {
    if (c.length === 0) {
      for (var h = a._data; ar(h); )
        h = h[0];
      return h;
    }
    return a._size = c.slice(0), a._data = Gn(a._data, a._size, d), a;
  }
  o.prototype.reshape = function(a, c) {
    var d = c ? this.clone() : this;
    d._data = Ff(d._data, a);
    var h = d._size.reduce((p, v) => p * v);
    return d._size = If(a, h), d;
  };
  function f(a, c, d) {
    for (var h = a._size.slice(0), p = !1; h.length < c.length; )
      h.push(0), p = !0;
    for (var v = 0, g = c.length; v < g; v++)
      c[v] > h[v] && (h[v] = c[v], p = !0);
    p && l(a, h, d);
  }
  o.prototype.clone = function() {
    var a = new o({
      data: Ie(this._data),
      size: Ie(this._size),
      datatype: this._datatype
    });
    return a;
  }, o.prototype.size = function() {
    return this._size.slice(0);
  }, o.prototype.map = function(a) {
    var c = this, d = Z1(a), h = function g(m, x) {
      return ar(m) ? m.map(function(y, E) {
        return g(y, x.concat(E));
      }) : d === 1 ? a(m) : d === 2 ? a(m, x) : a(m, x, c);
    }, p = h(this._data, []), v = this._datatype !== void 0 ? wi(p, fr) : void 0;
    return new o(p, v);
  }, o.prototype.forEach = function(a) {
    var c = this, d = function h(p, v) {
      ar(p) ? p.forEach(function(g, m) {
        h(g, v.concat(m));
      }) : a(p, v, c);
    };
    d(this._data, []);
  }, o.prototype[Symbol.iterator] = function* () {
    var a = function* c(d, h) {
      if (ar(d))
        for (var p = 0; p < d.length; p++)
          yield* c(d[p], h.concat(p));
      else
        yield {
          value: d,
          index: h
        };
    };
    yield* a(this._data, []);
  }, o.prototype.rows = function() {
    var a = [], c = this.size();
    if (c.length !== 2)
      throw new TypeError("Rows can only be returned for a 2D matrix.");
    var d = this._data;
    for (var h of d)
      a.push(new o([h], this._datatype));
    return a;
  }, o.prototype.columns = function() {
    var a = this, c = [], d = this.size();
    if (d.length !== 2)
      throw new TypeError("Rows can only be returned for a 2D matrix.");
    for (var h = this._data, p = function(m) {
      var x = h.map((y) => [y[m]]);
      c.push(new o(x, a._datatype));
    }, v = 0; v < d[1]; v++)
      p(v);
    return c;
  }, o.prototype.toArray = function() {
    return Ie(this._data);
  }, o.prototype.valueOf = function() {
    return this._data;
  }, o.prototype.format = function(a) {
    return Ze(this._data, a);
  }, o.prototype.toString = function() {
    return Ze(this._data);
  }, o.prototype.toJSON = function() {
    return {
      mathjs: "DenseMatrix",
      data: this._data,
      size: this._size,
      datatype: this._datatype
    };
  }, o.prototype.diagonal = function(a) {
    if (a) {
      if (Re(a) && (a = a.toNumber()), !$e(a) || !Te(a))
        throw new TypeError("The parameter k must be an integer number");
    } else
      a = 0;
    for (var c = a > 0 ? a : 0, d = a < 0 ? -a : 0, h = this._size[0], p = this._size[1], v = Math.min(h - d, p - c), g = [], m = 0; m < v; m++)
      g[m] = this._data[m + d][m + c];
    return new o({
      data: g,
      size: [v],
      datatype: this._datatype
    });
  }, o.diagonal = function(a, c, d, h) {
    if (!ar(a))
      throw new TypeError("Array expected, size parameter");
    if (a.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (a = a.map(function(R) {
      if (Re(R) && (R = R.toNumber()), !$e(R) || !Te(R) || R < 1)
        throw new Error("Size values must be positive integers");
      return R;
    }), d) {
      if (Re(d) && (d = d.toNumber()), !$e(d) || !Te(d))
        throw new TypeError("The parameter k must be an integer number");
    } else
      d = 0;
    var p = d > 0 ? d : 0, v = d < 0 ? -d : 0, g = a[0], m = a[1], x = Math.min(g - v, m - p), y;
    if (ar(c)) {
      if (c.length !== x)
        throw new Error("Invalid value array length");
      y = function(O) {
        return c[O];
      };
    } else if (Fe(c)) {
      var E = c.size();
      if (E.length !== 1 || E[0] !== x)
        throw new Error("Invalid matrix length");
      y = function(O) {
        return c.get([O]);
      };
    } else
      y = function() {
        return c;
      };
    h || (h = Re(y(0)) ? y(0).mul(0) : 0);
    var N = [];
    if (a.length > 0) {
      N = Gn(N, a, h);
      for (var S = 0; S < x; S++)
        N[S + v][S + p] = y(S);
    }
    return new o({
      data: N,
      size: [g, m]
    });
  }, o.fromJSON = function(a) {
    return new o(a);
  }, o.prototype.swapRows = function(a, c) {
    if (!$e(a) || !Te(a) || !$e(c) || !Te(c))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return sr(a, this._size[0]), sr(c, this._size[0]), o._swapRows(a, c, this._data), this;
  }, o._swapRows = function(a, c, d) {
    var h = d[a];
    d[a] = d[c], d[c] = h;
  };
  function s(a) {
    return Fe(a) ? s(a.valueOf()) : ar(a) ? a.map(s) : a;
  }
  return o;
}, {
  isClass: !0
}), Hc = "clone", bx = ["typed"], yx = /* @__PURE__ */ Q(Hc, bx, (e) => {
  var {
    typed: r
  } = e;
  return r(Hc, {
    any: Ie
  });
});
function j1(e) {
  var r = e.length, o = e[0].length, n, i, t = [];
  for (i = 0; i < o; i++) {
    var u = [];
    for (n = 0; n < r; n++)
      u.push(e[n][i]);
    t.push(u);
  }
  return t;
}
function Xn(e) {
  for (var r = 0; r < e.length; r++)
    if (nt(e[r]))
      return !0;
  return !1;
}
function Wt(e, r) {
  Fe(e) && (e = e.valueOf());
  for (var o = 0, n = e.length; o < n; o++) {
    var i = e[o];
    Array.isArray(i) ? Wt(i, r) : r(i);
  }
}
function Ke(e, r, o) {
  return e && typeof e.map == "function" ? e.map(function(n) {
    return Ke(n, r);
  }) : r(e);
}
function no(e, r, o) {
  var n = Array.isArray(e) ? ze(e) : e.size();
  if (r < 0 || r >= n.length)
    throw new dt(r, n.length);
  return Fe(e) ? e.create(Ca(e.valueOf(), r, o)) : Ca(e, r, o);
}
function Ca(e, r, o) {
  var n, i, t, u;
  if (r <= 0)
    if (Array.isArray(e[0])) {
      for (u = j1(e), i = [], n = 0; n < u.length; n++)
        i[n] = Ca(u[n], r - 1, o);
      return i;
    } else {
      for (t = e[0], n = 1; n < e.length; n++)
        t = o(t, e[n]);
      return t;
    }
  else {
    for (i = [], n = 0; n < e.length; n++)
      i[n] = Ca(e[n], r - 1, o);
    return i;
  }
}
function Gc(e, r, o, n, i, t, u, l, f, s, a) {
  var c = e._values, d = e._index, h = e._ptr, p, v, g, m;
  if (n)
    for (v = h[r], g = h[r + 1], p = v; p < g; p++)
      m = d[p], o[m] !== t ? (o[m] = t, u.push(m), s ? (n[m] = f ? l(c[p], a) : l(a, c[p]), i[m] = t) : n[m] = c[p]) : (n[m] = f ? l(c[p], n[m]) : l(n[m], c[p]), i[m] = t);
  else
    for (v = h[r], g = h[r + 1], p = v; p < g; p++)
      m = d[p], o[m] !== t ? (o[m] = t, u.push(m)) : i[m] = t;
}
var Vc = "isInteger", wx = ["typed"], xx = /* @__PURE__ */ Q(Vc, wx, (e) => {
  var {
    typed: r
  } = e;
  return r(Vc, {
    number: Te,
    // TODO: what to do with isInteger(add(0.1, 0.2))  ?
    BigNumber: function(n) {
      return n.isInt();
    },
    bigint: function(n) {
      return !0;
    },
    Fraction: function(n) {
      return n.d === 1 && isFinite(n.n);
    },
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o))
  });
}), xt = "number", Jn = "number, number";
function Y1(e) {
  return Math.abs(e);
}
Y1.signature = xt;
function X1(e, r) {
  return e + r;
}
X1.signature = Jn;
function J1(e, r) {
  return e - r;
}
J1.signature = Jn;
function Q1(e, r) {
  return e * r;
}
Q1.signature = Jn;
function eg(e) {
  return -e;
}
eg.signature = xt;
function rg(e) {
  return e;
}
rg.signature = xt;
function li(e) {
  return y2(e);
}
li.signature = xt;
function tg(e) {
  return e * e * e;
}
tg.signature = xt;
function ng(e) {
  return Math.exp(e);
}
ng.signature = xt;
function ig(e) {
  return w2(e);
}
ig.signature = xt;
function ag(e, r) {
  if (!Te(e) || !Te(r))
    throw new Error("Parameters in function lcm must be integer numbers");
  if (e === 0 || r === 0)
    return 0;
  for (var o, n = e * r; r !== 0; )
    o = r, r = e % o, e = o;
  return Math.abs(n / e);
}
ag.signature = Jn;
function Ex(e, r) {
  return r ? Math.log(e) / Math.log(r) : Math.log(e);
}
function og(e) {
  return g2(e);
}
og.signature = xt;
function sg(e) {
  return m2(e);
}
sg.signature = xt;
function Wc(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, o = r < 0;
  if (o && (r = -r), r === 0)
    throw new Error("Root must be non-zero");
  if (e < 0 && Math.abs(r) % 2 !== 1)
    throw new Error("Root must be odd when a is negative.");
  if (e === 0)
    return o ? 1 / 0 : 0;
  if (!isFinite(e))
    return o ? 0 : e;
  var n = Math.pow(Math.abs(e), 1 / r);
  return n = e < 0 ? -n : n, o ? 1 / n : n;
}
function Hu(e) {
  return rn(e);
}
Hu.signature = xt;
function ug(e) {
  return e * e;
}
ug.signature = xt;
function fg(e, r) {
  var o, n, i, t = 0, u = 1, l = 1, f = 0;
  if (!Te(e) || !Te(r))
    throw new Error("Parameters in function xgcd must be integer numbers");
  for (; r; )
    n = Math.floor(e / r), i = e - n * r, o = t, t = u - n * t, u = o, o = l, l = f - n * l, f = o, e = r, r = i;
  var s;
  return e < 0 ? s = [-e, -u, -f] : s = [e, e ? u : 0, f], s;
}
fg.signature = Jn;
function cg(e, r) {
  return e * e < 1 && r === 1 / 0 || e * e > 1 && r === -1 / 0 ? 0 : Math.pow(e, r);
}
cg.signature = Jn;
function si(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!Te(r) || r < 0 || r > 15)
    throw new Error("Number of decimals in function round must be an integer from 0 to 15 inclusive");
  return parseFloat(m1(e, r));
}
var Ax = "number", Qn = "number, number";
function lg(e, r) {
  if (!Te(e) || !Te(r))
    throw new Error("Integers expected in function bitAnd");
  return e & r;
}
lg.signature = Qn;
function dg(e) {
  if (!Te(e))
    throw new Error("Integer expected in function bitNot");
  return ~e;
}
dg.signature = Ax;
function hg(e, r) {
  if (!Te(e) || !Te(r))
    throw new Error("Integers expected in function bitOr");
  return e | r;
}
hg.signature = Qn;
function pg(e, r) {
  if (!Te(e) || !Te(r))
    throw new Error("Integers expected in function bitXor");
  return e ^ r;
}
pg.signature = Qn;
function vg(e, r) {
  if (!Te(e) || !Te(r))
    throw new Error("Integers expected in function leftShift");
  return e << r;
}
vg.signature = Qn;
function mg(e, r) {
  if (!Te(e) || !Te(r))
    throw new Error("Integers expected in function rightArithShift");
  return e >> r;
}
mg.signature = Qn;
function gg(e, r) {
  if (!Te(e) || !Te(r))
    throw new Error("Integers expected in function rightLogShift");
  return e >>> r;
}
gg.signature = Qn;
function kt(e, r) {
  if (r < e)
    return 1;
  if (r === e)
    return r;
  var o = r + e >> 1;
  return kt(e, o) * kt(o + 1, r);
}
function bg(e, r) {
  if (!Te(e) || e < 0)
    throw new TypeError("Positive integer value expected in function combinations");
  if (!Te(r) || r < 0)
    throw new TypeError("Positive integer value expected in function combinations");
  if (r > e)
    throw new TypeError("k must be less than or equal to n");
  for (var o = e - r, n = 1, i = r < o ? o + 1 : r + 1, t = 2, u = r < o ? r : o, l = i; l <= e; ++l)
    for (n *= l; t <= u && n % t === 0; )
      n /= t, ++t;
  return t <= u && (n /= kt(t, u)), n;
}
bg.signature = "number, number";
var Sx = Math.PI, Dx = 2 * Math.PI, Nx = Math.E, Mx = 1.618033988749895, _x = "number", Of = "number, number";
function yg(e) {
  return !e;
}
yg.signature = _x;
function Gu(e, r) {
  return !!(e || r);
}
Gu.signature = Of;
function Vu(e, r) {
  return !!e != !!r;
}
Vu.signature = Of;
function Wu(e, r) {
  return !!(e && r);
}
Wu.signature = Of;
function Ta(e) {
  var r;
  if (Te(e))
    return e <= 0 ? isFinite(e) ? 1 / 0 : NaN : e > 171 ? 1 / 0 : kt(1, e - 1);
  if (e < 0.5)
    return Math.PI / (Math.sin(Math.PI * e) * Ta(1 - e));
  if (e >= 171.35)
    return 1 / 0;
  if (e > 85) {
    var o = e * e, n = o * e, i = n * e, t = i * e;
    return Math.sqrt(2 * Math.PI / e) * Math.pow(e / Math.E, e) * (1 + 1 / (12 * e) + 1 / (288 * o) - 139 / (51840 * n) - 571 / (2488320 * i) + 163879 / (209018880 * t) + 5246819 / (75246796800 * t * e));
  }
  --e, r = Ln[0];
  for (var u = 1; u < Ln.length; ++u)
    r += Ln[u] / (e + u);
  var l = e + wg + 0.5;
  return Math.sqrt(2 * Math.PI) * Math.pow(l, e + 0.5) * Math.exp(-l) * r;
}
Ta.signature = "number";
var wg = 4.7421875, Ln = [0.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -0.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, 1580887032249125e-19, -21026444172410488e-20, 21743961811521265e-20, -1643181065367639e-19, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22], xg = 0.9189385332046728, Cx = 5, Tx = 7, Kc = [1.000000000190015, 76.18009172947146, -86.50532032941678, 24.01409824083091, -1.231739572450155, 0.001208650973866179, -5395239384953e-18];
function Ba(e) {
  if (e < 0)
    return NaN;
  if (e === 0)
    return 1 / 0;
  if (!isFinite(e))
    return e;
  if (e < 0.5)
    return Math.log(Math.PI / Math.sin(Math.PI * e)) - Ba(1 - e);
  e = e - 1;
  for (var r = e + Cx + 0.5, o = Kc[0], n = Tx - 1; n >= 1; n--)
    o += Kc[n] / (e + n);
  return xg + (e + 0.5) * Math.log(r) - r + Math.log(o);
}
Ba.signature = "number";
var Gr = "number";
function Eg(e) {
  return S2(e);
}
Eg.signature = Gr;
function Ag(e) {
  return Math.atan(1 / e);
}
Ag.signature = Gr;
function Sg(e) {
  return isFinite(e) ? (Math.log((e + 1) / e) + Math.log(e / (e - 1))) / 2 : 0;
}
Sg.signature = Gr;
function Dg(e) {
  return Math.asin(1 / e);
}
Dg.signature = Gr;
function Ng(e) {
  var r = 1 / e;
  return Math.log(r + Math.sqrt(r * r + 1));
}
Ng.signature = Gr;
function Mg(e) {
  return Math.acos(1 / e);
}
Mg.signature = Gr;
function _g(e) {
  var r = 1 / e, o = Math.sqrt(r * r - 1);
  return Math.log(o + r);
}
_g.signature = Gr;
function Cg(e) {
  return D2(e);
}
Cg.signature = Gr;
function Tg(e) {
  return N2(e);
}
Tg.signature = Gr;
function Bg(e) {
  return 1 / Math.tan(e);
}
Bg.signature = Gr;
function Fg(e) {
  var r = Math.exp(2 * e);
  return (r + 1) / (r - 1);
}
Fg.signature = Gr;
function Ig(e) {
  return 1 / Math.sin(e);
}
Ig.signature = Gr;
function Og(e) {
  return e === 0 ? Number.POSITIVE_INFINITY : Math.abs(2 / (Math.exp(e) - Math.exp(-e))) * rn(e);
}
Og.signature = Gr;
function Rg(e) {
  return 1 / Math.cos(e);
}
Rg.signature = Gr;
function Pg(e) {
  return 2 / (Math.exp(e) + Math.exp(-e));
}
Pg.signature = Gr;
function qg(e) {
  return _2(e);
}
qg.signature = Gr;
var Rf = "number";
function $g(e) {
  return e < 0;
}
$g.signature = Rf;
function zg(e) {
  return e > 0;
}
zg.signature = Rf;
function Lg(e) {
  return Number.isNaN(e);
}
Lg.signature = Rf;
function Xr(e, r) {
  var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-9, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (o <= 0)
    throw new Error("Relative tolerance must be greater than 0");
  if (n < 0)
    throw new Error("Absolute tolerance must be at least 0");
  return e.isNaN() || r.isNaN() ? !1 : !e.isFinite() || !r.isFinite() ? e.eq(r) : e.eq(r) ? !0 : e.minus(r).abs().lte(e.constructor.max(e.constructor.max(e.abs(), r.abs()).mul(o), n));
}
var Zc = "isNegative", Bx = ["typed", "config"], Fx = /* @__PURE__ */ Q(Zc, Bx, (e) => {
  var {
    typed: r,
    config: o
  } = e;
  return r(Zc, {
    number: (n) => zr(n, 0, o.relTol, o.absTol) ? !1 : $g(n),
    BigNumber: (n) => Xr(n, new n.constructor(0), o.relTol, o.absTol) ? !1 : n.isNeg() && !n.isZero() && !n.isNaN(),
    bigint: (n) => n < 0n,
    Fraction: (n) => n.s < 0,
    // It's enough to decide on the sign
    Unit: r.referToSelf((n) => (i) => r.find(n, i.valueType())(i.value)),
    "Array | Matrix": r.referToSelf((n) => (i) => Ke(i, n))
  });
}), jc = "isNumeric", Ix = ["typed"], Ox = /* @__PURE__ */ Q(jc, Ix, (e) => {
  var {
    typed: r
  } = e;
  return r(jc, {
    "number | BigNumber | bigint | Fraction | boolean": () => !0,
    "Complex | Unit | string | null | undefined | Node": () => !1,
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o))
  });
}), Yc = "hasNumericValue", Rx = ["typed", "isNumeric"], Px = /* @__PURE__ */ Q(Yc, Rx, (e) => {
  var {
    typed: r,
    isNumeric: o
  } = e;
  return r(Yc, {
    boolean: () => !0,
    string: function(i) {
      return i.trim().length > 0 && !isNaN(Number(i));
    },
    any: function(i) {
      return o(i);
    }
  });
}), Xc = "isPositive", qx = ["typed", "config"], $x = /* @__PURE__ */ Q(Xc, qx, (e) => {
  var {
    typed: r,
    config: o
  } = e;
  return r(Xc, {
    number: (n) => zr(n, 0, o.relTol, o.absTol) ? !1 : zg(n),
    BigNumber: (n) => Xr(n, new n.constructor(0), o.relTol, o.absTol) ? !1 : !n.isNeg() && !n.isZero() && !n.isNaN(),
    bigint: (n) => n > 0n,
    Fraction: (n) => n.s > 0 && n.n > 0,
    Unit: r.referToSelf((n) => (i) => r.find(n, i.valueType())(i.value)),
    "Array | Matrix": r.referToSelf((n) => (i) => Ke(i, n))
  });
}), Jc = "isZero", zx = ["typed", "equalScalar"], Lx = /* @__PURE__ */ Q(Jc, zx, (e) => {
  var {
    typed: r,
    equalScalar: o
  } = e;
  return r(Jc, {
    "number | BigNumber | Complex | Fraction": (n) => o(n, 0),
    bigint: (n) => n === 0n,
    Unit: r.referToSelf((n) => (i) => r.find(n, i.valueType())(i.value)),
    "Array | Matrix": r.referToSelf((n) => (i) => Ke(i, n))
  });
}), Qc = "isNaN", Ux = ["typed"], kx = /* @__PURE__ */ Q(Qc, Ux, (e) => {
  var {
    typed: r
  } = e;
  return r(Qc, {
    number: Lg,
    BigNumber: function(n) {
      return n.isNaN();
    },
    bigint: function(n) {
      return !1;
    },
    Fraction: function(n) {
      return !1;
    },
    Complex: function(n) {
      return n.isNaN();
    },
    Unit: function(n) {
      return Number.isNaN(n.value);
    },
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o))
  });
}), el = "typeOf", Hx = ["typed"], Gx = /* @__PURE__ */ Q(el, Hx, (e) => {
  var {
    typed: r
  } = e;
  return r(el, {
    any: fr
  });
});
function Vx(e, r, o, n) {
  return zr(e.re, r.re, o, n) && zr(e.im, r.im, o, n);
}
var ei = /* @__PURE__ */ Q("compareUnits", ["typed"], (e) => {
  var {
    typed: r
  } = e;
  return {
    "Unit, Unit": r.referToSelf((o) => (n, i) => {
      if (!n.equalBase(i))
        throw new Error("Cannot compare units with different base");
      return r.find(o, [n.valueType(), i.valueType()])(n.value, i.value);
    })
  };
}), Fa = "equalScalar", Wx = ["typed", "config"], Kx = /* @__PURE__ */ Q(Fa, Wx, (e) => {
  var {
    typed: r,
    config: o
  } = e, n = ei({
    typed: r
  });
  return r(Fa, {
    "boolean, boolean": function(t, u) {
      return t === u;
    },
    "number, number": function(t, u) {
      return zr(t, u, o.relTol, o.absTol);
    },
    "BigNumber, BigNumber": function(t, u) {
      return t.eq(u) || Xr(t, u, o.relTol, o.absTol);
    },
    "bigint, bigint": function(t, u) {
      return t === u;
    },
    "Fraction, Fraction": function(t, u) {
      return t.equals(u);
    },
    "Complex, Complex": function(t, u) {
      return Vx(t, u, o.relTol, o.absTol);
    }
  }, n);
});
Q(Fa, ["typed", "config"], (e) => {
  var {
    typed: r,
    config: o
  } = e;
  return r(Fa, {
    "number, number": function(i, t) {
      return zr(i, t, o.relTol, o.absTol);
    }
  });
});
var Zx = "SparseMatrix", jx = ["typed", "equalScalar", "Matrix"], Yx = /* @__PURE__ */ Q(Zx, jx, (e) => {
  var {
    typed: r,
    equalScalar: o,
    Matrix: n
  } = e;
  function i(v, g) {
    if (!(this instanceof i))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (g && !qr(g))
      throw new Error("Invalid datatype: " + g);
    if (Fe(v))
      t(this, v, g);
    else if (v && ar(v.index) && ar(v.ptr) && ar(v.size))
      this._values = v.values, this._index = v.index, this._ptr = v.ptr, this._size = v.size, this._datatype = g || v.datatype;
    else if (ar(v))
      u(this, v, g);
    else {
      if (v)
        throw new TypeError("Unsupported type of data (" + fr(v) + ")");
      this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = g;
    }
  }
  function t(v, g, m) {
    g.type === "SparseMatrix" ? (v._values = g._values ? Ie(g._values) : void 0, v._index = Ie(g._index), v._ptr = Ie(g._ptr), v._size = Ie(g._size), v._datatype = m || g._datatype) : u(v, g.valueOf(), m || g._datatype);
  }
  function u(v, g, m) {
    v._values = [], v._index = [], v._ptr = [], v._datatype = m;
    var x = g.length, y = 0, E = o, N = 0;
    if (qr(m) && (E = r.find(o, [m, m]) || o, N = r.convert(0, m)), x > 0) {
      var S = 0;
      do {
        v._ptr.push(v._index.length);
        for (var R = 0; R < x; R++) {
          var O = g[R];
          if (ar(O)) {
            if (S === 0 && y < O.length && (y = O.length), S < O.length) {
              var B = O[S];
              E(B, N) || (v._values.push(B), v._index.push(R));
            }
          } else
            S === 0 && y < 1 && (y = 1), E(O, N) || (v._values.push(O), v._index.push(R));
        }
        S++;
      } while (S < y);
    }
    v._ptr.push(v._index.length), v._size = [x, y];
  }
  i.prototype = new n(), i.prototype.createSparseMatrix = function(v, g) {
    return new i(v, g);
  }, Object.defineProperty(i, "name", {
    value: "SparseMatrix"
  }), i.prototype.constructor = i, i.prototype.type = "SparseMatrix", i.prototype.isSparseMatrix = !0, i.prototype.getDataType = function() {
    return wi(this._values, fr);
  }, i.prototype.storage = function() {
    return "sparse";
  }, i.prototype.datatype = function() {
    return this._datatype;
  }, i.prototype.create = function(v, g) {
    return new i(v, g);
  }, i.prototype.density = function() {
    var v = this._size[0], g = this._size[1];
    return v !== 0 && g !== 0 ? this._index.length / (v * g) : 0;
  }, i.prototype.subset = function(v, g, m) {
    if (!this._values)
      throw new Error("Cannot invoke subset on a Pattern only matrix");
    switch (arguments.length) {
      case 1:
        return l(this, v);
      case 2:
      case 3:
        return f(this, v, g, m);
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  };
  function l(v, g) {
    if (!Ni(g))
      throw new TypeError("Invalid index");
    var m = g.isScalar();
    if (m)
      return v.get(g.min());
    var x = g.size();
    if (x.length !== v._size.length)
      throw new We(x.length, v._size.length);
    var y, E, N, S, R = g.min(), O = g.max();
    for (y = 0, E = v._size.length; y < E; y++)
      sr(R[y], v._size[y]), sr(O[y], v._size[y]);
    var B = v._values, $ = v._index, F = v._ptr, w = g.dimension(0), A = g.dimension(1), b = [], D = [];
    w.forEach(function(C, T) {
      D[C] = T[0], b[C] = !0;
    });
    var M = B ? [] : void 0, _ = [], q = [];
    return A.forEach(function(C) {
      for (q.push(_.length), N = F[C], S = F[C + 1]; N < S; N++)
        y = $[N], b[y] === !0 && (_.push(D[y]), M && M.push(B[N]));
    }), q.push(_.length), new i({
      values: M,
      index: _,
      ptr: q,
      size: x,
      datatype: v._datatype
    });
  }
  function f(v, g, m, x) {
    if (!g || g.isIndex !== !0)
      throw new TypeError("Invalid index");
    var y = g.size(), E = g.isScalar(), N;
    if (Fe(m) ? (N = m.size(), m = m.toArray()) : N = ze(m), E) {
      if (N.length !== 0)
        throw new TypeError("Scalar expected");
      v.set(g.min(), m, x);
    } else {
      if (y.length !== 1 && y.length !== 2)
        throw new We(y.length, v._size.length, "<");
      if (N.length < y.length) {
        for (var S = 0, R = 0; y[S] === 1 && N[S] === 1; )
          S++;
        for (; y[S] === 1; )
          R++, S++;
        m = U1(m, y.length, R, N);
      }
      if (!Vt(y, N))
        throw new We(y, N, ">");
      if (y.length === 1) {
        var O = g.dimension(0);
        O.forEach(function(F, w) {
          sr(F), v.set([F, 0], m[w[0]], x);
        });
      } else {
        var B = g.dimension(0), $ = g.dimension(1);
        B.forEach(function(F, w) {
          sr(F), $.forEach(function(A, b) {
            sr(A), v.set([F, A], m[w[0]][b[0]], x);
          });
        });
      }
    }
    return v;
  }
  i.prototype.get = function(v) {
    if (!ar(v))
      throw new TypeError("Array expected");
    if (v.length !== this._size.length)
      throw new We(v.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke get on a Pattern only matrix");
    var g = v[0], m = v[1];
    sr(g, this._size[0]), sr(m, this._size[1]);
    var x = s(g, this._ptr[m], this._ptr[m + 1], this._index);
    return x < this._ptr[m + 1] && this._index[x] === g ? this._values[x] : 0;
  }, i.prototype.set = function(v, g, m) {
    if (!ar(v))
      throw new TypeError("Array expected");
    if (v.length !== this._size.length)
      throw new We(v.length, this._size.length);
    if (!this._values)
      throw new Error("Cannot invoke set on a Pattern only matrix");
    var x = v[0], y = v[1], E = this._size[0], N = this._size[1], S = o, R = 0;
    qr(this._datatype) && (S = r.find(o, [this._datatype, this._datatype]) || o, R = r.convert(0, this._datatype)), (x > E - 1 || y > N - 1) && (d(this, Math.max(x + 1, E), Math.max(y + 1, N), m), E = this._size[0], N = this._size[1]), sr(x, E), sr(y, N);
    var O = s(x, this._ptr[y], this._ptr[y + 1], this._index);
    return O < this._ptr[y + 1] && this._index[O] === x ? S(g, R) ? a(O, y, this._values, this._index, this._ptr) : this._values[O] = g : S(g, R) || c(O, x, y, g, this._values, this._index, this._ptr), this;
  };
  function s(v, g, m, x) {
    if (m - g === 0)
      return m;
    for (var y = g; y < m; y++)
      if (x[y] === v)
        return y;
    return g;
  }
  function a(v, g, m, x, y) {
    m.splice(v, 1), x.splice(v, 1);
    for (var E = g + 1; E < y.length; E++)
      y[E]--;
  }
  function c(v, g, m, x, y, E, N) {
    y.splice(v, 0, x), E.splice(v, 0, g);
    for (var S = m + 1; S < N.length; S++)
      N[S]++;
  }
  i.prototype.resize = function(v, g, m) {
    if (!nt(v))
      throw new TypeError("Array or Matrix expected");
    var x = v.valueOf().map((E) => Array.isArray(E) && E.length === 1 ? E[0] : E);
    if (x.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    x.forEach(function(E) {
      if (!$e(E) || !Te(E) || E < 0)
        throw new TypeError("Invalid size, must contain positive integers (size: " + Ze(x) + ")");
    });
    var y = m ? this.clone() : this;
    return d(y, x[0], x[1], g);
  };
  function d(v, g, m, x) {
    var y = x || 0, E = o, N = 0;
    qr(v._datatype) && (E = r.find(o, [v._datatype, v._datatype]) || o, N = r.convert(0, v._datatype), y = r.convert(y, v._datatype));
    var S = !E(y, N), R = v._size[0], O = v._size[1], B, $, F;
    if (m > O) {
      for ($ = O; $ < m; $++)
        if (v._ptr[$] = v._values.length, S)
          for (B = 0; B < R; B++)
            v._values.push(y), v._index.push(B);
      v._ptr[m] = v._values.length;
    } else
      m < O && (v._ptr.splice(m + 1, O - m), v._values.splice(v._ptr[m], v._values.length), v._index.splice(v._ptr[m], v._index.length));
    if (O = m, g > R) {
      if (S) {
        var w = 0;
        for ($ = 0; $ < O; $++) {
          v._ptr[$] = v._ptr[$] + w, F = v._ptr[$ + 1] + w;
          var A = 0;
          for (B = R; B < g; B++, A++)
            v._values.splice(F + A, 0, y), v._index.splice(F + A, 0, B), w++;
        }
        v._ptr[O] = v._values.length;
      }
    } else if (g < R) {
      var b = 0;
      for ($ = 0; $ < O; $++) {
        v._ptr[$] = v._ptr[$] - b;
        var D = v._ptr[$], M = v._ptr[$ + 1] - b;
        for (F = D; F < M; F++)
          B = v._index[F], B > g - 1 && (v._values.splice(F, 1), v._index.splice(F, 1), b++);
      }
      v._ptr[$] = v._values.length;
    }
    return v._size[0] = g, v._size[1] = m, v;
  }
  i.prototype.reshape = function(v, g) {
    if (!ar(v))
      throw new TypeError("Array expected");
    if (v.length !== 2)
      throw new Error("Sparse matrices can only be reshaped in two dimensions");
    v.forEach(function(C) {
      if (!$e(C) || !Te(C) || C <= -2 || C === 0)
        throw new TypeError("Invalid size, must contain positive integers or -1 (size: " + Ze(v) + ")");
    });
    var m = this._size[0] * this._size[1];
    v = If(v, m);
    var x = v[0] * v[1];
    if (m !== x)
      throw new Error("Reshaping sparse matrix will result in the wrong number of elements");
    var y = g ? this.clone() : this;
    if (this._size[0] === v[0] && this._size[1] === v[1])
      return y;
    for (var E = [], N = 0; N < y._ptr.length; N++)
      for (var S = 0; S < y._ptr[N + 1] - y._ptr[N]; S++)
        E.push(N);
    for (var R = y._values.slice(), O = y._index.slice(), B = 0; B < y._index.length; B++) {
      var $ = O[B], F = E[B], w = $ * y._size[1] + F;
      E[B] = w % v[1], O[B] = Math.floor(w / v[1]);
    }
    y._values.length = 0, y._index.length = 0, y._ptr.length = v[1] + 1, y._size = v.slice();
    for (var A = 0; A < y._ptr.length; A++)
      y._ptr[A] = 0;
    for (var b = 0; b < R.length; b++) {
      var D = O[b], M = E[b], _ = R[b], q = s(D, y._ptr[M], y._ptr[M + 1], y._index);
      c(q, D, M, _, y._values, y._index, y._ptr);
    }
    return y;
  }, i.prototype.clone = function() {
    var v = new i({
      values: this._values ? Ie(this._values) : void 0,
      index: Ie(this._index),
      ptr: Ie(this._ptr),
      size: Ie(this._size),
      datatype: this._datatype
    });
    return v;
  }, i.prototype.size = function() {
    return this._size.slice(0);
  }, i.prototype.map = function(v, g) {
    if (!this._values)
      throw new Error("Cannot invoke map on a Pattern only matrix");
    var m = this, x = this._size[0], y = this._size[1], E = Z1(v), N = function(R, O, B) {
      return E === 1 ? v(R) : E === 2 ? v(R, [O, B]) : v(R, [O, B], m);
    };
    return h(this, 0, x - 1, 0, y - 1, N, g);
  };
  function h(v, g, m, x, y, E, N) {
    var S = [], R = [], O = [], B = o, $ = 0;
    qr(v._datatype) && (B = r.find(o, [v._datatype, v._datatype]) || o, $ = r.convert(0, v._datatype));
    for (var F = function(U, ee, se) {
      U = E(U, ee, se), B(U, $) || (S.push(U), R.push(ee));
    }, w = x; w <= y; w++) {
      O.push(S.length);
      var A = v._ptr[w], b = v._ptr[w + 1];
      if (N)
        for (var D = A; D < b; D++) {
          var M = v._index[D];
          M >= g && M <= m && F(v._values[D], M - g, w - x);
        }
      else {
        for (var _ = {}, q = A; q < b; q++) {
          var C = v._index[q];
          _[C] = v._values[q];
        }
        for (var T = g; T <= m; T++) {
          var z = T in _ ? _[T] : 0;
          F(z, T - g, w - x);
        }
      }
    }
    return O.push(S.length), new i({
      values: S,
      index: R,
      ptr: O,
      size: [m - g + 1, y - x + 1]
    });
  }
  i.prototype.forEach = function(v, g) {
    if (!this._values)
      throw new Error("Cannot invoke forEach on a Pattern only matrix");
    for (var m = this, x = this._size[0], y = this._size[1], E = 0; E < y; E++) {
      var N = this._ptr[E], S = this._ptr[E + 1];
      if (g)
        for (var R = N; R < S; R++) {
          var O = this._index[R];
          v(this._values[R], [O, E], m);
        }
      else {
        for (var B = {}, $ = N; $ < S; $++) {
          var F = this._index[$];
          B[F] = this._values[$];
        }
        for (var w = 0; w < x; w++) {
          var A = w in B ? B[w] : 0;
          v(A, [w, E], m);
        }
      }
    }
  }, i.prototype[Symbol.iterator] = function* () {
    if (!this._values)
      throw new Error("Cannot iterate a Pattern only matrix");
    for (var v = this._size[1], g = 0; g < v; g++)
      for (var m = this._ptr[g], x = this._ptr[g + 1], y = m; y < x; y++) {
        var E = this._index[y];
        yield {
          value: this._values[y],
          index: [E, g]
        };
      }
  }, i.prototype.toArray = function() {
    return p(this._values, this._index, this._ptr, this._size, !0);
  }, i.prototype.valueOf = function() {
    return p(this._values, this._index, this._ptr, this._size, !1);
  };
  function p(v, g, m, x, y) {
    var E = x[0], N = x[1], S = [], R, O;
    for (R = 0; R < E; R++)
      for (S[R] = [], O = 0; O < N; O++)
        S[R][O] = 0;
    for (O = 0; O < N; O++)
      for (var B = m[O], $ = m[O + 1], F = B; F < $; F++)
        R = g[F], S[R][O] = v ? y ? Ie(v[F]) : v[F] : 1;
    return S;
  }
  return i.prototype.format = function(v) {
    for (var g = this._size[0], m = this._size[1], x = this.density(), y = "Sparse Matrix [" + Ze(g, v) + " x " + Ze(m, v) + "] density: " + Ze(x, v) + `
`, E = 0; E < m; E++)
      for (var N = this._ptr[E], S = this._ptr[E + 1], R = N; R < S; R++) {
        var O = this._index[R];
        y += `
    (` + Ze(O, v) + ", " + Ze(E, v) + ") ==> " + (this._values ? Ze(this._values[R], v) : "X");
      }
    return y;
  }, i.prototype.toString = function() {
    return Ze(this.toArray());
  }, i.prototype.toJSON = function() {
    return {
      mathjs: "SparseMatrix",
      values: this._values,
      index: this._index,
      ptr: this._ptr,
      size: this._size,
      datatype: this._datatype
    };
  }, i.prototype.diagonal = function(v) {
    if (v) {
      if (Re(v) && (v = v.toNumber()), !$e(v) || !Te(v))
        throw new TypeError("The parameter k must be an integer number");
    } else
      v = 0;
    var g = v > 0 ? v : 0, m = v < 0 ? -v : 0, x = this._size[0], y = this._size[1], E = Math.min(x - m, y - g), N = [], S = [], R = [];
    R[0] = 0;
    for (var O = g; O < y && N.length < E; O++)
      for (var B = this._ptr[O], $ = this._ptr[O + 1], F = B; F < $; F++) {
        var w = this._index[F];
        if (w === O - g + m) {
          N.push(this._values[F]), S[N.length - 1] = w - m;
          break;
        }
      }
    return R.push(N.length), new i({
      values: N,
      index: S,
      ptr: R,
      size: [E, 1]
    });
  }, i.fromJSON = function(v) {
    return new i(v);
  }, i.diagonal = function(v, g, m, x, y) {
    if (!ar(v))
      throw new TypeError("Array expected, size parameter");
    if (v.length !== 2)
      throw new Error("Only two dimensions matrix are supported");
    if (v = v.map(function(C) {
      if (Re(C) && (C = C.toNumber()), !$e(C) || !Te(C) || C < 1)
        throw new Error("Size values must be positive integers");
      return C;
    }), m) {
      if (Re(m) && (m = m.toNumber()), !$e(m) || !Te(m))
        throw new TypeError("The parameter k must be an integer number");
    } else
      m = 0;
    var E = o, N = 0;
    qr(y) && (E = r.find(o, [y, y]) || o, N = r.convert(0, y));
    var S = m > 0 ? m : 0, R = m < 0 ? -m : 0, O = v[0], B = v[1], $ = Math.min(O - R, B - S), F;
    if (ar(g)) {
      if (g.length !== $)
        throw new Error("Invalid value array length");
      F = function(T) {
        return g[T];
      };
    } else if (Fe(g)) {
      var w = g.size();
      if (w.length !== 1 || w[0] !== $)
        throw new Error("Invalid matrix length");
      F = function(T) {
        return g.get([T]);
      };
    } else
      F = function() {
        return g;
      };
    for (var A = [], b = [], D = [], M = 0; M < B; M++) {
      D.push(A.length);
      var _ = M - S;
      if (_ >= 0 && _ < $) {
        var q = F(_);
        E(q, N) || (b.push(_ + R), A.push(q));
      }
    }
    return D.push(A.length), new i({
      values: A,
      index: b,
      ptr: D,
      size: [O, B]
    });
  }, i.prototype.swapRows = function(v, g) {
    if (!$e(v) || !Te(v) || !$e(g) || !Te(g))
      throw new Error("Row index must be positive integers");
    if (this._size.length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    return sr(v, this._size[0]), sr(g, this._size[0]), i._swapRows(v, g, this._size[1], this._values, this._index, this._ptr), this;
  }, i._forEachRow = function(v, g, m, x, y) {
    for (var E = x[v], N = x[v + 1], S = E; S < N; S++)
      y(m[S], g[S]);
  }, i._swapRows = function(v, g, m, x, y, E) {
    for (var N = 0; N < m; N++) {
      var S = E[N], R = E[N + 1], O = s(v, S, R, y), B = s(g, S, R, y);
      if (O < R && B < R && y[O] === v && y[B] === g) {
        if (x) {
          var $ = x[O];
          x[O] = x[B], x[B] = $;
        }
        continue;
      }
      if (O < R && y[O] === v && (B >= R || y[B] !== g)) {
        var F = x ? x[O] : void 0;
        y.splice(B, 0, g), x && x.splice(B, 0, F), y.splice(B <= O ? O + 1 : O, 1), x && x.splice(B <= O ? O + 1 : O, 1);
        continue;
      }
      if (B < R && y[B] === g && (O >= R || y[O] !== v)) {
        var w = x ? x[B] : void 0;
        y.splice(O, 0, v), x && x.splice(O, 0, w), y.splice(O <= B ? B + 1 : B, 1), x && x.splice(O <= B ? B + 1 : B, 1);
      }
    }
  }, i;
}, {
  isClass: !0
}), Xx = "number", Jx = ["typed"];
function Qx(e) {
  var r = e.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
  if (r) {
    var o = {
      "0b": 2,
      "0o": 8,
      "0x": 16
    }[r[1]], n = r[2], i = r[3];
    return {
      input: e,
      radix: o,
      integerPart: n,
      fractionalPart: i
    };
  } else
    return null;
}
function e3(e) {
  for (var r = parseInt(e.integerPart, e.radix), o = 0, n = 0; n < e.fractionalPart.length; n++) {
    var i = parseInt(e.fractionalPart[n], e.radix);
    o += i / Math.pow(e.radix, n + 1);
  }
  var t = r + o;
  if (isNaN(t))
    throw new SyntaxError('String "' + e.input + '" is not a valid number');
  return t;
}
var r3 = /* @__PURE__ */ Q(Xx, Jx, (e) => {
  var {
    typed: r
  } = e, o = r("number", {
    "": function() {
      return 0;
    },
    number: function(i) {
      return i;
    },
    string: function(i) {
      if (i === "NaN")
        return NaN;
      var t = Qx(i);
      if (t)
        return e3(t);
      var u = 0, l = i.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
      l && (u = Number(l[2]), i = l[1]);
      var f = Number(i);
      if (isNaN(f))
        throw new SyntaxError('String "' + i + '" is not a valid number');
      if (l) {
        if (f > 2 ** u - 1)
          throw new SyntaxError('String "'.concat(i, '" is out of range'));
        f >= 2 ** (u - 1) && (f = f - 2 ** u);
      }
      return f;
    },
    BigNumber: function(i) {
      return i.toNumber();
    },
    bigint: function(i) {
      return Number(i);
    },
    Fraction: function(i) {
      return i.valueOf();
    },
    Unit: r.referToSelf((n) => (i) => {
      var t = i.clone();
      return t.value = n(i.value), t;
    }),
    null: function(i) {
      return 0;
    },
    "Unit, string | Unit": function(i, t) {
      return i.toNumber(t);
    },
    "Array | Matrix": r.referToSelf((n) => (i) => Ke(i, n))
  });
  return o.fromJSON = function(n) {
    return parseFloat(n.value);
  }, o;
}), t3 = "bigint", n3 = ["typed"], i3 = /* @__PURE__ */ Q(t3, n3, (e) => {
  var {
    typed: r
  } = e, o = r("bigint", {
    "": function() {
      return 0n;
    },
    bigint: function(i) {
      return i;
    },
    number: function(i) {
      return BigInt(i.toFixed());
    },
    BigNumber: function(i) {
      return BigInt(i.round().toString());
    },
    Fraction: function(i) {
      return BigInt(i.valueOf().toFixed());
    },
    "string | boolean": function(i) {
      return BigInt(i);
    },
    null: function(i) {
      return 0n;
    },
    "Array | Matrix": r.referToSelf((n) => (i) => Ke(i, n))
  });
  return o.fromJSON = function(n) {
    return BigInt(n.value);
  }, o;
}), rl = "string", a3 = ["typed"], o3 = /* @__PURE__ */ Q(rl, a3, (e) => {
  var {
    typed: r
  } = e;
  return r(rl, {
    "": function() {
      return "";
    },
    number: xn,
    null: function(n) {
      return "null";
    },
    boolean: function(n) {
      return n + "";
    },
    string: function(n) {
      return n;
    },
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o)),
    any: function(n) {
      return String(n);
    }
  });
}), tl = "boolean", s3 = ["typed"], u3 = /* @__PURE__ */ Q(tl, s3, (e) => {
  var {
    typed: r
  } = e;
  return r(tl, {
    "": function() {
      return !1;
    },
    boolean: function(n) {
      return n;
    },
    number: function(n) {
      return !!n;
    },
    null: function(n) {
      return !1;
    },
    BigNumber: function(n) {
      return !n.isZero();
    },
    string: function(n) {
      var i = n.toLowerCase();
      if (i === "true")
        return !0;
      if (i === "false")
        return !1;
      var t = Number(n);
      if (n !== "" && !isNaN(t))
        return !!t;
      throw new Error('Cannot convert "' + n + '" to a boolean');
    },
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o))
  });
}), f3 = "bignumber", c3 = ["typed", "BigNumber"], l3 = /* @__PURE__ */ Q(f3, c3, (e) => {
  var {
    typed: r,
    BigNumber: o
  } = e;
  return r("bignumber", {
    "": function() {
      return new o(0);
    },
    number: function(i) {
      return new o(i + "");
    },
    string: function(i) {
      var t = i.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
      if (t) {
        var u = t[2], l = o(t[1]), f = new o(2).pow(Number(u));
        if (l.gt(f.sub(1)))
          throw new SyntaxError('String "'.concat(i, '" is out of range'));
        var s = new o(2).pow(Number(u) - 1);
        return l.gte(s) ? l.sub(f) : l;
      }
      return new o(i);
    },
    BigNumber: function(i) {
      return i;
    },
    bigint: function(i) {
      return new o(i.toString());
    },
    Unit: r.referToSelf((n) => (i) => {
      var t = i.clone();
      return t.value = n(i.value), t;
    }),
    Fraction: function(i) {
      return new o(i.n).div(i.d).times(i.s);
    },
    null: function(i) {
      return new o(0);
    },
    "Array | Matrix": r.referToSelf((n) => (i) => Ke(i, n))
  });
}), d3 = "complex", h3 = ["typed", "Complex"], p3 = /* @__PURE__ */ Q(d3, h3, (e) => {
  var {
    typed: r,
    Complex: o
  } = e;
  return r("complex", {
    "": function() {
      return o.ZERO;
    },
    number: function(i) {
      return new o(i, 0);
    },
    "number, number": function(i, t) {
      return new o(i, t);
    },
    // TODO: this signature should be redundant
    "BigNumber, BigNumber": function(i, t) {
      return new o(i.toNumber(), t.toNumber());
    },
    Fraction: function(i) {
      return new o(i.valueOf(), 0);
    },
    Complex: function(i) {
      return i.clone();
    },
    string: function(i) {
      return o(i);
    },
    null: function(i) {
      return o(0);
    },
    Object: function(i) {
      if ("re" in i && "im" in i)
        return new o(i.re, i.im);
      if ("r" in i && "phi" in i || "abs" in i && "arg" in i)
        return new o(i);
      throw new Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)");
    },
    "Array | Matrix": r.referToSelf((n) => (i) => Ke(i, n))
  });
}), v3 = "fraction", m3 = ["typed", "Fraction"], g3 = /* @__PURE__ */ Q(v3, m3, (e) => {
  var {
    typed: r,
    Fraction: o
  } = e;
  return r("fraction", {
    number: function(i) {
      if (!isFinite(i) || isNaN(i))
        throw new Error(i + " cannot be represented as a fraction");
      return new o(i);
    },
    string: function(i) {
      return new o(i);
    },
    "number, number": function(i, t) {
      return new o(i, t);
    },
    null: function(i) {
      return new o(0);
    },
    BigNumber: function(i) {
      return new o(i.toString());
    },
    bigint: function(i) {
      return new o(i.toString());
    },
    Fraction: function(i) {
      return i;
    },
    Unit: r.referToSelf((n) => (i) => {
      var t = i.clone();
      return t.value = n(i.value), t;
    }),
    Object: function(i) {
      return new o(i);
    },
    "Array | Matrix": r.referToSelf((n) => (i) => Ke(i, n))
  });
}), nl = "matrix", b3 = ["typed", "Matrix", "DenseMatrix", "SparseMatrix"], y3 = /* @__PURE__ */ Q(nl, b3, (e) => {
  var {
    typed: r,
    Matrix: o,
    DenseMatrix: n,
    SparseMatrix: i
  } = e;
  return r(nl, {
    "": function() {
      return t([]);
    },
    string: function(l) {
      return t([], l);
    },
    "string, string": function(l, f) {
      return t([], l, f);
    },
    Array: function(l) {
      return t(l);
    },
    Matrix: function(l) {
      return t(l, l.storage());
    },
    "Array | Matrix, string": t,
    "Array | Matrix, string, string": t
  });
  function t(u, l, f) {
    if (l === "dense" || l === "default" || l === void 0)
      return new n(u, f);
    if (l === "sparse")
      return new i(u, f);
    throw new TypeError("Unknown matrix type " + JSON.stringify(l) + ".");
  }
}), il = "matrixFromFunction", w3 = ["typed", "matrix", "isZero"], x3 = /* @__PURE__ */ Q(il, w3, (e) => {
  var {
    typed: r,
    matrix: o,
    isZero: n
  } = e;
  return r(il, {
    "Array | Matrix, function, string, string": function(u, l, f, s) {
      return i(u, l, f, s);
    },
    "Array | Matrix, function, string": function(u, l, f) {
      return i(u, l, f);
    },
    "Matrix, function": function(u, l) {
      return i(u, l, "dense");
    },
    "Array, function": function(u, l) {
      return i(u, l, "dense").toArray();
    },
    "Array | Matrix, string, function": function(u, l, f) {
      return i(u, f, l);
    },
    "Array | Matrix, string, string, function": function(u, l, f, s) {
      return i(u, s, l, f);
    }
  });
  function i(t, u, l, f) {
    var s;
    return f !== void 0 ? s = o(l, f) : s = o(l), s.resize(t), s.forEach(function(a, c) {
      var d = u(c);
      n(d) || s.set(c, d);
    }), s;
  }
}), al = "matrixFromRows", E3 = ["typed", "matrix", "flatten", "size"], A3 = /* @__PURE__ */ Q(al, E3, (e) => {
  var {
    typed: r,
    matrix: o,
    flatten: n,
    size: i
  } = e;
  return r(al, {
    "...Array": function(f) {
      return t(f);
    },
    "...Matrix": function(f) {
      return o(t(f.map((s) => s.toArray())));
    }
    // TODO implement this properly for SparseMatrix
  });
  function t(l) {
    if (l.length === 0)
      throw new TypeError("At least one row is needed to construct a matrix.");
    var f = u(l[0]), s = [];
    for (var a of l) {
      var c = u(a);
      if (c !== f)
        throw new TypeError("The vectors had different length: " + (f | 0) + " ≠ " + (c | 0));
      s.push(n(a));
    }
    return s;
  }
  function u(l) {
    var f = i(l);
    if (f.length === 1)
      return f[0];
    if (f.length === 2) {
      if (f[0] === 1)
        return f[1];
      if (f[1] === 1)
        return f[0];
      throw new TypeError("At least one of the arguments is not a vector.");
    } else
      throw new TypeError("Only one- or two-dimensional vectors are supported.");
  }
}), ol = "matrixFromColumns", S3 = ["typed", "matrix", "flatten", "size"], D3 = /* @__PURE__ */ Q(ol, S3, (e) => {
  var {
    typed: r,
    matrix: o,
    flatten: n,
    size: i
  } = e;
  return r(ol, {
    "...Array": function(f) {
      return t(f);
    },
    "...Matrix": function(f) {
      return o(t(f.map((s) => s.toArray())));
    }
    // TODO implement this properly for SparseMatrix
  });
  function t(l) {
    if (l.length === 0)
      throw new TypeError("At least one column is needed to construct a matrix.");
    for (var f = u(l[0]), s = [], a = 0; a < f; a++)
      s[a] = [];
    for (var c of l) {
      var d = u(c);
      if (d !== f)
        throw new TypeError("The vectors had different length: " + (f | 0) + " ≠ " + (d | 0));
      for (var h = n(c), p = 0; p < f; p++)
        s[p].push(h[p]);
    }
    return s;
  }
  function u(l) {
    var f = i(l);
    if (f.length === 1)
      return f[0];
    if (f.length === 2) {
      if (f[0] === 1)
        return f[1];
      if (f[1] === 1)
        return f[0];
      throw new TypeError("At least one of the arguments is not a vector.");
    } else
      throw new TypeError("Only one- or two-dimensional vectors are supported.");
  }
}), sl = "splitUnit", N3 = ["typed"], M3 = /* @__PURE__ */ Q(sl, N3, (e) => {
  var {
    typed: r
  } = e;
  return r(sl, {
    "Unit, Array": function(n, i) {
      return n.splitUnit(i);
    }
  });
}), ul = "unaryMinus", _3 = ["typed"], C3 = /* @__PURE__ */ Q(ul, _3, (e) => {
  var {
    typed: r
  } = e;
  return r(ul, {
    number: eg,
    "Complex | BigNumber | Fraction": (o) => o.neg(),
    bigint: (o) => -o,
    Unit: r.referToSelf((o) => (n) => {
      var i = n.clone();
      return i.value = r.find(o, i.valueType())(n.value), i;
    }),
    // deep map collection, skip zeros since unaryMinus(0) = 0
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o))
    // TODO: add support for string
  });
}), fl = "unaryPlus", T3 = ["typed", "config", "numeric"], B3 = /* @__PURE__ */ Q(fl, T3, (e) => {
  var {
    typed: r,
    config: o,
    numeric: n
  } = e;
  return r(fl, {
    number: rg,
    Complex: function(t) {
      return t;
    },
    BigNumber: function(t) {
      return t;
    },
    bigint: function(t) {
      return t;
    },
    Fraction: function(t) {
      return t;
    },
    Unit: function(t) {
      return t.clone();
    },
    // deep map collection, skip zeros since unaryPlus(0) = 0
    "Array | Matrix": r.referToSelf((i) => (t) => Ke(t, i)),
    boolean: function(t) {
      return n(t ? 1 : 0, o.number);
    },
    string: function(t) {
      return n(t, sn(t, o));
    }
  });
}), cl = "abs", F3 = ["typed"], I3 = /* @__PURE__ */ Q(cl, F3, (e) => {
  var {
    typed: r
  } = e;
  return r(cl, {
    number: Y1,
    "Complex | BigNumber | Fraction | Unit": (o) => o.abs(),
    bigint: (o) => o < 0n ? -o : o,
    // deep map collection, skip zeros since abs(0) = 0
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o))
  });
}), ll = "apply", O3 = ["typed", "isInteger"], Pf = /* @__PURE__ */ Q(ll, O3, (e) => {
  var {
    typed: r,
    isInteger: o
  } = e;
  return r(ll, {
    "Array | Matrix, number | BigNumber, function": function(i, t, u) {
      if (!o(t))
        throw new TypeError("Integer number expected for dimension");
      var l = Array.isArray(i) ? ze(i) : i.size();
      if (t < 0 || t >= l.length)
        throw new dt(t, l.length);
      return Fe(i) ? i.create(Ia(i.valueOf(), t, u)) : Ia(i, t, u);
    }
  });
});
function Ia(e, r, o) {
  var n, i, t;
  if (r <= 0)
    if (Array.isArray(e[0])) {
      for (t = R3(e), i = [], n = 0; n < t.length; n++)
        i[n] = Ia(t[n], r - 1, o);
      return i;
    } else
      return o(e);
  else {
    for (i = [], n = 0; n < e.length; n++)
      i[n] = Ia(e[n], r - 1, o);
    return i;
  }
}
function R3(e) {
  var r = e.length, o = e[0].length, n, i, t = [];
  for (i = 0; i < o; i++) {
    var u = [];
    for (n = 0; n < r; n++)
      u.push(e[n][i]);
    t.push(u);
  }
  return t;
}
var dl = "addScalar", P3 = ["typed"], q3 = /* @__PURE__ */ Q(dl, P3, (e) => {
  var {
    typed: r
  } = e;
  return r(dl, {
    "number, number": X1,
    "Complex, Complex": function(n, i) {
      return n.add(i);
    },
    "BigNumber, BigNumber": function(n, i) {
      return n.plus(i);
    },
    "bigint, bigint": function(n, i) {
      return n + i;
    },
    "Fraction, Fraction": function(n, i) {
      return n.add(i);
    },
    "Unit, Unit": r.referToSelf((o) => (n, i) => {
      if (n.value === null || n.value === void 0)
        throw new Error("Parameter x contains a unit with undefined value");
      if (i.value === null || i.value === void 0)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!n.equalBase(i))
        throw new Error("Units do not match");
      var t = n.clone();
      return t.value = r.find(o, [t.valueType(), i.valueType()])(t.value, i.value), t.fixPrefix = !1, t;
    })
  });
}), hl = "subtractScalar", $3 = ["typed"], z3 = /* @__PURE__ */ Q(hl, $3, (e) => {
  var {
    typed: r
  } = e;
  return r(hl, {
    "number, number": J1,
    "Complex, Complex": function(n, i) {
      return n.sub(i);
    },
    "BigNumber, BigNumber": function(n, i) {
      return n.minus(i);
    },
    "bigint, bigint": function(n, i) {
      return n - i;
    },
    "Fraction, Fraction": function(n, i) {
      return n.sub(i);
    },
    "Unit, Unit": r.referToSelf((o) => (n, i) => {
      if (n.value === null || n.value === void 0)
        throw new Error("Parameter x contains a unit with undefined value");
      if (i.value === null || i.value === void 0)
        throw new Error("Parameter y contains a unit with undefined value");
      if (!n.equalBase(i))
        throw new Error("Units do not match");
      var t = n.clone();
      return t.value = r.find(o, [t.valueType(), i.valueType()])(t.value, i.value), t.fixPrefix = !1, t;
    })
  });
}), pl = "cbrt", L3 = ["config", "typed", "isNegative", "unaryMinus", "matrix", "Complex", "BigNumber", "Fraction"], U3 = /* @__PURE__ */ Q(pl, L3, (e) => {
  var {
    config: r,
    typed: o,
    isNegative: n,
    unaryMinus: i,
    matrix: t,
    Complex: u,
    BigNumber: l,
    Fraction: f
  } = e;
  return o(pl, {
    number: li,
    // note: signature 'number, boolean' is also supported,
    //       created by typed as it knows how to convert number to Complex
    Complex: s,
    "Complex, boolean": s,
    BigNumber: function(d) {
      return d.cbrt();
    },
    Unit: a
  });
  function s(c, d) {
    var h = c.arg() / 3, p = c.abs(), v = new u(li(p), 0).mul(new u(0, h).exp());
    if (d) {
      var g = [v, new u(li(p), 0).mul(new u(0, h + Math.PI * 2 / 3).exp()), new u(li(p), 0).mul(new u(0, h - Math.PI * 2 / 3).exp())];
      return r.matrix === "Array" ? g : t(g);
    } else
      return v;
  }
  function a(c) {
    if (c.value && yt(c.value)) {
      var d = c.clone();
      return d.value = 1, d = d.pow(1 / 3), d.value = s(c.value), d;
    } else {
      var h = n(c.value);
      h && (c.value = i(c.value));
      var p;
      Re(c.value) ? p = new l(1).div(3) : An(c.value) ? p = new f(1, 3) : p = 1 / 3;
      var v = c.pow(p);
      return h && (v.value = i(v.value)), v;
    }
  }
}), k3 = "matAlgo11xS0s", H3 = ["typed", "equalScalar"], Lr = /* @__PURE__ */ Q(k3, H3, (e) => {
  var {
    typed: r,
    equalScalar: o
  } = e;
  return function(i, t, u, l) {
    var f = i._values, s = i._index, a = i._ptr, c = i._size, d = i._datatype;
    if (!f)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var h = c[0], p = c[1], v, g = o, m = 0, x = u;
    typeof d == "string" && (v = d, g = r.find(o, [v, v]), m = r.convert(0, v), t = r.convert(t, v), x = r.find(u, [v, v]));
    for (var y = [], E = [], N = [], S = 0; S < p; S++) {
      N[S] = E.length;
      for (var R = a[S], O = a[S + 1], B = R; B < O; B++) {
        var $ = s[B], F = l ? x(t, f[B]) : x(f[B], t);
        g(F, m) || (E.push($), y.push(F));
      }
    }
    return N[p] = E.length, i.createSparseMatrix({
      values: y,
      index: E,
      ptr: N,
      size: [h, p],
      datatype: v
    });
  };
}), G3 = "matAlgo12xSfs", V3 = ["typed", "DenseMatrix"], Ir = /* @__PURE__ */ Q(G3, V3, (e) => {
  var {
    typed: r,
    DenseMatrix: o
  } = e;
  return function(i, t, u, l) {
    var f = i._values, s = i._index, a = i._ptr, c = i._size, d = i._datatype;
    if (!f)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var h = c[0], p = c[1], v, g = u;
    typeof d == "string" && (v = d, t = r.convert(t, v), g = r.find(u, [v, v]));
    for (var m = [], x = [], y = [], E = 0; E < p; E++) {
      for (var N = E + 1, S = a[E], R = a[E + 1], O = S; O < R; O++) {
        var B = s[O];
        x[B] = f[O], y[B] = N;
      }
      for (var $ = 0; $ < h; $++)
        E === 0 && (m[$] = []), y[$] === N ? m[$][E] = l ? g(t, x[$]) : g(x[$], t) : m[$][E] = l ? g(t, 0) : g(0, t);
    }
    return new o({
      data: m,
      size: [h, p],
      datatype: v
    });
  };
}), W3 = "matAlgo14xDs", K3 = ["typed"], Et = /* @__PURE__ */ Q(W3, K3, (e) => {
  var {
    typed: r
  } = e;
  return function(i, t, u, l) {
    var f = i._data, s = i._size, a = i._datatype, c, d = u;
    typeof a == "string" && (c = a, t = r.convert(t, c), d = r.find(u, [c, c]));
    var h = s.length > 0 ? o(d, 0, s, s[0], f, t, l) : [];
    return i.createDenseMatrix({
      data: h,
      size: Ie(s),
      datatype: c
    });
  };
  function o(n, i, t, u, l, f, s) {
    var a = [];
    if (i === t.length - 1)
      for (var c = 0; c < u; c++)
        a[c] = s ? n(f, l[c]) : n(l[c], f);
    else
      for (var d = 0; d < u; d++)
        a[d] = o(n, i + 1, t, t[i + 1], l[d], f, s);
    return a;
  }
}), Ku = "ceil", Z3 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix"], j3 = /* @__PURE__ */ Q(Ku, ["typed", "config", "round"], (e) => {
  var {
    typed: r,
    config: o,
    round: n
  } = e;
  return r(Ku, {
    number: function(t) {
      return zr(t, n(t), o.relTol, o.absTol) ? n(t) : Math.ceil(t);
    },
    "number, number": function(t, u) {
      if (zr(t, n(t, u), o.relTol, o.absTol))
        return n(t, u);
      var [l, f] = "".concat(t, "e").split("e"), s = Math.ceil(Number("".concat(l, "e").concat(Number(f) + u)));
      return [l, f] = "".concat(s, "e").split("e"), Number("".concat(l, "e").concat(Number(f) - u));
    }
  });
}), Y3 = /* @__PURE__ */ Q(Ku, Z3, (e) => {
  var {
    typed: r,
    config: o,
    round: n,
    matrix: i,
    equalScalar: t,
    zeros: u,
    DenseMatrix: l
  } = e, f = Lr({
    typed: r,
    equalScalar: t
  }), s = Ir({
    typed: r,
    DenseMatrix: l
  }), a = Et({
    typed: r
  }), c = j3({
    typed: r,
    config: o,
    round: n
  });
  return r("ceil", {
    number: c.signatures.number,
    "number,number": c.signatures["number,number"],
    Complex: function(h) {
      return h.ceil();
    },
    "Complex, number": function(h, p) {
      return h.ceil(p);
    },
    "Complex, BigNumber": function(h, p) {
      return h.ceil(p.toNumber());
    },
    BigNumber: function(h) {
      return Xr(h, n(h), o.relTol, o.absTol) ? n(h) : h.ceil();
    },
    "BigNumber, BigNumber": function(h, p) {
      return Xr(h, n(h, p), o.relTol, o.absTol) ? n(h, p) : h.toDecimalPlaces(p.toNumber(), on.ROUND_CEIL);
    },
    Fraction: function(h) {
      return h.ceil();
    },
    "Fraction, number": function(h, p) {
      return h.ceil(p);
    },
    "Fraction, BigNumber": function(h, p) {
      return h.ceil(p.toNumber());
    },
    "Array | Matrix": r.referToSelf((d) => (h) => Ke(h, d)),
    "Array, number | BigNumber": r.referToSelf((d) => (h, p) => Ke(h, (v) => d(v, p))),
    "SparseMatrix, number | BigNumber": r.referToSelf((d) => (h, p) => f(h, p, d, !1)),
    "DenseMatrix, number | BigNumber": r.referToSelf((d) => (h, p) => a(h, p, d, !1)),
    "number | Complex | Fraction | BigNumber, Array": r.referToSelf((d) => (h, p) => a(i(p), h, d, !0).valueOf()),
    "number | Complex | Fraction | BigNumber, Matrix": r.referToSelf((d) => (h, p) => t(h, 0) ? u(p.size(), p.storage()) : p.storage() === "dense" ? a(p, h, d, !0) : s(p, h, d, !0))
  });
}), vl = "cube", X3 = ["typed"], J3 = /* @__PURE__ */ Q(vl, X3, (e) => {
  var {
    typed: r
  } = e;
  return r(vl, {
    number: tg,
    Complex: function(n) {
      return n.mul(n).mul(n);
    },
    BigNumber: function(n) {
      return n.times(n).times(n);
    },
    bigint: function(n) {
      return n * n * n;
    },
    Fraction: function(n) {
      return n.pow(3);
    },
    Unit: function(n) {
      return n.pow(3);
    }
  });
}), ml = "exp", Q3 = ["typed"], e4 = /* @__PURE__ */ Q(ml, Q3, (e) => {
  var {
    typed: r
  } = e;
  return r(ml, {
    number: ng,
    Complex: function(n) {
      return n.exp();
    },
    BigNumber: function(n) {
      return n.exp();
    }
  });
}), gl = "expm1", r4 = ["typed", "Complex"], t4 = /* @__PURE__ */ Q(gl, r4, (e) => {
  var {
    typed: r,
    Complex: o
  } = e;
  return r(gl, {
    number: ig,
    Complex: function(i) {
      var t = Math.exp(i.re);
      return new o(t * Math.cos(i.im) - 1, t * Math.sin(i.im));
    },
    BigNumber: function(i) {
      return i.exp().minus(1);
    }
  });
}), Zu = "fix", n4 = ["typed", "Complex", "matrix", "ceil", "floor", "equalScalar", "zeros", "DenseMatrix"], i4 = /* @__PURE__ */ Q(Zu, ["typed", "ceil", "floor"], (e) => {
  var {
    typed: r,
    ceil: o,
    floor: n
  } = e;
  return r(Zu, {
    number: function(t) {
      return t > 0 ? n(t) : o(t);
    },
    "number, number": function(t, u) {
      return t > 0 ? n(t, u) : o(t, u);
    }
  });
}), a4 = /* @__PURE__ */ Q(Zu, n4, (e) => {
  var {
    typed: r,
    Complex: o,
    matrix: n,
    ceil: i,
    floor: t,
    equalScalar: u,
    zeros: l,
    DenseMatrix: f
  } = e, s = Ir({
    typed: r,
    DenseMatrix: f
  }), a = Et({
    typed: r
  }), c = i4({
    typed: r,
    ceil: i,
    floor: t
  });
  return r("fix", {
    number: c.signatures.number,
    "number, number | BigNumber": c.signatures["number,number"],
    Complex: function(h) {
      return new o(h.re > 0 ? Math.floor(h.re) : Math.ceil(h.re), h.im > 0 ? Math.floor(h.im) : Math.ceil(h.im));
    },
    "Complex, number": function(h, p) {
      return new o(h.re > 0 ? t(h.re, p) : i(h.re, p), h.im > 0 ? t(h.im, p) : i(h.im, p));
    },
    "Complex, BigNumber": function(h, p) {
      var v = p.toNumber();
      return new o(h.re > 0 ? t(h.re, v) : i(h.re, v), h.im > 0 ? t(h.im, v) : i(h.im, v));
    },
    BigNumber: function(h) {
      return h.isNegative() ? i(h) : t(h);
    },
    "BigNumber, number | BigNumber": function(h, p) {
      return h.isNegative() ? i(h, p) : t(h, p);
    },
    Fraction: function(h) {
      return h.s < 0 ? h.ceil() : h.floor();
    },
    "Fraction, number | BigNumber": function(h, p) {
      return h.s < 0 ? i(h, p) : t(h, p);
    },
    "Array | Matrix": r.referToSelf((d) => (h) => Ke(h, d)),
    "Array | Matrix, number | BigNumber": r.referToSelf((d) => (h, p) => Ke(h, (v) => d(v, p))),
    "number | Complex | Fraction | BigNumber, Array": r.referToSelf((d) => (h, p) => a(n(p), h, d, !0).valueOf()),
    "number | Complex | Fraction | BigNumber, Matrix": r.referToSelf((d) => (h, p) => u(h, 0) ? l(p.size(), p.storage()) : p.storage() === "dense" ? a(p, h, d, !0) : s(p, h, d, !0))
  });
}), ju = "floor", o4 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix"], s4 = /* @__PURE__ */ Q(ju, ["typed", "config", "round"], (e) => {
  var {
    typed: r,
    config: o,
    round: n
  } = e;
  return r(ju, {
    number: function(t) {
      return zr(t, n(t), o.relTol, o.absTol) ? n(t) : Math.floor(t);
    },
    "number, number": function(t, u) {
      if (zr(t, n(t, u), o.relTol, o.absTol))
        return n(t, u);
      var [l, f] = "".concat(t, "e").split("e"), s = Math.floor(Number("".concat(l, "e").concat(Number(f) + u)));
      return [l, f] = "".concat(s, "e").split("e"), Number("".concat(l, "e").concat(Number(f) - u));
    }
  });
}), Ug = /* @__PURE__ */ Q(ju, o4, (e) => {
  var {
    typed: r,
    config: o,
    round: n,
    matrix: i,
    equalScalar: t,
    zeros: u,
    DenseMatrix: l
  } = e, f = Lr({
    typed: r,
    equalScalar: t
  }), s = Ir({
    typed: r,
    DenseMatrix: l
  }), a = Et({
    typed: r
  }), c = s4({
    typed: r,
    config: o,
    round: n
  });
  return r("floor", {
    number: c.signatures.number,
    "number,number": c.signatures["number,number"],
    Complex: function(h) {
      return h.floor();
    },
    "Complex, number": function(h, p) {
      return h.floor(p);
    },
    "Complex, BigNumber": function(h, p) {
      return h.floor(p.toNumber());
    },
    BigNumber: function(h) {
      return Xr(h, n(h), o.relTol, o.absTol) ? n(h) : h.floor();
    },
    "BigNumber, BigNumber": function(h, p) {
      return Xr(h, n(h, p), o.relTol, o.absTol) ? n(h, p) : h.toDecimalPlaces(p.toNumber(), on.ROUND_FLOOR);
    },
    Fraction: function(h) {
      return h.floor();
    },
    "Fraction, number": function(h, p) {
      return h.floor(p);
    },
    "Fraction, BigNumber": function(h, p) {
      return h.floor(p.toNumber());
    },
    "Array | Matrix": r.referToSelf((d) => (h) => Ke(h, d)),
    "Array, number | BigNumber": r.referToSelf((d) => (h, p) => Ke(h, (v) => d(v, p))),
    "SparseMatrix, number | BigNumber": r.referToSelf((d) => (h, p) => f(h, p, d, !1)),
    "DenseMatrix, number | BigNumber": r.referToSelf((d) => (h, p) => a(h, p, d, !1)),
    "number | Complex | Fraction | BigNumber, Array": r.referToSelf((d) => (h, p) => a(i(p), h, d, !0).valueOf()),
    "number | Complex | Fraction | BigNumber, Matrix": r.referToSelf((d) => (h, p) => t(h, 0) ? u(p.size(), p.storage()) : p.storage() === "dense" ? a(p, h, d, !0) : s(p, h, d, !0))
  });
}), u4 = "matAlgo02xDS0", f4 = ["typed", "equalScalar"], At = /* @__PURE__ */ Q(u4, f4, (e) => {
  var {
    typed: r,
    equalScalar: o
  } = e;
  return function(i, t, u, l) {
    var f = i._data, s = i._size, a = i._datatype || i.getDataType(), c = t._values, d = t._index, h = t._ptr, p = t._size, v = t._datatype || t._data === void 0 ? t._datatype : t.getDataType();
    if (s.length !== p.length)
      throw new We(s.length, p.length);
    if (s[0] !== p[0] || s[1] !== p[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + s + ") must match Matrix B (" + p + ")");
    if (!c)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var g = s[0], m = s[1], x, y = o, E = 0, N = u;
    typeof a == "string" && a === v && a !== "mixed" && (x = a, y = r.find(o, [x, x]), E = r.convert(0, x), N = r.find(u, [x, x]));
    for (var S = [], R = [], O = [], B = 0; B < m; B++) {
      O[B] = R.length;
      for (var $ = h[B], F = h[B + 1], w = $; w < F; w++) {
        var A = d[w], b = l ? N(c[w], f[A][B]) : N(f[A][B], c[w]);
        y(b, E) || (R.push(A), S.push(b));
      }
    }
    return O[m] = R.length, t.createSparseMatrix({
      values: S,
      index: R,
      ptr: O,
      size: [g, m],
      datatype: a === i._datatype && v === t._datatype ? x : void 0
    });
  };
}), c4 = "matAlgo03xDSf", l4 = ["typed"], Kr = /* @__PURE__ */ Q(c4, l4, (e) => {
  var {
    typed: r
  } = e;
  return function(n, i, t, u) {
    var l = n._data, f = n._size, s = n._datatype || n.getDataType(), a = i._values, c = i._index, d = i._ptr, h = i._size, p = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (f.length !== h.length)
      throw new We(f.length, h.length);
    if (f[0] !== h[0] || f[1] !== h[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + f + ") must match Matrix B (" + h + ")");
    if (!a)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var v = f[0], g = f[1], m, x = 0, y = t;
    typeof s == "string" && s === p && s !== "mixed" && (m = s, x = r.convert(0, m), y = r.find(t, [m, m]));
    for (var E = [], N = 0; N < v; N++)
      E[N] = [];
    for (var S = [], R = [], O = 0; O < g; O++) {
      for (var B = O + 1, $ = d[O], F = d[O + 1], w = $; w < F; w++) {
        var A = c[w];
        S[A] = u ? y(a[w], l[A][O]) : y(l[A][O], a[w]), R[A] = B;
      }
      for (var b = 0; b < v; b++)
        R[b] === B ? E[b][O] = S[b] : E[b][O] = u ? y(x, l[b][O]) : y(l[b][O], x);
    }
    return n.createDenseMatrix({
      data: E,
      size: [v, g],
      datatype: s === n._datatype && p === i._datatype ? m : void 0
    });
  };
}), d4 = "matAlgo05xSfSf", h4 = ["typed", "equalScalar"], io = /* @__PURE__ */ Q(d4, h4, (e) => {
  var {
    typed: r,
    equalScalar: o
  } = e;
  return function(i, t, u) {
    var l = i._values, f = i._index, s = i._ptr, a = i._size, c = i._datatype || i._data === void 0 ? i._datatype : i.getDataType(), d = t._values, h = t._index, p = t._ptr, v = t._size, g = t._datatype || t._data === void 0 ? t._datatype : t.getDataType();
    if (a.length !== v.length)
      throw new We(a.length, v.length);
    if (a[0] !== v[0] || a[1] !== v[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + v + ")");
    var m = a[0], x = a[1], y, E = o, N = 0, S = u;
    typeof c == "string" && c === g && c !== "mixed" && (y = c, E = r.find(o, [y, y]), N = r.convert(0, y), S = r.find(u, [y, y]));
    var R = l && d ? [] : void 0, O = [], B = [], $ = R ? [] : void 0, F = R ? [] : void 0, w = [], A = [], b, D, M, _;
    for (D = 0; D < x; D++) {
      B[D] = O.length;
      var q = D + 1;
      for (M = s[D], _ = s[D + 1]; M < _; M++)
        b = f[M], O.push(b), w[b] = q, $ && ($[b] = l[M]);
      for (M = p[D], _ = p[D + 1]; M < _; M++)
        b = h[M], w[b] !== q && O.push(b), A[b] = q, F && (F[b] = d[M]);
      if (R)
        for (M = B[D]; M < O.length; ) {
          b = O[M];
          var C = w[b], T = A[b];
          if (C === q || T === q) {
            var z = C === q ? $[b] : N, I = T === q ? F[b] : N, U = S(z, I);
            E(U, N) ? O.splice(M, 1) : (R.push(U), M++);
          }
        }
    }
    return B[x] = O.length, i.createSparseMatrix({
      values: R,
      index: O,
      ptr: B,
      size: [m, x],
      datatype: c === i._datatype && g === t._datatype ? y : void 0
    });
  };
}), p4 = "matAlgo13xDD", v4 = ["typed"], m4 = /* @__PURE__ */ Q(p4, v4, (e) => {
  var {
    typed: r
  } = e;
  return function(i, t, u) {
    var l = i._data, f = i._size, s = i._datatype, a = t._data, c = t._size, d = t._datatype, h = [];
    if (f.length !== c.length)
      throw new We(f.length, c.length);
    for (var p = 0; p < f.length; p++) {
      if (f[p] !== c[p])
        throw new RangeError("Dimension mismatch. Matrix A (" + f + ") must match Matrix B (" + c + ")");
      h[p] = f[p];
    }
    var v, g = u;
    typeof s == "string" && s === d && (v = s, g = r.find(u, [v, v]));
    var m = h.length > 0 ? o(g, 0, h, h[0], l, a) : [];
    return i.createDenseMatrix({
      data: m,
      size: h,
      datatype: v
    });
  };
  function o(n, i, t, u, l, f) {
    var s = [];
    if (i === t.length - 1)
      for (var a = 0; a < u; a++)
        s[a] = n(l[a], f[a]);
    else
      for (var c = 0; c < u; c++)
        s[c] = o(n, i + 1, t, t[i + 1], l[c], f[c]);
    return s;
  }
});
function Or(e, r) {
  if (Vt(e.size(), r.size()))
    return [e, r];
  var o = W1(e.size(), r.size());
  return [e, r].map((n) => g4(n, o));
}
function g4(e, r) {
  return Vt(e.size(), r) ? e : e.create(ku(e.valueOf(), r), e.datatype());
}
var b4 = "matrixAlgorithmSuite", y4 = ["typed", "matrix"], lr = /* @__PURE__ */ Q(b4, y4, (e) => {
  var {
    typed: r,
    matrix: o
  } = e, n = m4({
    typed: r
  }), i = Et({
    typed: r
  });
  return function(u) {
    var l = u.elop, f = u.SD || u.DS, s;
    l ? (s = {
      "DenseMatrix, DenseMatrix": (h, p) => n(...Or(h, p), l),
      "Array, Array": (h, p) => n(...Or(o(h), o(p)), l).valueOf(),
      "Array, DenseMatrix": (h, p) => n(...Or(o(h), p), l),
      "DenseMatrix, Array": (h, p) => n(...Or(h, o(p)), l)
    }, u.SS && (s["SparseMatrix, SparseMatrix"] = (h, p) => u.SS(...Or(h, p), l, !1)), u.DS && (s["DenseMatrix, SparseMatrix"] = (h, p) => u.DS(...Or(h, p), l, !1), s["Array, SparseMatrix"] = (h, p) => u.DS(...Or(o(h), p), l, !1)), f && (s["SparseMatrix, DenseMatrix"] = (h, p) => f(...Or(p, h), l, !0), s["SparseMatrix, Array"] = (h, p) => f(...Or(o(p), h), l, !0))) : (s = {
      "DenseMatrix, DenseMatrix": r.referToSelf((h) => (p, v) => n(...Or(p, v), h)),
      "Array, Array": r.referToSelf((h) => (p, v) => n(...Or(o(p), o(v)), h).valueOf()),
      "Array, DenseMatrix": r.referToSelf((h) => (p, v) => n(...Or(o(p), v), h)),
      "DenseMatrix, Array": r.referToSelf((h) => (p, v) => n(...Or(p, o(v)), h))
    }, u.SS && (s["SparseMatrix, SparseMatrix"] = r.referToSelf((h) => (p, v) => u.SS(...Or(p, v), h, !1))), u.DS && (s["DenseMatrix, SparseMatrix"] = r.referToSelf((h) => (p, v) => u.DS(...Or(p, v), h, !1)), s["Array, SparseMatrix"] = r.referToSelf((h) => (p, v) => u.DS(...Or(o(p), v), h, !1))), f && (s["SparseMatrix, DenseMatrix"] = r.referToSelf((h) => (p, v) => f(...Or(v, p), h, !0)), s["SparseMatrix, Array"] = r.referToSelf((h) => (p, v) => f(...Or(o(v), p), h, !0))));
    var a = u.scalar || "any", c = u.Ds || u.Ss;
    c && (l ? (s["DenseMatrix," + a] = (h, p) => i(h, p, l, !1), s[a + ", DenseMatrix"] = (h, p) => i(p, h, l, !0), s["Array," + a] = (h, p) => i(o(h), p, l, !1).valueOf(), s[a + ", Array"] = (h, p) => i(o(p), h, l, !0).valueOf()) : (s["DenseMatrix," + a] = r.referToSelf((h) => (p, v) => i(p, v, h, !1)), s[a + ", DenseMatrix"] = r.referToSelf((h) => (p, v) => i(v, p, h, !0)), s["Array," + a] = r.referToSelf((h) => (p, v) => i(o(p), v, h, !1).valueOf()), s[a + ", Array"] = r.referToSelf((h) => (p, v) => i(o(v), p, h, !0).valueOf())));
    var d = u.sS !== void 0 ? u.sS : u.Ss;
    return l ? (u.Ss && (s["SparseMatrix," + a] = (h, p) => u.Ss(h, p, l, !1)), d && (s[a + ", SparseMatrix"] = (h, p) => d(p, h, l, !0))) : (u.Ss && (s["SparseMatrix," + a] = r.referToSelf((h) => (p, v) => u.Ss(p, v, h, !1))), d && (s[a + ", SparseMatrix"] = r.referToSelf((h) => (p, v) => d(v, p, h, !0)))), l && l.signatures && l1(s, l.signatures), s;
  };
}), bl = "mod", w4 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], kg = /* @__PURE__ */ Q(bl, w4, (e) => {
  var {
    typed: r,
    config: o,
    round: n,
    matrix: i,
    equalScalar: t,
    zeros: u,
    DenseMatrix: l,
    concat: f
  } = e, s = Ug({
    typed: r,
    config: o,
    round: n,
    matrix: i,
    equalScalar: t,
    zeros: u,
    DenseMatrix: l
  }), a = At({
    typed: r,
    equalScalar: t
  }), c = Kr({
    typed: r
  }), d = io({
    typed: r,
    equalScalar: t
  }), h = Lr({
    typed: r,
    equalScalar: t
  }), p = Ir({
    typed: r,
    DenseMatrix: l
  }), v = lr({
    typed: r,
    matrix: i,
    concat: f
  });
  return r(bl, {
    "number, number": g,
    "BigNumber, BigNumber": function(x, y) {
      return y.isZero() ? x : x.sub(y.mul(s(x.div(y))));
    },
    "bigint, bigint": function(x, y) {
      if (y === 0n)
        return x;
      if (x < 0) {
        var E = x % y;
        return E === 0n ? E : E + y;
      }
      return x % y;
    },
    "Fraction, Fraction": function(x, y) {
      return y.equals(0) ? x : x.sub(y.mul(s(x.div(y))));
    }
  }, v({
    SS: d,
    DS: c,
    SD: a,
    Ss: h,
    sS: p
  }));
  function g(m, x) {
    return x === 0 ? m : m - x * s(m / x);
  }
}), x4 = "matAlgo01xDSid", E4 = ["typed"], fn = /* @__PURE__ */ Q(x4, E4, (e) => {
  var {
    typed: r
  } = e;
  return function(n, i, t, u) {
    var l = n._data, f = n._size, s = n._datatype || n.getDataType(), a = i._values, c = i._index, d = i._ptr, h = i._size, p = i._datatype || i._data === void 0 ? i._datatype : i.getDataType();
    if (f.length !== h.length)
      throw new We(f.length, h.length);
    if (f[0] !== h[0] || f[1] !== h[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + f + ") must match Matrix B (" + h + ")");
    if (!a)
      throw new Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");
    var v = f[0], g = f[1], m = typeof s == "string" && s !== "mixed" && s === p ? s : void 0, x = m ? r.find(t, [m, m]) : t, y, E, N = [];
    for (y = 0; y < v; y++)
      N[y] = [];
    var S = [], R = [];
    for (E = 0; E < g; E++) {
      for (var O = E + 1, B = d[E], $ = d[E + 1], F = B; F < $; F++)
        y = c[F], S[y] = u ? x(a[F], l[y][E]) : x(l[y][E], a[F]), R[y] = O;
      for (y = 0; y < v; y++)
        R[y] === O ? N[y][E] = S[y] : N[y][E] = l[y][E];
    }
    return n.createDenseMatrix({
      data: N,
      size: [v, g],
      datatype: s === n._datatype && p === i._datatype ? m : void 0
    });
  };
}), A4 = "matAlgo04xSidSid", S4 = ["typed", "equalScalar"], qf = /* @__PURE__ */ Q(A4, S4, (e) => {
  var {
    typed: r,
    equalScalar: o
  } = e;
  return function(i, t, u) {
    var l = i._values, f = i._index, s = i._ptr, a = i._size, c = i._datatype || i._data === void 0 ? i._datatype : i.getDataType(), d = t._values, h = t._index, p = t._ptr, v = t._size, g = t._datatype || t._data === void 0 ? t._datatype : t.getDataType();
    if (a.length !== v.length)
      throw new We(a.length, v.length);
    if (a[0] !== v[0] || a[1] !== v[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + v + ")");
    var m = a[0], x = a[1], y, E = o, N = 0, S = u;
    typeof c == "string" && c === g && c !== "mixed" && (y = c, E = r.find(o, [y, y]), N = r.convert(0, y), S = r.find(u, [y, y]));
    var R = l && d ? [] : void 0, O = [], B = [], $ = l && d ? [] : void 0, F = l && d ? [] : void 0, w = [], A = [], b, D, M, _, q;
    for (D = 0; D < x; D++) {
      B[D] = O.length;
      var C = D + 1;
      for (_ = s[D], q = s[D + 1], M = _; M < q; M++)
        b = f[M], O.push(b), w[b] = C, $ && ($[b] = l[M]);
      for (_ = p[D], q = p[D + 1], M = _; M < q; M++)
        if (b = h[M], w[b] === C) {
          if ($) {
            var T = S($[b], d[M]);
            E(T, N) ? w[b] = null : $[b] = T;
          }
        } else
          O.push(b), A[b] = C, F && (F[b] = d[M]);
      if ($ && F)
        for (M = B[D]; M < O.length; )
          b = O[M], w[b] === C ? (R[M] = $[b], M++) : A[b] === C ? (R[M] = F[b], M++) : O.splice(M, 1);
    }
    return B[x] = O.length, i.createSparseMatrix({
      values: R,
      index: O,
      ptr: B,
      size: [m, x],
      datatype: c === i._datatype && g === t._datatype ? y : void 0
    });
  };
}), D4 = "matAlgo10xSids", N4 = ["typed", "DenseMatrix"], Dn = /* @__PURE__ */ Q(D4, N4, (e) => {
  var {
    typed: r,
    DenseMatrix: o
  } = e;
  return function(i, t, u, l) {
    var f = i._values, s = i._index, a = i._ptr, c = i._size, d = i._datatype;
    if (!f)
      throw new Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");
    var h = c[0], p = c[1], v, g = u;
    typeof d == "string" && (v = d, t = r.convert(t, v), g = r.find(u, [v, v]));
    for (var m = [], x = [], y = [], E = 0; E < p; E++) {
      for (var N = E + 1, S = a[E], R = a[E + 1], O = S; O < R; O++) {
        var B = s[O];
        x[B] = f[O], y[B] = N;
      }
      for (var $ = 0; $ < h; $++)
        E === 0 && (m[$] = []), y[$] === N ? m[$][E] = l ? g(t, x[$]) : g(x[$], t) : m[$][E] = t;
    }
    return new o({
      data: m,
      size: [h, p],
      datatype: v
    });
  };
});
function Zt(e, r, o, n) {
  if (!(this instanceof Zt))
    throw new SyntaxError("Constructor must be called with the new operator");
  this.fn = e, this.count = r, this.min = o, this.max = n, this.message = "Wrong number of arguments in function " + e + " (" + r + " provided, " + o + (n != null ? "-" + n : "") + " expected)", this.stack = new Error().stack;
}
Zt.prototype = new Error();
Zt.prototype.constructor = Error;
Zt.prototype.name = "ArgumentsError";
Zt.prototype.isArgumentsError = !0;
var yl = "gcd", M4 = ["typed", "config", "round", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix", "concat"], wo = "number | BigNumber | Fraction | Matrix | Array", _4 = "".concat(wo, ", ").concat(wo, ", ...").concat(wo);
function wl(e) {
  return !e.some((r) => Array.isArray(r));
}
var C4 = /* @__PURE__ */ Q(yl, M4, (e) => {
  var {
    typed: r,
    matrix: o,
    config: n,
    round: i,
    equalScalar: t,
    zeros: u,
    BigNumber: l,
    DenseMatrix: f,
    concat: s
  } = e, a = kg({
    typed: r,
    config: n,
    round: i,
    matrix: o,
    equalScalar: t,
    zeros: u,
    DenseMatrix: f,
    concat: s
  }), c = fn({
    typed: r
  }), d = qf({
    typed: r,
    equalScalar: t
  }), h = Dn({
    typed: r,
    DenseMatrix: f
  }), p = lr({
    typed: r,
    matrix: o,
    concat: s
  });
  return r(yl, {
    "number, number": v,
    "BigNumber, BigNumber": g,
    "Fraction, Fraction": (m, x) => m.gcd(x)
  }, p({
    SS: d,
    DS: c,
    Ss: h
  }), {
    [_4]: r.referToSelf((m) => (x, y, E) => {
      for (var N = m(x, y), S = 0; S < E.length; S++)
        N = m(N, E[S]);
      return N;
    }),
    Array: r.referToSelf((m) => (x) => {
      if (x.length === 1 && Array.isArray(x[0]) && wl(x[0]))
        return m(...x[0]);
      if (wl(x))
        return m(...x);
      throw new Zt("gcd() supports only 1d matrices!");
    }),
    Matrix: r.referToSelf((m) => (x) => m(x.toArray()))
  });
  function v(m, x) {
    if (!Te(m) || !Te(x))
      throw new Error("Parameters in function gcd must be integer numbers");
    for (var y; x !== 0; )
      y = a(m, x), m = x, x = y;
    return m < 0 ? -m : m;
  }
  function g(m, x) {
    if (!m.isInt() || !x.isInt())
      throw new Error("Parameters in function gcd must be integer numbers");
    for (var y = new l(0); !x.isZero(); ) {
      var E = a(m, x);
      m = x, x = E;
    }
    return m.lt(y) ? m.neg() : m;
  }
}), T4 = "matAlgo06xS0S0", B4 = ["typed", "equalScalar"], ao = /* @__PURE__ */ Q(T4, B4, (e) => {
  var {
    typed: r,
    equalScalar: o
  } = e;
  return function(i, t, u) {
    var l = i._values, f = i._size, s = i._datatype || i._data === void 0 ? i._datatype : i.getDataType(), a = t._values, c = t._size, d = t._datatype || t._data === void 0 ? t._datatype : t.getDataType();
    if (f.length !== c.length)
      throw new We(f.length, c.length);
    if (f[0] !== c[0] || f[1] !== c[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + f + ") must match Matrix B (" + c + ")");
    var h = f[0], p = f[1], v, g = o, m = 0, x = u;
    typeof s == "string" && s === d && s !== "mixed" && (v = s, g = r.find(o, [v, v]), m = r.convert(0, v), x = r.find(u, [v, v]));
    for (var y = l && a ? [] : void 0, E = [], N = [], S = y ? [] : void 0, R = [], O = [], B = 0; B < p; B++) {
      N[B] = E.length;
      var $ = B + 1;
      if (Gc(i, B, R, S, O, $, E, x), Gc(t, B, R, S, O, $, E, x), S)
        for (var F = N[B]; F < E.length; ) {
          var w = E[F];
          if (O[w] === $) {
            var A = S[w];
            g(A, m) ? E.splice(F, 1) : (y.push(A), F++);
          } else
            E.splice(F, 1);
        }
      else
        for (var b = N[B]; b < E.length; ) {
          var D = E[b];
          O[D] !== $ ? E.splice(b, 1) : b++;
        }
    }
    return N[p] = E.length, i.createSparseMatrix({
      values: y,
      index: E,
      ptr: N,
      size: [h, p],
      datatype: s === i._datatype && d === t._datatype ? v : void 0
    });
  };
}), xl = "lcm", F4 = ["typed", "matrix", "equalScalar", "concat"], I4 = /* @__PURE__ */ Q(xl, F4, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    concat: i
  } = e, t = At({
    typed: r,
    equalScalar: n
  }), u = ao({
    typed: r,
    equalScalar: n
  }), l = Lr({
    typed: r,
    equalScalar: n
  }), f = lr({
    typed: r,
    matrix: o,
    concat: i
  }), s = "number | BigNumber | Fraction | Matrix | Array", a = {};
  return a["".concat(s, ", ").concat(s, ", ...").concat(s)] = r.referToSelf((d) => (h, p, v) => {
    for (var g = d(h, p), m = 0; m < v.length; m++)
      g = d(g, v[m]);
    return g;
  }), r(xl, {
    "number, number": ag,
    "BigNumber, BigNumber": c,
    "Fraction, Fraction": (d, h) => d.lcm(h)
  }, f({
    SS: u,
    DS: t,
    Ss: l
  }), a);
  function c(d, h) {
    if (!d.isInt() || !h.isInt())
      throw new Error("Parameters in function lcm must be integer numbers");
    if (d.isZero())
      return d;
    if (h.isZero())
      return h;
    for (var p = d.times(h); !h.isZero(); ) {
      var v = h;
      h = d.mod(v), d = v;
    }
    return p.div(d).abs();
  }
}), El = "log10", O4 = ["typed", "config", "Complex"], R4 = /* @__PURE__ */ Q(El, O4, (e) => {
  var {
    typed: r,
    config: o,
    Complex: n
  } = e;
  return r(El, {
    number: function(t) {
      return t >= 0 || o.predictable ? og(t) : new n(t, 0).log().div(Math.LN10);
    },
    Complex: function(t) {
      return new n(t).log().div(Math.LN10);
    },
    BigNumber: function(t) {
      return !t.isNegative() || o.predictable ? t.log() : new n(t.toNumber(), 0).log().div(Math.LN10);
    },
    "Array | Matrix": r.referToSelf((i) => (t) => Ke(t, i))
  });
}), Al = "log2", P4 = ["typed", "config", "Complex"], q4 = /* @__PURE__ */ Q(Al, P4, (e) => {
  var {
    typed: r,
    config: o,
    Complex: n
  } = e;
  return r(Al, {
    number: function(u) {
      return u >= 0 || o.predictable ? sg(u) : i(new n(u, 0));
    },
    Complex: i,
    BigNumber: function(u) {
      return !u.isNegative() || o.predictable ? u.log(2) : i(new n(u.toNumber(), 0));
    },
    "Array | Matrix": r.referToSelf((t) => (u) => Ke(u, t))
  });
  function i(t) {
    var u = Math.sqrt(t.re * t.re + t.im * t.im);
    return new n(Math.log2 ? Math.log2(u) : Math.log(u) / Math.LN2, Math.atan2(t.im, t.re) / Math.LN2);
  }
}), $4 = "multiplyScalar", z4 = ["typed"], L4 = /* @__PURE__ */ Q($4, z4, (e) => {
  var {
    typed: r
  } = e;
  return r("multiplyScalar", {
    "number, number": Q1,
    "Complex, Complex": function(n, i) {
      return n.mul(i);
    },
    "BigNumber, BigNumber": function(n, i) {
      return n.times(i);
    },
    "bigint, bigint": function(n, i) {
      return n * i;
    },
    "Fraction, Fraction": function(n, i) {
      return n.mul(i);
    },
    "number | Fraction | BigNumber | Complex, Unit": (o, n) => n.multiply(o),
    "Unit, number | Fraction | BigNumber | Complex | Unit": (o, n) => o.multiply(n)
  });
}), Sl = "multiply", U4 = ["typed", "matrix", "addScalar", "multiplyScalar", "equalScalar", "dot"], k4 = /* @__PURE__ */ Q(Sl, U4, (e) => {
  var {
    typed: r,
    matrix: o,
    addScalar: n,
    multiplyScalar: i,
    equalScalar: t,
    dot: u
  } = e, l = Lr({
    typed: r,
    equalScalar: t
  }), f = Et({
    typed: r
  });
  function s(N, S) {
    switch (N.length) {
      case 1:
        switch (S.length) {
          case 1:
            if (N[0] !== S[0])
              throw new RangeError("Dimension mismatch in multiplication. Vectors must have the same length");
            break;
          case 2:
            if (N[0] !== S[0])
              throw new RangeError("Dimension mismatch in multiplication. Vector length (" + N[0] + ") must match Matrix rows (" + S[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + S.length + " dimensions)");
        }
        break;
      case 2:
        switch (S.length) {
          case 1:
            if (N[1] !== S[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix columns (" + N[1] + ") must match Vector length (" + S[0] + ")");
            break;
          case 2:
            if (N[1] !== S[0])
              throw new RangeError("Dimension mismatch in multiplication. Matrix A columns (" + N[1] + ") must match Matrix B rows (" + S[0] + ")");
            break;
          default:
            throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has " + S.length + " dimensions)");
        }
        break;
      default:
        throw new Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has " + N.length + " dimensions)");
    }
  }
  function a(N, S, R) {
    if (R === 0)
      throw new Error("Cannot multiply two empty vectors");
    return u(N, S);
  }
  function c(N, S) {
    if (S.storage() !== "dense")
      throw new Error("Support for SparseMatrix not implemented");
    return d(N, S);
  }
  function d(N, S) {
    var R = N._data, O = N._size, B = N._datatype || N.getDataType(), $ = S._data, F = S._size, w = S._datatype || S.getDataType(), A = O[0], b = F[1], D, M = n, _ = i;
    B && w && B === w && typeof B == "string" && B !== "mixed" && (D = B, M = r.find(n, [D, D]), _ = r.find(i, [D, D]));
    for (var q = [], C = 0; C < b; C++) {
      for (var T = _(R[0], $[0][C]), z = 1; z < A; z++)
        T = M(T, _(R[z], $[z][C]));
      q[C] = T;
    }
    return N.createDenseMatrix({
      data: q,
      size: [b],
      datatype: B === N._datatype && w === S._datatype ? D : void 0
    });
  }
  var h = r("_multiplyMatrixVector", {
    "DenseMatrix, any": v,
    "SparseMatrix, any": x
  }), p = r("_multiplyMatrixMatrix", {
    "DenseMatrix, DenseMatrix": g,
    "DenseMatrix, SparseMatrix": m,
    "SparseMatrix, DenseMatrix": y,
    "SparseMatrix, SparseMatrix": E
  });
  function v(N, S) {
    var R = N._data, O = N._size, B = N._datatype || N.getDataType(), $ = S._data, F = S._datatype || S.getDataType(), w = O[0], A = O[1], b, D = n, M = i;
    B && F && B === F && typeof B == "string" && B !== "mixed" && (b = B, D = r.find(n, [b, b]), M = r.find(i, [b, b]));
    for (var _ = [], q = 0; q < w; q++) {
      for (var C = R[q], T = M(C[0], $[0]), z = 1; z < A; z++)
        T = D(T, M(C[z], $[z]));
      _[q] = T;
    }
    return N.createDenseMatrix({
      data: _,
      size: [w],
      datatype: B === N._datatype && F === S._datatype ? b : void 0
    });
  }
  function g(N, S) {
    var R = N._data, O = N._size, B = N._datatype || N.getDataType(), $ = S._data, F = S._size, w = S._datatype || S.getDataType(), A = O[0], b = O[1], D = F[1], M, _ = n, q = i;
    B && w && B === w && typeof B == "string" && B !== "mixed" && B !== "mixed" && (M = B, _ = r.find(n, [M, M]), q = r.find(i, [M, M]));
    for (var C = [], T = 0; T < A; T++) {
      var z = R[T];
      C[T] = [];
      for (var I = 0; I < D; I++) {
        for (var U = q(z[0], $[0][I]), ee = 1; ee < b; ee++)
          U = _(U, q(z[ee], $[ee][I]));
        C[T][I] = U;
      }
    }
    return N.createDenseMatrix({
      data: C,
      size: [A, D],
      datatype: B === N._datatype && w === S._datatype ? M : void 0
    });
  }
  function m(N, S) {
    var R = N._data, O = N._size, B = N._datatype || N.getDataType(), $ = S._values, F = S._index, w = S._ptr, A = S._size, b = S._datatype || S._data === void 0 ? S._datatype : S.getDataType();
    if (!$)
      throw new Error("Cannot multiply Dense Matrix times Pattern only Matrix");
    var D = O[0], M = A[1], _, q = n, C = i, T = t, z = 0;
    B && b && B === b && typeof B == "string" && B !== "mixed" && (_ = B, q = r.find(n, [_, _]), C = r.find(i, [_, _]), T = r.find(t, [_, _]), z = r.convert(0, _));
    for (var I = [], U = [], ee = [], se = S.createSparseMatrix({
      values: I,
      index: U,
      ptr: ee,
      size: [D, M],
      datatype: B === N._datatype && b === S._datatype ? _ : void 0
    }), K = 0; K < M; K++) {
      ee[K] = U.length;
      var J = w[K], te = w[K + 1];
      if (te > J)
        for (var ne = 0, ue = 0; ue < D; ue++) {
          for (var V = ue + 1, W = void 0, fe = J; fe < te; fe++) {
            var pe = F[fe];
            ne !== V ? (W = C(R[ue][pe], $[fe]), ne = V) : W = q(W, C(R[ue][pe], $[fe]));
          }
          ne === V && !T(W, z) && (U.push(ue), I.push(W));
        }
    }
    return ee[M] = U.length, se;
  }
  function x(N, S) {
    var R = N._values, O = N._index, B = N._ptr, $ = N._datatype || N._data === void 0 ? N._datatype : N.getDataType();
    if (!R)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var F = S._data, w = S._datatype || S.getDataType(), A = N._size[0], b = S._size[0], D = [], M = [], _ = [], q, C = n, T = i, z = t, I = 0;
    $ && w && $ === w && typeof $ == "string" && $ !== "mixed" && (q = $, C = r.find(n, [q, q]), T = r.find(i, [q, q]), z = r.find(t, [q, q]), I = r.convert(0, q));
    var U = [], ee = [];
    _[0] = 0;
    for (var se = 0; se < b; se++) {
      var K = F[se];
      if (!z(K, I))
        for (var J = B[se], te = B[se + 1], ne = J; ne < te; ne++) {
          var ue = O[ne];
          ee[ue] ? U[ue] = C(U[ue], T(K, R[ne])) : (ee[ue] = !0, M.push(ue), U[ue] = T(K, R[ne]));
        }
    }
    for (var V = M.length, W = 0; W < V; W++) {
      var fe = M[W];
      D[W] = U[fe];
    }
    return _[1] = M.length, N.createSparseMatrix({
      values: D,
      index: M,
      ptr: _,
      size: [A, 1],
      datatype: $ === N._datatype && w === S._datatype ? q : void 0
    });
  }
  function y(N, S) {
    var R = N._values, O = N._index, B = N._ptr, $ = N._datatype || N._data === void 0 ? N._datatype : N.getDataType();
    if (!R)
      throw new Error("Cannot multiply Pattern only Matrix times Dense Matrix");
    var F = S._data, w = S._datatype || S.getDataType(), A = N._size[0], b = S._size[0], D = S._size[1], M, _ = n, q = i, C = t, T = 0;
    $ && w && $ === w && typeof $ == "string" && $ !== "mixed" && (M = $, _ = r.find(n, [M, M]), q = r.find(i, [M, M]), C = r.find(t, [M, M]), T = r.convert(0, M));
    for (var z = [], I = [], U = [], ee = N.createSparseMatrix({
      values: z,
      index: I,
      ptr: U,
      size: [A, D],
      datatype: $ === N._datatype && w === S._datatype ? M : void 0
    }), se = [], K = [], J = 0; J < D; J++) {
      U[J] = I.length;
      for (var te = J + 1, ne = 0; ne < b; ne++) {
        var ue = F[ne][J];
        if (!C(ue, T))
          for (var V = B[ne], W = B[ne + 1], fe = V; fe < W; fe++) {
            var pe = O[fe];
            K[pe] !== te ? (K[pe] = te, I.push(pe), se[pe] = q(ue, R[fe])) : se[pe] = _(se[pe], q(ue, R[fe]));
          }
      }
      for (var Y = U[J], k = I.length, L = Y; L < k; L++) {
        var P = I[L];
        z[L] = se[P];
      }
    }
    return U[D] = I.length, ee;
  }
  function E(N, S) {
    var R = N._values, O = N._index, B = N._ptr, $ = N._datatype || N._data === void 0 ? N._datatype : N.getDataType(), F = S._values, w = S._index, A = S._ptr, b = S._datatype || S._data === void 0 ? S._datatype : S.getDataType(), D = N._size[0], M = S._size[1], _ = R && F, q, C = n, T = i;
    $ && b && $ === b && typeof $ == "string" && $ !== "mixed" && (q = $, C = r.find(n, [q, q]), T = r.find(i, [q, q]));
    for (var z = _ ? [] : void 0, I = [], U = [], ee = N.createSparseMatrix({
      values: z,
      index: I,
      ptr: U,
      size: [D, M],
      datatype: $ === N._datatype && b === S._datatype ? q : void 0
    }), se = _ ? [] : void 0, K = [], J, te, ne, ue, V, W, fe, pe, Y = 0; Y < M; Y++) {
      U[Y] = I.length;
      var k = Y + 1;
      for (V = A[Y], W = A[Y + 1], ue = V; ue < W; ue++)
        if (pe = w[ue], _)
          for (te = B[pe], ne = B[pe + 1], J = te; J < ne; J++)
            fe = O[J], K[fe] !== k ? (K[fe] = k, I.push(fe), se[fe] = T(F[ue], R[J])) : se[fe] = C(se[fe], T(F[ue], R[J]));
        else
          for (te = B[pe], ne = B[pe + 1], J = te; J < ne; J++)
            fe = O[J], K[fe] !== k && (K[fe] = k, I.push(fe));
      if (_)
        for (var L = U[Y], P = I.length, G = L; G < P; G++) {
          var j = I[G];
          z[G] = se[j];
        }
    }
    return U[M] = I.length, ee;
  }
  return r(Sl, i, {
    // we extend the signatures of multiplyScalar with signatures dealing with matrices
    "Array, Array": r.referTo("Matrix, Matrix", (N) => (S, R) => {
      s(ze(S), ze(R));
      var O = N(o(S), o(R));
      return Fe(O) ? O.valueOf() : O;
    }),
    "Matrix, Matrix": function(S, R) {
      var O = S.size(), B = R.size();
      return s(O, B), O.length === 1 ? B.length === 1 ? a(S, R, O[0]) : c(S, R) : B.length === 1 ? h(S, R) : p(S, R);
    },
    "Matrix, Array": r.referTo("Matrix,Matrix", (N) => (S, R) => N(S, o(R))),
    "Array, Matrix": r.referToSelf((N) => (S, R) => N(o(S, R.storage()), R)),
    "SparseMatrix, any": function(S, R) {
      return l(S, R, i, !1);
    },
    "DenseMatrix, any": function(S, R) {
      return f(S, R, i, !1);
    },
    "any, SparseMatrix": function(S, R) {
      return l(R, S, i, !0);
    },
    "any, DenseMatrix": function(S, R) {
      return f(R, S, i, !0);
    },
    "Array, any": function(S, R) {
      return f(o(S), R, i, !1).valueOf();
    },
    "any, Array": function(S, R) {
      return f(o(R), S, i, !0).valueOf();
    },
    "any, any": i,
    "any, any, ...any": r.referToSelf((N) => (S, R, O) => {
      for (var B = N(S, R), $ = 0; $ < O.length; $++)
        B = N(B, O[$]);
      return B;
    })
  });
}), Dl = "nthRoot", H4 = ["typed", "matrix", "equalScalar", "BigNumber", "concat"], G4 = /* @__PURE__ */ Q(Dl, H4, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    BigNumber: i,
    concat: t
  } = e, u = fn({
    typed: r
  }), l = At({
    typed: r,
    equalScalar: n
  }), f = ao({
    typed: r,
    equalScalar: n
  }), s = Lr({
    typed: r,
    equalScalar: n
  }), a = lr({
    typed: r,
    matrix: o,
    concat: t
  });
  function c() {
    throw new Error("Complex number not supported in function nthRoot. Use nthRoots instead.");
  }
  return r(Dl, {
    number: Wc,
    "number, number": Wc,
    BigNumber: (h) => d(h, new i(2)),
    "BigNumber, BigNumber": d,
    Complex: c,
    "Complex, number": c,
    Array: r.referTo("DenseMatrix,number", (h) => (p) => h(o(p), 2).valueOf()),
    DenseMatrix: r.referTo("DenseMatrix,number", (h) => (p) => h(p, 2)),
    SparseMatrix: r.referTo("SparseMatrix,number", (h) => (p) => h(p, 2)),
    "SparseMatrix, SparseMatrix": r.referToSelf((h) => (p, v) => {
      if (v.density() === 1)
        return f(p, v, h);
      throw new Error("Root must be non-zero");
    }),
    "DenseMatrix, SparseMatrix": r.referToSelf((h) => (p, v) => {
      if (v.density() === 1)
        return u(p, v, h, !1);
      throw new Error("Root must be non-zero");
    }),
    "Array, SparseMatrix": r.referTo("DenseMatrix,SparseMatrix", (h) => (p, v) => h(o(p), v)),
    "number | BigNumber, SparseMatrix": r.referToSelf((h) => (p, v) => {
      if (v.density() === 1)
        return s(v, p, h, !0);
      throw new Error("Root must be non-zero");
    })
  }, a({
    scalar: "number | BigNumber",
    SD: l,
    Ss: s,
    sS: !1
  }));
  function d(h, p) {
    var v = i.precision, g = i.clone({
      precision: v + 2
    }), m = new i(0), x = new g(1), y = p.isNegative();
    if (y && (p = p.neg()), p.isZero())
      throw new Error("Root must be non-zero");
    if (h.isNegative() && !p.abs().mod(2).equals(1))
      throw new Error("Root must be odd when a is negative.");
    if (h.isZero())
      return y ? new g(1 / 0) : 0;
    if (!h.isFinite())
      return y ? m : h;
    var E = h.abs().pow(x.div(p));
    return E = h.isNeg() ? E.neg() : E, new i((y ? x.div(E) : E).toPrecision(v));
  }
}), Nl = "sign", V4 = ["typed", "BigNumber", "Fraction", "complex"], W4 = /* @__PURE__ */ Q(Nl, V4, (e) => {
  var {
    typed: r,
    BigNumber: o,
    complex: n,
    Fraction: i
  } = e;
  return r(Nl, {
    number: Hu,
    Complex: function(u) {
      return u.im === 0 ? n(Hu(u.re)) : u.sign();
    },
    BigNumber: function(u) {
      return new o(u.cmp(0));
    },
    bigint: function(u) {
      return u > 0n ? 1n : u < 0n ? -1n : 0n;
    },
    Fraction: function(u) {
      return new i(u.s, 1);
    },
    // deep map collection, skip zeros since sign(0) = 0
    "Array | Matrix": r.referToSelf((t) => (u) => Ke(u, t)),
    Unit: r.referToSelf((t) => (u) => {
      if (!u._isDerived() && u.units[0].unit.offset !== 0)
        throw new TypeError("sign is ambiguous for units with offset");
      return r.find(t, u.valueType())(u.value);
    })
  });
}), K4 = "sqrt", Z4 = ["config", "typed", "Complex"], j4 = /* @__PURE__ */ Q(K4, Z4, (e) => {
  var {
    config: r,
    typed: o,
    Complex: n
  } = e;
  return o("sqrt", {
    number: i,
    Complex: function(u) {
      return u.sqrt();
    },
    BigNumber: function(u) {
      return !u.isNegative() || r.predictable ? u.sqrt() : i(u.toNumber());
    },
    Unit: function(u) {
      return u.pow(0.5);
    }
  });
  function i(t) {
    return isNaN(t) ? NaN : t >= 0 || r.predictable ? Math.sqrt(t) : new n(t, 0).sqrt();
  }
}), Ml = "square", Y4 = ["typed"], X4 = /* @__PURE__ */ Q(Ml, Y4, (e) => {
  var {
    typed: r
  } = e;
  return r(Ml, {
    number: ug,
    Complex: function(n) {
      return n.mul(n);
    },
    BigNumber: function(n) {
      return n.times(n);
    },
    bigint: function(n) {
      return n * n;
    },
    Fraction: function(n) {
      return n.mul(n);
    },
    Unit: function(n) {
      return n.pow(2);
    }
  });
}), _l = "subtract", J4 = ["typed", "matrix", "equalScalar", "subtractScalar", "unaryMinus", "DenseMatrix", "concat"], Q4 = /* @__PURE__ */ Q(_l, J4, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    subtractScalar: i,
    unaryMinus: t,
    DenseMatrix: u,
    concat: l
  } = e, f = fn({
    typed: r
  }), s = Kr({
    typed: r
  }), a = io({
    typed: r,
    equalScalar: n
  }), c = Dn({
    typed: r,
    DenseMatrix: u
  }), d = Ir({
    typed: r,
    DenseMatrix: u
  }), h = lr({
    typed: r,
    matrix: o,
    concat: l
  });
  return r(_l, {
    "any, any": i
  }, h({
    elop: i,
    SS: a,
    DS: f,
    SD: s,
    Ss: d,
    sS: c
  }));
}), Cl = "xgcd", e6 = ["typed", "config", "matrix", "BigNumber"], r6 = /* @__PURE__ */ Q(Cl, e6, (e) => {
  var {
    typed: r,
    config: o,
    matrix: n,
    BigNumber: i
  } = e;
  return r(Cl, {
    "number, number": function(l, f) {
      var s = fg(l, f);
      return o.matrix === "Array" ? s : n(s);
    },
    "BigNumber, BigNumber": t
    // TODO: implement support for Fraction
  });
  function t(u, l) {
    var f, s, a, c = new i(0), d = new i(1), h = c, p = d, v = d, g = c;
    if (!u.isInt() || !l.isInt())
      throw new Error("Parameters in function xgcd must be integer numbers");
    for (; !l.isZero(); )
      s = u.div(l).floor(), a = u.mod(l), f = h, h = p.minus(s.times(h)), p = f, f = v, v = g.minus(s.times(v)), g = f, u = l, l = a;
    var m;
    return u.lt(c) ? m = [u.neg(), p.neg(), g.neg()] : m = [u, u.isZero() ? 0 : p, g], o.matrix === "Array" ? m : n(m);
  }
}), Tl = "invmod", t6 = ["typed", "config", "BigNumber", "xgcd", "equal", "smaller", "mod", "add", "isInteger"], n6 = /* @__PURE__ */ Q(Tl, t6, (e) => {
  var {
    typed: r,
    config: o,
    BigNumber: n,
    xgcd: i,
    equal: t,
    smaller: u,
    mod: l,
    add: f,
    isInteger: s
  } = e;
  return r(Tl, {
    "number, number": a,
    "BigNumber, BigNumber": a
  });
  function a(c, d) {
    if (!s(c) || !s(d))
      throw new Error("Parameters in function invmod must be integer numbers");
    if (c = l(c, d), t(d, 0))
      throw new Error("Divisor must be non zero");
    var h = i(c, d);
    h = h.valueOf();
    var [p, v] = h;
    return t(p, n(1)) ? (v = l(v, d), u(v, n(0)) && (v = f(v, d)), v) : NaN;
  }
}), i6 = "matAlgo09xS0Sf", a6 = ["typed", "equalScalar"], Hg = /* @__PURE__ */ Q(i6, a6, (e) => {
  var {
    typed: r,
    equalScalar: o
  } = e;
  return function(i, t, u) {
    var l = i._values, f = i._index, s = i._ptr, a = i._size, c = i._datatype || i._data === void 0 ? i._datatype : i.getDataType(), d = t._values, h = t._index, p = t._ptr, v = t._size, g = t._datatype || t._data === void 0 ? t._datatype : t.getDataType();
    if (a.length !== v.length)
      throw new We(a.length, v.length);
    if (a[0] !== v[0] || a[1] !== v[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + v + ")");
    var m = a[0], x = a[1], y, E = o, N = 0, S = u;
    typeof c == "string" && c === g && c !== "mixed" && (y = c, E = r.find(o, [y, y]), N = r.convert(0, y), S = r.find(u, [y, y]));
    var R = l && d ? [] : void 0, O = [], B = [], $ = R ? [] : void 0, F = [], w, A, b, D, M;
    for (A = 0; A < x; A++) {
      B[A] = O.length;
      var _ = A + 1;
      if ($)
        for (D = p[A], M = p[A + 1], b = D; b < M; b++)
          w = h[b], F[w] = _, $[w] = d[b];
      for (D = s[A], M = s[A + 1], b = D; b < M; b++)
        if (w = f[b], $) {
          var q = F[w] === _ ? $[w] : N, C = S(l[b], q);
          E(C, N) || (O.push(w), R.push(C));
        } else
          O.push(w);
    }
    return B[x] = O.length, i.createSparseMatrix({
      values: R,
      index: O,
      ptr: B,
      size: [m, x],
      datatype: c === i._datatype && g === t._datatype ? y : void 0
    });
  };
}), Bl = "dotMultiply", o6 = ["typed", "matrix", "equalScalar", "multiplyScalar", "concat"], s6 = /* @__PURE__ */ Q(Bl, o6, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    multiplyScalar: i,
    concat: t
  } = e, u = At({
    typed: r,
    equalScalar: n
  }), l = Hg({
    typed: r,
    equalScalar: n
  }), f = Lr({
    typed: r,
    equalScalar: n
  }), s = lr({
    typed: r,
    matrix: o,
    concat: t
  });
  return r(Bl, s({
    elop: i,
    SS: l,
    DS: u,
    Ss: f
  }));
});
function u6(e, r) {
  if (e.isFinite() && !e.isInteger() || r.isFinite() && !r.isInteger())
    throw new Error("Integers expected in function bitAnd");
  var o = e.constructor;
  if (e.isNaN() || r.isNaN())
    return new o(NaN);
  if (e.isZero() || r.eq(-1) || e.eq(r))
    return e;
  if (r.isZero() || e.eq(-1))
    return r;
  if (!e.isFinite() || !r.isFinite()) {
    if (!e.isFinite() && !r.isFinite())
      return e.isNegative() === r.isNegative() ? e : new o(0);
    if (!e.isFinite())
      return r.isNegative() ? e : e.isNegative() ? new o(0) : r;
    if (!r.isFinite())
      return e.isNegative() ? r : r.isNegative() ? new o(0) : e;
  }
  return $f(e, r, function(n, i) {
    return n & i;
  });
}
function xi(e) {
  if (e.isFinite() && !e.isInteger())
    throw new Error("Integer expected in function bitNot");
  var r = e.constructor, o = r.precision;
  r.config({
    precision: 1e9
  });
  var n = e.plus(new r(1));
  return n.s = -n.s || null, r.config({
    precision: o
  }), n;
}
function f6(e, r) {
  if (e.isFinite() && !e.isInteger() || r.isFinite() && !r.isInteger())
    throw new Error("Integers expected in function bitOr");
  var o = e.constructor;
  if (e.isNaN() || r.isNaN())
    return new o(NaN);
  var n = new o(-1);
  return e.isZero() || r.eq(n) || e.eq(r) ? r : r.isZero() || e.eq(n) ? e : !e.isFinite() || !r.isFinite() ? !e.isFinite() && !e.isNegative() && r.isNegative() || e.isNegative() && !r.isNegative() && !r.isFinite() ? n : e.isNegative() && r.isNegative() ? e.isFinite() ? e : r : e.isFinite() ? r : e : $f(e, r, function(i, t) {
    return i | t;
  });
}
function $f(e, r, o) {
  var n = e.constructor, i, t, u = +(e.s < 0), l = +(r.s < 0);
  if (u) {
    i = Li(xi(e));
    for (var f = 0; f < i.length; ++f)
      i[f] ^= 1;
  } else
    i = Li(e);
  if (l) {
    t = Li(xi(r));
    for (var s = 0; s < t.length; ++s)
      t[s] ^= 1;
  } else
    t = Li(r);
  var a, c, d;
  i.length <= t.length ? (a = i, c = t, d = u) : (a = t, c = i, d = l);
  var h = a.length, p = c.length, v = o(u, l) ^ 1, g = new n(v ^ 1), m = new n(1), x = new n(2), y = n.precision;
  for (n.config({
    precision: 1e9
  }); h > 0; )
    o(a[--h], c[--p]) === v && (g = g.plus(m)), m = m.times(x);
  for (; p > 0; )
    o(d, c[--p]) === v && (g = g.plus(m)), m = m.times(x);
  return n.config({
    precision: y
  }), v === 0 && (g.s = -g.s), g;
}
function Li(e) {
  for (var r = e.d, o = r[0] + "", n = 1; n < r.length; ++n) {
    for (var i = r[n] + "", t = 7 - i.length; t--; )
      i = "0" + i;
    o += i;
  }
  for (var u = o.length; o.charAt(u) === "0"; )
    u--;
  var l = e.e, f = o.slice(0, u + 1 || 1), s = f.length;
  if (l > 0)
    if (++l > s)
      for (l -= s; l--; )
        f += "0";
    else
      l < s && (f = f.slice(0, l) + "." + f.slice(l));
  for (var a = [0], c = 0; c < f.length; ) {
    for (var d = a.length; d--; )
      a[d] *= 10;
    a[0] += parseInt(f.charAt(c++));
    for (var h = 0; h < a.length; ++h)
      a[h] > 1 && ((a[h + 1] === null || a[h + 1] === void 0) && (a[h + 1] = 0), a[h + 1] += a[h] >> 1, a[h] &= 1);
  }
  return a.reverse();
}
function c6(e, r) {
  if (e.isFinite() && !e.isInteger() || r.isFinite() && !r.isInteger())
    throw new Error("Integers expected in function bitXor");
  var o = e.constructor;
  if (e.isNaN() || r.isNaN())
    return new o(NaN);
  if (e.isZero())
    return r;
  if (r.isZero())
    return e;
  if (e.eq(r))
    return new o(0);
  var n = new o(-1);
  return e.eq(n) ? xi(r) : r.eq(n) ? xi(e) : !e.isFinite() || !r.isFinite() ? !e.isFinite() && !r.isFinite() ? n : new o(e.isNegative() === r.isNegative() ? 1 / 0 : -1 / 0) : $f(e, r, function(i, t) {
    return i ^ t;
  });
}
function l6(e, r) {
  if (e.isFinite() && !e.isInteger() || r.isFinite() && !r.isInteger())
    throw new Error("Integers expected in function leftShift");
  var o = e.constructor;
  return e.isNaN() || r.isNaN() || r.isNegative() && !r.isZero() ? new o(NaN) : e.isZero() || r.isZero() ? e : !e.isFinite() && !r.isFinite() ? new o(NaN) : r.lt(55) ? e.times(Math.pow(2, r.toNumber()) + "") : e.times(new o(2).pow(r));
}
function d6(e, r) {
  if (e.isFinite() && !e.isInteger() || r.isFinite() && !r.isInteger())
    throw new Error("Integers expected in function rightArithShift");
  var o = e.constructor;
  return e.isNaN() || r.isNaN() || r.isNegative() && !r.isZero() ? new o(NaN) : e.isZero() || r.isZero() ? e : r.isFinite() ? r.lt(55) ? e.div(Math.pow(2, r.toNumber()) + "").floor() : e.div(new o(2).pow(r)).floor() : e.isNegative() ? new o(-1) : e.isFinite() ? new o(0) : new o(NaN);
}
var Fl = "bitAnd", h6 = ["typed", "matrix", "equalScalar", "concat"], Gg = /* @__PURE__ */ Q(Fl, h6, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    concat: i
  } = e, t = At({
    typed: r,
    equalScalar: n
  }), u = ao({
    typed: r,
    equalScalar: n
  }), l = Lr({
    typed: r,
    equalScalar: n
  }), f = lr({
    typed: r,
    matrix: o,
    concat: i
  });
  return r(Fl, {
    "number, number": lg,
    "BigNumber, BigNumber": u6,
    "bigint, bigint": (s, a) => s & a
  }, f({
    SS: u,
    DS: t,
    Ss: l
  }));
}), Il = "bitNot", p6 = ["typed"], v6 = /* @__PURE__ */ Q(Il, p6, (e) => {
  var {
    typed: r
  } = e;
  return r(Il, {
    number: dg,
    BigNumber: xi,
    bigint: (o) => ~o,
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o))
  });
}), Ol = "bitOr", m6 = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], Vg = /* @__PURE__ */ Q(Ol, m6, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    DenseMatrix: i,
    concat: t
  } = e, u = fn({
    typed: r
  }), l = qf({
    typed: r,
    equalScalar: n
  }), f = Dn({
    typed: r,
    DenseMatrix: i
  }), s = lr({
    typed: r,
    matrix: o,
    concat: t
  });
  return r(Ol, {
    "number, number": hg,
    "BigNumber, BigNumber": f6,
    "bigint, bigint": (a, c) => a | c
  }, s({
    SS: l,
    DS: u,
    Ss: f
  }));
}), g6 = "matAlgo07xSSf", b6 = ["typed", "DenseMatrix"], Mt = /* @__PURE__ */ Q(g6, b6, (e) => {
  var {
    typed: r,
    DenseMatrix: o
  } = e;
  return function(t, u, l) {
    var f = t._size, s = t._datatype || t._data === void 0 ? t._datatype : t.getDataType(), a = u._size, c = u._datatype || u._data === void 0 ? u._datatype : u.getDataType();
    if (f.length !== a.length)
      throw new We(f.length, a.length);
    if (f[0] !== a[0] || f[1] !== a[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + f + ") must match Matrix B (" + a + ")");
    var d = f[0], h = f[1], p, v = 0, g = l;
    typeof s == "string" && s === c && s !== "mixed" && (p = s, v = r.convert(0, p), g = r.find(l, [p, p]));
    var m, x, y = [];
    for (m = 0; m < d; m++)
      y[m] = [];
    var E = [], N = [], S = [], R = [];
    for (x = 0; x < h; x++) {
      var O = x + 1;
      for (n(t, x, S, E, O), n(u, x, R, N, O), m = 0; m < d; m++) {
        var B = S[m] === O ? E[m] : v, $ = R[m] === O ? N[m] : v;
        y[m][x] = g(B, $);
      }
    }
    return new o({
      data: y,
      size: [d, h],
      datatype: s === t._datatype && c === u._datatype ? p : void 0
    });
  };
  function n(i, t, u, l, f) {
    for (var s = i._values, a = i._index, c = i._ptr, d = c[t], h = c[t + 1]; d < h; d++) {
      var p = a[d];
      u[p] = f, l[p] = s[d];
    }
  }
}), Rl = "bitXor", y6 = ["typed", "matrix", "DenseMatrix", "concat"], w6 = /* @__PURE__ */ Q(Rl, y6, (e) => {
  var {
    typed: r,
    matrix: o,
    DenseMatrix: n,
    concat: i
  } = e, t = Kr({
    typed: r
  }), u = Mt({
    typed: r,
    DenseMatrix: n
  }), l = Ir({
    typed: r,
    DenseMatrix: n
  }), f = lr({
    typed: r,
    matrix: o,
    concat: i
  });
  return r(Rl, {
    "number, number": pg,
    "BigNumber, BigNumber": c6,
    "bigint, bigint": (s, a) => s ^ a
  }, f({
    SS: u,
    DS: t,
    Ss: l
  }));
}), Pl = "arg", x6 = ["typed"], E6 = /* @__PURE__ */ Q(Pl, x6, (e) => {
  var {
    typed: r
  } = e;
  return r(Pl, {
    number: function(n) {
      return Math.atan2(0, n);
    },
    BigNumber: function(n) {
      return n.constructor.atan2(0, n);
    },
    Complex: function(n) {
      return n.arg();
    },
    // TODO: implement BigNumber support for function arg
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o))
  });
}), ql = "conj", A6 = ["typed"], S6 = /* @__PURE__ */ Q(ql, A6, (e) => {
  var {
    typed: r
  } = e;
  return r(ql, {
    "number | BigNumber | Fraction": (o) => o,
    Complex: (o) => o.conjugate(),
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o))
  });
}), $l = "im", D6 = ["typed"], N6 = /* @__PURE__ */ Q($l, D6, (e) => {
  var {
    typed: r
  } = e;
  return r($l, {
    number: () => 0,
    "BigNumber | Fraction": (o) => o.mul(0),
    Complex: (o) => o.im,
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o))
  });
}), zl = "re", M6 = ["typed"], _6 = /* @__PURE__ */ Q(zl, M6, (e) => {
  var {
    typed: r
  } = e;
  return r(zl, {
    "number | BigNumber | Fraction": (o) => o,
    Complex: (o) => o.re,
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o))
  });
}), Ll = "not", C6 = ["typed"], T6 = /* @__PURE__ */ Q(Ll, C6, (e) => {
  var {
    typed: r
  } = e;
  return r(Ll, {
    "null | undefined": () => !0,
    number: yg,
    Complex: function(n) {
      return n.re === 0 && n.im === 0;
    },
    BigNumber: function(n) {
      return n.isZero() || n.isNaN();
    },
    bigint: (o) => !o,
    Unit: r.referToSelf((o) => (n) => r.find(o, n.valueType())(n.value)),
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o))
  });
}), Ul = "or", B6 = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], Wg = /* @__PURE__ */ Q(Ul, B6, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    DenseMatrix: i,
    concat: t
  } = e, u = Kr({
    typed: r
  }), l = io({
    typed: r,
    equalScalar: n
  }), f = Ir({
    typed: r,
    DenseMatrix: i
  }), s = lr({
    typed: r,
    matrix: o,
    concat: t
  });
  return r(Ul, {
    "number, number": Gu,
    "Complex, Complex": function(c, d) {
      return c.re !== 0 || c.im !== 0 || d.re !== 0 || d.im !== 0;
    },
    "BigNumber, BigNumber": function(c, d) {
      return !c.isZero() && !c.isNaN() || !d.isZero() && !d.isNaN();
    },
    "bigint, bigint": Gu,
    "Unit, Unit": r.referToSelf((a) => (c, d) => a(c.value || 0, d.value || 0))
  }, s({
    SS: l,
    DS: u,
    Ss: f
  }));
}), kl = "xor", F6 = ["typed", "matrix", "DenseMatrix", "concat"], I6 = /* @__PURE__ */ Q(kl, F6, (e) => {
  var {
    typed: r,
    matrix: o,
    DenseMatrix: n,
    concat: i
  } = e, t = Kr({
    typed: r
  }), u = Mt({
    typed: r,
    DenseMatrix: n
  }), l = Ir({
    typed: r,
    DenseMatrix: n
  }), f = lr({
    typed: r,
    matrix: o,
    concat: i
  });
  return r(kl, {
    "number, number": Vu,
    "Complex, Complex": function(a, c) {
      return (a.re !== 0 || a.im !== 0) != (c.re !== 0 || c.im !== 0);
    },
    "bigint, bigint": Vu,
    "BigNumber, BigNumber": function(a, c) {
      return (!a.isZero() && !a.isNaN()) != (!c.isZero() && !c.isNaN());
    },
    "Unit, Unit": r.referToSelf((s) => (a, c) => s(a.value || 0, c.value || 0))
  }, f({
    SS: u,
    DS: t,
    Ss: l
  }));
}), Hl = "concat", O6 = ["typed", "matrix", "isInteger"], Kg = /* @__PURE__ */ Q(Hl, O6, (e) => {
  var {
    typed: r,
    matrix: o,
    isInteger: n
  } = e;
  return r(Hl, {
    // TODO: change signature to '...Array | Matrix, dim?' when supported
    "...Array | Matrix | number | BigNumber": function(t) {
      var u, l = t.length, f = -1, s, a = !1, c = [];
      for (u = 0; u < l; u++) {
        var d = t[u];
        if (Fe(d) && (a = !0), $e(d) || Re(d)) {
          if (u !== l - 1)
            throw new Error("Dimension must be specified as last argument");
          if (s = f, f = d.valueOf(), !n(f))
            throw new TypeError("Integer number expected for dimension");
          if (f < 0 || u > 0 && f > s)
            throw new dt(f, s + 1);
        } else {
          var h = Ie(d).valueOf(), p = ze(h);
          if (c[u] = h, s = f, f = p.length - 1, u > 0 && f !== s)
            throw new We(s + 1, f + 1);
        }
      }
      if (c.length === 0)
        throw new SyntaxError("At least one matrix expected");
      for (var v = c.shift(); c.length; )
        v = V1(v, c.shift(), f);
      return a ? o(v) : v;
    },
    "...string": function(t) {
      return t.join("");
    }
  });
}), Gl = "column", R6 = ["typed", "Index", "matrix", "range"], Zg = /* @__PURE__ */ Q(Gl, R6, (e) => {
  var {
    typed: r,
    Index: o,
    matrix: n,
    range: i
  } = e;
  return r(Gl, {
    "Matrix, number": t,
    "Array, number": function(l, f) {
      return t(n(Ie(l)), f).valueOf();
    }
  });
  function t(u, l) {
    if (u.size().length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    sr(l, u.size()[1]);
    var f = i(0, u.size()[0]), s = new o(f, l), a = u.subset(s);
    return Fe(a) ? a : n([[a]]);
  }
}), Vl = "count", P6 = ["typed", "size", "prod"], q6 = /* @__PURE__ */ Q(Vl, P6, (e) => {
  var {
    typed: r,
    size: o,
    prod: n
  } = e;
  return r(Vl, {
    string: function(t) {
      return t.length;
    },
    "Matrix | Array": function(t) {
      return n(o(t));
    }
  });
}), Wl = "cross", $6 = ["typed", "matrix", "subtract", "multiply"], z6 = /* @__PURE__ */ Q(Wl, $6, (e) => {
  var {
    typed: r,
    matrix: o,
    subtract: n,
    multiply: i
  } = e;
  return r(Wl, {
    "Matrix, Matrix": function(l, f) {
      return o(t(l.toArray(), f.toArray()));
    },
    "Matrix, Array": function(l, f) {
      return o(t(l.toArray(), f));
    },
    "Array, Matrix": function(l, f) {
      return o(t(l, f.toArray()));
    },
    "Array, Array": t
  });
  function t(u, l) {
    var f = Math.max(ze(u).length, ze(l).length);
    u = Na(u), l = Na(l);
    var s = ze(u), a = ze(l);
    if (s.length !== 1 || a.length !== 1 || s[0] !== 3 || a[0] !== 3)
      throw new RangeError("Vectors with length 3 expected (Size A = [" + s.join(", ") + "], B = [" + a.join(", ") + "])");
    var c = [n(i(u[1], l[2]), i(u[2], l[1])), n(i(u[2], l[0]), i(u[0], l[2])), n(i(u[0], l[1]), i(u[1], l[0]))];
    return f > 1 ? [c] : c;
  }
}), Kl = "diag", L6 = ["typed", "matrix", "DenseMatrix", "SparseMatrix"], U6 = /* @__PURE__ */ Q(Kl, L6, (e) => {
  var {
    typed: r,
    matrix: o,
    DenseMatrix: n,
    SparseMatrix: i
  } = e;
  return r(Kl, {
    // FIXME: simplify this huge amount of signatures as soon as typed-function supports optional arguments
    Array: function(s) {
      return t(s, 0, ze(s), null);
    },
    "Array, number": function(s, a) {
      return t(s, a, ze(s), null);
    },
    "Array, BigNumber": function(s, a) {
      return t(s, a.toNumber(), ze(s), null);
    },
    "Array, string": function(s, a) {
      return t(s, 0, ze(s), a);
    },
    "Array, number, string": function(s, a, c) {
      return t(s, a, ze(s), c);
    },
    "Array, BigNumber, string": function(s, a, c) {
      return t(s, a.toNumber(), ze(s), c);
    },
    Matrix: function(s) {
      return t(s, 0, s.size(), s.storage());
    },
    "Matrix, number": function(s, a) {
      return t(s, a, s.size(), s.storage());
    },
    "Matrix, BigNumber": function(s, a) {
      return t(s, a.toNumber(), s.size(), s.storage());
    },
    "Matrix, string": function(s, a) {
      return t(s, 0, s.size(), a);
    },
    "Matrix, number, string": function(s, a, c) {
      return t(s, a, s.size(), c);
    },
    "Matrix, BigNumber, string": function(s, a, c) {
      return t(s, a.toNumber(), s.size(), c);
    }
  });
  function t(f, s, a, c) {
    if (!Te(s))
      throw new TypeError("Second parameter in function diag must be an integer");
    var d = s > 0 ? s : 0, h = s < 0 ? -s : 0;
    switch (a.length) {
      case 1:
        return u(f, s, c, a[0], h, d);
      case 2:
        return l(f, s, c, a, h, d);
    }
    throw new RangeError("Matrix for function diag must be 2 dimensional");
  }
  function u(f, s, a, c, d, h) {
    var p = [c + d, c + h];
    if (a && a !== "sparse" && a !== "dense")
      throw new TypeError("Unknown matrix type ".concat(a, '"'));
    var v = a === "sparse" ? i.diagonal(p, f, s) : n.diagonal(p, f, s);
    return a !== null ? v : v.valueOf();
  }
  function l(f, s, a, c, d, h) {
    if (Fe(f)) {
      var p = f.diagonal(s);
      return a !== null ? a !== p.storage() ? o(p, a) : p : p.valueOf();
    }
    for (var v = Math.min(c[0] - d, c[1] - h), g = [], m = 0; m < v; m++)
      g[m] = f[m + d][m + h];
    return a !== null ? o(g) : g;
  }
});
function ri(e, r, o, n, i) {
  if (wn.isTypedFunction(e)) {
    var t = [r, o, n], u = wn.resolve(e, t);
    if (u)
      return c(u.implementation, t);
    var l = [r, o], f = wn.resolve(e, l);
    if (f)
      return c(f.implementation, l);
    var s = [r], a = wn.resolve(e, s);
    return a ? c(a.implementation, s) : c(e, t);
  } else
    return e(r, o, n);
  function c(d, h) {
    try {
      return d.apply(d, h);
    } catch (g) {
      var p;
      if (g instanceof TypeError && ((p = g.data) === null || p === void 0 ? void 0 : p.category) === "wrongType") {
        var v = [];
        throw v.push("value: ".concat(fr(r))), h.length >= 2 && v.push("index: ".concat(fr(o))), h.length >= 3 && v.push("array: ".concat(fr(n))), new TypeError("Function ".concat(i, " cannot apply callback arguments ") + "".concat(e.name, "(").concat(v.join(", "), ") at index ").concat(JSON.stringify(o)));
      } else
        throw new TypeError("Function ".concat(i, " cannot apply callback arguments ") + "to function ".concat(e.name, ": ").concat(g.message));
    }
  }
}
var k6 = "filter", H6 = ["typed"], G6 = /* @__PURE__ */ Q(k6, H6, (e) => {
  var {
    typed: r
  } = e;
  return r("filter", {
    "Array, function": Zl,
    "Matrix, function": function(n, i) {
      return n.create(Zl(n.toArray(), i));
    },
    "Array, RegExp": Ma,
    "Matrix, RegExp": function(n, i) {
      return n.create(Ma(n.toArray(), i));
    }
  });
});
function Zl(e, r) {
  return H1(e, function(o, n, i) {
    return ri(r, o, [n], i, "filter");
  });
}
var jl = "flatten", V6 = ["typed", "matrix"], W6 = /* @__PURE__ */ Q(jl, V6, (e) => {
  var {
    typed: r,
    matrix: o
  } = e;
  return r(jl, {
    Array: function(i) {
      return ir(i);
    },
    Matrix: function(i) {
      var t = ir(i.toArray());
      return o(t);
    }
  });
}), Yl = "forEach", K6 = ["typed"], Z6 = /* @__PURE__ */ Q(Yl, K6, (e) => {
  var {
    typed: r
  } = e;
  return r(Yl, {
    "Array, function": j6,
    "Matrix, function": function(n, i) {
      n.forEach(i);
    }
  });
});
function j6(e, r) {
  var o = function n(i, t) {
    if (Array.isArray(i))
      to(i, function(u, l) {
        n(u, t.concat(l));
      });
    else
      return ri(r, i, t, e, "forEach");
  };
  o(e, []);
}
var Xl = "getMatrixDataType", Y6 = ["typed"], X6 = /* @__PURE__ */ Q(Xl, Y6, (e) => {
  var {
    typed: r
  } = e;
  return r(Xl, {
    Array: function(n) {
      return wi(n, fr);
    },
    Matrix: function(n) {
      return n.getDataType();
    }
  });
}), Jl = "identity", J6 = ["typed", "config", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix"], Q6 = /* @__PURE__ */ Q(Jl, J6, (e) => {
  var {
    typed: r,
    config: o,
    matrix: n,
    BigNumber: i,
    DenseMatrix: t,
    SparseMatrix: u
  } = e;
  return r(Jl, {
    "": function() {
      return o.matrix === "Matrix" ? n([]) : [];
    },
    string: function(a) {
      return n(a);
    },
    "number | BigNumber": function(a) {
      return f(a, a, o.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, string": function(a, c) {
      return f(a, a, c);
    },
    "number | BigNumber, number | BigNumber": function(a, c) {
      return f(a, c, o.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber, number | BigNumber, string": function(a, c, d) {
      return f(a, c, d);
    },
    Array: function(a) {
      return l(a);
    },
    "Array, string": function(a, c) {
      return l(a, c);
    },
    Matrix: function(a) {
      return l(a.valueOf(), a.storage());
    },
    "Matrix, string": function(a, c) {
      return l(a.valueOf(), c);
    }
  });
  function l(s, a) {
    switch (s.length) {
      case 0:
        return a ? n(a) : [];
      case 1:
        return f(s[0], s[0], a);
      case 2:
        return f(s[0], s[1], a);
      default:
        throw new Error("Vector containing two values expected");
    }
  }
  function f(s, a, c) {
    var d = Re(s) || Re(a) ? i : null;
    if (Re(s) && (s = s.toNumber()), Re(a) && (a = a.toNumber()), !Te(s) || s < 1)
      throw new Error("Parameters in function identity must be positive integers");
    if (!Te(a) || a < 1)
      throw new Error("Parameters in function identity must be positive integers");
    var h = d ? new i(1) : 1, p = d ? new d(0) : 0, v = [s, a];
    if (c) {
      if (c === "sparse")
        return u.diagonal(v, h, 0, p);
      if (c === "dense")
        return t.diagonal(v, h, 0, p);
      throw new TypeError('Unknown matrix type "'.concat(c, '"'));
    }
    for (var g = Gn([], v, p), m = s < a ? s : a, x = 0; x < m; x++)
      g[x][x] = h;
    return g;
  }
}), Ql = "kron", e8 = ["typed", "matrix", "multiplyScalar"], r8 = /* @__PURE__ */ Q(Ql, e8, (e) => {
  var {
    typed: r,
    matrix: o,
    multiplyScalar: n
  } = e;
  return r(Ql, {
    "Matrix, Matrix": function(u, l) {
      return o(i(u.toArray(), l.toArray()));
    },
    "Matrix, Array": function(u, l) {
      return o(i(u.toArray(), l));
    },
    "Array, Matrix": function(u, l) {
      return o(i(u, l.toArray()));
    },
    "Array, Array": i
  });
  function i(t, u) {
    if (ze(t).length === 1 && (t = [t]), ze(u).length === 1 && (u = [u]), ze(t).length > 2 || ze(u).length > 2)
      throw new RangeError("Vectors with dimensions greater then 2 are not supported expected (Size x = " + JSON.stringify(t.length) + ", y = " + JSON.stringify(u.length) + ")");
    var l = [], f = [];
    return t.map(function(s) {
      return u.map(function(a) {
        return f = [], l.push(f), s.map(function(c) {
          return a.map(function(d) {
            return f.push(n(c, d));
          });
        });
      });
    }) && l;
  }
}), ed = "map", t8 = ["typed"], n8 = /* @__PURE__ */ Q(ed, t8, (e) => {
  var {
    typed: r
  } = e;
  return r(ed, {
    "Array, function": i8,
    "Matrix, function": function(n, i) {
      return n.map(i);
    }
  });
});
function i8(e, r) {
  var o = function n(i, t) {
    return Array.isArray(i) ? i.map(function(u, l) {
      return n(u, t.concat(l));
    }) : ri(r, i, t, e, "map");
  };
  return o(e, []);
}
var rd = "diff", a8 = ["typed", "matrix", "subtract", "number"], jg = /* @__PURE__ */ Q(rd, a8, (e) => {
  var {
    typed: r,
    matrix: o,
    subtract: n,
    number: i
  } = e;
  return r(rd, {
    "Array | Matrix": function(a) {
      return Fe(a) ? o(u(a.toArray())) : u(a);
    },
    "Array | Matrix, number": function(a, c) {
      if (!Te(c))
        throw new RangeError("Dimension must be a whole number");
      return Fe(a) ? o(t(a.toArray(), c)) : t(a, c);
    },
    "Array, BigNumber": r.referTo("Array,number", (s) => (a, c) => s(a, i(c))),
    "Matrix, BigNumber": r.referTo("Matrix,number", (s) => (a, c) => s(a, i(c)))
  });
  function t(s, a) {
    if (Fe(s) && (s = s.toArray()), !Array.isArray(s))
      throw RangeError("Array/Matrix does not have that many dimensions");
    if (a > 0) {
      var c = [];
      return s.forEach((d) => {
        c.push(t(d, a - 1));
      }), c;
    } else {
      if (a === 0)
        return u(s);
      throw RangeError("Cannot have negative dimension");
    }
  }
  function u(s) {
    for (var a = [], c = s.length, d = 1; d < c; d++)
      a.push(l(s[d - 1], s[d]));
    return a;
  }
  function l(s, a) {
    Fe(s) && (s = s.toArray()), Fe(a) && (a = a.toArray());
    var c = Array.isArray(s), d = Array.isArray(a);
    if (c && d)
      return f(s, a);
    if (!c && !d)
      return n(a, s);
    throw TypeError("Cannot calculate difference between 1 array and 1 non-array");
  }
  function f(s, a) {
    if (s.length !== a.length)
      throw RangeError("Not all sub-arrays have the same length");
    for (var c = [], d = s.length, h = 0; h < d; h++)
      c.push(l(s[h], a[h]));
    return c;
  }
}), o8 = "ones", s8 = ["typed", "config", "matrix", "BigNumber"], u8 = /* @__PURE__ */ Q(o8, s8, (e) => {
  var {
    typed: r,
    config: o,
    matrix: n,
    BigNumber: i
  } = e;
  return r("ones", {
    "": function() {
      return o.matrix === "Array" ? t([]) : t([], "default");
    },
    // math.ones(m, n, p, ..., format)
    // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
    "...number | BigNumber | string": function(s) {
      var a = s[s.length - 1];
      if (typeof a == "string") {
        var c = s.pop();
        return t(s, c);
      } else
        return o.matrix === "Array" ? t(s) : t(s, "default");
    },
    Array: t,
    Matrix: function(s) {
      var a = s.storage();
      return t(s.valueOf(), a);
    },
    "Array | Matrix, string": function(s, a) {
      return t(s.valueOf(), a);
    }
  });
  function t(f, s) {
    var a = u(f), c = a ? new i(1) : 1;
    if (l(f), s) {
      var d = n(s);
      return f.length > 0 ? d.resize(f, c) : d;
    } else {
      var h = [];
      return f.length > 0 ? Gn(h, f, c) : h;
    }
  }
  function u(f) {
    var s = !1;
    return f.forEach(function(a, c, d) {
      Re(a) && (s = !0, d[c] = a.toNumber());
    }), s;
  }
  function l(f) {
    f.forEach(function(s) {
      if (typeof s != "number" || !Te(s) || s < 0)
        throw new Error("Parameters in function ones must be positive integers");
    });
  }
});
function zf() {
  throw new Error('No "bignumber" implementation available');
}
function Yg() {
  throw new Error('No "fraction" implementation available');
}
function Xg() {
  throw new Error('No "matrix" implementation available');
}
var td = "range", f8 = ["typed", "config", "?matrix", "?bignumber", "smaller", "smallerEq", "larger", "largerEq", "add", "isPositive"], Jg = /* @__PURE__ */ Q(td, f8, (e) => {
  var {
    typed: r,
    config: o,
    matrix: n,
    bignumber: i,
    smaller: t,
    smallerEq: u,
    larger: l,
    largerEq: f,
    add: s,
    isPositive: a
  } = e;
  return r(td, {
    // TODO: simplify signatures when typed-function supports default values and optional arguments
    // TODO: a number or boolean should not be converted to string here
    string: d,
    "string, boolean": d,
    "number, number": function(g, m) {
      return c(h(g, m, 1, !1));
    },
    "number, number, number": function(g, m, x) {
      return c(h(g, m, x, !1));
    },
    "number, number, boolean": function(g, m, x) {
      return c(h(g, m, 1, x));
    },
    "number, number, number, boolean": function(g, m, x, y) {
      return c(h(g, m, x, y));
    },
    "BigNumber, BigNumber": function(g, m) {
      var x = g.constructor;
      return c(h(g, m, new x(1), !1));
    },
    "BigNumber, BigNumber, BigNumber": function(g, m, x) {
      return c(h(g, m, x, !1));
    },
    "BigNumber, BigNumber, boolean": function(g, m, x) {
      var y = g.constructor;
      return c(h(g, m, new y(1), x));
    },
    "BigNumber, BigNumber, BigNumber, boolean": function(g, m, x, y) {
      return c(h(g, m, x, y));
    },
    "Unit, Unit, Unit": function(g, m, x) {
      return c(h(g, m, x, !1));
    },
    "Unit, Unit, Unit, boolean": function(g, m, x, y) {
      return c(h(g, m, x, y));
    }
  });
  function c(v) {
    return o.matrix === "Matrix" ? n ? n(v) : Xg() : v;
  }
  function d(v, g) {
    var m = p(v);
    if (!m)
      throw new SyntaxError('String "' + v + '" is no valid range');
    return o.number === "BigNumber" ? (i === void 0 && zf(), c(h(i(m.start), i(m.end), i(m.step)))) : c(h(m.start, m.end, m.step, g));
  }
  function h(v, g, m, x) {
    for (var y = [], E = a(m) ? x ? u : t : x ? f : l, N = v; E(N, g); )
      y.push(N), N = s(N, m);
    return y;
  }
  function p(v) {
    var g = v.split(":"), m = g.map(function(y) {
      return Number(y);
    }), x = m.some(function(y) {
      return isNaN(y);
    });
    if (x)
      return null;
    switch (m.length) {
      case 2:
        return {
          start: m[0],
          end: m[1],
          step: 1
        };
      case 3:
        return {
          start: m[0],
          end: m[2],
          step: m[1]
        };
      default:
        return null;
    }
  }
}), nd = "reshape", c8 = ["typed", "isInteger", "matrix"], l8 = /* @__PURE__ */ Q(nd, c8, (e) => {
  var {
    typed: r,
    isInteger: o
  } = e;
  return r(nd, {
    "Matrix, Array": function(i, t) {
      return i.reshape(t, !0);
    },
    "Array, Array": function(i, t) {
      return t.forEach(function(u) {
        if (!o(u))
          throw new TypeError("Invalid size for dimension: " + u);
      }), Ff(i, t);
    }
  });
}), d8 = "resize", h8 = ["config", "matrix"], p8 = /* @__PURE__ */ Q(d8, h8, (e) => {
  var {
    config: r,
    matrix: o
  } = e;
  return function(t, u, l) {
    if (arguments.length !== 2 && arguments.length !== 3)
      throw new Zt("resize", arguments.length, 2, 3);
    if (Fe(u) && (u = u.valueOf()), Re(u[0]) && (u = u.map(function(a) {
      return Re(a) ? a.toNumber() : a;
    })), Fe(t))
      return t.resize(u, l, !0);
    if (typeof t == "string")
      return n(t, u, l);
    var f = Array.isArray(t) ? !1 : r.matrix !== "Array";
    if (u.length === 0) {
      for (; Array.isArray(t); )
        t = t[0];
      return Ie(t);
    } else {
      Array.isArray(t) || (t = [t]), t = Ie(t);
      var s = Gn(t, u, l);
      return f ? o(s) : s;
    }
  };
  function n(i, t, u) {
    if (u !== void 0) {
      if (typeof u != "string" || u.length !== 1)
        throw new TypeError("Single character expected as defaultValue");
    } else
      u = " ";
    if (t.length !== 1)
      throw new We(t.length, 1);
    var l = t[0];
    if (typeof l != "number" || !Te(l))
      throw new TypeError("Invalid size, must contain positive integers (size: " + Ze(t) + ")");
    if (i.length > l)
      return i.substring(0, l);
    if (i.length < l) {
      for (var f = i, s = 0, a = l - i.length; s < a; s++)
        f += u;
      return f;
    } else
      return i;
  }
}), id = "rotate", v8 = ["typed", "multiply", "rotationMatrix"], m8 = /* @__PURE__ */ Q(id, v8, (e) => {
  var {
    typed: r,
    multiply: o,
    rotationMatrix: n
  } = e;
  return r(id, {
    "Array , number | BigNumber | Complex | Unit": function(u, l) {
      i(u, 2);
      var f = o(n(l), u);
      return f.toArray();
    },
    "Matrix , number | BigNumber | Complex | Unit": function(u, l) {
      return i(u, 2), o(n(l), u);
    },
    "Array, number | BigNumber | Complex | Unit, Array | Matrix": function(u, l, f) {
      i(u, 3);
      var s = o(n(l, f), u);
      return s;
    },
    "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function(u, l, f) {
      return i(u, 3), o(n(l, f), u);
    }
  });
  function i(t, u) {
    var l = Array.isArray(t) ? ze(t) : t.size();
    if (l.length > 2)
      throw new RangeError("Vector must be of dimensions 1x".concat(u));
    if (l.length === 2 && l[1] !== 1)
      throw new RangeError("Vector must be of dimensions 1x".concat(u));
    if (l[0] !== u)
      throw new RangeError("Vector must be of dimensions 1x".concat(u));
  }
}), ad = "rotationMatrix", g8 = ["typed", "config", "multiplyScalar", "addScalar", "unaryMinus", "norm", "matrix", "BigNumber", "DenseMatrix", "SparseMatrix", "cos", "sin"], b8 = /* @__PURE__ */ Q(ad, g8, (e) => {
  var {
    typed: r,
    config: o,
    multiplyScalar: n,
    addScalar: i,
    unaryMinus: t,
    norm: u,
    BigNumber: l,
    matrix: f,
    DenseMatrix: s,
    SparseMatrix: a,
    cos: c,
    sin: d
  } = e;
  return r(ad, {
    "": function() {
      return o.matrix === "Matrix" ? f([]) : [];
    },
    string: function(y) {
      return f(y);
    },
    "number | BigNumber | Complex | Unit": function(y) {
      return h(y, o.matrix === "Matrix" ? "dense" : void 0);
    },
    "number | BigNumber | Complex | Unit, string": function(y, E) {
      return h(y, E);
    },
    "number | BigNumber | Complex | Unit, Array": function(y, E) {
      var N = f(E);
      return p(N), m(y, N, void 0);
    },
    "number | BigNumber | Complex | Unit, Matrix": function(y, E) {
      p(E);
      var N = E.storage() || (o.matrix === "Matrix" ? "dense" : void 0);
      return m(y, E, N);
    },
    "number | BigNumber | Complex | Unit, Array, string": function(y, E, N) {
      var S = f(E);
      return p(S), m(y, S, N);
    },
    "number | BigNumber | Complex | Unit, Matrix, string": function(y, E, N) {
      return p(E), m(y, E, N);
    }
  });
  function h(x, y) {
    var E = Re(x), N = E ? new l(-1) : -1, S = c(x), R = d(x), O = [[S, n(N, R)], [R, S]];
    return g(O, y);
  }
  function p(x) {
    var y = x.size();
    if (y.length < 1 || y[0] !== 3)
      throw new RangeError("Vector must be of dimensions 1x3");
  }
  function v(x) {
    return x.reduce((y, E) => n(y, E));
  }
  function g(x, y) {
    if (y) {
      if (y === "sparse")
        return new a(x);
      if (y === "dense")
        return new s(x);
      throw new TypeError('Unknown matrix type "'.concat(y, '"'));
    }
    return x;
  }
  function m(x, y, E) {
    var N = u(y);
    if (N === 0)
      throw new RangeError("Rotation around zero vector");
    var S = Re(x) ? l : null, R = S ? new S(1) : 1, O = S ? new S(-1) : -1, B = S ? new S(y.get([0]) / N) : y.get([0]) / N, $ = S ? new S(y.get([1]) / N) : y.get([1]) / N, F = S ? new S(y.get([2]) / N) : y.get([2]) / N, w = c(x), A = i(R, t(w)), b = d(x), D = i(w, v([B, B, A])), M = i(v([B, $, A]), v([O, F, b])), _ = i(v([B, F, A]), v([$, b])), q = i(v([B, $, A]), v([F, b])), C = i(w, v([$, $, A])), T = i(v([$, F, A]), v([O, B, b])), z = i(v([B, F, A]), v([O, $, b])), I = i(v([$, F, A]), v([B, b])), U = i(w, v([F, F, A])), ee = [[D, M, _], [q, C, T], [z, I, U]];
    return g(ee, E);
  }
}), od = "row", y8 = ["typed", "Index", "matrix", "range"], Qg = /* @__PURE__ */ Q(od, y8, (e) => {
  var {
    typed: r,
    Index: o,
    matrix: n,
    range: i
  } = e;
  return r(od, {
    "Matrix, number": t,
    "Array, number": function(l, f) {
      return t(n(Ie(l)), f).valueOf();
    }
  });
  function t(u, l) {
    if (u.size().length !== 2)
      throw new Error("Only two dimensional matrix is supported");
    sr(l, u.size()[0]);
    var f = i(0, u.size()[1]), s = new o(l, f), a = u.subset(s);
    return Fe(a) ? a : n([[a]]);
  }
}), sd = "size", w8 = ["typed", "config", "?matrix"], x8 = /* @__PURE__ */ Q(sd, w8, (e) => {
  var {
    typed: r,
    config: o,
    matrix: n
  } = e;
  return r(sd, {
    Matrix: function(t) {
      return t.create(t.size());
    },
    Array: ze,
    string: function(t) {
      return o.matrix === "Array" ? [t.length] : n([t.length]);
    },
    "number | Complex | BigNumber | Unit | boolean | null": function(t) {
      return o.matrix === "Array" ? [] : n ? n([]) : Xg();
    }
  });
}), ud = "squeeze", E8 = ["typed", "matrix"], A8 = /* @__PURE__ */ Q(ud, E8, (e) => {
  var {
    typed: r,
    matrix: o
  } = e;
  return r(ud, {
    Array: function(i) {
      return Na(Ie(i));
    },
    Matrix: function(i) {
      var t = Na(i.toArray());
      return Array.isArray(t) ? o(t) : t;
    },
    any: function(i) {
      return Ie(i);
    }
  });
}), fd = "subset", S8 = ["typed", "matrix", "zeros", "add"], eb = /* @__PURE__ */ Q(fd, S8, (e) => {
  var {
    typed: r,
    matrix: o,
    zeros: n,
    add: i
  } = e;
  return r(fd, {
    // get subset
    "Matrix, Index": function(l, f) {
      return Hn(f) ? o() : (Da(l, f), l.subset(f));
    },
    "Array, Index": r.referTo("Matrix, Index", function(u) {
      return function(l, f) {
        var s = u(o(l), f);
        return f.isScalar() ? s : s.valueOf();
      };
    }),
    "Object, Index": N8,
    "string, Index": D8,
    // set subset
    "Matrix, Index, any, any": function(l, f, s, a) {
      return Hn(f) ? l : (Da(l, f), l.clone().subset(f, t(s, f), a));
    },
    "Array, Index, any, any": r.referTo("Matrix, Index, any, any", function(u) {
      return function(l, f, s, a) {
        var c = u(o(l), f, s, a);
        return c.isMatrix ? c.valueOf() : c;
      };
    }),
    "Array, Index, any": r.referTo("Matrix, Index, any, any", function(u) {
      return function(l, f, s) {
        return u(o(l), f, s, void 0).valueOf();
      };
    }),
    "Matrix, Index, any": r.referTo("Matrix, Index, any, any", function(u) {
      return function(l, f, s) {
        return u(l, f, s, void 0);
      };
    }),
    "string, Index, string": cd,
    "string, Index, string, string": cd,
    "Object, Index, any": M8
  });
  function t(u, l) {
    if (typeof u == "string")
      throw new Error("can't boradcast a string");
    if (l._isScalar)
      return u;
    var f = l.size();
    if (f.every((s) => s > 0))
      try {
        return i(u, n(f));
      } catch {
        return u;
      }
    else
      return u;
  }
});
function D8(e, r) {
  if (!Ni(r))
    throw new TypeError("Index expected");
  if (Hn(r))
    return "";
  if (Da(Array.from(e), r), r.size().length !== 1)
    throw new We(r.size().length, 1);
  var o = e.length;
  sr(r.min()[0], o), sr(r.max()[0], o);
  var n = r.dimension(0), i = "";
  return n.forEach(function(t) {
    i += e.charAt(t);
  }), i;
}
function cd(e, r, o, n) {
  if (!r || r.isIndex !== !0)
    throw new TypeError("Index expected");
  if (Hn(r))
    return e;
  if (Da(Array.from(e), r), r.size().length !== 1)
    throw new We(r.size().length, 1);
  if (n !== void 0) {
    if (typeof n != "string" || n.length !== 1)
      throw new TypeError("Single character expected as defaultValue");
  } else
    n = " ";
  var i = r.dimension(0), t = i.size()[0];
  if (t !== o.length)
    throw new We(i.size()[0], o.length);
  var u = e.length;
  sr(r.min()[0]), sr(r.max()[0]);
  for (var l = [], f = 0; f < u; f++)
    l[f] = e.charAt(f);
  if (i.forEach(function(c, d) {
    l[c] = o.charAt(d[0]);
  }), l.length > u)
    for (var s = u - 1, a = l.length; s < a; s++)
      l[s] || (l[s] = n);
  return l.join("");
}
function N8(e, r) {
  if (!Hn(r)) {
    if (r.size().length !== 1)
      throw new We(r.size(), 1);
    var o = r.dimension(0);
    if (typeof o != "string")
      throw new TypeError("String expected as index to retrieve an object property");
    return Vr(e, o);
  }
}
function M8(e, r, o) {
  if (Hn(r))
    return e;
  if (r.size().length !== 1)
    throw new We(r.size(), 1);
  var n = r.dimension(0);
  if (typeof n != "string")
    throw new TypeError("String expected as index to retrieve an object property");
  var i = Ie(e);
  return Un(i, n, o), i;
}
var ld = "transpose", _8 = ["typed", "matrix"], C8 = /* @__PURE__ */ Q(ld, _8, (e) => {
  var {
    typed: r,
    matrix: o
  } = e;
  return r(ld, {
    Array: (u) => n(o(u)).valueOf(),
    Matrix: n,
    any: Ie
    // scalars
  });
  function n(u) {
    var l = u.size(), f;
    switch (l.length) {
      case 1:
        f = u.clone();
        break;
      case 2:
        {
          var s = l[0], a = l[1];
          if (a === 0)
            throw new RangeError("Cannot transpose a 2D matrix with no columns (size: " + Ze(l) + ")");
          switch (u.storage()) {
            case "dense":
              f = i(u, s, a);
              break;
            case "sparse":
              f = t(u, s, a);
              break;
          }
        }
        break;
      default:
        throw new RangeError("Matrix must be a vector or two dimensional (size: " + Ze(l) + ")");
    }
    return f;
  }
  function i(u, l, f) {
    for (var s = u._data, a = [], c, d = 0; d < f; d++) {
      c = a[d] = [];
      for (var h = 0; h < l; h++)
        c[h] = Ie(s[h][d]);
    }
    return u.createDenseMatrix({
      data: a,
      size: [f, l],
      datatype: u._datatype
    });
  }
  function t(u, l, f) {
    for (var s = u._values, a = u._index, c = u._ptr, d = s ? [] : void 0, h = [], p = [], v = [], g = 0; g < l; g++)
      v[g] = 0;
    var m, x, y;
    for (m = 0, x = a.length; m < x; m++)
      v[a[m]]++;
    for (var E = 0, N = 0; N < l; N++)
      p.push(E), E += v[N], v[N] = p[N];
    for (p.push(E), y = 0; y < f; y++)
      for (var S = c[y], R = c[y + 1], O = S; O < R; O++) {
        var B = v[a[O]]++;
        h[B] = y, s && (d[B] = Ie(s[O]));
      }
    return u.createSparseMatrix({
      values: d,
      index: h,
      ptr: p,
      size: [f, l],
      datatype: u._datatype
    });
  }
}), dd = "ctranspose", T8 = ["typed", "transpose", "conj"], B8 = /* @__PURE__ */ Q(dd, T8, (e) => {
  var {
    typed: r,
    transpose: o,
    conj: n
  } = e;
  return r(dd, {
    any: function(t) {
      return n(o(t));
    }
  });
}), hd = "zeros", F8 = ["typed", "config", "matrix", "BigNumber"], I8 = /* @__PURE__ */ Q(hd, F8, (e) => {
  var {
    typed: r,
    config: o,
    matrix: n,
    BigNumber: i
  } = e;
  return r(hd, {
    "": function() {
      return o.matrix === "Array" ? t([]) : t([], "default");
    },
    // math.zeros(m, n, p, ..., format)
    // TODO: more accurate signature '...number | BigNumber, string' as soon as typed-function supports this
    "...number | BigNumber | string": function(s) {
      var a = s[s.length - 1];
      if (typeof a == "string") {
        var c = s.pop();
        return t(s, c);
      } else
        return o.matrix === "Array" ? t(s) : t(s, "default");
    },
    Array: t,
    Matrix: function(s) {
      var a = s.storage();
      return t(s.valueOf(), a);
    },
    "Array | Matrix, string": function(s, a) {
      return t(s.valueOf(), a);
    }
  });
  function t(f, s) {
    var a = u(f), c = a ? new i(0) : 0;
    if (l(f), s) {
      var d = n(s);
      return f.length > 0 ? d.resize(f, c) : d;
    } else {
      var h = [];
      return f.length > 0 ? Gn(h, f, c) : h;
    }
  }
  function u(f) {
    var s = !1;
    return f.forEach(function(a, c, d) {
      Re(a) && (s = !0, d[c] = a.toNumber());
    }), s;
  }
  function l(f) {
    f.forEach(function(s) {
      if (typeof s != "number" || !Te(s) || s < 0)
        throw new Error("Parameters in function zeros must be positive integers");
    });
  }
}), pd = "fft", O8 = ["typed", "matrix", "addScalar", "multiplyScalar", "divideScalar", "exp", "tau", "i", "dotDivide", "conj", "pow", "ceil", "log2"], R8 = /* @__PURE__ */ Q(pd, O8, (e) => {
  var {
    typed: r,
    matrix: o,
    addScalar: n,
    multiplyScalar: i,
    divideScalar: t,
    exp: u,
    tau: l,
    i: f,
    dotDivide: s,
    conj: a,
    pow: c,
    ceil: d,
    log2: h
  } = e;
  return r(pd, {
    Array: p,
    Matrix: function(y) {
      return y.create(p(y.toArray()));
    }
  });
  function p(x) {
    var y = ze(x);
    return y.length === 1 ? m(x, y[0]) : v(x.map((E) => p(E, y.slice(1))), 0);
  }
  function v(x, y) {
    var E = ze(x);
    if (y !== 0)
      return new Array(E[0]).fill(0).map((S, R) => v(x[R], y - 1));
    if (E.length === 1)
      return m(x);
    function N(S) {
      var R = ze(S);
      return new Array(R[1]).fill(0).map((O, B) => new Array(R[0]).fill(0).map(($, F) => S[F][B]));
    }
    return N(v(N(x), 1));
  }
  function g(x) {
    for (var y = x.length, E = u(t(i(-1, i(f, l)), y)), N = [], S = 1 - y; S < y; S++)
      N.push(c(E, t(c(S, 2), 2)));
    for (var R = c(2, d(h(y + y - 1))), O = [...new Array(y).fill(0).map((M, _) => i(x[_], N[y - 1 + _])), ...new Array(R - y).fill(0)], B = [...new Array(y + y - 1).fill(0).map((M, _) => t(1, N[_])), ...new Array(R - (y + y - 1)).fill(0)], $ = m(O), F = m(B), w = new Array(R).fill(0).map((M, _) => i($[_], F[_])), A = s(a(p(a(w))), R), b = [], D = y - 1; D < y + y - 1; D++)
      b.push(i(A[D], N[D]));
    return b;
  }
  function m(x) {
    var y = x.length;
    if (y === 1)
      return [x[0]];
    if (y % 2 === 0) {
      for (var E = [...m(x.filter((O, B) => B % 2 === 0)), ...m(x.filter((O, B) => B % 2 === 1))], N = 0; N < y / 2; N++) {
        var S = E[N], R = i(E[N + y / 2], u(i(i(l, f), t(-N, y))));
        E[N] = n(S, R), E[N + y / 2] = n(S, i(-1, R));
      }
      return E;
    } else
      return g(x);
  }
}), vd = "ifft", P8 = ["typed", "fft", "dotDivide", "conj"], q8 = /* @__PURE__ */ Q(vd, P8, (e) => {
  var {
    typed: r,
    fft: o,
    dotDivide: n,
    conj: i
  } = e;
  return r(vd, {
    "Array | Matrix": function(u) {
      var l = Fe(u) ? u.size() : ze(u);
      return n(i(o(i(u))), l.reduce((f, s) => f * s, 1));
    }
  });
});
function Ei(e) {
  "@babel/helpers - typeof";
  return Ei = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Ei(e);
}
function $8(e, r) {
  if (Ei(e) != "object" || !e)
    return e;
  var o = e[Symbol.toPrimitive];
  if (o !== void 0) {
    var n = o.call(e, r || "default");
    if (Ei(n) != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function z8(e) {
  var r = $8(e, "string");
  return Ei(r) == "symbol" ? r : r + "";
}
function Fr(e, r, o) {
  return (r = z8(r)) in e ? Object.defineProperty(e, r, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = o, e;
}
function md(e, r) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), o.push.apply(o, n);
  }
  return o;
}
function L8(e) {
  for (var r = 1; r < arguments.length; r++) {
    var o = arguments[r] != null ? arguments[r] : {};
    r % 2 ? md(Object(o), !0).forEach(function(n) {
      Fr(e, n, o[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : md(Object(o)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(o, n));
    });
  }
  return e;
}
var U8 = "solveODE", k8 = ["typed", "add", "subtract", "multiply", "divide", "max", "map", "abs", "isPositive", "isNegative", "larger", "smaller", "matrix", "bignumber", "unaryMinus"], H8 = /* @__PURE__ */ Q(U8, k8, (e) => {
  var {
    typed: r,
    add: o,
    subtract: n,
    multiply: i,
    divide: t,
    max: u,
    map: l,
    abs: f,
    isPositive: s,
    isNegative: a,
    larger: c,
    smaller: d,
    matrix: h,
    bignumber: p,
    unaryMinus: v
  } = e;
  function g(O) {
    return function(B, $, F, w) {
      var A = !($.length === 2 && ($.every(S) || $.every(jr)));
      if (A)
        throw new Error('"tspan" must be an Array of two numeric values or two units [tStart, tEnd]');
      var b = $[0], D = $[1], M = c(D, b), _ = w.firstStep;
      if (_ !== void 0 && !s(_))
        throw new Error('"firstStep" must be positive');
      var q = w.maxStep;
      if (q !== void 0 && !s(q))
        throw new Error('"maxStep" must be positive');
      var C = w.minStep;
      if (C && a(C))
        throw new Error('"minStep" must be positive or zero');
      var T = [b, D, _, C, q].filter((Z) => Z !== void 0);
      if (!(T.every(S) || T.every(jr)))
        throw new Error('Inconsistent type of "t" dependant variables');
      for (var z = 1, I = w.tol ? w.tol : 1e-4, U = w.minDelta ? w.minDelta : 0.2, ee = w.maxDelta ? w.maxDelta : 5, se = w.maxIter ? w.maxIter : 1e4, K = [b, D, ...F, q, C].some(Re), [J, te, ne, ue] = K ? [p(O.a), p(O.c), p(O.b), p(O.bp)] : [O.a, O.c, O.b, O.bp], V = _ ? M ? _ : v(_) : t(n(D, b), z), W = [b], fe = [F], pe = n(ne, ue), Y = 0, k = 0, L = E(M), P = N(M); L(W[Y], D); ) {
        var G = [];
        V = P(W[Y], D, V), G.push(B(W[Y], fe[Y]));
        for (var j = 1; j < te.length; ++j)
          G.push(B(o(W[Y], i(te[j], V)), o(fe[Y], i(V, J[j], G))));
        var re = u(f(l(i(pe, G), (Z) => jr(Z) ? Z.value : Z)));
        re < I && I / re > 1 / 4 && (W.push(o(W[Y], V)), fe.push(o(fe[Y], i(V, ne, G))), Y++);
        var ie = 0.84 * (I / re) ** (1 / 5);
        if (d(ie, U) ? ie = U : c(ie, ee) && (ie = ee), ie = K ? p(ie) : ie, V = i(V, ie), q && c(f(V), q) ? V = M ? q : v(q) : C && d(f(V), C) && (V = M ? C : v(C)), k++, k > se)
          throw new Error("Maximum number of iterations reached, try changing options");
      }
      return {
        t: W,
        y: fe
      };
    };
  }
  function m(O, B, $, F) {
    var w = [[], [0.5], [0, 0.75], [0.2222222222222222, 0.3333333333333333, 0.4444444444444444]], A = [null, 1 / 2, 3 / 4, 1], b = [2 / 9, 1 / 3, 4 / 9, 0], D = [7 / 24, 1 / 4, 1 / 3, 1 / 8], M = {
      a: w,
      c: A,
      b,
      bp: D
    };
    return g(M)(O, B, $, F);
  }
  function x(O, B, $, F) {
    var w = [[], [0.2], [0.075, 0.225], [0.9777777777777777, -3.7333333333333334, 3.5555555555555554], [2.9525986892242035, -11.595793324188385, 9.822892851699436, -0.2908093278463649], [2.8462752525252526, -10.757575757575758, 8.906422717743473, 0.2784090909090909, -0.2735313036020583], [0.09114583333333333, 0, 0.44923629829290207, 0.6510416666666666, -0.322376179245283, 0.13095238095238096]], A = [null, 1 / 5, 3 / 10, 4 / 5, 8 / 9, 1, 1], b = [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84, 0], D = [5179 / 57600, 0, 7571 / 16695, 393 / 640, -92097 / 339200, 187 / 2100, 1 / 40], M = {
      a: w,
      c: A,
      b,
      bp: D
    };
    return g(M)(O, B, $, F);
  }
  function y(O, B, $, F) {
    var w = F.method ? F.method : "RK45", A = {
      RK23: m,
      RK45: x
    };
    if (w.toUpperCase() in A) {
      var b = L8({}, F);
      return delete b.method, A[w.toUpperCase()](O, B, $, b);
    } else {
      var D = Object.keys(A).map((_) => '"'.concat(_, '"')), M = "".concat(D.slice(0, -1).join(", "), " and ").concat(D.slice(-1));
      throw new Error('Unavailable method "'.concat(w, '". Available methods are ').concat(M));
    }
  }
  function E(O) {
    return O ? d : c;
  }
  function N(O) {
    var B = O ? c : d;
    return function($, F, w) {
      var A = o($, w);
      return B(A, F) ? n(F, $) : w;
    };
  }
  function S(O) {
    return Re(O) || $e(O);
  }
  function R(O, B, $, F) {
    var w = y(O, B.toArray(), $.toArray(), F);
    return {
      t: h(w.t),
      y: h(w.y)
    };
  }
  return r("solveODE", {
    "function, Array, Array, Object": y,
    "function, Matrix, Matrix, Object": R,
    "function, Array, Array": (O, B, $) => y(O, B, $, {}),
    "function, Matrix, Matrix": (O, B, $) => R(O, B, $, {}),
    "function, Array, number | BigNumber | Unit": (O, B, $) => {
      var F = y(O, B, [$], {});
      return {
        t: F.t,
        y: F.y.map((w) => w[0])
      };
    },
    "function, Matrix, number | BigNumber | Unit": (O, B, $) => {
      var F = y(O, B.toArray(), [$], {});
      return {
        t: h(F.t),
        y: h(F.y.map((w) => w[0]))
      };
    },
    "function, Array, number | BigNumber | Unit, Object": (O, B, $, F) => {
      var w = y(O, B, [$], F);
      return {
        t: w.t,
        y: w.y.map((A) => A[0])
      };
    },
    "function, Matrix, number | BigNumber | Unit, Object": (O, B, $, F) => {
      var w = y(O, B.toArray(), [$], F);
      return {
        t: h(w.t),
        y: h(w.y.map((A) => A[0]))
      };
    }
  });
}), G8 = "erf", V8 = ["typed"], W8 = /* @__PURE__ */ Q(G8, V8, (e) => {
  var {
    typed: r
  } = e;
  return r("name", {
    number: function(u) {
      var l = Math.abs(u);
      return l >= j8 ? rn(u) : l <= K8 ? rn(u) * o(l) : l <= 4 ? rn(u) * (1 - n(l)) : rn(u) * (1 - i(l));
    },
    "Array | Matrix": r.referToSelf((t) => (u) => Ke(u, t))
    // TODO: For complex numbers, use the approximation for the Faddeeva function
    //  from "More Efficient Computation of the Complex Error Function" (AMS)
  });
  function o(t) {
    var u = t * t, l = zt[0][4] * u, f = u, s;
    for (s = 0; s < 3; s += 1)
      l = (l + zt[0][s]) * u, f = (f + Cn[0][s]) * u;
    return t * (l + zt[0][3]) / (f + Cn[0][3]);
  }
  function n(t) {
    var u = zt[1][8] * t, l = t, f;
    for (f = 0; f < 7; f += 1)
      u = (u + zt[1][f]) * t, l = (l + Cn[1][f]) * t;
    var s = (u + zt[1][7]) / (l + Cn[1][7]), a = parseInt(t * 16) / 16, c = (t - a) * (t + a);
    return Math.exp(-a * a) * Math.exp(-c) * s;
  }
  function i(t) {
    var u = 1 / (t * t), l = zt[2][5] * u, f = u, s;
    for (s = 0; s < 4; s += 1)
      l = (l + zt[2][s]) * u, f = (f + Cn[2][s]) * u;
    var a = u * (l + zt[2][4]) / (f + Cn[2][4]);
    a = (Z8 - a) / t, u = parseInt(t * 16) / 16;
    var c = (t - u) * (t + u);
    return Math.exp(-u * u) * Math.exp(-c) * a;
  }
}), K8 = 0.46875, Z8 = 0.5641895835477563, zt = [[3.1611237438705655, 113.86415415105016, 377.485237685302, 3209.3775891384694, 0.18577770618460315], [0.5641884969886701, 8.883149794388377, 66.11919063714163, 298.6351381974001, 881.952221241769, 1712.0476126340707, 2051.0783778260716, 1230.3393547979972, 21531153547440383e-24], [0.30532663496123236, 0.36034489994980445, 0.12578172611122926, 0.016083785148742275, 6587491615298378e-19, 0.016315387137302097]], Cn = [[23.601290952344122, 244.02463793444417, 1282.6165260773723, 2844.236833439171], [15.744926110709835, 117.6939508913125, 537.1811018620099, 1621.3895745666903, 3290.7992357334597, 4362.619090143247, 3439.3676741437216, 1230.3393548037495], [2.568520192289822, 1.8729528499234604, 0.5279051029514285, 0.06051834131244132, 0.0023352049762686918]], j8 = Math.pow(2, 53), gd = "zeta", Y8 = ["typed", "config", "multiply", "pow", "divide", "factorial", "equal", "smallerEq", "isNegative", "gamma", "sin", "subtract", "add", "?Complex", "?BigNumber", "pi"], X8 = /* @__PURE__ */ Q(gd, Y8, (e) => {
  var {
    typed: r,
    config: o,
    multiply: n,
    pow: i,
    divide: t,
    factorial: u,
    equal: l,
    smallerEq: f,
    isNegative: s,
    gamma: a,
    sin: c,
    subtract: d,
    add: h,
    Complex: p,
    BigNumber: v,
    pi: g
  } = e;
  return r(gd, {
    number: (S) => m(S, (R) => R, () => 20),
    BigNumber: (S) => m(S, (R) => new v(R), () => Math.abs(Math.log10(o.relTol))),
    Complex: x
  });
  function m(S, R, O) {
    return l(S, 0) ? R(-0.5) : l(S, 1) ? R(NaN) : isFinite(S) ? y(S, R, O, (B) => B) : s(S) ? R(NaN) : R(1);
  }
  function x(S) {
    return S.re === 0 && S.im === 0 ? new p(-0.5) : S.re === 1 ? new p(NaN, NaN) : S.re === 1 / 0 && S.im === 0 ? new p(1) : S.im === 1 / 0 || S.re === -1 / 0 ? new p(NaN, NaN) : y(S, (R) => R, (R) => Math.round(1.3 * 15 + 0.9 * Math.abs(R.im)), (R) => R.re);
  }
  function y(S, R, O, B) {
    var $ = O(S);
    if (B(S) > -($ - 1) / 2)
      return N(S, R($), R);
    var F = n(i(2, S), i(R(g), d(S, 1)));
    return F = n(F, c(n(t(R(g), 2), S))), F = n(F, a(d(1, S))), n(F, y(d(1, S), R, O, B));
  }
  function E(S, R) {
    for (var O = S, B = S; f(B, R); B = h(B, 1)) {
      var $ = t(n(u(h(R, d(B, 1))), i(4, B)), n(u(d(R, B)), u(n(2, B))));
      O = h(O, $);
    }
    return n(R, O);
  }
  function N(S, R, O) {
    for (var B = t(1, n(E(O(0), R), d(1, i(2, d(1, S))))), $ = O(0), F = O(1); f(F, R); F = h(F, 1))
      $ = h($, t(n((-1) ** (F - 1), E(F, R)), i(F, S)));
    return n(B, $);
  }
}), bd = "mode", J8 = ["typed", "isNaN", "isNumeric"], Q8 = /* @__PURE__ */ Q(bd, J8, (e) => {
  var {
    typed: r,
    isNaN: o,
    isNumeric: n
  } = e;
  return r(bd, {
    "Array | Matrix": i,
    "...": function(u) {
      return i(u);
    }
  });
  function i(t) {
    t = ir(t.valueOf());
    var u = t.length;
    if (u === 0)
      throw new Error("Cannot calculate mode of an empty array");
    for (var l = {}, f = [], s = 0, a = 0; a < t.length; a++) {
      var c = t[a];
      if (n(c) && o(c))
        throw new Error("Cannot calculate mode of an array containing NaN values");
      c in l || (l[c] = 0), l[c]++, l[c] === s ? f.push(c) : l[c] > s && (s = l[c], f = [c]);
    }
    return f;
  }
});
function Wr(e, r, o) {
  var n;
  return String(e).includes("Unexpected type") ? (n = arguments.length > 2 ? " (type: " + fr(o) + ", value: " + JSON.stringify(o) + ")" : " (type: " + e.data.actual + ")", new TypeError("Cannot calculate " + r + ", unexpected type of argument" + n)) : String(e).includes("complex numbers") ? (n = arguments.length > 2 ? " (type: " + fr(o) + ", value: " + JSON.stringify(o) + ")" : "", new TypeError("Cannot calculate " + r + ", no ordering relation is defined for complex numbers" + n)) : e;
}
var yd = "prod", e5 = ["typed", "config", "multiplyScalar", "numeric"], r5 = /* @__PURE__ */ Q(yd, e5, (e) => {
  var {
    typed: r,
    config: o,
    multiplyScalar: n,
    numeric: i
  } = e;
  return r(yd, {
    // prod([a, b, c, d, ...])
    "Array | Matrix": t,
    // prod([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(l, f) {
      throw new Error("prod(A, dim) is not yet supported");
    },
    // prod(a, b, c, d, ...)
    "...": function(l) {
      return t(l);
    }
  });
  function t(u) {
    var l;
    if (Wt(u, function(f) {
      try {
        l = l === void 0 ? f : n(l, f);
      } catch (s) {
        throw Wr(s, "prod", f);
      }
    }), typeof l == "string" && (l = i(l, sn(l, o))), l === void 0)
      throw new Error("Cannot calculate prod of an empty array");
    return l;
  }
}), wd = "format", t5 = ["typed"], n5 = /* @__PURE__ */ Q(wd, t5, (e) => {
  var {
    typed: r
  } = e;
  return r(wd, {
    any: Ze,
    "any, Object | function | number | BigNumber": Ze
  });
}), xd = "bin", i5 = ["typed", "format"], a5 = Q(xd, i5, (e) => {
  var {
    typed: r,
    format: o
  } = e;
  return r(xd, {
    "number | BigNumber": function(i) {
      return o(i, {
        notation: "bin"
      });
    },
    "number | BigNumber, number | BigNumber": function(i, t) {
      return o(i, {
        notation: "bin",
        wordSize: t
      });
    }
  });
}), Ed = "oct", o5 = ["typed", "format"], s5 = Q(Ed, o5, (e) => {
  var {
    typed: r,
    format: o
  } = e;
  return r(Ed, {
    "number | BigNumber": function(i) {
      return o(i, {
        notation: "oct"
      });
    },
    "number | BigNumber, number | BigNumber": function(i, t) {
      return o(i, {
        notation: "oct",
        wordSize: t
      });
    }
  });
}), Ad = "hex", u5 = ["typed", "format"], f5 = Q(Ad, u5, (e) => {
  var {
    typed: r,
    format: o
  } = e;
  return r(Ad, {
    "number | BigNumber": function(i) {
      return o(i, {
        notation: "hex"
      });
    },
    "number | BigNumber, number | BigNumber": function(i, t) {
      return o(i, {
        notation: "hex",
        wordSize: t
      });
    }
  });
}), rb = /\$([\w.]+)/g, Sd = "print", c5 = ["typed"], tb = /* @__PURE__ */ Q(Sd, c5, (e) => {
  var {
    typed: r
  } = e;
  return r(Sd, {
    // note: Matrix will be converted automatically to an Array
    "string, Object | Array": Dd,
    "string, Object | Array, number | Object": Dd
  });
});
function Dd(e, r, o) {
  return e.replace(rb, function(n, i) {
    var t = i.split("."), u = r[t.shift()];
    for (u !== void 0 && u.isMatrix && (u = u.toArray()); t.length && u !== void 0; ) {
      var l = t.shift();
      u = l ? u[l] : u + ".";
    }
    return u !== void 0 ? qr(u) ? u : Ze(u, o) : n;
  });
}
var Nd = "to", l5 = ["typed", "matrix", "concat"], d5 = /* @__PURE__ */ Q(Nd, l5, (e) => {
  var {
    typed: r,
    matrix: o,
    concat: n
  } = e, i = lr({
    typed: r,
    matrix: o,
    concat: n
  });
  return r(Nd, {
    "Unit, Unit | string": (t, u) => t.to(u)
  }, i({
    Ds: !0
  }));
}), Md = "isPrime", h5 = ["typed"], p5 = /* @__PURE__ */ Q(Md, h5, (e) => {
  var {
    typed: r
  } = e;
  return r(Md, {
    number: function(n) {
      if (n <= 3)
        return n > 1;
      if (n % 2 === 0 || n % 3 === 0)
        return !1;
      for (var i = 5; i * i <= n; i += 6)
        if (n % i === 0 || n % (i + 2) === 0)
          return !1;
      return !0;
    },
    bigint: function(n) {
      if (n <= 3n)
        return n > 1n;
      if (n % 2n === 0n || n % 3n === 0n)
        return !1;
      for (var i = 5n; i * i <= n; i += 6n)
        if (n % i === 0n || n % (i + 2n) === 0n)
          return !1;
      return !0;
    },
    BigNumber: function(n) {
      if (n.lte(3))
        return n.gt(1);
      if (n.mod(2).eq(0) || n.mod(3).eq(0))
        return !1;
      if (n.lt(Math.pow(2, 32))) {
        for (var i = n.toNumber(), t = 5; t * t <= i; t += 6)
          if (i % t === 0 || i % (t + 2) === 0)
            return !1;
        return !0;
      }
      function u(x, y, E) {
        for (var N = 1; !y.eq(0); )
          y.mod(2).eq(0) ? (y = y.div(2), x = x.mul(x).mod(E)) : (y = y.sub(1), N = x.mul(N).mod(E));
        return N;
      }
      var l = n.constructor.clone({
        precision: n.toFixed(0).length * 2
      });
      n = new l(n);
      for (var f = 0, s = n.sub(1); s.mod(2).eq(0); )
        s = s.div(2), f += 1;
      var a = null;
      if (n.lt("3317044064679887385961981"))
        a = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41].filter((x) => x < n);
      else {
        var c = Math.min(n.toNumber() - 2, Math.floor(2 * Math.pow(n.toFixed(0).length * Math.log(10), 2)));
        a = [];
        for (var d = 2; d <= c; d += 1)
          a.push(c);
      }
      for (var h = 0; h < a.length; h += 1) {
        var p = a[h], v = u(n.sub(n).add(p), s, n);
        if (!v.eq(1)) {
          for (var g = 0, m = v; !m.eq(n.sub(1)); g += 1, m = m.mul(m).mod(n))
            if (g === f - 1)
              return !1;
        }
      }
      return !0;
    },
    "Array | Matrix": r.referToSelf((o) => (n) => Ke(n, o))
  });
}), v5 = "numeric", m5 = ["number", "?bignumber", "?fraction"], g5 = /* @__PURE__ */ Q(v5, m5, (e) => {
  var {
    number: r,
    bignumber: o,
    fraction: n
  } = e, i = {
    string: !0,
    number: !0,
    BigNumber: !0,
    Fraction: !0
  }, t = {
    number: (u) => r(u),
    BigNumber: o ? (u) => o(u) : zf,
    bigint: (u) => BigInt(u),
    Fraction: n ? (u) => n(u) : Yg
  };
  return function(l) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "number", s = arguments.length > 2 ? arguments[2] : void 0;
    if (s !== void 0)
      throw new SyntaxError("numeric() takes one or two arguments");
    var a = fr(l);
    if (!(a in i))
      throw new TypeError("Cannot convert " + l + ' of type "' + a + '"; valid input types are ' + Object.keys(i).join(", "));
    if (!(f in t))
      throw new TypeError("Cannot convert " + l + ' to type "' + f + '"; valid output types are ' + Object.keys(t).join(", "));
    return f === a ? l : t[f](l);
  };
}), _d = "divideScalar", b5 = ["typed", "numeric"], y5 = /* @__PURE__ */ Q(_d, b5, (e) => {
  var {
    typed: r,
    numeric: o
  } = e;
  return r(_d, {
    "number, number": function(i, t) {
      return i / t;
    },
    "Complex, Complex": function(i, t) {
      return i.div(t);
    },
    "BigNumber, BigNumber": function(i, t) {
      return i.div(t);
    },
    "bigint, bigint": function(i, t) {
      return i / t;
    },
    "Fraction, Fraction": function(i, t) {
      return i.div(t);
    },
    "Unit, number | Complex | Fraction | BigNumber | Unit": (n, i) => n.divide(i),
    "number | Fraction | Complex | BigNumber, Unit": (n, i) => i.divideInto(n)
  });
}), Cd = "pow", w5 = ["typed", "config", "identity", "multiply", "matrix", "inv", "fraction", "number", "Complex"], x5 = /* @__PURE__ */ Q(Cd, w5, (e) => {
  var {
    typed: r,
    config: o,
    identity: n,
    multiply: i,
    matrix: t,
    inv: u,
    number: l,
    fraction: f,
    Complex: s
  } = e;
  return r(Cd, {
    "number, number": a,
    "Complex, Complex": function(p, v) {
      return p.pow(v);
    },
    "BigNumber, BigNumber": function(p, v) {
      return v.isInteger() || p >= 0 || o.predictable ? p.pow(v) : new s(p.toNumber(), 0).pow(v.toNumber(), 0);
    },
    "bigint, bigint": (h, p) => h ** p,
    "Fraction, Fraction": function(p, v) {
      var g = p.pow(v);
      if (g != null)
        return g;
      if (o.predictable)
        throw new Error("Result of pow is non-rational and cannot be expressed as a fraction");
      return a(p.valueOf(), v.valueOf());
    },
    "Array, number": c,
    "Array, BigNumber": function(p, v) {
      return c(p, v.toNumber());
    },
    "Matrix, number": d,
    "Matrix, BigNumber": function(p, v) {
      return d(p, v.toNumber());
    },
    "Unit, number | BigNumber": function(p, v) {
      return p.pow(v);
    }
  });
  function a(h, p) {
    if (o.predictable && !Te(p) && h < 0)
      try {
        var v = f(p), g = l(v);
        if ((p === g || Math.abs((p - g) / p) < 1e-14) && v.d % 2 === 1)
          return (v.n % 2 === 0 ? 1 : -1) * Math.pow(-h, p);
      } catch {
      }
    return o.predictable && (h < -1 && p === 1 / 0 || h > -1 && h < 0 && p === -1 / 0) ? NaN : Te(p) || h >= 0 || o.predictable ? cg(h, p) : h * h < 1 && p === 1 / 0 || h * h > 1 && p === -1 / 0 ? 0 : new s(h, 0).pow(p, 0);
  }
  function c(h, p) {
    if (!Te(p))
      throw new TypeError("For A^b, b must be an integer (value is " + p + ")");
    var v = ze(h);
    if (v.length !== 2)
      throw new Error("For A^b, A must be 2 dimensional (A has " + v.length + " dimensions)");
    if (v[0] !== v[1])
      throw new Error("For A^b, A must be square (size is " + v[0] + "x" + v[1] + ")");
    if (p < 0)
      try {
        return c(u(h), -p);
      } catch (x) {
        throw x.message === "Cannot calculate inverse, determinant is zero" ? new TypeError("For A^b, when A is not invertible, b must be a positive integer (value is " + p + ")") : x;
      }
    for (var g = n(v[0]).valueOf(), m = h; p >= 1; )
      (p & 1) === 1 && (g = i(m, g)), p >>= 1, m = i(m, m);
    return g;
  }
  function d(h, p) {
    return t(c(h.valueOf(), p));
  }
}), Tn = "Number of decimals in function round must be an integer", Td = "round", E5 = ["typed", "config", "matrix", "equalScalar", "zeros", "BigNumber", "DenseMatrix"], A5 = /* @__PURE__ */ Q(Td, E5, (e) => {
  var {
    typed: r,
    config: o,
    matrix: n,
    equalScalar: i,
    zeros: t,
    BigNumber: u,
    DenseMatrix: l
  } = e, f = Lr({
    typed: r,
    equalScalar: i
  }), s = Ir({
    typed: r,
    DenseMatrix: l
  }), a = Et({
    typed: r
  });
  function c(d) {
    return Math.abs(Ci(d).exponent);
  }
  return r(Td, {
    number: function(h) {
      var p = si(h, c(o.relTol)), v = zr(h, p, o.relTol, o.absTol) ? p : h;
      return si(v);
    },
    "number, number": function(h, p) {
      var v = c(o.relTol);
      if (p >= v)
        return si(h, p);
      var g = si(h, v), m = zr(h, g, o.relTol, o.absTol) ? g : h;
      return si(m, p);
    },
    "number, BigNumber": function(h, p) {
      if (!p.isInteger())
        throw new TypeError(Tn);
      return new u(h).toDecimalPlaces(p.toNumber());
    },
    Complex: function(h) {
      return h.round();
    },
    "Complex, number": function(h, p) {
      if (p % 1)
        throw new TypeError(Tn);
      return h.round(p);
    },
    "Complex, BigNumber": function(h, p) {
      if (!p.isInteger())
        throw new TypeError(Tn);
      var v = p.toNumber();
      return h.round(v);
    },
    BigNumber: function(h) {
      var p = new u(h).toDecimalPlaces(c(o.relTol)), v = Xr(h, p, o.relTol, o.absTol) ? p : h;
      return v.toDecimalPlaces(0);
    },
    "BigNumber, BigNumber": function(h, p) {
      if (!p.isInteger())
        throw new TypeError(Tn);
      var v = c(o.relTol);
      if (p >= v)
        return h.toDecimalPlaces(p.toNumber());
      var g = h.toDecimalPlaces(v), m = Xr(h, g, o.relTol, o.absTol) ? g : h;
      return m.toDecimalPlaces(p.toNumber());
    },
    Fraction: function(h) {
      return h.round();
    },
    "Fraction, number": function(h, p) {
      if (p % 1)
        throw new TypeError(Tn);
      return h.round(p);
    },
    "Fraction, BigNumber": function(h, p) {
      if (!p.isInteger())
        throw new TypeError(Tn);
      return h.round(p.toNumber());
    },
    "Unit, number, Unit": r.referToSelf((d) => function(h, p, v) {
      var g = h.toNumeric(v);
      return v.multiply(d(g, p));
    }),
    "Unit, BigNumber, Unit": r.referToSelf((d) => (h, p, v) => d(h, p.toNumber(), v)),
    "Unit, Unit": r.referToSelf((d) => (h, p) => d(h, 0, p)),
    "Array | Matrix, number, Unit": r.referToSelf((d) => (h, p, v) => Ke(h, (g) => d(g, p, v))),
    "Array | Matrix, BigNumber, Unit": r.referToSelf((d) => (h, p, v) => d(h, p.toNumber(), v)),
    "Array | Matrix, Unit": r.referToSelf((d) => (h, p) => d(h, 0, p)),
    "Array | Matrix": r.referToSelf((d) => (h) => Ke(h, d)),
    "SparseMatrix, number | BigNumber": r.referToSelf((d) => (h, p) => f(h, p, d, !1)),
    "DenseMatrix, number | BigNumber": r.referToSelf((d) => (h, p) => a(h, p, d, !1)),
    "Array, number | BigNumber": r.referToSelf((d) => (h, p) => a(n(h), p, d, !1).valueOf()),
    "number | Complex | BigNumber | Fraction, SparseMatrix": r.referToSelf((d) => (h, p) => i(h, 0) ? t(p.size(), p.storage()) : s(p, h, d, !0)),
    "number | Complex | BigNumber | Fraction, DenseMatrix": r.referToSelf((d) => (h, p) => i(h, 0) ? t(p.size(), p.storage()) : a(p, h, d, !0)),
    "number | Complex | BigNumber | Fraction, Array": r.referToSelf((d) => (h, p) => a(n(p), h, d, !0).valueOf())
  });
}), Bd = "log", S5 = ["config", "typed", "divideScalar", "Complex"], D5 = /* @__PURE__ */ Q(Bd, S5, (e) => {
  var {
    typed: r,
    config: o,
    divideScalar: n,
    Complex: i
  } = e;
  return r(Bd, {
    number: function(u) {
      return u >= 0 || o.predictable ? Ex(u) : new i(u, 0).log();
    },
    Complex: function(u) {
      return u.log();
    },
    BigNumber: function(u) {
      return !u.isNegative() || o.predictable ? u.ln() : new i(u.toNumber(), 0).log();
    },
    "any, any": r.referToSelf((t) => (u, l) => n(t(u), t(l)))
  });
}), Fd = "log1p", N5 = ["typed", "config", "divideScalar", "log", "Complex"], M5 = /* @__PURE__ */ Q(Fd, N5, (e) => {
  var {
    typed: r,
    config: o,
    divideScalar: n,
    log: i,
    Complex: t
  } = e;
  return r(Fd, {
    number: function(f) {
      return f >= -1 || o.predictable ? b2(f) : u(new t(f, 0));
    },
    Complex: u,
    BigNumber: function(f) {
      var s = f.plus(1);
      return !s.isNegative() || o.predictable ? s.ln() : u(new t(f.toNumber(), 0));
    },
    "Array | Matrix": r.referToSelf((l) => (f) => Ke(f, l)),
    "any, any": r.referToSelf((l) => (f, s) => n(l(f), i(s)))
  });
  function u(l) {
    var f = l.re + 1;
    return new t(Math.log(Math.sqrt(f * f + l.im * l.im)), Math.atan2(l.im, f));
  }
}), Id = "nthRoots", _5 = ["config", "typed", "divideScalar", "Complex"], C5 = /* @__PURE__ */ Q(Id, _5, (e) => {
  var {
    typed: r,
    config: o,
    divideScalar: n,
    Complex: i
  } = e, t = [function(f) {
    return new i(f, 0);
  }, function(f) {
    return new i(0, f);
  }, function(f) {
    return new i(-f, 0);
  }, function(f) {
    return new i(0, -f);
  }];
  function u(l, f) {
    if (f < 0)
      throw new Error("Root must be greater than zero");
    if (f === 0)
      throw new Error("Root must be non-zero");
    if (f % 1 !== 0)
      throw new Error("Root must be an integer");
    if (l === 0 || l.abs() === 0)
      return [new i(0, 0)];
    var s = typeof l == "number", a;
    (s || l.re === 0 || l.im === 0) && (s ? a = 2 * +(l < 0) : l.im === 0 ? a = 2 * +(l.re < 0) : a = 2 * +(l.im < 0) + 1);
    for (var c = l.arg(), d = l.abs(), h = [], p = Math.pow(d, 1 / f), v = 0; v < f; v++) {
      var g = (a + 4 * v) / f;
      if (g === Math.round(g)) {
        h.push(t[g % 4](p));
        continue;
      }
      h.push(new i({
        r: p,
        phi: (c + 2 * Math.PI * v) / f
      }));
    }
    return h;
  }
  return r(Id, {
    Complex: function(f) {
      return u(f, 2);
    },
    "Complex, number": u
  });
}), Od = "dotPow", T5 = ["typed", "equalScalar", "matrix", "pow", "DenseMatrix", "concat"], B5 = /* @__PURE__ */ Q(Od, T5, (e) => {
  var {
    typed: r,
    equalScalar: o,
    matrix: n,
    pow: i,
    DenseMatrix: t,
    concat: u
  } = e, l = Kr({
    typed: r
  }), f = Mt({
    typed: r,
    DenseMatrix: t
  }), s = Lr({
    typed: r,
    equalScalar: o
  }), a = Ir({
    typed: r,
    DenseMatrix: t
  }), c = lr({
    typed: r,
    matrix: n,
    concat: u
  }), d = {};
  for (var h in i.signatures)
    Object.prototype.hasOwnProperty.call(i.signatures, h) && !h.includes("Matrix") && !h.includes("Array") && (d[h] = i.signatures[h]);
  var p = r(d);
  return r(Od, c({
    elop: p,
    SS: f,
    DS: l,
    Ss: s,
    sS: a
  }));
}), Rd = "dotDivide", F5 = ["typed", "matrix", "equalScalar", "divideScalar", "DenseMatrix", "concat"], I5 = /* @__PURE__ */ Q(Rd, F5, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    divideScalar: i,
    DenseMatrix: t,
    concat: u
  } = e, l = At({
    typed: r,
    equalScalar: n
  }), f = Kr({
    typed: r
  }), s = Mt({
    typed: r,
    DenseMatrix: t
  }), a = Lr({
    typed: r,
    equalScalar: n
  }), c = Ir({
    typed: r,
    DenseMatrix: t
  }), d = lr({
    typed: r,
    matrix: o,
    concat: u
  });
  return r(Rd, d({
    elop: i,
    SS: s,
    DS: f,
    SD: l,
    Ss: a,
    sS: c
  }));
});
function Fi(e) {
  var {
    DenseMatrix: r
  } = e;
  return function(n, i, t) {
    var u = n.size();
    if (u.length !== 2)
      throw new RangeError("Matrix must be two dimensional (size: " + Ze(u) + ")");
    var l = u[0], f = u[1];
    if (l !== f)
      throw new RangeError("Matrix must be square (size: " + Ze(u) + ")");
    var s = [];
    if (Fe(i)) {
      var a = i.size(), c = i._data;
      if (a.length === 1) {
        if (a[0] !== l)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var d = 0; d < l; d++)
          s[d] = [c[d]];
        return new r({
          data: s,
          size: [l, 1],
          datatype: i._datatype
        });
      }
      if (a.length === 2) {
        if (a[0] !== l || a[1] !== 1)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        if (gi(i)) {
          if (t) {
            s = [];
            for (var h = 0; h < l; h++)
              s[h] = [c[h][0]];
            return new r({
              data: s,
              size: [l, 1],
              datatype: i._datatype
            });
          }
          return i;
        }
        if (en(i)) {
          for (var p = 0; p < l; p++)
            s[p] = [0];
          for (var v = i._values, g = i._index, m = i._ptr, x = m[1], y = m[0]; y < x; y++) {
            var E = g[y];
            s[E][0] = v[y];
          }
          return new r({
            data: s,
            size: [l, 1],
            datatype: i._datatype
          });
        }
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
    if (ar(i)) {
      var N = ze(i);
      if (N.length === 1) {
        if (N[0] !== l)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var S = 0; S < l; S++)
          s[S] = [i[S]];
        return new r({
          data: s,
          size: [l, 1]
        });
      }
      if (N.length === 2) {
        if (N[0] !== l || N[1] !== 1)
          throw new RangeError("Dimension mismatch. Matrix columns must match vector length.");
        for (var R = 0; R < l; R++)
          s[R] = [i[R][0]];
        return new r({
          data: s,
          size: [l, 1]
        });
      }
      throw new RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.");
    }
  };
}
var Pd = "lsolve", O5 = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], R5 = /* @__PURE__ */ Q(Pd, O5, (e) => {
  var {
    typed: r,
    matrix: o,
    divideScalar: n,
    multiplyScalar: i,
    subtractScalar: t,
    equalScalar: u,
    DenseMatrix: l
  } = e, f = Fi({
    DenseMatrix: l
  });
  return r(Pd, {
    "SparseMatrix, Array | Matrix": function(d, h) {
      return a(d, h);
    },
    "DenseMatrix, Array | Matrix": function(d, h) {
      return s(d, h);
    },
    "Array, Array | Matrix": function(d, h) {
      var p = o(d), v = s(p, h);
      return v.valueOf();
    }
  });
  function s(c, d) {
    d = f(c, d, !0);
    for (var h = d._data, p = c._size[0], v = c._size[1], g = [], m = c._data, x = 0; x < v; x++) {
      var y = h[x][0] || 0, E = void 0;
      if (u(y, 0))
        E = 0;
      else {
        var N = m[x][x];
        if (u(N, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        E = n(y, N);
        for (var S = x + 1; S < p; S++)
          h[S] = [t(h[S][0] || 0, i(E, m[S][x]))];
      }
      g[x] = [E];
    }
    return new l({
      data: g,
      size: [p, 1]
    });
  }
  function a(c, d) {
    d = f(c, d, !0);
    for (var h = d._data, p = c._size[0], v = c._size[1], g = c._values, m = c._index, x = c._ptr, y = [], E = 0; E < v; E++) {
      var N = h[E][0] || 0;
      if (u(N, 0))
        y[E] = [0];
      else {
        for (var S = 0, R = [], O = [], B = x[E], $ = x[E + 1], F = B; F < $; F++) {
          var w = m[F];
          w === E ? S = g[F] : w > E && (R.push(g[F]), O.push(w));
        }
        if (u(S, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        for (var A = n(N, S), b = 0, D = O.length; b < D; b++) {
          var M = O[b];
          h[M] = [t(h[M][0] || 0, i(A, R[b]))];
        }
        y[E] = [A];
      }
    }
    return new l({
      data: y,
      size: [p, 1]
    });
  }
}), qd = "usolve", P5 = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], q5 = /* @__PURE__ */ Q(qd, P5, (e) => {
  var {
    typed: r,
    matrix: o,
    divideScalar: n,
    multiplyScalar: i,
    subtractScalar: t,
    equalScalar: u,
    DenseMatrix: l
  } = e, f = Fi({
    DenseMatrix: l
  });
  return r(qd, {
    "SparseMatrix, Array | Matrix": function(d, h) {
      return a(d, h);
    },
    "DenseMatrix, Array | Matrix": function(d, h) {
      return s(d, h);
    },
    "Array, Array | Matrix": function(d, h) {
      var p = o(d), v = s(p, h);
      return v.valueOf();
    }
  });
  function s(c, d) {
    d = f(c, d, !0);
    for (var h = d._data, p = c._size[0], v = c._size[1], g = [], m = c._data, x = v - 1; x >= 0; x--) {
      var y = h[x][0] || 0, E = void 0;
      if (u(y, 0))
        E = 0;
      else {
        var N = m[x][x];
        if (u(N, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        E = n(y, N);
        for (var S = x - 1; S >= 0; S--)
          h[S] = [t(h[S][0] || 0, i(E, m[S][x]))];
      }
      g[x] = [E];
    }
    return new l({
      data: g,
      size: [p, 1]
    });
  }
  function a(c, d) {
    d = f(c, d, !0);
    for (var h = d._data, p = c._size[0], v = c._size[1], g = c._values, m = c._index, x = c._ptr, y = [], E = v - 1; E >= 0; E--) {
      var N = h[E][0] || 0;
      if (u(N, 0))
        y[E] = [0];
      else {
        for (var S = 0, R = [], O = [], B = x[E], $ = x[E + 1], F = $ - 1; F >= B; F--) {
          var w = m[F];
          w === E ? S = g[F] : w < E && (R.push(g[F]), O.push(w));
        }
        if (u(S, 0))
          throw new Error("Linear system cannot be solved since matrix is singular");
        for (var A = n(N, S), b = 0, D = O.length; b < D; b++) {
          var M = O[b];
          h[M] = [t(h[M][0], i(A, R[b]))];
        }
        y[E] = [A];
      }
    }
    return new l({
      data: y,
      size: [p, 1]
    });
  }
}), $d = "lsolveAll", $5 = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], z5 = /* @__PURE__ */ Q($d, $5, (e) => {
  var {
    typed: r,
    matrix: o,
    divideScalar: n,
    multiplyScalar: i,
    subtractScalar: t,
    equalScalar: u,
    DenseMatrix: l
  } = e, f = Fi({
    DenseMatrix: l
  });
  return r($d, {
    "SparseMatrix, Array | Matrix": function(d, h) {
      return a(d, h);
    },
    "DenseMatrix, Array | Matrix": function(d, h) {
      return s(d, h);
    },
    "Array, Array | Matrix": function(d, h) {
      var p = o(d), v = s(p, h);
      return v.map((g) => g.valueOf());
    }
  });
  function s(c, d) {
    for (var h = [f(c, d, !0)._data.map((O) => O[0])], p = c._data, v = c._size[0], g = c._size[1], m = 0; m < g; m++)
      for (var x = h.length, y = 0; y < x; y++) {
        var E = h[y];
        if (u(p[m][m], 0))
          if (u(E[m], 0)) {
            if (y === 0) {
              var S = [...E];
              S[m] = 1;
              for (var R = m + 1; R < g; R++)
                S[R] = t(S[R], p[R][m]);
              h.push(S);
            }
          } else {
            if (y === 0)
              return [];
            h.splice(y, 1), y -= 1, x -= 1;
          }
        else {
          E[m] = n(E[m], p[m][m]);
          for (var N = m + 1; N < g; N++)
            E[N] = t(E[N], i(E[m], p[N][m]));
        }
      }
    return h.map((O) => new l({
      data: O.map((B) => [B]),
      size: [v, 1]
    }));
  }
  function a(c, d) {
    for (var h = [f(c, d, !0)._data.map((z) => z[0])], p = c._size[0], v = c._size[1], g = c._values, m = c._index, x = c._ptr, y = 0; y < v; y++)
      for (var E = h.length, N = 0; N < E; N++) {
        for (var S = h[N], R = [], O = [], B = x[y], $ = x[y + 1], F = 0, w = B; w < $; w++) {
          var A = m[w];
          A === y ? F = g[w] : A > y && (R.push(g[w]), O.push(A));
        }
        if (u(F, 0))
          if (u(S[y], 0)) {
            if (N === 0) {
              var _ = [...S];
              _[y] = 1;
              for (var q = 0, C = O.length; q < C; q++) {
                var T = O[q];
                _[T] = t(_[T], R[q]);
              }
              h.push(_);
            }
          } else {
            if (N === 0)
              return [];
            h.splice(N, 1), N -= 1, E -= 1;
          }
        else {
          S[y] = n(S[y], F);
          for (var b = 0, D = O.length; b < D; b++) {
            var M = O[b];
            S[M] = t(S[M], i(S[y], R[b]));
          }
        }
      }
    return h.map((z) => new l({
      data: z.map((I) => [I]),
      size: [p, 1]
    }));
  }
}), zd = "usolveAll", L5 = ["typed", "matrix", "divideScalar", "multiplyScalar", "subtractScalar", "equalScalar", "DenseMatrix"], U5 = /* @__PURE__ */ Q(zd, L5, (e) => {
  var {
    typed: r,
    matrix: o,
    divideScalar: n,
    multiplyScalar: i,
    subtractScalar: t,
    equalScalar: u,
    DenseMatrix: l
  } = e, f = Fi({
    DenseMatrix: l
  });
  return r(zd, {
    "SparseMatrix, Array | Matrix": function(d, h) {
      return a(d, h);
    },
    "DenseMatrix, Array | Matrix": function(d, h) {
      return s(d, h);
    },
    "Array, Array | Matrix": function(d, h) {
      var p = o(d), v = s(p, h);
      return v.map((g) => g.valueOf());
    }
  });
  function s(c, d) {
    for (var h = [f(c, d, !0)._data.map((O) => O[0])], p = c._data, v = c._size[0], g = c._size[1], m = g - 1; m >= 0; m--)
      for (var x = h.length, y = 0; y < x; y++) {
        var E = h[y];
        if (u(p[m][m], 0))
          if (u(E[m], 0)) {
            if (y === 0) {
              var S = [...E];
              S[m] = 1;
              for (var R = m - 1; R >= 0; R--)
                S[R] = t(S[R], p[R][m]);
              h.push(S);
            }
          } else {
            if (y === 0)
              return [];
            h.splice(y, 1), y -= 1, x -= 1;
          }
        else {
          E[m] = n(E[m], p[m][m]);
          for (var N = m - 1; N >= 0; N--)
            E[N] = t(E[N], i(E[m], p[N][m]));
        }
      }
    return h.map((O) => new l({
      data: O.map((B) => [B]),
      size: [v, 1]
    }));
  }
  function a(c, d) {
    for (var h = [f(c, d, !0)._data.map((z) => z[0])], p = c._size[0], v = c._size[1], g = c._values, m = c._index, x = c._ptr, y = v - 1; y >= 0; y--)
      for (var E = h.length, N = 0; N < E; N++) {
        for (var S = h[N], R = [], O = [], B = x[y], $ = x[y + 1], F = 0, w = $ - 1; w >= B; w--) {
          var A = m[w];
          A === y ? F = g[w] : A < y && (R.push(g[w]), O.push(A));
        }
        if (u(F, 0))
          if (u(S[y], 0)) {
            if (N === 0) {
              var _ = [...S];
              _[y] = 1;
              for (var q = 0, C = O.length; q < C; q++) {
                var T = O[q];
                _[T] = t(_[T], R[q]);
              }
              h.push(_);
            }
          } else {
            if (N === 0)
              return [];
            h.splice(N, 1), N -= 1, E -= 1;
          }
        else {
          S[y] = n(S[y], F);
          for (var b = 0, D = O.length; b < D; b++) {
            var M = O[b];
            S[M] = t(S[M], i(S[y], R[b]));
          }
        }
      }
    return h.map((z) => new l({
      data: z.map((I) => [I]),
      size: [p, 1]
    }));
  }
}), k5 = "matAlgo08xS0Sid", H5 = ["typed", "equalScalar"], Lf = /* @__PURE__ */ Q(k5, H5, (e) => {
  var {
    typed: r,
    equalScalar: o
  } = e;
  return function(i, t, u) {
    var l = i._values, f = i._index, s = i._ptr, a = i._size, c = i._datatype || i._data === void 0 ? i._datatype : i.getDataType(), d = t._values, h = t._index, p = t._ptr, v = t._size, g = t._datatype || t._data === void 0 ? t._datatype : t.getDataType();
    if (a.length !== v.length)
      throw new We(a.length, v.length);
    if (a[0] !== v[0] || a[1] !== v[1])
      throw new RangeError("Dimension mismatch. Matrix A (" + a + ") must match Matrix B (" + v + ")");
    if (!l || !d)
      throw new Error("Cannot perform operation on Pattern Sparse Matrices");
    var m = a[0], x = a[1], y, E = o, N = 0, S = u;
    typeof c == "string" && c === g && c !== "mixed" && (y = c, E = r.find(o, [y, y]), N = r.convert(0, y), S = r.find(u, [y, y]));
    for (var R = [], O = [], B = [], $ = [], F = [], w, A, b, D, M = 0; M < x; M++) {
      B[M] = O.length;
      var _ = M + 1;
      for (A = s[M], b = s[M + 1], w = A; w < b; w++)
        D = f[w], F[D] = _, $[D] = l[w], O.push(D);
      for (A = p[M], b = p[M + 1], w = A; w < b; w++)
        D = h[w], F[D] === _ && ($[D] = S($[D], d[w]));
      for (w = B[M]; w < O.length; ) {
        D = O[w];
        var q = $[D];
        E(q, N) ? O.splice(w, 1) : (R.push(q), w++);
      }
    }
    return B[x] = O.length, i.createSparseMatrix({
      values: R,
      index: O,
      ptr: B,
      size: [m, x],
      datatype: c === i._datatype && g === t._datatype ? y : void 0
    });
  };
}), Uf = /* @__PURE__ */ Q("useMatrixForArrayScalar", ["typed", "matrix"], (e) => {
  var {
    typed: r,
    matrix: o
  } = e;
  return {
    "Array, number": r.referTo("DenseMatrix, number", (n) => (i, t) => n(o(i), t).valueOf()),
    "Array, BigNumber": r.referTo("DenseMatrix, BigNumber", (n) => (i, t) => n(o(i), t).valueOf()),
    "number, Array": r.referTo("number, DenseMatrix", (n) => (i, t) => n(i, o(t)).valueOf()),
    "BigNumber, Array": r.referTo("BigNumber, DenseMatrix", (n) => (i, t) => n(i, o(t)).valueOf())
  };
}), Ld = "leftShift", G5 = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], V5 = /* @__PURE__ */ Q(Ld, G5, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    zeros: i,
    DenseMatrix: t,
    concat: u
  } = e, l = fn({
    typed: r
  }), f = At({
    typed: r,
    equalScalar: n
  }), s = Lf({
    typed: r,
    equalScalar: n
  }), a = Dn({
    typed: r,
    DenseMatrix: t
  }), c = Lr({
    typed: r,
    equalScalar: n
  }), d = Et({
    typed: r
  }), h = lr({
    typed: r,
    matrix: o,
    concat: u
  }), p = Uf({
    typed: r,
    matrix: o
  });
  return r(Ld, {
    "number, number": vg,
    "BigNumber, BigNumber": l6,
    "bigint, bigint": (v, g) => v << g,
    "SparseMatrix, number | BigNumber": r.referToSelf((v) => (g, m) => n(m, 0) ? g.clone() : c(g, m, v, !1)),
    "DenseMatrix, number | BigNumber": r.referToSelf((v) => (g, m) => n(m, 0) ? g.clone() : d(g, m, v, !1)),
    "number | BigNumber, SparseMatrix": r.referToSelf((v) => (g, m) => n(g, 0) ? i(m.size(), m.storage()) : a(m, g, v, !0)),
    "number | BigNumber, DenseMatrix": r.referToSelf((v) => (g, m) => n(g, 0) ? i(m.size(), m.storage()) : d(m, g, v, !0))
  }, p, h({
    SS: s,
    DS: l,
    SD: f
  }));
}), Ud = "rightArithShift", W5 = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], K5 = /* @__PURE__ */ Q(Ud, W5, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    zeros: i,
    DenseMatrix: t,
    concat: u
  } = e, l = fn({
    typed: r
  }), f = At({
    typed: r,
    equalScalar: n
  }), s = Lf({
    typed: r,
    equalScalar: n
  }), a = Dn({
    typed: r,
    DenseMatrix: t
  }), c = Lr({
    typed: r,
    equalScalar: n
  }), d = Et({
    typed: r
  }), h = lr({
    typed: r,
    matrix: o,
    concat: u
  }), p = Uf({
    typed: r,
    matrix: o
  });
  return r(Ud, {
    "number, number": mg,
    "BigNumber, BigNumber": d6,
    "bigint, bigint": (v, g) => v >> g,
    "SparseMatrix, number | BigNumber": r.referToSelf((v) => (g, m) => n(m, 0) ? g.clone() : c(g, m, v, !1)),
    "DenseMatrix, number | BigNumber": r.referToSelf((v) => (g, m) => n(m, 0) ? g.clone() : d(g, m, v, !1)),
    "number | BigNumber, SparseMatrix": r.referToSelf((v) => (g, m) => n(g, 0) ? i(m.size(), m.storage()) : a(m, g, v, !0)),
    "number | BigNumber, DenseMatrix": r.referToSelf((v) => (g, m) => n(g, 0) ? i(m.size(), m.storage()) : d(m, g, v, !0))
  }, p, h({
    SS: s,
    DS: l,
    SD: f
  }));
}), kd = "rightLogShift", Z5 = ["typed", "matrix", "equalScalar", "zeros", "DenseMatrix", "concat"], j5 = /* @__PURE__ */ Q(kd, Z5, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    zeros: i,
    DenseMatrix: t,
    concat: u
  } = e, l = fn({
    typed: r
  }), f = At({
    typed: r,
    equalScalar: n
  }), s = Lf({
    typed: r,
    equalScalar: n
  }), a = Dn({
    typed: r,
    DenseMatrix: t
  }), c = Lr({
    typed: r,
    equalScalar: n
  }), d = Et({
    typed: r
  }), h = lr({
    typed: r,
    matrix: o,
    concat: u
  }), p = Uf({
    typed: r,
    matrix: o
  });
  return r(kd, {
    "number, number": gg,
    // 'BigNumber, BigNumber': ..., // TODO: implement BigNumber support for rightLogShift
    "SparseMatrix, number | BigNumber": r.referToSelf((v) => (g, m) => n(m, 0) ? g.clone() : c(g, m, v, !1)),
    "DenseMatrix, number | BigNumber": r.referToSelf((v) => (g, m) => n(m, 0) ? g.clone() : d(g, m, v, !1)),
    "number | BigNumber, SparseMatrix": r.referToSelf((v) => (g, m) => n(g, 0) ? i(m.size(), m.storage()) : a(m, g, v, !0)),
    "number | BigNumber, DenseMatrix": r.referToSelf((v) => (g, m) => n(g, 0) ? i(m.size(), m.storage()) : d(m, g, v, !0))
  }, p, h({
    SS: s,
    DS: l,
    SD: f
  }));
}), Hd = "and", Y5 = ["typed", "matrix", "equalScalar", "zeros", "not", "concat"], nb = /* @__PURE__ */ Q(Hd, Y5, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    zeros: i,
    not: t,
    concat: u
  } = e, l = At({
    typed: r,
    equalScalar: n
  }), f = ao({
    typed: r,
    equalScalar: n
  }), s = Lr({
    typed: r,
    equalScalar: n
  }), a = Et({
    typed: r
  }), c = lr({
    typed: r,
    matrix: o,
    concat: u
  });
  return r(Hd, {
    "number, number": Wu,
    "Complex, Complex": function(h, p) {
      return (h.re !== 0 || h.im !== 0) && (p.re !== 0 || p.im !== 0);
    },
    "BigNumber, BigNumber": function(h, p) {
      return !h.isZero() && !p.isZero() && !h.isNaN() && !p.isNaN();
    },
    "bigint, bigint": Wu,
    "Unit, Unit": r.referToSelf((d) => (h, p) => d(h.value || 0, p.value || 0)),
    "SparseMatrix, any": r.referToSelf((d) => (h, p) => t(p) ? i(h.size(), h.storage()) : s(h, p, d, !1)),
    "DenseMatrix, any": r.referToSelf((d) => (h, p) => t(p) ? i(h.size(), h.storage()) : a(h, p, d, !1)),
    "any, SparseMatrix": r.referToSelf((d) => (h, p) => t(h) ? i(h.size(), h.storage()) : s(p, h, d, !0)),
    "any, DenseMatrix": r.referToSelf((d) => (h, p) => t(h) ? i(h.size(), h.storage()) : a(p, h, d, !0)),
    "Array, any": r.referToSelf((d) => (h, p) => d(o(h), p).valueOf()),
    "any, Array": r.referToSelf((d) => (h, p) => d(h, o(p)).valueOf())
  }, c({
    SS: f,
    DS: l
  }));
}), Oa = "compare", X5 = ["typed", "config", "matrix", "equalScalar", "BigNumber", "Fraction", "DenseMatrix", "concat"], J5 = /* @__PURE__ */ Q(Oa, X5, (e) => {
  var {
    typed: r,
    config: o,
    equalScalar: n,
    matrix: i,
    BigNumber: t,
    Fraction: u,
    DenseMatrix: l,
    concat: f
  } = e, s = Kr({
    typed: r
  }), a = io({
    typed: r,
    equalScalar: n
  }), c = Ir({
    typed: r,
    DenseMatrix: l
  }), d = lr({
    typed: r,
    matrix: i,
    concat: f
  }), h = ei({
    typed: r
  });
  return r(Oa, Q5({
    typed: r,
    config: o
  }), {
    "boolean, boolean": function(v, g) {
      return v === g ? 0 : v > g ? 1 : -1;
    },
    "BigNumber, BigNumber": function(v, g) {
      return Xr(v, g, o.relTol, o.absTol) ? new t(0) : new t(v.cmp(g));
    },
    "bigint, bigint": function(v, g) {
      return v === g ? 0n : v > g ? 1n : -1n;
    },
    "Fraction, Fraction": function(v, g) {
      return new u(v.compare(g));
    },
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, h, d({
    SS: a,
    DS: s,
    Ss: c
  }));
}), Q5 = /* @__PURE__ */ Q(Oa, ["typed", "config"], (e) => {
  var {
    typed: r,
    config: o
  } = e;
  return r(Oa, {
    "number, number": function(i, t) {
      return zr(i, t, o.relTol, o.absTol) ? 0 : i > t ? 1 : -1;
    }
  });
}), eE = function e(r, o) {
  var n = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, i = /(^[ ]*|[ ]*$)/g, t = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, u = /^0x[0-9a-f]+$/i, l = /^0/, f = function(y) {
    return e.insensitive && ("" + y).toLowerCase() || "" + y;
  }, s = f(r).replace(i, "") || "", a = f(o).replace(i, "") || "", c = s.replace(n, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), d = a.replace(n, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"), h = parseInt(s.match(u), 16) || c.length !== 1 && s.match(t) && Date.parse(s), p = parseInt(a.match(u), 16) || h && a.match(t) && Date.parse(a) || null, v, g;
  if (p) {
    if (h < p)
      return -1;
    if (h > p)
      return 1;
  }
  for (var m = 0, x = Math.max(c.length, d.length); m < x; m++) {
    if (v = !(c[m] || "").match(l) && parseFloat(c[m]) || c[m] || 0, g = !(d[m] || "").match(l) && parseFloat(d[m]) || d[m] || 0, isNaN(v) !== isNaN(g))
      return isNaN(v) ? 1 : -1;
    if (typeof v != typeof g && (v += "", g += ""), v < g)
      return -1;
    if (v > g)
      return 1;
  }
  return 0;
};
const Bn = /* @__PURE__ */ Ti(eE);
var Gd = "compareNatural", rE = ["typed", "compare"], tE = /* @__PURE__ */ Q(Gd, rE, (e) => {
  var {
    typed: r,
    compare: o
  } = e, n = o.signatures["boolean,boolean"];
  return r(Gd, {
    "any, any": i
  });
  function i(f, s) {
    var a = fr(f), c = fr(s), d;
    if ((a === "number" || a === "BigNumber" || a === "Fraction") && (c === "number" || c === "BigNumber" || c === "Fraction"))
      return d = o(f, s), d.toString() !== "0" ? d > 0 ? 1 : -1 : Bn(a, c);
    var h = ["Array", "DenseMatrix", "SparseMatrix"];
    if (h.includes(a) || h.includes(c))
      return d = t(i, f, s), d !== 0 ? d : Bn(a, c);
    if (a !== c)
      return Bn(a, c);
    if (a === "Complex")
      return nE(f, s);
    if (a === "Unit")
      return f.equalBase(s) ? i(f.value, s.value) : u(i, f.formatUnits(), s.formatUnits());
    if (a === "boolean")
      return n(f, s);
    if (a === "string")
      return Bn(f, s);
    if (a === "Object")
      return l(i, f, s);
    if (a === "null" || a === "undefined")
      return 0;
    throw new TypeError('Unsupported type of value "' + a + '"');
  }
  function t(f, s, a) {
    return en(s) && en(a) ? u(f, s.toJSON().values, a.toJSON().values) : en(s) ? t(f, s.toArray(), a) : en(a) ? t(f, s, a.toArray()) : gi(s) ? t(f, s.toJSON().data, a) : gi(a) ? t(f, s, a.toJSON().data) : Array.isArray(s) ? Array.isArray(a) ? u(f, s, a) : t(f, s, [a]) : t(f, [s], a);
  }
  function u(f, s, a) {
    for (var c = 0, d = Math.min(s.length, a.length); c < d; c++) {
      var h = f(s[c], a[c]);
      if (h !== 0)
        return h;
    }
    return s.length > a.length ? 1 : s.length < a.length ? -1 : 0;
  }
  function l(f, s, a) {
    var c = Object.keys(s), d = Object.keys(a);
    c.sort(Bn), d.sort(Bn);
    var h = u(f, c, d);
    if (h !== 0)
      return h;
    for (var p = 0; p < c.length; p++) {
      var v = f(s[c[p]], a[d[p]]);
      if (v !== 0)
        return v;
    }
    return 0;
  }
});
function nE(e, r) {
  return e.re > r.re ? 1 : e.re < r.re ? -1 : e.im > r.im ? 1 : e.im < r.im ? -1 : 0;
}
var Vd = "compareText", iE = ["typed", "matrix", "concat"];
Lu.signature = "any, any";
var aE = /* @__PURE__ */ Q(Vd, iE, (e) => {
  var {
    typed: r,
    matrix: o,
    concat: n
  } = e, i = lr({
    typed: r,
    matrix: o,
    concat: n
  });
  return r(Vd, Lu, i({
    elop: Lu,
    Ds: !0
  }));
}), Ra = "equal", oE = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], sE = /* @__PURE__ */ Q(Ra, oE, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    DenseMatrix: i,
    concat: t
  } = e, u = Kr({
    typed: r
  }), l = Mt({
    typed: r,
    DenseMatrix: i
  }), f = Ir({
    typed: r,
    DenseMatrix: i
  }), s = lr({
    typed: r,
    matrix: o,
    concat: t
  });
  return r(Ra, uE({
    typed: r,
    equalScalar: n
  }), s({
    elop: n,
    SS: l,
    DS: u,
    Ss: f
  }));
}), uE = Q(Ra, ["typed", "equalScalar"], (e) => {
  var {
    typed: r,
    equalScalar: o
  } = e;
  return r(Ra, {
    "any, any": function(i, t) {
      return i === null ? t === null : t === null ? i === null : i === void 0 ? t === void 0 : t === void 0 ? i === void 0 : o(i, t);
    }
  });
}), Wd = "equalText", fE = ["typed", "compareText", "isZero"], cE = /* @__PURE__ */ Q(Wd, fE, (e) => {
  var {
    typed: r,
    compareText: o,
    isZero: n
  } = e;
  return r(Wd, {
    "any, any": function(t, u) {
      return n(o(t, u));
    }
  });
}), Pa = "smaller", lE = ["typed", "config", "matrix", "DenseMatrix", "concat"], dE = /* @__PURE__ */ Q(Pa, lE, (e) => {
  var {
    typed: r,
    config: o,
    matrix: n,
    DenseMatrix: i,
    concat: t
  } = e, u = Kr({
    typed: r
  }), l = Mt({
    typed: r,
    DenseMatrix: i
  }), f = Ir({
    typed: r,
    DenseMatrix: i
  }), s = lr({
    typed: r,
    matrix: n,
    concat: t
  }), a = ei({
    typed: r
  });
  return r(Pa, hE({
    typed: r,
    config: o
  }), {
    "boolean, boolean": (c, d) => c < d,
    "BigNumber, BigNumber": function(d, h) {
      return d.lt(h) && !Xr(d, h, o.relTol, o.absTol);
    },
    "bigint, bigint": (c, d) => c < d,
    "Fraction, Fraction": (c, d) => c.compare(d) === -1,
    "Complex, Complex": function(d, h) {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, a, s({
    SS: l,
    DS: u,
    Ss: f
  }));
}), hE = /* @__PURE__ */ Q(Pa, ["typed", "config"], (e) => {
  var {
    typed: r,
    config: o
  } = e;
  return r(Pa, {
    "number, number": function(i, t) {
      return i < t && !zr(i, t, o.relTol, o.absTol);
    }
  });
}), qa = "smallerEq", pE = ["typed", "config", "matrix", "DenseMatrix", "concat"], vE = /* @__PURE__ */ Q(qa, pE, (e) => {
  var {
    typed: r,
    config: o,
    matrix: n,
    DenseMatrix: i,
    concat: t
  } = e, u = Kr({
    typed: r
  }), l = Mt({
    typed: r,
    DenseMatrix: i
  }), f = Ir({
    typed: r,
    DenseMatrix: i
  }), s = lr({
    typed: r,
    matrix: n,
    concat: t
  }), a = ei({
    typed: r
  });
  return r(qa, mE({
    typed: r,
    config: o
  }), {
    "boolean, boolean": (c, d) => c <= d,
    "BigNumber, BigNumber": function(d, h) {
      return d.lte(h) || Xr(d, h, o.relTol, o.absTol);
    },
    "bigint, bigint": (c, d) => c <= d,
    "Fraction, Fraction": (c, d) => c.compare(d) !== 1,
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, a, s({
    SS: l,
    DS: u,
    Ss: f
  }));
}), mE = /* @__PURE__ */ Q(qa, ["typed", "config"], (e) => {
  var {
    typed: r,
    config: o
  } = e;
  return r(qa, {
    "number, number": function(i, t) {
      return i <= t || zr(i, t, o.relTol, o.absTol);
    }
  });
}), $a = "larger", gE = ["typed", "config", "matrix", "DenseMatrix", "concat"], bE = /* @__PURE__ */ Q($a, gE, (e) => {
  var {
    typed: r,
    config: o,
    matrix: n,
    DenseMatrix: i,
    concat: t
  } = e, u = Kr({
    typed: r
  }), l = Mt({
    typed: r,
    DenseMatrix: i
  }), f = Ir({
    typed: r,
    DenseMatrix: i
  }), s = lr({
    typed: r,
    matrix: n,
    concat: t
  }), a = ei({
    typed: r
  });
  return r($a, yE({
    typed: r,
    config: o
  }), {
    "boolean, boolean": (c, d) => c > d,
    "BigNumber, BigNumber": function(d, h) {
      return d.gt(h) && !Xr(d, h, o.relTol, o.absTol);
    },
    "bigint, bigint": (c, d) => c > d,
    "Fraction, Fraction": (c, d) => c.compare(d) === 1,
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, a, s({
    SS: l,
    DS: u,
    Ss: f
  }));
}), yE = /* @__PURE__ */ Q($a, ["typed", "config"], (e) => {
  var {
    typed: r,
    config: o
  } = e;
  return r($a, {
    "number, number": function(i, t) {
      return i > t && !zr(i, t, o.relTol, o.absTol);
    }
  });
}), za = "largerEq", wE = ["typed", "config", "matrix", "DenseMatrix", "concat"], xE = /* @__PURE__ */ Q(za, wE, (e) => {
  var {
    typed: r,
    config: o,
    matrix: n,
    DenseMatrix: i,
    concat: t
  } = e, u = Kr({
    typed: r
  }), l = Mt({
    typed: r,
    DenseMatrix: i
  }), f = Ir({
    typed: r,
    DenseMatrix: i
  }), s = lr({
    typed: r,
    matrix: n,
    concat: t
  }), a = ei({
    typed: r
  });
  return r(za, EE({
    typed: r,
    config: o
  }), {
    "boolean, boolean": (c, d) => c >= d,
    "BigNumber, BigNumber": function(d, h) {
      return d.gte(h) || Xr(d, h, o.relTol, o.absTol);
    },
    "bigint, bigint": function(d, h) {
      return d >= h;
    },
    "Fraction, Fraction": (c, d) => c.compare(d) !== -1,
    "Complex, Complex": function() {
      throw new TypeError("No ordering relation is defined for complex numbers");
    }
  }, a, s({
    SS: l,
    DS: u,
    Ss: f
  }));
}), EE = /* @__PURE__ */ Q(za, ["typed", "config"], (e) => {
  var {
    typed: r,
    config: o
  } = e;
  return r(za, {
    "number, number": function(i, t) {
      return i >= t || zr(i, t, o.relTol, o.absTol);
    }
  });
}), Kd = "deepEqual", AE = ["typed", "equal"], SE = /* @__PURE__ */ Q(Kd, AE, (e) => {
  var {
    typed: r,
    equal: o
  } = e;
  return r(Kd, {
    "any, any": function(t, u) {
      return n(t.valueOf(), u.valueOf());
    }
  });
  function n(i, t) {
    if (Array.isArray(i))
      if (Array.isArray(t)) {
        var u = i.length;
        if (u !== t.length)
          return !1;
        for (var l = 0; l < u; l++)
          if (!n(i[l], t[l]))
            return !1;
        return !0;
      } else
        return !1;
    else
      return Array.isArray(t) ? !1 : o(i, t);
  }
}), La = "unequal", DE = ["typed", "config", "equalScalar", "matrix", "DenseMatrix", "concat"], NE = /* @__PURE__ */ Q(La, DE, (e) => {
  var {
    typed: r,
    config: o,
    equalScalar: n,
    matrix: i,
    DenseMatrix: t,
    concat: u
  } = e, l = Kr({
    typed: r
  }), f = Mt({
    typed: r,
    DenseMatrix: t
  }), s = Ir({
    typed: r,
    DenseMatrix: t
  }), a = lr({
    typed: r,
    matrix: i,
    concat: u
  });
  return r(La, ME({
    typed: r,
    equalScalar: n
  }), a({
    elop: c,
    SS: f,
    DS: l,
    Ss: s
  }));
  function c(d, h) {
    return !n(d, h);
  }
}), ME = Q(La, ["typed", "equalScalar"], (e) => {
  var {
    typed: r,
    equalScalar: o
  } = e;
  return r(La, {
    "any, any": function(i, t) {
      return i === null ? t !== null : t === null ? i !== null : i === void 0 ? t !== void 0 : t === void 0 ? i !== void 0 : !o(i, t);
    }
  });
}), Zd = "partitionSelect", _E = ["typed", "isNumeric", "isNaN", "compare"], CE = /* @__PURE__ */ Q(Zd, _E, (e) => {
  var {
    typed: r,
    isNumeric: o,
    isNaN: n,
    compare: i
  } = e, t = i, u = (s, a) => -i(s, a);
  return r(Zd, {
    "Array | Matrix, number": function(a, c) {
      return l(a, c, t);
    },
    "Array | Matrix, number, string": function(a, c, d) {
      if (d === "asc")
        return l(a, c, t);
      if (d === "desc")
        return l(a, c, u);
      throw new Error('Compare string must be "asc" or "desc"');
    },
    "Array | Matrix, number, function": l
  });
  function l(s, a, c) {
    if (!Te(a) || a < 0)
      throw new Error("k must be a non-negative integer");
    if (Fe(s)) {
      var d = s.size();
      if (d.length > 1)
        throw new Error("Only one dimensional matrices supported");
      return f(s.valueOf(), a, c);
    }
    if (Array.isArray(s))
      return f(s, a, c);
  }
  function f(s, a, c) {
    if (a >= s.length)
      throw new Error("k out of bounds");
    for (var d = 0; d < s.length; d++)
      if (o(s[d]) && n(s[d]))
        return s[d];
    for (var h = 0, p = s.length - 1; h < p; ) {
      for (var v = h, g = p, m = s[Math.floor(Math.random() * (p - h + 1)) + h]; v < g; )
        if (c(s[v], m) >= 0) {
          var x = s[g];
          s[g] = s[v], s[v] = x, --g;
        } else
          ++v;
      c(s[v], m) > 0 && --v, a <= v ? p = v : h = v + 1;
    }
    return s[a];
  }
}), jd = "sort", TE = ["typed", "matrix", "compare", "compareNatural"], BE = /* @__PURE__ */ Q(jd, TE, (e) => {
  var {
    typed: r,
    matrix: o,
    compare: n,
    compareNatural: i
  } = e, t = n, u = (a, c) => -n(a, c);
  return r(jd, {
    Array: function(c) {
      return f(c), c.sort(t);
    },
    Matrix: function(c) {
      return s(c), o(c.toArray().sort(t), c.storage());
    },
    "Array, function": function(c, d) {
      return f(c), c.sort(d);
    },
    "Matrix, function": function(c, d) {
      return s(c), o(c.toArray().sort(d), c.storage());
    },
    "Array, string": function(c, d) {
      return f(c), c.sort(l(d));
    },
    "Matrix, string": function(c, d) {
      return s(c), o(c.toArray().sort(l(d)), c.storage());
    }
  });
  function l(a) {
    if (a === "asc")
      return t;
    if (a === "desc")
      return u;
    if (a === "natural")
      return i;
    throw new Error('String "asc", "desc", or "natural" expected');
  }
  function f(a) {
    if (ze(a).length !== 1)
      throw new Error("One dimensional array expected");
  }
  function s(a) {
    if (a.size().length !== 1)
      throw new Error("One dimensional matrix expected");
  }
}), Yd = "max", FE = ["typed", "config", "numeric", "larger"], ib = /* @__PURE__ */ Q(Yd, FE, (e) => {
  var {
    typed: r,
    config: o,
    numeric: n,
    larger: i
  } = e;
  return r(Yd, {
    // max([a, b, c, d, ...])
    "Array | Matrix": u,
    // max([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(f, s) {
      return no(f, s.valueOf(), t);
    },
    // max(a, b, c, d, ...)
    "...": function(f) {
      if (Xn(f))
        throw new TypeError("Scalar values expected in function max");
      return u(f);
    }
  });
  function t(l, f) {
    try {
      return i(l, f) ? l : f;
    } catch (s) {
      throw Wr(s, "max", f);
    }
  }
  function u(l) {
    var f;
    if (Wt(l, function(s) {
      try {
        isNaN(s) && typeof s == "number" ? f = NaN : (f === void 0 || i(s, f)) && (f = s);
      } catch (a) {
        throw Wr(a, "max", s);
      }
    }), f === void 0)
      throw new Error("Cannot calculate max of an empty array");
    return typeof f == "string" && (f = n(f, sn(f, o))), f;
  }
}), Xd = "min", IE = ["typed", "config", "numeric", "smaller"], ab = /* @__PURE__ */ Q(Xd, IE, (e) => {
  var {
    typed: r,
    config: o,
    numeric: n,
    smaller: i
  } = e;
  return r(Xd, {
    // min([a, b, c, d, ...])
    "Array | Matrix": u,
    // min([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(f, s) {
      return no(f, s.valueOf(), t);
    },
    // min(a, b, c, d, ...)
    "...": function(f) {
      if (Xn(f))
        throw new TypeError("Scalar values expected in function min");
      return u(f);
    }
  });
  function t(l, f) {
    try {
      return i(l, f) ? l : f;
    } catch (s) {
      throw Wr(s, "min", f);
    }
  }
  function u(l) {
    var f;
    if (Wt(l, function(s) {
      try {
        isNaN(s) && typeof s == "number" ? f = NaN : (f === void 0 || i(s, f)) && (f = s);
      } catch (a) {
        throw Wr(a, "min", s);
      }
    }), f === void 0)
      throw new Error("Cannot calculate min of an empty array");
    return typeof f == "string" && (f = n(f, sn(f, o))), f;
  }
}), OE = "ImmutableDenseMatrix", RE = ["smaller", "DenseMatrix"], PE = /* @__PURE__ */ Q(OE, RE, (e) => {
  var {
    smaller: r,
    DenseMatrix: o
  } = e;
  function n(i, t) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (t && !qr(t))
      throw new Error("Invalid datatype: " + t);
    if (Fe(i) || ar(i)) {
      var u = new o(i, t);
      this._data = u._data, this._size = u._size, this._datatype = u._datatype, this._min = null, this._max = null;
    } else if (i && ar(i.data) && ar(i.size))
      this._data = i.data, this._size = i.size, this._datatype = i.datatype, this._min = typeof i.min < "u" ? i.min : null, this._max = typeof i.max < "u" ? i.max : null;
    else {
      if (i)
        throw new TypeError("Unsupported type of data (" + fr(i) + ")");
      this._data = [], this._size = [0], this._datatype = t, this._min = null, this._max = null;
    }
  }
  return n.prototype = new o(), n.prototype.type = "ImmutableDenseMatrix", n.prototype.isImmutableDenseMatrix = !0, n.prototype.subset = function(i) {
    switch (arguments.length) {
      case 1: {
        var t = o.prototype.subset.call(this, i);
        return Fe(t) ? new n({
          data: t._data,
          size: t._size,
          datatype: t._datatype
        }) : t;
      }
      case 2:
      case 3:
        throw new Error("Cannot invoke set subset on an Immutable Matrix instance");
      default:
        throw new SyntaxError("Wrong number of arguments");
    }
  }, n.prototype.set = function() {
    throw new Error("Cannot invoke set on an Immutable Matrix instance");
  }, n.prototype.resize = function() {
    throw new Error("Cannot invoke resize on an Immutable Matrix instance");
  }, n.prototype.reshape = function() {
    throw new Error("Cannot invoke reshape on an Immutable Matrix instance");
  }, n.prototype.clone = function() {
    return new n({
      data: Ie(this._data),
      size: Ie(this._size),
      datatype: this._datatype
    });
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "ImmutableDenseMatrix",
      data: this._data,
      size: this._size,
      datatype: this._datatype
    };
  }, n.fromJSON = function(i) {
    return new n(i);
  }, n.prototype.swapRows = function() {
    throw new Error("Cannot invoke swapRows on an Immutable Matrix instance");
  }, n.prototype.min = function() {
    if (this._min === null) {
      var i = null;
      this.forEach(function(t) {
        (i === null || r(t, i)) && (i = t);
      }), this._min = i !== null ? i : void 0;
    }
    return this._min;
  }, n.prototype.max = function() {
    if (this._max === null) {
      var i = null;
      this.forEach(function(t) {
        (i === null || r(i, t)) && (i = t);
      }), this._max = i !== null ? i : void 0;
    }
    return this._max;
  }, n;
}, {
  isClass: !0
}), qE = "Index", $E = ["ImmutableDenseMatrix", "getMatrixDataType"], zE = /* @__PURE__ */ Q(qE, $E, (e) => {
  var {
    ImmutableDenseMatrix: r,
    getMatrixDataType: o
  } = e;
  function n(t) {
    if (!(this instanceof n))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._dimensions = [], this._sourceSize = [], this._isScalar = !0;
    for (var u = 0, l = arguments.length; u < l; u++) {
      var f = arguments[u], s = ar(f), a = Fe(f), c = null;
      if (Ya(f))
        this._dimensions.push(f), this._isScalar = !1;
      else if (s || a) {
        var d = void 0;
        o(f) === "boolean" ? (s && (d = i(Jd(f).valueOf())), a && (d = i(Jd(f._data).valueOf())), c = f.valueOf().length) : d = i(f.valueOf()), this._dimensions.push(d);
        var h = d.size();
        (h.length !== 1 || h[0] !== 1 || c !== null) && (this._isScalar = !1);
      } else if (typeof f == "number")
        this._dimensions.push(i([f]));
      else if (typeof f == "string")
        this._dimensions.push(f);
      else
        throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
      this._sourceSize.push(c);
    }
  }
  n.prototype.type = "Index", n.prototype.isIndex = !0;
  function i(t) {
    for (var u = 0, l = t.length; u < l; u++)
      if (typeof t[u] != "number" || !Te(t[u]))
        throw new TypeError("Index parameters must be positive integer numbers");
    return new r(t);
  }
  return n.prototype.clone = function() {
    var t = new n();
    return t._dimensions = Ie(this._dimensions), t._isScalar = this._isScalar, t._sourceSize = this._sourceSize, t;
  }, n.create = function(t) {
    var u = new n();
    return n.apply(u, t), u;
  }, n.prototype.size = function() {
    for (var t = [], u = 0, l = this._dimensions.length; u < l; u++) {
      var f = this._dimensions[u];
      t[u] = typeof f == "string" ? 1 : f.size()[0];
    }
    return t;
  }, n.prototype.max = function() {
    for (var t = [], u = 0, l = this._dimensions.length; u < l; u++) {
      var f = this._dimensions[u];
      t[u] = typeof f == "string" ? f : f.max();
    }
    return t;
  }, n.prototype.min = function() {
    for (var t = [], u = 0, l = this._dimensions.length; u < l; u++) {
      var f = this._dimensions[u];
      t[u] = typeof f == "string" ? f : f.min();
    }
    return t;
  }, n.prototype.forEach = function(t) {
    for (var u = 0, l = this._dimensions.length; u < l; u++)
      t(this._dimensions[u], u, this);
  }, n.prototype.dimension = function(t) {
    return this._dimensions[t] || null;
  }, n.prototype.isObjectProperty = function() {
    return this._dimensions.length === 1 && typeof this._dimensions[0] == "string";
  }, n.prototype.getObjectProperty = function() {
    return this.isObjectProperty() ? this._dimensions[0] : null;
  }, n.prototype.isScalar = function() {
    return this._isScalar;
  }, n.prototype.toArray = function() {
    for (var t = [], u = 0, l = this._dimensions.length; u < l; u++) {
      var f = this._dimensions[u];
      t.push(typeof f == "string" ? f : f.toArray());
    }
    return t;
  }, n.prototype.valueOf = n.prototype.toArray, n.prototype.toString = function() {
    for (var t = [], u = 0, l = this._dimensions.length; u < l; u++) {
      var f = this._dimensions[u];
      typeof f == "string" ? t.push(JSON.stringify(f)) : t.push(f.toString());
    }
    return "[" + t.join(", ") + "]";
  }, n.prototype.toJSON = function() {
    return {
      mathjs: "Index",
      dimensions: this._dimensions
    };
  }, n.fromJSON = function(t) {
    return n.create(t.dimensions);
  }, n;
}, {
  isClass: !0
});
function Jd(e) {
  var r = [];
  return e.forEach((o, n) => {
    o && r.push(n);
  }), r;
}
var LE = "FibonacciHeap", UE = ["smaller", "larger"], kE = /* @__PURE__ */ Q(LE, UE, (e) => {
  var {
    smaller: r,
    larger: o
  } = e, n = 1 / Math.log((1 + Math.sqrt(5)) / 2);
  function i() {
    if (!(this instanceof i))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._minimum = null, this._size = 0;
  }
  i.prototype.type = "FibonacciHeap", i.prototype.isFibonacciHeap = !0, i.prototype.insert = function(a, c) {
    var d = {
      key: a,
      value: c,
      degree: 0
    };
    if (this._minimum) {
      var h = this._minimum;
      d.left = h, d.right = h.right, h.right = d, d.right.left = d, r(a, h.key) && (this._minimum = d);
    } else
      d.left = d, d.right = d, this._minimum = d;
    return this._size++, d;
  }, i.prototype.size = function() {
    return this._size;
  }, i.prototype.clear = function() {
    this._minimum = null, this._size = 0;
  }, i.prototype.isEmpty = function() {
    return this._size === 0;
  }, i.prototype.extractMinimum = function() {
    var a = this._minimum;
    if (a === null)
      return a;
    for (var c = this._minimum, d = a.degree, h = a.child; d > 0; ) {
      var p = h.right;
      h.left.right = h.right, h.right.left = h.left, h.left = c, h.right = c.right, c.right = h, h.right.left = h, h.parent = null, h = p, d--;
    }
    return a.left.right = a.right, a.right.left = a.left, a === a.right ? c = null : (c = a.right, c = s(c, this._size)), this._size--, this._minimum = c, a;
  }, i.prototype.remove = function(a) {
    this._minimum = t(this._minimum, a, -1), this.extractMinimum();
  };
  function t(a, c, d) {
    c.key = d;
    var h = c.parent;
    return h && r(c.key, h.key) && (u(a, c, h), l(a, h)), r(c.key, a.key) && (a = c), a;
  }
  function u(a, c, d) {
    c.left.right = c.right, c.right.left = c.left, d.degree--, d.child === c && (d.child = c.right), d.degree === 0 && (d.child = null), c.left = a, c.right = a.right, a.right = c, c.right.left = c, c.parent = null, c.mark = !1;
  }
  function l(a, c) {
    var d = c.parent;
    d && (c.mark ? (u(a, c, d), l(d)) : c.mark = !0);
  }
  var f = function(c, d) {
    c.left.right = c.right, c.right.left = c.left, c.parent = d, d.child ? (c.left = d.child, c.right = d.child.right, d.child.right = c, c.right.left = c) : (d.child = c, c.right = c, c.left = c), d.degree++, c.mark = !1;
  };
  function s(a, c) {
    var d = Math.floor(Math.log(c) * n) + 1, h = new Array(d), p = 0, v = a;
    if (v)
      for (p++, v = v.right; v !== a; )
        p++, v = v.right;
    for (var g; p > 0; ) {
      for (var m = v.degree, x = v.right; g = h[m], !!g; ) {
        if (o(v.key, g.key)) {
          var y = g;
          g = v, v = y;
        }
        f(g, v), h[m] = null, m++;
      }
      h[m] = v, v = x, p--;
    }
    a = null;
    for (var E = 0; E < d; E++)
      g = h[E], g && (a ? (g.left.right = g.right, g.right.left = g.left, g.left = a, g.right = a.right, a.right = g, g.right.left = g, r(g.key, a.key) && (a = g)) : a = g);
    return a;
  }
  return i;
}, {
  isClass: !0
}), HE = "Spa", GE = ["addScalar", "equalScalar", "FibonacciHeap"], VE = /* @__PURE__ */ Q(HE, GE, (e) => {
  var {
    addScalar: r,
    equalScalar: o,
    FibonacciHeap: n
  } = e;
  function i() {
    if (!(this instanceof i))
      throw new SyntaxError("Constructor must be called with the new operator");
    this._values = [], this._heap = new n();
  }
  return i.prototype.type = "Spa", i.prototype.isSpa = !0, i.prototype.set = function(t, u) {
    if (this._values[t])
      this._values[t].value = u;
    else {
      var l = this._heap.insert(t, u);
      this._values[t] = l;
    }
  }, i.prototype.get = function(t) {
    var u = this._values[t];
    return u ? u.value : 0;
  }, i.prototype.accumulate = function(t, u) {
    var l = this._values[t];
    l ? l.value = r(l.value, u) : (l = this._heap.insert(t, u), this._values[t] = l);
  }, i.prototype.forEach = function(t, u, l) {
    var f = this._heap, s = this._values, a = [], c = f.extractMinimum();
    for (c && a.push(c); c && c.key <= u; )
      c.key >= t && (o(c.value, 0) || l(c.key, c.value, this)), c = f.extractMinimum(), c && a.push(c);
    for (var d = 0; d < a.length; d++) {
      var h = a[d];
      c = f.insert(h.key, h.value), s[c.key] = c;
    }
  }, i.prototype.swap = function(t, u) {
    var l = this._values[t], f = this._values[u];
    if (!l && f)
      l = this._heap.insert(t, f.value), this._heap.remove(f), this._values[t] = l, this._values[u] = void 0;
    else if (l && !f)
      f = this._heap.insert(u, l.value), this._heap.remove(l), this._values[u] = f, this._values[t] = void 0;
    else if (l && f) {
      var s = l.value;
      l.value = f.value, f.value = s;
    }
  }, i;
}, {
  isClass: !0
}), WE = Bi(function(e) {
  return new e(1).exp();
}, {
  hasher: oo
}), KE = Bi(function(e) {
  return new e(1).plus(new e(5).sqrt()).div(2);
}, {
  hasher: oo
}), kf = Bi(function(e) {
  return e.acos(-1);
}, {
  hasher: oo
}), ZE = Bi(function(e) {
  return kf(e).times(2);
}, {
  hasher: oo
});
function oo(e) {
  return e[0].precision;
}
function Qd(e, r) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), o.push.apply(o, n);
  }
  return o;
}
function xo(e) {
  for (var r = 1; r < arguments.length; r++) {
    var o = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Qd(Object(o), !0).forEach(function(n) {
      Fr(e, n, o[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : Qd(Object(o)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(o, n));
    });
  }
  return e;
}
var jE = "Unit", YE = ["?on", "config", "addScalar", "subtractScalar", "multiplyScalar", "divideScalar", "pow", "abs", "fix", "round", "equal", "isNumeric", "format", "number", "Complex", "BigNumber", "Fraction"], XE = /* @__PURE__ */ Q(jE, YE, (e) => {
  var {
    on: r,
    config: o,
    addScalar: n,
    subtractScalar: i,
    multiplyScalar: t,
    divideScalar: u,
    pow: l,
    abs: f,
    fix: s,
    round: a,
    equal: c,
    isNumeric: d,
    format: h,
    number: p,
    Complex: v,
    BigNumber: g,
    Fraction: m
  } = e, x = p;
  function y(Y, k) {
    if (!(this instanceof y))
      throw new Error("Constructor must be called with the new operator");
    if (!(Y == null || d(Y) || yt(Y)))
      throw new TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");
    if (this.fixPrefix = !1, this.skipAutomaticSimplification = !0, k === void 0)
      this.units = [], this.dimensions = q.map((P) => 0);
    else if (typeof k == "string") {
      var L = y.parse(k);
      this.units = L.units, this.dimensions = L.dimensions;
    } else if (jr(k) && k.value === null)
      this.fixPrefix = k.fixPrefix, this.skipAutomaticSimplification = k.skipAutomaticSimplification, this.dimensions = k.dimensions.slice(0), this.units = k.units.map((P) => kr({}, P));
    else
      throw new TypeError("Second parameter in Unit constructor must be a string or valueless Unit");
    this.value = this._normalize(Y);
  }
  Object.defineProperty(y, "name", {
    value: "Unit"
  }), y.prototype.constructor = y, y.prototype.type = "Unit", y.prototype.isUnit = !0;
  var E, N, S;
  function R() {
    for (; S === " " || S === "	"; )
      $();
  }
  function O(Y) {
    return Y >= "0" && Y <= "9" || Y === ".";
  }
  function B(Y) {
    return Y >= "0" && Y <= "9";
  }
  function $() {
    N++, S = E.charAt(N);
  }
  function F(Y) {
    N = Y, S = E.charAt(N);
  }
  function w() {
    var Y = "", k = N;
    if (S === "+" ? $() : S === "-" && (Y += S, $()), !O(S))
      return F(k), null;
    if (S === ".") {
      if (Y += S, $(), !B(S))
        return F(k), null;
    } else {
      for (; B(S); )
        Y += S, $();
      S === "." && (Y += S, $());
    }
    for (; B(S); )
      Y += S, $();
    if (S === "E" || S === "e") {
      var L = "", P = N;
      if (L += S, $(), (S === "+" || S === "-") && (L += S, $()), !B(S))
        return F(P), Y;
      for (Y = Y + L; B(S); )
        Y += S, $();
    }
    return Y;
  }
  function A() {
    for (var Y = ""; B(S) || y.isValidAlpha(S); )
      Y += S, $();
    var k = Y.charAt(0);
    return y.isValidAlpha(k) ? Y : null;
  }
  function b(Y) {
    return S === Y ? ($(), Y) : null;
  }
  y.parse = function(Y, k) {
    if (k = k || {}, E = Y, N = -1, S = "", typeof E != "string")
      throw new TypeError("Invalid argument in Unit.parse, string expected");
    var L = new y();
    L.units = [];
    var P = 1, G = !1;
    $(), R();
    var j = w(), re = null;
    if (j) {
      if (o.number === "BigNumber")
        re = new g(j);
      else if (o.number === "Fraction")
        try {
          re = new m(j);
        } catch {
          re = parseFloat(j);
        }
      else
        re = parseFloat(j);
      R(), b("*") ? (P = 1, G = !0) : b("/") && (P = -1, G = !0);
    }
    for (var ie = [], Z = 1; ; ) {
      for (R(); S === "("; )
        ie.push(P), Z *= P, P = 1, $(), R();
      var X = void 0;
      if (S) {
        var oe = S;
        if (X = A(), X === null)
          throw new SyntaxError('Unexpected "' + oe + '" in "' + E + '" at index ' + N.toString());
      } else
        break;
      var ce = D(X);
      if (ce === null)
        throw new SyntaxError('Unit "' + X + '" not found.');
      var le = P * Z;
      if (R(), b("^")) {
        R();
        var ve = w();
        if (ve === null)
          throw new SyntaxError('In "' + Y + '", "^" must be followed by a floating-point number');
        le *= ve;
      }
      L.units.push({
        unit: ce.unit,
        prefix: ce.prefix,
        power: le
      });
      for (var ge = 0; ge < q.length; ge++)
        L.dimensions[ge] += (ce.unit.dimensions[ge] || 0) * le;
      for (R(); S === ")"; ) {
        if (ie.length === 0)
          throw new SyntaxError('Unmatched ")" in "' + E + '" at index ' + N.toString());
        Z /= ie.pop(), $(), R();
      }
      if (G = !1, b("*") ? (P = 1, G = !0) : b("/") ? (P = -1, G = !0) : P = 1, ce.unit.base) {
        var me = ce.unit.base.key;
        K.auto[me] = {
          unit: ce.unit,
          prefix: ce.prefix
        };
      }
    }
    if (R(), S)
      throw new SyntaxError('Could not parse: "' + Y + '"');
    if (G)
      throw new SyntaxError('Trailing characters: "' + Y + '"');
    if (ie.length !== 0)
      throw new SyntaxError('Unmatched "(" in "' + E + '"');
    if (L.units.length === 0 && !k.allowNoUnits)
      throw new SyntaxError('"' + Y + '" contains no units');
    return L.value = re !== void 0 ? L._normalize(re) : null, L;
  }, y.prototype.clone = function() {
    var Y = new y();
    Y.fixPrefix = this.fixPrefix, Y.skipAutomaticSimplification = this.skipAutomaticSimplification, Y.value = Ie(this.value), Y.dimensions = this.dimensions.slice(0), Y.units = [];
    for (var k = 0; k < this.units.length; k++) {
      Y.units[k] = {};
      for (var L in this.units[k])
        De(this.units[k], L) && (Y.units[k][L] = this.units[k][L]);
    }
    return Y;
  }, y.prototype.valueType = function() {
    return fr(this.value);
  }, y.prototype._isDerived = function() {
    return this.units.length === 0 ? !1 : this.units.length > 1 || Math.abs(this.units[0].power - 1) > 1e-15;
  }, y.prototype._normalize = function(Y) {
    if (Y == null || this.units.length === 0)
      return Y;
    for (var k = Y, L = y._getNumberConverter(fr(Y)), P = 0; P < this.units.length; P++) {
      var G = L(this.units[P].unit.value), j = L(this.units[P].prefix.value), re = L(this.units[P].power);
      k = t(k, l(t(G, j), re));
    }
    return k;
  }, y.prototype._denormalize = function(Y, k) {
    if (Y == null || this.units.length === 0)
      return Y;
    for (var L = Y, P = y._getNumberConverter(fr(Y)), G = 0; G < this.units.length; G++) {
      var j = P(this.units[G].unit.value), re = P(this.units[G].prefix.value), ie = P(this.units[G].power);
      L = u(L, l(t(j, re), ie));
    }
    return L;
  };
  var D = Bi((Y) => {
    if (De(U, Y)) {
      var k = U[Y], L = k.prefixes[""];
      return {
        unit: k,
        prefix: L
      };
    }
    for (var P in U)
      if (De(U, P) && ux(Y, P)) {
        var G = U[P], j = Y.length - P.length, re = Y.substring(0, j), ie = De(G.prefixes, re) ? G.prefixes[re] : void 0;
        if (ie !== void 0)
          return {
            unit: G,
            prefix: ie
          };
      }
    return null;
  }, {
    hasher: (Y) => Y[0],
    limit: 100
  });
  y.isValuelessUnit = function(Y) {
    return D(Y) !== null;
  }, y.prototype.hasBase = function(Y) {
    if (typeof Y == "string" && (Y = C[Y]), !Y)
      return !1;
    for (var k = 0; k < q.length; k++)
      if (Math.abs((this.dimensions[k] || 0) - (Y.dimensions[k] || 0)) > 1e-12)
        return !1;
    return !0;
  }, y.prototype.equalBase = function(Y) {
    for (var k = 0; k < q.length; k++)
      if (Math.abs((this.dimensions[k] || 0) - (Y.dimensions[k] || 0)) > 1e-12)
        return !1;
    return !0;
  }, y.prototype.equals = function(Y) {
    return this.equalBase(Y) && c(this.value, Y.value);
  }, y.prototype.multiply = function(Y) {
    for (var k = this.clone(), L = jr(Y) ? Y : new y(Y), P = 0; P < q.length; P++)
      k.dimensions[P] = (this.dimensions[P] || 0) + (L.dimensions[P] || 0);
    for (var G = 0; G < L.units.length; G++) {
      var j = xo({}, L.units[G]);
      k.units.push(j);
    }
    if (this.value !== null || L.value !== null) {
      var re = this.value === null ? this._normalize(1) : this.value, ie = L.value === null ? L._normalize(1) : L.value;
      k.value = t(re, ie);
    } else
      k.value = null;
    return jr(Y) && (k.skipAutomaticSimplification = !1), M(k);
  }, y.prototype.divideInto = function(Y) {
    return new y(Y).divide(this);
  }, y.prototype.divide = function(Y) {
    for (var k = this.clone(), L = jr(Y) ? Y : new y(Y), P = 0; P < q.length; P++)
      k.dimensions[P] = (this.dimensions[P] || 0) - (L.dimensions[P] || 0);
    for (var G = 0; G < L.units.length; G++) {
      var j = xo(xo({}, L.units[G]), {}, {
        power: -L.units[G].power
      });
      k.units.push(j);
    }
    if (this.value !== null || L.value !== null) {
      var re = this.value === null ? this._normalize(1) : this.value, ie = L.value === null ? L._normalize(1) : L.value;
      k.value = u(re, ie);
    } else
      k.value = null;
    return jr(Y) && (k.skipAutomaticSimplification = !1), M(k);
  }, y.prototype.pow = function(Y) {
    for (var k = this.clone(), L = 0; L < q.length; L++)
      k.dimensions[L] = (this.dimensions[L] || 0) * Y;
    for (var P = 0; P < k.units.length; P++)
      k.units[P].power *= Y;
    return k.value !== null ? k.value = l(k.value, Y) : k.value = null, k.skipAutomaticSimplification = !1, M(k);
  };
  function M(Y) {
    return Y.equalBase(C.NONE) && Y.value !== null && !o.predictable ? Y.value : Y;
  }
  y.prototype.abs = function() {
    var Y = this.clone();
    if (Y.value !== null)
      if (Y._isDerived() || Y.units.length === 0 || Y.units[0].unit.offset === 0)
        Y.value = f(Y.value);
      else {
        var k = Y._numberConverter(), L = k(Y.units[0].unit.value), P = k(Y.units[0].unit.offset), G = t(L, P);
        Y.value = i(f(n(Y.value, G)), G);
      }
    for (var j in Y.units)
      (Y.units[j].unit.name === "VA" || Y.units[j].unit.name === "VAR") && (Y.units[j].unit = U.W);
    return Y;
  }, y.prototype.to = function(Y) {
    var k = this.value === null ? this._normalize(1) : this.value, L;
    if (typeof Y == "string")
      L = y.parse(Y);
    else if (jr(Y))
      L = Y.clone();
    else
      throw new Error("String or Unit expected as parameter");
    if (!this.equalBase(L))
      throw new Error("Units do not match ('".concat(L.toString(), "' != '").concat(this.toString(), "')"));
    if (L.value !== null)
      throw new Error("Cannot convert to a unit with a value");
    if (this.value === null || this._isDerived() || this.units.length === 0 || L.units.length === 0 || this.units[0].unit.offset === L.units[0].unit.offset)
      L.value = Ie(k);
    else {
      var P = y._getNumberConverter(fr(k)), G = this.units[0].unit.value, j = this.units[0].unit.offset, re = t(G, j), ie = L.units[0].unit.value, Z = L.units[0].unit.offset, X = t(ie, Z);
      L.value = n(k, P(i(re, X)));
    }
    return L.fixPrefix = !0, L.skipAutomaticSimplification = !0, L;
  }, y.prototype.toNumber = function(Y) {
    return x(this.toNumeric(Y));
  }, y.prototype.toNumeric = function(Y) {
    var k;
    return Y ? k = this.to(Y) : k = this.clone(), k._isDerived() || k.units.length === 0 ? k._denormalize(k.value) : k._denormalize(k.value, k.units[0].prefix.value);
  }, y.prototype.toString = function() {
    return this.format();
  }, y.prototype.toJSON = function() {
    return {
      mathjs: "Unit",
      value: this._denormalize(this.value),
      unit: this.units.length > 0 ? this.formatUnits() : null,
      fixPrefix: this.fixPrefix
    };
  }, y.fromJSON = function(Y) {
    var k, L = new y(Y.value, (k = Y.unit) !== null && k !== void 0 ? k : void 0);
    return L.fixPrefix = Y.fixPrefix || !1, L;
  }, y.prototype.valueOf = y.prototype.toString, y.prototype.simplify = function() {
    var Y = this.clone(), k = [], L;
    for (var P in J)
      if (De(J, P) && Y.hasBase(C[P])) {
        L = P;
        break;
      }
    if (L === "NONE")
      Y.units = [];
    else {
      var G;
      if (L && De(J, L) && (G = J[L]), G)
        Y.units = [{
          unit: G.unit,
          prefix: G.prefix,
          power: 1
        }];
      else {
        for (var j = !1, re = 0; re < q.length; re++) {
          var ie = q[re];
          Math.abs(Y.dimensions[re] || 0) > 1e-12 && (De(J, ie) ? k.push({
            unit: J[ie].unit,
            prefix: J[ie].prefix,
            power: Y.dimensions[re] || 0
          }) : j = !0);
        }
        k.length < Y.units.length && !j && (Y.units = k);
      }
    }
    return Y;
  }, y.prototype.toSI = function() {
    for (var Y = this.clone(), k = [], L = 0; L < q.length; L++) {
      var P = q[L];
      if (Math.abs(Y.dimensions[L] || 0) > 1e-12)
        if (De(K.si, P))
          k.push({
            unit: K.si[P].unit,
            prefix: K.si[P].prefix,
            power: Y.dimensions[L] || 0
          });
        else
          throw new Error("Cannot express custom unit " + P + " in SI units");
    }
    return Y.units = k, Y.fixPrefix = !0, Y.skipAutomaticSimplification = !0, this.value !== null ? (Y.value = null, this.to(Y)) : Y;
  }, y.prototype.formatUnits = function() {
    for (var Y = "", k = "", L = 0, P = 0, G = 0; G < this.units.length; G++)
      this.units[G].power > 0 ? (L++, Y += " " + this.units[G].prefix.name + this.units[G].unit.name, Math.abs(this.units[G].power - 1) > 1e-15 && (Y += "^" + this.units[G].power)) : this.units[G].power < 0 && P++;
    if (P > 0)
      for (var j = 0; j < this.units.length; j++)
        this.units[j].power < 0 && (L > 0 ? (k += " " + this.units[j].prefix.name + this.units[j].unit.name, Math.abs(this.units[j].power + 1) > 1e-15 && (k += "^" + -this.units[j].power)) : (k += " " + this.units[j].prefix.name + this.units[j].unit.name, k += "^" + this.units[j].power));
    Y = Y.substr(1), k = k.substr(1), L > 1 && P > 0 && (Y = "(" + Y + ")"), P > 1 && L > 0 && (k = "(" + k + ")");
    var re = Y;
    return L > 0 && P > 0 && (re += " / "), re += k, re;
  }, y.prototype.format = function(Y) {
    var k = this.skipAutomaticSimplification || this.value === null ? this.clone() : this.simplify(), L = !1;
    typeof k.value < "u" && k.value !== null && yt(k.value) && (L = Math.abs(k.value.re) < 1e-14);
    for (var P in k.units)
      De(k.units, P) && k.units[P].unit && (k.units[P].unit.name === "VA" && L ? k.units[P].unit = U.VAR : k.units[P].unit.name === "VAR" && !L && (k.units[P].unit = U.VA));
    k.units.length === 1 && !k.fixPrefix && Math.abs(k.units[0].power - Math.round(k.units[0].power)) < 1e-14 && (k.units[0].prefix = k._bestPrefix());
    var G = k._denormalize(k.value), j = k.value !== null ? h(G, Y || {}) : "", re = k.formatUnits();
    return k.value && yt(k.value) && (j = "(" + j + ")"), re.length > 0 && j.length > 0 && (j += " "), j += re, j;
  }, y.prototype._bestPrefix = function() {
    if (this.units.length !== 1)
      throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    if (Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14)
      throw new Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");
    var Y = this.value !== null ? f(this.value) : 0, k = f(this.units[0].unit.value), L = this.units[0].prefix;
    if (Y === 0)
      return L;
    var P = this.units[0].power, G = Math.log(Y / Math.pow(L.value * k, P)) / Math.LN10 - 1.2;
    if (G > -2.200001 && G < 1.800001)
      return L;
    G = Math.abs(G);
    var j = this.units[0].unit.prefixes;
    for (var re in j)
      if (De(j, re)) {
        var ie = j[re];
        if (ie.scientific) {
          var Z = Math.abs(Math.log(Y / Math.pow(ie.value * k, P)) / Math.LN10 - 1.2);
          (Z < G || Z === G && ie.name.length < L.name.length) && (L = ie, G = Z);
        }
      }
    return L;
  }, y.prototype.splitUnit = function(Y) {
    for (var k = this.clone(), L = [], P = 0; P < Y.length && (k = k.to(Y[P]), P !== Y.length - 1); P++) {
      var G = k.toNumeric(), j = a(G), re = void 0, ie = c(j, G);
      ie ? re = j : re = s(k.toNumeric());
      var Z = new y(re, Y[P].toString());
      L.push(Z), k = i(k, Z);
    }
    for (var X = 0, oe = 0; oe < L.length; oe++)
      X = n(X, L[oe].value);
    return c(X, this.value) && (k.value = 0), L.push(k), L;
  };
  var _ = {
    NONE: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      }
    },
    SHORT: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 10,
        scientific: !1
      },
      h: {
        name: "h",
        value: 100,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e3,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e6,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e9,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e12,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e15,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e18,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e21,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e24,
        scientific: !0
      },
      R: {
        name: "R",
        value: 1e27,
        scientific: !0
      },
      Q: {
        name: "Q",
        value: 1e30,
        scientific: !0
      },
      d: {
        name: "d",
        value: 0.1,
        scientific: !1
      },
      c: {
        name: "c",
        value: 0.01,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-3,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-6,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-9,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-12,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-15,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-18,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-21,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-24,
        scientific: !0
      },
      r: {
        name: "r",
        value: 1e-27,
        scientific: !0
      },
      q: {
        name: "q",
        value: 1e-30,
        scientific: !0
      }
    },
    LONG: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      deca: {
        name: "deca",
        value: 10,
        scientific: !1
      },
      hecto: {
        name: "hecto",
        value: 100,
        scientific: !1
      },
      kilo: {
        name: "kilo",
        value: 1e3,
        scientific: !0
      },
      mega: {
        name: "mega",
        value: 1e6,
        scientific: !0
      },
      giga: {
        name: "giga",
        value: 1e9,
        scientific: !0
      },
      tera: {
        name: "tera",
        value: 1e12,
        scientific: !0
      },
      peta: {
        name: "peta",
        value: 1e15,
        scientific: !0
      },
      exa: {
        name: "exa",
        value: 1e18,
        scientific: !0
      },
      zetta: {
        name: "zetta",
        value: 1e21,
        scientific: !0
      },
      yotta: {
        name: "yotta",
        value: 1e24,
        scientific: !0
      },
      ronna: {
        name: "ronna",
        value: 1e27,
        scientific: !0
      },
      quetta: {
        name: "quetta",
        value: 1e30,
        scientific: !0
      },
      deci: {
        name: "deci",
        value: 0.1,
        scientific: !1
      },
      centi: {
        name: "centi",
        value: 0.01,
        scientific: !1
      },
      milli: {
        name: "milli",
        value: 1e-3,
        scientific: !0
      },
      micro: {
        name: "micro",
        value: 1e-6,
        scientific: !0
      },
      nano: {
        name: "nano",
        value: 1e-9,
        scientific: !0
      },
      pico: {
        name: "pico",
        value: 1e-12,
        scientific: !0
      },
      femto: {
        name: "femto",
        value: 1e-15,
        scientific: !0
      },
      atto: {
        name: "atto",
        value: 1e-18,
        scientific: !0
      },
      zepto: {
        name: "zepto",
        value: 1e-21,
        scientific: !0
      },
      yocto: {
        name: "yocto",
        value: 1e-24,
        scientific: !0
      },
      ronto: {
        name: "ronto",
        value: 1e-27,
        scientific: !0
      },
      quecto: {
        name: "quecto",
        value: 1e-30,
        scientific: !0
      }
    },
    SQUARED: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 100,
        scientific: !1
      },
      h: {
        name: "h",
        value: 1e4,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e6,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e12,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e18,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e24,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e30,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e36,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e42,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e48,
        scientific: !0
      },
      R: {
        name: "R",
        value: 1e54,
        scientific: !0
      },
      Q: {
        name: "Q",
        value: 1e60,
        scientific: !0
      },
      d: {
        name: "d",
        value: 0.01,
        scientific: !1
      },
      c: {
        name: "c",
        value: 1e-4,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-6,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-12,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-18,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-24,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-30,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-36,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-42,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-48,
        scientific: !0
      },
      r: {
        name: "r",
        value: 1e-54,
        scientific: !0
      },
      q: {
        name: "q",
        value: 1e-60,
        scientific: !0
      }
    },
    CUBIC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      da: {
        name: "da",
        value: 1e3,
        scientific: !1
      },
      h: {
        name: "h",
        value: 1e6,
        scientific: !1
      },
      k: {
        name: "k",
        value: 1e9,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e18,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e27,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e36,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e45,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e54,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e63,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e72,
        scientific: !0
      },
      R: {
        name: "R",
        value: 1e81,
        scientific: !0
      },
      Q: {
        name: "Q",
        value: 1e90,
        scientific: !0
      },
      d: {
        name: "d",
        value: 1e-3,
        scientific: !1
      },
      c: {
        name: "c",
        value: 1e-6,
        scientific: !1
      },
      m: {
        name: "m",
        value: 1e-9,
        scientific: !0
      },
      u: {
        name: "u",
        value: 1e-18,
        scientific: !0
      },
      n: {
        name: "n",
        value: 1e-27,
        scientific: !0
      },
      p: {
        name: "p",
        value: 1e-36,
        scientific: !0
      },
      f: {
        name: "f",
        value: 1e-45,
        scientific: !0
      },
      a: {
        name: "a",
        value: 1e-54,
        scientific: !0
      },
      z: {
        name: "z",
        value: 1e-63,
        scientific: !0
      },
      y: {
        name: "y",
        value: 1e-72,
        scientific: !0
      },
      r: {
        name: "r",
        value: 1e-81,
        scientific: !0
      },
      q: {
        name: "q",
        value: 1e-90,
        scientific: !0
      }
    },
    BINARY_SHORT_SI: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      k: {
        name: "k",
        value: 1e3,
        scientific: !0
      },
      M: {
        name: "M",
        value: 1e6,
        scientific: !0
      },
      G: {
        name: "G",
        value: 1e9,
        scientific: !0
      },
      T: {
        name: "T",
        value: 1e12,
        scientific: !0
      },
      P: {
        name: "P",
        value: 1e15,
        scientific: !0
      },
      E: {
        name: "E",
        value: 1e18,
        scientific: !0
      },
      Z: {
        name: "Z",
        value: 1e21,
        scientific: !0
      },
      Y: {
        name: "Y",
        value: 1e24,
        scientific: !0
      }
    },
    BINARY_SHORT_IEC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      Ki: {
        name: "Ki",
        value: 1024,
        scientific: !0
      },
      Mi: {
        name: "Mi",
        value: Math.pow(1024, 2),
        scientific: !0
      },
      Gi: {
        name: "Gi",
        value: Math.pow(1024, 3),
        scientific: !0
      },
      Ti: {
        name: "Ti",
        value: Math.pow(1024, 4),
        scientific: !0
      },
      Pi: {
        name: "Pi",
        value: Math.pow(1024, 5),
        scientific: !0
      },
      Ei: {
        name: "Ei",
        value: Math.pow(1024, 6),
        scientific: !0
      },
      Zi: {
        name: "Zi",
        value: Math.pow(1024, 7),
        scientific: !0
      },
      Yi: {
        name: "Yi",
        value: Math.pow(1024, 8),
        scientific: !0
      }
    },
    BINARY_LONG_SI: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      kilo: {
        name: "kilo",
        value: 1e3,
        scientific: !0
      },
      mega: {
        name: "mega",
        value: 1e6,
        scientific: !0
      },
      giga: {
        name: "giga",
        value: 1e9,
        scientific: !0
      },
      tera: {
        name: "tera",
        value: 1e12,
        scientific: !0
      },
      peta: {
        name: "peta",
        value: 1e15,
        scientific: !0
      },
      exa: {
        name: "exa",
        value: 1e18,
        scientific: !0
      },
      zetta: {
        name: "zetta",
        value: 1e21,
        scientific: !0
      },
      yotta: {
        name: "yotta",
        value: 1e24,
        scientific: !0
      }
    },
    BINARY_LONG_IEC: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      kibi: {
        name: "kibi",
        value: 1024,
        scientific: !0
      },
      mebi: {
        name: "mebi",
        value: Math.pow(1024, 2),
        scientific: !0
      },
      gibi: {
        name: "gibi",
        value: Math.pow(1024, 3),
        scientific: !0
      },
      tebi: {
        name: "tebi",
        value: Math.pow(1024, 4),
        scientific: !0
      },
      pebi: {
        name: "pebi",
        value: Math.pow(1024, 5),
        scientific: !0
      },
      exi: {
        name: "exi",
        value: Math.pow(1024, 6),
        scientific: !0
      },
      zebi: {
        name: "zebi",
        value: Math.pow(1024, 7),
        scientific: !0
      },
      yobi: {
        name: "yobi",
        value: Math.pow(1024, 8),
        scientific: !0
      }
    },
    BTU: {
      "": {
        name: "",
        value: 1,
        scientific: !0
      },
      MM: {
        name: "MM",
        value: 1e6,
        scientific: !0
      }
    }
  };
  _.SHORTLONG = kr({}, _.SHORT, _.LONG), _.BINARY_SHORT = kr({}, _.BINARY_SHORT_SI, _.BINARY_SHORT_IEC), _.BINARY_LONG = kr({}, _.BINARY_LONG_SI, _.BINARY_LONG_IEC);
  var q = ["MASS", "LENGTH", "TIME", "CURRENT", "TEMPERATURE", "LUMINOUS_INTENSITY", "AMOUNT_OF_SUBSTANCE", "ANGLE", "BIT"], C = {
    NONE: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    MASS: {
      dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    LENGTH: {
      dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0]
    },
    TIME: {
      dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0]
    },
    CURRENT: {
      dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0]
    },
    TEMPERATURE: {
      dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0]
    },
    LUMINOUS_INTENSITY: {
      dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0]
    },
    AMOUNT_OF_SUBSTANCE: {
      dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0]
    },
    FORCE: {
      dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0]
    },
    SURFACE: {
      dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0]
    },
    VOLUME: {
      dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0]
    },
    ENERGY: {
      dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0]
    },
    POWER: {
      dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0]
    },
    PRESSURE: {
      dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CHARGE: {
      dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CAPACITANCE: {
      dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_POTENTIAL: {
      dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0]
    },
    ELECTRIC_RESISTANCE: {
      dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_INDUCTANCE: {
      dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0]
    },
    ELECTRIC_CONDUCTANCE: {
      dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0]
    },
    MAGNETIC_FLUX: {
      dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0]
    },
    MAGNETIC_FLUX_DENSITY: {
      dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0]
    },
    FREQUENCY: {
      dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0]
    },
    ANGLE: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0]
    },
    BIT: {
      dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1]
    }
  };
  for (var T in C)
    De(C, T) && (C[T].key = T);
  var z = {}, I = {
    name: "",
    base: z,
    value: 1,
    offset: 0,
    dimensions: q.map((Y) => 0)
  }, U = {
    // length
    meter: {
      name: "meter",
      base: C.LENGTH,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    inch: {
      name: "inch",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 0.0254,
      offset: 0
    },
    foot: {
      name: "foot",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 0.3048,
      offset: 0
    },
    yard: {
      name: "yard",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 0.9144,
      offset: 0
    },
    mile: {
      name: "mile",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 1609.344,
      offset: 0
    },
    link: {
      name: "link",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 0.201168,
      offset: 0
    },
    rod: {
      name: "rod",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 5.0292,
      offset: 0
    },
    chain: {
      name: "chain",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 20.1168,
      offset: 0
    },
    angstrom: {
      name: "angstrom",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 1e-10,
      offset: 0
    },
    m: {
      name: "m",
      base: C.LENGTH,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    in: {
      name: "in",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 0.0254,
      offset: 0
    },
    ft: {
      name: "ft",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 0.3048,
      offset: 0
    },
    yd: {
      name: "yd",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 0.9144,
      offset: 0
    },
    mi: {
      name: "mi",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 1609.344,
      offset: 0
    },
    li: {
      name: "li",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 0.201168,
      offset: 0
    },
    rd: {
      name: "rd",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 5.02921,
      offset: 0
    },
    ch: {
      name: "ch",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 20.1168,
      offset: 0
    },
    mil: {
      name: "mil",
      base: C.LENGTH,
      prefixes: _.NONE,
      value: 254e-7,
      offset: 0
    },
    // 1/1000 inch
    // Surface
    m2: {
      name: "m2",
      base: C.SURFACE,
      prefixes: _.SQUARED,
      value: 1,
      offset: 0
    },
    sqin: {
      name: "sqin",
      base: C.SURFACE,
      prefixes: _.NONE,
      value: 64516e-8,
      offset: 0
    },
    // 645.16 mm2
    sqft: {
      name: "sqft",
      base: C.SURFACE,
      prefixes: _.NONE,
      value: 0.09290304,
      offset: 0
    },
    // 0.09290304 m2
    sqyd: {
      name: "sqyd",
      base: C.SURFACE,
      prefixes: _.NONE,
      value: 0.83612736,
      offset: 0
    },
    // 0.83612736 m2
    sqmi: {
      name: "sqmi",
      base: C.SURFACE,
      prefixes: _.NONE,
      value: 2589988110336e-6,
      offset: 0
    },
    // 2.589988110336 km2
    sqrd: {
      name: "sqrd",
      base: C.SURFACE,
      prefixes: _.NONE,
      value: 25.29295,
      offset: 0
    },
    // 25.29295 m2
    sqch: {
      name: "sqch",
      base: C.SURFACE,
      prefixes: _.NONE,
      value: 404.6873,
      offset: 0
    },
    // 404.6873 m2
    sqmil: {
      name: "sqmil",
      base: C.SURFACE,
      prefixes: _.NONE,
      value: 64516e-14,
      offset: 0
    },
    // 6.4516 * 10^-10 m2
    acre: {
      name: "acre",
      base: C.SURFACE,
      prefixes: _.NONE,
      value: 4046.86,
      offset: 0
    },
    // 4046.86 m2
    hectare: {
      name: "hectare",
      base: C.SURFACE,
      prefixes: _.NONE,
      value: 1e4,
      offset: 0
    },
    // 10000 m2
    // Volume
    m3: {
      name: "m3",
      base: C.VOLUME,
      prefixes: _.CUBIC,
      value: 1,
      offset: 0
    },
    L: {
      name: "L",
      base: C.VOLUME,
      prefixes: _.SHORT,
      value: 1e-3,
      offset: 0
    },
    // litre
    l: {
      name: "l",
      base: C.VOLUME,
      prefixes: _.SHORT,
      value: 1e-3,
      offset: 0
    },
    // litre
    litre: {
      name: "litre",
      base: C.VOLUME,
      prefixes: _.LONG,
      value: 1e-3,
      offset: 0
    },
    cuin: {
      name: "cuin",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 16387064e-12,
      offset: 0
    },
    // 1.6387064e-5 m3
    cuft: {
      name: "cuft",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 0.028316846592,
      offset: 0
    },
    // 28.316 846 592 L
    cuyd: {
      name: "cuyd",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 0.764554857984,
      offset: 0
    },
    // 764.554 857 984 L
    teaspoon: {
      name: "teaspoon",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 5e-6,
      offset: 0
    },
    // 5 mL
    tablespoon: {
      name: "tablespoon",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 15e-6,
      offset: 0
    },
    // 15 mL
    // {name: 'cup', base: BASE_UNITS.VOLUME, prefixes: PREFIXES.NONE, value: 0.000240, offset: 0}, // 240 mL  // not possible, we have already another cup
    drop: {
      name: "drop",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 5e-8,
      offset: 0
    },
    // 0.05 mL = 5e-8 m3
    gtt: {
      name: "gtt",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 5e-8,
      offset: 0
    },
    // 0.05 mL = 5e-8 m3
    // Liquid volume
    minim: {
      name: "minim",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 61611519921875e-21,
      offset: 0
    },
    // 1/61440 gallons
    fluiddram: {
      name: "fluiddram",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 36966911953125e-19,
      offset: 0
    },
    // 1/1024 gallons
    fluidounce: {
      name: "fluidounce",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 295735295625e-16,
      offset: 0
    },
    // 1/128 gallons
    gill: {
      name: "gill",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 11829411825e-14,
      offset: 0
    },
    // 1/32 gallons
    cc: {
      name: "cc",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 1e-6,
      offset: 0
    },
    // 1e-6 L
    cup: {
      name: "cup",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 2365882365e-13,
      offset: 0
    },
    // 1/16 gallons
    pint: {
      name: "pint",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 473176473e-12,
      offset: 0
    },
    // 1/8 gallons
    quart: {
      name: "quart",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 946352946e-12,
      offset: 0
    },
    // 1/4 gallons
    gallon: {
      name: "gallon",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 0.003785411784,
      offset: 0
    },
    // 3.785411784 L
    beerbarrel: {
      name: "beerbarrel",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 0.117347765304,
      offset: 0
    },
    // 31 gallons
    oilbarrel: {
      name: "oilbarrel",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 0.158987294928,
      offset: 0
    },
    // 42 gallons
    hogshead: {
      name: "hogshead",
      base: C.VOLUME,
      prefixes: _.NONE,
      value: 0.238480942392,
      offset: 0
    },
    // 63 gallons
    // Mass
    g: {
      name: "g",
      base: C.MASS,
      prefixes: _.SHORT,
      value: 1e-3,
      offset: 0
    },
    gram: {
      name: "gram",
      base: C.MASS,
      prefixes: _.LONG,
      value: 1e-3,
      offset: 0
    },
    ton: {
      name: "ton",
      base: C.MASS,
      prefixes: _.SHORT,
      value: 907.18474,
      offset: 0
    },
    t: {
      name: "t",
      base: C.MASS,
      prefixes: _.SHORT,
      value: 1e3,
      offset: 0
    },
    tonne: {
      name: "tonne",
      base: C.MASS,
      prefixes: _.LONG,
      value: 1e3,
      offset: 0
    },
    grain: {
      name: "grain",
      base: C.MASS,
      prefixes: _.NONE,
      value: 6479891e-11,
      offset: 0
    },
    dram: {
      name: "dram",
      base: C.MASS,
      prefixes: _.NONE,
      value: 0.0017718451953125,
      offset: 0
    },
    ounce: {
      name: "ounce",
      base: C.MASS,
      prefixes: _.NONE,
      value: 0.028349523125,
      offset: 0
    },
    poundmass: {
      name: "poundmass",
      base: C.MASS,
      prefixes: _.NONE,
      value: 0.45359237,
      offset: 0
    },
    hundredweight: {
      name: "hundredweight",
      base: C.MASS,
      prefixes: _.NONE,
      value: 45.359237,
      offset: 0
    },
    stick: {
      name: "stick",
      base: C.MASS,
      prefixes: _.NONE,
      value: 0.115,
      offset: 0
    },
    stone: {
      name: "stone",
      base: C.MASS,
      prefixes: _.NONE,
      value: 6.35029318,
      offset: 0
    },
    gr: {
      name: "gr",
      base: C.MASS,
      prefixes: _.NONE,
      value: 6479891e-11,
      offset: 0
    },
    dr: {
      name: "dr",
      base: C.MASS,
      prefixes: _.NONE,
      value: 0.0017718451953125,
      offset: 0
    },
    oz: {
      name: "oz",
      base: C.MASS,
      prefixes: _.NONE,
      value: 0.028349523125,
      offset: 0
    },
    lbm: {
      name: "lbm",
      base: C.MASS,
      prefixes: _.NONE,
      value: 0.45359237,
      offset: 0
    },
    cwt: {
      name: "cwt",
      base: C.MASS,
      prefixes: _.NONE,
      value: 45.359237,
      offset: 0
    },
    // Time
    s: {
      name: "s",
      base: C.TIME,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    min: {
      name: "min",
      base: C.TIME,
      prefixes: _.NONE,
      value: 60,
      offset: 0
    },
    h: {
      name: "h",
      base: C.TIME,
      prefixes: _.NONE,
      value: 3600,
      offset: 0
    },
    second: {
      name: "second",
      base: C.TIME,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    sec: {
      name: "sec",
      base: C.TIME,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    minute: {
      name: "minute",
      base: C.TIME,
      prefixes: _.NONE,
      value: 60,
      offset: 0
    },
    hour: {
      name: "hour",
      base: C.TIME,
      prefixes: _.NONE,
      value: 3600,
      offset: 0
    },
    day: {
      name: "day",
      base: C.TIME,
      prefixes: _.NONE,
      value: 86400,
      offset: 0
    },
    week: {
      name: "week",
      base: C.TIME,
      prefixes: _.NONE,
      value: 7 * 86400,
      offset: 0
    },
    month: {
      name: "month",
      base: C.TIME,
      prefixes: _.NONE,
      value: 2629800,
      // 1/12th of Julian year
      offset: 0
    },
    year: {
      name: "year",
      base: C.TIME,
      prefixes: _.NONE,
      value: 31557600,
      // Julian year
      offset: 0
    },
    decade: {
      name: "decade",
      base: C.TIME,
      prefixes: _.NONE,
      value: 315576e3,
      // Julian decade
      offset: 0
    },
    century: {
      name: "century",
      base: C.TIME,
      prefixes: _.NONE,
      value: 315576e4,
      // Julian century
      offset: 0
    },
    millennium: {
      name: "millennium",
      base: C.TIME,
      prefixes: _.NONE,
      value: 315576e5,
      // Julian millennium
      offset: 0
    },
    // Frequency
    hertz: {
      name: "Hertz",
      base: C.FREQUENCY,
      prefixes: _.LONG,
      value: 1,
      offset: 0,
      reciprocal: !0
    },
    Hz: {
      name: "Hz",
      base: C.FREQUENCY,
      prefixes: _.SHORT,
      value: 1,
      offset: 0,
      reciprocal: !0
    },
    // Angle
    rad: {
      name: "rad",
      base: C.ANGLE,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    radian: {
      name: "radian",
      base: C.ANGLE,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    // deg = rad / (2*pi) * 360 = rad / 0.017453292519943295769236907684888
    deg: {
      name: "deg",
      base: C.ANGLE,
      prefixes: _.SHORT,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    degree: {
      name: "degree",
      base: C.ANGLE,
      prefixes: _.LONG,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // grad = rad / (2*pi) * 400  = rad / 0.015707963267948966192313216916399
    grad: {
      name: "grad",
      base: C.ANGLE,
      prefixes: _.SHORT,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    gradian: {
      name: "gradian",
      base: C.ANGLE,
      prefixes: _.LONG,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // cycle = rad / (2*pi) = rad / 6.2831853071795864769252867665793
    cycle: {
      name: "cycle",
      base: C.ANGLE,
      prefixes: _.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // arcsec = rad / (3600 * (360 / 2 * pi)) = rad / 0.0000048481368110953599358991410235795
    arcsec: {
      name: "arcsec",
      base: C.ANGLE,
      prefixes: _.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // arcmin = rad / (60 * (360 / 2 * pi)) = rad / 0.00029088820866572159615394846141477
    arcmin: {
      name: "arcmin",
      base: C.ANGLE,
      prefixes: _.NONE,
      value: null,
      // will be filled in by calculateAngleValues()
      offset: 0
    },
    // Electric current
    A: {
      name: "A",
      base: C.CURRENT,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    ampere: {
      name: "ampere",
      base: C.CURRENT,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    // Temperature
    // K(C) = °C + 273.15
    // K(F) = (°F + 459.67) * (5 / 9)
    // K(R) = °R * (5 / 9)
    K: {
      name: "K",
      base: C.TEMPERATURE,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    degC: {
      name: "degC",
      base: C.TEMPERATURE,
      prefixes: _.SHORT,
      value: 1,
      offset: 273.15
    },
    degF: {
      name: "degF",
      base: C.TEMPERATURE,
      prefixes: _.SHORT,
      value: new m(5, 9),
      offset: 459.67
    },
    degR: {
      name: "degR",
      base: C.TEMPERATURE,
      prefixes: _.SHORT,
      value: new m(5, 9),
      offset: 0
    },
    kelvin: {
      name: "kelvin",
      base: C.TEMPERATURE,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    celsius: {
      name: "celsius",
      base: C.TEMPERATURE,
      prefixes: _.LONG,
      value: 1,
      offset: 273.15
    },
    fahrenheit: {
      name: "fahrenheit",
      base: C.TEMPERATURE,
      prefixes: _.LONG,
      value: new m(5, 9),
      offset: 459.67
    },
    rankine: {
      name: "rankine",
      base: C.TEMPERATURE,
      prefixes: _.LONG,
      value: new m(5, 9),
      offset: 0
    },
    // amount of substance
    mol: {
      name: "mol",
      base: C.AMOUNT_OF_SUBSTANCE,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    mole: {
      name: "mole",
      base: C.AMOUNT_OF_SUBSTANCE,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    // luminous intensity
    cd: {
      name: "cd",
      base: C.LUMINOUS_INTENSITY,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    candela: {
      name: "candela",
      base: C.LUMINOUS_INTENSITY,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    // TODO: units STERADIAN
    // {name: 'sr', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
    // {name: 'steradian', base: BASE_UNITS.STERADIAN, prefixes: PREFIXES.NONE, value: 1, offset: 0},
    // Force
    N: {
      name: "N",
      base: C.FORCE,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    newton: {
      name: "newton",
      base: C.FORCE,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    dyn: {
      name: "dyn",
      base: C.FORCE,
      prefixes: _.SHORT,
      value: 1e-5,
      offset: 0
    },
    dyne: {
      name: "dyne",
      base: C.FORCE,
      prefixes: _.LONG,
      value: 1e-5,
      offset: 0
    },
    lbf: {
      name: "lbf",
      base: C.FORCE,
      prefixes: _.NONE,
      value: 4.4482216152605,
      offset: 0
    },
    poundforce: {
      name: "poundforce",
      base: C.FORCE,
      prefixes: _.NONE,
      value: 4.4482216152605,
      offset: 0
    },
    kip: {
      name: "kip",
      base: C.FORCE,
      prefixes: _.LONG,
      value: 4448.2216,
      offset: 0
    },
    kilogramforce: {
      name: "kilogramforce",
      base: C.FORCE,
      prefixes: _.NONE,
      value: 9.80665,
      offset: 0
    },
    // Energy
    J: {
      name: "J",
      base: C.ENERGY,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    joule: {
      name: "joule",
      base: C.ENERGY,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    erg: {
      name: "erg",
      base: C.ENERGY,
      prefixes: _.SHORTLONG,
      // Both kiloerg and kerg are acceptable
      value: 1e-7,
      offset: 0
    },
    Wh: {
      name: "Wh",
      base: C.ENERGY,
      prefixes: _.SHORT,
      value: 3600,
      offset: 0
    },
    BTU: {
      name: "BTU",
      base: C.ENERGY,
      prefixes: _.BTU,
      value: 1055.05585262,
      offset: 0
    },
    eV: {
      name: "eV",
      base: C.ENERGY,
      prefixes: _.SHORT,
      value: 1602176565e-28,
      offset: 0
    },
    electronvolt: {
      name: "electronvolt",
      base: C.ENERGY,
      prefixes: _.LONG,
      value: 1602176565e-28,
      offset: 0
    },
    // Power
    W: {
      name: "W",
      base: C.POWER,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    watt: {
      name: "watt",
      base: C.POWER,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    hp: {
      name: "hp",
      base: C.POWER,
      prefixes: _.NONE,
      value: 745.6998715386,
      offset: 0
    },
    // Electrical power units
    VAR: {
      name: "VAR",
      base: C.POWER,
      prefixes: _.SHORT,
      value: v.I,
      offset: 0
    },
    VA: {
      name: "VA",
      base: C.POWER,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    // Pressure
    Pa: {
      name: "Pa",
      base: C.PRESSURE,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    psi: {
      name: "psi",
      base: C.PRESSURE,
      prefixes: _.NONE,
      value: 6894.75729276459,
      offset: 0
    },
    atm: {
      name: "atm",
      base: C.PRESSURE,
      prefixes: _.NONE,
      value: 101325,
      offset: 0
    },
    bar: {
      name: "bar",
      base: C.PRESSURE,
      prefixes: _.SHORTLONG,
      value: 1e5,
      offset: 0
    },
    torr: {
      name: "torr",
      base: C.PRESSURE,
      prefixes: _.NONE,
      value: 133.322,
      offset: 0
    },
    mmHg: {
      name: "mmHg",
      base: C.PRESSURE,
      prefixes: _.NONE,
      value: 133.322,
      offset: 0
    },
    mmH2O: {
      name: "mmH2O",
      base: C.PRESSURE,
      prefixes: _.NONE,
      value: 9.80665,
      offset: 0
    },
    cmH2O: {
      name: "cmH2O",
      base: C.PRESSURE,
      prefixes: _.NONE,
      value: 98.0665,
      offset: 0
    },
    // Electric charge
    coulomb: {
      name: "coulomb",
      base: C.ELECTRIC_CHARGE,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    C: {
      name: "C",
      base: C.ELECTRIC_CHARGE,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    // Electric capacitance
    farad: {
      name: "farad",
      base: C.ELECTRIC_CAPACITANCE,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    F: {
      name: "F",
      base: C.ELECTRIC_CAPACITANCE,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    // Electric potential
    volt: {
      name: "volt",
      base: C.ELECTRIC_POTENTIAL,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    V: {
      name: "V",
      base: C.ELECTRIC_POTENTIAL,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    // Electric resistance
    ohm: {
      name: "ohm",
      base: C.ELECTRIC_RESISTANCE,
      prefixes: _.SHORTLONG,
      // Both Mohm and megaohm are acceptable
      value: 1,
      offset: 0
    },
    /*
     * Unicode breaks in browsers if charset is not specified
    Ω: {
      name: 'Ω',
      base: BASE_UNITS.ELECTRIC_RESISTANCE,
      prefixes: PREFIXES.SHORT,
      value: 1,
      offset: 0
    },
    */
    // Electric inductance
    henry: {
      name: "henry",
      base: C.ELECTRIC_INDUCTANCE,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    H: {
      name: "H",
      base: C.ELECTRIC_INDUCTANCE,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    // Electric conductance
    siemens: {
      name: "siemens",
      base: C.ELECTRIC_CONDUCTANCE,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    S: {
      name: "S",
      base: C.ELECTRIC_CONDUCTANCE,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    // Magnetic flux
    weber: {
      name: "weber",
      base: C.MAGNETIC_FLUX,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    Wb: {
      name: "Wb",
      base: C.MAGNETIC_FLUX,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    // Magnetic flux density
    tesla: {
      name: "tesla",
      base: C.MAGNETIC_FLUX_DENSITY,
      prefixes: _.LONG,
      value: 1,
      offset: 0
    },
    T: {
      name: "T",
      base: C.MAGNETIC_FLUX_DENSITY,
      prefixes: _.SHORT,
      value: 1,
      offset: 0
    },
    // Binary
    b: {
      name: "b",
      base: C.BIT,
      prefixes: _.BINARY_SHORT,
      value: 1,
      offset: 0
    },
    bits: {
      name: "bits",
      base: C.BIT,
      prefixes: _.BINARY_LONG,
      value: 1,
      offset: 0
    },
    B: {
      name: "B",
      base: C.BIT,
      prefixes: _.BINARY_SHORT,
      value: 8,
      offset: 0
    },
    bytes: {
      name: "bytes",
      base: C.BIT,
      prefixes: _.BINARY_LONG,
      value: 8,
      offset: 0
    }
  }, ee = {
    meters: "meter",
    inches: "inch",
    feet: "foot",
    yards: "yard",
    miles: "mile",
    links: "link",
    rods: "rod",
    chains: "chain",
    angstroms: "angstrom",
    lt: "l",
    litres: "litre",
    liter: "litre",
    liters: "litre",
    teaspoons: "teaspoon",
    tablespoons: "tablespoon",
    minims: "minim",
    fldr: "fluiddram",
    fluiddrams: "fluiddram",
    floz: "fluidounce",
    fluidounces: "fluidounce",
    gi: "gill",
    gills: "gill",
    cp: "cup",
    cups: "cup",
    pt: "pint",
    pints: "pint",
    qt: "quart",
    quarts: "quart",
    gal: "gallon",
    gallons: "gallon",
    bbl: "beerbarrel",
    beerbarrels: "beerbarrel",
    obl: "oilbarrel",
    oilbarrels: "oilbarrel",
    hogsheads: "hogshead",
    gtts: "gtt",
    grams: "gram",
    tons: "ton",
    tonnes: "tonne",
    grains: "grain",
    drams: "dram",
    ounces: "ounce",
    poundmasses: "poundmass",
    hundredweights: "hundredweight",
    sticks: "stick",
    lb: "lbm",
    lbs: "lbm",
    kips: "kip",
    kgf: "kilogramforce",
    acres: "acre",
    hectares: "hectare",
    sqfeet: "sqft",
    sqyard: "sqyd",
    sqmile: "sqmi",
    sqmiles: "sqmi",
    mmhg: "mmHg",
    mmh2o: "mmH2O",
    cmh2o: "cmH2O",
    seconds: "second",
    secs: "second",
    minutes: "minute",
    mins: "minute",
    hours: "hour",
    hr: "hour",
    hrs: "hour",
    days: "day",
    weeks: "week",
    months: "month",
    years: "year",
    decades: "decade",
    centuries: "century",
    millennia: "millennium",
    hertz: "hertz",
    radians: "radian",
    degrees: "degree",
    gradians: "gradian",
    cycles: "cycle",
    arcsecond: "arcsec",
    arcseconds: "arcsec",
    arcminute: "arcmin",
    arcminutes: "arcmin",
    BTUs: "BTU",
    watts: "watt",
    joules: "joule",
    amperes: "ampere",
    amps: "ampere",
    amp: "ampere",
    coulombs: "coulomb",
    volts: "volt",
    ohms: "ohm",
    farads: "farad",
    webers: "weber",
    teslas: "tesla",
    electronvolts: "electronvolt",
    moles: "mole",
    bit: "bits",
    byte: "bytes"
  };
  function se(Y) {
    if (Y.number === "BigNumber") {
      var k = kf(g);
      U.rad.value = new g(1), U.deg.value = k.div(180), U.grad.value = k.div(200), U.cycle.value = k.times(2), U.arcsec.value = k.div(648e3), U.arcmin.value = k.div(10800);
    } else
      U.rad.value = 1, U.deg.value = Math.PI / 180, U.grad.value = Math.PI / 200, U.cycle.value = Math.PI * 2, U.arcsec.value = Math.PI / 648e3, U.arcmin.value = Math.PI / 10800;
    U.radian.value = U.rad.value, U.degree.value = U.deg.value, U.gradian.value = U.grad.value;
  }
  se(o), r && r("config", function(Y, k) {
    Y.number !== k.number && se(Y);
  });
  var K = {
    si: {
      // Base units
      NONE: {
        unit: I,
        prefix: _.NONE[""]
      },
      LENGTH: {
        unit: U.m,
        prefix: _.SHORT[""]
      },
      MASS: {
        unit: U.g,
        prefix: _.SHORT.k
      },
      TIME: {
        unit: U.s,
        prefix: _.SHORT[""]
      },
      CURRENT: {
        unit: U.A,
        prefix: _.SHORT[""]
      },
      TEMPERATURE: {
        unit: U.K,
        prefix: _.SHORT[""]
      },
      LUMINOUS_INTENSITY: {
        unit: U.cd,
        prefix: _.SHORT[""]
      },
      AMOUNT_OF_SUBSTANCE: {
        unit: U.mol,
        prefix: _.SHORT[""]
      },
      ANGLE: {
        unit: U.rad,
        prefix: _.SHORT[""]
      },
      BIT: {
        unit: U.bits,
        prefix: _.SHORT[""]
      },
      // Derived units
      FORCE: {
        unit: U.N,
        prefix: _.SHORT[""]
      },
      ENERGY: {
        unit: U.J,
        prefix: _.SHORT[""]
      },
      POWER: {
        unit: U.W,
        prefix: _.SHORT[""]
      },
      PRESSURE: {
        unit: U.Pa,
        prefix: _.SHORT[""]
      },
      ELECTRIC_CHARGE: {
        unit: U.C,
        prefix: _.SHORT[""]
      },
      ELECTRIC_CAPACITANCE: {
        unit: U.F,
        prefix: _.SHORT[""]
      },
      ELECTRIC_POTENTIAL: {
        unit: U.V,
        prefix: _.SHORT[""]
      },
      ELECTRIC_RESISTANCE: {
        unit: U.ohm,
        prefix: _.SHORT[""]
      },
      ELECTRIC_INDUCTANCE: {
        unit: U.H,
        prefix: _.SHORT[""]
      },
      ELECTRIC_CONDUCTANCE: {
        unit: U.S,
        prefix: _.SHORT[""]
      },
      MAGNETIC_FLUX: {
        unit: U.Wb,
        prefix: _.SHORT[""]
      },
      MAGNETIC_FLUX_DENSITY: {
        unit: U.T,
        prefix: _.SHORT[""]
      },
      FREQUENCY: {
        unit: U.Hz,
        prefix: _.SHORT[""]
      }
    }
  };
  K.cgs = JSON.parse(JSON.stringify(K.si)), K.cgs.LENGTH = {
    unit: U.m,
    prefix: _.SHORT.c
  }, K.cgs.MASS = {
    unit: U.g,
    prefix: _.SHORT[""]
  }, K.cgs.FORCE = {
    unit: U.dyn,
    prefix: _.SHORT[""]
  }, K.cgs.ENERGY = {
    unit: U.erg,
    prefix: _.NONE[""]
  }, K.us = JSON.parse(JSON.stringify(K.si)), K.us.LENGTH = {
    unit: U.ft,
    prefix: _.NONE[""]
  }, K.us.MASS = {
    unit: U.lbm,
    prefix: _.NONE[""]
  }, K.us.TEMPERATURE = {
    unit: U.degF,
    prefix: _.NONE[""]
  }, K.us.FORCE = {
    unit: U.lbf,
    prefix: _.NONE[""]
  }, K.us.ENERGY = {
    unit: U.BTU,
    prefix: _.BTU[""]
  }, K.us.POWER = {
    unit: U.hp,
    prefix: _.NONE[""]
  }, K.us.PRESSURE = {
    unit: U.psi,
    prefix: _.NONE[""]
  }, K.auto = JSON.parse(JSON.stringify(K.si));
  var J = K.auto;
  y.setUnitSystem = function(Y) {
    if (De(K, Y))
      J = K[Y];
    else
      throw new Error("Unit system " + Y + " does not exist. Choices are: " + Object.keys(K).join(", "));
  }, y.getUnitSystem = function() {
    for (var Y in K)
      if (De(K, Y) && K[Y] === J)
        return Y;
  }, y.typeConverters = {
    BigNumber: function(k) {
      return k != null && k.isFraction ? new g(k.n).div(k.d).times(k.s) : new g(k + "");
    },
    Fraction: function(k) {
      return new m(k);
    },
    Complex: function(k) {
      return k;
    },
    number: function(k) {
      return k != null && k.isFraction ? p(k) : k;
    }
  }, y.prototype._numberConverter = function() {
    var Y = y.typeConverters[this.valueType()];
    if (Y)
      return Y;
    throw new TypeError('Unsupported Unit value type "' + this.valueType() + '"');
  }, y._getNumberConverter = function(Y) {
    if (!y.typeConverters[Y])
      throw new TypeError('Unsupported type "' + Y + '"');
    return y.typeConverters[Y];
  };
  for (var te in U)
    if (De(U, te)) {
      var ne = U[te];
      ne.dimensions = ne.base.dimensions;
    }
  for (var ue in ee)
    if (De(ee, ue)) {
      var V = U[ee[ue]], W = {};
      for (var fe in V)
        De(V, fe) && (W[fe] = V[fe]);
      W.name = ue, U[ue] = W;
    }
  y.isValidAlpha = function(k) {
    return /^[a-zA-Z]$/.test(k);
  };
  function pe(Y) {
    for (var k = 0; k < Y.length; k++) {
      if (S = Y.charAt(k), k === 0 && !y.isValidAlpha(S))
        throw new Error('Invalid unit name (must begin with alpha character): "' + Y + '"');
      if (k > 0 && !(y.isValidAlpha(S) || B(S)))
        throw new Error('Invalid unit name (only alphanumeric characters are allowed): "' + Y + '"');
    }
  }
  return y.createUnit = function(Y, k) {
    if (typeof Y != "object")
      throw new TypeError("createUnit expects first parameter to be of type 'Object'");
    if (k && k.override) {
      for (var L in Y)
        if (De(Y, L) && y.deleteUnit(L), Y[L].aliases)
          for (var P = 0; P < Y[L].aliases.length; P++)
            y.deleteUnit(Y[L].aliases[P]);
    }
    var G;
    for (var j in Y)
      De(Y, j) && (G = y.createUnitSingle(j, Y[j]));
    return G;
  }, y.createUnitSingle = function(Y, k) {
    if ((typeof k > "u" || k === null) && (k = {}), typeof Y != "string")
      throw new TypeError("createUnitSingle expects first parameter to be of type 'string'");
    if (De(U, Y))
      throw new Error('Cannot create unit "' + Y + '": a unit with that name already exists');
    pe(Y);
    var L = null, P = [], G = 0, j, re, ie;
    if (k && k.type === "Unit")
      L = k.clone();
    else if (typeof k == "string")
      k !== "" && (j = k);
    else if (typeof k == "object")
      j = k.definition, re = k.prefixes, G = k.offset, ie = k.baseName, k.aliases && (P = k.aliases.valueOf());
    else
      throw new TypeError('Cannot create unit "' + Y + '" from "' + k.toString() + '": expecting "string" or "Unit" or "Object"');
    if (P) {
      for (var Z = 0; Z < P.length; Z++)
        if (De(U, P[Z]))
          throw new Error('Cannot create alias "' + P[Z] + '": a unit with that name already exists');
    }
    if (j && typeof j == "string" && !L)
      try {
        L = y.parse(j, {
          allowNoUnits: !0
        });
      } catch (H) {
        throw H.message = 'Could not create unit "' + Y + '" from "' + j + '": ' + H.message, H;
      }
    else
      j && j.type === "Unit" && (L = j.clone());
    P = P || [], G = G || 0, re && re.toUpperCase ? re = _[re.toUpperCase()] || _.NONE : re = _.NONE;
    var X = {};
    if (L) {
      X = {
        name: Y,
        value: L.value,
        dimensions: L.dimensions.slice(0),
        prefixes: re,
        offset: G
      };
      var ve = !1;
      for (var ge in C)
        if (De(C, ge)) {
          for (var me = !0, we = 0; we < q.length; we++)
            if (Math.abs((X.dimensions[we] || 0) - (C[ge].dimensions[we] || 0)) > 1e-12) {
              me = !1;
              break;
            }
          if (me) {
            ve = !0, X.base = C[ge];
            break;
          }
        }
      if (!ve) {
        ie = ie || Y + "_STUFF";
        var be = {
          dimensions: L.dimensions.slice(0)
        };
        be.key = ie, C[ie] = be, J[ie] = {
          unit: X,
          prefix: _.NONE[""]
        }, X.base = C[ie];
      }
    } else {
      if (ie = ie || Y + "_STUFF", q.indexOf(ie) >= 0)
        throw new Error('Cannot create new base unit "' + Y + '": a base unit with that name already exists (and cannot be overridden)');
      q.push(ie);
      for (var oe in C)
        De(C, oe) && (C[oe].dimensions[q.length - 1] = 0);
      for (var ce = {
        dimensions: []
      }, le = 0; le < q.length; le++)
        ce.dimensions[le] = 0;
      ce.dimensions[q.length - 1] = 1, ce.key = ie, C[ie] = ce, X = {
        name: Y,
        value: 1,
        dimensions: C[ie].dimensions.slice(0),
        prefixes: re,
        offset: G,
        base: C[ie]
      }, J[ie] = {
        unit: X,
        prefix: _.NONE[""]
      };
    }
    y.UNITS[Y] = X;
    for (var Ae = 0; Ae < P.length; Ae++) {
      var _e = P[Ae], Se = {};
      for (var Me in X)
        De(X, Me) && (Se[Me] = X[Me]);
      Se.name = _e, y.UNITS[_e] = Se;
    }
    return delete D.cache, new y(null, Y);
  }, y.deleteUnit = function(Y) {
    delete y.UNITS[Y], delete D.cache;
  }, y.PREFIXES = _, y.BASE_DIMENSIONS = q, y.BASE_UNITS = C, y.UNIT_SYSTEMS = K, y.UNITS = U, y;
}, {
  isClass: !0
}), eh = "unit", JE = ["typed", "Unit"], QE = /* @__PURE__ */ Q(eh, JE, (e) => {
  var {
    typed: r,
    Unit: o
  } = e;
  return r(eh, {
    Unit: function(i) {
      return i.clone();
    },
    string: function(i) {
      return o.isValuelessUnit(i) ? new o(null, i) : o.parse(i, {
        allowNoUnits: !0
      });
    },
    "number | BigNumber | Fraction | Complex, string | Unit": function(i, t) {
      return new o(i, t);
    },
    "number | BigNumber | Fraction": function(i) {
      return new o(i);
    },
    "Array | Matrix": r.referToSelf((n) => (i) => Ke(i, n))
  });
}), rh = "sparse", eA = ["typed", "SparseMatrix"], rA = /* @__PURE__ */ Q(rh, eA, (e) => {
  var {
    typed: r,
    SparseMatrix: o
  } = e;
  return r(rh, {
    "": function() {
      return new o([]);
    },
    string: function(i) {
      return new o([], i);
    },
    "Array | Matrix": function(i) {
      return new o(i);
    },
    "Array | Matrix, string": function(i, t) {
      return new o(i, t);
    }
  });
}), th = "createUnit", tA = ["typed", "Unit"], nA = /* @__PURE__ */ Q(th, tA, (e) => {
  var {
    typed: r,
    Unit: o
  } = e;
  return r(th, {
    // General function signature. First parameter is an object where each property is the definition of a new unit. The object keys are the unit names and the values are the definitions. The values can be objects, strings, or Units. If a property is an empty object or an empty string, a new base unit is created. The second parameter is the options.
    "Object, Object": function(i, t) {
      return o.createUnit(i, t);
    },
    // Same as above but without the options.
    Object: function(i) {
      return o.createUnit(i, {});
    },
    // Shortcut method for creating one unit.
    "string, Unit | string | Object, Object": function(i, t, u) {
      var l = {};
      return l[i] = t, o.createUnit(l, u);
    },
    // Same as above but without the options.
    "string, Unit | string | Object": function(i, t) {
      var u = {};
      return u[i] = t, o.createUnit(u, {});
    },
    // Without a definition, creates a base unit.
    string: function(i) {
      var t = {};
      return t[i] = {}, o.createUnit(t, {});
    }
  });
}), nh = "acos", iA = ["typed", "config", "Complex"], aA = /* @__PURE__ */ Q(nh, iA, (e) => {
  var {
    typed: r,
    config: o,
    Complex: n
  } = e;
  return r(nh, {
    number: function(t) {
      return t >= -1 && t <= 1 || o.predictable ? Math.acos(t) : new n(t, 0).acos();
    },
    Complex: function(t) {
      return t.acos();
    },
    BigNumber: function(t) {
      return t.acos();
    }
  });
}), ih = "acosh", oA = ["typed", "config", "Complex"], sA = /* @__PURE__ */ Q(ih, oA, (e) => {
  var {
    typed: r,
    config: o,
    Complex: n
  } = e;
  return r(ih, {
    number: function(t) {
      return t >= 1 || o.predictable ? Eg(t) : t <= -1 ? new n(Math.log(Math.sqrt(t * t - 1) - t), Math.PI) : new n(t, 0).acosh();
    },
    Complex: function(t) {
      return t.acosh();
    },
    BigNumber: function(t) {
      return t.acosh();
    }
  });
}), ah = "acot", uA = ["typed", "BigNumber"], fA = /* @__PURE__ */ Q(ah, uA, (e) => {
  var {
    typed: r,
    BigNumber: o
  } = e;
  return r(ah, {
    number: Ag,
    Complex: function(i) {
      return i.acot();
    },
    BigNumber: function(i) {
      return new o(1).div(i).atan();
    }
  });
}), oh = "acoth", cA = ["typed", "config", "Complex", "BigNumber"], lA = /* @__PURE__ */ Q(oh, cA, (e) => {
  var {
    typed: r,
    config: o,
    Complex: n,
    BigNumber: i
  } = e;
  return r(oh, {
    number: function(u) {
      return u >= 1 || u <= -1 || o.predictable ? Sg(u) : new n(u, 0).acoth();
    },
    Complex: function(u) {
      return u.acoth();
    },
    BigNumber: function(u) {
      return new i(1).div(u).atanh();
    }
  });
}), sh = "acsc", dA = ["typed", "config", "Complex", "BigNumber"], hA = /* @__PURE__ */ Q(sh, dA, (e) => {
  var {
    typed: r,
    config: o,
    Complex: n,
    BigNumber: i
  } = e;
  return r(sh, {
    number: function(u) {
      return u <= -1 || u >= 1 || o.predictable ? Dg(u) : new n(u, 0).acsc();
    },
    Complex: function(u) {
      return u.acsc();
    },
    BigNumber: function(u) {
      return new i(1).div(u).asin();
    }
  });
}), uh = "acsch", pA = ["typed", "BigNumber"], vA = /* @__PURE__ */ Q(uh, pA, (e) => {
  var {
    typed: r,
    BigNumber: o
  } = e;
  return r(uh, {
    number: Ng,
    Complex: function(i) {
      return i.acsch();
    },
    BigNumber: function(i) {
      return new o(1).div(i).asinh();
    }
  });
}), fh = "asec", mA = ["typed", "config", "Complex", "BigNumber"], gA = /* @__PURE__ */ Q(fh, mA, (e) => {
  var {
    typed: r,
    config: o,
    Complex: n,
    BigNumber: i
  } = e;
  return r(fh, {
    number: function(u) {
      return u <= -1 || u >= 1 || o.predictable ? Mg(u) : new n(u, 0).asec();
    },
    Complex: function(u) {
      return u.asec();
    },
    BigNumber: function(u) {
      return new i(1).div(u).acos();
    }
  });
}), ch = "asech", bA = ["typed", "config", "Complex", "BigNumber"], yA = /* @__PURE__ */ Q(ch, bA, (e) => {
  var {
    typed: r,
    config: o,
    Complex: n,
    BigNumber: i
  } = e;
  return r(ch, {
    number: function(u) {
      if (u <= 1 && u >= -1 || o.predictable) {
        var l = 1 / u;
        if (l > 0 || o.predictable)
          return _g(u);
        var f = Math.sqrt(l * l - 1);
        return new n(Math.log(f - l), Math.PI);
      }
      return new n(u, 0).asech();
    },
    Complex: function(u) {
      return u.asech();
    },
    BigNumber: function(u) {
      return new i(1).div(u).acosh();
    }
  });
}), lh = "asin", wA = ["typed", "config", "Complex"], xA = /* @__PURE__ */ Q(lh, wA, (e) => {
  var {
    typed: r,
    config: o,
    Complex: n
  } = e;
  return r(lh, {
    number: function(t) {
      return t >= -1 && t <= 1 || o.predictable ? Math.asin(t) : new n(t, 0).asin();
    },
    Complex: function(t) {
      return t.asin();
    },
    BigNumber: function(t) {
      return t.asin();
    }
  });
}), EA = "asinh", AA = ["typed"], SA = /* @__PURE__ */ Q(EA, AA, (e) => {
  var {
    typed: r
  } = e;
  return r("asinh", {
    number: Cg,
    Complex: function(n) {
      return n.asinh();
    },
    BigNumber: function(n) {
      return n.asinh();
    }
  });
}), DA = "atan", NA = ["typed"], MA = /* @__PURE__ */ Q(DA, NA, (e) => {
  var {
    typed: r
  } = e;
  return r("atan", {
    number: function(n) {
      return Math.atan(n);
    },
    Complex: function(n) {
      return n.atan();
    },
    BigNumber: function(n) {
      return n.atan();
    }
  });
}), dh = "atan2", _A = ["typed", "matrix", "equalScalar", "BigNumber", "DenseMatrix", "concat"], CA = /* @__PURE__ */ Q(dh, _A, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    BigNumber: i,
    DenseMatrix: t,
    concat: u
  } = e, l = At({
    typed: r,
    equalScalar: n
  }), f = Kr({
    typed: r
  }), s = Hg({
    typed: r,
    equalScalar: n
  }), a = Lr({
    typed: r,
    equalScalar: n
  }), c = Ir({
    typed: r,
    DenseMatrix: t
  }), d = lr({
    typed: r,
    matrix: o,
    concat: u
  });
  return r(dh, {
    "number, number": Math.atan2,
    // Complex numbers doesn't seem to have a reasonable implementation of
    // atan2(). Even Matlab removed the support, after they only calculated
    // the atan only on base of the real part of the numbers and ignored
    // the imaginary.
    "BigNumber, BigNumber": (h, p) => i.atan2(h, p)
  }, d({
    scalar: "number | BigNumber",
    SS: s,
    DS: f,
    SD: l,
    Ss: a,
    sS: c
  }));
}), hh = "atanh", TA = ["typed", "config", "Complex"], BA = /* @__PURE__ */ Q(hh, TA, (e) => {
  var {
    typed: r,
    config: o,
    Complex: n
  } = e;
  return r(hh, {
    number: function(t) {
      return t <= 1 && t >= -1 || o.predictable ? Tg(t) : new n(t, 0).atanh();
    },
    Complex: function(t) {
      return t.atanh();
    },
    BigNumber: function(t) {
      return t.atanh();
    }
  });
}), ti = /* @__PURE__ */ Q("trigUnit", ["typed"], (e) => {
  var {
    typed: r
  } = e;
  return {
    Unit: r.referToSelf((o) => (n) => {
      if (!n.hasBase(n.constructor.BASE_UNITS.ANGLE))
        throw new TypeError("Unit in function cot is no angle");
      return r.find(o, n.valueType())(n.value);
    })
  };
}), ph = "cos", FA = ["typed"], IA = /* @__PURE__ */ Q(ph, FA, (e) => {
  var {
    typed: r
  } = e, o = ti({
    typed: r
  });
  return r(ph, {
    number: Math.cos,
    "Complex | BigNumber": (n) => n.cos()
  }, o);
}), vh = "cosh", OA = ["typed"], RA = /* @__PURE__ */ Q(vh, OA, (e) => {
  var {
    typed: r
  } = e;
  return r(vh, {
    number: M2,
    "Complex | BigNumber": (o) => o.cosh()
  });
}), mh = "cot", PA = ["typed", "BigNumber"], qA = /* @__PURE__ */ Q(mh, PA, (e) => {
  var {
    typed: r,
    BigNumber: o
  } = e, n = ti({
    typed: r
  });
  return r(mh, {
    number: Bg,
    Complex: (i) => i.cot(),
    BigNumber: (i) => new o(1).div(i.tan())
  }, n);
}), gh = "coth", $A = ["typed", "BigNumber"], zA = /* @__PURE__ */ Q(gh, $A, (e) => {
  var {
    typed: r,
    BigNumber: o
  } = e;
  return r(gh, {
    number: Fg,
    Complex: (n) => n.coth(),
    BigNumber: (n) => new o(1).div(n.tanh())
  });
}), bh = "csc", LA = ["typed", "BigNumber"], UA = /* @__PURE__ */ Q(bh, LA, (e) => {
  var {
    typed: r,
    BigNumber: o
  } = e, n = ti({
    typed: r
  });
  return r(bh, {
    number: Ig,
    Complex: (i) => i.csc(),
    BigNumber: (i) => new o(1).div(i.sin())
  }, n);
}), yh = "csch", kA = ["typed", "BigNumber"], HA = /* @__PURE__ */ Q(yh, kA, (e) => {
  var {
    typed: r,
    BigNumber: o
  } = e;
  return r(yh, {
    number: Og,
    Complex: (n) => n.csch(),
    BigNumber: (n) => new o(1).div(n.sinh())
  });
}), wh = "sec", GA = ["typed", "BigNumber"], VA = /* @__PURE__ */ Q(wh, GA, (e) => {
  var {
    typed: r,
    BigNumber: o
  } = e, n = ti({
    typed: r
  });
  return r(wh, {
    number: Rg,
    Complex: (i) => i.sec(),
    BigNumber: (i) => new o(1).div(i.cos())
  }, n);
}), xh = "sech", WA = ["typed", "BigNumber"], KA = /* @__PURE__ */ Q(xh, WA, (e) => {
  var {
    typed: r,
    BigNumber: o
  } = e;
  return r(xh, {
    number: Pg,
    Complex: (n) => n.sech(),
    BigNumber: (n) => new o(1).div(n.cosh())
  });
}), Eh = "sin", ZA = ["typed"], jA = /* @__PURE__ */ Q(Eh, ZA, (e) => {
  var {
    typed: r
  } = e, o = ti({
    typed: r
  });
  return r(Eh, {
    number: Math.sin,
    "Complex | BigNumber": (n) => n.sin()
  }, o);
}), Ah = "sinh", YA = ["typed"], XA = /* @__PURE__ */ Q(Ah, YA, (e) => {
  var {
    typed: r
  } = e;
  return r(Ah, {
    number: qg,
    "Complex | BigNumber": (o) => o.sinh()
  });
}), Sh = "tan", JA = ["typed"], QA = /* @__PURE__ */ Q(Sh, JA, (e) => {
  var {
    typed: r
  } = e, o = ti({
    typed: r
  });
  return r(Sh, {
    number: Math.tan,
    "Complex | BigNumber": (n) => n.tan()
  }, o);
}), e7 = "tanh", r7 = ["typed"], t7 = /* @__PURE__ */ Q(e7, r7, (e) => {
  var {
    typed: r
  } = e;
  return r("tanh", {
    number: C2,
    "Complex | BigNumber": (o) => o.tanh()
  });
}), Dh = "setCartesian", n7 = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], i7 = /* @__PURE__ */ Q(Dh, n7, (e) => {
  var {
    typed: r,
    size: o,
    subset: n,
    compareNatural: i,
    Index: t,
    DenseMatrix: u
  } = e;
  return r(Dh, {
    "Array | Matrix, Array | Matrix": function(f, s) {
      var a = [];
      if (n(o(f), new t(0)) !== 0 && n(o(s), new t(0)) !== 0) {
        var c = ir(Array.isArray(f) ? f : f.toArray()).sort(i), d = ir(Array.isArray(s) ? s : s.toArray()).sort(i);
        a = [];
        for (var h = 0; h < c.length; h++)
          for (var p = 0; p < d.length; p++)
            a.push([c[h], d[p]]);
      }
      return Array.isArray(f) && Array.isArray(s) ? a : new u(a);
    }
  });
}), Nh = "setDifference", a7 = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], o7 = /* @__PURE__ */ Q(Nh, a7, (e) => {
  var {
    typed: r,
    size: o,
    subset: n,
    compareNatural: i,
    Index: t,
    DenseMatrix: u
  } = e;
  return r(Nh, {
    "Array | Matrix, Array | Matrix": function(f, s) {
      var a;
      if (n(o(f), new t(0)) === 0)
        a = [];
      else {
        if (n(o(s), new t(0)) === 0)
          return ir(f.toArray());
        var c = Vn(ir(Array.isArray(f) ? f : f.toArray()).sort(i)), d = Vn(ir(Array.isArray(s) ? s : s.toArray()).sort(i));
        a = [];
        for (var h, p = 0; p < c.length; p++) {
          h = !1;
          for (var v = 0; v < d.length; v++)
            if (i(c[p].value, d[v].value) === 0 && c[p].identifier === d[v].identifier) {
              h = !0;
              break;
            }
          h || a.push(c[p]);
        }
      }
      return Array.isArray(f) && Array.isArray(s) ? _a(a) : new u(_a(a));
    }
  });
}), Mh = "setDistinct", s7 = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], u7 = /* @__PURE__ */ Q(Mh, s7, (e) => {
  var {
    typed: r,
    size: o,
    subset: n,
    compareNatural: i,
    Index: t,
    DenseMatrix: u
  } = e;
  return r(Mh, {
    "Array | Matrix": function(f) {
      var s;
      if (n(o(f), new t(0)) === 0)
        s = [];
      else {
        var a = ir(Array.isArray(f) ? f : f.toArray()).sort(i);
        s = [], s.push(a[0]);
        for (var c = 1; c < a.length; c++)
          i(a[c], a[c - 1]) !== 0 && s.push(a[c]);
      }
      return Array.isArray(f) ? s : new u(s);
    }
  });
}), _h = "setIntersect", f7 = ["typed", "size", "subset", "compareNatural", "Index", "DenseMatrix"], c7 = /* @__PURE__ */ Q(_h, f7, (e) => {
  var {
    typed: r,
    size: o,
    subset: n,
    compareNatural: i,
    Index: t,
    DenseMatrix: u
  } = e;
  return r(_h, {
    "Array | Matrix, Array | Matrix": function(f, s) {
      var a;
      if (n(o(f), new t(0)) === 0 || n(o(s), new t(0)) === 0)
        a = [];
      else {
        var c = Vn(ir(Array.isArray(f) ? f : f.toArray()).sort(i)), d = Vn(ir(Array.isArray(s) ? s : s.toArray()).sort(i));
        a = [];
        for (var h = 0; h < c.length; h++)
          for (var p = 0; p < d.length; p++)
            if (i(c[h].value, d[p].value) === 0 && c[h].identifier === d[p].identifier) {
              a.push(c[h]);
              break;
            }
      }
      return Array.isArray(f) && Array.isArray(s) ? _a(a) : new u(_a(a));
    }
  });
}), Ch = "setIsSubset", l7 = ["typed", "size", "subset", "compareNatural", "Index"], d7 = /* @__PURE__ */ Q(Ch, l7, (e) => {
  var {
    typed: r,
    size: o,
    subset: n,
    compareNatural: i,
    Index: t
  } = e;
  return r(Ch, {
    "Array | Matrix, Array | Matrix": function(l, f) {
      if (n(o(l), new t(0)) === 0)
        return !0;
      if (n(o(f), new t(0)) === 0)
        return !1;
      for (var s = Vn(ir(Array.isArray(l) ? l : l.toArray()).sort(i)), a = Vn(ir(Array.isArray(f) ? f : f.toArray()).sort(i)), c, d = 0; d < s.length; d++) {
        c = !1;
        for (var h = 0; h < a.length; h++)
          if (i(s[d].value, a[h].value) === 0 && s[d].identifier === a[h].identifier) {
            c = !0;
            break;
          }
        if (c === !1)
          return !1;
      }
      return !0;
    }
  });
}), Th = "setMultiplicity", h7 = ["typed", "size", "subset", "compareNatural", "Index"], p7 = /* @__PURE__ */ Q(Th, h7, (e) => {
  var {
    typed: r,
    size: o,
    subset: n,
    compareNatural: i,
    Index: t
  } = e;
  return r(Th, {
    "number | BigNumber | Fraction | Complex, Array | Matrix": function(l, f) {
      if (n(o(f), new t(0)) === 0)
        return 0;
      for (var s = ir(Array.isArray(f) ? f : f.toArray()), a = 0, c = 0; c < s.length; c++)
        i(s[c], l) === 0 && a++;
      return a;
    }
  });
}), Bh = "setPowerset", v7 = ["typed", "size", "subset", "compareNatural", "Index"], m7 = /* @__PURE__ */ Q(Bh, v7, (e) => {
  var {
    typed: r,
    size: o,
    subset: n,
    compareNatural: i,
    Index: t
  } = e;
  return r(Bh, {
    "Array | Matrix": function(s) {
      if (n(o(s), new t(0)) === 0)
        return [];
      for (var a = ir(Array.isArray(s) ? s : s.toArray()).sort(i), c = [], d = 0; d.toString(2).length <= a.length; )
        c.push(u(a, d.toString(2).split("").reverse())), d++;
      return l(c);
    }
  });
  function u(f, s) {
    for (var a = [], c = 0; c < s.length; c++)
      s[c] === "1" && a.push(f[c]);
    return a;
  }
  function l(f) {
    for (var s = [], a = f.length - 1; a > 0; a--)
      for (var c = 0; c < a; c++)
        f[c].length > f[c + 1].length && (s = f[c], f[c] = f[c + 1], f[c + 1] = s);
    return f;
  }
}), Fh = "setSize", g7 = ["typed", "compareNatural"], b7 = /* @__PURE__ */ Q(Fh, g7, (e) => {
  var {
    typed: r,
    compareNatural: o
  } = e;
  return r(Fh, {
    "Array | Matrix": function(i) {
      return Array.isArray(i) ? ir(i).length : ir(i.toArray()).length;
    },
    "Array | Matrix, boolean": function(i, t) {
      if (t === !1 || i.length === 0)
        return Array.isArray(i) ? ir(i).length : ir(i.toArray()).length;
      for (var u = ir(Array.isArray(i) ? i : i.toArray()).sort(o), l = 1, f = 1; f < u.length; f++)
        o(u[f], u[f - 1]) !== 0 && l++;
      return l;
    }
  });
}), Ih = "setSymDifference", y7 = ["typed", "size", "concat", "subset", "setDifference", "Index"], w7 = /* @__PURE__ */ Q(Ih, y7, (e) => {
  var {
    typed: r,
    size: o,
    concat: n,
    subset: i,
    setDifference: t,
    Index: u
  } = e;
  return r(Ih, {
    "Array | Matrix, Array | Matrix": function(f, s) {
      if (i(o(f), new u(0)) === 0)
        return ir(s);
      if (i(o(s), new u(0)) === 0)
        return ir(f);
      var a = ir(f), c = ir(s);
      return n(t(a, c), t(c, a));
    }
  });
}), Oh = "setUnion", x7 = ["typed", "size", "concat", "subset", "setIntersect", "setSymDifference", "Index"], E7 = /* @__PURE__ */ Q(Oh, x7, (e) => {
  var {
    typed: r,
    size: o,
    concat: n,
    subset: i,
    setIntersect: t,
    setSymDifference: u,
    Index: l
  } = e;
  return r(Oh, {
    "Array | Matrix, Array | Matrix": function(s, a) {
      if (i(o(s), new l(0)) === 0)
        return ir(a);
      if (i(o(a), new l(0)) === 0)
        return ir(s);
      var c = ir(s), d = ir(a);
      return n(u(c, d), t(c, d));
    }
  });
}), Rh = "add", A7 = ["typed", "matrix", "addScalar", "equalScalar", "DenseMatrix", "SparseMatrix", "concat"], S7 = /* @__PURE__ */ Q(Rh, A7, (e) => {
  var {
    typed: r,
    matrix: o,
    addScalar: n,
    equalScalar: i,
    DenseMatrix: t,
    SparseMatrix: u,
    concat: l
  } = e, f = fn({
    typed: r
  }), s = qf({
    typed: r,
    equalScalar: i
  }), a = Dn({
    typed: r,
    DenseMatrix: t
  }), c = lr({
    typed: r,
    matrix: o,
    concat: l
  });
  return r(Rh, {
    "any, any": n,
    "any, any, ...any": r.referToSelf((d) => (h, p, v) => {
      for (var g = d(h, p), m = 0; m < v.length; m++)
        g = d(g, v[m]);
      return g;
    })
  }, c({
    elop: n,
    DS: f,
    SS: s,
    Ss: a
  }));
}), Ph = "hypot", D7 = ["typed", "abs", "addScalar", "divideScalar", "multiplyScalar", "sqrt", "smaller", "isPositive"], N7 = /* @__PURE__ */ Q(Ph, D7, (e) => {
  var {
    typed: r,
    abs: o,
    addScalar: n,
    divideScalar: i,
    multiplyScalar: t,
    sqrt: u,
    smaller: l,
    isPositive: f
  } = e;
  return r(Ph, {
    "... number | BigNumber": s,
    Array: s,
    Matrix: (a) => s(ir(a.toArray()))
  });
  function s(a) {
    for (var c = 0, d = 0, h = 0; h < a.length; h++) {
      if (yt(a[h]))
        throw new TypeError("Unexpected type of argument to hypot");
      var p = o(a[h]);
      l(d, p) ? (c = t(c, t(i(d, p), i(d, p))), c = n(c, 1), d = p) : c = n(c, f(p) ? t(i(p, d), i(p, d)) : p);
    }
    return t(d, u(c));
  }
}), qh = "norm", M7 = ["typed", "abs", "add", "pow", "conj", "sqrt", "multiply", "equalScalar", "larger", "smaller", "matrix", "ctranspose", "eigs"], _7 = /* @__PURE__ */ Q(qh, M7, (e) => {
  var {
    typed: r,
    abs: o,
    add: n,
    pow: i,
    conj: t,
    sqrt: u,
    multiply: l,
    equalScalar: f,
    larger: s,
    smaller: a,
    matrix: c,
    ctranspose: d,
    eigs: h
  } = e;
  return r(qh, {
    number: Math.abs,
    Complex: function(O) {
      return O.abs();
    },
    BigNumber: function(O) {
      return O.abs();
    },
    boolean: function(O) {
      return Math.abs(O);
    },
    Array: function(O) {
      return S(c(O), 2);
    },
    Matrix: function(O) {
      return S(O, 2);
    },
    "Array, number | BigNumber | string": function(O, B) {
      return S(c(O), B);
    },
    "Matrix, number | BigNumber | string": function(O, B) {
      return S(O, B);
    }
  });
  function p(R) {
    var O = 0;
    return R.forEach(function(B) {
      var $ = o(B);
      s($, O) && (O = $);
    }, !0), O;
  }
  function v(R) {
    var O;
    return R.forEach(function(B) {
      var $ = o(B);
      (!O || a($, O)) && (O = $);
    }, !0), O || 0;
  }
  function g(R, O) {
    if (O === Number.POSITIVE_INFINITY || O === "inf")
      return p(R);
    if (O === Number.NEGATIVE_INFINITY || O === "-inf")
      return v(R);
    if (O === "fro")
      return S(R, 2);
    if (typeof O == "number" && !isNaN(O)) {
      if (!f(O, 0)) {
        var B = 0;
        return R.forEach(function($) {
          B = n(i(o($), O), B);
        }, !0), i(B, 1 / O);
      }
      return Number.POSITIVE_INFINITY;
    }
    throw new Error("Unsupported parameter value");
  }
  function m(R) {
    var O = 0;
    return R.forEach(function(B, $) {
      O = n(O, l(B, t(B)));
    }), o(u(O));
  }
  function x(R) {
    var O = [], B = 0;
    return R.forEach(function($, F) {
      var w = F[1], A = n(O[w] || 0, o($));
      s(A, B) && (B = A), O[w] = A;
    }, !0), B;
  }
  function y(R) {
    var O = R.size();
    if (O[0] !== O[1])
      throw new RangeError("Invalid matrix dimensions");
    var B = d(R), $ = l(B, R), F = h($).values.toArray(), w = F[F.length - 1];
    return o(u(w));
  }
  function E(R) {
    var O = [], B = 0;
    return R.forEach(function($, F) {
      var w = F[0], A = n(O[w] || 0, o($));
      s(A, B) && (B = A), O[w] = A;
    }, !0), B;
  }
  function N(R, O) {
    if (O === 1)
      return x(R);
    if (O === Number.POSITIVE_INFINITY || O === "inf")
      return E(R);
    if (O === "fro")
      return m(R);
    if (O === 2)
      return y(R);
    throw new Error("Unsupported parameter value " + O);
  }
  function S(R, O) {
    var B = R.size();
    if (B.length === 1)
      return g(R, O);
    if (B.length === 2) {
      if (B[0] && B[1])
        return N(R, O);
      throw new RangeError("Invalid matrix dimensions");
    }
  }
}), $h = "dot", C7 = ["typed", "addScalar", "multiplyScalar", "conj", "size"], T7 = /* @__PURE__ */ Q($h, C7, (e) => {
  var {
    typed: r,
    addScalar: o,
    multiplyScalar: n,
    conj: i,
    size: t
  } = e;
  return r($h, {
    "Array | DenseMatrix, Array | DenseMatrix": l,
    "SparseMatrix, SparseMatrix": f
  });
  function u(a, c) {
    var d = s(a), h = s(c), p, v;
    if (d.length === 1)
      p = d[0];
    else if (d.length === 2 && d[1] === 1)
      p = d[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + d.join(", ") + ")");
    if (h.length === 1)
      v = h[0];
    else if (h.length === 2 && h[1] === 1)
      v = h[0];
    else
      throw new RangeError("Expected a column vector, instead got a matrix of size (" + h.join(", ") + ")");
    if (p !== v)
      throw new RangeError("Vectors must have equal length (" + p + " != " + v + ")");
    if (p === 0)
      throw new RangeError("Cannot calculate the dot product of empty vectors");
    return p;
  }
  function l(a, c) {
    var d = u(a, c), h = Fe(a) ? a._data : a, p = Fe(a) ? a._datatype || a.getDataType() : void 0, v = Fe(c) ? c._data : c, g = Fe(c) ? c._datatype || c.getDataType() : void 0, m = s(a).length === 2, x = s(c).length === 2, y = o, E = n;
    if (p && g && p === g && typeof p == "string" && p !== "mixed") {
      var N = p;
      y = r.find(o, [N, N]), E = r.find(n, [N, N]);
    }
    if (!m && !x) {
      for (var S = E(i(h[0]), v[0]), R = 1; R < d; R++)
        S = y(S, E(i(h[R]), v[R]));
      return S;
    }
    if (!m && x) {
      for (var O = E(i(h[0]), v[0][0]), B = 1; B < d; B++)
        O = y(O, E(i(h[B]), v[B][0]));
      return O;
    }
    if (m && !x) {
      for (var $ = E(i(h[0][0]), v[0]), F = 1; F < d; F++)
        $ = y($, E(i(h[F][0]), v[F]));
      return $;
    }
    if (m && x) {
      for (var w = E(i(h[0][0]), v[0][0]), A = 1; A < d; A++)
        w = y(w, E(i(h[A][0]), v[A][0]));
      return w;
    }
  }
  function f(a, c) {
    u(a, c);
    for (var d = a._index, h = a._values, p = c._index, v = c._values, g = 0, m = o, x = n, y = 0, E = 0; y < d.length && E < p.length; ) {
      var N = d[y], S = p[E];
      if (N < S) {
        y++;
        continue;
      }
      if (N > S) {
        E++;
        continue;
      }
      N === S && (g = m(g, x(h[y], v[E])), y++, E++);
    }
    return g;
  }
  function s(a) {
    return Fe(a) ? a.size() : t(a);
  }
}), B7 = "trace", F7 = ["typed", "matrix", "add"], I7 = /* @__PURE__ */ Q(B7, F7, (e) => {
  var {
    typed: r,
    matrix: o,
    add: n
  } = e;
  return r("trace", {
    Array: function(l) {
      return i(o(l));
    },
    SparseMatrix: t,
    DenseMatrix: i,
    any: Ie
  });
  function i(u) {
    var l = u._size, f = u._data;
    switch (l.length) {
      case 1:
        if (l[0] === 1)
          return Ie(f[0]);
        throw new RangeError("Matrix must be square (size: " + Ze(l) + ")");
      case 2: {
        var s = l[0], a = l[1];
        if (s === a) {
          for (var c = 0, d = 0; d < s; d++)
            c = n(c, f[d][d]);
          return c;
        } else
          throw new RangeError("Matrix must be square (size: " + Ze(l) + ")");
      }
      default:
        throw new RangeError("Matrix must be two dimensional (size: " + Ze(l) + ")");
    }
  }
  function t(u) {
    var l = u._values, f = u._index, s = u._ptr, a = u._size, c = a[0], d = a[1];
    if (c === d) {
      var h = 0;
      if (l.length > 0)
        for (var p = 0; p < d; p++)
          for (var v = s[p], g = s[p + 1], m = v; m < g; m++) {
            var x = f[m];
            if (x === p) {
              h = n(h, l[m]);
              break;
            }
            if (x > p)
              break;
          }
      return h;
    }
    throw new RangeError("Matrix must be square (size: " + Ze(a) + ")");
  }
}), zh = "index", O7 = ["typed", "Index"], R7 = /* @__PURE__ */ Q(zh, O7, (e) => {
  var {
    typed: r,
    Index: o
  } = e;
  return r(zh, {
    "...number | string | BigNumber | Range | Array | Matrix": function(i) {
      var t = i.map(function(l) {
        return Re(l) ? l.toNumber() : ar(l) || Fe(l) ? l.map(function(f) {
          return Re(f) ? f.toNumber() : f;
        }) : l;
      }), u = new o();
      return o.apply(u, t), u;
    }
  });
}), ob = /* @__PURE__ */ new Set(["end"]), P7 = "Node", q7 = ["mathWithTransform"], $7 = /* @__PURE__ */ Q(P7, q7, (e) => {
  var {
    mathWithTransform: r
  } = e;
  function o(i) {
    for (var t of [...ob])
      if (i.has(t))
        throw new Error('Scope contains an illegal symbol, "' + t + '" is a reserved keyword');
  }
  class n {
    get type() {
      return "Node";
    }
    get isNode() {
      return !0;
    }
    /**
     * Evaluate the node
     * @param {Object} [scope]  Scope to read/write variables
     * @return {*}              Returns the result
     */
    evaluate(t) {
      return this.compile().evaluate(t);
    }
    /**
     * Compile the node into an optimized, evauatable JavaScript function
     * @return {{evaluate: function([Object])}} object
     *                Returns an object with a function 'evaluate',
     *                which can be invoked as expr.evaluate([scope: Object]),
     *                where scope is an optional object with
     *                variables.
     */
    compile() {
      var t = this._compile(r, {}), u = {}, l = null;
      function f(s) {
        var a = zn(s);
        return o(a), t(a, u, l);
      }
      return {
        evaluate: f
      };
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(t, u) {
      throw new Error("Method _compile must be implemented by type " + this.type);
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(t) {
      throw new Error("Cannot run forEach on a Node interface");
    }
    /**
     * Create a new Node whose children are the results of calling the
     * provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {OperatorNode} Returns a transformed copy of the node
     */
    map(t) {
      throw new Error("Cannot run map on a Node interface");
    }
    /**
     * Validate whether an object is a Node, for use with map
     * @param {Node} node
     * @returns {Node} Returns the input if it's a node, else throws an Error
     * @protected
     */
    _ifNode(t) {
      if (!or(t))
        throw new TypeError("Callback function must return a Node");
      return t;
    }
    /**
     * Recursively traverse all nodes in a node tree. Executes given callback for
     * this node and each of its child nodes.
     * @param {function(node: Node, path: string, parent: Node)} callback
     *          A callback called for every node in the node tree.
     */
    traverse(t) {
      t(this, null, null);
      function u(l, f) {
        l.forEach(function(s, a, c) {
          f(s, a, c), u(s, f);
        });
      }
      u(this, t);
    }
    /**
     * Recursively transform a node tree via a transform function.
     *
     * For example, to replace all nodes of type SymbolNode having name 'x' with
     * a ConstantNode with value 2:
     *
     *     const res = Node.transform(function (node, path, parent) {
     *       if (node && node.isSymbolNode) && (node.name === 'x')) {
     *         return new ConstantNode(2)
     *       }
     *       else {
     *         return node
     *       }
     *     })
     *
     * @param {function(node: Node, path: string, parent: Node) : Node} callback
     *          A mapping function accepting a node, and returning
     *          a replacement for the node or the original node. The "signature"
     *          of the callback must be:
     *          callback(node: Node, index: string, parent: Node) : Node
     * @return {Node} Returns the original node or its replacement
     */
    transform(t) {
      function u(l, f, s) {
        var a = t(l, f, s);
        return a !== l ? a : l.map(u);
      }
      return u(this, null, null);
    }
    /**
     * Find any node in the node tree matching given filter function. For
     * example, to find all nodes of type SymbolNode having name 'x':
     *
     *     const results = Node.filter(function (node) {
     *       return (node && node.isSymbolNode) && (node.name === 'x')
     *     })
     *
     * @param {function(node: Node, path: string, parent: Node) : Node} callback
     *            A test function returning true when a node matches, and false
     *            otherwise. Function signature:
     *            callback(node: Node, index: string, parent: Node) : boolean
     * @return {Node[]} nodes
     *            An array with nodes matching given filter criteria
     */
    filter(t) {
      var u = [];
      return this.traverse(function(l, f, s) {
        t(l, f, s) && u.push(l);
      }), u;
    }
    /**
     * Create a shallow clone of this node
     * @return {Node}
     */
    clone() {
      throw new Error("Cannot clone a Node interface");
    }
    /**
     * Create a deep clone of this node
     * @return {Node}
     */
    cloneDeep() {
      return this.map(function(t) {
        return t.cloneDeep();
      });
    }
    /**
     * Deep compare this node with another node.
     * @param {Node} other
     * @return {boolean} Returns true when both nodes are of the same type and
     *                   contain the same values (as do their childs)
     */
    equals(t) {
      return t ? this.type === t.type && Vt(this, t) : !1;
    }
    /**
     * Get string representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)"or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */
    toString(t) {
      var u = this._getCustomString(t);
      return typeof u < "u" ? u : this._toString(t);
    }
    /**
     * Internal function to generate the string output.
     * This has to be implemented by every Node
     *
     * @throws {Error}
     */
    _toString() {
      throw new Error("_toString not implemented for " + this.type);
    }
    /**
     * Get a JSON representation of the node
     * Both .toJSON() and the static .fromJSON(json) should be implemented by all
     * implementations of Node
     * @returns {Object}
     */
    toJSON() {
      throw new Error("Cannot serialize object: toJSON not implemented by " + this.type);
    }
    /**
     * Get HTML representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)" or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */
    toHTML(t) {
      var u = this._getCustomString(t);
      return typeof u < "u" ? u : this._toHTML(t);
    }
    /**
     * Internal function to generate the HTML output.
     * This has to be implemented by every Node
     *
     * @throws {Error}
     */
    _toHTML() {
      throw new Error("_toHTML not implemented for " + this.type);
    }
    /**
     * Get LaTeX representation. (wrapper function)
     *
     * This function can get an object of the following form:
     * {
     *    handler: //This can be a callback function of the form
     *             // "function callback(node, options)"or
     *             // a map that maps function names (used in FunctionNodes)
     *             // to callbacks
     *    parenthesis: "keep" //the parenthesis option (This is optional)
     * }
     *
     * @param {Object} [options]
     * @return {string}
     */
    toTex(t) {
      var u = this._getCustomString(t);
      return typeof u < "u" ? u : this._toTex(t);
    }
    /**
     * Internal function to generate the LaTeX output.
     * This has to be implemented by every Node
     *
     * @param {Object} [options]
     * @throws {Error}
     */
    _toTex(t) {
      throw new Error("_toTex not implemented for " + this.type);
    }
    /**
     * Helper used by `to...` functions.
     */
    _getCustomString(t) {
      if (t && typeof t == "object")
        switch (typeof t.handler) {
          case "object":
          case "undefined":
            return;
          case "function":
            return t.handler(this, t);
          default:
            throw new TypeError("Object or function expected as callback");
        }
    }
    /**
     * Get identifier.
     * @return {string}
     */
    getIdentifier() {
      return this.type;
    }
    /**
     * Get the content of the current Node.
     * @return {Node} node
     **/
    getContent() {
      return this;
    }
  }
  return n;
}, {
  isClass: !0,
  isNode: !0
});
function Zr(e) {
  return e && e.isIndexError ? new dt(e.index + 1, e.min + 1, e.max !== void 0 ? e.max + 1 : void 0) : e;
}
function sb(e) {
  var {
    subset: r
  } = e;
  return function(n, i) {
    try {
      if (Array.isArray(n))
        return r(n, i);
      if (n && typeof n.subset == "function")
        return n.subset(i);
      if (typeof n == "string")
        return r(n, i);
      if (typeof n == "object") {
        if (!i.isObjectProperty())
          throw new TypeError("Cannot apply a numeric index as object property");
        return Vr(n, i.getObjectProperty());
      } else
        throw new TypeError("Cannot apply index: unsupported type of object");
    } catch (t) {
      throw Zr(t);
    }
  };
}
var Ui = "AccessorNode", z7 = ["subset", "Node"], L7 = /* @__PURE__ */ Q(Ui, z7, (e) => {
  var {
    subset: r,
    Node: o
  } = e, n = sb({
    subset: r
  });
  function i(u) {
    return !(nn(u) || tt(u) || rr(u) || Gt(u) || _i(u) || Dt(u) || Br(u));
  }
  class t extends o {
    /**
     * @constructor AccessorNode
     * @extends {Node}
     * Access an object property or get a matrix subset
     *
     * @param {Node} object                 The object from which to retrieve
     *                                      a property or subset.
     * @param {IndexNode} index             IndexNode containing ranges
     */
    constructor(l, f) {
      if (super(), !or(l))
        throw new TypeError('Node expected for parameter "object"');
      if (!Sn(f))
        throw new TypeError('IndexNode expected for parameter "index"');
      this.object = l, this.index = f;
    }
    // readonly property name
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
    }
    get type() {
      return Ui;
    }
    get isAccessorNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(l, f) {
      var s = this.object._compile(l, f), a = this.index._compile(l, f);
      if (this.index.isObjectProperty()) {
        var c = this.index.getObjectProperty();
        return function(h, p, v) {
          return Vr(s(h, p, v), c);
        };
      } else
        return function(h, p, v) {
          var g = s(h, p, v), m = a(h, p, g);
          return n(g, m);
        };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(l) {
      l(this.object, "object", this), l(this.index, "index", this);
    }
    /**
     * Create a new AccessorNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {AccessorNode} Returns a transformed copy of the node
     */
    map(l) {
      return new t(this._ifNode(l(this.object, "object", this)), this._ifNode(l(this.index, "index", this)));
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {AccessorNode}
     */
    clone() {
      return new t(this.object, this.index);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string}
     */
    _toString(l) {
      var f = this.object.toString(l);
      return i(this.object) && (f = "(" + f + ")"), f + this.index.toString(l);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string}
     */
    _toHTML(l) {
      var f = this.object.toHTML(l);
      return i(this.object) && (f = '<span class="math-parenthesis math-round-parenthesis">(</span>' + f + '<span class="math-parenthesis math-round-parenthesis">)</span>'), f + this.index.toHTML(l);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string}
     */
    _toTex(l) {
      var f = this.object.toTex(l);
      return i(this.object) && (f = "\\left(' + object + '\\right)"), f + this.index.toTex(l);
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Ui,
        object: this.object,
        index: this.index
      };
    }
    /**
     * Instantiate an AccessorNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "AccessorNode", object: ..., index: ...}`,
     *     where mathjs is optional
     * @returns {AccessorNode}
     */
    static fromJSON(l) {
      return new t(l.object, l.index);
    }
  }
  return Fr(t, "name", Ui), t;
}, {
  isClass: !0,
  isNode: !0
}), ki = "ArrayNode", U7 = ["Node"], k7 = /* @__PURE__ */ Q(ki, U7, (e) => {
  var {
    Node: r
  } = e;
  class o extends r {
    /**
     * @constructor ArrayNode
     * @extends {Node}
     * Holds an 1-dimensional array with items
     * @param {Node[]} [items]   1 dimensional array with items
     */
    constructor(i) {
      if (super(), this.items = i || [], !Array.isArray(this.items) || !this.items.every(or))
        throw new TypeError("Array containing Nodes expected");
    }
    get type() {
      return ki;
    }
    get isArrayNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, t) {
      var u = Ht(this.items, function(s) {
        return s._compile(i, t);
      }), l = i.config.matrix !== "Array";
      if (l) {
        var f = i.matrix;
        return function(a, c, d) {
          return f(Ht(u, function(h) {
            return h(a, c, d);
          }));
        };
      } else
        return function(a, c, d) {
          return Ht(u, function(h) {
            return h(a, c, d);
          });
        };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      for (var t = 0; t < this.items.length; t++) {
        var u = this.items[t];
        i(u, "items[" + t + "]", this);
      }
    }
    /**
     * Create a new ArrayNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ArrayNode} Returns a transformed copy of the node
     */
    map(i) {
      for (var t = [], u = 0; u < this.items.length; u++)
        t[u] = this._ifNode(i(this.items[u], "items[" + u + "]", this));
      return new o(t);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ArrayNode}
     */
    clone() {
      return new o(this.items.slice(0));
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(i) {
      var t = this.items.map(function(u) {
        return u.toString(i);
      });
      return "[" + t.join(", ") + "]";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: ki,
        items: this.items
      };
    }
    /**
     * Instantiate an ArrayNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ArrayNode", items: [...]}`,
     *                       where mathjs is optional
     * @returns {ArrayNode}
     */
    static fromJSON(i) {
      return new o(i.items);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(i) {
      var t = this.items.map(function(u) {
        return u.toHTML(i);
      });
      return '<span class="math-parenthesis math-square-parenthesis">[</span>' + t.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(i) {
      function t(u, l) {
        var f = u.some(tt) && !u.every(tt), s = l || f, a = s ? "&" : "\\\\", c = u.map(function(d) {
          return d.items ? t(d.items, !l) : d.toTex(i);
        }).join(a);
        return f || !s || s && !l ? "\\begin{bmatrix}" + c + "\\end{bmatrix}" : c;
      }
      return t(this.items, !1);
    }
  }
  return Fr(o, "name", ki), o;
}, {
  isClass: !0,
  isNode: !0
});
function H7(e) {
  var {
    subset: r,
    matrix: o
  } = e;
  return function(i, t, u) {
    try {
      if (Array.isArray(i)) {
        var l = o(i).subset(t, u).valueOf();
        return l.forEach((f, s) => {
          i[s] = f;
        }), i;
      } else {
        if (i && typeof i.subset == "function")
          return i.subset(t, u);
        if (typeof i == "string")
          return r(i, t, u);
        if (typeof i == "object") {
          if (!t.isObjectProperty())
            throw TypeError("Cannot apply a numeric index as object property");
          return Un(i, t.getObjectProperty(), u), i;
        } else
          throw new TypeError("Cannot apply index: unsupported type of object");
      }
    } catch (f) {
      throw Zr(f);
    }
  };
}
var mt = [{
  // assignment
  AssignmentNode: {},
  FunctionAssignmentNode: {}
}, {
  // conditional expression
  ConditionalNode: {
    latexLeftParens: !1,
    latexRightParens: !1,
    latexParens: !1
    // conditionals don't need parentheses in LaTeX because
    // they are 2 dimensional
  }
}, {
  // logical or
  "OperatorNode:or": {
    op: "or",
    associativity: "left",
    associativeWith: []
  }
}, {
  // logical xor
  "OperatorNode:xor": {
    op: "xor",
    associativity: "left",
    associativeWith: []
  }
}, {
  // logical and
  "OperatorNode:and": {
    op: "and",
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitwise or
  "OperatorNode:bitOr": {
    op: "|",
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitwise xor
  "OperatorNode:bitXor": {
    op: "^|",
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitwise and
  "OperatorNode:bitAnd": {
    op: "&",
    associativity: "left",
    associativeWith: []
  }
}, {
  // relational operators
  "OperatorNode:equal": {
    op: "==",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:unequal": {
    op: "!=",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:smaller": {
    op: "<",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:larger": {
    op: ">",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:smallerEq": {
    op: "<=",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:largerEq": {
    op: ">=",
    associativity: "left",
    associativeWith: []
  },
  RelationalNode: {
    associativity: "left",
    associativeWith: []
  }
}, {
  // bitshift operators
  "OperatorNode:leftShift": {
    op: "<<",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:rightArithShift": {
    op: ">>",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:rightLogShift": {
    op: ">>>",
    associativity: "left",
    associativeWith: []
  }
}, {
  // unit conversion
  "OperatorNode:to": {
    op: "to",
    associativity: "left",
    associativeWith: []
  }
}, {
  // range
  RangeNode: {}
}, {
  // addition, subtraction
  "OperatorNode:add": {
    op: "+",
    associativity: "left",
    associativeWith: ["OperatorNode:add", "OperatorNode:subtract"]
  },
  "OperatorNode:subtract": {
    op: "-",
    associativity: "left",
    associativeWith: []
  }
}, {
  // multiply, divide, modulus
  "OperatorNode:multiply": {
    op: "*",
    associativity: "left",
    associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"]
  },
  "OperatorNode:divide": {
    op: "/",
    associativity: "left",
    associativeWith: [],
    latexLeftParens: !1,
    latexRightParens: !1,
    latexParens: !1
    // fractions don't require parentheses because
    // they're 2 dimensional, so parens aren't needed
    // in LaTeX
  },
  "OperatorNode:dotMultiply": {
    op: ".*",
    associativity: "left",
    associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "OperatorNode:dotMultiply", "OperatorNode:doDivide"]
  },
  "OperatorNode:dotDivide": {
    op: "./",
    associativity: "left",
    associativeWith: []
  },
  "OperatorNode:mod": {
    op: "mod",
    associativity: "left",
    associativeWith: []
  }
}, {
  // Repeat multiplication for implicit multiplication
  "OperatorNode:multiply": {
    associativity: "left",
    associativeWith: ["OperatorNode:multiply", "OperatorNode:divide", "Operator:dotMultiply", "Operator:dotDivide"]
  }
}, {
  // unary prefix operators
  "OperatorNode:unaryPlus": {
    op: "+",
    associativity: "right"
  },
  "OperatorNode:unaryMinus": {
    op: "-",
    associativity: "right"
  },
  "OperatorNode:bitNot": {
    op: "~",
    associativity: "right"
  },
  "OperatorNode:not": {
    op: "not",
    associativity: "right"
  }
}, {
  // exponentiation
  "OperatorNode:pow": {
    op: "^",
    associativity: "right",
    associativeWith: [],
    latexRightParens: !1
    // the exponent doesn't need parentheses in
    // LaTeX because it's 2 dimensional
    // (it's on top)
  },
  "OperatorNode:dotPow": {
    op: ".^",
    associativity: "right",
    associativeWith: []
  }
}, {
  // factorial
  "OperatorNode:factorial": {
    op: "!",
    associativity: "left"
  }
}, {
  // matrix transpose
  "OperatorNode:ctranspose": {
    op: "'",
    associativity: "left"
  }
}];
function Hi(e, r) {
  if (!r || r !== "auto")
    return e;
  for (var o = e; Dt(o); )
    o = o.content;
  return o;
}
function ur(e, r, o, n) {
  var i = e;
  r !== "keep" && (i = e.getContent());
  for (var t = i.getIdentifier(), u = null, l = 0; l < mt.length; l++)
    if (t in mt[l]) {
      u = l;
      break;
    }
  if (t === "OperatorNode:multiply" && i.implicit && o !== "show") {
    var f = Hi(i.args[0], r);
    !(rr(f) && n && n.getIdentifier() === "OperatorNode:divide" && Ou(Hi(n.args[0], r))) && !(f.getIdentifier() === "OperatorNode:divide" && Ou(Hi(f.args[0], r)) && rr(Hi(f.args[1]))) && (u += 1);
  }
  return u;
}
function ui(e, r) {
  var o = e;
  r !== "keep" && (o = e.getContent());
  var n = o.getIdentifier(), i = ur(o, r);
  if (i === null)
    return null;
  var t = mt[i][n];
  if (De(t, "associativity")) {
    if (t.associativity === "left")
      return "left";
    if (t.associativity === "right")
      return "right";
    throw Error("'" + n + "' has the invalid associativity '" + t.associativity + "'.");
  }
  return null;
}
function Eo(e, r, o) {
  var n = o !== "keep" ? e.getContent() : e, i = o !== "keep" ? e.getContent() : r, t = n.getIdentifier(), u = i.getIdentifier(), l = ur(n, o);
  if (l === null)
    return null;
  var f = mt[l][t];
  if (De(f, "associativeWith") && f.associativeWith instanceof Array) {
    for (var s = 0; s < f.associativeWith.length; s++)
      if (f.associativeWith[s] === u)
        return !0;
    return !1;
  }
  return null;
}
function G7(e) {
  var r = "OperatorNode:" + e;
  for (var o of mt)
    if (r in o)
      return o[r].op;
  return null;
}
var Gi = "AssignmentNode", V7 = [
  "subset",
  "?matrix",
  // FIXME: should not be needed at all, should be handled by subset
  "Node"
], W7 = /* @__PURE__ */ Q(Gi, V7, (e) => {
  var {
    subset: r,
    matrix: o,
    Node: n
  } = e, i = sb({
    subset: r
  }), t = H7({
    subset: r,
    matrix: o
  });
  function u(f, s, a) {
    s || (s = "keep");
    var c = ur(f, s, a), d = ur(f.value, s, a);
    return s === "all" || d !== null && d <= c;
  }
  class l extends n {
    /**
     * @constructor AssignmentNode
     * @extends {Node}
     *
     * Define a symbol, like `a=3.2`, update a property like `a.b=3.2`, or
     * replace a subset of a matrix like `A[2,2]=42`.
     *
     * Syntax:
     *
     *     new AssignmentNode(symbol, value)
     *     new AssignmentNode(object, index, value)
     *
     * Usage:
     *
     *    new AssignmentNode(new SymbolNode('a'), new ConstantNode(2))  // a=2
     *    new AssignmentNode(new SymbolNode('a'),
     *                       new IndexNode('b'),
     *                       new ConstantNode(2))   // a.b=2
     *    new AssignmentNode(new SymbolNode('a'),
     *                       new IndexNode(1, 2),
     *                       new ConstantNode(3))  // a[1,2]=3
     *
     * @param {SymbolNode | AccessorNode} object
     *     Object on which to assign a value
     * @param {IndexNode} [index=null]
     *     Index, property name or matrix index. Optional. If not provided
     *     and `object` is a SymbolNode, the property is assigned to the
     *     global scope.
     * @param {Node} value
     *     The value to be assigned
     */
    constructor(s, a, c) {
      if (super(), this.object = s, this.index = c ? a : null, this.value = c || a, !Br(s) && !nn(s))
        throw new TypeError('SymbolNode or AccessorNode expected as "object"');
      if (Br(s) && s.name === "end")
        throw new Error('Cannot assign to symbol "end"');
      if (this.index && !Sn(this.index))
        throw new TypeError('IndexNode expected as "index"');
      if (!or(this.value))
        throw new TypeError('Node expected as "value"');
    }
    // class name for typing purposes:
    // readonly property name
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : "" : this.object.name || "";
    }
    get type() {
      return Gi;
    }
    get isAssignmentNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(s, a) {
      var c = this.object._compile(s, a), d = this.index ? this.index._compile(s, a) : null, h = this.value._compile(s, a), p = this.object.name;
      if (this.index)
        if (this.index.isObjectProperty()) {
          var v = this.index.getObjectProperty();
          return function(E, N, S) {
            var R = c(E, N, S), O = h(E, N, S);
            return Un(R, v, O), O;
          };
        } else {
          if (Br(this.object))
            return function(E, N, S) {
              var R = c(E, N, S), O = h(E, N, S), B = d(E, N, R);
              return E.set(p, t(R, B, O)), O;
            };
          var g = this.object.object._compile(s, a);
          if (this.object.index.isObjectProperty()) {
            var m = this.object.index.getObjectProperty();
            return function(E, N, S) {
              var R = g(E, N, S), O = Vr(R, m), B = d(E, N, O), $ = h(E, N, S);
              return Un(R, m, t(O, B, $)), $;
            };
          } else {
            var x = this.object.index._compile(s, a);
            return function(E, N, S) {
              var R = g(E, N, S), O = x(E, N, R), B = i(R, O), $ = d(E, N, B), F = h(E, N, S);
              return t(R, O, t(B, $, F)), F;
            };
          }
        }
      else {
        if (!Br(this.object))
          throw new TypeError("SymbolNode expected as object");
        return function(E, N, S) {
          var R = h(E, N, S);
          return E.set(p, R), R;
        };
      }
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(s) {
      s(this.object, "object", this), this.index && s(this.index, "index", this), s(this.value, "value", this);
    }
    /**
     * Create a new AssignmentNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {AssignmentNode} Returns a transformed copy of the node
     */
    map(s) {
      var a = this._ifNode(s(this.object, "object", this)), c = this.index ? this._ifNode(s(this.index, "index", this)) : null, d = this._ifNode(s(this.value, "value", this));
      return new l(a, c, d);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {AssignmentNode}
     */
    clone() {
      return new l(this.object, this.index, this.value);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string}
     */
    _toString(s) {
      var a = this.object.toString(s), c = this.index ? this.index.toString(s) : "", d = this.value.toString(s);
      return u(this, s && s.parenthesis, s && s.implicit) && (d = "(" + d + ")"), a + c + " = " + d;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Gi,
        object: this.object,
        index: this.index,
        value: this.value
      };
    }
    /**
     * Instantiate an AssignmentNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "AssignmentNode", object: ..., index: ..., value: ...}`,
     *     where mathjs is optional
     * @returns {AssignmentNode}
     */
    static fromJSON(s) {
      return new l(s.object, s.index, s.value);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string}
     */
    _toHTML(s) {
      var a = this.object.toHTML(s), c = this.index ? this.index.toHTML(s) : "", d = this.value.toHTML(s);
      return u(this, s && s.parenthesis, s && s.implicit) && (d = '<span class="math-paranthesis math-round-parenthesis">(</span>' + d + '<span class="math-paranthesis math-round-parenthesis">)</span>'), a + c + '<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + d;
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string}
     */
    _toTex(s) {
      var a = this.object.toTex(s), c = this.index ? this.index.toTex(s) : "", d = this.value.toTex(s);
      return u(this, s && s.parenthesis, s && s.implicit) && (d = "\\left(".concat(d, "\\right)")), a + c + "=" + d;
    }
  }
  return Fr(l, "name", Gi), l;
}, {
  isClass: !0,
  isNode: !0
}), Vi = "BlockNode", K7 = ["ResultSet", "Node"], Z7 = /* @__PURE__ */ Q(Vi, K7, (e) => {
  var {
    ResultSet: r,
    Node: o
  } = e;
  class n extends o {
    /**
     * @constructor BlockNode
     * @extends {Node}
     * Holds a set with blocks
     * @param {Array.<{node: Node} | {node: Node, visible: boolean}>} blocks
     *            An array with blocks, where a block is constructed as an
     *            Object with properties block, which is a Node, and visible,
     *            which is a boolean. The property visible is optional and
     *            is true by default
     */
    constructor(t) {
      if (super(), !Array.isArray(t))
        throw new Error("Array expected");
      this.blocks = t.map(function(u) {
        var l = u && u.node, f = u && u.visible !== void 0 ? u.visible : !0;
        if (!or(l))
          throw new TypeError('Property "node" must be a Node');
        if (typeof f != "boolean")
          throw new TypeError('Property "visible" must be a boolean');
        return {
          node: l,
          visible: f
        };
      });
    }
    get type() {
      return Vi;
    }
    get isBlockNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(t, u) {
      var l = Ht(this.blocks, function(f) {
        return {
          evaluate: f.node._compile(t, u),
          visible: f.visible
        };
      });
      return function(s, a, c) {
        var d = [];
        return to(l, function(p) {
          var v = p.evaluate(s, a, c);
          p.visible && d.push(v);
        }), new r(d);
      };
    }
    /**
     * Execute a callback for each of the child blocks of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(t) {
      for (var u = 0; u < this.blocks.length; u++)
        t(this.blocks[u].node, "blocks[" + u + "].node", this);
    }
    /**
     * Create a new BlockNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {BlockNode} Returns a transformed copy of the node
     */
    map(t) {
      for (var u = [], l = 0; l < this.blocks.length; l++) {
        var f = this.blocks[l], s = this._ifNode(t(f.node, "blocks[" + l + "].node", this));
        u[l] = {
          node: s,
          visible: f.visible
        };
      }
      return new n(u);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {BlockNode}
     */
    clone() {
      var t = this.blocks.map(function(u) {
        return {
          node: u.node,
          visible: u.visible
        };
      });
      return new n(t);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(t) {
      return this.blocks.map(function(u) {
        return u.node.toString(t) + (u.visible ? "" : ";");
      }).join(`
`);
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Vi,
        blocks: this.blocks
      };
    }
    /**
     * Instantiate an BlockNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "BlockNode", blocks: [{node: ..., visible: false}, ...]}`,
     *     where mathjs is optional
     * @returns {BlockNode}
     */
    static fromJSON(t) {
      return new n(t.blocks);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(t) {
      return this.blocks.map(function(u) {
        return u.node.toHTML(t) + (u.visible ? "" : '<span class="math-separator">;</span>');
      }).join('<span class="math-separator"><br /></span>');
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(t) {
      return this.blocks.map(function(u) {
        return u.node.toTex(t) + (u.visible ? "" : ";");
      }).join(`\\;\\;
`);
    }
  }
  return Fr(n, "name", Vi), n;
}, {
  isClass: !0,
  isNode: !0
}), Wi = "ConditionalNode", j7 = ["Node"], Y7 = /* @__PURE__ */ Q(Wi, j7, (e) => {
  var {
    Node: r
  } = e;
  function o(i) {
    if (typeof i == "number" || typeof i == "boolean" || typeof i == "string")
      return !!i;
    if (i) {
      if (Re(i))
        return !i.isZero();
      if (yt(i))
        return !!(i.re || i.im);
      if (jr(i))
        return !!i.value;
    }
    if (i == null)
      return !1;
    throw new TypeError('Unsupported type of condition "' + fr(i) + '"');
  }
  class n extends r {
    /**
     * A lazy evaluating conditional operator: 'condition ? trueExpr : falseExpr'
     *
     * @param {Node} condition   Condition, must result in a boolean
     * @param {Node} trueExpr    Expression evaluated when condition is true
     * @param {Node} falseExpr   Expression evaluated when condition is true
     *
     * @constructor ConditionalNode
     * @extends {Node}
     */
    constructor(t, u, l) {
      if (super(), !or(t))
        throw new TypeError("Parameter condition must be a Node");
      if (!or(u))
        throw new TypeError("Parameter trueExpr must be a Node");
      if (!or(l))
        throw new TypeError("Parameter falseExpr must be a Node");
      this.condition = t, this.trueExpr = u, this.falseExpr = l;
    }
    get type() {
      return Wi;
    }
    get isConditionalNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(t, u) {
      var l = this.condition._compile(t, u), f = this.trueExpr._compile(t, u), s = this.falseExpr._compile(t, u);
      return function(c, d, h) {
        return o(l(c, d, h)) ? f(c, d, h) : s(c, d, h);
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(t) {
      t(this.condition, "condition", this), t(this.trueExpr, "trueExpr", this), t(this.falseExpr, "falseExpr", this);
    }
    /**
     * Create a new ConditionalNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ConditionalNode} Returns a transformed copy of the node
     */
    map(t) {
      return new n(this._ifNode(t(this.condition, "condition", this)), this._ifNode(t(this.trueExpr, "trueExpr", this)), this._ifNode(t(this.falseExpr, "falseExpr", this)));
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ConditionalNode}
     */
    clone() {
      return new n(this.condition, this.trueExpr, this.falseExpr);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(t) {
      var u = t && t.parenthesis ? t.parenthesis : "keep", l = ur(this, u, t && t.implicit), f = this.condition.toString(t), s = ur(this.condition, u, t && t.implicit);
      (u === "all" || this.condition.type === "OperatorNode" || s !== null && s <= l) && (f = "(" + f + ")");
      var a = this.trueExpr.toString(t), c = ur(this.trueExpr, u, t && t.implicit);
      (u === "all" || this.trueExpr.type === "OperatorNode" || c !== null && c <= l) && (a = "(" + a + ")");
      var d = this.falseExpr.toString(t), h = ur(this.falseExpr, u, t && t.implicit);
      return (u === "all" || this.falseExpr.type === "OperatorNode" || h !== null && h <= l) && (d = "(" + d + ")"), f + " ? " + a + " : " + d;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Wi,
        condition: this.condition,
        trueExpr: this.trueExpr,
        falseExpr: this.falseExpr
      };
    }
    /**
     * Instantiate an ConditionalNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     ```
     *     {"mathjs": "ConditionalNode",
     *      "condition": ...,
     *      "trueExpr": ...,
     *      "falseExpr": ...}
     *     ```
     *     where mathjs is optional
     * @returns {ConditionalNode}
     */
    static fromJSON(t) {
      return new n(t.condition, t.trueExpr, t.falseExpr);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(t) {
      var u = t && t.parenthesis ? t.parenthesis : "keep", l = ur(this, u, t && t.implicit), f = this.condition.toHTML(t), s = ur(this.condition, u, t && t.implicit);
      (u === "all" || this.condition.type === "OperatorNode" || s !== null && s <= l) && (f = '<span class="math-parenthesis math-round-parenthesis">(</span>' + f + '<span class="math-parenthesis math-round-parenthesis">)</span>');
      var a = this.trueExpr.toHTML(t), c = ur(this.trueExpr, u, t && t.implicit);
      (u === "all" || this.trueExpr.type === "OperatorNode" || c !== null && c <= l) && (a = '<span class="math-parenthesis math-round-parenthesis">(</span>' + a + '<span class="math-parenthesis math-round-parenthesis">)</span>');
      var d = this.falseExpr.toHTML(t), h = ur(this.falseExpr, u, t && t.implicit);
      return (u === "all" || this.falseExpr.type === "OperatorNode" || h !== null && h <= l) && (d = '<span class="math-parenthesis math-round-parenthesis">(</span>' + d + '<span class="math-parenthesis math-round-parenthesis">)</span>'), f + '<span class="math-operator math-conditional-operator">?</span>' + a + '<span class="math-operator math-conditional-operator">:</span>' + d;
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(t) {
      return "\\begin{cases} {" + this.trueExpr.toTex(t) + "}, &\\quad{\\text{if }\\;" + this.condition.toTex(t) + "}\\\\{" + this.falseExpr.toTex(t) + "}, &\\quad{\\text{otherwise}}\\end{cases}";
    }
  }
  return Fr(n, "name", Wi), n;
}, {
  isClass: !0,
  isNode: !0
}), Yu = Object.assign || function(e) {
  for (var r = 1; r < arguments.length; r++) {
    var o = arguments[r];
    for (var n in o)
      Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
  }
  return e;
}, X7 = {
  "{": "\\{",
  "}": "\\}",
  "\\": "\\textbackslash{}",
  "#": "\\#",
  $: "\\$",
  "%": "\\%",
  "&": "\\&",
  "^": "\\textasciicircum{}",
  _: "\\_",
  "~": "\\textasciitilde{}"
}, J7 = {
  "–": "\\--",
  "—": "\\---",
  " ": "~",
  "	": "\\qquad{}",
  "\r\n": "\\newline{}",
  "\n": "\\newline{}"
}, Q7 = function(r, o) {
  return Yu({}, r, o);
}, e9 = function(e) {
  for (var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = r.preserveFormatting, n = o === void 0 ? !1 : o, i = r.escapeMapFn, t = i === void 0 ? Q7 : i, u = String(e), l = "", f = t(Yu({}, X7), n ? Yu({}, J7) : {}), s = Object.keys(f), a = function() {
    var d = !1;
    s.forEach(function(h, p) {
      d || u.length >= h.length && u.slice(0, h.length) === h && (l += f[s[p]], u = u.slice(h.length, u.length), d = !0);
    }), d || (l += u.slice(0, 1), u = u.slice(1, u.length));
  }; u; )
    a();
  return l;
};
const r9 = /* @__PURE__ */ Ti(e9);
var Xu = {
  // GREEK LETTERS
  Alpha: "A",
  alpha: "\\alpha",
  Beta: "B",
  beta: "\\beta",
  Gamma: "\\Gamma",
  gamma: "\\gamma",
  Delta: "\\Delta",
  delta: "\\delta",
  Epsilon: "E",
  epsilon: "\\epsilon",
  varepsilon: "\\varepsilon",
  Zeta: "Z",
  zeta: "\\zeta",
  Eta: "H",
  eta: "\\eta",
  Theta: "\\Theta",
  theta: "\\theta",
  vartheta: "\\vartheta",
  Iota: "I",
  iota: "\\iota",
  Kappa: "K",
  kappa: "\\kappa",
  varkappa: "\\varkappa",
  Lambda: "\\Lambda",
  lambda: "\\lambda",
  Mu: "M",
  mu: "\\mu",
  Nu: "N",
  nu: "\\nu",
  Xi: "\\Xi",
  xi: "\\xi",
  Omicron: "O",
  omicron: "o",
  Pi: "\\Pi",
  pi: "\\pi",
  varpi: "\\varpi",
  Rho: "P",
  rho: "\\rho",
  varrho: "\\varrho",
  Sigma: "\\Sigma",
  sigma: "\\sigma",
  varsigma: "\\varsigma",
  Tau: "T",
  tau: "\\tau",
  Upsilon: "\\Upsilon",
  upsilon: "\\upsilon",
  Phi: "\\Phi",
  phi: "\\phi",
  varphi: "\\varphi",
  Chi: "X",
  chi: "\\chi",
  Psi: "\\Psi",
  psi: "\\psi",
  Omega: "\\Omega",
  omega: "\\omega",
  // logic
  true: "\\mathrm{True}",
  false: "\\mathrm{False}",
  // other
  i: "i",
  // TODO use \i ??
  inf: "\\infty",
  Inf: "\\infty",
  infinity: "\\infty",
  Infinity: "\\infty",
  oo: "\\infty",
  lim: "\\lim",
  undefined: "\\mathbf{?}"
}, tr = {
  transpose: "^\\top",
  ctranspose: "^H",
  factorial: "!",
  pow: "^",
  dotPow: ".^\\wedge",
  // TODO find ideal solution
  unaryPlus: "+",
  unaryMinus: "-",
  bitNot: "\\~",
  // TODO find ideal solution
  not: "\\neg",
  multiply: "\\cdot",
  divide: "\\frac",
  // TODO how to handle that properly?
  dotMultiply: ".\\cdot",
  // TODO find ideal solution
  dotDivide: ".:",
  // TODO find ideal solution
  mod: "\\mod",
  add: "+",
  subtract: "-",
  to: "\\rightarrow",
  leftShift: "<<",
  rightArithShift: ">>",
  rightLogShift: ">>>",
  equal: "=",
  unequal: "\\neq",
  smaller: "<",
  larger: ">",
  smallerEq: "\\leq",
  largerEq: "\\geq",
  bitAnd: "\\&",
  bitXor: "\\underline{|}",
  bitOr: "|",
  and: "\\wedge",
  xor: "\\veebar",
  or: "\\vee"
}, Lh = {
  // arithmetic
  abs: {
    1: "\\left|${args[0]}\\right|"
  },
  add: {
    2: "\\left(${args[0]}".concat(tr.add, "${args[1]}\\right)")
  },
  cbrt: {
    1: "\\sqrt[3]{${args[0]}}"
  },
  ceil: {
    1: "\\left\\lceil${args[0]}\\right\\rceil"
  },
  cube: {
    1: "\\left(${args[0]}\\right)^3"
  },
  divide: {
    2: "\\frac{${args[0]}}{${args[1]}}"
  },
  dotDivide: {
    2: "\\left(${args[0]}".concat(tr.dotDivide, "${args[1]}\\right)")
  },
  dotMultiply: {
    2: "\\left(${args[0]}".concat(tr.dotMultiply, "${args[1]}\\right)")
  },
  dotPow: {
    2: "\\left(${args[0]}".concat(tr.dotPow, "${args[1]}\\right)")
  },
  exp: {
    1: "\\exp\\left(${args[0]}\\right)"
  },
  expm1: "\\left(e".concat(tr.pow, "{${args[0]}}-1\\right)"),
  fix: {
    1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
  },
  floor: {
    1: "\\left\\lfloor${args[0]}\\right\\rfloor"
  },
  gcd: "\\gcd\\left(${args}\\right)",
  hypot: "\\hypot\\left(${args}\\right)",
  log: {
    1: "\\ln\\left(${args[0]}\\right)",
    2: "\\log_{${args[1]}}\\left(${args[0]}\\right)"
  },
  log10: {
    1: "\\log_{10}\\left(${args[0]}\\right)"
  },
  log1p: {
    1: "\\ln\\left(${args[0]}+1\\right)",
    2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)"
  },
  log2: "\\log_{2}\\left(${args[0]}\\right)",
  mod: {
    2: "\\left(${args[0]}".concat(tr.mod, "${args[1]}\\right)")
  },
  multiply: {
    2: "\\left(${args[0]}".concat(tr.multiply, "${args[1]}\\right)")
  },
  norm: {
    1: "\\left\\|${args[0]}\\right\\|",
    2: void 0
    // use default template
  },
  nthRoot: {
    2: "\\sqrt[${args[1]}]{${args[0]}}"
  },
  nthRoots: {
    2: "\\{y : $y^{args[1]} = {${args[0]}}\\}"
  },
  pow: {
    2: "\\left(${args[0]}\\right)".concat(tr.pow, "{${args[1]}}")
  },
  round: {
    1: "\\left\\lfloor${args[0]}\\right\\rceil",
    2: void 0
    // use default template
  },
  sign: {
    1: "\\mathrm{${name}}\\left(${args[0]}\\right)"
  },
  sqrt: {
    1: "\\sqrt{${args[0]}}"
  },
  square: {
    1: "\\left(${args[0]}\\right)^2"
  },
  subtract: {
    2: "\\left(${args[0]}".concat(tr.subtract, "${args[1]}\\right)")
  },
  unaryMinus: {
    1: "".concat(tr.unaryMinus, "\\left(${args[0]}\\right)")
  },
  unaryPlus: {
    1: "".concat(tr.unaryPlus, "\\left(${args[0]}\\right)")
  },
  // bitwise
  bitAnd: {
    2: "\\left(${args[0]}".concat(tr.bitAnd, "${args[1]}\\right)")
  },
  bitNot: {
    1: tr.bitNot + "\\left(${args[0]}\\right)"
  },
  bitOr: {
    2: "\\left(${args[0]}".concat(tr.bitOr, "${args[1]}\\right)")
  },
  bitXor: {
    2: "\\left(${args[0]}".concat(tr.bitXor, "${args[1]}\\right)")
  },
  leftShift: {
    2: "\\left(${args[0]}".concat(tr.leftShift, "${args[1]}\\right)")
  },
  rightArithShift: {
    2: "\\left(${args[0]}".concat(tr.rightArithShift, "${args[1]}\\right)")
  },
  rightLogShift: {
    2: "\\left(${args[0]}".concat(tr.rightLogShift, "${args[1]}\\right)")
  },
  // combinatorics
  bellNumbers: {
    1: "\\mathrm{B}_{${args[0]}}"
  },
  catalan: {
    1: "\\mathrm{C}_{${args[0]}}"
  },
  stirlingS2: {
    2: "\\mathrm{S}\\left(${args}\\right)"
  },
  // complex
  arg: {
    1: "\\arg\\left(${args[0]}\\right)"
  },
  conj: {
    1: "\\left(${args[0]}\\right)^*"
  },
  im: {
    1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace"
  },
  re: {
    1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace"
  },
  // logical
  and: {
    2: "\\left(${args[0]}".concat(tr.and, "${args[1]}\\right)")
  },
  not: {
    1: tr.not + "\\left(${args[0]}\\right)"
  },
  or: {
    2: "\\left(${args[0]}".concat(tr.or, "${args[1]}\\right)")
  },
  xor: {
    2: "\\left(${args[0]}".concat(tr.xor, "${args[1]}\\right)")
  },
  // matrix
  cross: {
    2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)"
  },
  ctranspose: {
    1: "\\left(${args[0]}\\right)".concat(tr.ctranspose)
  },
  det: {
    1: "\\det\\left(${args[0]}\\right)"
  },
  dot: {
    2: "\\left(${args[0]}\\cdot${args[1]}\\right)"
  },
  expm: {
    1: "\\exp\\left(${args[0]}\\right)"
  },
  inv: {
    1: "\\left(${args[0]}\\right)^{-1}"
  },
  pinv: {
    1: "\\left(${args[0]}\\right)^{+}"
  },
  sqrtm: {
    1: "{${args[0]}}".concat(tr.pow, "{\\frac{1}{2}}")
  },
  trace: {
    1: "\\mathrm{tr}\\left(${args[0]}\\right)"
  },
  transpose: {
    1: "\\left(${args[0]}\\right)".concat(tr.transpose)
  },
  // probability
  combinations: {
    2: "\\binom{${args[0]}}{${args[1]}}"
  },
  combinationsWithRep: {
    2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)"
  },
  factorial: {
    1: "\\left(${args[0]}\\right)".concat(tr.factorial)
  },
  gamma: {
    1: "\\Gamma\\left(${args[0]}\\right)"
  },
  lgamma: {
    1: "\\ln\\Gamma\\left(${args[0]}\\right)"
  },
  // relational
  equal: {
    2: "\\left(${args[0]}".concat(tr.equal, "${args[1]}\\right)")
  },
  larger: {
    2: "\\left(${args[0]}".concat(tr.larger, "${args[1]}\\right)")
  },
  largerEq: {
    2: "\\left(${args[0]}".concat(tr.largerEq, "${args[1]}\\right)")
  },
  smaller: {
    2: "\\left(${args[0]}".concat(tr.smaller, "${args[1]}\\right)")
  },
  smallerEq: {
    2: "\\left(${args[0]}".concat(tr.smallerEq, "${args[1]}\\right)")
  },
  unequal: {
    2: "\\left(${args[0]}".concat(tr.unequal, "${args[1]}\\right)")
  },
  // special
  erf: {
    1: "erf\\left(${args[0]}\\right)"
  },
  // statistics
  max: "\\max\\left(${args}\\right)",
  min: "\\min\\left(${args}\\right)",
  variance: "\\mathrm{Var}\\left(${args}\\right)",
  // trigonometry
  acos: {
    1: "\\cos^{-1}\\left(${args[0]}\\right)"
  },
  acosh: {
    1: "\\cosh^{-1}\\left(${args[0]}\\right)"
  },
  acot: {
    1: "\\cot^{-1}\\left(${args[0]}\\right)"
  },
  acoth: {
    1: "\\coth^{-1}\\left(${args[0]}\\right)"
  },
  acsc: {
    1: "\\csc^{-1}\\left(${args[0]}\\right)"
  },
  acsch: {
    1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)"
  },
  asec: {
    1: "\\sec^{-1}\\left(${args[0]}\\right)"
  },
  asech: {
    1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)"
  },
  asin: {
    1: "\\sin^{-1}\\left(${args[0]}\\right)"
  },
  asinh: {
    1: "\\sinh^{-1}\\left(${args[0]}\\right)"
  },
  atan: {
    1: "\\tan^{-1}\\left(${args[0]}\\right)"
  },
  atan2: {
    2: "\\mathrm{atan2}\\left(${args}\\right)"
  },
  atanh: {
    1: "\\tanh^{-1}\\left(${args[0]}\\right)"
  },
  cos: {
    1: "\\cos\\left(${args[0]}\\right)"
  },
  cosh: {
    1: "\\cosh\\left(${args[0]}\\right)"
  },
  cot: {
    1: "\\cot\\left(${args[0]}\\right)"
  },
  coth: {
    1: "\\coth\\left(${args[0]}\\right)"
  },
  csc: {
    1: "\\csc\\left(${args[0]}\\right)"
  },
  csch: {
    1: "\\mathrm{csch}\\left(${args[0]}\\right)"
  },
  sec: {
    1: "\\sec\\left(${args[0]}\\right)"
  },
  sech: {
    1: "\\mathrm{sech}\\left(${args[0]}\\right)"
  },
  sin: {
    1: "\\sin\\left(${args[0]}\\right)"
  },
  sinh: {
    1: "\\sinh\\left(${args[0]}\\right)"
  },
  tan: {
    1: "\\tan\\left(${args[0]}\\right)"
  },
  tanh: {
    1: "\\tanh\\left(${args[0]}\\right)"
  },
  // unit
  to: {
    2: "\\left(${args[0]}".concat(tr.to, "${args[1]}\\right)")
  },
  // utils
  numeric: function(r, o) {
    return r.args[0].toTex();
  },
  // type
  number: {
    0: "0",
    1: "\\left(${args[0]}\\right)",
    2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
  },
  string: {
    0: '\\mathtt{""}',
    1: "\\mathrm{string}\\left(${args[0]}\\right)"
  },
  bignumber: {
    0: "0",
    1: "\\left(${args[0]}\\right)"
  },
  bigint: {
    0: "0",
    1: "\\left(${args[0]}\\right)"
  },
  complex: {
    0: "0",
    1: "\\left(${args[0]}\\right)",
    2: "\\left(\\left(${args[0]}\\right)+".concat(Xu.i, "\\cdot\\left(${args[1]}\\right)\\right)")
  },
  matrix: {
    0: "\\begin{bmatrix}\\end{bmatrix}",
    1: "\\left(${args[0]}\\right)",
    2: "\\left(${args[0]}\\right)"
  },
  sparse: {
    0: "\\begin{bsparse}\\end{bsparse}",
    1: "\\left(${args[0]}\\right)"
  },
  unit: {
    1: "\\left(${args[0]}\\right)",
    2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)"
  }
}, t9 = "\\mathrm{${name}}\\left(${args}\\right)", Uh = {
  deg: "^\\circ"
};
function Ju(e) {
  return r9(e, {
    preserveFormatting: !0
  });
}
function ub(e, r) {
  return r = typeof r > "u" ? !1 : r, r ? De(Uh, e) ? Uh[e] : "\\mathrm{" + Ju(e) + "}" : De(Xu, e) ? Xu[e] : Ju(e);
}
var Ki = "ConstantNode", n9 = ["Node"], i9 = /* @__PURE__ */ Q(Ki, n9, (e) => {
  var {
    Node: r
  } = e;
  class o extends r {
    /**
     * A ConstantNode holds a constant value like a number or string.
     *
     * Usage:
     *
     *     new ConstantNode(2.3)
     *     new ConstantNode('hello')
     *
     * @param {*} value    Value can be any type (number, BigNumber, bigint, string, ...)
     * @constructor ConstantNode
     * @extends {Node}
     */
    constructor(i) {
      super(), this.value = i;
    }
    get type() {
      return Ki;
    }
    get isConstantNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, t) {
      var u = this.value;
      return function() {
        return u;
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
    }
    /**
     * Create a new ConstantNode with children produced by the given callback.
     * Trivial because there are no children.
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {ConstantNode} Returns a clone of the node
     */
    map(i) {
      return this.clone();
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ConstantNode}
     */
    clone() {
      return new o(this.value);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(i) {
      return Ze(this.value, i);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(i) {
      var t = this._toString(i);
      switch (fr(this.value)) {
        case "number":
        case "bigint":
        case "BigNumber":
        case "Fraction":
          return '<span class="math-number">' + t + "</span>";
        case "string":
          return '<span class="math-string">' + t + "</span>";
        case "boolean":
          return '<span class="math-boolean">' + t + "</span>";
        case "null":
          return '<span class="math-null-symbol">' + t + "</span>";
        case "undefined":
          return '<span class="math-undefined">' + t + "</span>";
        default:
          return '<span class="math-symbol">' + t + "</span>";
      }
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Ki,
        value: this.value
      };
    }
    /**
     * Instantiate a ConstantNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "SymbolNode", value: 2.3}`,
     *                       where mathjs is optional
     * @returns {ConstantNode}
     */
    static fromJSON(i) {
      return new o(i.value);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(i) {
      var t = this._toString(i), u = fr(this.value);
      switch (u) {
        case "string":
          return "\\mathtt{" + Ju(t) + "}";
        case "number":
        case "BigNumber": {
          var l = u === "BigNumber" ? this.value.isFinite() : isFinite(this.value);
          if (!l)
            return this.value.valueOf() < 0 ? "-\\infty" : "\\infty";
          var f = t.toLowerCase().indexOf("e");
          return f !== -1 ? t.substring(0, f) + "\\cdot10^{" + t.substring(f + 1) + "}" : t;
        }
        case "bigint":
          return t.toString();
        case "Fraction":
          return this.value.toLatex();
        default:
          return t;
      }
    }
  }
  return Fr(o, "name", Ki), o;
}, {
  isClass: !0,
  isNode: !0
}), Zi = "FunctionAssignmentNode", a9 = ["typed", "Node"], o9 = /* @__PURE__ */ Q(Zi, a9, (e) => {
  var {
    typed: r,
    Node: o
  } = e;
  function n(t, u, l) {
    var f = ur(t, u, l), s = ur(t.expr, u, l);
    return u === "all" || s !== null && s <= f;
  }
  class i extends o {
    /**
     * @constructor FunctionAssignmentNode
     * @extends {Node}
     * Function assignment
     *
     * @param {string} name           Function name
     * @param {string[] | Array.<{name: string, type: string}>} params
     *                                Array with function parameter names, or an
     *                                array with objects containing the name
     *                                and type of the parameter
     * @param {Node} expr             The function expression
     */
    constructor(u, l, f) {
      if (super(), typeof u != "string")
        throw new TypeError('String expected for parameter "name"');
      if (!Array.isArray(l))
        throw new TypeError('Array containing strings or objects expected for parameter "params"');
      if (!or(f))
        throw new TypeError('Node expected for parameter "expr"');
      if (ob.has(u))
        throw new Error('Illegal function name, "' + u + '" is a reserved keyword');
      var s = /* @__PURE__ */ new Set();
      for (var a of l) {
        var c = typeof a == "string" ? a : a.name;
        if (s.has(c))
          throw new Error('Duplicate parameter name "'.concat(c, '"'));
        s.add(c);
      }
      this.name = u, this.params = l.map(function(d) {
        return d && d.name || d;
      }), this.types = l.map(function(d) {
        return d && d.type || "any";
      }), this.expr = f;
    }
    get type() {
      return Zi;
    }
    get isFunctionAssignmentNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(u, l) {
      var f = Object.create(l);
      to(this.params, function(p) {
        f[p] = !0;
      });
      var s = this.expr._compile(u, f), a = this.name, c = this.params, d = kc(this.types, ","), h = a + "(" + kc(this.params, ", ") + ")";
      return function(v, g, m) {
        var x = {};
        x[d] = function() {
          for (var E = Object.create(g), N = 0; N < c.length; N++)
            E[c[N]] = arguments[N];
          return s(v, E, m);
        };
        var y = r(a, x);
        return y.syntax = h, v.set(a, y), y;
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(u) {
      u(this.expr, "expr", this);
    }
    /**
     * Create a new FunctionAssignmentNode whose children are the results of
     * calling the provided callback function for each child of the original
     * node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {FunctionAssignmentNode} Returns a transformed copy of the node
     */
    map(u) {
      var l = this._ifNode(u(this.expr, "expr", this));
      return new i(this.name, this.params.slice(0), l);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {FunctionAssignmentNode}
     */
    clone() {
      return new i(this.name, this.params.slice(0), this.expr);
    }
    /**
     * get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(u) {
      var l = u && u.parenthesis ? u.parenthesis : "keep", f = this.expr.toString(u);
      return n(this, l, u && u.implicit) && (f = "(" + f + ")"), this.name + "(" + this.params.join(", ") + ") = " + f;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      var u = this.types;
      return {
        mathjs: Zi,
        name: this.name,
        params: this.params.map(function(l, f) {
          return {
            name: l,
            type: u[f]
          };
        }),
        expr: this.expr
      };
    }
    /**
     * Instantiate an FunctionAssignmentNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     ```
     *     {"mathjs": "FunctionAssignmentNode",
     *      name: ..., params: ..., expr: ...}
     *     ```
     *     where mathjs is optional
     * @returns {FunctionAssignmentNode}
     */
    static fromJSON(u) {
      return new i(u.name, u.params, u.expr);
    }
    /**
     * get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(u) {
      for (var l = u && u.parenthesis ? u.parenthesis : "keep", f = [], s = 0; s < this.params.length; s++)
        f.push('<span class="math-symbol math-parameter">' + ct(this.params[s]) + "</span>");
      var a = this.expr.toHTML(u);
      return n(this, l, u && u.implicit) && (a = '<span class="math-parenthesis math-round-parenthesis">(</span>' + a + '<span class="math-parenthesis math-round-parenthesis">)</span>'), '<span class="math-function">' + ct(this.name) + '</span><span class="math-parenthesis math-round-parenthesis">(</span>' + f.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>' + a;
    }
    /**
     * get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(u) {
      var l = u && u.parenthesis ? u.parenthesis : "keep", f = this.expr.toTex(u);
      return n(this, l, u && u.implicit) && (f = "\\left(".concat(f, "\\right)")), "\\mathrm{" + this.name + "}\\left(" + this.params.map(ub).join(",") + "\\right)=" + f;
    }
  }
  return Fr(i, "name", Zi), i;
}, {
  isClass: !0,
  isNode: !0
}), ji = "IndexNode", s9 = ["Node", "size"], u9 = /* @__PURE__ */ Q(ji, s9, (e) => {
  var {
    Node: r,
    size: o
  } = e;
  class n extends r {
    /**
     * @constructor IndexNode
     * @extends Node
     *
     * Describes a subset of a matrix or an object property.
     * Cannot be used on its own, needs to be used within an AccessorNode or
     * AssignmentNode.
     *
     * @param {Node[]} dimensions
     * @param {boolean} [dotNotation=false]
     *     Optional property describing whether this index was written using dot
     *     notation like `a.b`, or using bracket notation like `a["b"]`
     *     (which is the default). This property is used for string conversion.
     */
    constructor(t, u) {
      if (super(), this.dimensions = t, this.dotNotation = u || !1, !Array.isArray(t) || !t.every(or))
        throw new TypeError('Array containing Nodes expected for parameter "dimensions"');
      if (this.dotNotation && !this.isObjectProperty())
        throw new Error("dotNotation only applicable for object properties");
    }
    get type() {
      return ji;
    }
    get isIndexNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(t, u) {
      var l = Ht(this.dimensions, function(s, a) {
        var c = s.filter((p) => p.isSymbolNode && p.name === "end").length > 0;
        if (c) {
          var d = Object.create(u);
          d.end = !0;
          var h = s._compile(t, d);
          return function(v, g, m) {
            if (!Fe(m) && !ar(m) && !qr(m))
              throw new TypeError('Cannot resolve "end": context must be a Matrix, Array, or string but is ' + fr(m));
            var x = o(m).valueOf(), y = Object.create(g);
            return y.end = x[a], h(v, y, m);
          };
        } else
          return s._compile(t, u);
      }), f = Vr(t, "index");
      return function(a, c, d) {
        var h = Ht(l, function(p) {
          return p(a, c, d);
        });
        return f(...h);
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(t) {
      for (var u = 0; u < this.dimensions.length; u++)
        t(this.dimensions[u], "dimensions[" + u + "]", this);
    }
    /**
     * Create a new IndexNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {IndexNode} Returns a transformed copy of the node
     */
    map(t) {
      for (var u = [], l = 0; l < this.dimensions.length; l++)
        u[l] = this._ifNode(t(this.dimensions[l], "dimensions[" + l + "]", this));
      return new n(u, this.dotNotation);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {IndexNode}
     */
    clone() {
      return new n(this.dimensions.slice(0), this.dotNotation);
    }
    /**
     * Test whether this IndexNode contains a single property name
     * @return {boolean}
     */
    isObjectProperty() {
      return this.dimensions.length === 1 && rr(this.dimensions[0]) && typeof this.dimensions[0].value == "string";
    }
    /**
     * Returns the property name if IndexNode contains a property.
     * If not, returns null.
     * @return {string | null}
     */
    getObjectProperty() {
      return this.isObjectProperty() ? this.dimensions[0].value : null;
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(t) {
      return this.dotNotation ? "." + this.getObjectProperty() : "[" + this.dimensions.join(", ") + "]";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: ji,
        dimensions: this.dimensions,
        dotNotation: this.dotNotation
      };
    }
    /**
     * Instantiate an IndexNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "IndexNode", dimensions: [...], dotNotation: false}`,
     *     where mathjs is optional
     * @returns {IndexNode}
     */
    static fromJSON(t) {
      return new n(t.dimensions, t.dotNotation);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(t) {
      for (var u = [], l = 0; l < this.dimensions.length; l++)
        u[l] = this.dimensions[l].toHTML();
      return this.dotNotation ? '<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">' + ct(this.getObjectProperty()) + "</span>" : '<span class="math-parenthesis math-square-parenthesis">[</span>' + u.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-square-parenthesis">]</span>';
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(t) {
      var u = this.dimensions.map(function(l) {
        return l.toTex(t);
      });
      return this.dotNotation ? "." + this.getObjectProperty() : "_{" + u.join(",") + "}";
    }
  }
  return Fr(n, "name", ji), n;
}, {
  isClass: !0,
  isNode: !0
}), Yi = "ObjectNode", f9 = ["Node"], c9 = /* @__PURE__ */ Q(Yi, f9, (e) => {
  var {
    Node: r
  } = e;
  class o extends r {
    /**
     * @constructor ObjectNode
     * @extends {Node}
     * Holds an object with keys/values
     * @param {Object.<string, Node>} [properties]   object with key/value pairs
     */
    constructor(i) {
      if (super(), this.properties = i || {}, i && (typeof i != "object" || !Object.keys(i).every(function(t) {
        return or(i[t]);
      })))
        throw new TypeError("Object containing Nodes expected");
    }
    get type() {
      return Yi;
    }
    get isObjectNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, t) {
      var u = {};
      for (var l in this.properties)
        if (De(this.properties, l)) {
          var f = qn(l), s = JSON.parse(f), a = Vr(this.properties, l);
          u[s] = a._compile(i, t);
        }
      return function(d, h, p) {
        var v = {};
        for (var g in u)
          De(u, g) && (v[g] = u[g](d, h, p));
        return v;
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      for (var t in this.properties)
        De(this.properties, t) && i(this.properties[t], "properties[" + qn(t) + "]", this);
    }
    /**
     * Create a new ObjectNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {ObjectNode} Returns a transformed copy of the node
     */
    map(i) {
      var t = {};
      for (var u in this.properties)
        De(this.properties, u) && (t[u] = this._ifNode(i(this.properties[u], "properties[" + qn(u) + "]", this)));
      return new o(t);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ObjectNode}
     */
    clone() {
      var i = {};
      for (var t in this.properties)
        De(this.properties, t) && (i[t] = this.properties[t]);
      return new o(i);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(i) {
      var t = [];
      for (var u in this.properties)
        De(this.properties, u) && t.push(qn(u) + ": " + this.properties[u].toString(i));
      return "{" + t.join(", ") + "}";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Yi,
        properties: this.properties
      };
    }
    /**
     * Instantiate an OperatorNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ObjectNode", "properties": {...}}`,
     *                       where mathjs is optional
     * @returns {ObjectNode}
     */
    static fromJSON(i) {
      return new o(i.properties);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(i) {
      var t = [];
      for (var u in this.properties)
        De(this.properties, u) && t.push('<span class="math-symbol math-property">' + ct(u) + '</span><span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>' + this.properties[u].toHTML(i));
      return '<span class="math-parenthesis math-curly-parenthesis">{</span>' + t.join('<span class="math-separator">,</span>') + '<span class="math-parenthesis math-curly-parenthesis">}</span>';
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(i) {
      var t = [];
      for (var u in this.properties)
        De(this.properties, u) && t.push("\\mathbf{" + u + ":} & " + this.properties[u].toTex(i) + "\\\\");
      var l = "\\left\\{\\begin{array}{ll}" + t.join(`
`) + "\\end{array}\\right\\}";
      return l;
    }
  }
  return Fr(o, "name", Yi), o;
}, {
  isClass: !0,
  isNode: !0
});
function di(e, r) {
  return new x1(e, new Ja(r), new Set(Object.keys(r)));
}
var Xi = "OperatorNode", l9 = ["Node"], d9 = /* @__PURE__ */ Q(Xi, l9, (e) => {
  var {
    Node: r
  } = e;
  function o(t, u) {
    var l = t;
    if (u === "auto")
      for (; Dt(l); )
        l = l.content;
    return rr(l) ? !0 : Cr(l) ? o(l.args[0], u) : !1;
  }
  function n(t, u, l, f, s) {
    var a = ur(t, u, l), c = ui(t, u);
    if (u === "all" || f.length > 2 && t.getIdentifier() !== "OperatorNode:add" && t.getIdentifier() !== "OperatorNode:multiply")
      return f.map(function($) {
        switch ($.getContent().type) {
          case "ArrayNode":
          case "ConstantNode":
          case "SymbolNode":
          case "ParenthesisNode":
            return !1;
          default:
            return !0;
        }
      });
    var d;
    switch (f.length) {
      case 0:
        d = [];
        break;
      case 1:
        {
          var h = ur(f[0], u, l, t);
          if (s && h !== null) {
            var p, v;
            if (u === "keep" ? (p = f[0].getIdentifier(), v = t.getIdentifier()) : (p = f[0].getContent().getIdentifier(), v = t.getContent().getIdentifier()), mt[a][v].latexLeftParens === !1) {
              d = [!1];
              break;
            }
            if (mt[h][p].latexParens === !1) {
              d = [!1];
              break;
            }
          }
          if (h === null) {
            d = [!1];
            break;
          }
          if (h <= a) {
            d = [!0];
            break;
          }
          d = [!1];
        }
        break;
      case 2:
        {
          var g, m = ur(f[0], u, l, t), x = Eo(t, f[0], u);
          m === null ? g = !1 : m === a && c === "right" && !x || m < a ? g = !0 : g = !1;
          var y, E = ur(f[1], u, l, t), N = Eo(t, f[1], u);
          if (E === null ? y = !1 : E === a && c === "left" && !N || E < a ? y = !0 : y = !1, s) {
            var S, R, O;
            u === "keep" ? (S = t.getIdentifier(), R = t.args[0].getIdentifier(), O = t.args[1].getIdentifier()) : (S = t.getContent().getIdentifier(), R = t.args[0].getContent().getIdentifier(), O = t.args[1].getContent().getIdentifier()), m !== null && (mt[a][S].latexLeftParens === !1 && (g = !1), mt[m][R].latexParens === !1 && (g = !1)), E !== null && (mt[a][S].latexRightParens === !1 && (y = !1), mt[E][O].latexParens === !1 && (y = !1));
          }
          d = [g, y];
        }
        break;
      default:
        (t.getIdentifier() === "OperatorNode:add" || t.getIdentifier() === "OperatorNode:multiply") && (d = f.map(function($) {
          var F = ur($, u, l, t), w = Eo(t, $, u), A = ui($, u);
          return F === null ? !1 : a === F && c === A && !w ? !0 : F < a;
        }));
        break;
    }
    if (f.length >= 2 && t.getIdentifier() === "OperatorNode:multiply" && t.implicit && u !== "all" && l === "hide")
      for (var B = 1; B < d.length; ++B)
        o(f[B], u) && !d[B - 1] && (u !== "keep" || !Dt(f[B - 1])) && (d[B] = !0);
    return d;
  }
  class i extends r {
    /**
     * @constructor OperatorNode
     * @extends {Node}
     * An operator with two arguments, like 2+3
     *
     * @param {string} op           Operator name, for example '+'
     * @param {string} fn           Function name, for example 'add'
     * @param {Node[]} args         Operator arguments
     * @param {boolean} [implicit]  Is this an implicit multiplication?
     * @param {boolean} [isPercentage] Is this an percentage Operation?
     */
    constructor(u, l, f, s, a) {
      if (super(), typeof u != "string")
        throw new TypeError('string expected for parameter "op"');
      if (typeof l != "string")
        throw new TypeError('string expected for parameter "fn"');
      if (!Array.isArray(f) || !f.every(or))
        throw new TypeError('Array containing Nodes expected for parameter "args"');
      this.implicit = s === !0, this.isPercentage = a === !0, this.op = u, this.fn = l, this.args = f || [];
    }
    get type() {
      return Xi;
    }
    get isOperatorNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(u, l) {
      if (typeof this.fn != "string" || !Cf(u, this.fn))
        throw u[this.fn] ? new Error('No access to function "' + this.fn + '"') : new Error("Function " + this.fn + ' missing in provided namespace "math"');
      var f = Vr(u, this.fn), s = Ht(this.args, function(p) {
        return p._compile(u, l);
      });
      if (typeof f == "function" && f.rawArgs === !0) {
        var a = this.args;
        return function(v, g, m) {
          return f(a, u, di(v, g));
        };
      } else if (s.length === 1) {
        var c = s[0];
        return function(v, g, m) {
          return f(c(v, g, m));
        };
      } else if (s.length === 2) {
        var d = s[0], h = s[1];
        return function(v, g, m) {
          return f(d(v, g, m), h(v, g, m));
        };
      } else
        return function(v, g, m) {
          return f.apply(null, Ht(s, function(x) {
            return x(v, g, m);
          }));
        };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(u) {
      for (var l = 0; l < this.args.length; l++)
        u(this.args[l], "args[" + l + "]", this);
    }
    /**
     * Create a new OperatorNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {OperatorNode} Returns a transformed copy of the node
     */
    map(u) {
      for (var l = [], f = 0; f < this.args.length; f++)
        l[f] = this._ifNode(u(this.args[f], "args[" + f + "]", this));
      return new i(this.op, this.fn, l, this.implicit, this.isPercentage);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {OperatorNode}
     */
    clone() {
      return new i(this.op, this.fn, this.args.slice(0), this.implicit, this.isPercentage);
    }
    /**
     * Check whether this is an unary OperatorNode:
     * has exactly one argument, like `-a`.
     * @return {boolean}
     *     Returns true when an unary operator node, false otherwise.
     */
    isUnary() {
      return this.args.length === 1;
    }
    /**
     * Check whether this is a binary OperatorNode:
     * has exactly two arguments, like `a + b`.
     * @return {boolean}
     *     Returns true when a binary operator node, false otherwise.
     */
    isBinary() {
      return this.args.length === 2;
    }
    /**
     * Get string representation.
     * @param {Object} options
     * @return {string} str
     */
    _toString(u) {
      var l = u && u.parenthesis ? u.parenthesis : "keep", f = u && u.implicit ? u.implicit : "hide", s = this.args, a = n(this, l, f, s, !1);
      if (s.length === 1) {
        var c = ui(this, l), d = s[0].toString(u);
        a[0] && (d = "(" + d + ")");
        var h = /[a-zA-Z]+/.test(this.op);
        return c === "right" ? this.op + (h ? " " : "") + d : c === "left" ? d + (h ? " " : "") + this.op : d + this.op;
      } else if (s.length === 2) {
        var p = s[0].toString(u), v = s[1].toString(u);
        return a[0] && (p = "(" + p + ")"), a[1] && (v = "(" + v + ")"), this.implicit && this.getIdentifier() === "OperatorNode:multiply" && f === "hide" ? p + " " + v : p + " " + this.op + " " + v;
      } else if (s.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
        var g = s.map(function(m, x) {
          return m = m.toString(u), a[x] && (m = "(" + m + ")"), m;
        });
        return this.implicit && this.getIdentifier() === "OperatorNode:multiply" && f === "hide" ? g.join(" ") : g.join(" " + this.op + " ");
      } else
        return this.fn + "(" + this.args.join(", ") + ")";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Xi,
        op: this.op,
        fn: this.fn,
        args: this.args,
        implicit: this.implicit,
        isPercentage: this.isPercentage
      };
    }
    /**
     * Instantiate an OperatorNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     ```
     *     {"mathjs": "OperatorNode",
     *      "op": "+", "fn": "add", "args": [...],
     *      "implicit": false,
     *      "isPercentage":false}
     *     ```
     *     where mathjs is optional
     * @returns {OperatorNode}
     */
    static fromJSON(u) {
      return new i(u.op, u.fn, u.args, u.implicit, u.isPercentage);
    }
    /**
     * Get HTML representation.
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(u) {
      var l = u && u.parenthesis ? u.parenthesis : "keep", f = u && u.implicit ? u.implicit : "hide", s = this.args, a = n(this, l, f, s, !1);
      if (s.length === 1) {
        var c = ui(this, l), d = s[0].toHTML(u);
        return a[0] && (d = '<span class="math-parenthesis math-round-parenthesis">(</span>' + d + '<span class="math-parenthesis math-round-parenthesis">)</span>'), c === "right" ? '<span class="math-operator math-unary-operator math-lefthand-unary-operator">' + ct(this.op) + "</span>" + d : d + '<span class="math-operator math-unary-operator math-righthand-unary-operator">' + ct(this.op) + "</span>";
      } else if (s.length === 2) {
        var h = s[0].toHTML(u), p = s[1].toHTML(u);
        return a[0] && (h = '<span class="math-parenthesis math-round-parenthesis">(</span>' + h + '<span class="math-parenthesis math-round-parenthesis">)</span>'), a[1] && (p = '<span class="math-parenthesis math-round-parenthesis">(</span>' + p + '<span class="math-parenthesis math-round-parenthesis">)</span>'), this.implicit && this.getIdentifier() === "OperatorNode:multiply" && f === "hide" ? h + '<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>' + p : h + '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + ct(this.op) + "</span>" + p;
      } else {
        var v = s.map(function(g, m) {
          return g = g.toHTML(u), a[m] && (g = '<span class="math-parenthesis math-round-parenthesis">(</span>' + g + '<span class="math-parenthesis math-round-parenthesis">)</span>'), g;
        });
        return s.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply") ? this.implicit && this.getIdentifier() === "OperatorNode:multiply" && f === "hide" ? v.join('<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>') : v.join('<span class="math-operator math-binary-operator math-explicit-binary-operator">' + ct(this.op) + "</span>") : '<span class="math-function">' + ct(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + v.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
      }
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(u) {
      var l = u && u.parenthesis ? u.parenthesis : "keep", f = u && u.implicit ? u.implicit : "hide", s = this.args, a = n(this, l, f, s, !0), c = tr[this.fn];
      if (c = typeof c > "u" ? this.op : c, s.length === 1) {
        var d = ui(this, l), h = s[0].toTex(u);
        return a[0] && (h = "\\left(".concat(h, "\\right)")), d === "right" ? c + h : h + c;
      } else if (s.length === 2) {
        var p = s[0], v = p.toTex(u);
        a[0] && (v = "\\left(".concat(v, "\\right)"));
        var g = s[1], m = g.toTex(u);
        a[1] && (m = "\\left(".concat(m, "\\right)"));
        var x;
        switch (l === "keep" ? x = p.getIdentifier() : x = p.getContent().getIdentifier(), this.getIdentifier()) {
          case "OperatorNode:divide":
            return c + "{" + v + "}{" + m + "}";
          case "OperatorNode:pow":
            switch (v = "{" + v + "}", m = "{" + m + "}", x) {
              case "ConditionalNode":
              case "OperatorNode:divide":
                v = "\\left(".concat(v, "\\right)");
            }
            break;
          case "OperatorNode:multiply":
            if (this.implicit && f === "hide")
              return v + "~" + m;
        }
        return v + c + m;
      } else if (s.length > 2 && (this.getIdentifier() === "OperatorNode:add" || this.getIdentifier() === "OperatorNode:multiply")) {
        var y = s.map(function(E, N) {
          return E = E.toTex(u), a[N] && (E = "\\left(".concat(E, "\\right)")), E;
        });
        return this.getIdentifier() === "OperatorNode:multiply" && this.implicit && f === "hide" ? y.join("~") : y.join(c);
      } else
        return "\\mathrm{" + this.fn + "}\\left(" + s.map(function(E) {
          return E.toTex(u);
        }).join(",") + "\\right)";
    }
    /**
     * Get identifier.
     * @return {string}
     */
    getIdentifier() {
      return this.type + ":" + this.fn;
    }
  }
  return Fr(i, "name", Xi), i;
}, {
  isClass: !0,
  isNode: !0
}), Ji = "ParenthesisNode", h9 = ["Node"], p9 = /* @__PURE__ */ Q(Ji, h9, (e) => {
  var {
    Node: r
  } = e;
  class o extends r {
    /**
     * @constructor ParenthesisNode
     * @extends {Node}
     * A parenthesis node describes manual parenthesis from the user input
     * @param {Node} content
     * @extends {Node}
     */
    constructor(i) {
      if (super(), !or(i))
        throw new TypeError('Node expected for parameter "content"');
      this.content = i;
    }
    get type() {
      return Ji;
    }
    get isParenthesisNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(i, t) {
      return this.content._compile(i, t);
    }
    /**
     * Get the content of the current Node.
     * @return {Node} content
     * @override
     **/
    getContent() {
      return this.content.getContent();
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(i) {
      i(this.content, "content", this);
    }
    /**
     * Create a new ParenthesisNode whose child is the result of calling
     * the provided callback function on the child of this node.
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {ParenthesisNode} Returns a clone of the node
     */
    map(i) {
      var t = i(this.content, "content", this);
      return new o(t);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {ParenthesisNode}
     */
    clone() {
      return new o(this.content);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(i) {
      return !i || i && !i.parenthesis || i && i.parenthesis === "keep" ? "(" + this.content.toString(i) + ")" : this.content.toString(i);
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Ji,
        content: this.content
      };
    }
    /**
     * Instantiate an ParenthesisNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "ParenthesisNode", "content": ...}`,
     *                       where mathjs is optional
     * @returns {ParenthesisNode}
     */
    static fromJSON(i) {
      return new o(i.content);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(i) {
      return !i || i && !i.parenthesis || i && i.parenthesis === "keep" ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + this.content.toHTML(i) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : this.content.toHTML(i);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toTex(i) {
      return !i || i && !i.parenthesis || i && i.parenthesis === "keep" ? "\\left(".concat(this.content.toTex(i), "\\right)") : this.content.toTex(i);
    }
  }
  return Fr(o, "name", Ji), o;
}, {
  isClass: !0,
  isNode: !0
}), Qi = "RangeNode", v9 = ["Node"], m9 = /* @__PURE__ */ Q(Qi, v9, (e) => {
  var {
    Node: r
  } = e;
  function o(i, t, u) {
    var l = ur(i, t, u), f = {}, s = ur(i.start, t, u);
    if (f.start = s !== null && s <= l || t === "all", i.step) {
      var a = ur(i.step, t, u);
      f.step = a !== null && a <= l || t === "all";
    }
    var c = ur(i.end, t, u);
    return f.end = c !== null && c <= l || t === "all", f;
  }
  class n extends r {
    /**
     * @constructor RangeNode
     * @extends {Node}
     * create a range
     * @param {Node} start  included lower-bound
     * @param {Node} end    included upper-bound
     * @param {Node} [step] optional step
     */
    constructor(t, u, l) {
      if (super(), !or(t))
        throw new TypeError("Node expected");
      if (!or(u))
        throw new TypeError("Node expected");
      if (l && !or(l))
        throw new TypeError("Node expected");
      if (arguments.length > 3)
        throw new Error("Too many arguments");
      this.start = t, this.end = u, this.step = l || null;
    }
    get type() {
      return Qi;
    }
    get isRangeNode() {
      return !0;
    }
    /**
     * Check whether the RangeNode needs the `end` symbol to be defined.
     * This end is the size of the Matrix in current dimension.
     * @return {boolean}
     */
    needsEnd() {
      var t = this.filter(function(u) {
        return Br(u) && u.name === "end";
      });
      return t.length > 0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(t, u) {
      var l = t.range, f = this.start._compile(t, u), s = this.end._compile(t, u);
      if (this.step) {
        var a = this.step._compile(t, u);
        return function(d, h, p) {
          return l(f(d, h, p), s(d, h, p), a(d, h, p));
        };
      } else
        return function(d, h, p) {
          return l(f(d, h, p), s(d, h, p));
        };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(t) {
      t(this.start, "start", this), t(this.end, "end", this), this.step && t(this.step, "step", this);
    }
    /**
     * Create a new RangeNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {RangeNode} Returns a transformed copy of the node
     */
    map(t) {
      return new n(this._ifNode(t(this.start, "start", this)), this._ifNode(t(this.end, "end", this)), this.step && this._ifNode(t(this.step, "step", this)));
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {RangeNode}
     */
    clone() {
      return new n(this.start, this.end, this.step && this.step);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(t) {
      var u = t && t.parenthesis ? t.parenthesis : "keep", l = o(this, u, t && t.implicit), f, s = this.start.toString(t);
      if (l.start && (s = "(" + s + ")"), f = s, this.step) {
        var a = this.step.toString(t);
        l.step && (a = "(" + a + ")"), f += ":" + a;
      }
      var c = this.end.toString(t);
      return l.end && (c = "(" + c + ")"), f += ":" + c, f;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: Qi,
        start: this.start,
        end: this.end,
        step: this.step
      };
    }
    /**
     * Instantiate an RangeNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "RangeNode", "start": ..., "end": ..., "step": ...}`,
     *     where mathjs is optional
     * @returns {RangeNode}
     */
    static fromJSON(t) {
      return new n(t.start, t.end, t.step);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(t) {
      var u = t && t.parenthesis ? t.parenthesis : "keep", l = o(this, u, t && t.implicit), f, s = this.start.toHTML(t);
      if (l.start && (s = '<span class="math-parenthesis math-round-parenthesis">(</span>' + s + '<span class="math-parenthesis math-round-parenthesis">)</span>'), f = s, this.step) {
        var a = this.step.toHTML(t);
        l.step && (a = '<span class="math-parenthesis math-round-parenthesis">(</span>' + a + '<span class="math-parenthesis math-round-parenthesis">)</span>'), f += '<span class="math-operator math-range-operator">:</span>' + a;
      }
      var c = this.end.toHTML(t);
      return l.end && (c = '<span class="math-parenthesis math-round-parenthesis">(</span>' + c + '<span class="math-parenthesis math-round-parenthesis">)</span>'), f += '<span class="math-operator math-range-operator">:</span>' + c, f;
    }
    /**
     * Get LaTeX representation
     * @params {Object} options
     * @return {string} str
     */
    _toTex(t) {
      var u = t && t.parenthesis ? t.parenthesis : "keep", l = o(this, u, t && t.implicit), f = this.start.toTex(t);
      if (l.start && (f = "\\left(".concat(f, "\\right)")), this.step) {
        var s = this.step.toTex(t);
        l.step && (s = "\\left(".concat(s, "\\right)")), f += ":" + s;
      }
      var a = this.end.toTex(t);
      return l.end && (a = "\\left(".concat(a, "\\right)")), f += ":" + a, f;
    }
  }
  return Fr(n, "name", Qi), n;
}, {
  isClass: !0,
  isNode: !0
}), ea = "RelationalNode", g9 = ["Node"], b9 = /* @__PURE__ */ Q(ea, g9, (e) => {
  var {
    Node: r
  } = e, o = {
    equal: "==",
    unequal: "!=",
    smaller: "<",
    larger: ">",
    smallerEq: "<=",
    largerEq: ">="
  };
  class n extends r {
    /**
     * A node representing a chained conditional expression, such as 'x > y > z'
     *
     * @param {String[]} conditionals
     *     An array of conditional operators used to compare the parameters
     * @param {Node[]} params
     *     The parameters that will be compared
     *
     * @constructor RelationalNode
     * @extends {Node}
     */
    constructor(t, u) {
      if (super(), !Array.isArray(t))
        throw new TypeError("Parameter conditionals must be an array");
      if (!Array.isArray(u))
        throw new TypeError("Parameter params must be an array");
      if (t.length !== u.length - 1)
        throw new TypeError("Parameter params must contain exactly one more element than parameter conditionals");
      this.conditionals = t, this.params = u;
    }
    get type() {
      return ea;
    }
    get isRelationalNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(t, u) {
      var l = this, f = this.params.map((s) => s._compile(t, u));
      return function(a, c, d) {
        for (var h, p = f[0](a, c, d), v = 0; v < l.conditionals.length; v++) {
          h = p, p = f[v + 1](a, c, d);
          var g = Vr(t, l.conditionals[v]);
          if (!g(h, p))
            return !1;
        }
        return !0;
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(t) {
      this.params.forEach((u, l) => t(u, "params[" + l + "]", this), this);
    }
    /**
     * Create a new RelationalNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {RelationalNode} Returns a transformed copy of the node
     */
    map(t) {
      return new n(this.conditionals.slice(), this.params.map((u, l) => this._ifNode(t(u, "params[" + l + "]", this)), this));
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {RelationalNode}
     */
    clone() {
      return new n(this.conditionals, this.params);
    }
    /**
     * Get string representation.
     * @param {Object} options
     * @return {string} str
     */
    _toString(t) {
      for (var u = t && t.parenthesis ? t.parenthesis : "keep", l = ur(this, u, t && t.implicit), f = this.params.map(function(c, d) {
        var h = ur(c, u, t && t.implicit);
        return u === "all" || h !== null && h <= l ? "(" + c.toString(t) + ")" : c.toString(t);
      }), s = f[0], a = 0; a < this.conditionals.length; a++)
        s += " " + o[this.conditionals[a]], s += " " + f[a + 1];
      return s;
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: ea,
        conditionals: this.conditionals,
        params: this.params
      };
    }
    /**
     * Instantiate a RelationalNode from its JSON representation
     * @param {Object} json
     *     An object structured like
     *     `{"mathjs": "RelationalNode", "conditionals": ..., "params": ...}`,
     *     where mathjs is optional
     * @returns {RelationalNode}
     */
    static fromJSON(t) {
      return new n(t.conditionals, t.params);
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(t) {
      for (var u = t && t.parenthesis ? t.parenthesis : "keep", l = ur(this, u, t && t.implicit), f = this.params.map(function(c, d) {
        var h = ur(c, u, t && t.implicit);
        return u === "all" || h !== null && h <= l ? '<span class="math-parenthesis math-round-parenthesis">(</span>' + c.toHTML(t) + '<span class="math-parenthesis math-round-parenthesis">)</span>' : c.toHTML(t);
      }), s = f[0], a = 0; a < this.conditionals.length; a++)
        s += '<span class="math-operator math-binary-operator math-explicit-binary-operator">' + ct(o[this.conditionals[a]]) + "</span>" + f[a + 1];
      return s;
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(t) {
      for (var u = t && t.parenthesis ? t.parenthesis : "keep", l = ur(this, u, t && t.implicit), f = this.params.map(function(c, d) {
        var h = ur(c, u, t && t.implicit);
        return u === "all" || h !== null && h <= l ? "\\left(" + c.toTex(t) + "\right)" : c.toTex(t);
      }), s = f[0], a = 0; a < this.conditionals.length; a++)
        s += tr[this.conditionals[a]] + f[a + 1];
      return s;
    }
  }
  return Fr(n, "name", ea), n;
}, {
  isClass: !0,
  isNode: !0
}), y9 = "SymbolNode", w9 = ["math", "?Unit", "Node"], x9 = /* @__PURE__ */ Q(y9, w9, (e) => {
  var {
    math: r,
    Unit: o,
    Node: n
  } = e;
  function i(u) {
    return o ? o.isValuelessUnit(u) : !1;
  }
  class t extends n {
    /**
     * @constructor SymbolNode
     * @extends {Node}
     * A symbol node can hold and resolve a symbol
     * @param {string} name
     * @extends {Node}
     */
    constructor(l) {
      if (super(), typeof l != "string")
        throw new TypeError('String expected for parameter "name"');
      this.name = l;
    }
    get type() {
      return "SymbolNode";
    }
    get isSymbolNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(l, f) {
      var s = this.name;
      if (f[s] === !0)
        return function(c, d, h) {
          return Vr(d, s);
        };
      if (s in l)
        return function(c, d, h) {
          return c.has(s) ? c.get(s) : Vr(l, s);
        };
      var a = i(s);
      return function(c, d, h) {
        return c.has(s) ? c.get(s) : a ? new o(null, s) : t.onUndefinedSymbol(s);
      };
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(l) {
    }
    /**
     * Create a new SymbolNode with children produced by the given callback.
     * Trivial since a SymbolNode has no children
     * @param {function(child: Node, path: string, parent: Node) : Node} callback
     * @returns {SymbolNode} Returns a clone of the node
     */
    map(l) {
      return this.clone();
    }
    /**
     * Throws an error 'Undefined symbol {name}'
     * @param {string} name
     */
    static onUndefinedSymbol(l) {
      throw new Error("Undefined symbol " + l);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {SymbolNode}
     */
    clone() {
      return new t(this.name);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toString(l) {
      return this.name;
    }
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toHTML(l) {
      var f = ct(this.name);
      return f === "true" || f === "false" ? '<span class="math-symbol math-boolean">' + f + "</span>" : f === "i" ? '<span class="math-symbol math-imaginary-symbol">' + f + "</span>" : f === "Infinity" ? '<span class="math-symbol math-infinity-symbol">' + f + "</span>" : f === "NaN" ? '<span class="math-symbol math-nan-symbol">' + f + "</span>" : f === "null" ? '<span class="math-symbol math-null-symbol">' + f + "</span>" : f === "undefined" ? '<span class="math-symbol math-undefined-symbol">' + f + "</span>" : '<span class="math-symbol">' + f + "</span>";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: "SymbolNode",
        name: this.name
      };
    }
    /**
     * Instantiate a SymbolNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "SymbolNode", name: "x"}`,
     *                       where mathjs is optional
     * @returns {SymbolNode}
     */
    static fromJSON(l) {
      return new t(l.name);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     * @override
     */
    _toTex(l) {
      var f = !1;
      typeof r[this.name] > "u" && i(this.name) && (f = !0);
      var s = ub(this.name, f);
      return s[0] === "\\" ? s : " " + s;
    }
  }
  return t;
}, {
  isClass: !0,
  isNode: !0
}), ra = "FunctionNode", E9 = ["math", "Node", "SymbolNode"], A9 = /* @__PURE__ */ Q(ra, E9, (e) => {
  var r, {
    math: o,
    Node: n,
    SymbolNode: i
  } = e, t = (f) => Ze(f, {
    truncate: 78
  });
  function u(f, s, a) {
    for (var c = "", d = /\$(?:\{([a-z_][a-z_0-9]*)(?:\[([0-9]+)\])?\}|\$)/gi, h = 0, p; (p = d.exec(f)) !== null; )
      if (c += f.substring(h, p.index), h = p.index, p[0] === "$$")
        c += "$", h++;
      else {
        h += p[0].length;
        var v = s[p[1]];
        if (!v)
          throw new ReferenceError("Template: Property " + p[1] + " does not exist.");
        if (p[2] === void 0)
          switch (typeof v) {
            case "string":
              c += v;
              break;
            case "object":
              if (or(v))
                c += v.toTex(a);
              else if (Array.isArray(v))
                c += v.map(function(g, m) {
                  if (or(g))
                    return g.toTex(a);
                  throw new TypeError("Template: " + p[1] + "[" + m + "] is not a Node.");
                }).join(",");
              else
                throw new TypeError("Template: " + p[1] + " has to be a Node, String or array of Nodes");
              break;
            default:
              throw new TypeError("Template: " + p[1] + " has to be a Node, String or array of Nodes");
          }
        else if (or(v[p[2]] && v[p[2]]))
          c += v[p[2]].toTex(a);
        else
          throw new TypeError("Template: " + p[1] + "[" + p[2] + "] is not a Node.");
      }
    return c += f.slice(h), c;
  }
  class l extends n {
    /**
     * @constructor FunctionNode
     * @extends {./Node}
     * invoke a list with arguments on a node
     * @param {./Node | string} fn
     *     Item resolving to a function on which to invoke
     *     the arguments, typically a SymboNode or AccessorNode
     * @param {./Node[]} args
     */
    constructor(s, a) {
      if (super(), typeof s == "string" && (s = new i(s)), !or(s))
        throw new TypeError('Node expected as parameter "fn"');
      if (!Array.isArray(a) || !a.every(or))
        throw new TypeError('Array containing Nodes expected for parameter "args"');
      this.fn = s, this.args = a || [];
    }
    // readonly property name
    get name() {
      return this.fn.name || "";
    }
    get type() {
      return ra;
    }
    get isFunctionNode() {
      return !0;
    }
    /**
     * Compile a node into a JavaScript function.
     * This basically pre-calculates as much as possible and only leaves open
     * calculations which depend on a dynamic scope with variables.
     * @param {Object} math     Math.js namespace with functions and constants.
     * @param {Object} argNames An object with argument names as key and `true`
     *                          as value. Used in the SymbolNode to optimize
     *                          for arguments from user assigned functions
     *                          (see FunctionAssignmentNode) or special symbols
     *                          like `end` (see IndexNode).
     * @return {function} Returns a function which can be called like:
     *                        evalNode(scope: Object, args: Object, context: *)
     */
    _compile(s, a) {
      var c = this.args.map((O) => O._compile(s, a));
      if (Br(this.fn)) {
        var d = this.fn.name;
        if (a[d]) {
          var m = this.args;
          return function(B, $, F) {
            var w = Vr($, d);
            if (typeof w != "function")
              throw new TypeError("Argument '".concat(d, "' was not a function; received: ").concat(t(w)));
            if (w.rawArgs)
              return w(m, s, di(B, $));
            var A = c.map((b) => b(B, $, F));
            return w.apply(w, A);
          };
        } else {
          var h = d in s ? Vr(s, d) : void 0, p = typeof h == "function" && h.rawArgs === !0, v = (O) => {
            var B;
            if (O.has(d))
              B = O.get(d);
            else if (d in s)
              B = Vr(s, d);
            else
              return l.onUndefinedFunction(d);
            if (typeof B == "function")
              return B;
            throw new TypeError("'".concat(d, `' is not a function; its value is:
  `).concat(t(B)));
          };
          if (p) {
            var g = this.args;
            return function(B, $, F) {
              var w = v(B);
              return w(g, s, di(B, $));
            };
          } else
            switch (c.length) {
              case 0:
                return function(B, $, F) {
                  var w = v(B);
                  return w();
                };
              case 1:
                return function(B, $, F) {
                  var w = v(B), A = c[0];
                  return w(A(B, $, F));
                };
              case 2:
                return function(B, $, F) {
                  var w = v(B), A = c[0], b = c[1];
                  return w(A(B, $, F), b(B, $, F));
                };
              default:
                return function(B, $, F) {
                  var w = v(B), A = c.map((b) => b(B, $, F));
                  return w(...A);
                };
            }
        }
      } else if (nn(this.fn) && Sn(this.fn.index) && this.fn.index.isObjectProperty()) {
        var x = this.fn.object._compile(s, a), y = this.fn.index.getObjectProperty(), E = this.args;
        return function(B, $, F) {
          var w = x(B, $, F), A = O2(w, y);
          if (A != null && A.rawArgs)
            return A(E, s, di(B, $));
          var b = c.map((D) => D(B, $, F));
          return A.apply(w, b);
        };
      } else {
        var N = this.fn.toString(), S = this.fn._compile(s, a), R = this.args;
        return function(B, $, F) {
          var w = S(B, $, F);
          if (typeof w != "function")
            throw new TypeError("Expression '".concat(N, "' did not evaluate to a function; value is:") + `
  `.concat(t(w)));
          if (w.rawArgs)
            return w(R, s, di(B, $));
          var A = c.map((b) => b(B, $, F));
          return w.apply(w, A);
        };
      }
    }
    /**
     * Execute a callback for each of the child nodes of this node
     * @param {function(child: Node, path: string, parent: Node)} callback
     */
    forEach(s) {
      s(this.fn, "fn", this);
      for (var a = 0; a < this.args.length; a++)
        s(this.args[a], "args[" + a + "]", this);
    }
    /**
     * Create a new FunctionNode whose children are the results of calling
     * the provided callback function for each child of the original node.
     * @param {function(child: Node, path: string, parent: Node): Node} callback
     * @returns {FunctionNode} Returns a transformed copy of the node
     */
    map(s) {
      for (var a = this._ifNode(s(this.fn, "fn", this)), c = [], d = 0; d < this.args.length; d++)
        c[d] = this._ifNode(s(this.args[d], "args[" + d + "]", this));
      return new l(a, c);
    }
    /**
     * Create a clone of this node, a shallow copy
     * @return {FunctionNode}
     */
    clone() {
      return new l(this.fn, this.args.slice(0));
    }
    /**
     * Throws an error 'Undefined function {name}'
     * @param {string} name
     */
    /**
     * Get string representation. (wrapper function)
     * This overrides parts of Node's toString function.
     * If callback is an object containing callbacks, it
     * calls the correct callback for the current node,
     * otherwise it falls back to calling Node's toString
     * function.
     *
     * @param {Object} options
     * @return {string} str
     * @override
     */
    toString(s) {
      var a, c = this.fn.toString(s);
      return s && typeof s.handler == "object" && De(s.handler, c) && (a = s.handler[c](this, s)), typeof a < "u" ? a : super.toString(s);
    }
    /**
     * Get string representation
     * @param {Object} options
     * @return {string} str
     */
    _toString(s) {
      var a = this.args.map(function(d) {
        return d.toString(s);
      }), c = Yn(this.fn) ? "(" + this.fn.toString(s) + ")" : this.fn.toString(s);
      return c + "(" + a.join(", ") + ")";
    }
    /**
     * Get a JSON representation of the node
     * @returns {Object}
     */
    toJSON() {
      return {
        mathjs: ra,
        fn: this.fn,
        args: this.args
      };
    }
    /**
     * Instantiate an AssignmentNode from its JSON representation
     * @param {Object} json  An object structured like
     *                       `{"mathjs": "FunctionNode", fn: ..., args: ...}`,
     *                       where mathjs is optional
     * @returns {FunctionNode}
     */
    /**
     * Get HTML representation
     * @param {Object} options
     * @return {string} str
     */
    _toHTML(s) {
      var a = this.args.map(function(c) {
        return c.toHTML(s);
      });
      return '<span class="math-function">' + ct(this.fn) + '</span><span class="math-paranthesis math-round-parenthesis">(</span>' + a.join('<span class="math-separator">,</span>') + '<span class="math-paranthesis math-round-parenthesis">)</span>';
    }
    /**
     * Get LaTeX representation. (wrapper function)
     * This overrides parts of Node's toTex function.
     * If callback is an object containing callbacks, it
     * calls the correct callback for the current node,
     * otherwise it falls back to calling Node's toTex
     * function.
     *
     * @param {Object} options
     * @return {string}
     */
    toTex(s) {
      var a;
      return s && typeof s.handler == "object" && De(s.handler, this.name) && (a = s.handler[this.name](this, s)), typeof a < "u" ? a : super.toTex(s);
    }
    /**
     * Get LaTeX representation
     * @param {Object} options
     * @return {string} str
     */
    _toTex(s) {
      var a = this.args.map(function(h) {
        return h.toTex(s);
      }), c;
      Lh[this.name] && (c = Lh[this.name]), o[this.name] && (typeof o[this.name].toTex == "function" || typeof o[this.name].toTex == "object" || typeof o[this.name].toTex == "string") && (c = o[this.name].toTex);
      var d;
      switch (typeof c) {
        case "function":
          d = c(this, s);
          break;
        case "string":
          d = u(c, this, s);
          break;
        case "object":
          switch (typeof c[a.length]) {
            case "function":
              d = c[a.length](this, s);
              break;
            case "string":
              d = u(c[a.length], this, s);
              break;
          }
      }
      return typeof d < "u" ? d : u(t9, this, s);
    }
    /**
     * Get identifier.
     * @return {string}
     */
    getIdentifier() {
      return this.type + ":" + this.name;
    }
  }
  return r = l, Fr(l, "name", ra), Fr(l, "onUndefinedFunction", function(f) {
    throw new Error("Undefined function " + f);
  }), Fr(l, "fromJSON", function(f) {
    return new r(f.fn, f.args);
  }), l;
}, {
  isClass: !0,
  isNode: !0
}), kh = "parse", S9 = ["typed", "numeric", "config", "AccessorNode", "ArrayNode", "AssignmentNode", "BlockNode", "ConditionalNode", "ConstantNode", "FunctionAssignmentNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "RangeNode", "RelationalNode", "SymbolNode"], D9 = /* @__PURE__ */ Q(kh, S9, (e) => {
  var {
    typed: r,
    numeric: o,
    config: n,
    AccessorNode: i,
    ArrayNode: t,
    AssignmentNode: u,
    BlockNode: l,
    ConditionalNode: f,
    ConstantNode: s,
    FunctionAssignmentNode: a,
    FunctionNode: c,
    IndexNode: d,
    ObjectNode: h,
    OperatorNode: p,
    ParenthesisNode: v,
    RangeNode: g,
    RelationalNode: m,
    SymbolNode: x
  } = e, y = r(kh, {
    string: function(ae) {
      return z(ae, {});
    },
    "Array | Matrix": function(ae) {
      return E(ae, {});
    },
    "string, Object": function(ae, de) {
      var ye = de.nodes !== void 0 ? de.nodes : {};
      return z(ae, ye);
    },
    "Array | Matrix, Object": E
  });
  function E(H) {
    var ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, de = ae.nodes !== void 0 ? ae.nodes : {};
    return Ke(H, function(ye) {
      if (typeof ye != "string")
        throw new TypeError("String expected");
      return z(ye, de);
    });
  }
  var N = {
    NULL: 0,
    DELIMITER: 1,
    NUMBER: 2,
    SYMBOL: 3,
    UNKNOWN: 4
  }, S = {
    ",": !0,
    "(": !0,
    ")": !0,
    "[": !0,
    "]": !0,
    "{": !0,
    "}": !0,
    '"': !0,
    "'": !0,
    ";": !0,
    "+": !0,
    "-": !0,
    "*": !0,
    ".*": !0,
    "/": !0,
    "./": !0,
    "%": !0,
    "^": !0,
    ".^": !0,
    "~": !0,
    "!": !0,
    "&": !0,
    "|": !0,
    "^|": !0,
    "=": !0,
    ":": !0,
    "?": !0,
    "==": !0,
    "!=": !0,
    "<": !0,
    ">": !0,
    "<=": !0,
    ">=": !0,
    "<<": !0,
    ">>": !0,
    ">>>": !0
  }, R = {
    mod: !0,
    to: !0,
    in: !0,
    and: !0,
    xor: !0,
    or: !0,
    not: !0
  }, O = {
    true: !0,
    false: !1,
    null: null,
    undefined: void 0
  }, B = ["NaN", "Infinity"], $ = {
    '"': '"',
    "'": "'",
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
    // note that \u is handled separately in parseStringToken()
  };
  function F() {
    return {
      extraNodes: {},
      // current extra nodes, must be careful not to mutate
      expression: "",
      // current expression
      comment: "",
      // last parsed comment
      index: 0,
      // current index in expr
      token: "",
      // current token
      tokenType: N.NULL,
      // type of the token
      nestingLevel: 0,
      // level of nesting inside parameters, used to ignore newline characters
      conditionalLevel: null
      // when a conditional is being parsed, the level of the conditional is stored here
    };
  }
  function w(H, ae) {
    return H.expression.substr(H.index, ae);
  }
  function A(H) {
    return w(H, 1);
  }
  function b(H) {
    H.index++;
  }
  function D(H) {
    return H.expression.charAt(H.index - 1);
  }
  function M(H) {
    return H.expression.charAt(H.index + 1);
  }
  function _(H) {
    for (H.tokenType = N.NULL, H.token = "", H.comment = ""; ; ) {
      if (A(H) === "#")
        for (; A(H) !== `
` && A(H) !== ""; )
          H.comment += A(H), b(H);
      if (y.isWhitespace(A(H), H.nestingLevel))
        b(H);
      else
        break;
    }
    if (A(H) === "") {
      H.tokenType = N.DELIMITER;
      return;
    }
    if (A(H) === `
` && !H.nestingLevel) {
      H.tokenType = N.DELIMITER, H.token = A(H), b(H);
      return;
    }
    var ae = A(H), de = w(H, 2), ye = w(H, 3);
    if (ye.length === 3 && S[ye]) {
      H.tokenType = N.DELIMITER, H.token = ye, b(H), b(H), b(H);
      return;
    }
    if (de.length === 2 && S[de]) {
      H.tokenType = N.DELIMITER, H.token = de, b(H), b(H);
      return;
    }
    if (S[ae]) {
      H.tokenType = N.DELIMITER, H.token = ae, b(H);
      return;
    }
    if (y.isDigitDot(ae)) {
      H.tokenType = N.NUMBER;
      var Ne = w(H, 2);
      if (Ne === "0b" || Ne === "0o" || Ne === "0x") {
        for (H.token += A(H), b(H), H.token += A(H), b(H); y.isHexDigit(A(H)); )
          H.token += A(H), b(H);
        if (A(H) === ".")
          for (H.token += ".", b(H); y.isHexDigit(A(H)); )
            H.token += A(H), b(H);
        else if (A(H) === "i")
          for (H.token += "i", b(H); y.isDigit(A(H)); )
            H.token += A(H), b(H);
        return;
      }
      if (A(H) === ".") {
        if (H.token += A(H), b(H), !y.isDigit(A(H))) {
          H.tokenType = N.DELIMITER;
          return;
        }
      } else {
        for (; y.isDigit(A(H)); )
          H.token += A(H), b(H);
        y.isDecimalMark(A(H), M(H)) && (H.token += A(H), b(H));
      }
      for (; y.isDigit(A(H)); )
        H.token += A(H), b(H);
      if (A(H) === "E" || A(H) === "e") {
        if (y.isDigit(M(H)) || M(H) === "-" || M(H) === "+") {
          if (H.token += A(H), b(H), (A(H) === "+" || A(H) === "-") && (H.token += A(H), b(H)), !y.isDigit(A(H)))
            throw Se(H, 'Digit expected, got "' + A(H) + '"');
          for (; y.isDigit(A(H)); )
            H.token += A(H), b(H);
          if (y.isDecimalMark(A(H), M(H)))
            throw Se(H, 'Digit expected, got "' + A(H) + '"');
        } else if (M(H) === ".")
          throw b(H), Se(H, 'Digit expected, got "' + A(H) + '"');
      }
      return;
    }
    if (y.isAlpha(A(H), D(H), M(H))) {
      for (; y.isAlpha(A(H), D(H), M(H)) || y.isDigit(A(H)); )
        H.token += A(H), b(H);
      De(R, H.token) ? H.tokenType = N.DELIMITER : H.tokenType = N.SYMBOL;
      return;
    }
    for (H.tokenType = N.UNKNOWN; A(H) !== ""; )
      H.token += A(H), b(H);
    throw Se(H, 'Syntax error in part "' + H.token + '"');
  }
  function q(H) {
    do
      _(H);
    while (H.token === `
`);
  }
  function C(H) {
    H.nestingLevel++;
  }
  function T(H) {
    H.nestingLevel--;
  }
  y.isAlpha = function(ae, de, ye) {
    return y.isValidLatinOrGreek(ae) || y.isValidMathSymbol(ae, ye) || y.isValidMathSymbol(de, ae);
  }, y.isValidLatinOrGreek = function(ae) {
    return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(ae);
  }, y.isValidMathSymbol = function(ae, de) {
    return /^[\uD835]$/.test(ae) && /^[\uDC00-\uDFFF]$/.test(de) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(de);
  }, y.isWhitespace = function(ae, de) {
    return ae === " " || ae === "	" || ae === `
` && de > 0;
  }, y.isDecimalMark = function(ae, de) {
    return ae === "." && de !== "/" && de !== "*" && de !== "^";
  }, y.isDigitDot = function(ae) {
    return ae >= "0" && ae <= "9" || ae === ".";
  }, y.isDigit = function(ae) {
    return ae >= "0" && ae <= "9";
  }, y.isHexDigit = function(ae) {
    return ae >= "0" && ae <= "9" || ae >= "a" && ae <= "f" || ae >= "A" && ae <= "F";
  };
  function z(H, ae) {
    var de = F();
    kr(de, {
      expression: H,
      extraNodes: ae
    }), _(de);
    var ye = I(de);
    if (de.token !== "")
      throw de.tokenType === N.DELIMITER ? Me(de, "Unexpected operator " + de.token) : Se(de, 'Unexpected part "' + de.token + '"');
    return ye;
  }
  function I(H) {
    var ae, de = [], ye;
    for (H.token !== "" && H.token !== `
` && H.token !== ";" && (ae = U(H), H.comment && (ae.comment = H.comment)); H.token === `
` || H.token === ";"; )
      de.length === 0 && ae && (ye = H.token !== ";", de.push({
        node: ae,
        visible: ye
      })), _(H), H.token !== `
` && H.token !== ";" && H.token !== "" && (ae = U(H), H.comment && (ae.comment = H.comment), ye = H.token !== ";", de.push({
        node: ae,
        visible: ye
      }));
    return de.length > 0 ? new l(de) : (ae || (ae = new s(void 0), H.comment && (ae.comment = H.comment)), ae);
  }
  function U(H) {
    var ae, de, ye, Ne, Ee = ee(H);
    if (H.token === "=") {
      if (Br(Ee))
        return ae = Ee.name, q(H), ye = U(H), new u(new x(ae), ye);
      if (nn(Ee))
        return q(H), ye = U(H), new u(Ee.object, Ee.index, ye);
      if (Gt(Ee) && Br(Ee.fn) && (Ne = !0, de = [], ae = Ee.name, Ee.args.forEach(function(Qe, dr) {
        Br(Qe) ? de[dr] = Qe.name : Ne = !1;
      }), Ne))
        return q(H), ye = U(H), new a(ae, de, ye);
      throw Se(H, "Invalid left hand side of assignment operator =");
    }
    return Ee;
  }
  function ee(H) {
    for (var ae = se(H); H.token === "?"; ) {
      var de = H.conditionalLevel;
      H.conditionalLevel = H.nestingLevel, q(H);
      var ye = ae, Ne = U(H);
      if (H.token !== ":")
        throw Se(H, "False part of conditional expression expected");
      H.conditionalLevel = null, q(H);
      var Ee = U(H);
      ae = new f(ye, Ne, Ee), H.conditionalLevel = de;
    }
    return ae;
  }
  function se(H) {
    for (var ae = K(H); H.token === "or"; )
      q(H), ae = new p("or", "or", [ae, K(H)]);
    return ae;
  }
  function K(H) {
    for (var ae = J(H); H.token === "xor"; )
      q(H), ae = new p("xor", "xor", [ae, J(H)]);
    return ae;
  }
  function J(H) {
    for (var ae = te(H); H.token === "and"; )
      q(H), ae = new p("and", "and", [ae, te(H)]);
    return ae;
  }
  function te(H) {
    for (var ae = ne(H); H.token === "|"; )
      q(H), ae = new p("|", "bitOr", [ae, ne(H)]);
    return ae;
  }
  function ne(H) {
    for (var ae = ue(H); H.token === "^|"; )
      q(H), ae = new p("^|", "bitXor", [ae, ue(H)]);
    return ae;
  }
  function ue(H) {
    for (var ae = V(H); H.token === "&"; )
      q(H), ae = new p("&", "bitAnd", [ae, V(H)]);
    return ae;
  }
  function V(H) {
    for (var ae = [W(H)], de = [], ye = {
      "==": "equal",
      "!=": "unequal",
      "<": "smaller",
      ">": "larger",
      "<=": "smallerEq",
      ">=": "largerEq"
    }; De(ye, H.token); ) {
      var Ne = {
        name: H.token,
        fn: ye[H.token]
      };
      de.push(Ne), q(H), ae.push(W(H));
    }
    return ae.length === 1 ? ae[0] : ae.length === 2 ? new p(de[0].name, de[0].fn, ae) : new m(de.map((Ee) => Ee.fn), ae);
  }
  function W(H) {
    var ae, de, ye, Ne;
    ae = fe(H);
    for (var Ee = {
      "<<": "leftShift",
      ">>": "rightArithShift",
      ">>>": "rightLogShift"
    }; De(Ee, H.token); )
      de = H.token, ye = Ee[de], q(H), Ne = [ae, fe(H)], ae = new p(de, ye, Ne);
    return ae;
  }
  function fe(H) {
    var ae, de, ye, Ne;
    ae = pe(H);
    for (var Ee = {
      to: "to",
      in: "to"
      // alias of 'to'
    }; De(Ee, H.token); )
      de = H.token, ye = Ee[de], q(H), de === "in" && H.token === "" ? ae = new p("*", "multiply", [ae, new x("in")], !0) : (Ne = [ae, pe(H)], ae = new p(de, ye, Ne));
    return ae;
  }
  function pe(H) {
    var ae, de = [];
    if (H.token === ":" ? ae = new s(1) : ae = Y(H), H.token === ":" && H.conditionalLevel !== H.nestingLevel) {
      for (de.push(ae); H.token === ":" && de.length < 3; )
        q(H), H.token === ")" || H.token === "]" || H.token === "," || H.token === "" ? de.push(new x("end")) : de.push(Y(H));
      de.length === 3 ? ae = new g(de[0], de[2], de[1]) : ae = new g(de[0], de[1]);
    }
    return ae;
  }
  function Y(H) {
    var ae, de, ye, Ne;
    ae = k(H);
    for (var Ee = {
      "+": "add",
      "-": "subtract"
    }; De(Ee, H.token); ) {
      de = H.token, ye = Ee[de], q(H);
      var Qe = k(H);
      Qe.isPercentage ? Ne = [ae, new p("*", "multiply", [ae, Qe])] : Ne = [ae, Qe], ae = new p(de, ye, Ne);
    }
    return ae;
  }
  function k(H) {
    var ae, de, ye, Ne;
    ae = L(H), de = ae;
    for (var Ee = {
      "*": "multiply",
      ".*": "dotMultiply",
      "/": "divide",
      "./": "dotDivide"
    }; De(Ee, H.token); )
      ye = H.token, Ne = Ee[ye], q(H), de = L(H), ae = new p(ye, Ne, [ae, de]);
    return ae;
  }
  function L(H) {
    var ae, de;
    for (ae = P(H), de = ae; H.tokenType === N.SYMBOL || H.token === "in" && rr(ae) || H.tokenType === N.NUMBER && !rr(de) && (!Cr(de) || de.op === "!") || H.token === "("; )
      de = P(H), ae = new p(
        "*",
        "multiply",
        [ae, de],
        !0
        /* implicit */
      );
    return ae;
  }
  function P(H) {
    for (var ae = G(H), de = ae, ye = []; H.token === "/" && Ou(de); )
      if (ye.push(kr({}, H)), q(H), H.tokenType === N.NUMBER)
        if (ye.push(kr({}, H)), q(H), H.tokenType === N.SYMBOL || H.token === "(")
          kr(H, ye.pop()), ye.pop(), de = G(H), ae = new p("/", "divide", [ae, de]);
        else {
          ye.pop(), kr(H, ye.pop());
          break;
        }
      else {
        kr(H, ye.pop());
        break;
      }
    return ae;
  }
  function G(H) {
    var ae, de, ye, Ne;
    ae = j(H);
    for (var Ee = {
      "%": "mod",
      mod: "mod"
    }; De(Ee, H.token); )
      de = H.token, ye = Ee[de], q(H), de === "%" && H.tokenType === N.DELIMITER && H.token !== "(" ? ae = new p("/", "divide", [ae, new s(100)], !1, !0) : (Ne = [ae, j(H)], ae = new p(de, ye, Ne));
    return ae;
  }
  function j(H) {
    var ae, de, ye, Ne = {
      "-": "unaryMinus",
      "+": "unaryPlus",
      "~": "bitNot",
      not: "not"
    };
    return De(Ne, H.token) ? (ye = Ne[H.token], ae = H.token, q(H), de = [j(H)], new p(ae, ye, de)) : re(H);
  }
  function re(H) {
    var ae, de, ye, Ne;
    return ae = ie(H), (H.token === "^" || H.token === ".^") && (de = H.token, ye = de === "^" ? "pow" : "dotPow", q(H), Ne = [ae, j(H)], ae = new p(de, ye, Ne)), ae;
  }
  function ie(H) {
    var ae, de, ye, Ne;
    ae = Z(H);
    for (var Ee = {
      "!": "factorial",
      "'": "ctranspose"
    }; De(Ee, H.token); )
      de = H.token, ye = Ee[de], _(H), Ne = [ae], ae = new p(de, ye, Ne), ae = oe(H, ae);
    return ae;
  }
  function Z(H) {
    var ae = [];
    if (H.tokenType === N.SYMBOL && De(H.extraNodes, H.token)) {
      var de = H.extraNodes[H.token];
      if (_(H), H.token === "(") {
        if (ae = [], C(H), _(H), H.token !== ")")
          for (ae.push(U(H)); H.token === ","; )
            _(H), ae.push(U(H));
        if (H.token !== ")")
          throw Se(H, "Parenthesis ) expected");
        T(H), _(H);
      }
      return new de(ae);
    }
    return X(H);
  }
  function X(H) {
    var ae, de;
    return H.tokenType === N.SYMBOL || H.tokenType === N.DELIMITER && H.token in R ? (de = H.token, _(H), De(O, de) ? ae = new s(O[de]) : B.includes(de) ? ae = new s(o(de, "number")) : ae = new x(de), ae = oe(H, ae), ae) : ce(H);
  }
  function oe(H, ae, de) {
    for (var ye; (H.token === "(" || H.token === "[" || H.token === ".") && (!de || de.includes(H.token)); )
      if (ye = [], H.token === "(")
        if (Br(ae) || nn(ae)) {
          if (C(H), _(H), H.token !== ")")
            for (ye.push(U(H)); H.token === ","; )
              _(H), ye.push(U(H));
          if (H.token !== ")")
            throw Se(H, "Parenthesis ) expected");
          T(H), _(H), ae = new c(ae, ye);
        } else
          return ae;
      else if (H.token === "[") {
        if (C(H), _(H), H.token !== "]")
          for (ye.push(U(H)); H.token === ","; )
            _(H), ye.push(U(H));
        if (H.token !== "]")
          throw Se(H, "Parenthesis ] expected");
        T(H), _(H), ae = new i(ae, new d(ye));
      } else {
        _(H);
        var Ne = H.tokenType === N.SYMBOL || H.tokenType === N.DELIMITER && H.token in R;
        if (!Ne)
          throw Se(H, "Property name expected after dot");
        ye.push(new s(H.token)), _(H);
        var Ee = !0;
        ae = new i(ae, new d(ye, Ee));
      }
    return ae;
  }
  function ce(H) {
    var ae, de;
    return H.token === '"' || H.token === "'" ? (de = le(H, H.token), ae = new s(de), ae = oe(H, ae), ae) : ve(H);
  }
  function le(H, ae) {
    for (var de = ""; A(H) !== "" && A(H) !== ae; )
      if (A(H) === "\\") {
        b(H);
        var ye = A(H), Ne = $[ye];
        if (Ne !== void 0)
          de += Ne, H.index += 1;
        else if (ye === "u") {
          var Ee = H.expression.slice(H.index + 1, H.index + 5);
          if (/^[0-9A-Fa-f]{4}$/.test(Ee))
            de += String.fromCharCode(parseInt(Ee, 16)), H.index += 5;
          else
            throw Se(H, "Invalid unicode character \\u".concat(Ee));
        } else
          throw Se(H, "Bad escape character \\".concat(ye));
      } else
        de += A(H), b(H);
    if (_(H), H.token !== ae)
      throw Se(H, "End of string ".concat(ae, " expected"));
    return _(H), de;
  }
  function ve(H) {
    var ae, de, ye, Ne;
    if (H.token === "[") {
      if (C(H), _(H), H.token !== "]") {
        var Ee = ge(H);
        if (H.token === ";") {
          for (ye = 1, de = [Ee]; H.token === ";"; )
            _(H), H.token !== "]" && (de[ye] = ge(H), ye++);
          if (H.token !== "]")
            throw Se(H, "End of matrix ] expected");
          T(H), _(H), Ne = de[0].items.length;
          for (var Qe = 1; Qe < ye; Qe++)
            if (de[Qe].items.length !== Ne)
              throw Me(H, "Column dimensions mismatch (" + de[Qe].items.length + " !== " + Ne + ")");
          ae = new t(de);
        } else {
          if (H.token !== "]")
            throw Se(H, "End of matrix ] expected");
          T(H), _(H), ae = Ee;
        }
      } else
        T(H), _(H), ae = new t([]);
      return oe(H, ae);
    }
    return me(H);
  }
  function ge(H) {
    for (var ae = [U(H)], de = 1; H.token === ","; )
      _(H), H.token !== "]" && H.token !== ";" && (ae[de] = U(H), de++);
    return new t(ae);
  }
  function me(H) {
    if (H.token === "{") {
      C(H);
      var ae, de = {};
      do
        if (_(H), H.token !== "}") {
          if (H.token === '"' || H.token === "'")
            ae = le(H, H.token);
          else if (H.tokenType === N.SYMBOL || H.tokenType === N.DELIMITER && H.token in R)
            ae = H.token, _(H);
          else
            throw Se(H, "Symbol or string expected as object key");
          if (H.token !== ":")
            throw Se(H, "Colon : expected after object key");
          _(H), de[ae] = U(H);
        }
      while (H.token === ",");
      if (H.token !== "}")
        throw Se(H, "Comma , or bracket } expected after object value");
      T(H), _(H);
      var ye = new h(de);
      return ye = oe(H, ye), ye;
    }
    return we(H);
  }
  function we(H) {
    var ae;
    if (H.tokenType === N.NUMBER) {
      ae = H.token, _(H);
      var de = sn(ae, n), ye = o(ae, de);
      return new s(ye);
    }
    return be(H);
  }
  function be(H) {
    var ae;
    if (H.token === "(") {
      if (C(H), _(H), ae = U(H), H.token !== ")")
        throw Se(H, "Parenthesis ) expected");
      return T(H), _(H), ae = new v(ae), ae = oe(H, ae), ae;
    }
    return Ae(H);
  }
  function Ae(H) {
    throw H.token === "" ? Se(H, "Unexpected end of expression") : Se(H, "Value expected");
  }
  function _e(H) {
    return H.index - H.token.length + 1;
  }
  function Se(H, ae) {
    var de = _e(H), ye = new SyntaxError(ae + " (char " + de + ")");
    return ye.char = de, ye;
  }
  function Me(H, ae) {
    var de = _e(H), ye = new SyntaxError(ae + " (char " + de + ")");
    return ye.char = de, ye;
  }
  return r.addConversion({
    from: "string",
    to: "Node",
    convert: y
  }), y;
}), Hh = "compile", N9 = ["typed", "parse"], M9 = /* @__PURE__ */ Q(Hh, N9, (e) => {
  var {
    typed: r,
    parse: o
  } = e;
  return r(Hh, {
    string: function(i) {
      return o(i).compile();
    },
    "Array | Matrix": function(i) {
      return Ke(i, function(t) {
        return o(t).compile();
      });
    }
  });
}), Gh = "evaluate", _9 = ["typed", "parse"], C9 = /* @__PURE__ */ Q(Gh, _9, (e) => {
  var {
    typed: r,
    parse: o
  } = e;
  return r(Gh, {
    string: function(i) {
      var t = bi();
      return o(i).compile().evaluate(t);
    },
    "string, Map | Object": function(i, t) {
      return o(i).compile().evaluate(t);
    },
    "Array | Matrix": function(i) {
      var t = bi();
      return Ke(i, function(u) {
        return o(u).compile().evaluate(t);
      });
    },
    "Array | Matrix, Map | Object": function(i, t) {
      return Ke(i, function(u) {
        return o(u).compile().evaluate(t);
      });
    }
  });
}), T9 = "Parser", B9 = ["evaluate"], F9 = /* @__PURE__ */ Q(T9, B9, (e) => {
  var {
    evaluate: r
  } = e;
  function o() {
    if (!(this instanceof o))
      throw new SyntaxError("Constructor must be called with the new operator");
    Object.defineProperty(this, "scope", {
      value: bi(),
      writable: !1
    });
  }
  return o.prototype.type = "Parser", o.prototype.isParser = !0, o.prototype.evaluate = function(n) {
    return r(n, this.scope);
  }, o.prototype.get = function(n) {
    if (this.scope.has(n))
      return this.scope.get(n);
  }, o.prototype.getAll = function() {
    return q2(this.scope);
  }, o.prototype.getAllAsMap = function() {
    return this.scope;
  }, o.prototype.set = function(n, i) {
    return this.scope.set(n, i), i;
  }, o.prototype.remove = function(n) {
    this.scope.delete(n);
  }, o.prototype.clear = function() {
    this.scope.clear();
  }, o;
}, {
  isClass: !0
}), Vh = "parser", I9 = ["typed", "Parser"], O9 = /* @__PURE__ */ Q(Vh, I9, (e) => {
  var {
    typed: r,
    Parser: o
  } = e;
  return r(Vh, {
    "": function() {
      return new o();
    }
  });
}), Wh = "lup", R9 = ["typed", "matrix", "abs", "addScalar", "divideScalar", "multiplyScalar", "subtractScalar", "larger", "equalScalar", "unaryMinus", "DenseMatrix", "SparseMatrix", "Spa"], P9 = /* @__PURE__ */ Q(Wh, R9, (e) => {
  var {
    typed: r,
    matrix: o,
    abs: n,
    addScalar: i,
    divideScalar: t,
    multiplyScalar: u,
    subtractScalar: l,
    larger: f,
    equalScalar: s,
    unaryMinus: a,
    DenseMatrix: c,
    SparseMatrix: d,
    Spa: h
  } = e;
  return r(Wh, {
    DenseMatrix: function(m) {
      return p(m);
    },
    SparseMatrix: function(m) {
      return v(m);
    },
    Array: function(m) {
      var x = o(m), y = p(x);
      return {
        L: y.L.valueOf(),
        U: y.U.valueOf(),
        p: y.p
      };
    }
  });
  function p(g) {
    var m = g._size[0], x = g._size[1], y = Math.min(m, x), E = Ie(g._data), N = [], S = [m, y], R = [], O = [y, x], B, $, F, w = [];
    for (B = 0; B < m; B++)
      w[B] = B;
    for ($ = 0; $ < x; $++) {
      if ($ > 0)
        for (B = 0; B < m; B++) {
          var A = Math.min(B, $), b = 0;
          for (F = 0; F < A; F++)
            b = i(b, u(E[B][F], E[F][$]));
          E[B][$] = l(E[B][$], b);
        }
      var D = $, M = 0, _ = 0;
      for (B = $; B < m; B++) {
        var q = E[B][$], C = n(q);
        f(C, M) && (D = B, M = C, _ = q);
      }
      if ($ !== D && (w[$] = [w[D], w[D] = w[$]][0], c._swapRows($, D, E)), $ < m)
        for (B = $ + 1; B < m; B++) {
          var T = E[B][$];
          s(T, 0) || (E[B][$] = t(E[B][$], _));
        }
    }
    for ($ = 0; $ < x; $++)
      for (B = 0; B < m; B++) {
        if ($ === 0 && (B < x && (R[B] = []), N[B] = []), B < $) {
          B < x && (R[B][$] = E[B][$]), $ < m && (N[B][$] = 0);
          continue;
        }
        if (B === $) {
          B < x && (R[B][$] = E[B][$]), $ < m && (N[B][$] = 1);
          continue;
        }
        B < x && (R[B][$] = 0), $ < m && (N[B][$] = E[B][$]);
      }
    var z = new c({
      data: N,
      size: S
    }), I = new c({
      data: R,
      size: O
    }), U = [];
    for (B = 0, y = w.length; B < y; B++)
      U[w[B]] = B;
    return {
      L: z,
      U: I,
      p: U,
      toString: function() {
        return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
      }
    };
  }
  function v(g) {
    var m = g._size[0], x = g._size[1], y = Math.min(m, x), E = g._values, N = g._index, S = g._ptr, R = [], O = [], B = [], $ = [m, y], F = [], w = [], A = [], b = [y, x], D, M, _, q = [], C = [];
    for (D = 0; D < m; D++)
      q[D] = D, C[D] = D;
    var T = function(U, ee) {
      var se = C[U], K = C[ee];
      q[se] = ee, q[K] = U, C[U] = K, C[ee] = se;
    }, z = function() {
      var U = new h();
      M < m && (B.push(R.length), R.push(1), O.push(M)), A.push(F.length);
      var ee = S[M], se = S[M + 1];
      for (_ = ee; _ < se; _++)
        D = N[_], U.set(q[D], E[_]);
      M > 0 && U.forEach(0, M - 1, function(ne, ue) {
        d._forEachRow(ne, R, O, B, function(V, W) {
          V > ne && U.accumulate(V, a(u(W, ue)));
        });
      });
      var K = M, J = U.get(M), te = n(J);
      U.forEach(M + 1, m - 1, function(ne, ue) {
        var V = n(ue);
        f(V, te) && (K = ne, te = V, J = ue);
      }), M !== K && (d._swapRows(M, K, $[1], R, O, B), d._swapRows(M, K, b[1], F, w, A), U.swap(M, K), T(M, K)), U.forEach(0, m - 1, function(ne, ue) {
        ne <= M ? (F.push(ue), w.push(ne)) : (ue = t(ue, J), s(ue, 0) || (R.push(ue), O.push(ne)));
      });
    };
    for (M = 0; M < x; M++)
      z();
    return A.push(F.length), B.push(R.length), {
      L: new d({
        values: R,
        index: O,
        ptr: B,
        size: $
      }),
      U: new d({
        values: F,
        index: w,
        ptr: A,
        size: b
      }),
      p: q,
      toString: function() {
        return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
      }
    };
  }
}), Kh = "qr", q9 = ["typed", "matrix", "zeros", "identity", "isZero", "equal", "sign", "sqrt", "conj", "unaryMinus", "addScalar", "divideScalar", "multiplyScalar", "subtractScalar", "complex"], $9 = /* @__PURE__ */ Q(Kh, q9, (e) => {
  var {
    typed: r,
    matrix: o,
    zeros: n,
    identity: i,
    isZero: t,
    equal: u,
    sign: l,
    sqrt: f,
    conj: s,
    unaryMinus: a,
    addScalar: c,
    divideScalar: d,
    multiplyScalar: h,
    subtractScalar: p,
    complex: v
  } = e;
  return kr(r(Kh, {
    DenseMatrix: function(E) {
      return m(E);
    },
    SparseMatrix: function(E) {
      return x();
    },
    Array: function(E) {
      var N = o(E), S = m(N);
      return {
        Q: S.Q.valueOf(),
        R: S.R.valueOf()
      };
    }
  }), {
    _denseQRimpl: g
  });
  function g(y) {
    var E = y._size[0], N = y._size[1], S = i([E], "dense"), R = S._data, O = y.clone(), B = O._data, $, F, w, A = n([E], "");
    for (w = 0; w < Math.min(N, E); ++w) {
      var b = B[w][w], D = a(u(b, 0) ? 1 : l(b)), M = s(D), _ = 0;
      for ($ = w; $ < E; $++)
        _ = c(_, h(B[$][w], s(B[$][w])));
      var q = h(D, f(_));
      if (!t(q)) {
        var C = p(b, q);
        for (A[w] = 1, $ = w + 1; $ < E; $++)
          A[$] = d(B[$][w], C);
        var T = a(s(d(C, q))), z = void 0;
        for (F = w; F < N; F++) {
          for (z = 0, $ = w; $ < E; $++)
            z = c(z, h(s(A[$]), B[$][F]));
          for (z = h(z, T), $ = w; $ < E; $++)
            B[$][F] = h(p(B[$][F], h(A[$], z)), M);
        }
        for ($ = 0; $ < E; $++) {
          for (z = 0, F = w; F < E; F++)
            z = c(z, h(R[$][F], A[F]));
          for (z = h(z, T), F = w; F < E; ++F)
            R[$][F] = d(p(R[$][F], h(z, s(A[F]))), M);
        }
      }
    }
    return {
      Q: S,
      R: O,
      toString: function() {
        return "Q: " + this.Q.toString() + `
R: ` + this.R.toString();
      }
    };
  }
  function m(y) {
    var E = g(y), N = E.R._data;
    if (y._data.length > 0)
      for (var S = N[0][0].type === "Complex" ? v(0) : 0, R = 0; R < N.length; ++R)
        for (var O = 0; O < R && O < (N[0] || []).length; ++O)
          N[R][O] = S;
    return E;
  }
  function x(y) {
    throw new Error("qr not implemented for sparse matrices yet");
  }
});
function z9(e, r, o, n) {
  for (var i = e._values, t = e._index, u = e._ptr, l = e._size, f = e._datatype, s = l[0], a = l[1], c = n && e._values ? [] : null, d = [], h = [], p = 0, v = 0; v < a; v++) {
    h[v] = p;
    for (var g = o ? o[v] : v, m = u[g], x = u[g + 1], y = m; y < x; y++) {
      var E = r ? r[t[y]] : t[y];
      d[p] = E, c && (c[p] = i[y]), p++;
    }
  }
  return h[a] = p, e.createSparseMatrix({
    values: c,
    index: d,
    ptr: h,
    size: [s, a],
    datatype: f
  });
}
function fb(e, r, o, n, i, t, u) {
  var l = 0;
  for (o[u] = e; l >= 0; ) {
    var f = o[u + l], s = o[n + f];
    s === -1 ? (l--, t[r++] = f) : (o[n + f] = o[i + s], ++l, o[u + l] = s);
  }
  return r;
}
function L9(e, r) {
  if (!e)
    return null;
  var o = 0, n, i = [], t = [], u = 0, l = r, f = 2 * r;
  for (n = 0; n < r; n++)
    t[u + n] = -1;
  for (n = r - 1; n >= 0; n--)
    e[n] !== -1 && (t[l + n] = t[u + e[n]], t[u + e[n]] = n);
  for (n = 0; n < r; n++)
    e[n] === -1 && (o = fb(n, o, t, u, l, i, f));
  return i;
}
function U9(e, r) {
  if (!e)
    return null;
  var o = e._index, n = e._ptr, i = e._size, t = i[0], u = i[1], l = [], f = [], s = 0, a = u, c, d;
  if (r)
    for (c = 0; c < t; c++)
      f[a + c] = -1;
  for (var h = 0; h < u; h++) {
    l[h] = -1, f[s + h] = -1;
    for (var p = n[h], v = n[h + 1], g = p; g < v; g++) {
      var m = o[g];
      for (c = r ? f[a + m] : m; c !== -1 && c < h; c = d)
        d = f[s + c], f[s + c] = h, d === -1 && (l[c] = h);
      r && (f[a + m] = h);
    }
  }
  return l;
}
function k9(e, r, o) {
  for (var n = e._values, i = e._index, t = e._ptr, u = e._size, l = u[1], f = 0, s = 0; s < l; s++) {
    var a = t[s];
    for (t[s] = f; a < t[s + 1]; a++)
      r(i[a], s, n ? n[a] : 1, o) && (i[f] = i[a], n && (n[f] = n[a]), f++);
  }
  return t[l] = f, i.splice(f, i.length - f), n && n.splice(f, n.length - f), f;
}
function Jt(e) {
  return -e - 2;
}
var H9 = "csAmd", G9 = ["add", "multiply", "transpose"], V9 = /* @__PURE__ */ Q(H9, G9, (e) => {
  var {
    add: r,
    multiply: o,
    transpose: n
  } = e;
  return function(a, c) {
    if (!c || a <= 0 || a > 3)
      return null;
    var d = c._size, h = d[0], p = d[1], v = 0, g = Math.max(16, 10 * Math.sqrt(p));
    g = Math.min(p - 2, g);
    var m = i(a, c, h, p, g);
    k9(m, f, null);
    for (var x = m._index, y = m._ptr, E = y[p], N = [], S = [], R = 0, O = p + 1, B = 2 * (p + 1), $ = 3 * (p + 1), F = 4 * (p + 1), w = 5 * (p + 1), A = 6 * (p + 1), b = 7 * (p + 1), D = N, M = t(p, y, S, R, $, D, B, b, O, A, F, w), _ = u(p, y, S, w, F, A, g, O, $, D, B), q = 0, C, T, z, I, U, ee, se, K, J, te, ne, ue, V, W, fe, pe; _ < p; ) {
      for (z = -1; q < p && (z = S[$ + q]) === -1; q++)
        ;
      S[B + z] !== -1 && (D[S[B + z]] = -1), S[$ + q] = S[B + z];
      var Y = S[F + z], k = S[O + z];
      _ += k;
      var L = 0;
      S[O + z] = -k;
      var P = y[z], G = Y === 0 ? P : E, j = G;
      for (I = 1; I <= Y + 1; I++) {
        for (I > Y ? (ee = z, se = P, K = S[R + z] - Y) : (ee = x[P++], se = y[ee], K = S[R + ee]), U = 1; U <= K; U++)
          C = x[se++], !((J = S[O + C]) <= 0) && (L += J, S[O + C] = -J, x[j++] = C, S[B + C] !== -1 && (D[S[B + C]] = D[C]), D[C] !== -1 ? S[B + D[C]] = S[B + C] : S[$ + S[w + C]] = S[B + C]);
        ee !== z && (y[ee] = Jt(z), S[A + ee] = 0);
      }
      for (Y !== 0 && (E = j), S[w + z] = L, y[z] = G, S[R + z] = j - G, S[F + z] = -2, M = l(M, v, S, A, p), te = G; te < j; te++)
        if (C = x[te], !((ne = S[F + C]) <= 0)) {
          J = -S[O + C];
          var re = M - J;
          for (P = y[C], ue = y[C] + ne - 1; P <= ue; P++)
            ee = x[P], S[A + ee] >= M ? S[A + ee] -= J : S[A + ee] !== 0 && (S[A + ee] = S[w + ee] + re);
        }
      for (te = G; te < j; te++) {
        for (C = x[te], ue = y[C], V = ue + S[F + C] - 1, W = ue, fe = 0, pe = 0, P = ue; P <= V; P++)
          if (ee = x[P], S[A + ee] !== 0) {
            var ie = S[A + ee] - M;
            ie > 0 ? (pe += ie, x[W++] = ee, fe += ee) : (y[ee] = Jt(z), S[A + ee] = 0);
          }
        S[F + C] = W - ue + 1;
        var Z = W, X = ue + S[R + C];
        for (P = V + 1; P < X; P++) {
          T = x[P];
          var oe = S[O + T];
          oe <= 0 || (pe += oe, x[W++] = T, fe += T);
        }
        pe === 0 ? (y[C] = Jt(z), J = -S[O + C], L -= J, k += J, _ += J, S[O + C] = 0, S[F + C] = -1) : (S[w + C] = Math.min(S[w + C], pe), x[W] = x[Z], x[Z] = x[ue], x[ue] = z, S[R + C] = W - ue + 1, fe = (fe < 0 ? -fe : fe) % p, S[B + C] = S[b + fe], S[b + fe] = C, D[C] = fe);
      }
      for (S[w + z] = L, v = Math.max(v, L), M = l(M + v, v, S, A, p), te = G; te < j; te++)
        if (C = x[te], !(S[O + C] >= 0))
          for (fe = D[C], C = S[b + fe], S[b + fe] = -1; C !== -1 && S[B + C] !== -1; C = S[B + C], M++) {
            for (K = S[R + C], ne = S[F + C], P = y[C] + 1; P <= y[C] + K - 1; P++)
              S[A + x[P]] = M;
            var ce = C;
            for (T = S[B + C]; T !== -1; ) {
              var le = S[R + T] === K && S[F + T] === ne;
              for (P = y[T] + 1; le && P <= y[T] + K - 1; P++)
                S[A + x[P]] !== M && (le = 0);
              le ? (y[T] = Jt(C), S[O + C] += S[O + T], S[O + T] = 0, S[F + T] = -1, T = S[B + T], S[B + ce] = T) : (ce = T, T = S[B + T]);
            }
          }
      for (P = G, te = G; te < j; te++)
        C = x[te], !((J = -S[O + C]) <= 0) && (S[O + C] = J, pe = S[w + C] + L - J, pe = Math.min(pe, p - _ - J), S[$ + pe] !== -1 && (D[S[$ + pe]] = C), S[B + C] = S[$ + pe], D[C] = -1, S[$ + pe] = C, q = Math.min(q, pe), S[w + C] = pe, x[P++] = C);
      S[O + z] = k, (S[R + z] = P - G) === 0 && (y[z] = -1, S[A + z] = 0), Y !== 0 && (E = P);
    }
    for (C = 0; C < p; C++)
      y[C] = Jt(y[C]);
    for (T = 0; T <= p; T++)
      S[$ + T] = -1;
    for (T = p; T >= 0; T--)
      S[O + T] > 0 || (S[B + T] = S[$ + y[T]], S[$ + y[T]] = T);
    for (ee = p; ee >= 0; ee--)
      S[O + ee] <= 0 || y[ee] !== -1 && (S[B + ee] = S[$ + y[ee]], S[$ + y[ee]] = ee);
    for (z = 0, C = 0; C <= p; C++)
      y[C] === -1 && (z = fb(C, z, S, $, B, N, A));
    return N.splice(N.length - 1, 1), N;
  };
  function i(s, a, c, d, h) {
    var p = n(a);
    if (s === 1 && d === c)
      return r(a, p);
    if (s === 2) {
      for (var v = p._index, g = p._ptr, m = 0, x = 0; x < c; x++) {
        var y = g[x];
        if (g[x] = m, !(g[x + 1] - y > h))
          for (var E = g[x + 1]; y < E; y++)
            v[m++] = v[y];
      }
      return g[c] = m, a = n(p), o(p, a);
    }
    return o(p, a);
  }
  function t(s, a, c, d, h, p, v, g, m, x, y, E) {
    for (var N = 0; N < s; N++)
      c[d + N] = a[N + 1] - a[N];
    c[d + s] = 0;
    for (var S = 0; S <= s; S++)
      c[h + S] = -1, p[S] = -1, c[v + S] = -1, c[g + S] = -1, c[m + S] = 1, c[x + S] = 1, c[y + S] = 0, c[E + S] = c[d + S];
    var R = l(0, 0, c, x, s);
    return c[y + s] = -2, a[s] = -1, c[x + s] = 0, R;
  }
  function u(s, a, c, d, h, p, v, g, m, x, y) {
    for (var E = 0, N = 0; N < s; N++) {
      var S = c[d + N];
      if (S === 0)
        c[h + N] = -2, E++, a[N] = -1, c[p + N] = 0;
      else if (S > v)
        c[g + N] = 0, c[h + N] = -1, E++, a[N] = Jt(s), c[g + s]++;
      else {
        var R = c[m + S];
        R !== -1 && (x[R] = N), c[y + N] = c[m + S], c[m + S] = N;
      }
    }
    return E;
  }
  function l(s, a, c, d, h) {
    if (s < 2 || s + a < 0) {
      for (var p = 0; p < h; p++)
        c[d + p] !== 0 && (c[d + p] = 1);
      s = 2;
    }
    return s;
  }
  function f(s, a) {
    return s !== a;
  }
});
function W9(e, r, o, n, i, t, u) {
  var l, f, s = 0, a;
  if (e <= r || o[n + r] <= o[i + e])
    return -1;
  o[i + e] = o[n + r];
  var c = o[t + e];
  if (o[t + e] = r, c === -1)
    s = 1, a = e;
  else {
    for (s = 2, a = c; a !== o[u + a]; a = o[u + a])
      ;
    for (l = c; l !== a; l = f)
      f = o[u + l], o[u + l] = a;
  }
  return {
    jleaf: s,
    q: a
  };
}
var K9 = "csCounts", Z9 = ["transpose"], j9 = /* @__PURE__ */ Q(K9, Z9, (e) => {
  var {
    transpose: r
  } = e;
  return function(o, n, i, t) {
    if (!o || !n || !i)
      return null;
    var u = o._size, l = u[0], f = u[1], s, a, c, d, h, p, v, g = 4 * f + (t ? f + l + 1 : 0), m = [], x = 0, y = f, E = 2 * f, N = 3 * f, S = 4 * f, R = 5 * f + 1;
    for (c = 0; c < g; c++)
      m[c] = -1;
    var O = [], B = r(o), $ = B._index, F = B._ptr;
    for (c = 0; c < f; c++)
      for (a = i[c], O[a] = m[N + a] === -1 ? 1 : 0; a !== -1 && m[N + a] === -1; a = n[a])
        m[N + a] = c;
    if (t) {
      for (c = 0; c < f; c++)
        m[i[c]] = c;
      for (s = 0; s < l; s++) {
        for (c = f, p = F[s], v = F[s + 1], h = p; h < v; h++)
          c = Math.min(c, m[$[h]]);
        m[R + s] = m[S + c], m[S + c] = s;
      }
    }
    for (s = 0; s < f; s++)
      m[x + s] = s;
    for (c = 0; c < f; c++) {
      for (a = i[c], n[a] !== -1 && O[n[a]]--, d = t ? m[S + c] : a; d !== -1; d = t ? m[R + d] : -1)
        for (h = F[d]; h < F[d + 1]; h++) {
          s = $[h];
          var w = W9(s, a, m, N, y, E, x);
          w.jleaf >= 1 && O[a]++, w.jleaf === 2 && O[w.q]--;
        }
      n[a] !== -1 && (m[x + a] = n[a]);
    }
    for (a = 0; a < f; a++)
      n[a] !== -1 && (O[n[a]] += O[a]);
    return O;
  };
}), Y9 = "csSqr", X9 = ["add", "multiply", "transpose"], J9 = /* @__PURE__ */ Q(Y9, X9, (e) => {
  var {
    add: r,
    multiply: o,
    transpose: n
  } = e, i = V9({
    add: r,
    multiply: o,
    transpose: n
  }), t = j9({
    transpose: n
  });
  return function(f, s, a) {
    var c = s._ptr, d = s._size, h = d[1], p, v = {};
    if (v.q = i(f, s), f && !v.q)
      return null;
    if (a) {
      var g = f ? z9(s, null, v.q, 0) : s;
      v.parent = U9(g, 1);
      var m = L9(v.parent, h);
      if (v.cp = t(g, v.parent, m, 1), g && v.parent && v.cp && u(g, v))
        for (v.unz = 0, p = 0; p < h; p++)
          v.unz += v.cp[p];
    } else
      v.unz = 4 * c[h] + h, v.lnz = v.unz;
    return v;
  };
  function u(l, f) {
    var s = l._ptr, a = l._index, c = l._size, d = c[0], h = c[1];
    f.pinv = [], f.leftmost = [];
    var p = f.parent, v = f.pinv, g = f.leftmost, m = [], x = 0, y = d, E = d + h, N = d + 2 * h, S, R, O, B, $;
    for (R = 0; R < h; R++)
      m[y + R] = -1, m[E + R] = -1, m[N + R] = 0;
    for (S = 0; S < d; S++)
      g[S] = -1;
    for (R = h - 1; R >= 0; R--)
      for (B = s[R], $ = s[R + 1], O = B; O < $; O++)
        g[a[O]] = R;
    for (S = d - 1; S >= 0; S--)
      v[S] = -1, R = g[S], R !== -1 && (m[N + R]++ === 0 && (m[E + R] = S), m[x + S] = m[y + R], m[y + R] = S);
    for (f.lnz = 0, f.m2 = d, R = 0; R < h; R++)
      if (S = m[y + R], f.lnz++, S < 0 && (S = f.m2++), v[S] = R, !(--N[R] <= 0)) {
        f.lnz += m[N + R];
        var F = p[R];
        F !== -1 && (m[N + F] === 0 && (m[E + F] = m[E + R]), m[x + m[E + R]] = m[y + F], m[y + F] = m[x + S], m[N + F] += m[N + R]);
      }
    for (S = 0; S < d; S++)
      v[S] < 0 && (v[S] = R++);
    return !0;
  }
});
function Qu(e, r) {
  return e[r] < 0;
}
function cb(e, r) {
  e[r] = Jt(e[r]);
}
function Zh(e) {
  return e < 0 ? Jt(e) : e;
}
function Q9(e, r, o, n, i) {
  var t = r._index, u = r._ptr, l = r._size, f = l[1], s, a, c, d = 0;
  for (n[0] = e; d >= 0; ) {
    e = n[d];
    var h = i ? i[e] : e;
    Qu(u, e) || (cb(u, e), n[f + d] = h < 0 ? 0 : Zh(u[h]));
    var p = 1;
    for (a = n[f + d], c = h < 0 ? 0 : Zh(u[h + 1]); a < c; a++)
      if (s = t[a], !Qu(u, s)) {
        n[f + d] = a, n[++d] = s, p = 0;
        break;
      }
    p && (d--, n[--o] = e);
  }
  return o;
}
function eS(e, r, o, n, i) {
  var t = e._ptr, u = e._size, l = r._index, f = r._ptr, s = u[1], a, c, d, h = s;
  for (c = f[o], d = f[o + 1], a = c; a < d; a++) {
    var p = l[a];
    Qu(t, p) || (h = Q9(p, e, h, n, i));
  }
  for (a = h; a < s; a++)
    cb(t, n[a]);
  return h;
}
var rS = "csSpsolve", tS = ["divideScalar", "multiply", "subtract"], nS = /* @__PURE__ */ Q(rS, tS, (e) => {
  var {
    divideScalar: r,
    multiply: o,
    subtract: n
  } = e;
  return function(t, u, l, f, s, a, c) {
    var d = t._values, h = t._index, p = t._ptr, v = t._size, g = v[1], m = u._values, x = u._index, y = u._ptr, E, N, S, R, O = eS(t, u, l, f, a);
    for (E = O; E < g; E++)
      s[f[E]] = 0;
    for (N = y[l], S = y[l + 1], E = N; E < S; E++)
      s[x[E]] = m[E];
    for (var B = O; B < g; B++) {
      var $ = f[B], F = a ? a[$] : $;
      if (!(F < 0))
        for (N = p[F], S = p[F + 1], s[$] = r(s[$], d[c ? N : S - 1]), E = c ? N + 1 : N, R = c ? S : S - 1; E < R; E++) {
          var w = h[E];
          s[w] = n(s[w], o(d[E], s[$]));
        }
    }
    return O;
  };
}), iS = "csLu", aS = ["abs", "divideScalar", "multiply", "subtract", "larger", "largerEq", "SparseMatrix"], oS = /* @__PURE__ */ Q(iS, aS, (e) => {
  var {
    abs: r,
    divideScalar: o,
    multiply: n,
    subtract: i,
    larger: t,
    largerEq: u,
    SparseMatrix: l
  } = e, f = nS({
    divideScalar: o,
    multiply: n,
    subtract: i
  });
  return function(a, c, d) {
    if (!a)
      return null;
    var h = a._size, p = h[1], v, g = 100, m = 100;
    c && (v = c.q, g = c.lnz || g, m = c.unz || m);
    var x = [], y = [], E = [], N = new l({
      values: x,
      index: y,
      ptr: E,
      size: [p, p]
    }), S = [], R = [], O = [], B = new l({
      values: S,
      index: R,
      ptr: O,
      size: [p, p]
    }), $ = [], F, w, A = [], b = [];
    for (F = 0; F < p; F++)
      A[F] = 0, $[F] = -1, E[F + 1] = 0;
    g = 0, m = 0;
    for (var D = 0; D < p; D++) {
      E[D] = g, O[D] = m;
      var M = v ? v[D] : D, _ = f(N, a, M, b, A, $, 1), q = -1, C = -1;
      for (w = _; w < p; w++)
        if (F = b[w], $[F] < 0) {
          var T = r(A[F]);
          t(T, C) && (C = T, q = F);
        } else
          R[m] = $[F], S[m++] = A[F];
      if (q === -1 || C <= 0)
        return null;
      $[M] < 0 && u(r(A[M]), n(C, d)) && (q = M);
      var z = A[q];
      for (R[m] = D, S[m++] = z, $[q] = D, y[g] = q, x[g++] = 1, w = _; w < p; w++)
        F = b[w], $[F] < 0 && (y[g] = F, x[g++] = o(A[F], z)), A[F] = 0;
    }
    for (E[p] = g, O[p] = m, w = 0; w < g; w++)
      y[w] = $[y[w]];
    return x.splice(g, x.length - g), y.splice(g, y.length - g), S.splice(m, S.length - m), R.splice(m, R.length - m), {
      L: N,
      U: B,
      pinv: $
    };
  };
}), jh = "slu", sS = ["typed", "abs", "add", "multiply", "transpose", "divideScalar", "subtract", "larger", "largerEq", "SparseMatrix"], uS = /* @__PURE__ */ Q(jh, sS, (e) => {
  var {
    typed: r,
    abs: o,
    add: n,
    multiply: i,
    transpose: t,
    divideScalar: u,
    subtract: l,
    larger: f,
    largerEq: s,
    SparseMatrix: a
  } = e, c = J9({
    add: n,
    multiply: i,
    transpose: t
  }), d = oS({
    abs: o,
    divideScalar: u,
    multiply: i,
    subtract: l,
    larger: f,
    largerEq: s,
    SparseMatrix: a
  });
  return r(jh, {
    "SparseMatrix, number, number": function(p, v, g) {
      if (!Te(v) || v < 0 || v > 3)
        throw new Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");
      if (g < 0 || g > 1)
        throw new Error("Partial pivoting threshold must be a number from 0 to 1");
      var m = c(v, p, !1), x = d(p, m, g);
      return {
        L: x.L,
        U: x.U,
        p: x.pinv,
        q: m.q,
        toString: function() {
          return "L: " + this.L.toString() + `
U: ` + this.U.toString() + `
p: ` + this.p.toString() + (this.q ? `
q: ` + this.q.toString() : "") + `
`;
        }
      };
    }
  });
});
function Yh(e, r) {
  var o, n = r.length, i = [];
  if (e)
    for (o = 0; o < n; o++)
      i[e[o]] = r[o];
  else
    for (o = 0; o < n; o++)
      i[o] = r[o];
  return i;
}
var Xh = "lusolve", fS = ["typed", "matrix", "lup", "slu", "usolve", "lsolve", "DenseMatrix"], cS = /* @__PURE__ */ Q(Xh, fS, (e) => {
  var {
    typed: r,
    matrix: o,
    lup: n,
    slu: i,
    usolve: t,
    lsolve: u,
    DenseMatrix: l
  } = e, f = Fi({
    DenseMatrix: l
  });
  return r(Xh, {
    "Array, Array | Matrix": function(d, h) {
      d = o(d);
      var p = n(d), v = a(p.L, p.U, p.p, null, h);
      return v.valueOf();
    },
    "DenseMatrix, Array | Matrix": function(d, h) {
      var p = n(d);
      return a(p.L, p.U, p.p, null, h);
    },
    "SparseMatrix, Array | Matrix": function(d, h) {
      var p = n(d);
      return a(p.L, p.U, p.p, null, h);
    },
    "SparseMatrix, Array | Matrix, number, number": function(d, h, p, v) {
      var g = i(d, p, v);
      return a(g.L, g.U, g.p, g.q, h);
    },
    "Object, Array | Matrix": function(d, h) {
      return a(d.L, d.U, d.p, d.q, h);
    }
  });
  function s(c) {
    if (Fe(c))
      return c;
    if (ar(c))
      return o(c);
    throw new TypeError("Invalid Matrix LU decomposition");
  }
  function a(c, d, h, p, v) {
    c = s(c), d = s(d), h && (v = f(c, v, !0), v._data = Yh(h, v._data));
    var g = u(c, v), m = t(d, g);
    return p && (m._data = Yh(p, m._data)), m;
  }
}), Jh = "polynomialRoot", lS = ["typed", "isZero", "equalScalar", "add", "subtract", "multiply", "divide", "sqrt", "unaryMinus", "cbrt", "typeOf", "im", "re"], dS = /* @__PURE__ */ Q(Jh, lS, (e) => {
  var {
    typed: r,
    isZero: o,
    equalScalar: n,
    add: i,
    subtract: t,
    multiply: u,
    divide: l,
    sqrt: f,
    unaryMinus: s,
    cbrt: a,
    typeOf: c,
    im: d,
    re: h
  } = e;
  return r(Jh, {
    "number|Complex, ...number|Complex": (p, v) => {
      for (var g = [p, ...v]; g.length > 0 && o(g[g.length - 1]); )
        g.pop();
      if (g.length < 2)
        throw new RangeError("Polynomial [".concat(p, ", ").concat(v, "] must have a non-zero non-constant coefficient"));
      switch (g.length) {
        case 2:
          return [s(l(g[0], g[1]))];
        case 3: {
          var [m, x, y] = g, E = u(2, y), N = u(x, x), S = u(4, y, m);
          if (n(N, S))
            return [l(s(x), E)];
          var R = f(t(N, S));
          return [l(t(R, x), E), l(t(s(R), x), E)];
        }
        case 4: {
          var [O, B, $, F] = g, w = s(u(3, F)), A = u($, $), b = u(3, F, B), D = i(u(2, $, $, $), u(27, F, F, O)), M = u(9, F, $, B);
          if (n(A, b) && n(D, M))
            return [l($, w)];
          var _ = t(A, b), q = t(D, M), C = i(u(18, F, $, B, O), u($, $, B, B)), T = i(u(4, $, $, $, O), u(4, F, B, B, B), u(27, F, F, O, O));
          if (n(C, T))
            return [
              l(t(u(4, F, $, B), i(u(9, F, F, O), u($, $, $))), u(F, _)),
              // simple root
              l(t(u(9, F, O), u($, B)), u(2, _))
              // double root
            ];
          var z;
          n(A, b) ? z = q : z = l(i(q, f(t(u(q, q), u(4, _, _, _)))), 2);
          var I = !0, U = a(z, I).toArray().map((ee) => l(i($, ee, l(_, ee)), w));
          return U.map((ee) => c(ee) === "Complex" && n(h(ee), h(ee) + d(ee)) ? h(ee) : ee);
        }
        default:
          throw new RangeError("only implemented for cubic or lower-order polynomials, not ".concat(g));
      }
    }
  });
}), hS = "Help", pS = ["evaluate"], vS = /* @__PURE__ */ Q(hS, pS, (e) => {
  var {
    evaluate: r
  } = e;
  function o(n) {
    if (!(this instanceof o))
      throw new SyntaxError("Constructor must be called with the new operator");
    if (!n)
      throw new Error('Argument "doc" missing');
    this.doc = n;
  }
  return o.prototype.type = "Help", o.prototype.isHelp = !0, o.prototype.toString = function() {
    var n = this.doc || {}, i = `
`;
    if (n.name && (i += "Name: " + n.name + `

`), n.category && (i += "Category: " + n.category + `

`), n.description && (i += `Description:
    ` + n.description + `

`), n.syntax && (i += `Syntax:
    ` + n.syntax.join(`
    `) + `

`), n.examples) {
      i += `Examples:
`;
      for (var t = !1, u = r("config()"), l = {
        config: (c) => (t = !0, r("config(newConfig)", {
          newConfig: c
        }))
      }, f = 0; f < n.examples.length; f++) {
        var s = n.examples[f];
        i += "    " + s + `
`;
        var a = void 0;
        try {
          a = r(s, l);
        } catch (c) {
          a = c;
        }
        a !== void 0 && !Mf(a) && (i += "        " + Ze(a, {
          precision: 14
        }) + `
`);
      }
      i += `
`, t && r("config(originalConfig)", {
        originalConfig: u
      });
    }
    return n.mayThrow && n.mayThrow.length && (i += "Throws: " + n.mayThrow.join(", ") + `

`), n.seealso && n.seealso.length && (i += "See also: " + n.seealso.join(", ") + `
`), i;
  }, o.prototype.toJSON = function() {
    var n = Ie(this.doc);
    return n.mathjs = "Help", n;
  }, o.fromJSON = function(n) {
    var i = {};
    return Object.keys(n).filter((t) => t !== "mathjs").forEach((t) => {
      i[t] = n[t];
    }), new o(i);
  }, o.prototype.valueOf = o.prototype.toString, o;
}, {
  isClass: !0
}), mS = "Chain", gS = ["?on", "math", "typed"], bS = /* @__PURE__ */ Q(mS, gS, (e) => {
  var {
    on: r,
    math: o,
    typed: n
  } = e;
  function i(s) {
    if (!(this instanceof i))
      throw new SyntaxError("Constructor must be called with the new operator");
    _f(s) ? this.value = s.value : this.value = s;
  }
  i.prototype.type = "Chain", i.prototype.isChain = !0, i.prototype.done = function() {
    return this.value;
  }, i.prototype.valueOf = function() {
    return this.value;
  }, i.prototype.toString = function() {
    return Ze(this.value);
  }, i.prototype.toJSON = function() {
    return {
      mathjs: "Chain",
      value: this.value
    };
  }, i.fromJSON = function(s) {
    return new i(s.value);
  };
  function t(s, a) {
    typeof a == "function" && (i.prototype[s] = l(a));
  }
  function u(s, a) {
    ga(i.prototype, s, function() {
      var d = a();
      if (typeof d == "function")
        return l(d);
    });
  }
  function l(s) {
    return function() {
      if (arguments.length === 0)
        return new i(s(this.value));
      for (var a = [this.value], c = 0; c < arguments.length; c++)
        a[c + 1] = arguments[c];
      if (n.isTypedFunction(s)) {
        var d = n.resolve(s, a);
        if (d.params.length === 1)
          throw new Error("chain function " + s.name + " cannot match rest parameter between chain value and additional arguments.");
        return new i(d.implementation.apply(s, a));
      }
      return new i(s.apply(s, a));
    };
  }
  i.createProxy = function(s, a) {
    if (typeof s == "string")
      t(s, a);
    else {
      var c = function(p) {
        De(s, p) && f[p] === void 0 && u(p, () => s[p]);
      };
      for (var d in s)
        c(d);
    }
  };
  var f = {
    expression: !0,
    docs: !0,
    type: !0,
    classes: !0,
    json: !0,
    error: !0,
    isChain: !0
    // conflicts with the property isChain of a Chain instance
  };
  return i.createProxy(o), r && r("import", function(s, a, c) {
    c || u(s, a);
  }), i;
}, {
  isClass: !0
}), Qh = {
  name: "e",
  category: "Constants",
  syntax: ["e"],
  description: "Euler's number, the base of the natural logarithm. Approximately equal to 2.71828",
  examples: ["e", "e ^ 2", "exp(2)", "log(e)"],
  seealso: ["exp"]
}, yS = {
  name: "false",
  category: "Constants",
  syntax: ["false"],
  description: "Boolean value false",
  examples: ["false"],
  seealso: ["true"]
}, wS = {
  name: "i",
  category: "Constants",
  syntax: ["i"],
  description: "Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.",
  examples: ["i", "i * i", "sqrt(-1)"],
  seealso: []
}, xS = {
  name: "Infinity",
  category: "Constants",
  syntax: ["Infinity"],
  description: "Infinity, a number which is larger than the maximum number that can be handled by a floating point number.",
  examples: ["Infinity", "1 / 0"],
  seealso: []
}, ES = {
  name: "LN10",
  category: "Constants",
  syntax: ["LN10"],
  description: "Returns the natural logarithm of 10, approximately equal to 2.302",
  examples: ["LN10", "log(10)"],
  seealso: []
}, AS = {
  name: "LN2",
  category: "Constants",
  syntax: ["LN2"],
  description: "Returns the natural logarithm of 2, approximately equal to 0.693",
  examples: ["LN2", "log(2)"],
  seealso: []
}, SS = {
  name: "LOG10E",
  category: "Constants",
  syntax: ["LOG10E"],
  description: "Returns the base-10 logarithm of E, approximately equal to 0.434",
  examples: ["LOG10E", "log(e, 10)"],
  seealso: []
}, DS = {
  name: "LOG2E",
  category: "Constants",
  syntax: ["LOG2E"],
  description: "Returns the base-2 logarithm of E, approximately equal to 1.442",
  examples: ["LOG2E", "log(e, 2)"],
  seealso: []
}, NS = {
  name: "NaN",
  category: "Constants",
  syntax: ["NaN"],
  description: "Not a number",
  examples: ["NaN", "0 / 0"],
  seealso: []
}, MS = {
  name: "null",
  category: "Constants",
  syntax: ["null"],
  description: "Value null",
  examples: ["null"],
  seealso: ["true", "false"]
}, _S = {
  name: "phi",
  category: "Constants",
  syntax: ["phi"],
  description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...",
  examples: ["phi"],
  seealso: []
}, e0 = {
  name: "pi",
  category: "Constants",
  syntax: ["pi"],
  description: "The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159",
  examples: ["pi", "sin(pi/2)"],
  seealso: ["tau"]
}, CS = {
  name: "SQRT1_2",
  category: "Constants",
  syntax: ["SQRT1_2"],
  description: "Returns the square root of 1/2, approximately equal to 0.707",
  examples: ["SQRT1_2", "sqrt(1/2)"],
  seealso: []
}, TS = {
  name: "SQRT2",
  category: "Constants",
  syntax: ["SQRT2"],
  description: "Returns the square root of 2, approximately equal to 1.414",
  examples: ["SQRT2", "sqrt(2)"],
  seealso: []
}, BS = {
  name: "tau",
  category: "Constants",
  syntax: ["tau"],
  description: "Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.",
  examples: ["tau", "2 * pi"],
  seealso: ["pi"]
}, FS = {
  name: "true",
  category: "Constants",
  syntax: ["true"],
  description: "Boolean value true",
  examples: ["true"],
  seealso: ["false"]
}, IS = {
  name: "version",
  category: "Constants",
  syntax: ["version"],
  description: "A string with the version number of math.js",
  examples: ["version"],
  seealso: []
}, OS = {
  name: "bignumber",
  category: "Construction",
  syntax: ["bignumber(x)"],
  description: "Create a big number from a number or string.",
  examples: ["0.1 + 0.2", "bignumber(0.1) + bignumber(0.2)", 'bignumber("7.2")', 'bignumber("7.2e500")', "bignumber([0.1, 0.2, 0.3])"],
  seealso: ["boolean", "bigint", "complex", "fraction", "index", "matrix", "string", "unit"]
}, RS = {
  name: "bigint",
  category: "Construction",
  syntax: ["bigint(x)"],
  description: "Create a bigint, an integer with an arbitrary number of digits, from a number or string.",
  examples: ["123123123123123123 # a large number will lose digits", 'bigint("123123123123123123")', 'bignumber(["1", "3", "5"])'],
  seealso: ["boolean", "bignumber", "number", "complex", "fraction", "index", "matrix", "string", "unit"]
}, PS = {
  name: "boolean",
  category: "Construction",
  syntax: ["x", "boolean(x)"],
  description: "Convert a string or number into a boolean.",
  examples: ["boolean(0)", "boolean(1)", "boolean(3)", 'boolean("true")', 'boolean("false")', "boolean([1, 0, 1, 1])"],
  seealso: ["bignumber", "complex", "index", "matrix", "number", "string", "unit"]
}, qS = {
  name: "complex",
  category: "Construction",
  syntax: ["complex()", "complex(re, im)", "complex(string)"],
  description: "Create a complex number.",
  examples: ["complex()", "complex(2, 3)", 'complex("7 - 2i")'],
  seealso: ["bignumber", "boolean", "index", "matrix", "number", "string", "unit"]
}, $S = {
  name: "createUnit",
  category: "Construction",
  syntax: ["createUnit(definitions)", "createUnit(name, definition)"],
  description: "Create a user-defined unit and register it with the Unit type.",
  examples: ['createUnit("foo")', 'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})', 'createUnit("mph", "1 mile/hour")'],
  seealso: ["unit", "splitUnit"]
}, zS = {
  name: "fraction",
  category: "Construction",
  syntax: ["fraction(num)", "fraction(matrix)", "fraction(num,den)", "fraction({n: num, d: den})"],
  description: "Create a fraction from a number or from integer numerator and denominator.",
  examples: ["fraction(0.125)", "fraction(1, 3) + fraction(2, 5)", "fraction({n: 333, d: 53})", "fraction([sqrt(9), sqrt(10), sqrt(11)])"],
  seealso: ["bignumber", "boolean", "complex", "index", "matrix", "string", "unit"]
}, LS = {
  name: "index",
  category: "Construction",
  syntax: ["[start]", "[start:end]", "[start:step:end]", "[start1, start 2, ...]", "[start1:end1, start2:end2, ...]", "[start1:step1:end1, start2:step2:end2, ...]"],
  description: "Create an index to get or replace a subset of a matrix",
  examples: ["A = [1, 2, 3; 4, 5, 6]", "A[1, :]", "A[1, 2] = 50", "A[1:2, 1:2] = 1", "B = [1, 2, 3]", "B[B>1 and B<3]"],
  seealso: ["bignumber", "boolean", "complex", "matrix,", "number", "range", "string", "unit"]
}, US = {
  name: "matrix",
  category: "Construction",
  syntax: ["[]", "[a1, b1, ...; a2, b2, ...]", "matrix()", 'matrix("dense")', "matrix([...])"],
  description: "Create a matrix.",
  examples: ["[]", "[1, 2, 3]", "[1, 2, 3; 4, 5, 6]", "matrix()", "matrix([3, 4])", 'matrix([3, 4; 5, 6], "sparse")', 'matrix([3, 4; 5, 6], "sparse", "number")'],
  seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "sparse"]
}, kS = {
  name: "number",
  category: "Construction",
  syntax: ["x", "number(x)", "number(unit, valuelessUnit)"],
  description: "Create a number or convert a string or boolean into a number.",
  examples: ["2", "2e3", "4.05", "number(2)", 'number("7.2")', "number(true)", "number([true, false, true, true])", 'number(unit("52cm"), "m")'],
  seealso: ["bignumber", "bigint", "boolean", "complex", "fraction", "index", "matrix", "string", "unit"]
}, HS = {
  name: "sparse",
  category: "Construction",
  syntax: ["sparse()", "sparse([a1, b1, ...; a1, b2, ...])", 'sparse([a1, b1, ...; a1, b2, ...], "number")'],
  description: "Create a sparse matrix.",
  examples: ["sparse()", "sparse([3, 4; 5, 6])", 'sparse([3, 0; 5, 0], "number")'],
  seealso: ["bignumber", "boolean", "complex", "index", "number", "string", "unit", "matrix"]
}, GS = {
  name: "splitUnit",
  category: "Construction",
  syntax: ["splitUnit(unit: Unit, parts: Unit[])"],
  description: "Split a unit in an array of units whose sum is equal to the original unit.",
  examples: ['splitUnit(1 m, ["feet", "inch"])'],
  seealso: ["unit", "createUnit"]
}, VS = {
  name: "string",
  category: "Construction",
  syntax: ['"text"', "string(x)"],
  description: "Create a string or convert a value to a string",
  examples: ['"Hello World!"', "string(4.2)", "string(3 + 2i)"],
  seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "unit"]
}, WS = {
  name: "unit",
  category: "Construction",
  syntax: ["value unit", "unit(value, unit)", "unit(string)"],
  description: "Create a unit.",
  examples: ["5.5 mm", "3 inch", 'unit(7.1, "kilogram")', 'unit("23 deg")'],
  seealso: ["bignumber", "boolean", "complex", "index", "matrix", "number", "string"]
}, KS = {
  name: "config",
  category: "Core",
  syntax: ["config()", "config(options)"],
  description: "Get configuration or change configuration.",
  examples: ["config()", "1/3 + 1/4", 'config({number: "Fraction"})', "1/3 + 1/4"],
  seealso: []
}, ZS = {
  name: "import",
  category: "Core",
  syntax: ["import(functions)", "import(functions, options)"],
  description: "Import functions or constants from an object.",
  examples: ["import({myFn: f(x)=x^2, myConstant: 32 })", "myFn(2)", "myConstant"],
  seealso: []
}, jS = {
  name: "typed",
  category: "Core",
  syntax: ["typed(signatures)", "typed(name, signatures)"],
  description: "Create a typed function.",
  examples: ['double = typed({ "number": f(x)=x+x, "string": f(x)=concat(x,x) })', "double(2)", 'double("hello")'],
  seealso: []
}, YS = {
  name: "derivative",
  category: "Algebra",
  syntax: ["derivative(expr, variable)", "derivative(expr, variable, {simplify: boolean})"],
  description: "Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.",
  examples: ['derivative("2x^3", "x")', 'derivative("2x^3", "x", {simplify: false})', 'derivative("2x^2 + 3x + 4", "x")', 'derivative("sin(2x)", "x")', 'f = parse("x^2 + x")', 'x = parse("x")', "df = derivative(f, x)", "df.evaluate({x: 3})"],
  seealso: ["simplify", "parse", "evaluate"]
}, XS = {
  name: "leafCount",
  category: "Algebra",
  syntax: ["leafCount(expr)"],
  description: "Computes the number of leaves in the parse tree of the given expression",
  examples: ['leafCount("e^(i*pi)-1")', 'leafCount(parse("{a: 22/7, b: 10^(1/2)}"))'],
  seealso: ["simplify"]
}, JS = {
  name: "lsolve",
  category: "Algebra",
  syntax: ["x=lsolve(L, b)"],
  description: "Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
  examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"],
  seealso: ["lsolveAll", "lup", "lusolve", "usolve", "matrix", "sparse"]
}, QS = {
  name: "lsolveAll",
  category: "Algebra",
  syntax: ["x=lsolveAll(L, b)"],
  description: "Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",
  examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lsolve(a, b)"],
  seealso: ["lsolve", "lup", "lusolve", "usolve", "matrix", "sparse"]
}, eD = {
  name: "lup",
  category: "Algebra",
  syntax: ["lup(m)"],
  description: "Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U",
  examples: ["lup([[2, 1], [1, 4]])", "lup(matrix([[2, 1], [1, 4]]))", "lup(sparse([[2, 1], [1, 4]]))"],
  seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "slu", "qr"]
}, rD = {
  name: "lusolve",
  category: "Algebra",
  syntax: ["x=lusolve(A, b)", "x=lusolve(lu, b)"],
  description: "Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.",
  examples: ["a = [-2, 3; 2, 1]", "b = [11, 9]", "x = lusolve(a, b)"],
  seealso: ["lup", "slu", "lsolve", "usolve", "matrix", "sparse"]
}, tD = {
  name: "polynomialRoot",
  category: "Algebra",
  syntax: ["x=polynomialRoot(-6, 3)", "x=polynomialRoot(4, -4, 1)", "x=polynomialRoot(-8, 12, -6, 1)"],
  description: "Finds the roots of a univariate polynomial given by its coefficients starting from constant, linear, and so on, increasing in degree.",
  examples: ["a = polynomialRoot(-6, 11, -6, 1)"],
  seealso: ["cbrt", "sqrt"]
}, nD = {
  name: "qr",
  category: "Algebra",
  syntax: ["qr(A)"],
  description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.",
  examples: ["qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"],
  seealso: ["lup", "slu", "matrix"]
}, iD = {
  name: "rationalize",
  category: "Algebra",
  syntax: ["rationalize(expr)", "rationalize(expr, scope)", "rationalize(expr, scope, detailed)"],
  description: "Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.",
  examples: ['rationalize("2x/y - y/(x+1)")', 'rationalize("2x/y - y/(x+1)", true)'],
  seealso: ["simplify"]
}, aD = {
  name: "resolve",
  category: "Algebra",
  syntax: ["resolve(node, scope)"],
  description: "Recursively substitute variables in an expression tree.",
  examples: ['resolve(parse("1 + x"), { x: 7 })', 'resolve(parse("size(text)"), { text: "Hello World" })', 'resolve(parse("x + y"), { x: parse("3z") })', 'resolve(parse("3x"), { x: parse("y+z"), z: parse("w^y") })'],
  seealso: ["simplify", "evaluate"],
  mayThrow: ["ReferenceError"]
}, oD = {
  name: "simplify",
  category: "Algebra",
  syntax: ["simplify(expr)", "simplify(expr, rules)"],
  description: "Simplify an expression tree.",
  examples: ['simplify("3 + 2 / 4")', 'simplify("2x + x")', 'f = parse("x * (x + 2 + x)")', "simplified = simplify(f)", "simplified.evaluate({x: 2})"],
  seealso: ["simplifyCore", "derivative", "evaluate", "parse", "rationalize", "resolve"]
}, sD = {
  name: "simplifyConstant",
  category: "Algebra",
  syntax: ["simplifyConstant(expr)", "simplifyConstant(expr, options)"],
  description: "Replace constant subexpressions of node with their values.",
  examples: ['simplifyConstant("(3-3)*x")', 'simplifyConstant(parse("z-cos(tau/8)"))'],
  seealso: ["simplify", "simplifyCore", "evaluate"]
}, uD = {
  name: "simplifyCore",
  category: "Algebra",
  syntax: ["simplifyCore(node)"],
  description: "Perform simple one-pass simplifications on an expression tree.",
  examples: ['simplifyCore(parse("0*x"))', 'simplifyCore(parse("(x+0)*2"))'],
  seealso: ["simplify", "simplifyConstant", "evaluate"]
}, fD = {
  name: "slu",
  category: "Algebra",
  syntax: ["slu(A, order, threshold)"],
  description: "Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U",
  examples: ["slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"],
  seealso: ["lusolve", "lsolve", "usolve", "matrix", "sparse", "lup", "qr"]
}, cD = {
  name: "symbolicEqual",
  category: "Algebra",
  syntax: ["symbolicEqual(expr1, expr2)", "symbolicEqual(expr1, expr2, options)"],
  description: "Returns true if the difference of the expressions simplifies to 0",
  examples: ['symbolicEqual("x*y","y*x")', 'symbolicEqual("abs(x^2)", "x^2")', 'symbolicEqual("abs(x)", "x", {context: {abs: {trivial: true}}})'],
  seealso: ["simplify", "evaluate"]
}, lD = {
  name: "usolve",
  category: "Algebra",
  syntax: ["x=usolve(U, b)"],
  description: "Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
  examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"],
  seealso: ["usolveAll", "lup", "lusolve", "lsolve", "matrix", "sparse"]
}, dD = {
  name: "usolveAll",
  category: "Algebra",
  syntax: ["x=usolve(U, b)"],
  description: "Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",
  examples: ["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"],
  seealso: ["usolve", "lup", "lusolve", "lsolve", "matrix", "sparse"]
}, hD = {
  name: "abs",
  category: "Arithmetic",
  syntax: ["abs(x)"],
  description: "Compute the absolute value.",
  examples: ["abs(3.5)", "abs(-4.2)"],
  seealso: ["sign"]
}, pD = {
  name: "add",
  category: "Operators",
  syntax: ["x + y", "add(x, y)"],
  description: "Add two values.",
  examples: ["a = 2.1 + 3.6", "a - 3.6", "3 + 2i", "3 cm + 2 inch", '"2.3" + "4"'],
  seealso: ["subtract"]
}, vD = {
  name: "cbrt",
  category: "Arithmetic",
  syntax: ["cbrt(x)", "cbrt(x, allRoots)"],
  description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned",
  examples: ["cbrt(64)", "cube(4)", "cbrt(-8)", "cbrt(2 + 3i)", "cbrt(8i)", "cbrt(8i, true)", "cbrt(27 m^3)"],
  seealso: ["square", "sqrt", "cube", "multiply"]
}, mD = {
  name: "ceil",
  category: "Arithmetic",
  syntax: ["ceil(x)"],
  description: "Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.",
  examples: ["ceil(3.2)", "ceil(3.8)", "ceil(-4.2)"],
  seealso: ["floor", "fix", "round"]
}, gD = {
  name: "cube",
  category: "Arithmetic",
  syntax: ["cube(x)"],
  description: "Compute the cube of a value. The cube of x is x * x * x.",
  examples: ["cube(2)", "2^3", "2 * 2 * 2"],
  seealso: ["multiply", "square", "pow"]
}, bD = {
  name: "divide",
  category: "Operators",
  syntax: ["x / y", "divide(x, y)"],
  description: "Divide two values.",
  examples: ["a = 2 / 3", "a * 3", "4.5 / 2", "3 + 4 / 2", "(3 + 4) / 2", "18 km / 4.5"],
  seealso: ["multiply"]
}, yD = {
  name: "dotDivide",
  category: "Operators",
  syntax: ["x ./ y", "dotDivide(x, y)"],
  description: "Divide two values element wise.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a ./ b"],
  seealso: ["multiply", "dotMultiply", "divide"]
}, wD = {
  name: "dotMultiply",
  category: "Operators",
  syntax: ["x .* y", "dotMultiply(x, y)"],
  description: "Multiply two values element wise.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "b = [2, 1, 1; 3, 2, 5]", "a .* b"],
  seealso: ["multiply", "divide", "dotDivide"]
}, xD = {
  name: "dotPow",
  category: "Operators",
  syntax: ["x .^ y", "dotPow(x, y)"],
  description: "Calculates the power of x to y element wise.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "a .^ 2"],
  seealso: ["pow"]
}, ED = {
  name: "exp",
  category: "Arithmetic",
  syntax: ["exp(x)"],
  description: "Calculate the exponent of a value.",
  examples: ["exp(1.3)", "e ^ 1.3", "log(exp(1.3))", "x = 2.4", "(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula"],
  seealso: ["expm", "expm1", "pow", "log"]
}, AD = {
  name: "expm",
  category: "Arithmetic",
  syntax: ["exp(x)"],
  description: "Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.",
  examples: ["expm([[0,2],[0,0]])"],
  seealso: ["exp"]
}, SD = {
  name: "expm1",
  category: "Arithmetic",
  syntax: ["expm1(x)"],
  description: "Calculate the value of subtracting 1 from the exponential value.",
  examples: ["expm1(2)", "pow(e, 2) - 1", "log(expm1(2) + 1)"],
  seealso: ["exp", "pow", "log"]
}, DD = {
  name: "fix",
  category: "Arithmetic",
  syntax: ["fix(x)"],
  description: "Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.",
  examples: ["fix(3.2)", "fix(3.8)", "fix(-4.2)", "fix(-4.8)"],
  seealso: ["ceil", "floor", "round"]
}, ND = {
  name: "floor",
  category: "Arithmetic",
  syntax: ["floor(x)"],
  description: "Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.",
  examples: ["floor(3.2)", "floor(3.8)", "floor(-4.2)"],
  seealso: ["ceil", "fix", "round"]
}, MD = {
  name: "gcd",
  category: "Arithmetic",
  syntax: ["gcd(a, b)", "gcd(a, b, c, ...)"],
  description: "Compute the greatest common divisor.",
  examples: ["gcd(8, 12)", "gcd(-4, 6)", "gcd(25, 15, -10)"],
  seealso: ["lcm", "xgcd"]
}, _D = {
  name: "hypot",
  category: "Arithmetic",
  syntax: ["hypot(a, b, c, ...)", "hypot([a, b, c, ...])"],
  description: "Calculate the hypotenusa of a list with values. ",
  examples: ["hypot(3, 4)", "sqrt(3^2 + 4^2)", "hypot(-2)", "hypot([3, 4, 5])"],
  seealso: ["abs", "norm"]
}, CD = {
  name: "invmod",
  category: "Arithmetic",
  syntax: ["invmod(a, b)"],
  description: "Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation ax ≣ 1 (mod b)",
  examples: ["invmod(8, 12)", "invmod(7, 13)", "invmod(15151, 15122)"],
  seealso: ["gcd", "xgcd"]
}, TD = {
  name: "lcm",
  category: "Arithmetic",
  syntax: ["lcm(x, y)"],
  description: "Compute the least common multiple.",
  examples: ["lcm(4, 6)", "lcm(6, 21)", "lcm(6, 21, 5)"],
  seealso: ["gcd"]
}, BD = {
  name: "log",
  category: "Arithmetic",
  syntax: ["log(x)", "log(x, base)"],
  description: "Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).",
  examples: ["log(3.5)", "a = log(2.4)", "exp(a)", "10 ^ 4", "log(10000, 10)", "log(10000) / log(10)", "b = log(1024, 2)", "2 ^ b"],
  seealso: ["exp", "log1p", "log2", "log10"]
}, FD = {
  name: "log10",
  category: "Arithmetic",
  syntax: ["log10(x)"],
  description: "Compute the 10-base logarithm of a value.",
  examples: ["log10(0.00001)", "log10(10000)", "10 ^ 4", "log(10000) / log(10)", "log(10000, 10)"],
  seealso: ["exp", "log"]
}, ID = {
  name: "log1p",
  category: "Arithmetic",
  syntax: ["log1p(x)", "log1p(x, base)"],
  description: "Calculate the logarithm of a `value+1`",
  examples: ["log1p(2.5)", "exp(log1p(1.4))", "pow(10, 4)", "log1p(9999, 10)", "log1p(9999) / log(10)"],
  seealso: ["exp", "log", "log2", "log10"]
}, OD = {
  name: "log2",
  category: "Arithmetic",
  syntax: ["log2(x)"],
  description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.",
  examples: ["log2(0.03125)", "log2(16)", "log2(16) / log2(2)", "pow(2, 4)"],
  seealso: ["exp", "log1p", "log", "log10"]
}, RD = {
  name: "mod",
  category: "Operators",
  syntax: ["x % y", "x mod y", "mod(x, y)"],
  description: "Calculates the modulus, the remainder of an integer division.",
  examples: ["7 % 3", "11 % 2", "10 mod 4", "isOdd(x) = x % 2", "isOdd(2)", "isOdd(3)"],
  seealso: ["divide"]
}, PD = {
  name: "multiply",
  category: "Operators",
  syntax: ["x * y", "multiply(x, y)"],
  description: "multiply two values.",
  examples: ["a = 2.1 * 3.4", "a / 3.4", "2 * 3 + 4", "2 * (3 + 4)", "3 * 2.1 km"],
  seealso: ["divide"]
}, qD = {
  name: "norm",
  category: "Arithmetic",
  syntax: ["norm(x)", "norm(x, p)"],
  description: "Calculate the norm of a number, vector or matrix.",
  examples: ["abs(-3.5)", "norm(-3.5)", "norm(3 - 4i)", "norm([1, 2, -3], Infinity)", "norm([1, 2, -3], -Infinity)", "norm([3, 4], 2)", "norm([[1, 2], [3, 4]], 1)", 'norm([[1, 2], [3, 4]], "inf")', 'norm([[1, 2], [3, 4]], "fro")']
}, $D = {
  name: "nthRoot",
  category: "Arithmetic",
  syntax: ["nthRoot(a)", "nthRoot(a, root)"],
  description: 'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".',
  examples: ["4 ^ 3", "nthRoot(64, 3)", "nthRoot(9, 2)", "sqrt(9)"],
  seealso: ["nthRoots", "pow", "sqrt"]
}, zD = {
  name: "nthRoots",
  category: "Arithmetic",
  syntax: ["nthRoots(A)", "nthRoots(A, root)"],
  description: 'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.',
  examples: ["nthRoots(1)", "nthRoots(1, 3)"],
  seealso: ["sqrt", "pow", "nthRoot"]
}, LD = {
  name: "pow",
  category: "Operators",
  syntax: ["x ^ y", "pow(x, y)"],
  description: "Calculates the power of x to y, x^y.",
  examples: ["2^3", "2*2*2", "1 + e ^ (pi * i)", "pow([[1, 2], [4, 3]], 2)", "pow([[1, 2], [4, 3]], -1)"],
  seealso: ["multiply", "nthRoot", "nthRoots", "sqrt"]
}, UD = {
  name: "round",
  category: "Arithmetic",
  syntax: ["round(x)", "round(x, n)", "round(unit, valuelessUnit)", "round(unit, n, valuelessUnit)"],
  description: "round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.",
  examples: ["round(3.2)", "round(3.8)", "round(-4.2)", "round(-4.8)", "round(pi, 3)", "round(123.45678, 2)", "round(3.241cm, 2, cm)", "round([3.2, 3.8, -4.7])"],
  seealso: ["ceil", "floor", "fix"]
}, kD = {
  name: "sign",
  category: "Arithmetic",
  syntax: ["sign(x)"],
  description: "Compute the sign of a value. The sign of a value x is 1 when x>1, -1 when x<0, and 0 when x=0.",
  examples: ["sign(3.5)", "sign(-4.2)", "sign(0)"],
  seealso: ["abs"]
}, HD = {
  name: "sqrt",
  category: "Arithmetic",
  syntax: ["sqrt(x)"],
  description: "Compute the square root value. If x = y * y, then y is the square root of x.",
  examples: ["sqrt(25)", "5 * 5", "sqrt(-1)"],
  seealso: ["square", "sqrtm", "multiply", "nthRoot", "nthRoots", "pow"]
}, GD = {
  name: "sqrtm",
  category: "Arithmetic",
  syntax: ["sqrtm(x)"],
  description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.",
  examples: ["sqrtm([[33, 24], [48, 57]])"],
  seealso: ["sqrt", "abs", "square", "multiply"]
}, VD = {
  name: "sylvester",
  category: "Algebra",
  syntax: ["sylvester(A,B,C)"],
  description: "Solves the real-valued Sylvester equation AX+XB=C for X",
  examples: ["sylvester([[-1, -2], [1, 1]], [[-2, 1], [-1, 2]], [[-3, 2], [3, 0]])", "A = [[-1, -2], [1, 1]]; B = [[2, -1], [1, -2]]; C = [[-3, 2], [3, 0]]", "sylvester(A, B, C)"],
  seealso: ["schur", "lyap"]
}, WD = {
  name: "schur",
  category: "Algebra",
  syntax: ["schur(A)"],
  description: "Performs a real Schur decomposition of the real matrix A = UTU'",
  examples: ["schur([[1, 0], [-4, 3]])", "A = [[1, 0], [-4, 3]]", "schur(A)"],
  seealso: ["lyap", "sylvester"]
}, KD = {
  name: "lyap",
  category: "Algebra",
  syntax: ["lyap(A,Q)"],
  description: "Solves the Continuous-time Lyapunov equation AP+PA'+Q=0 for P",
  examples: ["lyap([[-2, 0], [1, -4]], [[3, 1], [1, 3]])", "A = [[-2, 0], [1, -4]]", "Q = [[3, 1], [1, 3]]", "lyap(A,Q)"],
  seealso: ["schur", "sylvester"]
}, ZD = {
  name: "square",
  category: "Arithmetic",
  syntax: ["square(x)"],
  description: "Compute the square of a value. The square of x is x * x.",
  examples: ["square(3)", "sqrt(9)", "3^2", "3 * 3"],
  seealso: ["multiply", "pow", "sqrt", "cube"]
}, jD = {
  name: "subtract",
  category: "Operators",
  syntax: ["x - y", "subtract(x, y)"],
  description: "subtract two values.",
  examples: ["a = 5.3 - 2", "a + 2", "2/3 - 1/6", "2 * 3 - 3", "2.1 km - 500m"],
  seealso: ["add"]
}, YD = {
  name: "unaryMinus",
  category: "Operators",
  syntax: ["-x", "unaryMinus(x)"],
  description: "Inverse the sign of a value. Converts booleans and strings to numbers.",
  examples: ["-4.5", "-(-5.6)", '-"22"'],
  seealso: ["add", "subtract", "unaryPlus"]
}, XD = {
  name: "unaryPlus",
  category: "Operators",
  syntax: ["+x", "unaryPlus(x)"],
  description: "Converts booleans and strings to numbers.",
  examples: ["+true", '+"2"'],
  seealso: ["add", "subtract", "unaryMinus"]
}, JD = {
  name: "xgcd",
  category: "Arithmetic",
  syntax: ["xgcd(a, b)"],
  description: "Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.",
  examples: ["xgcd(8, 12)", "gcd(8, 12)", "xgcd(36163, 21199)"],
  seealso: ["gcd", "lcm"]
}, QD = {
  name: "bitAnd",
  category: "Bitwise",
  syntax: ["x & y", "bitAnd(x, y)"],
  description: "Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0",
  examples: ["5 & 3", "bitAnd(53, 131)", "[1, 12, 31] & 42"],
  seealso: ["bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
}, eN = {
  name: "bitNot",
  category: "Bitwise",
  syntax: ["~x", "bitNot(x)"],
  description: "Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.",
  examples: ["~1", "~2", "bitNot([2, -3, 4])"],
  seealso: ["bitAnd", "bitOr", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
}, rN = {
  name: "bitOr",
  category: "Bitwise",
  syntax: ["x | y", "bitOr(x, y)"],
  description: "Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.",
  examples: ["5 | 3", "bitOr([1, 2, 3], 4)"],
  seealso: ["bitAnd", "bitNot", "bitXor", "leftShift", "rightArithShift", "rightLogShift"]
}, tN = {
  name: "bitXor",
  category: "Bitwise",
  syntax: ["bitXor(x, y)"],
  description: "Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.",
  examples: ["bitOr(1, 2)", "bitXor([2, 3, 4], 4)"],
  seealso: ["bitAnd", "bitNot", "bitOr", "leftShift", "rightArithShift", "rightLogShift"]
}, nN = {
  name: "leftShift",
  category: "Bitwise",
  syntax: ["x << y", "leftShift(x, y)"],
  description: "Bitwise left logical shift of a value x by y number of bits.",
  examples: ["4 << 1", "8 >> 1"],
  seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "rightArithShift", "rightLogShift"]
}, iN = {
  name: "rightArithShift",
  category: "Bitwise",
  syntax: ["x >> y", "rightArithShift(x, y)"],
  description: "Bitwise right arithmetic shift of a value x by y number of bits.",
  examples: ["8 >> 1", "4 << 1", "-12 >> 2"],
  seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightLogShift"]
}, aN = {
  name: "rightLogShift",
  category: "Bitwise",
  syntax: ["x >>> y", "rightLogShift(x, y)"],
  description: "Bitwise right logical shift of a value x by y number of bits.",
  examples: ["8 >>> 1", "4 << 1", "-12 >>> 2"],
  seealso: ["bitAnd", "bitNot", "bitOr", "bitXor", "leftShift", "rightArithShift"]
}, oN = {
  name: "bellNumbers",
  category: "Combinatorics",
  syntax: ["bellNumbers(n)"],
  description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.",
  examples: ["bellNumbers(3)", "bellNumbers(8)"],
  seealso: ["stirlingS2"]
}, sN = {
  name: "catalan",
  category: "Combinatorics",
  syntax: ["catalan(n)"],
  description: "The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.",
  examples: ["catalan(3)", "catalan(8)"],
  seealso: ["bellNumbers"]
}, uN = {
  name: "composition",
  category: "Combinatorics",
  syntax: ["composition(n, k)"],
  description: "The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.",
  examples: ["composition(5, 3)"],
  seealso: ["combinations"]
}, fN = {
  name: "stirlingS2",
  category: "Combinatorics",
  syntax: ["stirlingS2(n, k)"],
  description: "he Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.",
  examples: ["stirlingS2(5, 3)"],
  seealso: ["bellNumbers"]
}, cN = {
  name: "arg",
  category: "Complex",
  syntax: ["arg(x)"],
  description: "Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).",
  examples: ["arg(2 + 2i)", "atan2(3, 2)", "arg(2 + 3i)"],
  seealso: ["re", "im", "conj", "abs"]
}, lN = {
  name: "conj",
  category: "Complex",
  syntax: ["conj(x)"],
  description: "Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.",
  examples: ["conj(2 + 3i)", "conj(2 - 3i)", "conj(-5.2i)"],
  seealso: ["re", "im", "abs", "arg"]
}, dN = {
  name: "im",
  category: "Complex",
  syntax: ["im(x)"],
  description: "Get the imaginary part of a complex number.",
  examples: ["im(2 + 3i)", "re(2 + 3i)", "im(-5.2i)", "im(2.4)"],
  seealso: ["re", "conj", "abs", "arg"]
}, hN = {
  name: "re",
  category: "Complex",
  syntax: ["re(x)"],
  description: "Get the real part of a complex number.",
  examples: ["re(2 + 3i)", "im(2 + 3i)", "re(-5.2i)", "re(2.4)"],
  seealso: ["im", "conj", "abs", "arg"]
}, pN = {
  name: "evaluate",
  category: "Expression",
  syntax: ["evaluate(expression)", "evaluate(expression, scope)", "evaluate([expr1, expr2, expr3, ...])", "evaluate([expr1, expr2, expr3, ...], scope)"],
  description: "Evaluate an expression or an array with expressions.",
  examples: ['evaluate("2 + 3")', 'evaluate("sqrt(16)")', 'evaluate("2 inch to cm")', 'evaluate("sin(x * pi)", { "x": 1/2 })', 'evaluate(["width=2", "height=4","width*height"])'],
  seealso: []
}, vN = {
  name: "help",
  category: "Expression",
  syntax: ["help(object)", "help(string)"],
  description: "Display documentation on a function or data type.",
  examples: ["help(sqrt)", 'help("complex")'],
  seealso: []
}, mN = {
  name: "distance",
  category: "Geometry",
  syntax: ["distance([x1, y1], [x2, y2])", "distance([[x1, y1], [x2, y2]])"],
  description: "Calculates the Euclidean distance between two points.",
  examples: ["distance([0,0], [4,4])", "distance([[0,0], [4,4]])"],
  seealso: []
}, gN = {
  name: "intersect",
  category: "Geometry",
  syntax: ["intersect(expr1, expr2, expr3, expr4)", "intersect(expr1, expr2, expr3)"],
  description: "Computes the intersection point of lines and/or planes.",
  examples: ["intersect([0, 0], [10, 10], [10, 0], [0, 10])", "intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"],
  seealso: []
}, bN = {
  name: "and",
  category: "Logical",
  syntax: ["x and y", "and(x, y)"],
  description: "Logical and. Test whether two values are both defined with a nonzero/nonempty value.",
  examples: ["true and false", "true and true", "2 and 4"],
  seealso: ["not", "or", "xor"]
}, yN = {
  name: "not",
  category: "Logical",
  syntax: ["not x", "not(x)"],
  description: "Logical not. Flips the boolean value of given argument.",
  examples: ["not true", "not false", "not 2", "not 0"],
  seealso: ["and", "or", "xor"]
}, wN = {
  name: "or",
  category: "Logical",
  syntax: ["x or y", "or(x, y)"],
  description: "Logical or. Test if at least one value is defined with a nonzero/nonempty value.",
  examples: ["true or false", "false or false", "0 or 4"],
  seealso: ["not", "and", "xor"]
}, xN = {
  name: "xor",
  category: "Logical",
  syntax: ["x xor y", "xor(x, y)"],
  description: "Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.",
  examples: ["true xor false", "false xor false", "true xor true", "0 xor 4"],
  seealso: ["not", "and", "or"]
}, EN = {
  name: "column",
  category: "Matrix",
  syntax: ["column(x, index)"],
  description: "Return a column from a matrix or array.",
  examples: ["A = [[1, 2], [3, 4]]", "column(A, 1)", "column(A, 2)"],
  seealso: ["row", "matrixFromColumns"]
}, AN = {
  name: "concat",
  category: "Matrix",
  syntax: ["concat(A, B, C, ...)", "concat(A, B, C, ..., dim)"],
  description: "Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.",
  examples: ["A = [1, 2; 5, 6]", "B = [3, 4; 7, 8]", "concat(A, B)", "concat(A, B, 1)", "concat(A, B, 2)"],
  seealso: ["det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, SN = {
  name: "count",
  category: "Matrix",
  syntax: ["count(x)"],
  description: "Count the number of elements of a matrix, array or string.",
  examples: ["a = [1, 2; 3, 4; 5, 6]", "count(a)", "size(a)", 'count("hello world")'],
  seealso: ["size"]
}, DN = {
  name: "cross",
  category: "Matrix",
  syntax: ["cross(A, B)"],
  description: "Calculate the cross product for two vectors in three dimensional space.",
  examples: ["cross([1, 1, 0],  [0, 1, 1])", "cross([3, -3, 1], [4, 9, 2])", "cross([2, 3, 4],  [5, 6, 7])"],
  seealso: ["multiply", "dot"]
}, NN = {
  name: "ctranspose",
  category: "Matrix",
  syntax: ["x'", "ctranspose(x)"],
  description: "Complex Conjugate and Transpose a matrix",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "ctranspose(a)"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"]
}, MN = {
  name: "det",
  category: "Matrix",
  syntax: ["det(x)"],
  description: "Calculate the determinant of a matrix",
  examples: ["det([1, 2; 3, 4])", "det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"],
  seealso: ["concat", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, _N = {
  name: "diag",
  category: "Matrix",
  syntax: ["diag(x)", "diag(x, k)"],
  description: "Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.",
  examples: ["diag(1:3)", "diag(1:3, 1)", "a = [1, 2, 3; 4, 5, 6; 7, 8, 9]", "diag(a)"],
  seealso: ["concat", "det", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, CN = {
  name: "diff",
  category: "Matrix",
  syntax: ["diff(arr)", "diff(arr, dim)"],
  description: ["Create a new matrix or array with the difference of the passed matrix or array.", "Dim parameter is optional and used to indicant the dimension of the array/matrix to apply the difference", "If no dimension parameter is passed it is assumed as dimension 0", "Dimension is zero-based in javascript and one-based in the parser", "Arrays must be 'rectangular' meaning arrays like [1, 2]", "If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays"],
  examples: ["A = [1, 2, 4, 7, 0]", "diff(A)", "diff(A, 1)", "B = [[1, 2], [3, 4]]", "diff(B)", "diff(B, 1)", "diff(B, 2)", "diff(B, bignumber(2))", "diff([[1, 2], matrix([3, 4])], 2)"],
  seealso: ["subtract", "partitionSelect"]
}, TN = {
  name: "dot",
  category: "Matrix",
  syntax: ["dot(A, B)", "A * B"],
  description: "Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn",
  examples: ["dot([2, 4, 1], [2, 2, 3])", "[2, 4, 1] * [2, 2, 3]"],
  seealso: ["multiply", "cross"]
}, BN = {
  name: "eigs",
  category: "Matrix",
  syntax: ["eigs(x)"],
  description: "Calculate the eigenvalues and optionally eigenvectors of a square matrix",
  examples: ["eigs([[5, 2.3], [2.3, 1]])", "eigs([[1, 2, 3], [4, 5, 6], [7, 8, 9]], { precision: 1e-6, eigenvectors: false })"],
  seealso: ["inv"]
}, FN = {
  name: "filter",
  category: "Matrix",
  syntax: ["filter(x, test)"],
  description: "Filter items in a matrix.",
  examples: ["isPositive(x) = x > 0", "filter([6, -2, -1, 4, 3], isPositive)", "filter([6, -2, 0, 1, 0], x != 0)"],
  seealso: ["sort", "map", "forEach"]
}, IN = {
  name: "flatten",
  category: "Matrix",
  syntax: ["flatten(x)"],
  description: "Flatten a multi dimensional matrix into a single dimensional matrix.",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "size(a)", "b = flatten(a)", "size(b)"],
  seealso: ["concat", "resize", "size", "squeeze"]
}, ON = {
  name: "forEach",
  category: "Matrix",
  syntax: ["forEach(x, callback)"],
  description: "Iterates over all elements of a matrix/array, and executes the given callback function.",
  examples: ["numberOfPets = {}", "addPet(n) = numberOfPets[n] = (numberOfPets[n] ? numberOfPets[n]:0 ) + 1;", 'forEach(["Dog","Cat","Cat"], addPet)', "numberOfPets"],
  seealso: ["map", "sort", "filter"]
}, RN = {
  name: "getMatrixDataType",
  category: "Matrix",
  syntax: ["getMatrixDataType(x)"],
  description: 'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".',
  examples: ["getMatrixDataType([1, 2, 3])", "getMatrixDataType([[5 cm], [2 inch]])", 'getMatrixDataType([1, "text"])', "getMatrixDataType([1, bignumber(4)])"],
  seealso: ["matrix", "sparse", "typeOf"]
}, PN = {
  name: "identity",
  category: "Matrix",
  syntax: ["identity(n)", "identity(m, n)", "identity([m, n])"],
  description: "Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.",
  examples: ["identity(3)", "identity(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "identity(size(a))"],
  seealso: ["concat", "det", "diag", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, qN = {
  name: "inv",
  category: "Matrix",
  syntax: ["inv(x)"],
  description: "Calculate the inverse of a matrix",
  examples: ["inv([1, 2; 3, 4])", "inv(4)", "1 / 4"],
  seealso: ["concat", "det", "diag", "identity", "ones", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, $N = {
  name: "pinv",
  category: "Matrix",
  syntax: ["pinv(x)"],
  description: "Calculate the Moore–Penrose inverse of a matrix",
  examples: ["pinv([1, 2; 3, 4])", "pinv([[1, 0], [0, 1], [0, 1]])", "pinv(4)"],
  seealso: ["inv"]
}, zN = {
  name: "kron",
  category: "Matrix",
  syntax: ["kron(x, y)"],
  description: "Calculates the kronecker product of 2 matrices or vectors.",
  examples: ["kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])", "kron([1,1], [2,3,4])"],
  seealso: ["multiply", "dot", "cross"]
}, LN = {
  name: "map",
  category: "Matrix",
  syntax: ["map(x, callback)"],
  description: "Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array.",
  examples: ["map([1, 2, 3], square)"],
  seealso: ["filter", "forEach"]
}, UN = {
  name: "matrixFromColumns",
  category: "Matrix",
  syntax: ["matrixFromColumns(...arr)", "matrixFromColumns(row1, row2)", "matrixFromColumns(row1, row2, row3)"],
  description: "Create a dense matrix from vectors as individual columns.",
  examples: ["matrixFromColumns([1, 2, 3], [[4],[5],[6]])"],
  seealso: ["matrix", "matrixFromRows", "matrixFromFunction", "zeros"]
}, kN = {
  name: "matrixFromFunction",
  category: "Matrix",
  syntax: ["matrixFromFunction(size, fn)", "matrixFromFunction(size, fn, format)", "matrixFromFunction(size, fn, format, datatype)", "matrixFromFunction(size, format, fn)", "matrixFromFunction(size, format, datatype, fn)"],
  description: "Create a matrix by evaluating a generating function at each index.",
  examples: ["f(I) = I[1] - I[2]", "matrixFromFunction([3,3], f)", "g(I) = I[1] - I[2] == 1 ? 4 : 0", 'matrixFromFunction([100, 100], "sparse", g)', "matrixFromFunction([5], random)"],
  seealso: ["matrix", "matrixFromRows", "matrixFromColumns", "zeros"]
}, HN = {
  name: "matrixFromRows",
  category: "Matrix",
  syntax: ["matrixFromRows(...arr)", "matrixFromRows(row1, row2)", "matrixFromRows(row1, row2, row3)"],
  description: "Create a dense matrix from vectors as individual rows.",
  examples: ["matrixFromRows([1, 2, 3], [[4],[5],[6]])"],
  seealso: ["matrix", "matrixFromColumns", "matrixFromFunction", "zeros"]
}, GN = {
  name: "ones",
  category: "Matrix",
  syntax: ["ones(m)", "ones(m, n)", "ones(m, n, p, ...)", "ones([m])", "ones([m, n])", "ones([m, n, p, ...])"],
  description: "Create a matrix containing ones.",
  examples: ["ones(3)", "ones(3, 5)", "ones([2,3]) * 4.5", "a = [1, 2, 3; 4, 5, 6]", "ones(size(a))"],
  seealso: ["concat", "det", "diag", "identity", "inv", "range", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, VN = {
  name: "partitionSelect",
  category: "Matrix",
  syntax: ["partitionSelect(x, k)", "partitionSelect(x, k, compare)"],
  description: "Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.",
  examples: ["partitionSelect([5, 10, 1], 2)", 'partitionSelect(["C", "B", "A", "D"], 1, compareText)', "arr = [5, 2, 1]", "partitionSelect(arr, 0) # returns 1, arr is now: [1, 2, 5]", "arr", "partitionSelect(arr, 1, 'desc') # returns 2, arr is now: [5, 2, 1]", "arr"],
  seealso: ["sort"]
}, WN = {
  name: "range",
  category: "Type",
  syntax: ["start:end", "start:step:end", "range(start, end)", "range(start, end, step)", "range(string)"],
  description: "Create a range. Lower bound of the range is included, upper bound is excluded.",
  examples: ["1:5", "3:-1:-3", "range(3, 7)", "range(0, 12, 2)", 'range("4:10")', "range(1m, 1m, 3m)", "a = [1, 2, 3, 4; 5, 6, 7, 8]", "a[1:2, 1:2]"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "size", "squeeze", "subset", "trace", "transpose", "zeros"]
}, KN = {
  name: "reshape",
  category: "Matrix",
  syntax: ["reshape(x, sizes)"],
  description: "Reshape a multi dimensional array to fit the specified dimensions.",
  examples: ["reshape([1, 2, 3, 4, 5, 6], [2, 3])", "reshape([[1, 2], [3, 4]], [1, 4])", "reshape([[1, 2], [3, 4]], [4])", "reshape([1, 2, 3, 4], [-1, 2])"],
  seealso: ["size", "squeeze", "resize"]
}, ZN = {
  name: "resize",
  category: "Matrix",
  syntax: ["resize(x, size)", "resize(x, size, defaultValue)"],
  description: "Resize a matrix.",
  examples: ["resize([1,2,3,4,5], [3])", "resize([1,2,3], [5])", "resize([1,2,3], [5], -1)", "resize(2, [2, 3])", 'resize("hello", [8], "!")'],
  seealso: ["size", "subset", "squeeze", "reshape"]
}, jN = {
  name: "rotate",
  category: "Matrix",
  syntax: ["rotate(w, theta)", "rotate(w, theta, v)"],
  description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
  examples: ["rotate([1, 0], pi / 2)", 'rotate(matrix([1, 0]), unit("35deg"))', 'rotate([1, 0, 0], unit("90deg"), [0, 0, 1])', 'rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))'],
  seealso: ["matrix", "rotationMatrix"]
}, YN = {
  name: "rotationMatrix",
  category: "Matrix",
  syntax: ["rotationMatrix(theta)", "rotationMatrix(theta, v)", "rotationMatrix(theta, v, format)"],
  description: "Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",
  examples: ["rotationMatrix(pi / 2)", 'rotationMatrix(unit("45deg"), [0, 0, 1])', 'rotationMatrix(1, matrix([0, 0, 1]), "sparse")'],
  seealso: ["cos", "sin"]
}, XN = {
  name: "row",
  category: "Matrix",
  syntax: ["row(x, index)"],
  description: "Return a row from a matrix or array.",
  examples: ["A = [[1, 2], [3, 4]]", "row(A, 1)", "row(A, 2)"],
  seealso: ["column", "matrixFromRows"]
}, JN = {
  name: "size",
  category: "Matrix",
  syntax: ["size(x)"],
  description: "Calculate the size of a matrix.",
  examples: ["size(2.3)", 'size("hello world")', "a = [1, 2; 3, 4; 5, 6]", "size(a)", "size(1:6)"],
  seealso: ["concat", "count", "det", "diag", "identity", "inv", "ones", "range", "squeeze", "subset", "trace", "transpose", "zeros"]
}, QN = {
  name: "sort",
  category: "Matrix",
  syntax: ["sort(x)", "sort(x, compare)"],
  description: 'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.',
  examples: ["sort([5, 10, 1])", 'sort(["C", "B", "A", "D"], "natural")', "sortByLength(a, b) = size(a)[1] - size(b)[1]", 'sort(["Langdon", "Tom", "Sara"], sortByLength)', 'sort(["10", "1", "2"], "natural")'],
  seealso: ["map", "filter", "forEach"]
}, eM = {
  name: "squeeze",
  category: "Matrix",
  syntax: ["squeeze(x)"],
  description: "Remove inner and outer singleton dimensions from a matrix.",
  examples: ["a = zeros(3,2,1)", "size(squeeze(a))", "b = zeros(1,1,3)", "size(squeeze(b))"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "subset", "trace", "transpose", "zeros"]
}, rM = {
  name: "subset",
  category: "Matrix",
  syntax: ["value(index)", "value(index) = replacement", "subset(value, [index])", "subset(value, [index], replacement)"],
  description: "Get or set a subset of the entries of a matrix or characters of a string. Indexes are one-based. There should be one index specification for each dimension of the target. Each specification can be a single index, a list of indices, or a range in colon notation `l:u`. In a range, both the lower bound l and upper bound u are included; and if a bound is omitted it defaults to the most extreme valid value. The cartesian product of the indices specified in each dimension determines the target of the operation.",
  examples: ["d = [1, 2; 3, 4]", "e = []", "e[1, 1:2] = [5, 6]", "e[2, :] = [7, 8]", "f = d * e", "f[2, 1]", "f[:, 1]", "f[[1,2], [1,3]] = [9, 10; 11, 12]", "f"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "trace", "transpose", "zeros"]
}, tM = {
  name: "trace",
  category: "Matrix",
  syntax: ["trace(A)"],
  description: "Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.",
  examples: ["A = [1, 2, 3; -1, 2, 3; 2, 0, 3]", "trace(A)"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "transpose", "zeros"]
}, nM = {
  name: "transpose",
  category: "Matrix",
  syntax: ["x'", "transpose(x)"],
  description: "Transpose a matrix",
  examples: ["a = [1, 2, 3; 4, 5, 6]", "a'", "transpose(a)"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "zeros"]
}, iM = {
  name: "zeros",
  category: "Matrix",
  syntax: ["zeros(m)", "zeros(m, n)", "zeros(m, n, p, ...)", "zeros([m])", "zeros([m, n])", "zeros([m, n, p, ...])"],
  description: "Create a matrix containing zeros.",
  examples: ["zeros(3)", "zeros(3, 5)", "a = [1, 2, 3; 4, 5, 6]", "zeros(size(a))"],
  seealso: ["concat", "det", "diag", "identity", "inv", "ones", "range", "size", "squeeze", "subset", "trace", "transpose"]
}, aM = {
  name: "fft",
  category: "Matrix",
  syntax: ["fft(x)"],
  description: "Calculate N-dimensional fourier transform",
  examples: ["fft([[1, 0], [1, 0]])"],
  seealso: ["ifft"]
}, oM = {
  name: "ifft",
  category: "Matrix",
  syntax: ["ifft(x)"],
  description: "Calculate N-dimensional inverse fourier transform",
  examples: ["ifft([[2, 2], [0, 0]])"],
  seealso: ["fft"]
}, sM = {
  name: "combinations",
  category: "Probability",
  syntax: ["combinations(n, k)"],
  description: "Compute the number of combinations of n items taken k at a time",
  examples: ["combinations(7, 5)"],
  seealso: ["combinationsWithRep", "permutations", "factorial"]
}, uM = {
  name: "combinationsWithRep",
  category: "Probability",
  syntax: ["combinationsWithRep(n, k)"],
  description: "Compute the number of combinations of n items taken k at a time with replacements.",
  examples: ["combinationsWithRep(7, 5)"],
  seealso: ["combinations", "permutations", "factorial"]
}, fM = {
  name: "factorial",
  category: "Probability",
  syntax: ["n!", "factorial(n)"],
  description: "Compute the factorial of a value",
  examples: ["5!", "5 * 4 * 3 * 2 * 1", "3!"],
  seealso: ["combinations", "combinationsWithRep", "permutations", "gamma"]
}, cM = {
  name: "gamma",
  category: "Probability",
  syntax: ["gamma(n)"],
  description: "Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.",
  examples: ["gamma(4)", "3!", "gamma(1/2)", "sqrt(pi)"],
  seealso: ["factorial"]
}, lM = {
  name: "lgamma",
  category: "Probability",
  syntax: ["lgamma(n)"],
  description: "Logarithm of the gamma function for real, positive numbers and complex numbers, using Lanczos approximation for numbers and Stirling series for complex numbers.",
  examples: ["lgamma(4)", "lgamma(1/2)", "lgamma(i)", "lgamma(complex(1.1, 2))"],
  seealso: ["gamma"]
}, dM = {
  name: "kldivergence",
  category: "Probability",
  syntax: ["kldivergence(x, y)"],
  description: "Calculate the Kullback-Leibler (KL) divergence  between two distributions.",
  examples: ["kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"],
  seealso: []
}, hM = {
  name: "multinomial",
  category: "Probability",
  syntax: ["multinomial(A)"],
  description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.",
  examples: ["multinomial([1, 2, 1])"],
  seealso: ["combinations", "factorial"]
}, pM = {
  name: "permutations",
  category: "Probability",
  syntax: ["permutations(n)", "permutations(n, k)"],
  description: "Compute the number of permutations of n items taken k at a time",
  examples: ["permutations(5)", "permutations(5, 3)"],
  seealso: ["combinations", "combinationsWithRep", "factorial"]
}, vM = {
  name: "pickRandom",
  category: "Probability",
  syntax: ["pickRandom(array)", "pickRandom(array, number)", "pickRandom(array, weights)", "pickRandom(array, number, weights)", "pickRandom(array, weights, number)"],
  description: "Pick a random entry from a given array.",
  examples: ["pickRandom(0:10)", "pickRandom([1, 3, 1, 6])", "pickRandom([1, 3, 1, 6], 2)", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])", "pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"],
  seealso: ["random", "randomInt"]
}, mM = {
  name: "random",
  category: "Probability",
  syntax: ["random()", "random(max)", "random(min, max)", "random(size)", "random(size, max)", "random(size, min, max)"],
  description: "Return a random number.",
  examples: ["random()", "random(10, 20)", "random([2, 3])"],
  seealso: ["pickRandom", "randomInt"]
}, gM = {
  name: "randomInt",
  category: "Probability",
  syntax: ["randomInt(max)", "randomInt(min, max)", "randomInt(size)", "randomInt(size, max)", "randomInt(size, min, max)"],
  description: "Return a random integer number",
  examples: ["randomInt(10, 20)", "randomInt([2, 3], 10)"],
  seealso: ["pickRandom", "random"]
}, bM = {
  name: "compare",
  category: "Relational",
  syntax: ["compare(x, y)"],
  description: "Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
  examples: ["compare(2, 3)", "compare(3, 2)", "compare(2, 2)", "compare(5cm, 40mm)", "compare(2, [1, 2, 3])"],
  seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compareNatural", "compareText"]
}, yM = {
  name: "compareNatural",
  category: "Relational",
  syntax: ["compareNatural(x, y)"],
  description: "Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
  examples: ["compareNatural(2, 3)", "compareNatural(3, 2)", "compareNatural(2, 2)", "compareNatural(5cm, 40mm)", 'compareNatural("2", "10")', "compareNatural(2 + 3i, 2 + 4i)", "compareNatural([1, 2, 4], [1, 2, 3])", "compareNatural([1, 5], [1, 2, 3])", "compareNatural([1, 2], [1, 2])", "compareNatural({a: 2}, {a: 4})"],
  seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare", "compareText"]
}, wM = {
  name: "compareText",
  category: "Relational",
  syntax: ["compareText(x, y)"],
  description: "Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",
  examples: ['compareText("B", "A")', 'compareText("A", "B")', 'compareText("A", "A")', 'compareText("2", "10")', 'compare("2", "10")', "compare(2, 10)", 'compareNatural("2", "10")', 'compareText("B", ["A", "B", "C"])'],
  seealso: ["compare", "compareNatural"]
}, xM = {
  name: "deepEqual",
  category: "Relational",
  syntax: ["deepEqual(x, y)"],
  description: "Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.",
  examples: ["deepEqual([1,3,4], [1,3,4])", "deepEqual([1,3,4], [1,3])"],
  seealso: ["equal", "unequal", "smaller", "larger", "smallerEq", "largerEq", "compare"]
}, EM = {
  name: "equal",
  category: "Relational",
  syntax: ["x == y", "equal(x, y)"],
  description: "Check equality of two values. Returns true if the values are equal, and false if not.",
  examples: ["2+2 == 3", "2+2 == 4", "a = 3.2", "b = 6-2.8", "a == b", "50cm == 0.5m"],
  seealso: ["unequal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual", "equalText"]
}, AM = {
  name: "equalText",
  category: "Relational",
  syntax: ["equalText(x, y)"],
  description: "Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.",
  examples: ['equalText("Hello", "Hello")', 'equalText("a", "A")', 'equal("2e3", "2000")', 'equalText("2e3", "2000")', 'equalText("B", ["A", "B", "C"])'],
  seealso: ["compare", "compareNatural", "compareText", "equal"]
}, SM = {
  name: "larger",
  category: "Relational",
  syntax: ["x > y", "larger(x, y)"],
  description: "Check if value x is larger than y. Returns true if x is larger than y, and false if not.",
  examples: ["2 > 3", "5 > 2*2", "a = 3.3", "b = 6-2.8", "(a > b)", "(b < a)", "5 cm > 2 inch"],
  seealso: ["equal", "unequal", "smaller", "smallerEq", "largerEq", "compare"]
}, DM = {
  name: "largerEq",
  category: "Relational",
  syntax: ["x >= y", "largerEq(x, y)"],
  description: "Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.",
  examples: ["2 >= 1+1", "2 > 1+1", "a = 3.2", "b = 6-2.8", "(a >= b)"],
  seealso: ["equal", "unequal", "smallerEq", "smaller", "compare"]
}, NM = {
  name: "smaller",
  category: "Relational",
  syntax: ["x < y", "smaller(x, y)"],
  description: "Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not.",
  examples: ["2 < 3", "5 < 2*2", "a = 3.3", "b = 6-2.8", "(a < b)", "5 cm < 2 inch"],
  seealso: ["equal", "unequal", "larger", "smallerEq", "largerEq", "compare"]
}, MM = {
  name: "smallerEq",
  category: "Relational",
  syntax: ["x <= y", "smallerEq(x, y)"],
  description: "Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.",
  examples: ["2 <= 1+1", "2 < 1+1", "a = 3.2", "b = 6-2.8", "(a <= b)"],
  seealso: ["equal", "unequal", "larger", "smaller", "largerEq", "compare"]
}, _M = {
  name: "unequal",
  category: "Relational",
  syntax: ["x != y", "unequal(x, y)"],
  description: "Check unequality of two values. Returns true if the values are unequal, and false if they are equal.",
  examples: ["2+2 != 3", "2+2 != 4", "a = 3.2", "b = 6-2.8", "a != b", "50cm != 0.5m", "5 cm != 2 inch"],
  seealso: ["equal", "smaller", "larger", "smallerEq", "largerEq", "compare", "deepEqual"]
}, CM = {
  name: "setCartesian",
  category: "Set",
  syntax: ["setCartesian(set1, set2)"],
  description: "Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays and the values will be sorted in ascending order before the operation.",
  examples: ["setCartesian([1, 2], [3, 4])"],
  seealso: ["setUnion", "setIntersect", "setDifference", "setPowerset"]
}, TM = {
  name: "setDifference",
  category: "Set",
  syntax: ["setDifference(set1, set2)"],
  description: "Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setUnion", "setIntersect", "setSymDifference"]
}, BM = {
  name: "setDistinct",
  category: "Set",
  syntax: ["setDistinct(set)"],
  description: "Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
  examples: ["setDistinct([1, 1, 1, 2, 2, 3])"],
  seealso: ["setMultiplicity"]
}, FM = {
  name: "setIntersect",
  category: "Set",
  syntax: ["setIntersect(set1, set2)"],
  description: "Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setIntersect([1, 2, 3, 4], [3, 4, 5, 6])", "setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setUnion", "setDifference"]
}, IM = {
  name: "setIsSubset",
  category: "Set",
  syntax: ["setIsSubset(set1, set2)"],
  description: "Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setIsSubset([1, 2], [3, 4, 5, 6])", "setIsSubset([3, 4], [3, 4, 5, 6])"],
  seealso: ["setUnion", "setIntersect", "setDifference"]
}, OM = {
  name: "setMultiplicity",
  category: "Set",
  syntax: ["setMultiplicity(element, set)"],
  description: "Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",
  examples: ["setMultiplicity(1, [1, 2, 2, 4])", "setMultiplicity(2, [1, 2, 2, 4])"],
  seealso: ["setDistinct", "setSize"]
}, RM = {
  name: "setPowerset",
  category: "Set",
  syntax: ["setPowerset(set)"],
  description: "Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.",
  examples: ["setPowerset([1, 2, 3])"],
  seealso: ["setCartesian"]
}, PM = {
  name: "setSize",
  category: "Set",
  syntax: ["setSize(set)", "setSize(set, unique)"],
  description: 'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.',
  examples: ["setSize([1, 2, 2, 4])", "setSize([1, 2, 2, 4], true)"],
  seealso: ["setUnion", "setIntersect", "setDifference"]
}, qM = {
  name: "setSymDifference",
  category: "Set",
  syntax: ["setSymDifference(set1, set2)"],
  description: "Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])", "setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setUnion", "setIntersect", "setDifference"]
}, $M = {
  name: "setUnion",
  category: "Set",
  syntax: ["setUnion(set1, set2)"],
  description: "Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",
  examples: ["setUnion([1, 2, 3, 4], [3, 4, 5, 6])", "setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],
  seealso: ["setIntersect", "setDifference"]
}, zM = {
  name: "zpk2tf",
  category: "Signal",
  syntax: ["zpk2tf(z, p, k)"],
  description: "Compute the transfer function of a zero-pole-gain model.",
  examples: ["zpk2tf([1, 2], [-1, -2], 1)", "zpk2tf([1, 2], [-1, -2])", "zpk2tf([1 - 3i, 2 + 2i], [-1, -2])"],
  seealso: []
}, LM = {
  name: "freqz",
  category: "Signal",
  syntax: ["freqz(b, a)", "freqz(b, a, w)"],
  description: "Calculates the frequency response of a filter given its numerator and denominator coefficients.",
  examples: ["freqz([1, 2], [1, 2, 3])", "freqz([1, 2], [1, 2, 3], [0, 1])", "freqz([1, 2], [1, 2, 3], 512)"],
  seealso: []
}, UM = {
  name: "erf",
  category: "Special",
  syntax: ["erf(x)"],
  description: "Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x",
  examples: ["erf(0.2)", "erf(-0.5)", "erf(4)"],
  seealso: []
}, kM = {
  name: "zeta",
  category: "Special",
  syntax: ["zeta(s)"],
  description: "Compute the Riemann Zeta Function using an infinite series and Riemanns Functional Equation for the entire complex plane",
  examples: ["zeta(0.2)", "zeta(-0.5)", "zeta(4)"],
  seealso: []
}, HM = {
  name: "mad",
  category: "Statistics",
  syntax: ["mad(a, b, c, ...)", "mad(A)"],
  description: "Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.",
  examples: ["mad(10, 20, 30)", "mad([1, 2, 3])"],
  seealso: ["mean", "median", "std", "abs"]
}, GM = {
  name: "max",
  category: "Statistics",
  syntax: ["max(a, b, c, ...)", "max(A)", "max(A, dimension)"],
  description: "Compute the maximum value of a list of values.",
  examples: ["max(2, 3, 4, 1)", "max([2, 3, 4, 1])", "max([2, 5; 4, 3])", "max([2, 5; 4, 3], 1)", "max([2, 5; 4, 3], 2)", "max(2.7, 7.1, -4.5, 2.0, 4.1)", "min(2.7, 7.1, -4.5, 2.0, 4.1)"],
  seealso: ["mean", "median", "min", "prod", "std", "sum", "variance"]
}, VM = {
  name: "mean",
  category: "Statistics",
  syntax: ["mean(a, b, c, ...)", "mean(A)", "mean(A, dimension)"],
  description: "Compute the arithmetic mean of a list of values.",
  examples: ["mean(2, 3, 4, 1)", "mean([2, 3, 4, 1])", "mean([2, 5; 4, 3])", "mean([2, 5; 4, 3], 1)", "mean([2, 5; 4, 3], 2)", "mean([1.0, 2.7, 3.2, 4.0])"],
  seealso: ["max", "median", "min", "prod", "std", "sum", "variance"]
}, WM = {
  name: "median",
  category: "Statistics",
  syntax: ["median(a, b, c, ...)", "median(A)"],
  description: "Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.",
  examples: ["median(5, 2, 7)", "median([3, -1, 5, 7])"],
  seealso: ["max", "mean", "min", "prod", "std", "sum", "variance", "quantileSeq"]
}, KM = {
  name: "min",
  category: "Statistics",
  syntax: ["min(a, b, c, ...)", "min(A)", "min(A, dimension)"],
  description: "Compute the minimum value of a list of values.",
  examples: ["min(2, 3, 4, 1)", "min([2, 3, 4, 1])", "min([2, 5; 4, 3])", "min([2, 5; 4, 3], 1)", "min([2, 5; 4, 3], 2)", "min(2.7, 7.1, -4.5, 2.0, 4.1)", "max(2.7, 7.1, -4.5, 2.0, 4.1)"],
  seealso: ["max", "mean", "median", "prod", "std", "sum", "variance"]
}, ZM = {
  name: "mode",
  category: "Statistics",
  syntax: ["mode(a, b, c, ...)", "mode(A)", "mode(A, a, b, B, c, ...)"],
  description: "Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.",
  examples: ["mode(2, 1, 4, 3, 1)", "mode([1, 2.7, 3.2, 4, 2.7])", "mode(1, 4, 6, 1, 6)"],
  seealso: ["max", "mean", "min", "median", "prod", "std", "sum", "variance"]
}, jM = {
  name: "prod",
  category: "Statistics",
  syntax: ["prod(a, b, c, ...)", "prod(A)"],
  description: "Compute the product of all values.",
  examples: ["prod(2, 3, 4)", "prod([2, 3, 4])", "prod([2, 5; 4, 3])"],
  seealso: ["max", "mean", "min", "median", "min", "std", "sum", "variance"]
}, YM = {
  name: "quantileSeq",
  category: "Statistics",
  syntax: ["quantileSeq(A, prob[, sorted])", "quantileSeq(A, [prob1, prob2, ...][, sorted])", "quantileSeq(A, N[, sorted])"],
  description: `Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probablity are: Number, BigNumber. 

In case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.`,
  examples: ["quantileSeq([3, -1, 5, 7], 0.5)", "quantileSeq([3, -1, 5, 7], [1/3, 2/3])", "quantileSeq([3, -1, 5, 7], 2)", "quantileSeq([-1, 3, 5, 7], 0.5, true)"],
  seealso: ["mean", "median", "min", "max", "prod", "std", "sum", "variance"]
}, XM = {
  name: "std",
  category: "Statistics",
  syntax: ["std(a, b, c, ...)", "std(A)", "std(A, dimension)", "std(A, normalization)", "std(A, dimension, normalization)"],
  description: 'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
  examples: ["std(2, 4, 6)", "std([2, 4, 6, 8])", 'std([2, 4, 6, 8], "uncorrected")', 'std([2, 4, 6, 8], "biased")', "std([1, 2, 3; 4, 5, 6])"],
  seealso: ["max", "mean", "min", "median", "prod", "sum", "variance"]
}, JM = {
  name: "cumsum",
  category: "Statistics",
  syntax: ["cumsum(a, b, c, ...)", "cumsum(A)"],
  description: "Compute the cumulative sum of all values.",
  examples: ["cumsum(2, 3, 4, 1)", "cumsum([2, 3, 4, 1])", "cumsum([1, 2; 3, 4])", "cumsum([1, 2; 3, 4], 1)", "cumsum([1, 2; 3, 4], 2)"],
  seealso: ["max", "mean", "median", "min", "prod", "std", "sum", "variance"]
}, QM = {
  name: "sum",
  category: "Statistics",
  syntax: ["sum(a, b, c, ...)", "sum(A)", "sum(A, dimension)"],
  description: "Compute the sum of all values.",
  examples: ["sum(2, 3, 4, 1)", "sum([2, 3, 4, 1])", "sum([2, 5; 4, 3])"],
  seealso: ["max", "mean", "median", "min", "prod", "std", "sum", "variance"]
}, e_ = {
  name: "variance",
  category: "Statistics",
  syntax: ["variance(a, b, c, ...)", "variance(A)", "variance(A, dimension)", "variance(A, normalization)", "variance(A, dimension, normalization)"],
  description: 'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".',
  examples: ["variance(2, 4, 6)", "variance([2, 4, 6, 8])", 'variance([2, 4, 6, 8], "uncorrected")', 'variance([2, 4, 6, 8], "biased")', "variance([1, 2, 3; 4, 5, 6])"],
  seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"]
}, r_ = {
  name: "corr",
  category: "Statistics",
  syntax: ["corr(A,B)"],
  description: "Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.",
  examples: ["corr([2, 4, 6, 8],[1, 2, 3, 6])", "corr(matrix([[1, 2.2, 3, 4.8, 5], [1, 2, 3, 4, 5]]), matrix([[4, 5.3, 6.6, 7, 8], [1, 2, 3, 4, 5]]))"],
  seealso: ["max", "mean", "min", "median", "min", "prod", "std", "sum"]
}, t_ = {
  name: "acos",
  category: "Trigonometry",
  syntax: ["acos(x)"],
  description: "Compute the inverse cosine of a value in radians.",
  examples: ["acos(0.5)", "acos(cos(2.3))"],
  seealso: ["cos", "atan", "asin"]
}, n_ = {
  name: "acosh",
  category: "Trigonometry",
  syntax: ["acosh(x)"],
  description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.",
  examples: ["acosh(1.5)"],
  seealso: ["cosh", "asinh", "atanh"]
}, i_ = {
  name: "acot",
  category: "Trigonometry",
  syntax: ["acot(x)"],
  description: "Calculate the inverse cotangent of a value.",
  examples: ["acot(0.5)", "acot(cot(0.5))", "acot(2)"],
  seealso: ["cot", "atan"]
}, a_ = {
  name: "acoth",
  category: "Trigonometry",
  syntax: ["acoth(x)"],
  description: "Calculate the hyperbolic arccotangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.",
  examples: ["acoth(2)", "acoth(0.5)"],
  seealso: ["acsch", "asech"]
}, o_ = {
  name: "acsc",
  category: "Trigonometry",
  syntax: ["acsc(x)"],
  description: "Calculate the inverse cotangent of a value.",
  examples: ["acsc(2)", "acsc(csc(0.5))", "acsc(0.5)"],
  seealso: ["csc", "asin", "asec"]
}, s_ = {
  name: "acsch",
  category: "Trigonometry",
  syntax: ["acsch(x)"],
  description: "Calculate the hyperbolic arccosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.",
  examples: ["acsch(0.5)"],
  seealso: ["asech", "acoth"]
}, u_ = {
  name: "asec",
  category: "Trigonometry",
  syntax: ["asec(x)"],
  description: "Calculate the inverse secant of a value.",
  examples: ["asec(0.5)", "asec(sec(0.5))", "asec(2)"],
  seealso: ["acos", "acot", "acsc"]
}, f_ = {
  name: "asech",
  category: "Trigonometry",
  syntax: ["asech(x)"],
  description: "Calculate the inverse secant of a value.",
  examples: ["asech(0.5)"],
  seealso: ["acsch", "acoth"]
}, c_ = {
  name: "asin",
  category: "Trigonometry",
  syntax: ["asin(x)"],
  description: "Compute the inverse sine of a value in radians.",
  examples: ["asin(0.5)", "asin(sin(0.5))"],
  seealso: ["sin", "acos", "atan"]
}, l_ = {
  name: "asinh",
  category: "Trigonometry",
  syntax: ["asinh(x)"],
  description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.",
  examples: ["asinh(0.5)"],
  seealso: ["acosh", "atanh"]
}, d_ = {
  name: "atan",
  category: "Trigonometry",
  syntax: ["atan(x)"],
  description: "Compute the inverse tangent of a value in radians.",
  examples: ["atan(0.5)", "atan(tan(0.5))"],
  seealso: ["tan", "acos", "asin"]
}, h_ = {
  name: "atan2",
  category: "Trigonometry",
  syntax: ["atan2(y, x)"],
  description: "Computes the principal value of the arc tangent of y/x in radians.",
  examples: ["atan2(2, 2) / pi", "angle = 60 deg in rad", "x = cos(angle)", "y = sin(angle)", "atan2(y, x)"],
  seealso: ["sin", "cos", "tan"]
}, p_ = {
  name: "atanh",
  category: "Trigonometry",
  syntax: ["atanh(x)"],
  description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.",
  examples: ["atanh(0.5)"],
  seealso: ["acosh", "asinh"]
}, v_ = {
  name: "cos",
  category: "Trigonometry",
  syntax: ["cos(x)"],
  description: "Compute the cosine of x in radians.",
  examples: ["cos(2)", "cos(pi / 4) ^ 2", "cos(180 deg)", "cos(60 deg)", "sin(0.2)^2 + cos(0.2)^2"],
  seealso: ["acos", "sin", "tan"]
}, m_ = {
  name: "cosh",
  category: "Trigonometry",
  syntax: ["cosh(x)"],
  description: "Compute the hyperbolic cosine of x in radians.",
  examples: ["cosh(0.5)"],
  seealso: ["sinh", "tanh", "coth"]
}, g_ = {
  name: "cot",
  category: "Trigonometry",
  syntax: ["cot(x)"],
  description: "Compute the cotangent of x in radians. Defined as 1/tan(x)",
  examples: ["cot(2)", "1 / tan(2)"],
  seealso: ["sec", "csc", "tan"]
}, b_ = {
  name: "coth",
  category: "Trigonometry",
  syntax: ["coth(x)"],
  description: "Compute the hyperbolic cotangent of x in radians.",
  examples: ["coth(2)", "1 / tanh(2)"],
  seealso: ["sech", "csch", "tanh"]
}, y_ = {
  name: "csc",
  category: "Trigonometry",
  syntax: ["csc(x)"],
  description: "Compute the cosecant of x in radians. Defined as 1/sin(x)",
  examples: ["csc(2)", "1 / sin(2)"],
  seealso: ["sec", "cot", "sin"]
}, w_ = {
  name: "csch",
  category: "Trigonometry",
  syntax: ["csch(x)"],
  description: "Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)",
  examples: ["csch(2)", "1 / sinh(2)"],
  seealso: ["sech", "coth", "sinh"]
}, x_ = {
  name: "sec",
  category: "Trigonometry",
  syntax: ["sec(x)"],
  description: "Compute the secant of x in radians. Defined as 1/cos(x)",
  examples: ["sec(2)", "1 / cos(2)"],
  seealso: ["cot", "csc", "cos"]
}, E_ = {
  name: "sech",
  category: "Trigonometry",
  syntax: ["sech(x)"],
  description: "Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)",
  examples: ["sech(2)", "1 / cosh(2)"],
  seealso: ["coth", "csch", "cosh"]
}, A_ = {
  name: "sin",
  category: "Trigonometry",
  syntax: ["sin(x)"],
  description: "Compute the sine of x in radians.",
  examples: ["sin(2)", "sin(pi / 4) ^ 2", "sin(90 deg)", "sin(30 deg)", "sin(0.2)^2 + cos(0.2)^2"],
  seealso: ["asin", "cos", "tan"]
}, S_ = {
  name: "sinh",
  category: "Trigonometry",
  syntax: ["sinh(x)"],
  description: "Compute the hyperbolic sine of x in radians.",
  examples: ["sinh(0.5)"],
  seealso: ["cosh", "tanh"]
}, D_ = {
  name: "tan",
  category: "Trigonometry",
  syntax: ["tan(x)"],
  description: "Compute the tangent of x in radians.",
  examples: ["tan(0.5)", "sin(0.5) / cos(0.5)", "tan(pi / 4)", "tan(45 deg)"],
  seealso: ["atan", "sin", "cos"]
}, N_ = {
  name: "tanh",
  category: "Trigonometry",
  syntax: ["tanh(x)"],
  description: "Compute the hyperbolic tangent of x in radians.",
  examples: ["tanh(0.5)", "sinh(0.5) / cosh(0.5)"],
  seealso: ["sinh", "cosh"]
}, M_ = {
  name: "to",
  category: "Units",
  syntax: ["x to unit", "to(x, unit)"],
  description: "Change the unit of a value.",
  examples: ["5 inch to cm", "3.2kg to g", "16 bytes in bits"],
  seealso: []
}, __ = {
  name: "bin",
  category: "Utils",
  syntax: ["bin(value)"],
  description: "Format a number as binary",
  examples: ["bin(2)"],
  seealso: ["oct", "hex"]
}, C_ = {
  name: "clone",
  category: "Utils",
  syntax: ["clone(x)"],
  description: "Clone a variable. Creates a copy of primitive variables,and a deep copy of matrices",
  examples: ["clone(3.5)", "clone(2 - 4i)", "clone(45 deg)", "clone([1, 2; 3, 4])", 'clone("hello world")'],
  seealso: []
}, T_ = {
  name: "format",
  category: "Utils",
  syntax: ["format(value)", "format(value, precision)"],
  description: "Format a value of any type as string.",
  examples: ["format(2.3)", "format(3 - 4i)", "format([])", "format(pi, 3)"],
  seealso: ["print"]
}, B_ = {
  name: "hasNumericValue",
  category: "Utils",
  syntax: ["hasNumericValue(x)"],
  description: "Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.",
  examples: ["hasNumericValue(2)", 'hasNumericValue("2")', 'isNumeric("2")', "hasNumericValue(0)", "hasNumericValue(bignumber(500))", "hasNumericValue(fraction(0.125))", "hasNumericValue(2 + 3i)", 'hasNumericValue([2.3, "foo", false])'],
  seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "isNumeric"]
}, F_ = {
  name: "hex",
  category: "Utils",
  syntax: ["hex(value)"],
  description: "Format a number as hexadecimal",
  examples: ["hex(240)"],
  seealso: ["bin", "oct"]
}, I_ = {
  name: "isInteger",
  category: "Utils",
  syntax: ["isInteger(x)"],
  description: "Test whether a value is an integer number.",
  examples: ["isInteger(2)", "isInteger(3.5)", "isInteger([3, 0.5, -2])"],
  seealso: ["isNegative", "isNumeric", "isPositive", "isZero"]
}, O_ = {
  name: "isNaN",
  category: "Utils",
  syntax: ["isNaN(x)"],
  description: "Test whether a value is NaN (not a number)",
  examples: ["isNaN(2)", "isNaN(0 / 0)", "isNaN(NaN)", "isNaN(Infinity)"],
  seealso: ["isNegative", "isNumeric", "isPositive", "isZero"]
}, R_ = {
  name: "isNegative",
  category: "Utils",
  syntax: ["isNegative(x)"],
  description: "Test whether a value is negative: smaller than zero.",
  examples: ["isNegative(2)", "isNegative(0)", "isNegative(-4)", "isNegative([3, 0.5, -2])"],
  seealso: ["isInteger", "isNumeric", "isPositive", "isZero"]
}, P_ = {
  name: "isNumeric",
  category: "Utils",
  syntax: ["isNumeric(x)"],
  description: "Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.",
  examples: ["isNumeric(2)", 'isNumeric("2")', 'hasNumericValue("2")', "isNumeric(0)", "isNumeric(bignumber(500))", "isNumeric(fraction(0.125))", "isNumeric(2 + 3i)", 'isNumeric([2.3, "foo", false])'],
  seealso: ["isInteger", "isZero", "isNegative", "isPositive", "isNaN", "hasNumericValue"]
}, q_ = {
  name: "isPositive",
  category: "Utils",
  syntax: ["isPositive(x)"],
  description: "Test whether a value is positive: larger than zero.",
  examples: ["isPositive(2)", "isPositive(0)", "isPositive(-4)", "isPositive([3, 0.5, -2])"],
  seealso: ["isInteger", "isNumeric", "isNegative", "isZero"]
}, $_ = {
  name: "isPrime",
  category: "Utils",
  syntax: ["isPrime(x)"],
  description: "Test whether a value is prime: has no divisors other than itself and one.",
  examples: ["isPrime(3)", "isPrime(-2)", "isPrime([2, 17, 100])"],
  seealso: ["isInteger", "isNumeric", "isNegative", "isZero"]
}, z_ = {
  name: "isZero",
  category: "Utils",
  syntax: ["isZero(x)"],
  description: "Test whether a value is zero.",
  examples: ["isZero(2)", "isZero(0)", "isZero(-4)", "isZero([3, 0, -2, 0])"],
  seealso: ["isInteger", "isNumeric", "isNegative", "isPositive"]
}, L_ = {
  name: "numeric",
  category: "Utils",
  syntax: ["numeric(x)"],
  description: "Convert a numeric input to a specific numeric type: number, BigNumber, bigint, or Fraction.",
  examples: ['numeric("4")', 'numeric("4", "number")', 'numeric("4", "bigint")', 'numeric("4", "BigNumber")', 'numeric("4", "Fraction")', 'numeric(4, "Fraction")', 'numeric(fraction(2, 5), "number")'],
  seealso: ["number", "bigint", "fraction", "bignumber", "string", "format"]
}, U_ = {
  name: "oct",
  category: "Utils",
  syntax: ["oct(value)"],
  description: "Format a number as octal",
  examples: ["oct(56)"],
  seealso: ["bin", "hex"]
}, k_ = {
  name: "print",
  category: "Utils",
  syntax: ["print(template, values)", "print(template, values, precision)"],
  description: "Interpolate values into a string template.",
  examples: ['print("Lucy is $age years old", {age: 5})', 'print("The value of pi is $pi", {pi: pi}, 3)', 'print("Hello, $user.name!", {user: {name: "John"}})', 'print("Values: $1, $2, $3", [6, 9, 4])'],
  seealso: ["format"]
}, H_ = {
  name: "typeOf",
  category: "Utils",
  syntax: ["typeOf(x)"],
  description: "Get the type of a variable.",
  examples: ["typeOf(3.5)", "typeOf(2 - 4i)", "typeOf(45 deg)", 'typeOf("hello world")'],
  seealso: ["getMatrixDataType"]
}, G_ = {
  name: "solveODE",
  category: "Numeric",
  syntax: ["solveODE(func, tspan, y0)", "solveODE(func, tspan, y0, options)"],
  description: "Numerical Integration of Ordinary Differential Equations.",
  examples: ["f(t,y) = y", "tspan = [0, 4]", "solveODE(f, tspan, 1)", "solveODE(f, tspan, [1, 2])", 'solveODE(f, tspan, 1, { method:"RK23", maxStep:0.1 })'],
  seealso: ["derivative", "simplifyCore"]
}, V_ = {
  // construction functions
  bignumber: OS,
  bigint: RS,
  boolean: PS,
  complex: qS,
  createUnit: $S,
  fraction: zS,
  index: LS,
  matrix: US,
  number: kS,
  sparse: HS,
  splitUnit: GS,
  string: VS,
  unit: WS,
  // constants
  e: Qh,
  E: Qh,
  false: yS,
  i: wS,
  Infinity: xS,
  LN2: AS,
  LN10: ES,
  LOG2E: DS,
  LOG10E: SS,
  NaN: NS,
  null: MS,
  pi: e0,
  PI: e0,
  phi: _S,
  SQRT1_2: CS,
  SQRT2: TS,
  tau: BS,
  true: FS,
  version: IS,
  // physical constants
  // TODO: more detailed docs for physical constants
  speedOfLight: {
    description: "Speed of light in vacuum",
    examples: ["speedOfLight"]
  },
  gravitationConstant: {
    description: "Newtonian constant of gravitation",
    examples: ["gravitationConstant"]
  },
  planckConstant: {
    description: "Planck constant",
    examples: ["planckConstant"]
  },
  reducedPlanckConstant: {
    description: "Reduced Planck constant",
    examples: ["reducedPlanckConstant"]
  },
  magneticConstant: {
    description: "Magnetic constant (vacuum permeability)",
    examples: ["magneticConstant"]
  },
  electricConstant: {
    description: "Electric constant (vacuum permeability)",
    examples: ["electricConstant"]
  },
  vacuumImpedance: {
    description: "Characteristic impedance of vacuum",
    examples: ["vacuumImpedance"]
  },
  coulomb: {
    description: "Coulomb's constant",
    examples: ["coulomb"]
  },
  elementaryCharge: {
    description: "Elementary charge",
    examples: ["elementaryCharge"]
  },
  bohrMagneton: {
    description: "Borh magneton",
    examples: ["bohrMagneton"]
  },
  conductanceQuantum: {
    description: "Conductance quantum",
    examples: ["conductanceQuantum"]
  },
  inverseConductanceQuantum: {
    description: "Inverse conductance quantum",
    examples: ["inverseConductanceQuantum"]
  },
  // josephson: {description: 'Josephson constant', examples: ['josephson']},
  magneticFluxQuantum: {
    description: "Magnetic flux quantum",
    examples: ["magneticFluxQuantum"]
  },
  nuclearMagneton: {
    description: "Nuclear magneton",
    examples: ["nuclearMagneton"]
  },
  klitzing: {
    description: "Von Klitzing constant",
    examples: ["klitzing"]
  },
  bohrRadius: {
    description: "Borh radius",
    examples: ["bohrRadius"]
  },
  classicalElectronRadius: {
    description: "Classical electron radius",
    examples: ["classicalElectronRadius"]
  },
  electronMass: {
    description: "Electron mass",
    examples: ["electronMass"]
  },
  fermiCoupling: {
    description: "Fermi coupling constant",
    examples: ["fermiCoupling"]
  },
  fineStructure: {
    description: "Fine-structure constant",
    examples: ["fineStructure"]
  },
  hartreeEnergy: {
    description: "Hartree energy",
    examples: ["hartreeEnergy"]
  },
  protonMass: {
    description: "Proton mass",
    examples: ["protonMass"]
  },
  deuteronMass: {
    description: "Deuteron Mass",
    examples: ["deuteronMass"]
  },
  neutronMass: {
    description: "Neutron mass",
    examples: ["neutronMass"]
  },
  quantumOfCirculation: {
    description: "Quantum of circulation",
    examples: ["quantumOfCirculation"]
  },
  rydberg: {
    description: "Rydberg constant",
    examples: ["rydberg"]
  },
  thomsonCrossSection: {
    description: "Thomson cross section",
    examples: ["thomsonCrossSection"]
  },
  weakMixingAngle: {
    description: "Weak mixing angle",
    examples: ["weakMixingAngle"]
  },
  efimovFactor: {
    description: "Efimov factor",
    examples: ["efimovFactor"]
  },
  atomicMass: {
    description: "Atomic mass constant",
    examples: ["atomicMass"]
  },
  avogadro: {
    description: "Avogadro's number",
    examples: ["avogadro"]
  },
  boltzmann: {
    description: "Boltzmann constant",
    examples: ["boltzmann"]
  },
  faraday: {
    description: "Faraday constant",
    examples: ["faraday"]
  },
  firstRadiation: {
    description: "First radiation constant",
    examples: ["firstRadiation"]
  },
  loschmidt: {
    description: "Loschmidt constant at T=273.15 K and p=101.325 kPa",
    examples: ["loschmidt"]
  },
  gasConstant: {
    description: "Gas constant",
    examples: ["gasConstant"]
  },
  molarPlanckConstant: {
    description: "Molar Planck constant",
    examples: ["molarPlanckConstant"]
  },
  molarVolume: {
    description: "Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa",
    examples: ["molarVolume"]
  },
  sackurTetrode: {
    description: "Sackur-Tetrode constant at T=1 K and p=101.325 kPa",
    examples: ["sackurTetrode"]
  },
  secondRadiation: {
    description: "Second radiation constant",
    examples: ["secondRadiation"]
  },
  stefanBoltzmann: {
    description: "Stefan-Boltzmann constant",
    examples: ["stefanBoltzmann"]
  },
  wienDisplacement: {
    description: "Wien displacement law constant",
    examples: ["wienDisplacement"]
  },
  // spectralRadiance: {description: 'First radiation constant for spectral radiance', examples: ['spectralRadiance']},
  molarMass: {
    description: "Molar mass constant",
    examples: ["molarMass"]
  },
  molarMassC12: {
    description: "Molar mass constant of carbon-12",
    examples: ["molarMassC12"]
  },
  gravity: {
    description: "Standard acceleration of gravity (standard acceleration of free-fall on Earth)",
    examples: ["gravity"]
  },
  planckLength: {
    description: "Planck length",
    examples: ["planckLength"]
  },
  planckMass: {
    description: "Planck mass",
    examples: ["planckMass"]
  },
  planckTime: {
    description: "Planck time",
    examples: ["planckTime"]
  },
  planckCharge: {
    description: "Planck charge",
    examples: ["planckCharge"]
  },
  planckTemperature: {
    description: "Planck temperature",
    examples: ["planckTemperature"]
  },
  // functions - algebra
  derivative: YS,
  lsolve: JS,
  lsolveAll: QS,
  lup: eD,
  lusolve: rD,
  leafCount: XS,
  polynomialRoot: tD,
  resolve: aD,
  simplify: oD,
  simplifyConstant: sD,
  simplifyCore: uD,
  symbolicEqual: cD,
  rationalize: iD,
  slu: fD,
  usolve: lD,
  usolveAll: dD,
  qr: nD,
  // functions - arithmetic
  abs: hD,
  add: pD,
  cbrt: vD,
  ceil: mD,
  cube: gD,
  divide: bD,
  dotDivide: yD,
  dotMultiply: wD,
  dotPow: xD,
  exp: ED,
  expm: AD,
  expm1: SD,
  fix: DD,
  floor: ND,
  gcd: MD,
  hypot: _D,
  lcm: TD,
  log: BD,
  log2: OD,
  log1p: ID,
  log10: FD,
  mod: RD,
  multiply: PD,
  norm: qD,
  nthRoot: $D,
  nthRoots: zD,
  pow: LD,
  round: UD,
  sign: kD,
  sqrt: HD,
  sqrtm: GD,
  square: ZD,
  subtract: jD,
  unaryMinus: YD,
  unaryPlus: XD,
  xgcd: JD,
  invmod: CD,
  // functions - bitwise
  bitAnd: QD,
  bitNot: eN,
  bitOr: rN,
  bitXor: tN,
  leftShift: nN,
  rightArithShift: iN,
  rightLogShift: aN,
  // functions - combinatorics
  bellNumbers: oN,
  catalan: sN,
  composition: uN,
  stirlingS2: fN,
  // functions - core
  config: KS,
  import: ZS,
  typed: jS,
  // functions - complex
  arg: cN,
  conj: lN,
  re: hN,
  im: dN,
  // functions - expression
  evaluate: pN,
  help: vN,
  // functions - geometry
  distance: mN,
  intersect: gN,
  // functions - logical
  and: bN,
  not: yN,
  or: wN,
  xor: xN,
  // functions - matrix
  concat: AN,
  count: SN,
  cross: DN,
  column: EN,
  ctranspose: NN,
  det: MN,
  diag: _N,
  diff: CN,
  dot: TN,
  getMatrixDataType: RN,
  identity: PN,
  filter: FN,
  flatten: IN,
  forEach: ON,
  inv: qN,
  pinv: $N,
  eigs: BN,
  kron: zN,
  matrixFromFunction: kN,
  matrixFromRows: HN,
  matrixFromColumns: UN,
  map: LN,
  ones: GN,
  partitionSelect: VN,
  range: WN,
  resize: ZN,
  reshape: KN,
  rotate: jN,
  rotationMatrix: YN,
  row: XN,
  size: JN,
  sort: QN,
  squeeze: eM,
  subset: rM,
  trace: tM,
  transpose: nM,
  zeros: iM,
  fft: aM,
  ifft: oM,
  sylvester: VD,
  schur: WD,
  lyap: KD,
  // functions - numeric
  solveODE: G_,
  // functions - probability
  combinations: sM,
  combinationsWithRep: uM,
  // distribution: distributionDocs,
  factorial: fM,
  gamma: cM,
  kldivergence: dM,
  lgamma: lM,
  multinomial: hM,
  permutations: pM,
  pickRandom: vM,
  random: mM,
  randomInt: gM,
  // functions - relational
  compare: bM,
  compareNatural: yM,
  compareText: wM,
  deepEqual: xM,
  equal: EM,
  equalText: AM,
  larger: SM,
  largerEq: DM,
  smaller: NM,
  smallerEq: MM,
  unequal: _M,
  // functions - set
  setCartesian: CM,
  setDifference: TM,
  setDistinct: BM,
  setIntersect: FM,
  setIsSubset: IM,
  setMultiplicity: OM,
  setPowerset: RM,
  setSize: PM,
  setSymDifference: qM,
  setUnion: $M,
  // functions - signal
  zpk2tf: zM,
  freqz: LM,
  // functions - special
  erf: UM,
  zeta: kM,
  // functions - statistics
  cumsum: JM,
  mad: HM,
  max: GM,
  mean: VM,
  median: WM,
  min: KM,
  mode: ZM,
  prod: jM,
  quantileSeq: YM,
  std: XM,
  sum: QM,
  variance: e_,
  corr: r_,
  // functions - trigonometry
  acos: t_,
  acosh: n_,
  acot: i_,
  acoth: a_,
  acsc: o_,
  acsch: s_,
  asec: u_,
  asech: f_,
  asin: c_,
  asinh: l_,
  atan: d_,
  atanh: p_,
  atan2: h_,
  cos: v_,
  cosh: m_,
  cot: g_,
  coth: b_,
  csc: y_,
  csch: w_,
  sec: x_,
  sech: E_,
  sin: A_,
  sinh: S_,
  tan: D_,
  tanh: N_,
  // functions - units
  to: M_,
  // functions - utils
  clone: C_,
  format: T_,
  bin: __,
  oct: U_,
  hex: F_,
  isNaN: O_,
  isInteger: I_,
  isNegative: R_,
  isNumeric: P_,
  hasNumericValue: B_,
  isPositive: q_,
  isPrime: $_,
  isZero: z_,
  print: k_,
  typeOf: H_,
  numeric: L_
}, r0 = "help", W_ = ["typed", "mathWithTransform", "Help"], K_ = /* @__PURE__ */ Q(r0, W_, (e) => {
  var {
    typed: r,
    mathWithTransform: o,
    Help: n
  } = e;
  return r(r0, {
    any: function(t) {
      var u, l = t;
      if (typeof t != "string") {
        for (u in o)
          if (De(o, u) && t === o[u]) {
            l = u;
            break;
          }
      }
      var f = Vr(V_, l);
      if (!f) {
        var s = typeof l == "function" ? l.name : l;
        throw new Error('No documentation found on "' + s + '"');
      }
      return new n(f);
    }
  });
}), t0 = "chain", Z_ = ["typed", "Chain"], j_ = /* @__PURE__ */ Q(t0, Z_, (e) => {
  var {
    typed: r,
    Chain: o
  } = e;
  return r(t0, {
    "": function() {
      return new o();
    },
    any: function(i) {
      return new o(i);
    }
  });
}), n0 = "det", Y_ = ["typed", "matrix", "subtractScalar", "multiply", "divideScalar", "isZero", "unaryMinus"], X_ = /* @__PURE__ */ Q(n0, Y_, (e) => {
  var {
    typed: r,
    matrix: o,
    subtractScalar: n,
    multiply: i,
    divideScalar: t,
    isZero: u,
    unaryMinus: l
  } = e;
  return r(n0, {
    any: function(a) {
      return Ie(a);
    },
    "Array | Matrix": function(a) {
      var c;
      switch (Fe(a) ? c = a.size() : Array.isArray(a) ? (a = o(a), c = a.size()) : c = [], c.length) {
        case 0:
          return Ie(a);
        case 1:
          if (c[0] === 1)
            return Ie(a.valueOf()[0]);
          if (c[0] === 0)
            return 1;
          throw new RangeError("Matrix must be square (size: " + Ze(c) + ")");
        case 2: {
          var d = c[0], h = c[1];
          if (d === h)
            return f(a.clone().valueOf(), d);
          if (h === 0)
            return 1;
          throw new RangeError("Matrix must be square (size: " + Ze(c) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + Ze(c) + ")");
      }
    }
  });
  function f(s, a, c) {
    if (a === 1)
      return Ie(s[0][0]);
    if (a === 2)
      return n(i(s[0][0], s[1][1]), i(s[1][0], s[0][1]));
    for (var d = !1, h = new Array(a).fill(0).map((R, O) => O), p = 0; p < a; p++) {
      var v = h[p];
      if (u(s[v][p])) {
        var g = void 0;
        for (g = p + 1; g < a; g++)
          if (!u(s[h[g]][p])) {
            v = h[g], h[g] = h[p], h[p] = v, d = !d;
            break;
          }
        if (g === a)
          return s[v][p];
      }
      for (var m = s[v][p], x = p === 0 ? 1 : s[h[p - 1]][p - 1], y = p + 1; y < a; y++)
        for (var E = h[y], N = p + 1; N < a; N++)
          s[E][N] = t(n(i(s[E][N], m), i(s[E][p], s[v][N])), x);
    }
    var S = s[h[a - 1]][a - 1];
    return d ? l(S) : S;
  }
}), i0 = "inv", J_ = ["typed", "matrix", "divideScalar", "addScalar", "multiply", "unaryMinus", "det", "identity", "abs"], Q_ = /* @__PURE__ */ Q(i0, J_, (e) => {
  var {
    typed: r,
    matrix: o,
    divideScalar: n,
    addScalar: i,
    multiply: t,
    unaryMinus: u,
    det: l,
    identity: f,
    abs: s
  } = e;
  return r(i0, {
    "Array | Matrix": function(d) {
      var h = Fe(d) ? d.size() : ze(d);
      switch (h.length) {
        case 1:
          if (h[0] === 1)
            return Fe(d) ? o([n(1, d.valueOf()[0])]) : [n(1, d[0])];
          throw new RangeError("Matrix must be square (size: " + Ze(h) + ")");
        case 2: {
          var p = h[0], v = h[1];
          if (p === v)
            return Fe(d) ? o(a(d.valueOf(), p, v), d.storage()) : a(d, p, v);
          throw new RangeError("Matrix must be square (size: " + Ze(h) + ")");
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + Ze(h) + ")");
      }
    },
    any: function(d) {
      return n(1, d);
    }
  });
  function a(c, d, h) {
    var p, v, g, m, x;
    if (d === 1) {
      if (m = c[0][0], m === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[n(1, m)]];
    } else if (d === 2) {
      var y = l(c);
      if (y === 0)
        throw Error("Cannot calculate inverse, determinant is zero");
      return [[n(c[1][1], y), n(u(c[0][1]), y)], [n(u(c[1][0]), y), n(c[0][0], y)]];
    } else {
      var E = c.concat();
      for (p = 0; p < d; p++)
        E[p] = E[p].concat();
      for (var N = f(d).valueOf(), S = 0; S < h; S++) {
        var R = s(E[S][S]), O = S;
        for (p = S + 1; p < d; )
          s(E[p][S]) > R && (R = s(E[p][S]), O = p), p++;
        if (R === 0)
          throw Error("Cannot calculate inverse, determinant is zero");
        p = O, p !== S && (x = E[S], E[S] = E[p], E[p] = x, x = N[S], N[S] = N[p], N[p] = x);
        var B = E[S], $ = N[S];
        for (p = 0; p < d; p++) {
          var F = E[p], w = N[p];
          if (p !== S) {
            if (F[S] !== 0) {
              for (g = n(u(F[S]), B[S]), v = S; v < h; v++)
                F[v] = i(F[v], t(g, B[v]));
              for (v = 0; v < h; v++)
                w[v] = i(w[v], t(g, $[v]));
            }
          } else {
            for (g = B[S], v = S; v < h; v++)
              F[v] = n(F[v], g);
            for (v = 0; v < h; v++)
              w[v] = n(w[v], g);
          }
        }
      }
      return N;
    }
  }
}), a0 = "pinv", eC = ["typed", "matrix", "inv", "deepEqual", "equal", "dotDivide", "dot", "ctranspose", "divideScalar", "multiply", "add", "Complex"], rC = /* @__PURE__ */ Q(a0, eC, (e) => {
  var {
    typed: r,
    matrix: o,
    inv: n,
    deepEqual: i,
    equal: t,
    dotDivide: u,
    dot: l,
    ctranspose: f,
    divideScalar: s,
    multiply: a,
    add: c,
    Complex: d
  } = e;
  return r(a0, {
    "Array | Matrix": function(y) {
      var E = Fe(y) ? y.size() : ze(y);
      switch (E.length) {
        case 1:
          return m(y) ? f(y) : E[0] === 1 ? n(y) : u(f(y), l(y, y));
        case 2: {
          if (m(y))
            return f(y);
          var N = E[0], S = E[1];
          if (N === S)
            try {
              return n(y);
            } catch (R) {
              if (!(R instanceof Error && R.message.match(/Cannot calculate inverse, determinant is zero/)))
                throw R;
            }
          return Fe(y) ? o(h(y.valueOf(), N, S), y.storage()) : h(y, N, S);
        }
        default:
          throw new RangeError("Matrix must be two dimensional (size: " + Ze(E) + ")");
      }
    },
    any: function(y) {
      return t(y, 0) ? Ie(y) : s(1, y);
    }
  });
  function h(x, y, E) {
    var {
      C: N,
      F: S
    } = v(x, y, E), R = a(n(a(f(N), N)), f(N)), O = a(f(S), n(a(S, f(S))));
    return a(O, R);
  }
  function p(x, y, E) {
    for (var N = Ie(x), S = 0, R = 0; R < y; R++) {
      if (E <= S)
        return N;
      for (var O = R; g(N[O][S]); )
        if (O++, y === O && (O = R, S++, E === S))
          return N;
      [N[O], N[R]] = [N[R], N[O]];
      for (var B = N[R][S], $ = 0; $ < E; $++)
        N[R][$] = u(N[R][$], B);
      for (var F = 0; F < y; F++)
        if (F !== R) {
          B = N[F][S];
          for (var w = 0; w < E; w++)
            N[F][w] = c(N[F][w], a(-1, a(B, N[R][w])));
        }
      S++;
    }
    return N;
  }
  function v(x, y, E) {
    var N = p(x, y, E), S = x.map((O, B) => O.filter(($, F) => F < y && !g(l(N[F], N[F])))), R = N.filter((O, B) => !g(l(N[B], N[B])));
    return {
      C: S,
      F: R
    };
  }
  function g(x) {
    return t(c(x, d(1, 1)), c(0, d(1, 1)));
  }
  function m(x) {
    return i(c(x, d(1, 1)), c(a(x, 0), d(1, 1)));
  }
});
function tC(e) {
  var {
    addScalar: r,
    subtract: o,
    flatten: n,
    multiply: i,
    multiplyScalar: t,
    divideScalar: u,
    sqrt: l,
    abs: f,
    bignumber: s,
    diag: a,
    size: c,
    reshape: d,
    inv: h,
    qr: p,
    usolve: v,
    usolveAll: g,
    equal: m,
    complex: x,
    larger: y,
    smaller: E,
    matrixFromColumns: N,
    dot: S
  } = e;
  function R(I, U, ee, se) {
    var K = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, J = O(I, U, ee, se, K);
    B(I, U, ee, se, K, J);
    var {
      values: te,
      C: ne
    } = $(I, U, ee, se, K);
    if (K) {
      var ue = F(I, U, ne, J, te, ee, se);
      return {
        values: te,
        eigenvectors: ue
      };
    }
    return {
      values: te
    };
  }
  function O(I, U, ee, se, K) {
    var J = se === "BigNumber", te = se === "Complex", ne = J ? s(0) : 0, ue = J ? s(1) : te ? x(1) : 1, V = J ? s(1) : 1, W = J ? s(10) : 2, fe = t(W, W), pe;
    K && (pe = Array(U).fill(ue));
    for (var Y = !1; !Y; ) {
      Y = !0;
      for (var k = 0; k < U; k++) {
        for (var L = ne, P = ne, G = 0; G < U; G++)
          k !== G && (L = r(L, f(I[G][k])), P = r(P, f(I[k][G])));
        if (!m(L, 0) && !m(P, 0)) {
          for (var j = V, re = L, ie = u(P, W), Z = t(P, W); E(re, ie); )
            re = t(re, fe), j = t(j, W);
          for (; y(re, Z); )
            re = u(re, fe), j = u(j, W);
          var X = E(u(r(re, P), j), t(r(L, P), 0.95));
          if (X) {
            Y = !1;
            for (var oe = u(1, j), ce = 0; ce < U; ce++)
              k !== ce && (I[k][ce] = t(I[k][ce], oe), I[ce][k] = t(I[ce][k], j));
            K && (pe[k] = t(pe[k], oe));
          }
        }
      }
    }
    return K ? a(pe) : null;
  }
  function B(I, U, ee, se, K, J) {
    var te = se === "BigNumber", ne = se === "Complex", ue = te ? s(0) : ne ? x(0) : 0;
    te && (ee = s(ee));
    for (var V = 0; V < U - 2; V++) {
      for (var W = 0, fe = ue, pe = V + 1; pe < U; pe++) {
        var Y = I[pe][V];
        E(f(fe), f(Y)) && (fe = Y, W = pe);
      }
      if (!E(f(fe), ee)) {
        if (W !== V + 1) {
          var k = I[W];
          I[W] = I[V + 1], I[V + 1] = k;
          for (var L = 0; L < U; L++) {
            var P = I[L][W];
            I[L][W] = I[L][V + 1], I[L][V + 1] = P;
          }
          if (K) {
            var G = J[W];
            J[W] = J[V + 1], J[V + 1] = G;
          }
        }
        for (var j = V + 2; j < U; j++) {
          var re = u(I[j][V], fe);
          if (re !== 0) {
            for (var ie = 0; ie < U; ie++)
              I[j][ie] = o(I[j][ie], t(re, I[V + 1][ie]));
            for (var Z = 0; Z < U; Z++)
              I[Z][V + 1] = r(I[Z][V + 1], t(re, I[Z][j]));
            if (K)
              for (var X = 0; X < U; X++)
                J[j][X] = o(J[j][X], t(re, J[V + 1][X]));
          }
        }
      }
    }
    return J;
  }
  function $(I, U, ee, se, K) {
    var J = se === "BigNumber", te = se === "Complex", ne = J ? s(1) : te ? x(1) : 1;
    J && (ee = s(ee));
    for (var ue = Ie(I), V = [], W = U, fe = [], pe = K ? a(Array(U).fill(ne)) : void 0, Y = K ? a(Array(W).fill(ne)) : void 0, k = 0; k <= 100; ) {
      k += 1;
      for (var L = ue[W - 1][W - 1], P = 0; P < W; P++)
        ue[P][P] = o(ue[P][P], L);
      var {
        Q: G,
        R: j
      } = p(ue);
      ue = i(j, G);
      for (var re = 0; re < W; re++)
        ue[re][re] = r(ue[re][re], L);
      if (K && (Y = i(Y, G)), W === 1 || E(f(ue[W - 1][W - 2]), ee)) {
        k = 0, V.push(ue[W - 1][W - 1]), K && (fe.unshift([[1]]), b(Y, U), pe = i(pe, Y), W > 1 && (Y = a(Array(W - 1).fill(ne)))), W -= 1, ue.pop();
        for (var ie = 0; ie < W; ie++)
          ue[ie].pop();
      } else if (W === 2 || E(f(ue[W - 2][W - 3]), ee)) {
        k = 0;
        var Z = w(ue[W - 2][W - 2], ue[W - 2][W - 1], ue[W - 1][W - 2], ue[W - 1][W - 1]);
        V.push(...Z), K && (fe.unshift(A(ue[W - 2][W - 2], ue[W - 2][W - 1], ue[W - 1][W - 2], ue[W - 1][W - 1], Z[0], Z[1], ee, se)), b(Y, U), pe = i(pe, Y), W > 2 && (Y = a(Array(W - 2).fill(ne)))), W -= 2, ue.pop(), ue.pop();
        for (var X = 0; X < W; X++)
          ue[X].pop(), ue[X].pop();
      }
      if (W === 0)
        break;
    }
    if (V.sort((le, ve) => +o(f(le), f(ve))), k > 100) {
      var oe = Error("The eigenvalues failed to converge. Only found these eigenvalues: " + V.join(", "));
      throw oe.values = V, oe.vectors = [], oe;
    }
    var ce = K ? i(pe, D(fe, U)) : void 0;
    return {
      values: V,
      C: ce
    };
  }
  function F(I, U, ee, se, K, J, te) {
    var ne = h(ee), ue = i(ne, I, ee), V = te === "BigNumber", W = te === "Complex", fe = V ? s(0) : W ? x(0) : 0, pe = V ? s(1) : W ? x(1) : 1, Y = [], k = [];
    for (var L of K) {
      var P = M(Y, L, m);
      P === -1 ? (Y.push(L), k.push(1)) : k[P] += 1;
    }
    for (var G = [], j = Y.length, re = Array(U).fill(fe), ie = a(Array(U).fill(pe)), Z = function() {
      var ce = Y[X], le = o(ue, i(ce, ie)), ve = g(le, re);
      for (ve.shift(); ve.length < k[X]; ) {
        var ge = _(le, U, ve, J, te);
        if (ge === null)
          break;
        ve.push(ge);
      }
      var me = i(h(se), ee);
      ve = ve.map((we) => i(me, we)), G.push(...ve.map((we) => ({
        value: ce,
        vector: n(we)
      })));
    }, X = 0; X < j; X++)
      Z();
    return G;
  }
  function w(I, U, ee, se) {
    var K = r(I, se), J = o(t(I, se), t(U, ee)), te = t(K, 0.5), ne = t(l(o(t(K, K), t(4, J))), 0.5);
    return [r(te, ne), o(te, ne)];
  }
  function A(I, U, ee, se, K, J, te, ne) {
    var ue = ne === "BigNumber", V = ne === "Complex", W = ue ? s(0) : V ? x(0) : 0, fe = ue ? s(1) : V ? x(1) : 1;
    if (E(f(ee), te))
      return [[fe, W], [W, fe]];
    if (y(f(o(K, J)), te))
      return [[o(K, se), o(J, se)], [ee, ee]];
    var pe = o(I, K), Y = o(se, K);
    return E(f(U), te) && E(f(Y), te) ? [[pe, fe], [ee, W]] : [[U, W], [Y, fe]];
  }
  function b(I, U) {
    for (var ee = 0; ee < I.length; ee++)
      I[ee].push(...Array(U - I[ee].length).fill(0));
    for (var se = I.length; se < U; se++)
      I.push(Array(U).fill(0)), I[se][se] = 1;
    return I;
  }
  function D(I, U) {
    for (var ee = [], se = 0; se < U; se++)
      ee[se] = Array(U).fill(0);
    var K = 0;
    for (var J of I) {
      for (var te = J.length, ne = 0; ne < te; ne++)
        for (var ue = 0; ue < te; ue++)
          ee[K + ne][K + ue] = J[ne][ue];
      K += te;
    }
    return ee;
  }
  function M(I, U, ee) {
    for (var se = 0; se < I.length; se++)
      if (ee(I[se], U))
        return se;
    return -1;
  }
  function _(I, U, ee, se, K) {
    for (var J = K === "BigNumber" ? s(1e3) : 1e3, te, ne = 0; ne < 5; ++ne) {
      te = q(U, ee, K);
      try {
        te = v(I, te);
      } catch {
        continue;
      }
      if (y(T(te), J))
        break;
    }
    if (ne >= 5)
      return null;
    for (ne = 0; ; ) {
      var ue = v(I, te);
      if (E(T(C(te, [ue])), se))
        break;
      if (++ne >= 10)
        return null;
      te = z(ue);
    }
    return te;
  }
  function q(I, U, ee) {
    var se = ee === "BigNumber", K = ee === "Complex", J = Array(I).fill(0).map((te) => 2 * Math.random() - 1);
    return se && (J = J.map((te) => s(te))), K && (J = J.map((te) => x(te))), J = C(J, U), z(J, ee);
  }
  function C(I, U) {
    var ee = c(I);
    for (var se of U)
      se = d(se, ee), I = o(I, i(u(S(se, I), S(se, se)), se));
    return I;
  }
  function T(I) {
    return f(l(S(I, I)));
  }
  function z(I, U) {
    var ee = U === "BigNumber", se = U === "Complex", K = ee ? s(1) : se ? x(1) : 1;
    return i(u(K, T(I)), I);
  }
  return R;
}
function nC(e) {
  var {
    config: r,
    addScalar: o,
    subtract: n,
    abs: i,
    atan: t,
    cos: u,
    sin: l,
    multiplyScalar: f,
    inv: s,
    bignumber: a,
    multiply: c,
    add: d
  } = e;
  function h(B, $) {
    var F = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : r.relTol, w = arguments.length > 3 ? arguments[3] : void 0, A = arguments.length > 4 ? arguments[4] : void 0;
    if (w === "number")
      return p(B, F, A);
    if (w === "BigNumber")
      return v(B, F, A);
    throw TypeError("Unsupported data type: " + w);
  }
  function p(B, $, F) {
    var w = B.length, A = Math.abs($ / w), b, D;
    if (F) {
      D = new Array(w);
      for (var M = 0; M < w; M++)
        D[M] = Array(w).fill(0), D[M][M] = 1;
    }
    for (var _ = S(B); Math.abs(_[1]) >= Math.abs(A); ) {
      var q = _[0][0], C = _[0][1];
      b = g(B[q][q], B[C][C], B[q][C]), B = N(B, b, q, C), F && (D = x(D, b, q, C)), _ = S(B);
    }
    for (var T = Array(w).fill(0), z = 0; z < w; z++)
      T[z] = B[z][z];
    return O(Ie(T), D, F);
  }
  function v(B, $, F) {
    var w = B.length, A = i($ / w), b, D;
    if (F) {
      D = new Array(w);
      for (var M = 0; M < w; M++)
        D[M] = Array(w).fill(0), D[M][M] = 1;
    }
    for (var _ = R(B); i(_[1]) >= i(A); ) {
      var q = _[0][0], C = _[0][1];
      b = m(B[q][q], B[C][C], B[q][C]), B = E(B, b, q, C), F && (D = y(D, b, q, C)), _ = R(B);
    }
    for (var T = Array(w).fill(0), z = 0; z < w; z++)
      T[z] = B[z][z];
    return O(Ie(T), D, F);
  }
  function g(B, $, F) {
    var w = $ - B;
    return Math.abs(w) <= r.relTol ? Math.PI / 4 : 0.5 * Math.atan(2 * F / ($ - B));
  }
  function m(B, $, F) {
    var w = n($, B);
    return i(w) <= r.relTol ? a(-1).acos().div(4) : f(0.5, t(c(2, F, s(w))));
  }
  function x(B, $, F, w) {
    for (var A = B.length, b = Math.cos($), D = Math.sin($), M = Array(A).fill(0), _ = Array(A).fill(0), q = 0; q < A; q++)
      M[q] = b * B[q][F] - D * B[q][w], _[q] = D * B[q][F] + b * B[q][w];
    for (var C = 0; C < A; C++)
      B[C][F] = M[C], B[C][w] = _[C];
    return B;
  }
  function y(B, $, F, w) {
    for (var A = B.length, b = u($), D = l($), M = Array(A).fill(a(0)), _ = Array(A).fill(a(0)), q = 0; q < A; q++)
      M[q] = n(f(b, B[q][F]), f(D, B[q][w])), _[q] = o(f(D, B[q][F]), f(b, B[q][w]));
    for (var C = 0; C < A; C++)
      B[C][F] = M[C], B[C][w] = _[C];
    return B;
  }
  function E(B, $, F, w) {
    for (var A = B.length, b = a(u($)), D = a(l($)), M = f(b, b), _ = f(D, D), q = Array(A).fill(a(0)), C = Array(A).fill(a(0)), T = c(a(2), b, D, B[F][w]), z = o(n(f(M, B[F][F]), T), f(_, B[w][w])), I = d(f(_, B[F][F]), T, f(M, B[w][w])), U = 0; U < A; U++)
      q[U] = n(f(b, B[F][U]), f(D, B[w][U])), C[U] = o(f(D, B[F][U]), f(b, B[w][U]));
    B[F][F] = z, B[w][w] = I, B[F][w] = a(0), B[w][F] = a(0);
    for (var ee = 0; ee < A; ee++)
      ee !== F && ee !== w && (B[F][ee] = q[ee], B[ee][F] = q[ee], B[w][ee] = C[ee], B[ee][w] = C[ee]);
    return B;
  }
  function N(B, $, F, w) {
    for (var A = B.length, b = Math.cos($), D = Math.sin($), M = b * b, _ = D * D, q = Array(A).fill(0), C = Array(A).fill(0), T = M * B[F][F] - 2 * b * D * B[F][w] + _ * B[w][w], z = _ * B[F][F] + 2 * b * D * B[F][w] + M * B[w][w], I = 0; I < A; I++)
      q[I] = b * B[F][I] - D * B[w][I], C[I] = D * B[F][I] + b * B[w][I];
    B[F][F] = T, B[w][w] = z, B[F][w] = 0, B[w][F] = 0;
    for (var U = 0; U < A; U++)
      U !== F && U !== w && (B[F][U] = q[U], B[U][F] = q[U], B[w][U] = C[U], B[U][w] = C[U]);
    return B;
  }
  function S(B) {
    for (var $ = B.length, F = 0, w = [0, 1], A = 0; A < $; A++)
      for (var b = A + 1; b < $; b++)
        Math.abs(F) < Math.abs(B[A][b]) && (F = Math.abs(B[A][b]), w = [A, b]);
    return [w, F];
  }
  function R(B) {
    for (var $ = B.length, F = 0, w = [0, 1], A = 0; A < $; A++)
      for (var b = A + 1; b < $; b++)
        i(F) < i(B[A][b]) && (F = i(B[A][b]), w = [A, b]);
    return [w, F];
  }
  function O(B, $, F) {
    var w = B.length, A = Array(w), b;
    if (F) {
      b = Array(w);
      for (var D = 0; D < w; D++)
        b[D] = Array(w);
    }
    for (var M = 0; M < w; M++) {
      for (var _ = 0, q = B[0], C = 0; C < B.length; C++)
        i(B[C]) < i(q) && (_ = C, q = B[_]);
      if (A[M] = B.splice(_, 1)[0], F)
        for (var T = 0; T < w; T++)
          b[M][T] = $[T][_], $[T].splice(_, 1);
    }
    if (!F)
      return {
        values: A
      };
    var z = b.map((I, U) => ({
      value: A[U],
      vector: I
    }));
    return {
      values: A,
      eigenvectors: z
    };
  }
  return h;
}
var iC = "eigs", aC = ["config", "typed", "matrix", "addScalar", "equal", "subtract", "abs", "atan", "cos", "sin", "multiplyScalar", "divideScalar", "inv", "bignumber", "multiply", "add", "larger", "column", "flatten", "number", "complex", "sqrt", "diag", "size", "reshape", "qr", "usolve", "usolveAll", "im", "re", "smaller", "matrixFromColumns", "dot"], oC = /* @__PURE__ */ Q(iC, aC, (e) => {
  var {
    config: r,
    typed: o,
    matrix: n,
    addScalar: i,
    subtract: t,
    equal: u,
    abs: l,
    atan: f,
    cos: s,
    sin: a,
    multiplyScalar: c,
    divideScalar: d,
    inv: h,
    bignumber: p,
    multiply: v,
    add: g,
    larger: m,
    column: x,
    flatten: y,
    number: E,
    complex: N,
    sqrt: S,
    diag: R,
    size: O,
    reshape: B,
    qr: $,
    usolve: F,
    usolveAll: w,
    im: A,
    re: b,
    smaller: D,
    matrixFromColumns: M,
    dot: _
  } = e, q = nC({
    config: r,
    addScalar: i,
    subtract: t,
    column: x,
    flatten: y,
    equal: u,
    abs: l,
    atan: f,
    cos: s,
    sin: a,
    multiplyScalar: c,
    inv: h,
    bignumber: p,
    complex: N,
    multiply: v,
    add: g
  }), C = tC({
    config: r,
    addScalar: i,
    subtract: t,
    multiply: v,
    multiplyScalar: c,
    flatten: y,
    divideScalar: d,
    sqrt: S,
    abs: l,
    bignumber: p,
    diag: R,
    size: O,
    reshape: B,
    qr: $,
    inv: h,
    usolve: F,
    usolveAll: w,
    equal: u,
    complex: N,
    larger: m,
    smaller: D,
    matrixFromColumns: M,
    dot: _
  });
  return o("eigs", {
    // The conversion to matrix in the first two implementations,
    // just to convert back to an array right away in
    // computeValuesAndVectors, is unfortunate, and should perhaps be
    // streamlined. It is done because the Matrix object carries some
    // type information about its entries, and so constructing the matrix
    // is a roundabout way of doing type detection.
    Array: function(J) {
      return T(n(J));
    },
    "Array, number|BigNumber": function(J, te) {
      return T(n(J), {
        precision: te
      });
    },
    "Array, Object"(K, J) {
      return T(n(K), J);
    },
    Matrix: function(J) {
      return T(J, {
        matricize: !0
      });
    },
    "Matrix, number|BigNumber": function(J, te) {
      return T(J, {
        precision: te,
        matricize: !0
      });
    },
    "Matrix, Object": function(J, te) {
      var ne = {
        matricize: !0
      };
      return kr(ne, te), T(J, ne);
    }
  });
  function T(K) {
    var J, te = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ne = "eigenvectors" in te ? te.eigenvectors : !0, ue = (J = te.precision) !== null && J !== void 0 ? J : r.relTol, V = z(K, ue, ne);
    return te.matricize && (V.values = n(V.values), ne && (V.eigenvectors = V.eigenvectors.map((W) => {
      var {
        value: fe,
        vector: pe
      } = W;
      return {
        value: fe,
        vector: n(pe)
      };
    }))), ne && Object.defineProperty(V, "vectors", {
      enumerable: !1,
      // to make sure that the eigenvectors can still be
      // converted to string.
      get: () => {
        throw new Error("eigs(M).vectors replaced with eigs(M).eigenvectors");
      }
    }), V;
  }
  function z(K, J, te) {
    var ne = K.toArray(), ue = K.size();
    if (ue.length !== 2 || ue[0] !== ue[1])
      throw new RangeError("Matrix must be square (size: ".concat(Ze(ue), ")"));
    var V = ue[0];
    if (U(ne, V, J) && (ee(ne, V), I(ne, V, J))) {
      var W = se(K, ne, V);
      return q(ne, V, J, W, te);
    }
    var fe = se(K, ne, V);
    return C(ne, V, J, fe, te);
  }
  function I(K, J, te) {
    for (var ne = 0; ne < J; ne++)
      for (var ue = ne; ue < J; ue++)
        if (m(p(l(t(K[ne][ue], K[ue][ne]))), te))
          return !1;
    return !0;
  }
  function U(K, J, te) {
    for (var ne = 0; ne < J; ne++)
      for (var ue = 0; ue < J; ue++)
        if (m(p(l(A(K[ne][ue]))), te))
          return !1;
    return !0;
  }
  function ee(K, J) {
    for (var te = 0; te < J; te++)
      for (var ne = 0; ne < J; ne++)
        K[te][ne] = b(K[te][ne]);
  }
  function se(K, J, te) {
    var ne = K.datatype();
    if (ne === "number" || ne === "BigNumber" || ne === "Complex")
      return ne;
    for (var ue = !1, V = !1, W = !1, fe = 0; fe < te; fe++)
      for (var pe = 0; pe < te; pe++) {
        var Y = J[fe][pe];
        if ($e(Y) || An(Y))
          ue = !0;
        else if (Re(Y))
          V = !0;
        else if (yt(Y))
          W = !0;
        else
          throw TypeError("Unsupported type in Matrix: " + fr(Y));
      }
    if (V && W && console.warn("Complex BigNumbers not supported, this operation will lose precission."), W) {
      for (var k = 0; k < te; k++)
        for (var L = 0; L < te; L++)
          J[k][L] = N(J[k][L]);
      return "Complex";
    }
    if (V) {
      for (var P = 0; P < te; P++)
        for (var G = 0; G < te; G++)
          J[P][G] = p(J[P][G]);
      return "BigNumber";
    }
    if (ue) {
      for (var j = 0; j < te; j++)
        for (var re = 0; re < te; re++)
          J[j][re] = E(J[j][re]);
      return "number";
    } else
      throw TypeError("Matrix contains unsupported types only.");
  }
}), o0 = "expm", sC = ["typed", "abs", "add", "identity", "inv", "multiply"], uC = /* @__PURE__ */ Q(o0, sC, (e) => {
  var {
    typed: r,
    abs: o,
    add: n,
    identity: i,
    inv: t,
    multiply: u
  } = e;
  return r(o0, {
    Matrix: function(c) {
      var d = c.size();
      if (d.length !== 2 || d[0] !== d[1])
        throw new RangeError("Matrix must be square (size: " + Ze(d) + ")");
      for (var h = d[0], p = 1e-15, v = l(c), g = f(v, p), m = g.q, x = g.j, y = u(c, Math.pow(2, -x)), E = i(h), N = i(h), S = 1, R = y, O = -1, B = 1; B <= m; B++)
        B > 1 && (R = u(R, y), O = -O), S = S * (m - B + 1) / ((2 * m - B + 1) * B), E = n(E, u(S, R)), N = n(N, u(S * O, R));
      for (var $ = u(t(N), E), F = 0; F < x; F++)
        $ = u($, $);
      return en(c) ? c.createSparseMatrix($) : $;
    }
  });
  function l(a) {
    for (var c = a.size()[0], d = 0, h = 0; h < c; h++) {
      for (var p = 0, v = 0; v < c; v++)
        p += o(a.get([h, v]));
      d = Math.max(p, d);
    }
    return d;
  }
  function f(a, c) {
    for (var d = 30, h = 0; h < d; h++)
      for (var p = 0; p <= h; p++) {
        var v = h - p;
        if (s(a, p, v) < c)
          return {
            q: p,
            j: v
          };
      }
    throw new Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)");
  }
  function s(a, c, d) {
    for (var h = 1, p = 2; p <= c; p++)
      h *= p;
    for (var v = h, g = c + 1; g <= 2 * c; g++)
      v *= g;
    var m = v * (2 * c + 1);
    return 8 * Math.pow(a / Math.pow(2, d), 2 * c) * h * h / (v * m);
  }
}), s0 = "sqrtm", fC = ["typed", "abs", "add", "multiply", "map", "sqrt", "subtract", "inv", "size", "max", "identity"], cC = /* @__PURE__ */ Q(s0, fC, (e) => {
  var {
    typed: r,
    abs: o,
    add: n,
    multiply: i,
    map: t,
    sqrt: u,
    subtract: l,
    inv: f,
    size: s,
    max: a,
    identity: c
  } = e, d = 1e3, h = 1e-6;
  function p(v) {
    var g, m = 0, x = v, y = c(s(v));
    do {
      var E = x;
      if (x = i(0.5, n(E, f(y))), y = i(0.5, n(y, f(E))), g = a(o(l(x, E))), g > h && ++m > d)
        throw new Error("computing square root of matrix: iterative method could not converge");
    } while (g > h);
    return x;
  }
  return r(s0, {
    "Array | Matrix": function(g) {
      var m = Fe(g) ? g.size() : ze(g);
      switch (m.length) {
        case 1:
          if (m[0] === 1)
            return t(g, u);
          throw new RangeError("Matrix must be square (size: " + Ze(m) + ")");
        case 2: {
          var x = m[0], y = m[1];
          if (x === y)
            return p(g);
          throw new RangeError("Matrix must be square (size: " + Ze(m) + ")");
        }
        default:
          throw new RangeError("Matrix must be at most two dimensional (size: " + Ze(m) + ")");
      }
    }
  });
}), u0 = "sylvester", lC = ["typed", "schur", "matrixFromColumns", "matrix", "multiply", "range", "concat", "transpose", "index", "subset", "add", "subtract", "identity", "lusolve", "abs"], dC = /* @__PURE__ */ Q(u0, lC, (e) => {
  var {
    typed: r,
    schur: o,
    matrixFromColumns: n,
    matrix: i,
    multiply: t,
    range: u,
    concat: l,
    transpose: f,
    index: s,
    subset: a,
    add: c,
    subtract: d,
    identity: h,
    lusolve: p,
    abs: v
  } = e;
  return r(u0, {
    "Matrix, Matrix, Matrix": g,
    "Array, Matrix, Matrix": function(x, y, E) {
      return g(i(x), y, E);
    },
    "Array, Array, Matrix": function(x, y, E) {
      return g(i(x), i(y), E);
    },
    "Array, Matrix, Array": function(x, y, E) {
      return g(i(x), y, i(E));
    },
    "Matrix, Array, Matrix": function(x, y, E) {
      return g(x, i(y), E);
    },
    "Matrix, Array, Array": function(x, y, E) {
      return g(x, i(y), i(E));
    },
    "Matrix, Matrix, Array": function(x, y, E) {
      return g(x, y, i(E));
    },
    "Array, Array, Array": function(x, y, E) {
      return g(i(x), i(y), i(E)).toArray();
    }
  });
  function g(m, x, y) {
    for (var E = x.size()[0], N = m.size()[0], S = o(m), R = S.T, O = S.U, B = o(t(-1, x)), $ = B.T, F = B.U, w = t(t(f(O), y), F), A = u(0, N), b = [], D = (W, fe) => l(W, fe, 1), M = (W, fe) => l(W, fe, 0), _ = 0; _ < E; _++)
      if (_ < E - 1 && v(a($, s(_ + 1, _))) > 1e-5) {
        for (var q = M(a(w, s(A, _)), a(w, s(A, _ + 1))), C = 0; C < _; C++)
          q = c(q, M(t(b[C], a($, s(C, _))), t(b[C], a($, s(C, _ + 1)))));
        var T = t(h(N), t(-1, a($, s(_, _)))), z = t(h(N), t(-1, a($, s(_ + 1, _)))), I = t(h(N), t(-1, a($, s(_, _ + 1)))), U = t(h(N), t(-1, a($, s(_ + 1, _ + 1)))), ee = M(D(c(R, T), z), D(I, c(R, U))), se = p(ee, q);
        b[_] = se.subset(s(u(0, N), 0)), b[_ + 1] = se.subset(s(u(N, 2 * N), 0)), _++;
      } else {
        for (var K = a(w, s(A, _)), J = 0; J < _; J++)
          K = c(K, t(b[J], a($, s(J, _))));
        var te = a($, s(_, _)), ne = d(R, t(te, h(N)));
        b[_] = p(ne, K);
      }
    var ue = i(n(...b)), V = t(O, t(ue, f(F)));
    return V;
  }
}), f0 = "schur", hC = ["typed", "matrix", "identity", "multiply", "qr", "norm", "subtract"], pC = /* @__PURE__ */ Q(f0, hC, (e) => {
  var {
    typed: r,
    matrix: o,
    identity: n,
    multiply: i,
    qr: t,
    norm: u,
    subtract: l
  } = e;
  return r(f0, {
    Array: function(a) {
      var c = f(o(a));
      return {
        U: c.U.valueOf(),
        T: c.T.valueOf()
      };
    },
    Matrix: function(a) {
      return f(a);
    }
  });
  function f(s) {
    var a = s.size()[0], c = s, d = n(a), h = 0, p;
    do {
      p = c;
      var v = t(c), g = v.Q, m = v.R;
      if (c = i(m, g), d = i(d, g), h++ > 100)
        break;
    } while (u(l(c, p)) > 1e-4);
    return {
      U: d,
      T: c
    };
  }
}), c0 = "lyap", vC = ["typed", "matrix", "sylvester", "multiply", "transpose"], mC = /* @__PURE__ */ Q(c0, vC, (e) => {
  var {
    typed: r,
    matrix: o,
    sylvester: n,
    multiply: i,
    transpose: t
  } = e;
  return r(c0, {
    "Matrix, Matrix": function(l, f) {
      return n(l, t(l), i(-1, f));
    },
    "Array, Matrix": function(l, f) {
      return n(o(l), t(o(l)), i(-1, f));
    },
    "Matrix, Array": function(l, f) {
      return n(l, t(o(l)), o(i(-1, f)));
    },
    "Array, Array": function(l, f) {
      return n(o(l), t(o(l)), o(i(-1, f))).toArray();
    }
  });
}), gC = "divide", bC = ["typed", "matrix", "multiply", "equalScalar", "divideScalar", "inv"], yC = /* @__PURE__ */ Q(gC, bC, (e) => {
  var {
    typed: r,
    matrix: o,
    multiply: n,
    equalScalar: i,
    divideScalar: t,
    inv: u
  } = e, l = Lr({
    typed: r,
    equalScalar: i
  }), f = Et({
    typed: r
  });
  return r("divide", l1({
    // we extend the signatures of divideScalar with signatures dealing with matrices
    "Array | Matrix, Array | Matrix": function(a, c) {
      return n(a, u(c));
    },
    "DenseMatrix, any": function(a, c) {
      return f(a, c, t, !1);
    },
    "SparseMatrix, any": function(a, c) {
      return l(a, c, t, !1);
    },
    "Array, any": function(a, c) {
      return f(o(a), c, t, !1).valueOf();
    },
    "any, Array | Matrix": function(a, c) {
      return n(a, u(c));
    }
  }, t.signatures));
}), l0 = "distance", wC = ["typed", "addScalar", "subtractScalar", "divideScalar", "multiplyScalar", "deepEqual", "sqrt", "abs"], xC = /* @__PURE__ */ Q(l0, wC, (e) => {
  var {
    typed: r,
    addScalar: o,
    subtractScalar: n,
    multiplyScalar: i,
    divideScalar: t,
    deepEqual: u,
    sqrt: l,
    abs: f
  } = e;
  return r(l0, {
    "Array, Array, Array": function(N, S, R) {
      if (N.length === 2 && S.length === 2 && R.length === 2) {
        if (!a(N))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
        if (!a(S))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
        if (!a(R))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
        if (u(S, R))
          throw new TypeError("LinePoint1 should not be same with LinePoint2");
        var O = n(R[1], S[1]), B = n(S[0], R[0]), $ = n(i(R[0], S[1]), i(S[0], R[1]));
        return g(N[0], N[1], O, B, $);
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    "Object, Object, Object": function(N, S, R) {
      if (Object.keys(N).length === 2 && Object.keys(S).length === 2 && Object.keys(R).length === 2) {
        if (!a(N))
          throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
        if (!a(S))
          throw new TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");
        if (!a(R))
          throw new TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");
        if (u(p(S), p(R)))
          throw new TypeError("LinePoint1 should not be same with LinePoint2");
        if ("pointX" in N && "pointY" in N && "lineOnePtX" in S && "lineOnePtY" in S && "lineTwoPtX" in R && "lineTwoPtY" in R) {
          var O = n(R.lineTwoPtY, S.lineOnePtY), B = n(S.lineOnePtX, R.lineTwoPtX), $ = n(i(R.lineTwoPtX, S.lineOnePtY), i(S.lineOnePtX, R.lineTwoPtY));
          return g(N.pointX, N.pointY, O, B, $);
        } else
          throw new TypeError("Key names do not match");
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    "Array, Array": function(N, S) {
      if (N.length === 2 && S.length === 3) {
        if (!a(N))
          throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
        if (!c(S))
          throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
        return g(N[0], N[1], S[0], S[1], S[2]);
      } else if (N.length === 3 && S.length === 6) {
        if (!c(N))
          throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
        if (!h(S))
          throw new TypeError("Array with 6 numbers or BigNumbers expected for second argument");
        return m(N[0], N[1], N[2], S[0], S[1], S[2], S[3], S[4], S[5]);
      } else if (N.length === S.length && N.length > 0) {
        if (!d(N))
          throw new TypeError("All values of an array should be numbers or BigNumbers");
        if (!d(S))
          throw new TypeError("All values of an array should be numbers or BigNumbers");
        return x(N, S);
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    "Object, Object": function(N, S) {
      if (Object.keys(N).length === 2 && Object.keys(S).length === 3) {
        if (!a(N))
          throw new TypeError("Values of pointX and pointY should be numbers or BigNumbers");
        if (!c(S))
          throw new TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");
        if ("pointX" in N && "pointY" in N && "xCoeffLine" in S && "yCoeffLine" in S && "constant" in S)
          return g(N.pointX, N.pointY, S.xCoeffLine, S.yCoeffLine, S.constant);
        throw new TypeError("Key names do not match");
      } else if (Object.keys(N).length === 3 && Object.keys(S).length === 6) {
        if (!c(N))
          throw new TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");
        if (!h(S))
          throw new TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");
        if ("pointX" in N && "pointY" in N && "x0" in S && "y0" in S && "z0" in S && "a" in S && "b" in S && "c" in S)
          return m(N.pointX, N.pointY, N.pointZ, S.x0, S.y0, S.z0, S.a, S.b, S.c);
        throw new TypeError("Key names do not match");
      } else if (Object.keys(N).length === 2 && Object.keys(S).length === 2) {
        if (!a(N))
          throw new TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");
        if (!a(S))
          throw new TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");
        if ("pointOneX" in N && "pointOneY" in N && "pointTwoX" in S && "pointTwoY" in S)
          return x([N.pointOneX, N.pointOneY], [S.pointTwoX, S.pointTwoY]);
        throw new TypeError("Key names do not match");
      } else if (Object.keys(N).length === 3 && Object.keys(S).length === 3) {
        if (!c(N))
          throw new TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");
        if (!c(S))
          throw new TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");
        if ("pointOneX" in N && "pointOneY" in N && "pointOneZ" in N && "pointTwoX" in S && "pointTwoY" in S && "pointTwoZ" in S)
          return x([N.pointOneX, N.pointOneY, N.pointOneZ], [S.pointTwoX, S.pointTwoY, S.pointTwoZ]);
        throw new TypeError("Key names do not match");
      } else
        throw new TypeError("Invalid Arguments: Try again");
    },
    Array: function(N) {
      if (!v(N))
        throw new TypeError("Incorrect array format entered for pairwise distance calculation");
      return y(N);
    }
  });
  function s(E) {
    return typeof E == "number" || Re(E);
  }
  function a(E) {
    return E.constructor !== Array && (E = p(E)), s(E[0]) && s(E[1]);
  }
  function c(E) {
    return E.constructor !== Array && (E = p(E)), s(E[0]) && s(E[1]) && s(E[2]);
  }
  function d(E) {
    return Array.isArray(E) || (E = p(E)), E.every(s);
  }
  function h(E) {
    return E.constructor !== Array && (E = p(E)), s(E[0]) && s(E[1]) && s(E[2]) && s(E[3]) && s(E[4]) && s(E[5]);
  }
  function p(E) {
    for (var N = Object.keys(E), S = [], R = 0; R < N.length; R++)
      S.push(E[N[R]]);
    return S;
  }
  function v(E) {
    if (E[0].length === 2 && s(E[0][0]) && s(E[0][1])) {
      if (E.some((N) => N.length !== 2 || !s(N[0]) || !s(N[1])))
        return !1;
    } else if (E[0].length === 3 && s(E[0][0]) && s(E[0][1]) && s(E[0][2])) {
      if (E.some((N) => N.length !== 3 || !s(N[0]) || !s(N[1]) || !s(N[2])))
        return !1;
    } else
      return !1;
    return !0;
  }
  function g(E, N, S, R, O) {
    var B = f(o(o(i(S, E), i(R, N)), O)), $ = l(o(i(S, S), i(R, R)));
    return t(B, $);
  }
  function m(E, N, S, R, O, B, $, F, w) {
    var A = [n(i(n(O, N), w), i(n(B, S), F)), n(i(n(B, S), $), i(n(R, E), w)), n(i(n(R, E), F), i(n(O, N), $))];
    A = l(o(o(i(A[0], A[0]), i(A[1], A[1])), i(A[2], A[2])));
    var b = l(o(o(i($, $), i(F, F)), i(w, w)));
    return t(A, b);
  }
  function x(E, N) {
    for (var S = E.length, R = 0, O = 0, B = 0; B < S; B++)
      O = n(E[B], N[B]), R = o(i(O, O), R);
    return l(R);
  }
  function y(E) {
    for (var N = [], S = [], R = [], O = 0; O < E.length - 1; O++)
      for (var B = O + 1; B < E.length; B++)
        E[0].length === 2 ? (S = [E[O][0], E[O][1]], R = [E[B][0], E[B][1]]) : E[0].length === 3 && (S = [E[O][0], E[O][1], E[O][2]], R = [E[B][0], E[B][1], E[B][2]]), N.push(x(S, R));
    return N;
  }
}), EC = "intersect", AC = ["typed", "config", "abs", "add", "addScalar", "matrix", "multiply", "multiplyScalar", "divideScalar", "subtract", "smaller", "equalScalar", "flatten", "isZero", "isNumeric"], SC = /* @__PURE__ */ Q(EC, AC, (e) => {
  var {
    typed: r,
    config: o,
    abs: n,
    add: i,
    addScalar: t,
    matrix: u,
    multiply: l,
    multiplyScalar: f,
    divideScalar: s,
    subtract: a,
    smaller: c,
    equalScalar: d,
    flatten: h,
    isZero: p,
    isNumeric: v
  } = e;
  return r("intersect", {
    "Array, Array, Array": g,
    "Array, Array, Array, Array": m,
    "Matrix, Matrix, Matrix": function(F, w, A) {
      var b = g(F.valueOf(), w.valueOf(), A.valueOf());
      return b === null ? null : u(b);
    },
    "Matrix, Matrix, Matrix, Matrix": function(F, w, A, b) {
      var D = m(F.valueOf(), w.valueOf(), A.valueOf(), b.valueOf());
      return D === null ? null : u(D);
    }
  });
  function g($, F, w) {
    if ($ = x($), F = x(F), w = x(w), !E($))
      throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
    if (!E(F))
      throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
    if (!N(w))
      throw new TypeError("Array with 4 numbers expected as third argument");
    return B($[0], $[1], $[2], F[0], F[1], F[2], w[0], w[1], w[2], w[3]);
  }
  function m($, F, w, A) {
    if ($ = x($), F = x(F), w = x(w), A = x(A), $.length === 2) {
      if (!y($))
        throw new TypeError("Array with 2 numbers or BigNumbers expected for first argument");
      if (!y(F))
        throw new TypeError("Array with 2 numbers or BigNumbers expected for second argument");
      if (!y(w))
        throw new TypeError("Array with 2 numbers or BigNumbers expected for third argument");
      if (!y(A))
        throw new TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");
      return S($, F, w, A);
    } else if ($.length === 3) {
      if (!E($))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for first argument");
      if (!E(F))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for second argument");
      if (!E(w))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for third argument");
      if (!E(A))
        throw new TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");
      return O($[0], $[1], $[2], F[0], F[1], F[2], w[0], w[1], w[2], A[0], A[1], A[2]);
    } else
      throw new TypeError("Arrays with two or thee dimensional points expected");
  }
  function x($) {
    return $.length === 1 ? $[0] : $.length > 1 && Array.isArray($[0]) && $.every((F) => Array.isArray(F) && F.length === 1) ? h($) : $;
  }
  function y($) {
    return $.length === 2 && v($[0]) && v($[1]);
  }
  function E($) {
    return $.length === 3 && v($[0]) && v($[1]) && v($[2]);
  }
  function N($) {
    return $.length === 4 && v($[0]) && v($[1]) && v($[2]) && v($[3]);
  }
  function S($, F, w, A) {
    var b = $, D = w, M = a(b, F), _ = a(D, A), q = a(f(M[0], _[1]), f(_[0], M[1]));
    if (p(q) || c(n(q), o.relTol))
      return null;
    var C = f(_[0], b[1]), T = f(_[1], b[0]), z = f(_[0], D[1]), I = f(_[1], D[0]), U = s(t(a(a(C, T), z), I), q);
    return i(l(M, U), b);
  }
  function R($, F, w, A, b, D, M, _, q, C, T, z) {
    var I = f(a($, F), a(w, A)), U = f(a(b, D), a(M, _)), ee = f(a(q, C), a(T, z));
    return t(t(I, U), ee);
  }
  function O($, F, w, A, b, D, M, _, q, C, T, z) {
    var I = R($, M, C, M, F, _, T, _, w, q, z, q), U = R(C, M, A, $, T, _, b, F, z, q, D, w), ee = R($, M, A, $, F, _, b, F, w, q, D, w), se = R(C, M, C, M, T, _, T, _, z, q, z, q), K = R(A, $, A, $, b, F, b, F, D, w, D, w), J = a(f(I, U), f(ee, se)), te = a(f(K, se), f(U, U));
    if (p(te))
      return null;
    var ne = s(J, te), ue = s(t(I, f(ne, U)), se), V = t($, f(ne, a(A, $))), W = t(F, f(ne, a(b, F))), fe = t(w, f(ne, a(D, w))), pe = t(M, f(ue, a(C, M))), Y = t(_, f(ue, a(T, _))), k = t(q, f(ue, a(z, q)));
    return d(V, pe) && d(W, Y) && d(fe, k) ? [V, W, fe] : null;
  }
  function B($, F, w, A, b, D, M, _, q, C) {
    var T = f($, M), z = f(A, M), I = f(F, _), U = f(b, _), ee = f(w, q), se = f(D, q), K = a(a(a(C, T), I), ee), J = a(a(a(t(t(z, U), se), T), I), ee), te = s(K, J), ne = t($, f(te, a(A, $))), ue = t(F, f(te, a(b, F))), V = t(w, f(te, a(D, w)));
    return [ne, ue, V];
  }
}), d0 = "sum", DC = ["typed", "config", "add", "numeric"], lb = /* @__PURE__ */ Q(d0, DC, (e) => {
  var {
    typed: r,
    config: o,
    add: n,
    numeric: i
  } = e;
  return r(d0, {
    // sum([a, b, c, d, ...])
    "Array | Matrix": t,
    // sum([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": u,
    // sum(a, b, c, d, ...)
    "...": function(f) {
      if (Xn(f))
        throw new TypeError("Scalar values expected in function sum");
      return t(f);
    }
  });
  function t(l) {
    var f;
    return Wt(l, function(s) {
      try {
        f = f === void 0 ? s : n(f, s);
      } catch (a) {
        throw Wr(a, "sum", s);
      }
    }), f === void 0 && (f = i(0, o.number)), typeof f == "string" && (f = i(f, sn(f, o))), f;
  }
  function u(l, f) {
    try {
      var s = no(l, f, n);
      return s;
    } catch (a) {
      throw Wr(a, "sum");
    }
  }
}), ta = "cumsum", NC = ["typed", "add", "unaryPlus"], db = /* @__PURE__ */ Q(ta, NC, (e) => {
  var {
    typed: r,
    add: o,
    unaryPlus: n
  } = e;
  return r(ta, {
    // sum([a, b, c, d, ...])
    Array: i,
    Matrix: function(s) {
      return s.create(i(s.valueOf()));
    },
    // sum([a, b, c, d, ...], dim)
    "Array, number | BigNumber": u,
    "Matrix, number | BigNumber": function(s, a) {
      return s.create(u(s.valueOf(), a));
    },
    // cumsum(a, b, c, d, ...)
    "...": function(s) {
      if (Xn(s))
        throw new TypeError("All values expected to be scalar in function cumsum");
      return i(s);
    }
  });
  function i(f) {
    try {
      return t(f);
    } catch (s) {
      throw Wr(s, ta);
    }
  }
  function t(f) {
    if (f.length === 0)
      return [];
    for (var s = [n(f[0])], a = 1; a < f.length; ++a)
      s.push(o(s[a - 1], f[a]));
    return s;
  }
  function u(f, s) {
    var a = ze(f);
    if (s < 0 || s >= a.length)
      throw new dt(s, a.length);
    try {
      return l(f, s);
    } catch (c) {
      throw Wr(c, ta);
    }
  }
  function l(f, s) {
    var a, c, d;
    if (s <= 0) {
      var h = f[0][0];
      if (Array.isArray(h)) {
        for (d = j1(f), c = [], a = 0; a < d.length; a++)
          c[a] = l(d[a], s - 1);
        return c;
      } else
        return t(f);
    } else {
      for (c = [], a = 0; a < f.length; a++)
        c[a] = l(f[a], s - 1);
      return c;
    }
  }
}), h0 = "mean", MC = ["typed", "add", "divide"], hb = /* @__PURE__ */ Q(h0, MC, (e) => {
  var {
    typed: r,
    add: o,
    divide: n
  } = e;
  return r(h0, {
    // mean([a, b, c, d, ...])
    "Array | Matrix": t,
    // mean([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": i,
    // mean(a, b, c, d, ...)
    "...": function(l) {
      if (Xn(l))
        throw new TypeError("Scalar values expected in function mean");
      return t(l);
    }
  });
  function i(u, l) {
    try {
      var f = no(u, l, o), s = Array.isArray(u) ? ze(u) : u.size();
      return n(f, s[l]);
    } catch (a) {
      throw Wr(a, "mean");
    }
  }
  function t(u) {
    var l, f = 0;
    if (Wt(u, function(s) {
      try {
        l = l === void 0 ? s : o(l, s), f++;
      } catch (a) {
        throw Wr(a, "mean", s);
      }
    }), f === 0)
      throw new Error("Cannot calculate the mean of an empty array");
    return n(l, f);
  }
}), p0 = "median", _C = ["typed", "add", "divide", "compare", "partitionSelect"], CC = /* @__PURE__ */ Q(p0, _C, (e) => {
  var {
    typed: r,
    add: o,
    divide: n,
    compare: i,
    partitionSelect: t
  } = e;
  function u(s) {
    try {
      s = ir(s.valueOf());
      var a = s.length;
      if (a === 0)
        throw new Error("Cannot calculate median of an empty array");
      if (a % 2 === 0) {
        for (var c = a / 2 - 1, d = t(s, c + 1), h = s[c], p = 0; p < c; ++p)
          i(s[p], h) > 0 && (h = s[p]);
        return f(h, d);
      } else {
        var v = t(s, (a - 1) / 2);
        return l(v);
      }
    } catch (g) {
      throw Wr(g, "median");
    }
  }
  var l = r({
    "number | BigNumber | Complex | Unit": function(a) {
      return a;
    }
  }), f = r({
    "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function(a, c) {
      return n(o(a, c), 2);
    }
  });
  return r(p0, {
    // median([a, b, c, d, ...])
    "Array | Matrix": u,
    // median([a, b, c, d, ...], dim)
    "Array | Matrix, number | BigNumber": function(a, c) {
      throw new Error("median(A, dim) is not yet supported");
    },
    // median(a, b, c, d, ...)
    "...": function(a) {
      if (Xn(a))
        throw new TypeError("Scalar values expected in function median");
      return u(a);
    }
  });
}), v0 = "mad", TC = ["typed", "abs", "map", "median", "subtract"], BC = /* @__PURE__ */ Q(v0, TC, (e) => {
  var {
    typed: r,
    abs: o,
    map: n,
    median: i,
    subtract: t
  } = e;
  return r(v0, {
    // mad([a, b, c, d, ...])
    "Array | Matrix": u,
    // mad(a, b, c, d, ...)
    "...": function(f) {
      return u(f);
    }
  });
  function u(l) {
    if (l = ir(l.valueOf()), l.length === 0)
      throw new Error("Cannot calculate median absolute deviation (mad) of an empty array");
    try {
      var f = i(l);
      return i(n(l, function(s) {
        return o(t(s, f));
      }));
    } catch (s) {
      throw s instanceof TypeError && s.message.includes("median") ? new TypeError(s.message.replace("median", "mad")) : Wr(s, "mad");
    }
  }
}), Ao = "unbiased", m0 = "variance", FC = ["typed", "add", "subtract", "multiply", "divide", "apply", "isNaN"], pb = /* @__PURE__ */ Q(m0, FC, (e) => {
  var {
    typed: r,
    add: o,
    subtract: n,
    multiply: i,
    divide: t,
    apply: u,
    isNaN: l
  } = e;
  return r(m0, {
    // variance([a, b, c, d, ...])
    "Array | Matrix": function(c) {
      return f(c, Ao);
    },
    // variance([a, b, c, d, ...], normalization)
    "Array | Matrix, string": f,
    // variance([a, b, c, c, ...], dim)
    "Array | Matrix, number | BigNumber": function(c, d) {
      return s(c, d, Ao);
    },
    // variance([a, b, c, c, ...], dim, normalization)
    "Array | Matrix, number | BigNumber, string": s,
    // variance(a, b, c, d, ...)
    "...": function(c) {
      return f(c, Ao);
    }
  });
  function f(a, c) {
    var d, h = 0;
    if (a.length === 0)
      throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
    if (Wt(a, function(g) {
      try {
        d = d === void 0 ? g : o(d, g), h++;
      } catch (m) {
        throw Wr(m, "variance", g);
      }
    }), h === 0)
      throw new Error("Cannot calculate variance of an empty array");
    var p = t(d, h);
    if (d = void 0, Wt(a, function(g) {
      var m = n(g, p);
      d = d === void 0 ? i(m, m) : o(d, i(m, m));
    }), l(d))
      return d;
    switch (c) {
      case "uncorrected":
        return t(d, h);
      case "biased":
        return t(d, h + 1);
      case "unbiased": {
        var v = Re(d) ? d.mul(0) : 0;
        return h === 1 ? v : t(d, h - 1);
      }
      default:
        throw new Error('Unknown normalization "' + c + '". Choose "unbiased" (default), "uncorrected", or "biased".');
    }
  }
  function s(a, c, d) {
    try {
      if (a.length === 0)
        throw new SyntaxError("Function variance requires one or more parameters (0 provided)");
      return u(a, c, (h) => f(h, d));
    } catch (h) {
      throw Wr(h, "variance");
    }
  }
}), g0 = "quantileSeq", IC = ["typed", "?bignumber", "add", "subtract", "divide", "multiply", "partitionSelect", "compare", "isInteger", "smaller", "smallerEq", "larger"], vb = /* @__PURE__ */ Q(g0, IC, (e) => {
  var {
    typed: r,
    bignumber: o,
    add: n,
    subtract: i,
    divide: t,
    multiply: u,
    partitionSelect: l,
    compare: f,
    isInteger: s,
    smaller: a,
    smallerEq: c,
    larger: d
  } = e, h = Pf({
    typed: r,
    isInteger: s
  });
  return r(g0, {
    "Array | Matrix, number | BigNumber": (x, y) => v(x, y, !1),
    "Array | Matrix, number | BigNumber, number": (x, y, E) => p(x, y, !1, E, v),
    "Array | Matrix, number | BigNumber, boolean": v,
    "Array | Matrix, number | BigNumber, boolean, number": (x, y, E, N) => p(x, y, E, N, v),
    "Array | Matrix, Array | Matrix": (x, y) => g(x, y, !1),
    "Array | Matrix, Array | Matrix, number": (x, y, E) => p(x, y, !1, E, g),
    "Array | Matrix, Array | Matrix, boolean": g,
    "Array | Matrix, Array | Matrix, boolean, number": (x, y, E, N) => p(x, y, E, N, g)
  });
  function p(x, y, E, N, S) {
    return h(x, N, (R) => S(R, y, E));
  }
  function v(x, y, E) {
    var N, S = x.valueOf();
    if (a(y, 0))
      throw new Error("N/prob must be non-negative");
    if (c(y, 1))
      return $e(y) ? m(S, y, E) : o(m(S, y, E));
    if (d(y, 1)) {
      if (!s(y))
        throw new Error("N must be a positive integer");
      if (d(y, 4294967295))
        throw new Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");
      var R = n(y, 1);
      N = [];
      for (var O = 0; a(O, y); O++) {
        var B = t(O + 1, R);
        N.push(m(S, B, E));
      }
      return $e(y) ? N : o(N);
    }
  }
  function g(x, y, E) {
    for (var N = x.valueOf(), S = y.valueOf(), R = [], O = 0; O < S.length; ++O)
      R.push(m(N, S[O], E));
    return R;
  }
  function m(x, y, E) {
    var N = ir(x), S = N.length;
    if (S === 0)
      throw new Error("Cannot calculate quantile of an empty sequence");
    var R = $e(y) ? y * (S - 1) : y.times(S - 1), O = $e(y) ? Math.floor(R) : R.floor().toNumber(), B = $e(y) ? R % 1 : R.minus(O);
    if (s(R))
      return E ? N[R] : l(N, $e(y) ? R : R.valueOf());
    var $, F;
    if (E)
      $ = N[O], F = N[O + 1];
    else {
      F = l(N, O + 1), $ = N[O];
      for (var w = 0; w < O; ++w)
        f(N[w], $) > 0 && ($ = N[w]);
    }
    return n(u($, i(1, B)), u(F, B));
  }
}), b0 = "std", OC = ["typed", "map", "sqrt", "variance"], mb = /* @__PURE__ */ Q(b0, OC, (e) => {
  var {
    typed: r,
    map: o,
    sqrt: n,
    variance: i
  } = e;
  return r(b0, {
    // std([a, b, c, d, ...])
    "Array | Matrix": t,
    // std([a, b, c, d, ...], normalization)
    "Array | Matrix, string": t,
    // std([a, b, c, c, ...], dim)
    "Array | Matrix, number | BigNumber": t,
    // std([a, b, c, c, ...], dim, normalization)
    "Array | Matrix, number | BigNumber, string": t,
    // std(a, b, c, d, ...)
    "...": function(l) {
      return t(l);
    }
  });
  function t(u, l) {
    if (u.length === 0)
      throw new SyntaxError("Function std requires one or more parameters (0 provided)");
    try {
      var f = i.apply(null, arguments);
      return nt(f) ? o(f, n) : n(f);
    } catch (s) {
      throw s instanceof TypeError && s.message.includes(" variance") ? new TypeError(s.message.replace(" variance", " std")) : s;
    }
  }
}), y0 = "corr", RC = ["typed", "matrix", "mean", "sqrt", "sum", "add", "subtract", "multiply", "pow", "divide"], PC = /* @__PURE__ */ Q(y0, RC, (e) => {
  var {
    typed: r,
    matrix: o,
    sqrt: n,
    sum: i,
    add: t,
    subtract: u,
    multiply: l,
    pow: f,
    divide: s
  } = e;
  return r(y0, {
    "Array, Array": function(h, p) {
      return a(h, p);
    },
    "Matrix, Matrix": function(h, p) {
      var v = a(h.toArray(), p.toArray());
      return Array.isArray(v) ? o(v) : v;
    }
  });
  function a(d, h) {
    var p = [];
    if (Array.isArray(d[0]) && Array.isArray(h[0])) {
      if (d.length !== h.length)
        throw new SyntaxError("Dimension mismatch. Array A and B must have the same length.");
      for (var v = 0; v < d.length; v++) {
        if (d[v].length !== h[v].length)
          throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
        p.push(c(d[v], h[v]));
      }
      return p;
    } else {
      if (d.length !== h.length)
        throw new SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");
      return c(d, h);
    }
  }
  function c(d, h) {
    var p = d.length, v = i(d), g = i(h), m = d.reduce((S, R, O) => t(S, l(R, h[O])), 0), x = i(d.map((S) => f(S, 2))), y = i(h.map((S) => f(S, 2))), E = u(l(p, m), l(v, g)), N = n(l(u(l(p, x), f(v, 2)), u(l(p, y), f(g, 2))));
    return s(E, N);
  }
}), w0 = "combinations", qC = ["typed"], $C = /* @__PURE__ */ Q(w0, qC, (e) => {
  var {
    typed: r
  } = e;
  return r(w0, {
    "number, number": bg,
    "BigNumber, BigNumber": function(n, i) {
      var t = n.constructor, u, l, f = n.minus(i), s = new t(1);
      if (!x0(n) || !x0(i))
        throw new TypeError("Positive integer value expected in function combinations");
      if (i.gt(n))
        throw new TypeError("k must be less than n in function combinations");
      if (u = s, i.lt(f))
        for (l = s; l.lte(f); l = l.plus(s))
          u = u.times(i.plus(l)).dividedBy(l);
      else
        for (l = s; l.lte(i); l = l.plus(s))
          u = u.times(f.plus(l)).dividedBy(l);
      return u;
    }
    // TODO: implement support for collection in combinations
  });
});
function x0(e) {
  return e.isInteger() && e.gte(0);
}
var E0 = "combinationsWithRep", zC = ["typed"], LC = /* @__PURE__ */ Q(E0, zC, (e) => {
  var {
    typed: r
  } = e;
  return r(E0, {
    "number, number": function(n, i) {
      if (!Te(n) || n < 0)
        throw new TypeError("Positive integer value expected in function combinationsWithRep");
      if (!Te(i) || i < 0)
        throw new TypeError("Positive integer value expected in function combinationsWithRep");
      if (n < 1)
        throw new TypeError("k must be less than or equal to n + k - 1");
      if (i < n - 1) {
        var t = kt(n, n + i - 1);
        return t / kt(1, i);
      }
      var u = kt(i + 1, n + i - 1);
      return u / kt(1, n - 1);
    },
    "BigNumber, BigNumber": function(n, i) {
      var t = n.constructor, u, l, f = new t(1), s = n.minus(f);
      if (!A0(n) || !A0(i))
        throw new TypeError("Positive integer value expected in function combinationsWithRep");
      if (n.lt(f))
        throw new TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");
      if (u = f, i.lt(s))
        for (l = f; l.lte(s); l = l.plus(f))
          u = u.times(i.plus(l)).dividedBy(l);
      else
        for (l = f; l.lte(i); l = l.plus(f))
          u = u.times(s.plus(l)).dividedBy(l);
      return u;
    }
  });
});
function A0(e) {
  return e.isInteger() && e.gte(0);
}
var S0 = "gamma", UC = ["typed", "config", "multiplyScalar", "pow", "BigNumber", "Complex"], kC = /* @__PURE__ */ Q(S0, UC, (e) => {
  var {
    typed: r,
    config: o,
    multiplyScalar: n,
    pow: i,
    BigNumber: t,
    Complex: u
  } = e;
  function l(s) {
    if (s.im === 0)
      return Ta(s.re);
    if (s.re < 0.5) {
      var a = new u(1 - s.re, -s.im), c = new u(Math.PI * s.re, Math.PI * s.im);
      return new u(Math.PI).div(c.sin()).div(l(a));
    }
    s = new u(s.re - 1, s.im);
    for (var d = new u(Ln[0], 0), h = 1; h < Ln.length; ++h) {
      var p = new u(Ln[h], 0);
      d = d.add(p.div(s.add(h)));
    }
    var v = new u(s.re + wg + 0.5, s.im), g = Math.sqrt(2 * Math.PI), m = v.pow(s.add(0.5)), x = v.neg().exp();
    return d.mul(g).mul(m).mul(x);
  }
  return r(S0, {
    number: Ta,
    Complex: l,
    BigNumber: function(a) {
      if (a.isInteger())
        return a.isNegative() || a.isZero() ? new t(1 / 0) : f(a.minus(1));
      if (!a.isFinite())
        return new t(a.isNegative() ? NaN : 1 / 0);
      throw new Error("Integer BigNumber expected");
    }
  });
  function f(s) {
    if (s < 8)
      return new t([1, 1, 2, 6, 24, 120, 720, 5040][s]);
    var a = o.precision + (Math.log(s.toNumber()) | 0), c = t.clone({
      precision: a
    });
    if (s % 2 === 1)
      return s.times(f(new t(s - 1)));
    for (var d = s, h = new c(s), p = s.toNumber(); d > 2; )
      d -= 2, p += d, h = h.times(p);
    return new t(h.toPrecision(t.precision));
  }
}), D0 = "lgamma", HC = ["Complex", "typed"], GC = /* @__PURE__ */ Q(D0, HC, (e) => {
  var {
    Complex: r,
    typed: o
  } = e, n = 7, i = 7, t = [-0.029550653594771242, 0.00641025641025641, -0.0019175269175269176, 8417508417508417e-19, -5952380952380953e-19, 7936507936507937e-19, -0.002777777777777778, 0.08333333333333333];
  return o(D0, {
    number: Ba,
    Complex: u,
    BigNumber: function() {
      throw new Error("mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber");
    }
  });
  function u(s) {
    var a = 6.283185307179586, c = 1.1447298858494002, d = 0.1;
    if (s.isNaN())
      return new r(NaN, NaN);
    if (s.im === 0)
      return new r(Ba(s.re), 0);
    if (s.re >= n || Math.abs(s.im) >= i)
      return l(s);
    if (s.re <= d) {
      var h = T2(a, s.im) * Math.floor(0.5 * s.re + 0.25), p = s.mul(Math.PI).sin().log(), v = u(new r(1 - s.re, -s.im));
      return new r(c, h).sub(p).sub(v);
    } else
      return s.im >= 0 ? f(s) : f(s.conjugate()).conjugate();
  }
  function l(s) {
    for (var a = s.sub(0.5).mul(s.log()).sub(s).add(xg), c = new r(1, 0).div(s), d = c.div(s), h = t[0], p = t[1], v = 2 * d.re, g = d.re * d.re + d.im * d.im, m = 2; m < 8; m++) {
      var x = p;
      p = -g * h + t[m], h = v * h + x;
    }
    var y = c.mul(d.mul(h).add(p));
    return a.add(y);
  }
  function f(s) {
    var a = 0, c = 0, d = s;
    for (s = s.add(1); s.re <= n; ) {
      d = d.mul(s);
      var h = d.im < 0 ? 1 : 0;
      h !== 0 && c === 0 && a++, c = h, s = s.add(1);
    }
    return l(s).sub(d.log()).sub(new r(0, a * 2 * Math.PI * 1));
  }
}), N0 = "factorial", VC = ["typed", "gamma"], WC = /* @__PURE__ */ Q(N0, VC, (e) => {
  var {
    typed: r,
    gamma: o
  } = e;
  return r(N0, {
    number: function(i) {
      if (i < 0)
        throw new Error("Value must be non-negative");
      return o(i + 1);
    },
    BigNumber: function(i) {
      if (i.isNegative())
        throw new Error("Value must be non-negative");
      return o(i.plus(1));
    },
    "Array | Matrix": r.referToSelf((n) => (i) => Ke(i, n))
  });
}), M0 = "kldivergence", KC = ["typed", "matrix", "divide", "sum", "multiply", "map", "dotDivide", "log", "isNumeric"], ZC = /* @__PURE__ */ Q(M0, KC, (e) => {
  var {
    typed: r,
    matrix: o,
    divide: n,
    sum: i,
    multiply: t,
    map: u,
    dotDivide: l,
    log: f,
    isNumeric: s
  } = e;
  return r(M0, {
    "Array, Array": function(d, h) {
      return a(o(d), o(h));
    },
    "Matrix, Array": function(d, h) {
      return a(d, o(h));
    },
    "Array, Matrix": function(d, h) {
      return a(o(d), h);
    },
    "Matrix, Matrix": function(d, h) {
      return a(d, h);
    }
  });
  function a(c, d) {
    var h = d.size().length, p = c.size().length;
    if (h > 1)
      throw new Error("first object must be one dimensional");
    if (p > 1)
      throw new Error("second object must be one dimensional");
    if (h !== p)
      throw new Error("Length of two vectors must be equal");
    var v = i(c);
    if (v === 0)
      throw new Error("Sum of elements in first object must be non zero");
    var g = i(d);
    if (g === 0)
      throw new Error("Sum of elements in second object must be non zero");
    var m = n(c, i(c)), x = n(d, i(d)), y = i(t(m, u(l(m, x), (E) => f(E))));
    return s(y) ? y : Number.NaN;
  }
}), _0 = "multinomial", jC = ["typed", "add", "divide", "multiply", "factorial", "isInteger", "isPositive"], YC = /* @__PURE__ */ Q(_0, jC, (e) => {
  var {
    typed: r,
    add: o,
    divide: n,
    multiply: i,
    factorial: t,
    isInteger: u,
    isPositive: l
  } = e;
  return r(_0, {
    "Array | Matrix": function(s) {
      var a = 0, c = 1;
      return Wt(s, function(d) {
        if (!u(d) || !l(d))
          throw new TypeError("Positive integer value expected in function multinomial");
        a = o(a, d), c = i(c, t(d));
      }), n(t(a), c);
    }
  });
}), C0 = "permutations", XC = ["typed", "factorial"], JC = /* @__PURE__ */ Q(C0, XC, (e) => {
  var {
    typed: r,
    factorial: o
  } = e;
  return r(C0, {
    "number | BigNumber": o,
    "number, number": function(i, t) {
      if (!Te(i) || i < 0)
        throw new TypeError("Positive integer value expected in function permutations");
      if (!Te(t) || t < 0)
        throw new TypeError("Positive integer value expected in function permutations");
      if (t > i)
        throw new TypeError("second argument k must be less than or equal to first argument n");
      return kt(i - t + 1, i);
    },
    "BigNumber, BigNumber": function(i, t) {
      var u, l;
      if (!T0(i) || !T0(t))
        throw new TypeError("Positive integer value expected in function permutations");
      if (t.gt(i))
        throw new TypeError("second argument k must be less than or equal to first argument n");
      var f = i.mul(0).add(1);
      for (u = f, l = i.minus(t).plus(1); l.lte(i); l = l.plus(1))
        u = u.times(l);
      return u;
    }
    // TODO: implement support for collection in permutations
  });
});
function T0(e) {
  return e.isInteger() && e.gte(0);
}
var Hf = { exports: {} };
Hf.exports;
(function(e) {
  (function(r, o, n) {
    function i(f) {
      var s = this, a = l();
      s.next = function() {
        var c = 2091639 * s.s0 + s.c * 23283064365386963e-26;
        return s.s0 = s.s1, s.s1 = s.s2, s.s2 = c - (s.c = c | 0);
      }, s.c = 1, s.s0 = a(" "), s.s1 = a(" "), s.s2 = a(" "), s.s0 -= a(f), s.s0 < 0 && (s.s0 += 1), s.s1 -= a(f), s.s1 < 0 && (s.s1 += 1), s.s2 -= a(f), s.s2 < 0 && (s.s2 += 1), a = null;
    }
    function t(f, s) {
      return s.c = f.c, s.s0 = f.s0, s.s1 = f.s1, s.s2 = f.s2, s;
    }
    function u(f, s) {
      var a = new i(f), c = s && s.state, d = a.next;
      return d.int32 = function() {
        return a.next() * 4294967296 | 0;
      }, d.double = function() {
        return d() + (d() * 2097152 | 0) * 11102230246251565e-32;
      }, d.quick = d, c && (typeof c == "object" && t(c, a), d.state = function() {
        return t(a, {});
      }), d;
    }
    function l() {
      var f = 4022871197, s = function(a) {
        a = String(a);
        for (var c = 0; c < a.length; c++) {
          f += a.charCodeAt(c);
          var d = 0.02519603282416938 * f;
          f = d >>> 0, d -= f, d *= f, f = d >>> 0, d -= f, f += d * 4294967296;
        }
        return (f >>> 0) * 23283064365386963e-26;
      };
      return s;
    }
    o && o.exports ? o.exports = u : n && n.amd ? n(function() {
      return u;
    }) : this.alea = u;
  })(
    Xe,
    e,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(Hf);
var QC = Hf.exports, Gf = { exports: {} };
Gf.exports;
(function(e) {
  (function(r, o, n) {
    function i(l) {
      var f = this, s = "";
      f.x = 0, f.y = 0, f.z = 0, f.w = 0, f.next = function() {
        var c = f.x ^ f.x << 11;
        return f.x = f.y, f.y = f.z, f.z = f.w, f.w ^= f.w >>> 19 ^ c ^ c >>> 8;
      }, l === (l | 0) ? f.x = l : s += l;
      for (var a = 0; a < s.length + 64; a++)
        f.x ^= s.charCodeAt(a) | 0, f.next();
    }
    function t(l, f) {
      return f.x = l.x, f.y = l.y, f.z = l.z, f.w = l.w, f;
    }
    function u(l, f) {
      var s = new i(l), a = f && f.state, c = function() {
        return (s.next() >>> 0) / 4294967296;
      };
      return c.double = function() {
        do
          var d = s.next() >>> 11, h = (s.next() >>> 0) / 4294967296, p = (d + h) / (1 << 21);
        while (p === 0);
        return p;
      }, c.int32 = s.next, c.quick = c, a && (typeof a == "object" && t(a, s), c.state = function() {
        return t(s, {});
      }), c;
    }
    o && o.exports ? o.exports = u : n && n.amd ? n(function() {
      return u;
    }) : this.xor128 = u;
  })(
    Xe,
    e,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(Gf);
var eT = Gf.exports, Vf = { exports: {} };
Vf.exports;
(function(e) {
  (function(r, o, n) {
    function i(l) {
      var f = this, s = "";
      f.next = function() {
        var c = f.x ^ f.x >>> 2;
        return f.x = f.y, f.y = f.z, f.z = f.w, f.w = f.v, (f.d = f.d + 362437 | 0) + (f.v = f.v ^ f.v << 4 ^ (c ^ c << 1)) | 0;
      }, f.x = 0, f.y = 0, f.z = 0, f.w = 0, f.v = 0, l === (l | 0) ? f.x = l : s += l;
      for (var a = 0; a < s.length + 64; a++)
        f.x ^= s.charCodeAt(a) | 0, a == s.length && (f.d = f.x << 10 ^ f.x >>> 4), f.next();
    }
    function t(l, f) {
      return f.x = l.x, f.y = l.y, f.z = l.z, f.w = l.w, f.v = l.v, f.d = l.d, f;
    }
    function u(l, f) {
      var s = new i(l), a = f && f.state, c = function() {
        return (s.next() >>> 0) / 4294967296;
      };
      return c.double = function() {
        do
          var d = s.next() >>> 11, h = (s.next() >>> 0) / 4294967296, p = (d + h) / (1 << 21);
        while (p === 0);
        return p;
      }, c.int32 = s.next, c.quick = c, a && (typeof a == "object" && t(a, s), c.state = function() {
        return t(s, {});
      }), c;
    }
    o && o.exports ? o.exports = u : n && n.amd ? n(function() {
      return u;
    }) : this.xorwow = u;
  })(
    Xe,
    e,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(Vf);
var rT = Vf.exports, Wf = { exports: {} };
Wf.exports;
(function(e) {
  (function(r, o, n) {
    function i(l) {
      var f = this;
      f.next = function() {
        var a = f.x, c = f.i, d, h;
        return d = a[c], d ^= d >>> 7, h = d ^ d << 24, d = a[c + 1 & 7], h ^= d ^ d >>> 10, d = a[c + 3 & 7], h ^= d ^ d >>> 3, d = a[c + 4 & 7], h ^= d ^ d << 7, d = a[c + 7 & 7], d = d ^ d << 13, h ^= d ^ d << 9, a[c] = h, f.i = c + 1 & 7, h;
      };
      function s(a, c) {
        var d, h = [];
        if (c === (c | 0))
          h[0] = c;
        else
          for (c = "" + c, d = 0; d < c.length; ++d)
            h[d & 7] = h[d & 7] << 15 ^ c.charCodeAt(d) + h[d + 1 & 7] << 13;
        for (; h.length < 8; )
          h.push(0);
        for (d = 0; d < 8 && h[d] === 0; ++d)
          ;
        for (d == 8 ? h[7] = -1 : h[d], a.x = h, a.i = 0, d = 256; d > 0; --d)
          a.next();
      }
      s(f, l);
    }
    function t(l, f) {
      return f.x = l.x.slice(), f.i = l.i, f;
    }
    function u(l, f) {
      l == null && (l = +/* @__PURE__ */ new Date());
      var s = new i(l), a = f && f.state, c = function() {
        return (s.next() >>> 0) / 4294967296;
      };
      return c.double = function() {
        do
          var d = s.next() >>> 11, h = (s.next() >>> 0) / 4294967296, p = (d + h) / (1 << 21);
        while (p === 0);
        return p;
      }, c.int32 = s.next, c.quick = c, a && (a.x && t(a, s), c.state = function() {
        return t(s, {});
      }), c;
    }
    o && o.exports ? o.exports = u : n && n.amd ? n(function() {
      return u;
    }) : this.xorshift7 = u;
  })(
    Xe,
    e,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(Wf);
var tT = Wf.exports, Kf = { exports: {} };
Kf.exports;
(function(e) {
  (function(r, o, n) {
    function i(l) {
      var f = this;
      f.next = function() {
        var a = f.w, c = f.X, d = f.i, h, p;
        return f.w = a = a + 1640531527 | 0, p = c[d + 34 & 127], h = c[d = d + 1 & 127], p ^= p << 13, h ^= h << 17, p ^= p >>> 15, h ^= h >>> 12, p = c[d] = p ^ h, f.i = d, p + (a ^ a >>> 16) | 0;
      };
      function s(a, c) {
        var d, h, p, v, g, m = [], x = 128;
        for (c === (c | 0) ? (h = c, c = null) : (c = c + "\0", h = 0, x = Math.max(x, c.length)), p = 0, v = -32; v < x; ++v)
          c && (h ^= c.charCodeAt((v + 32) % c.length)), v === 0 && (g = h), h ^= h << 10, h ^= h >>> 15, h ^= h << 4, h ^= h >>> 13, v >= 0 && (g = g + 1640531527 | 0, d = m[v & 127] ^= h + g, p = d == 0 ? p + 1 : 0);
        for (p >= 128 && (m[(c && c.length || 0) & 127] = -1), p = 127, v = 4 * 128; v > 0; --v)
          h = m[p + 34 & 127], d = m[p = p + 1 & 127], h ^= h << 13, d ^= d << 17, h ^= h >>> 15, d ^= d >>> 12, m[p] = h ^ d;
        a.w = g, a.X = m, a.i = p;
      }
      s(f, l);
    }
    function t(l, f) {
      return f.i = l.i, f.w = l.w, f.X = l.X.slice(), f;
    }
    function u(l, f) {
      l == null && (l = +/* @__PURE__ */ new Date());
      var s = new i(l), a = f && f.state, c = function() {
        return (s.next() >>> 0) / 4294967296;
      };
      return c.double = function() {
        do
          var d = s.next() >>> 11, h = (s.next() >>> 0) / 4294967296, p = (d + h) / (1 << 21);
        while (p === 0);
        return p;
      }, c.int32 = s.next, c.quick = c, a && (a.X && t(a, s), c.state = function() {
        return t(s, {});
      }), c;
    }
    o && o.exports ? o.exports = u : n && n.amd ? n(function() {
      return u;
    }) : this.xor4096 = u;
  })(
    Xe,
    // window object or global
    e,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(Kf);
var nT = Kf.exports, Zf = { exports: {} };
Zf.exports;
(function(e) {
  (function(r, o, n) {
    function i(l) {
      var f = this, s = "";
      f.next = function() {
        var c = f.b, d = f.c, h = f.d, p = f.a;
        return c = c << 25 ^ c >>> 7 ^ d, d = d - h | 0, h = h << 24 ^ h >>> 8 ^ p, p = p - c | 0, f.b = c = c << 20 ^ c >>> 12 ^ d, f.c = d = d - h | 0, f.d = h << 16 ^ d >>> 16 ^ p, f.a = p - c | 0;
      }, f.a = 0, f.b = 0, f.c = -1640531527, f.d = 1367130551, l === Math.floor(l) ? (f.a = l / 4294967296 | 0, f.b = l | 0) : s += l;
      for (var a = 0; a < s.length + 20; a++)
        f.b ^= s.charCodeAt(a) | 0, f.next();
    }
    function t(l, f) {
      return f.a = l.a, f.b = l.b, f.c = l.c, f.d = l.d, f;
    }
    function u(l, f) {
      var s = new i(l), a = f && f.state, c = function() {
        return (s.next() >>> 0) / 4294967296;
      };
      return c.double = function() {
        do
          var d = s.next() >>> 11, h = (s.next() >>> 0) / 4294967296, p = (d + h) / (1 << 21);
        while (p === 0);
        return p;
      }, c.int32 = s.next, c.quick = c, a && (typeof a == "object" && t(a, s), c.state = function() {
        return t(s, {});
      }), c;
    }
    o && o.exports ? o.exports = u : n && n.amd ? n(function() {
      return u;
    }) : this.tychei = u;
  })(
    Xe,
    e,
    // present in node.js
    !1
    // present with an AMD loader
  );
})(Zf);
var iT = Zf.exports, gb = { exports: {} }, je = {}, na = { exports: {} }, ia = { exports: {} }, So = {}, fi = {}, B0;
function aT() {
  if (B0)
    return fi;
  B0 = 1, fi.byteLength = l, fi.toByteArray = s, fi.fromByteArray = d;
  for (var e = [], r = [], o = typeof Uint8Array < "u" ? Uint8Array : Array, n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = 0, t = n.length; i < t; ++i)
    e[i] = n[i], r[n.charCodeAt(i)] = i;
  r[45] = 62, r[95] = 63;
  function u(h) {
    var p = h.length;
    if (p % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var v = h.indexOf("=");
    v === -1 && (v = p);
    var g = v === p ? 0 : 4 - v % 4;
    return [v, g];
  }
  function l(h) {
    var p = u(h), v = p[0], g = p[1];
    return (v + g) * 3 / 4 - g;
  }
  function f(h, p, v) {
    return (p + v) * 3 / 4 - v;
  }
  function s(h) {
    var p, v = u(h), g = v[0], m = v[1], x = new o(f(h, g, m)), y = 0, E = m > 0 ? g - 4 : g, N;
    for (N = 0; N < E; N += 4)
      p = r[h.charCodeAt(N)] << 18 | r[h.charCodeAt(N + 1)] << 12 | r[h.charCodeAt(N + 2)] << 6 | r[h.charCodeAt(N + 3)], x[y++] = p >> 16 & 255, x[y++] = p >> 8 & 255, x[y++] = p & 255;
    return m === 2 && (p = r[h.charCodeAt(N)] << 2 | r[h.charCodeAt(N + 1)] >> 4, x[y++] = p & 255), m === 1 && (p = r[h.charCodeAt(N)] << 10 | r[h.charCodeAt(N + 1)] << 4 | r[h.charCodeAt(N + 2)] >> 2, x[y++] = p >> 8 & 255, x[y++] = p & 255), x;
  }
  function a(h) {
    return e[h >> 18 & 63] + e[h >> 12 & 63] + e[h >> 6 & 63] + e[h & 63];
  }
  function c(h, p, v) {
    for (var g, m = [], x = p; x < v; x += 3)
      g = (h[x] << 16 & 16711680) + (h[x + 1] << 8 & 65280) + (h[x + 2] & 255), m.push(a(g));
    return m.join("");
  }
  function d(h) {
    for (var p, v = h.length, g = v % 3, m = [], x = 16383, y = 0, E = v - g; y < E; y += x)
      m.push(c(h, y, y + x > E ? E : y + x));
    return g === 1 ? (p = h[v - 1], m.push(
      e[p >> 2] + e[p << 4 & 63] + "=="
    )) : g === 2 && (p = (h[v - 2] << 8) + h[v - 1], m.push(
      e[p >> 10] + e[p >> 4 & 63] + e[p << 2 & 63] + "="
    )), m.join("");
  }
  return fi;
}
var aa = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var F0;
function oT() {
  return F0 || (F0 = 1, aa.read = function(e, r, o, n, i) {
    var t, u, l = i * 8 - n - 1, f = (1 << l) - 1, s = f >> 1, a = -7, c = o ? i - 1 : 0, d = o ? -1 : 1, h = e[r + c];
    for (c += d, t = h & (1 << -a) - 1, h >>= -a, a += l; a > 0; t = t * 256 + e[r + c], c += d, a -= 8)
      ;
    for (u = t & (1 << -a) - 1, t >>= -a, a += n; a > 0; u = u * 256 + e[r + c], c += d, a -= 8)
      ;
    if (t === 0)
      t = 1 - s;
    else {
      if (t === f)
        return u ? NaN : (h ? -1 : 1) * (1 / 0);
      u = u + Math.pow(2, n), t = t - s;
    }
    return (h ? -1 : 1) * u * Math.pow(2, t - n);
  }, aa.write = function(e, r, o, n, i, t) {
    var u, l, f, s = t * 8 - i - 1, a = (1 << s) - 1, c = a >> 1, d = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = n ? 0 : t - 1, p = n ? 1 : -1, v = r < 0 || r === 0 && 1 / r < 0 ? 1 : 0;
    for (r = Math.abs(r), isNaN(r) || r === 1 / 0 ? (l = isNaN(r) ? 1 : 0, u = a) : (u = Math.floor(Math.log(r) / Math.LN2), r * (f = Math.pow(2, -u)) < 1 && (u--, f *= 2), u + c >= 1 ? r += d / f : r += d * Math.pow(2, 1 - c), r * f >= 2 && (u++, f /= 2), u + c >= a ? (l = 0, u = a) : u + c >= 1 ? (l = (r * f - 1) * Math.pow(2, i), u = u + c) : (l = r * Math.pow(2, c - 1) * Math.pow(2, i), u = 0)); i >= 8; e[o + h] = l & 255, h += p, l /= 256, i -= 8)
      ;
    for (u = u << i | l, s += i; s > 0; e[o + h] = u & 255, h += p, u /= 256, s -= 8)
      ;
    e[o + h - p] |= v * 128;
  }), aa;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var I0;
function Nn() {
  return I0 || (I0 = 1, function(e) {
    var r = aT(), o = oT(), n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    e.Buffer = l, e.SlowBuffer = x, e.INSPECT_MAX_BYTES = 50;
    var i = 2147483647;
    e.kMaxLength = i, l.TYPED_ARRAY_SUPPORT = t(), !l.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function t() {
      try {
        var k = new Uint8Array(1), L = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(L, Uint8Array.prototype), Object.setPrototypeOf(k, L), k.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(l.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (l.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(l.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (l.isBuffer(this))
          return this.byteOffset;
      }
    });
    function u(k) {
      if (k > i)
        throw new RangeError('The value "' + k + '" is invalid for option "size"');
      var L = new Uint8Array(k);
      return Object.setPrototypeOf(L, l.prototype), L;
    }
    function l(k, L, P) {
      if (typeof k == "number") {
        if (typeof L == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return c(k);
      }
      return f(k, L, P);
    }
    l.poolSize = 8192;
    function f(k, L, P) {
      if (typeof k == "string")
        return d(k, L);
      if (ArrayBuffer.isView(k))
        return p(k);
      if (k == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof k
        );
      if (fe(k, ArrayBuffer) || k && fe(k.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (fe(k, SharedArrayBuffer) || k && fe(k.buffer, SharedArrayBuffer)))
        return v(k, L, P);
      if (typeof k == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      var G = k.valueOf && k.valueOf();
      if (G != null && G !== k)
        return l.from(G, L, P);
      var j = g(k);
      if (j)
        return j;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof k[Symbol.toPrimitive] == "function")
        return l.from(
          k[Symbol.toPrimitive]("string"),
          L,
          P
        );
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof k
      );
    }
    l.from = function(k, L, P) {
      return f(k, L, P);
    }, Object.setPrototypeOf(l.prototype, Uint8Array.prototype), Object.setPrototypeOf(l, Uint8Array);
    function s(k) {
      if (typeof k != "number")
        throw new TypeError('"size" argument must be of type number');
      if (k < 0)
        throw new RangeError('The value "' + k + '" is invalid for option "size"');
    }
    function a(k, L, P) {
      return s(k), k <= 0 ? u(k) : L !== void 0 ? typeof P == "string" ? u(k).fill(L, P) : u(k).fill(L) : u(k);
    }
    l.alloc = function(k, L, P) {
      return a(k, L, P);
    };
    function c(k) {
      return s(k), u(k < 0 ? 0 : m(k) | 0);
    }
    l.allocUnsafe = function(k) {
      return c(k);
    }, l.allocUnsafeSlow = function(k) {
      return c(k);
    };
    function d(k, L) {
      if ((typeof L != "string" || L === "") && (L = "utf8"), !l.isEncoding(L))
        throw new TypeError("Unknown encoding: " + L);
      var P = y(k, L) | 0, G = u(P), j = G.write(k, L);
      return j !== P && (G = G.slice(0, j)), G;
    }
    function h(k) {
      for (var L = k.length < 0 ? 0 : m(k.length) | 0, P = u(L), G = 0; G < L; G += 1)
        P[G] = k[G] & 255;
      return P;
    }
    function p(k) {
      if (fe(k, Uint8Array)) {
        var L = new Uint8Array(k);
        return v(L.buffer, L.byteOffset, L.byteLength);
      }
      return h(k);
    }
    function v(k, L, P) {
      if (L < 0 || k.byteLength < L)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (k.byteLength < L + (P || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      var G;
      return L === void 0 && P === void 0 ? G = new Uint8Array(k) : P === void 0 ? G = new Uint8Array(k, L) : G = new Uint8Array(k, L, P), Object.setPrototypeOf(G, l.prototype), G;
    }
    function g(k) {
      if (l.isBuffer(k)) {
        var L = m(k.length) | 0, P = u(L);
        return P.length === 0 || k.copy(P, 0, 0, L), P;
      }
      if (k.length !== void 0)
        return typeof k.length != "number" || pe(k.length) ? u(0) : h(k);
      if (k.type === "Buffer" && Array.isArray(k.data))
        return h(k.data);
    }
    function m(k) {
      if (k >= i)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
      return k | 0;
    }
    function x(k) {
      return +k != k && (k = 0), l.alloc(+k);
    }
    l.isBuffer = function(L) {
      return L != null && L._isBuffer === !0 && L !== l.prototype;
    }, l.compare = function(L, P) {
      if (fe(L, Uint8Array) && (L = l.from(L, L.offset, L.byteLength)), fe(P, Uint8Array) && (P = l.from(P, P.offset, P.byteLength)), !l.isBuffer(L) || !l.isBuffer(P))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (L === P)
        return 0;
      for (var G = L.length, j = P.length, re = 0, ie = Math.min(G, j); re < ie; ++re)
        if (L[re] !== P[re]) {
          G = L[re], j = P[re];
          break;
        }
      return G < j ? -1 : j < G ? 1 : 0;
    }, l.isEncoding = function(L) {
      switch (String(L).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, l.concat = function(L, P) {
      if (!Array.isArray(L))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (L.length === 0)
        return l.alloc(0);
      var G;
      if (P === void 0)
        for (P = 0, G = 0; G < L.length; ++G)
          P += L[G].length;
      var j = l.allocUnsafe(P), re = 0;
      for (G = 0; G < L.length; ++G) {
        var ie = L[G];
        if (fe(ie, Uint8Array))
          re + ie.length > j.length ? l.from(ie).copy(j, re) : Uint8Array.prototype.set.call(
            j,
            ie,
            re
          );
        else if (l.isBuffer(ie))
          ie.copy(j, re);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        re += ie.length;
      }
      return j;
    };
    function y(k, L) {
      if (l.isBuffer(k))
        return k.length;
      if (ArrayBuffer.isView(k) || fe(k, ArrayBuffer))
        return k.byteLength;
      if (typeof k != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof k
        );
      var P = k.length, G = arguments.length > 2 && arguments[2] === !0;
      if (!G && P === 0)
        return 0;
      for (var j = !1; ; )
        switch (L) {
          case "ascii":
          case "latin1":
          case "binary":
            return P;
          case "utf8":
          case "utf-8":
            return te(k).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return P * 2;
          case "hex":
            return P >>> 1;
          case "base64":
            return V(k).length;
          default:
            if (j)
              return G ? -1 : te(k).length;
            L = ("" + L).toLowerCase(), j = !0;
        }
    }
    l.byteLength = y;
    function E(k, L, P) {
      var G = !1;
      if ((L === void 0 || L < 0) && (L = 0), L > this.length || ((P === void 0 || P > this.length) && (P = this.length), P <= 0) || (P >>>= 0, L >>>= 0, P <= L))
        return "";
      for (k || (k = "utf8"); ; )
        switch (k) {
          case "hex":
            return C(this, L, P);
          case "utf8":
          case "utf-8":
            return b(this, L, P);
          case "ascii":
            return _(this, L, P);
          case "latin1":
          case "binary":
            return q(this, L, P);
          case "base64":
            return A(this, L, P);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return T(this, L, P);
          default:
            if (G)
              throw new TypeError("Unknown encoding: " + k);
            k = (k + "").toLowerCase(), G = !0;
        }
    }
    l.prototype._isBuffer = !0;
    function N(k, L, P) {
      var G = k[L];
      k[L] = k[P], k[P] = G;
    }
    l.prototype.swap16 = function() {
      var L = this.length;
      if (L % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var P = 0; P < L; P += 2)
        N(this, P, P + 1);
      return this;
    }, l.prototype.swap32 = function() {
      var L = this.length;
      if (L % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var P = 0; P < L; P += 4)
        N(this, P, P + 3), N(this, P + 1, P + 2);
      return this;
    }, l.prototype.swap64 = function() {
      var L = this.length;
      if (L % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var P = 0; P < L; P += 8)
        N(this, P, P + 7), N(this, P + 1, P + 6), N(this, P + 2, P + 5), N(this, P + 3, P + 4);
      return this;
    }, l.prototype.toString = function() {
      var L = this.length;
      return L === 0 ? "" : arguments.length === 0 ? b(this, 0, L) : E.apply(this, arguments);
    }, l.prototype.toLocaleString = l.prototype.toString, l.prototype.equals = function(L) {
      if (!l.isBuffer(L))
        throw new TypeError("Argument must be a Buffer");
      return this === L ? !0 : l.compare(this, L) === 0;
    }, l.prototype.inspect = function() {
      var L = "", P = e.INSPECT_MAX_BYTES;
      return L = this.toString("hex", 0, P).replace(/(.{2})/g, "$1 ").trim(), this.length > P && (L += " ... "), "<Buffer " + L + ">";
    }, n && (l.prototype[n] = l.prototype.inspect), l.prototype.compare = function(L, P, G, j, re) {
      if (fe(L, Uint8Array) && (L = l.from(L, L.offset, L.byteLength)), !l.isBuffer(L))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof L
        );
      if (P === void 0 && (P = 0), G === void 0 && (G = L ? L.length : 0), j === void 0 && (j = 0), re === void 0 && (re = this.length), P < 0 || G > L.length || j < 0 || re > this.length)
        throw new RangeError("out of range index");
      if (j >= re && P >= G)
        return 0;
      if (j >= re)
        return -1;
      if (P >= G)
        return 1;
      if (P >>>= 0, G >>>= 0, j >>>= 0, re >>>= 0, this === L)
        return 0;
      for (var ie = re - j, Z = G - P, X = Math.min(ie, Z), oe = this.slice(j, re), ce = L.slice(P, G), le = 0; le < X; ++le)
        if (oe[le] !== ce[le]) {
          ie = oe[le], Z = ce[le];
          break;
        }
      return ie < Z ? -1 : Z < ie ? 1 : 0;
    };
    function S(k, L, P, G, j) {
      if (k.length === 0)
        return -1;
      if (typeof P == "string" ? (G = P, P = 0) : P > 2147483647 ? P = 2147483647 : P < -2147483648 && (P = -2147483648), P = +P, pe(P) && (P = j ? 0 : k.length - 1), P < 0 && (P = k.length + P), P >= k.length) {
        if (j)
          return -1;
        P = k.length - 1;
      } else if (P < 0)
        if (j)
          P = 0;
        else
          return -1;
      if (typeof L == "string" && (L = l.from(L, G)), l.isBuffer(L))
        return L.length === 0 ? -1 : R(k, L, P, G, j);
      if (typeof L == "number")
        return L = L & 255, typeof Uint8Array.prototype.indexOf == "function" ? j ? Uint8Array.prototype.indexOf.call(k, L, P) : Uint8Array.prototype.lastIndexOf.call(k, L, P) : R(k, [L], P, G, j);
      throw new TypeError("val must be string, number or Buffer");
    }
    function R(k, L, P, G, j) {
      var re = 1, ie = k.length, Z = L.length;
      if (G !== void 0 && (G = String(G).toLowerCase(), G === "ucs2" || G === "ucs-2" || G === "utf16le" || G === "utf-16le")) {
        if (k.length < 2 || L.length < 2)
          return -1;
        re = 2, ie /= 2, Z /= 2, P /= 2;
      }
      function X(ge, me) {
        return re === 1 ? ge[me] : ge.readUInt16BE(me * re);
      }
      var oe;
      if (j) {
        var ce = -1;
        for (oe = P; oe < ie; oe++)
          if (X(k, oe) === X(L, ce === -1 ? 0 : oe - ce)) {
            if (ce === -1 && (ce = oe), oe - ce + 1 === Z)
              return ce * re;
          } else
            ce !== -1 && (oe -= oe - ce), ce = -1;
      } else
        for (P + Z > ie && (P = ie - Z), oe = P; oe >= 0; oe--) {
          for (var le = !0, ve = 0; ve < Z; ve++)
            if (X(k, oe + ve) !== X(L, ve)) {
              le = !1;
              break;
            }
          if (le)
            return oe;
        }
      return -1;
    }
    l.prototype.includes = function(L, P, G) {
      return this.indexOf(L, P, G) !== -1;
    }, l.prototype.indexOf = function(L, P, G) {
      return S(this, L, P, G, !0);
    }, l.prototype.lastIndexOf = function(L, P, G) {
      return S(this, L, P, G, !1);
    };
    function O(k, L, P, G) {
      P = Number(P) || 0;
      var j = k.length - P;
      G ? (G = Number(G), G > j && (G = j)) : G = j;
      var re = L.length;
      G > re / 2 && (G = re / 2);
      for (var ie = 0; ie < G; ++ie) {
        var Z = parseInt(L.substr(ie * 2, 2), 16);
        if (pe(Z))
          return ie;
        k[P + ie] = Z;
      }
      return ie;
    }
    function B(k, L, P, G) {
      return W(te(L, k.length - P), k, P, G);
    }
    function $(k, L, P, G) {
      return W(ne(L), k, P, G);
    }
    function F(k, L, P, G) {
      return W(V(L), k, P, G);
    }
    function w(k, L, P, G) {
      return W(ue(L, k.length - P), k, P, G);
    }
    l.prototype.write = function(L, P, G, j) {
      if (P === void 0)
        j = "utf8", G = this.length, P = 0;
      else if (G === void 0 && typeof P == "string")
        j = P, G = this.length, P = 0;
      else if (isFinite(P))
        P = P >>> 0, isFinite(G) ? (G = G >>> 0, j === void 0 && (j = "utf8")) : (j = G, G = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      var re = this.length - P;
      if ((G === void 0 || G > re) && (G = re), L.length > 0 && (G < 0 || P < 0) || P > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      j || (j = "utf8");
      for (var ie = !1; ; )
        switch (j) {
          case "hex":
            return O(this, L, P, G);
          case "utf8":
          case "utf-8":
            return B(this, L, P, G);
          case "ascii":
          case "latin1":
          case "binary":
            return $(this, L, P, G);
          case "base64":
            return F(this, L, P, G);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return w(this, L, P, G);
          default:
            if (ie)
              throw new TypeError("Unknown encoding: " + j);
            j = ("" + j).toLowerCase(), ie = !0;
        }
    }, l.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function A(k, L, P) {
      return L === 0 && P === k.length ? r.fromByteArray(k) : r.fromByteArray(k.slice(L, P));
    }
    function b(k, L, P) {
      P = Math.min(k.length, P);
      for (var G = [], j = L; j < P; ) {
        var re = k[j], ie = null, Z = re > 239 ? 4 : re > 223 ? 3 : re > 191 ? 2 : 1;
        if (j + Z <= P) {
          var X, oe, ce, le;
          switch (Z) {
            case 1:
              re < 128 && (ie = re);
              break;
            case 2:
              X = k[j + 1], (X & 192) === 128 && (le = (re & 31) << 6 | X & 63, le > 127 && (ie = le));
              break;
            case 3:
              X = k[j + 1], oe = k[j + 2], (X & 192) === 128 && (oe & 192) === 128 && (le = (re & 15) << 12 | (X & 63) << 6 | oe & 63, le > 2047 && (le < 55296 || le > 57343) && (ie = le));
              break;
            case 4:
              X = k[j + 1], oe = k[j + 2], ce = k[j + 3], (X & 192) === 128 && (oe & 192) === 128 && (ce & 192) === 128 && (le = (re & 15) << 18 | (X & 63) << 12 | (oe & 63) << 6 | ce & 63, le > 65535 && le < 1114112 && (ie = le));
          }
        }
        ie === null ? (ie = 65533, Z = 1) : ie > 65535 && (ie -= 65536, G.push(ie >>> 10 & 1023 | 55296), ie = 56320 | ie & 1023), G.push(ie), j += Z;
      }
      return M(G);
    }
    var D = 4096;
    function M(k) {
      var L = k.length;
      if (L <= D)
        return String.fromCharCode.apply(String, k);
      for (var P = "", G = 0; G < L; )
        P += String.fromCharCode.apply(
          String,
          k.slice(G, G += D)
        );
      return P;
    }
    function _(k, L, P) {
      var G = "";
      P = Math.min(k.length, P);
      for (var j = L; j < P; ++j)
        G += String.fromCharCode(k[j] & 127);
      return G;
    }
    function q(k, L, P) {
      var G = "";
      P = Math.min(k.length, P);
      for (var j = L; j < P; ++j)
        G += String.fromCharCode(k[j]);
      return G;
    }
    function C(k, L, P) {
      var G = k.length;
      (!L || L < 0) && (L = 0), (!P || P < 0 || P > G) && (P = G);
      for (var j = "", re = L; re < P; ++re)
        j += Y[k[re]];
      return j;
    }
    function T(k, L, P) {
      for (var G = k.slice(L, P), j = "", re = 0; re < G.length - 1; re += 2)
        j += String.fromCharCode(G[re] + G[re + 1] * 256);
      return j;
    }
    l.prototype.slice = function(L, P) {
      var G = this.length;
      L = ~~L, P = P === void 0 ? G : ~~P, L < 0 ? (L += G, L < 0 && (L = 0)) : L > G && (L = G), P < 0 ? (P += G, P < 0 && (P = 0)) : P > G && (P = G), P < L && (P = L);
      var j = this.subarray(L, P);
      return Object.setPrototypeOf(j, l.prototype), j;
    };
    function z(k, L, P) {
      if (k % 1 !== 0 || k < 0)
        throw new RangeError("offset is not uint");
      if (k + L > P)
        throw new RangeError("Trying to access beyond buffer length");
    }
    l.prototype.readUintLE = l.prototype.readUIntLE = function(L, P, G) {
      L = L >>> 0, P = P >>> 0, G || z(L, P, this.length);
      for (var j = this[L], re = 1, ie = 0; ++ie < P && (re *= 256); )
        j += this[L + ie] * re;
      return j;
    }, l.prototype.readUintBE = l.prototype.readUIntBE = function(L, P, G) {
      L = L >>> 0, P = P >>> 0, G || z(L, P, this.length);
      for (var j = this[L + --P], re = 1; P > 0 && (re *= 256); )
        j += this[L + --P] * re;
      return j;
    }, l.prototype.readUint8 = l.prototype.readUInt8 = function(L, P) {
      return L = L >>> 0, P || z(L, 1, this.length), this[L];
    }, l.prototype.readUint16LE = l.prototype.readUInt16LE = function(L, P) {
      return L = L >>> 0, P || z(L, 2, this.length), this[L] | this[L + 1] << 8;
    }, l.prototype.readUint16BE = l.prototype.readUInt16BE = function(L, P) {
      return L = L >>> 0, P || z(L, 2, this.length), this[L] << 8 | this[L + 1];
    }, l.prototype.readUint32LE = l.prototype.readUInt32LE = function(L, P) {
      return L = L >>> 0, P || z(L, 4, this.length), (this[L] | this[L + 1] << 8 | this[L + 2] << 16) + this[L + 3] * 16777216;
    }, l.prototype.readUint32BE = l.prototype.readUInt32BE = function(L, P) {
      return L = L >>> 0, P || z(L, 4, this.length), this[L] * 16777216 + (this[L + 1] << 16 | this[L + 2] << 8 | this[L + 3]);
    }, l.prototype.readIntLE = function(L, P, G) {
      L = L >>> 0, P = P >>> 0, G || z(L, P, this.length);
      for (var j = this[L], re = 1, ie = 0; ++ie < P && (re *= 256); )
        j += this[L + ie] * re;
      return re *= 128, j >= re && (j -= Math.pow(2, 8 * P)), j;
    }, l.prototype.readIntBE = function(L, P, G) {
      L = L >>> 0, P = P >>> 0, G || z(L, P, this.length);
      for (var j = P, re = 1, ie = this[L + --j]; j > 0 && (re *= 256); )
        ie += this[L + --j] * re;
      return re *= 128, ie >= re && (ie -= Math.pow(2, 8 * P)), ie;
    }, l.prototype.readInt8 = function(L, P) {
      return L = L >>> 0, P || z(L, 1, this.length), this[L] & 128 ? (255 - this[L] + 1) * -1 : this[L];
    }, l.prototype.readInt16LE = function(L, P) {
      L = L >>> 0, P || z(L, 2, this.length);
      var G = this[L] | this[L + 1] << 8;
      return G & 32768 ? G | 4294901760 : G;
    }, l.prototype.readInt16BE = function(L, P) {
      L = L >>> 0, P || z(L, 2, this.length);
      var G = this[L + 1] | this[L] << 8;
      return G & 32768 ? G | 4294901760 : G;
    }, l.prototype.readInt32LE = function(L, P) {
      return L = L >>> 0, P || z(L, 4, this.length), this[L] | this[L + 1] << 8 | this[L + 2] << 16 | this[L + 3] << 24;
    }, l.prototype.readInt32BE = function(L, P) {
      return L = L >>> 0, P || z(L, 4, this.length), this[L] << 24 | this[L + 1] << 16 | this[L + 2] << 8 | this[L + 3];
    }, l.prototype.readFloatLE = function(L, P) {
      return L = L >>> 0, P || z(L, 4, this.length), o.read(this, L, !0, 23, 4);
    }, l.prototype.readFloatBE = function(L, P) {
      return L = L >>> 0, P || z(L, 4, this.length), o.read(this, L, !1, 23, 4);
    }, l.prototype.readDoubleLE = function(L, P) {
      return L = L >>> 0, P || z(L, 8, this.length), o.read(this, L, !0, 52, 8);
    }, l.prototype.readDoubleBE = function(L, P) {
      return L = L >>> 0, P || z(L, 8, this.length), o.read(this, L, !1, 52, 8);
    };
    function I(k, L, P, G, j, re) {
      if (!l.isBuffer(k))
        throw new TypeError('"buffer" argument must be a Buffer instance');
      if (L > j || L < re)
        throw new RangeError('"value" argument is out of bounds');
      if (P + G > k.length)
        throw new RangeError("Index out of range");
    }
    l.prototype.writeUintLE = l.prototype.writeUIntLE = function(L, P, G, j) {
      if (L = +L, P = P >>> 0, G = G >>> 0, !j) {
        var re = Math.pow(2, 8 * G) - 1;
        I(this, L, P, G, re, 0);
      }
      var ie = 1, Z = 0;
      for (this[P] = L & 255; ++Z < G && (ie *= 256); )
        this[P + Z] = L / ie & 255;
      return P + G;
    }, l.prototype.writeUintBE = l.prototype.writeUIntBE = function(L, P, G, j) {
      if (L = +L, P = P >>> 0, G = G >>> 0, !j) {
        var re = Math.pow(2, 8 * G) - 1;
        I(this, L, P, G, re, 0);
      }
      var ie = G - 1, Z = 1;
      for (this[P + ie] = L & 255; --ie >= 0 && (Z *= 256); )
        this[P + ie] = L / Z & 255;
      return P + G;
    }, l.prototype.writeUint8 = l.prototype.writeUInt8 = function(L, P, G) {
      return L = +L, P = P >>> 0, G || I(this, L, P, 1, 255, 0), this[P] = L & 255, P + 1;
    }, l.prototype.writeUint16LE = l.prototype.writeUInt16LE = function(L, P, G) {
      return L = +L, P = P >>> 0, G || I(this, L, P, 2, 65535, 0), this[P] = L & 255, this[P + 1] = L >>> 8, P + 2;
    }, l.prototype.writeUint16BE = l.prototype.writeUInt16BE = function(L, P, G) {
      return L = +L, P = P >>> 0, G || I(this, L, P, 2, 65535, 0), this[P] = L >>> 8, this[P + 1] = L & 255, P + 2;
    }, l.prototype.writeUint32LE = l.prototype.writeUInt32LE = function(L, P, G) {
      return L = +L, P = P >>> 0, G || I(this, L, P, 4, 4294967295, 0), this[P + 3] = L >>> 24, this[P + 2] = L >>> 16, this[P + 1] = L >>> 8, this[P] = L & 255, P + 4;
    }, l.prototype.writeUint32BE = l.prototype.writeUInt32BE = function(L, P, G) {
      return L = +L, P = P >>> 0, G || I(this, L, P, 4, 4294967295, 0), this[P] = L >>> 24, this[P + 1] = L >>> 16, this[P + 2] = L >>> 8, this[P + 3] = L & 255, P + 4;
    }, l.prototype.writeIntLE = function(L, P, G, j) {
      if (L = +L, P = P >>> 0, !j) {
        var re = Math.pow(2, 8 * G - 1);
        I(this, L, P, G, re - 1, -re);
      }
      var ie = 0, Z = 1, X = 0;
      for (this[P] = L & 255; ++ie < G && (Z *= 256); )
        L < 0 && X === 0 && this[P + ie - 1] !== 0 && (X = 1), this[P + ie] = (L / Z >> 0) - X & 255;
      return P + G;
    }, l.prototype.writeIntBE = function(L, P, G, j) {
      if (L = +L, P = P >>> 0, !j) {
        var re = Math.pow(2, 8 * G - 1);
        I(this, L, P, G, re - 1, -re);
      }
      var ie = G - 1, Z = 1, X = 0;
      for (this[P + ie] = L & 255; --ie >= 0 && (Z *= 256); )
        L < 0 && X === 0 && this[P + ie + 1] !== 0 && (X = 1), this[P + ie] = (L / Z >> 0) - X & 255;
      return P + G;
    }, l.prototype.writeInt8 = function(L, P, G) {
      return L = +L, P = P >>> 0, G || I(this, L, P, 1, 127, -128), L < 0 && (L = 255 + L + 1), this[P] = L & 255, P + 1;
    }, l.prototype.writeInt16LE = function(L, P, G) {
      return L = +L, P = P >>> 0, G || I(this, L, P, 2, 32767, -32768), this[P] = L & 255, this[P + 1] = L >>> 8, P + 2;
    }, l.prototype.writeInt16BE = function(L, P, G) {
      return L = +L, P = P >>> 0, G || I(this, L, P, 2, 32767, -32768), this[P] = L >>> 8, this[P + 1] = L & 255, P + 2;
    }, l.prototype.writeInt32LE = function(L, P, G) {
      return L = +L, P = P >>> 0, G || I(this, L, P, 4, 2147483647, -2147483648), this[P] = L & 255, this[P + 1] = L >>> 8, this[P + 2] = L >>> 16, this[P + 3] = L >>> 24, P + 4;
    }, l.prototype.writeInt32BE = function(L, P, G) {
      return L = +L, P = P >>> 0, G || I(this, L, P, 4, 2147483647, -2147483648), L < 0 && (L = 4294967295 + L + 1), this[P] = L >>> 24, this[P + 1] = L >>> 16, this[P + 2] = L >>> 8, this[P + 3] = L & 255, P + 4;
    };
    function U(k, L, P, G, j, re) {
      if (P + G > k.length)
        throw new RangeError("Index out of range");
      if (P < 0)
        throw new RangeError("Index out of range");
    }
    function ee(k, L, P, G, j) {
      return L = +L, P = P >>> 0, j || U(k, L, P, 4), o.write(k, L, P, G, 23, 4), P + 4;
    }
    l.prototype.writeFloatLE = function(L, P, G) {
      return ee(this, L, P, !0, G);
    }, l.prototype.writeFloatBE = function(L, P, G) {
      return ee(this, L, P, !1, G);
    };
    function se(k, L, P, G, j) {
      return L = +L, P = P >>> 0, j || U(k, L, P, 8), o.write(k, L, P, G, 52, 8), P + 8;
    }
    l.prototype.writeDoubleLE = function(L, P, G) {
      return se(this, L, P, !0, G);
    }, l.prototype.writeDoubleBE = function(L, P, G) {
      return se(this, L, P, !1, G);
    }, l.prototype.copy = function(L, P, G, j) {
      if (!l.isBuffer(L))
        throw new TypeError("argument should be a Buffer");
      if (G || (G = 0), !j && j !== 0 && (j = this.length), P >= L.length && (P = L.length), P || (P = 0), j > 0 && j < G && (j = G), j === G || L.length === 0 || this.length === 0)
        return 0;
      if (P < 0)
        throw new RangeError("targetStart out of bounds");
      if (G < 0 || G >= this.length)
        throw new RangeError("Index out of range");
      if (j < 0)
        throw new RangeError("sourceEnd out of bounds");
      j > this.length && (j = this.length), L.length - P < j - G && (j = L.length - P + G);
      var re = j - G;
      return this === L && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(P, G, j) : Uint8Array.prototype.set.call(
        L,
        this.subarray(G, j),
        P
      ), re;
    }, l.prototype.fill = function(L, P, G, j) {
      if (typeof L == "string") {
        if (typeof P == "string" ? (j = P, P = 0, G = this.length) : typeof G == "string" && (j = G, G = this.length), j !== void 0 && typeof j != "string")
          throw new TypeError("encoding must be a string");
        if (typeof j == "string" && !l.isEncoding(j))
          throw new TypeError("Unknown encoding: " + j);
        if (L.length === 1) {
          var re = L.charCodeAt(0);
          (j === "utf8" && re < 128 || j === "latin1") && (L = re);
        }
      } else
        typeof L == "number" ? L = L & 255 : typeof L == "boolean" && (L = Number(L));
      if (P < 0 || this.length < P || this.length < G)
        throw new RangeError("Out of range index");
      if (G <= P)
        return this;
      P = P >>> 0, G = G === void 0 ? this.length : G >>> 0, L || (L = 0);
      var ie;
      if (typeof L == "number")
        for (ie = P; ie < G; ++ie)
          this[ie] = L;
      else {
        var Z = l.isBuffer(L) ? L : l.from(L, j), X = Z.length;
        if (X === 0)
          throw new TypeError('The value "' + L + '" is invalid for argument "value"');
        for (ie = 0; ie < G - P; ++ie)
          this[ie + P] = Z[ie % X];
      }
      return this;
    };
    var K = /[^+/0-9A-Za-z-_]/g;
    function J(k) {
      if (k = k.split("=")[0], k = k.trim().replace(K, ""), k.length < 2)
        return "";
      for (; k.length % 4 !== 0; )
        k = k + "=";
      return k;
    }
    function te(k, L) {
      L = L || 1 / 0;
      for (var P, G = k.length, j = null, re = [], ie = 0; ie < G; ++ie) {
        if (P = k.charCodeAt(ie), P > 55295 && P < 57344) {
          if (!j) {
            if (P > 56319) {
              (L -= 3) > -1 && re.push(239, 191, 189);
              continue;
            } else if (ie + 1 === G) {
              (L -= 3) > -1 && re.push(239, 191, 189);
              continue;
            }
            j = P;
            continue;
          }
          if (P < 56320) {
            (L -= 3) > -1 && re.push(239, 191, 189), j = P;
            continue;
          }
          P = (j - 55296 << 10 | P - 56320) + 65536;
        } else
          j && (L -= 3) > -1 && re.push(239, 191, 189);
        if (j = null, P < 128) {
          if ((L -= 1) < 0)
            break;
          re.push(P);
        } else if (P < 2048) {
          if ((L -= 2) < 0)
            break;
          re.push(
            P >> 6 | 192,
            P & 63 | 128
          );
        } else if (P < 65536) {
          if ((L -= 3) < 0)
            break;
          re.push(
            P >> 12 | 224,
            P >> 6 & 63 | 128,
            P & 63 | 128
          );
        } else if (P < 1114112) {
          if ((L -= 4) < 0)
            break;
          re.push(
            P >> 18 | 240,
            P >> 12 & 63 | 128,
            P >> 6 & 63 | 128,
            P & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return re;
    }
    function ne(k) {
      for (var L = [], P = 0; P < k.length; ++P)
        L.push(k.charCodeAt(P) & 255);
      return L;
    }
    function ue(k, L) {
      for (var P, G, j, re = [], ie = 0; ie < k.length && !((L -= 2) < 0); ++ie)
        P = k.charCodeAt(ie), G = P >> 8, j = P % 256, re.push(j), re.push(G);
      return re;
    }
    function V(k) {
      return r.toByteArray(J(k));
    }
    function W(k, L, P, G) {
      for (var j = 0; j < G && !(j + P >= L.length || j >= k.length); ++j)
        L[j + P] = k[j];
      return j;
    }
    function fe(k, L) {
      return k instanceof L || k != null && k.constructor != null && k.constructor.name != null && k.constructor.name === L.name;
    }
    function pe(k) {
      return k !== k;
    }
    var Y = function() {
      for (var k = "0123456789abcdef", L = new Array(256), P = 0; P < 16; ++P)
        for (var G = P * 16, j = 0; j < 16; ++j)
          L[G + j] = k[P] + k[j];
      return L;
    }();
  }(So)), So;
}
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var O0;
function Ye() {
  return O0 || (O0 = 1, function(e, r) {
    var o = Nn(), n = o.Buffer;
    function i(u, l) {
      for (var f in u)
        l[f] = u[f];
    }
    n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? e.exports = o : (i(o, r), r.Buffer = t);
    function t(u, l, f) {
      return n(u, l, f);
    }
    t.prototype = Object.create(n.prototype), i(n, t), t.from = function(u, l, f) {
      if (typeof u == "number")
        throw new TypeError("Argument must not be a number");
      return n(u, l, f);
    }, t.alloc = function(u, l, f) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      var s = n(u);
      return l !== void 0 ? typeof f == "string" ? s.fill(l, f) : s.fill(l) : s.fill(0), s;
    }, t.allocUnsafe = function(u) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      return n(u);
    }, t.allocUnsafeSlow = function(u) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      return o.SlowBuffer(u);
    };
  }(ia, ia.exports)), ia.exports;
}
var R0;
function ni() {
  if (R0)
    return na.exports;
  R0 = 1;
  var e = 65536, r = 4294967295;
  function o() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var n = Ye().Buffer, i = Xe.crypto || Xe.msCrypto;
  i && i.getRandomValues ? na.exports = t : na.exports = o;
  function t(u, l) {
    if (u > r)
      throw new RangeError("requested too many random bytes");
    var f = n.allocUnsafe(u);
    if (u > 0)
      if (u > e)
        for (var s = 0; s < u; s += e)
          i.getRandomValues(f.slice(s, s + e));
      else
        i.getRandomValues(f);
    return typeof l == "function" ? process.nextTick(function() {
      l(null, f);
    }) : f;
  }
  return na.exports;
}
var oa = { exports: {} }, P0;
function Je() {
  return P0 || (P0 = 1, typeof Object.create == "function" ? oa.exports = function(r, o) {
    o && (r.super_ = o, r.prototype = Object.create(o.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : oa.exports = function(r, o) {
    if (o) {
      r.super_ = o;
      var n = function() {
      };
      n.prototype = o.prototype, r.prototype = new n(), r.prototype.constructor = r;
    }
  }), oa.exports;
}
var sa = { exports: {} }, ua = { exports: {} }, q0;
function bb() {
  if (q0)
    return ua.exports;
  q0 = 1;
  var e = typeof Reflect == "object" ? Reflect : null, r = e && typeof e.apply == "function" ? e.apply : function(N, S, R) {
    return Function.prototype.apply.call(N, S, R);
  }, o;
  e && typeof e.ownKeys == "function" ? o = e.ownKeys : Object.getOwnPropertySymbols ? o = function(N) {
    return Object.getOwnPropertyNames(N).concat(Object.getOwnPropertySymbols(N));
  } : o = function(N) {
    return Object.getOwnPropertyNames(N);
  };
  function n(E) {
    console && console.warn && console.warn(E);
  }
  var i = Number.isNaN || function(N) {
    return N !== N;
  };
  function t() {
    t.init.call(this);
  }
  ua.exports = t, ua.exports.once = m, t.EventEmitter = t, t.prototype._events = void 0, t.prototype._eventsCount = 0, t.prototype._maxListeners = void 0;
  var u = 10;
  function l(E) {
    if (typeof E != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof E);
  }
  Object.defineProperty(t, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return u;
    },
    set: function(E) {
      if (typeof E != "number" || E < 0 || i(E))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + E + ".");
      u = E;
    }
  }), t.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, t.prototype.setMaxListeners = function(N) {
    if (typeof N != "number" || N < 0 || i(N))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + N + ".");
    return this._maxListeners = N, this;
  };
  function f(E) {
    return E._maxListeners === void 0 ? t.defaultMaxListeners : E._maxListeners;
  }
  t.prototype.getMaxListeners = function() {
    return f(this);
  }, t.prototype.emit = function(N) {
    for (var S = [], R = 1; R < arguments.length; R++)
      S.push(arguments[R]);
    var O = N === "error", B = this._events;
    if (B !== void 0)
      O = O && B.error === void 0;
    else if (!O)
      return !1;
    if (O) {
      var $;
      if (S.length > 0 && ($ = S[0]), $ instanceof Error)
        throw $;
      var F = new Error("Unhandled error." + ($ ? " (" + $.message + ")" : ""));
      throw F.context = $, F;
    }
    var w = B[N];
    if (w === void 0)
      return !1;
    if (typeof w == "function")
      r(w, this, S);
    else
      for (var A = w.length, b = p(w, A), R = 0; R < A; ++R)
        r(b[R], this, S);
    return !0;
  };
  function s(E, N, S, R) {
    var O, B, $;
    if (l(S), B = E._events, B === void 0 ? (B = E._events = /* @__PURE__ */ Object.create(null), E._eventsCount = 0) : (B.newListener !== void 0 && (E.emit(
      "newListener",
      N,
      S.listener ? S.listener : S
    ), B = E._events), $ = B[N]), $ === void 0)
      $ = B[N] = S, ++E._eventsCount;
    else if (typeof $ == "function" ? $ = B[N] = R ? [S, $] : [$, S] : R ? $.unshift(S) : $.push(S), O = f(E), O > 0 && $.length > O && !$.warned) {
      $.warned = !0;
      var F = new Error("Possible EventEmitter memory leak detected. " + $.length + " " + String(N) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      F.name = "MaxListenersExceededWarning", F.emitter = E, F.type = N, F.count = $.length, n(F);
    }
    return E;
  }
  t.prototype.addListener = function(N, S) {
    return s(this, N, S, !1);
  }, t.prototype.on = t.prototype.addListener, t.prototype.prependListener = function(N, S) {
    return s(this, N, S, !0);
  };
  function a() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function c(E, N, S) {
    var R = { fired: !1, wrapFn: void 0, target: E, type: N, listener: S }, O = a.bind(R);
    return O.listener = S, R.wrapFn = O, O;
  }
  t.prototype.once = function(N, S) {
    return l(S), this.on(N, c(this, N, S)), this;
  }, t.prototype.prependOnceListener = function(N, S) {
    return l(S), this.prependListener(N, c(this, N, S)), this;
  }, t.prototype.removeListener = function(N, S) {
    var R, O, B, $, F;
    if (l(S), O = this._events, O === void 0)
      return this;
    if (R = O[N], R === void 0)
      return this;
    if (R === S || R.listener === S)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete O[N], O.removeListener && this.emit("removeListener", N, R.listener || S));
    else if (typeof R != "function") {
      for (B = -1, $ = R.length - 1; $ >= 0; $--)
        if (R[$] === S || R[$].listener === S) {
          F = R[$].listener, B = $;
          break;
        }
      if (B < 0)
        return this;
      B === 0 ? R.shift() : v(R, B), R.length === 1 && (O[N] = R[0]), O.removeListener !== void 0 && this.emit("removeListener", N, F || S);
    }
    return this;
  }, t.prototype.off = t.prototype.removeListener, t.prototype.removeAllListeners = function(N) {
    var S, R, O;
    if (R = this._events, R === void 0)
      return this;
    if (R.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : R[N] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete R[N]), this;
    if (arguments.length === 0) {
      var B = Object.keys(R), $;
      for (O = 0; O < B.length; ++O)
        $ = B[O], $ !== "removeListener" && this.removeAllListeners($);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (S = R[N], typeof S == "function")
      this.removeListener(N, S);
    else if (S !== void 0)
      for (O = S.length - 1; O >= 0; O--)
        this.removeListener(N, S[O]);
    return this;
  };
  function d(E, N, S) {
    var R = E._events;
    if (R === void 0)
      return [];
    var O = R[N];
    return O === void 0 ? [] : typeof O == "function" ? S ? [O.listener || O] : [O] : S ? g(O) : p(O, O.length);
  }
  t.prototype.listeners = function(N) {
    return d(this, N, !0);
  }, t.prototype.rawListeners = function(N) {
    return d(this, N, !1);
  }, t.listenerCount = function(E, N) {
    return typeof E.listenerCount == "function" ? E.listenerCount(N) : h.call(E, N);
  }, t.prototype.listenerCount = h;
  function h(E) {
    var N = this._events;
    if (N !== void 0) {
      var S = N[E];
      if (typeof S == "function")
        return 1;
      if (S !== void 0)
        return S.length;
    }
    return 0;
  }
  t.prototype.eventNames = function() {
    return this._eventsCount > 0 ? o(this._events) : [];
  };
  function p(E, N) {
    for (var S = new Array(N), R = 0; R < N; ++R)
      S[R] = E[R];
    return S;
  }
  function v(E, N) {
    for (; N + 1 < E.length; N++)
      E[N] = E[N + 1];
    E.pop();
  }
  function g(E) {
    for (var N = new Array(E.length), S = 0; S < N.length; ++S)
      N[S] = E[S].listener || E[S];
    return N;
  }
  function m(E, N) {
    return new Promise(function(S, R) {
      function O($) {
        E.removeListener(N, B), R($);
      }
      function B() {
        typeof E.removeListener == "function" && E.removeListener("error", O), S([].slice.call(arguments));
      }
      y(E, N, B, { once: !0 }), N !== "error" && x(E, O, { once: !0 });
    });
  }
  function x(E, N, S) {
    typeof E.on == "function" && y(E, "error", N, S);
  }
  function y(E, N, S, R) {
    if (typeof E.on == "function")
      R.once ? E.once(N, S) : E.on(N, S);
    else if (typeof E.addEventListener == "function")
      E.addEventListener(N, function O(B) {
        R.once && E.removeEventListener(N, O), S(B);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof E);
  }
  return ua.exports;
}
var Do, $0;
function yb() {
  return $0 || ($0 = 1, Do = bb().EventEmitter), Do;
}
const sT = {}, uT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sT
}, Symbol.toStringTag, { value: "Module" })), Ii = /* @__PURE__ */ Lw(uT);
var No, z0;
function fT() {
  if (z0)
    return No;
  z0 = 1;
  function e(p, v) {
    var g = Object.keys(p);
    if (Object.getOwnPropertySymbols) {
      var m = Object.getOwnPropertySymbols(p);
      v && (m = m.filter(function(x) {
        return Object.getOwnPropertyDescriptor(p, x).enumerable;
      })), g.push.apply(g, m);
    }
    return g;
  }
  function r(p) {
    for (var v = 1; v < arguments.length; v++) {
      var g = arguments[v] != null ? arguments[v] : {};
      v % 2 ? e(Object(g), !0).forEach(function(m) {
        o(p, m, g[m]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(p, Object.getOwnPropertyDescriptors(g)) : e(Object(g)).forEach(function(m) {
        Object.defineProperty(p, m, Object.getOwnPropertyDescriptor(g, m));
      });
    }
    return p;
  }
  function o(p, v, g) {
    return v = u(v), v in p ? Object.defineProperty(p, v, { value: g, enumerable: !0, configurable: !0, writable: !0 }) : p[v] = g, p;
  }
  function n(p, v) {
    if (!(p instanceof v))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(p, v) {
    for (var g = 0; g < v.length; g++) {
      var m = v[g];
      m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(p, u(m.key), m);
    }
  }
  function t(p, v, g) {
    return v && i(p.prototype, v), g && i(p, g), Object.defineProperty(p, "prototype", { writable: !1 }), p;
  }
  function u(p) {
    var v = l(p, "string");
    return typeof v == "symbol" ? v : String(v);
  }
  function l(p, v) {
    if (typeof p != "object" || p === null)
      return p;
    var g = p[Symbol.toPrimitive];
    if (g !== void 0) {
      var m = g.call(p, v || "default");
      if (typeof m != "object")
        return m;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (v === "string" ? String : Number)(p);
  }
  var f = Nn(), s = f.Buffer, a = Ii, c = a.inspect, d = c && c.custom || "inspect";
  function h(p, v, g) {
    s.prototype.copy.call(p, v, g);
  }
  return No = /* @__PURE__ */ function() {
    function p() {
      n(this, p), this.head = null, this.tail = null, this.length = 0;
    }
    return t(p, [{
      key: "push",
      value: function(g) {
        var m = {
          data: g,
          next: null
        };
        this.length > 0 ? this.tail.next = m : this.head = m, this.tail = m, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(g) {
        var m = {
          data: g,
          next: this.head
        };
        this.length === 0 && (this.tail = m), this.head = m, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var g = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, g;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(g) {
        if (this.length === 0)
          return "";
        for (var m = this.head, x = "" + m.data; m = m.next; )
          x += g + m.data;
        return x;
      }
    }, {
      key: "concat",
      value: function(g) {
        if (this.length === 0)
          return s.alloc(0);
        for (var m = s.allocUnsafe(g >>> 0), x = this.head, y = 0; x; )
          h(x.data, m, y), y += x.data.length, x = x.next;
        return m;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(g, m) {
        var x;
        return g < this.head.data.length ? (x = this.head.data.slice(0, g), this.head.data = this.head.data.slice(g)) : g === this.head.data.length ? x = this.shift() : x = m ? this._getString(g) : this._getBuffer(g), x;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(g) {
        var m = this.head, x = 1, y = m.data;
        for (g -= y.length; m = m.next; ) {
          var E = m.data, N = g > E.length ? E.length : g;
          if (N === E.length ? y += E : y += E.slice(0, g), g -= N, g === 0) {
            N === E.length ? (++x, m.next ? this.head = m.next : this.head = this.tail = null) : (this.head = m, m.data = E.slice(N));
            break;
          }
          ++x;
        }
        return this.length -= x, y;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(g) {
        var m = s.allocUnsafe(g), x = this.head, y = 1;
        for (x.data.copy(m), g -= x.data.length; x = x.next; ) {
          var E = x.data, N = g > E.length ? E.length : g;
          if (E.copy(m, m.length - g, 0, N), g -= N, g === 0) {
            N === E.length ? (++y, x.next ? this.head = x.next : this.head = this.tail = null) : (this.head = x, x.data = E.slice(N));
            break;
          }
          ++y;
        }
        return this.length -= y, m;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: d,
      value: function(g, m) {
        return c(this, r(r({}, m), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), p;
  }(), No;
}
var Mo, L0;
function wb() {
  if (L0)
    return Mo;
  L0 = 1;
  function e(u, l) {
    var f = this, s = this._readableState && this._readableState.destroyed, a = this._writableState && this._writableState.destroyed;
    return s || a ? (l ? l(u) : u && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, process.nextTick(i, this, u)) : process.nextTick(i, this, u)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(u || null, function(c) {
      !l && c ? f._writableState ? f._writableState.errorEmitted ? process.nextTick(o, f) : (f._writableState.errorEmitted = !0, process.nextTick(r, f, c)) : process.nextTick(r, f, c) : l ? (process.nextTick(o, f), l(c)) : process.nextTick(o, f);
    }), this);
  }
  function r(u, l) {
    i(u, l), o(u);
  }
  function o(u) {
    u._writableState && !u._writableState.emitClose || u._readableState && !u._readableState.emitClose || u.emit("close");
  }
  function n() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function i(u, l) {
    u.emit("error", l);
  }
  function t(u, l) {
    var f = u._readableState, s = u._writableState;
    f && f.autoDestroy || s && s.autoDestroy ? u.destroy(l) : u.emit("error", l);
  }
  return Mo = {
    destroy: e,
    undestroy: n,
    errorOrDestroy: t
  }, Mo;
}
var _o = {}, U0;
function ii() {
  if (U0)
    return _o;
  U0 = 1;
  function e(l, f) {
    l.prototype = Object.create(f.prototype), l.prototype.constructor = l, l.__proto__ = f;
  }
  var r = {};
  function o(l, f, s) {
    s || (s = Error);
    function a(d, h, p) {
      return typeof f == "string" ? f : f(d, h, p);
    }
    var c = /* @__PURE__ */ function(d) {
      e(h, d);
      function h(p, v, g) {
        return d.call(this, a(p, v, g)) || this;
      }
      return h;
    }(s);
    c.prototype.name = s.name, c.prototype.code = l, r[l] = c;
  }
  function n(l, f) {
    if (Array.isArray(l)) {
      var s = l.length;
      return l = l.map(function(a) {
        return String(a);
      }), s > 2 ? "one of ".concat(f, " ").concat(l.slice(0, s - 1).join(", "), ", or ") + l[s - 1] : s === 2 ? "one of ".concat(f, " ").concat(l[0], " or ").concat(l[1]) : "of ".concat(f, " ").concat(l[0]);
    } else
      return "of ".concat(f, " ").concat(String(l));
  }
  function i(l, f, s) {
    return l.substr(!s || s < 0 ? 0 : +s, f.length) === f;
  }
  function t(l, f, s) {
    return (s === void 0 || s > l.length) && (s = l.length), l.substring(s - f.length, s) === f;
  }
  function u(l, f, s) {
    return typeof s != "number" && (s = 0), s + f.length > l.length ? !1 : l.indexOf(f, s) !== -1;
  }
  return o("ERR_INVALID_OPT_VALUE", function(l, f) {
    return 'The value "' + f + '" is invalid for option "' + l + '"';
  }, TypeError), o("ERR_INVALID_ARG_TYPE", function(l, f, s) {
    var a;
    typeof f == "string" && i(f, "not ") ? (a = "must not be", f = f.replace(/^not /, "")) : a = "must be";
    var c;
    if (t(l, " argument"))
      c = "The ".concat(l, " ").concat(a, " ").concat(n(f, "type"));
    else {
      var d = u(l, ".") ? "property" : "argument";
      c = 'The "'.concat(l, '" ').concat(d, " ").concat(a, " ").concat(n(f, "type"));
    }
    return c += ". Received type ".concat(typeof s), c;
  }, TypeError), o("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), o("ERR_METHOD_NOT_IMPLEMENTED", function(l) {
    return "The " + l + " method is not implemented";
  }), o("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), o("ERR_STREAM_DESTROYED", function(l) {
    return "Cannot call " + l + " after a stream was destroyed";
  }), o("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), o("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), o("ERR_STREAM_WRITE_AFTER_END", "write after end"), o("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), o("ERR_UNKNOWN_ENCODING", function(l) {
    return "Unknown encoding: " + l;
  }, TypeError), o("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), _o.codes = r, _o;
}
var Co, k0;
function xb() {
  if (k0)
    return Co;
  k0 = 1;
  var e = ii().codes.ERR_INVALID_OPT_VALUE;
  function r(n, i, t) {
    return n.highWaterMark != null ? n.highWaterMark : i ? n[t] : null;
  }
  function o(n, i, t, u) {
    var l = r(i, u, t);
    if (l != null) {
      if (!(isFinite(l) && Math.floor(l) === l) || l < 0) {
        var f = u ? t : "highWaterMark";
        throw new e(f, l);
      }
      return Math.floor(l);
    }
    return n.objectMode ? 16 : 16 * 1024;
  }
  return Co = {
    getHighWaterMark: o
  }, Co;
}
var To, H0;
function cT() {
  if (H0)
    return To;
  H0 = 1, To = e;
  function e(o, n) {
    if (r("noDeprecation"))
      return o;
    var i = !1;
    function t() {
      if (!i) {
        if (r("throwDeprecation"))
          throw new Error(n);
        r("traceDeprecation") ? console.trace(n) : console.warn(n), i = !0;
      }
      return o.apply(this, arguments);
    }
    return t;
  }
  function r(o) {
    try {
      if (!Xe.localStorage)
        return !1;
    } catch {
      return !1;
    }
    var n = Xe.localStorage[o];
    return n == null ? !1 : String(n).toLowerCase() === "true";
  }
  return To;
}
var Bo, G0;
function Eb() {
  if (G0)
    return Bo;
  G0 = 1, Bo = O;
  function e(K) {
    var J = this;
    this.next = null, this.entry = null, this.finish = function() {
      se(J, K);
    };
  }
  var r;
  O.WritableState = S;
  var o = {
    deprecate: cT()
  }, n = yb(), i = Nn().Buffer, t = (typeof Xe < "u" ? Xe : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function u(K) {
    return i.from(K);
  }
  function l(K) {
    return i.isBuffer(K) || K instanceof t;
  }
  var f = wb(), s = xb(), a = s.getHighWaterMark, c = ii().codes, d = c.ERR_INVALID_ARG_TYPE, h = c.ERR_METHOD_NOT_IMPLEMENTED, p = c.ERR_MULTIPLE_CALLBACK, v = c.ERR_STREAM_CANNOT_PIPE, g = c.ERR_STREAM_DESTROYED, m = c.ERR_STREAM_NULL_VALUES, x = c.ERR_STREAM_WRITE_AFTER_END, y = c.ERR_UNKNOWN_ENCODING, E = f.errorOrDestroy;
  Je()(O, n);
  function N() {
  }
  function S(K, J, te) {
    r = r || Wn(), K = K || {}, typeof te != "boolean" && (te = J instanceof r), this.objectMode = !!K.objectMode, te && (this.objectMode = this.objectMode || !!K.writableObjectMode), this.highWaterMark = a(this, K, "writableHighWaterMark", te), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var ne = K.decodeStrings === !1;
    this.decodeStrings = !ne, this.defaultEncoding = K.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(ue) {
      M(J, ue);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = K.emitClose !== !1, this.autoDestroy = !!K.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
  }
  S.prototype.getBuffer = function() {
    for (var J = this.bufferedRequest, te = []; J; )
      te.push(J), J = J.next;
    return te;
  }, function() {
    try {
      Object.defineProperty(S.prototype, "buffer", {
        get: o.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var R;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (R = Function.prototype[Symbol.hasInstance], Object.defineProperty(O, Symbol.hasInstance, {
    value: function(J) {
      return R.call(this, J) ? !0 : this !== O ? !1 : J && J._writableState instanceof S;
    }
  })) : R = function(J) {
    return J instanceof this;
  };
  function O(K) {
    r = r || Wn();
    var J = this instanceof r;
    if (!J && !R.call(O, this))
      return new O(K);
    this._writableState = new S(K, this, J), this.writable = !0, K && (typeof K.write == "function" && (this._write = K.write), typeof K.writev == "function" && (this._writev = K.writev), typeof K.destroy == "function" && (this._destroy = K.destroy), typeof K.final == "function" && (this._final = K.final)), n.call(this);
  }
  O.prototype.pipe = function() {
    E(this, new v());
  };
  function B(K, J) {
    var te = new x();
    E(K, te), process.nextTick(J, te);
  }
  function $(K, J, te, ne) {
    var ue;
    return te === null ? ue = new m() : typeof te != "string" && !J.objectMode && (ue = new d("chunk", ["string", "Buffer"], te)), ue ? (E(K, ue), process.nextTick(ne, ue), !1) : !0;
  }
  O.prototype.write = function(K, J, te) {
    var ne = this._writableState, ue = !1, V = !ne.objectMode && l(K);
    return V && !i.isBuffer(K) && (K = u(K)), typeof J == "function" && (te = J, J = null), V ? J = "buffer" : J || (J = ne.defaultEncoding), typeof te != "function" && (te = N), ne.ending ? B(this, te) : (V || $(this, ne, K, te)) && (ne.pendingcb++, ue = w(this, ne, V, K, J, te)), ue;
  }, O.prototype.cork = function() {
    this._writableState.corked++;
  }, O.prototype.uncork = function() {
    var K = this._writableState;
    K.corked && (K.corked--, !K.writing && !K.corked && !K.bufferProcessing && K.bufferedRequest && C(this, K));
  }, O.prototype.setDefaultEncoding = function(J) {
    if (typeof J == "string" && (J = J.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((J + "").toLowerCase()) > -1))
      throw new y(J);
    return this._writableState.defaultEncoding = J, this;
  }, Object.defineProperty(O.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function F(K, J, te) {
    return !K.objectMode && K.decodeStrings !== !1 && typeof J == "string" && (J = i.from(J, te)), J;
  }
  Object.defineProperty(O.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function w(K, J, te, ne, ue, V) {
    if (!te) {
      var W = F(J, ne, ue);
      ne !== W && (te = !0, ue = "buffer", ne = W);
    }
    var fe = J.objectMode ? 1 : ne.length;
    J.length += fe;
    var pe = J.length < J.highWaterMark;
    if (pe || (J.needDrain = !0), J.writing || J.corked) {
      var Y = J.lastBufferedRequest;
      J.lastBufferedRequest = {
        chunk: ne,
        encoding: ue,
        isBuf: te,
        callback: V,
        next: null
      }, Y ? Y.next = J.lastBufferedRequest : J.bufferedRequest = J.lastBufferedRequest, J.bufferedRequestCount += 1;
    } else
      A(K, J, !1, fe, ne, ue, V);
    return pe;
  }
  function A(K, J, te, ne, ue, V, W) {
    J.writelen = ne, J.writecb = W, J.writing = !0, J.sync = !0, J.destroyed ? J.onwrite(new g("write")) : te ? K._writev(ue, J.onwrite) : K._write(ue, V, J.onwrite), J.sync = !1;
  }
  function b(K, J, te, ne, ue) {
    --J.pendingcb, te ? (process.nextTick(ue, ne), process.nextTick(U, K, J), K._writableState.errorEmitted = !0, E(K, ne)) : (ue(ne), K._writableState.errorEmitted = !0, E(K, ne), U(K, J));
  }
  function D(K) {
    K.writing = !1, K.writecb = null, K.length -= K.writelen, K.writelen = 0;
  }
  function M(K, J) {
    var te = K._writableState, ne = te.sync, ue = te.writecb;
    if (typeof ue != "function")
      throw new p();
    if (D(te), J)
      b(K, te, ne, J, ue);
    else {
      var V = T(te) || K.destroyed;
      !V && !te.corked && !te.bufferProcessing && te.bufferedRequest && C(K, te), ne ? process.nextTick(_, K, te, V, ue) : _(K, te, V, ue);
    }
  }
  function _(K, J, te, ne) {
    te || q(K, J), J.pendingcb--, ne(), U(K, J);
  }
  function q(K, J) {
    J.length === 0 && J.needDrain && (J.needDrain = !1, K.emit("drain"));
  }
  function C(K, J) {
    J.bufferProcessing = !0;
    var te = J.bufferedRequest;
    if (K._writev && te && te.next) {
      var ne = J.bufferedRequestCount, ue = new Array(ne), V = J.corkedRequestsFree;
      V.entry = te;
      for (var W = 0, fe = !0; te; )
        ue[W] = te, te.isBuf || (fe = !1), te = te.next, W += 1;
      ue.allBuffers = fe, A(K, J, !0, J.length, ue, "", V.finish), J.pendingcb++, J.lastBufferedRequest = null, V.next ? (J.corkedRequestsFree = V.next, V.next = null) : J.corkedRequestsFree = new e(J), J.bufferedRequestCount = 0;
    } else {
      for (; te; ) {
        var pe = te.chunk, Y = te.encoding, k = te.callback, L = J.objectMode ? 1 : pe.length;
        if (A(K, J, !1, L, pe, Y, k), te = te.next, J.bufferedRequestCount--, J.writing)
          break;
      }
      te === null && (J.lastBufferedRequest = null);
    }
    J.bufferedRequest = te, J.bufferProcessing = !1;
  }
  O.prototype._write = function(K, J, te) {
    te(new h("_write()"));
  }, O.prototype._writev = null, O.prototype.end = function(K, J, te) {
    var ne = this._writableState;
    return typeof K == "function" ? (te = K, K = null, J = null) : typeof J == "function" && (te = J, J = null), K != null && this.write(K, J), ne.corked && (ne.corked = 1, this.uncork()), ne.ending || ee(this, ne, te), this;
  }, Object.defineProperty(O.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function T(K) {
    return K.ending && K.length === 0 && K.bufferedRequest === null && !K.finished && !K.writing;
  }
  function z(K, J) {
    K._final(function(te) {
      J.pendingcb--, te && E(K, te), J.prefinished = !0, K.emit("prefinish"), U(K, J);
    });
  }
  function I(K, J) {
    !J.prefinished && !J.finalCalled && (typeof K._final == "function" && !J.destroyed ? (J.pendingcb++, J.finalCalled = !0, process.nextTick(z, K, J)) : (J.prefinished = !0, K.emit("prefinish")));
  }
  function U(K, J) {
    var te = T(J);
    if (te && (I(K, J), J.pendingcb === 0 && (J.finished = !0, K.emit("finish"), J.autoDestroy))) {
      var ne = K._readableState;
      (!ne || ne.autoDestroy && ne.endEmitted) && K.destroy();
    }
    return te;
  }
  function ee(K, J, te) {
    J.ending = !0, U(K, J), te && (J.finished ? process.nextTick(te) : K.once("finish", te)), J.ended = !0, K.writable = !1;
  }
  function se(K, J, te) {
    var ne = K.entry;
    for (K.entry = null; ne; ) {
      var ue = ne.callback;
      J.pendingcb--, ue(te), ne = ne.next;
    }
    J.corkedRequestsFree.next = K;
  }
  return Object.defineProperty(O.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(J) {
      this._writableState && (this._writableState.destroyed = J);
    }
  }), O.prototype.destroy = f.destroy, O.prototype._undestroy = f.undestroy, O.prototype._destroy = function(K, J) {
    J(K);
  }, Bo;
}
var Fo, V0;
function Wn() {
  if (V0)
    return Fo;
  V0 = 1;
  var e = Object.keys || function(s) {
    var a = [];
    for (var c in s)
      a.push(c);
    return a;
  };
  Fo = u;
  var r = Ab(), o = Eb();
  Je()(u, r);
  for (var n = e(o.prototype), i = 0; i < n.length; i++) {
    var t = n[i];
    u.prototype[t] || (u.prototype[t] = o.prototype[t]);
  }
  function u(s) {
    if (!(this instanceof u))
      return new u(s);
    r.call(this, s), o.call(this, s), this.allowHalfOpen = !0, s && (s.readable === !1 && (this.readable = !1), s.writable === !1 && (this.writable = !1), s.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", l)));
  }
  Object.defineProperty(u.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(u.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(u.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function l() {
    this._writableState.ended || process.nextTick(f, this);
  }
  function f(s) {
    s.end();
  }
  return Object.defineProperty(u.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(a) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = a, this._writableState.destroyed = a);
    }
  }), Fo;
}
var Io = {}, W0;
function K0() {
  if (W0)
    return Io;
  W0 = 1;
  var e = Ye().Buffer, r = e.isEncoding || function(m) {
    switch (m = "" + m, m && m.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function o(m) {
    if (!m)
      return "utf8";
    for (var x; ; )
      switch (m) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return m;
        default:
          if (x)
            return;
          m = ("" + m).toLowerCase(), x = !0;
      }
  }
  function n(m) {
    var x = o(m);
    if (typeof x != "string" && (e.isEncoding === r || !r(m)))
      throw new Error("Unknown encoding: " + m);
    return x || m;
  }
  Io.StringDecoder = i;
  function i(m) {
    this.encoding = n(m);
    var x;
    switch (this.encoding) {
      case "utf16le":
        this.text = c, this.end = d, x = 4;
        break;
      case "utf8":
        this.fillLast = f, x = 4;
        break;
      case "base64":
        this.text = h, this.end = p, x = 3;
        break;
      default:
        this.write = v, this.end = g;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = e.allocUnsafe(x);
  }
  i.prototype.write = function(m) {
    if (m.length === 0)
      return "";
    var x, y;
    if (this.lastNeed) {
      if (x = this.fillLast(m), x === void 0)
        return "";
      y = this.lastNeed, this.lastNeed = 0;
    } else
      y = 0;
    return y < m.length ? x ? x + this.text(m, y) : this.text(m, y) : x || "";
  }, i.prototype.end = a, i.prototype.text = s, i.prototype.fillLast = function(m) {
    if (this.lastNeed <= m.length)
      return m.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    m.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, m.length), this.lastNeed -= m.length;
  };
  function t(m) {
    return m <= 127 ? 0 : m >> 5 === 6 ? 2 : m >> 4 === 14 ? 3 : m >> 3 === 30 ? 4 : m >> 6 === 2 ? -1 : -2;
  }
  function u(m, x, y) {
    var E = x.length - 1;
    if (E < y)
      return 0;
    var N = t(x[E]);
    return N >= 0 ? (N > 0 && (m.lastNeed = N - 1), N) : --E < y || N === -2 ? 0 : (N = t(x[E]), N >= 0 ? (N > 0 && (m.lastNeed = N - 2), N) : --E < y || N === -2 ? 0 : (N = t(x[E]), N >= 0 ? (N > 0 && (N === 2 ? N = 0 : m.lastNeed = N - 3), N) : 0));
  }
  function l(m, x, y) {
    if ((x[0] & 192) !== 128)
      return m.lastNeed = 0, "�";
    if (m.lastNeed > 1 && x.length > 1) {
      if ((x[1] & 192) !== 128)
        return m.lastNeed = 1, "�";
      if (m.lastNeed > 2 && x.length > 2 && (x[2] & 192) !== 128)
        return m.lastNeed = 2, "�";
    }
  }
  function f(m) {
    var x = this.lastTotal - this.lastNeed, y = l(this, m);
    if (y !== void 0)
      return y;
    if (this.lastNeed <= m.length)
      return m.copy(this.lastChar, x, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    m.copy(this.lastChar, x, 0, m.length), this.lastNeed -= m.length;
  }
  function s(m, x) {
    var y = u(this, m, x);
    if (!this.lastNeed)
      return m.toString("utf8", x);
    this.lastTotal = y;
    var E = m.length - (y - this.lastNeed);
    return m.copy(this.lastChar, 0, E), m.toString("utf8", x, E);
  }
  function a(m) {
    var x = m && m.length ? this.write(m) : "";
    return this.lastNeed ? x + "�" : x;
  }
  function c(m, x) {
    if ((m.length - x) % 2 === 0) {
      var y = m.toString("utf16le", x);
      if (y) {
        var E = y.charCodeAt(y.length - 1);
        if (E >= 55296 && E <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = m[m.length - 2], this.lastChar[1] = m[m.length - 1], y.slice(0, -1);
      }
      return y;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = m[m.length - 1], m.toString("utf16le", x, m.length - 1);
  }
  function d(m) {
    var x = m && m.length ? this.write(m) : "";
    if (this.lastNeed) {
      var y = this.lastTotal - this.lastNeed;
      return x + this.lastChar.toString("utf16le", 0, y);
    }
    return x;
  }
  function h(m, x) {
    var y = (m.length - x) % 3;
    return y === 0 ? m.toString("base64", x) : (this.lastNeed = 3 - y, this.lastTotal = 3, y === 1 ? this.lastChar[0] = m[m.length - 1] : (this.lastChar[0] = m[m.length - 2], this.lastChar[1] = m[m.length - 1]), m.toString("base64", x, m.length - y));
  }
  function p(m) {
    var x = m && m.length ? this.write(m) : "";
    return this.lastNeed ? x + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : x;
  }
  function v(m) {
    return m.toString(this.encoding);
  }
  function g(m) {
    return m && m.length ? this.write(m) : "";
  }
  return Io;
}
var Oo, Z0;
function jf() {
  if (Z0)
    return Oo;
  Z0 = 1;
  var e = ii().codes.ERR_STREAM_PREMATURE_CLOSE;
  function r(t) {
    var u = !1;
    return function() {
      if (!u) {
        u = !0;
        for (var l = arguments.length, f = new Array(l), s = 0; s < l; s++)
          f[s] = arguments[s];
        t.apply(this, f);
      }
    };
  }
  function o() {
  }
  function n(t) {
    return t.setHeader && typeof t.abort == "function";
  }
  function i(t, u, l) {
    if (typeof u == "function")
      return i(t, null, u);
    u || (u = {}), l = r(l || o);
    var f = u.readable || u.readable !== !1 && t.readable, s = u.writable || u.writable !== !1 && t.writable, a = function() {
      t.writable || d();
    }, c = t._writableState && t._writableState.finished, d = function() {
      s = !1, c = !0, f || l.call(t);
    }, h = t._readableState && t._readableState.endEmitted, p = function() {
      f = !1, h = !0, s || l.call(t);
    }, v = function(y) {
      l.call(t, y);
    }, g = function() {
      var y;
      if (f && !h)
        return (!t._readableState || !t._readableState.ended) && (y = new e()), l.call(t, y);
      if (s && !c)
        return (!t._writableState || !t._writableState.ended) && (y = new e()), l.call(t, y);
    }, m = function() {
      t.req.on("finish", d);
    };
    return n(t) ? (t.on("complete", d), t.on("abort", g), t.req ? m() : t.on("request", m)) : s && !t._writableState && (t.on("end", a), t.on("close", a)), t.on("end", p), t.on("finish", d), u.error !== !1 && t.on("error", v), t.on("close", g), function() {
      t.removeListener("complete", d), t.removeListener("abort", g), t.removeListener("request", m), t.req && t.req.removeListener("finish", d), t.removeListener("end", a), t.removeListener("close", a), t.removeListener("finish", d), t.removeListener("end", p), t.removeListener("error", v), t.removeListener("close", g);
    };
  }
  return Oo = i, Oo;
}
var Ro, j0;
function lT() {
  if (j0)
    return Ro;
  j0 = 1;
  var e;
  function r(y, E, N) {
    return E = o(E), E in y ? Object.defineProperty(y, E, { value: N, enumerable: !0, configurable: !0, writable: !0 }) : y[E] = N, y;
  }
  function o(y) {
    var E = n(y, "string");
    return typeof E == "symbol" ? E : String(E);
  }
  function n(y, E) {
    if (typeof y != "object" || y === null)
      return y;
    var N = y[Symbol.toPrimitive];
    if (N !== void 0) {
      var S = N.call(y, E || "default");
      if (typeof S != "object")
        return S;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (E === "string" ? String : Number)(y);
  }
  var i = jf(), t = Symbol("lastResolve"), u = Symbol("lastReject"), l = Symbol("error"), f = Symbol("ended"), s = Symbol("lastPromise"), a = Symbol("handlePromise"), c = Symbol("stream");
  function d(y, E) {
    return {
      value: y,
      done: E
    };
  }
  function h(y) {
    var E = y[t];
    if (E !== null) {
      var N = y[c].read();
      N !== null && (y[s] = null, y[t] = null, y[u] = null, E(d(N, !1)));
    }
  }
  function p(y) {
    process.nextTick(h, y);
  }
  function v(y, E) {
    return function(N, S) {
      y.then(function() {
        if (E[f]) {
          N(d(void 0, !0));
          return;
        }
        E[a](N, S);
      }, S);
    };
  }
  var g = Object.getPrototypeOf(function() {
  }), m = Object.setPrototypeOf((e = {
    get stream() {
      return this[c];
    },
    next: function() {
      var E = this, N = this[l];
      if (N !== null)
        return Promise.reject(N);
      if (this[f])
        return Promise.resolve(d(void 0, !0));
      if (this[c].destroyed)
        return new Promise(function(B, $) {
          process.nextTick(function() {
            E[l] ? $(E[l]) : B(d(void 0, !0));
          });
        });
      var S = this[s], R;
      if (S)
        R = new Promise(v(S, this));
      else {
        var O = this[c].read();
        if (O !== null)
          return Promise.resolve(d(O, !1));
        R = new Promise(this[a]);
      }
      return this[s] = R, R;
    }
  }, r(e, Symbol.asyncIterator, function() {
    return this;
  }), r(e, "return", function() {
    var E = this;
    return new Promise(function(N, S) {
      E[c].destroy(null, function(R) {
        if (R) {
          S(R);
          return;
        }
        N(d(void 0, !0));
      });
    });
  }), e), g), x = function(E) {
    var N, S = Object.create(m, (N = {}, r(N, c, {
      value: E,
      writable: !0
    }), r(N, t, {
      value: null,
      writable: !0
    }), r(N, u, {
      value: null,
      writable: !0
    }), r(N, l, {
      value: null,
      writable: !0
    }), r(N, f, {
      value: E._readableState.endEmitted,
      writable: !0
    }), r(N, a, {
      value: function(O, B) {
        var $ = S[c].read();
        $ ? (S[s] = null, S[t] = null, S[u] = null, O(d($, !1))) : (S[t] = O, S[u] = B);
      },
      writable: !0
    }), N));
    return S[s] = null, i(E, function(R) {
      if (R && R.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var O = S[u];
        O !== null && (S[s] = null, S[t] = null, S[u] = null, O(R)), S[l] = R;
        return;
      }
      var B = S[t];
      B !== null && (S[s] = null, S[t] = null, S[u] = null, B(d(void 0, !0))), S[f] = !0;
    }), E.on("readable", p.bind(null, S)), S;
  };
  return Ro = x, Ro;
}
var Po, Y0;
function dT() {
  return Y0 || (Y0 = 1, Po = function() {
    throw new Error("Readable.from is not available in the browser");
  }), Po;
}
var qo, X0;
function Ab() {
  if (X0)
    return qo;
  X0 = 1, qo = B;
  var e;
  B.ReadableState = O, bb().EventEmitter;
  var r = function(W, fe) {
    return W.listeners(fe).length;
  }, o = yb(), n = Nn().Buffer, i = (typeof Xe < "u" ? Xe : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function t(V) {
    return n.from(V);
  }
  function u(V) {
    return n.isBuffer(V) || V instanceof i;
  }
  var l = Ii, f;
  l && l.debuglog ? f = l.debuglog("stream") : f = function() {
  };
  var s = fT(), a = wb(), c = xb(), d = c.getHighWaterMark, h = ii().codes, p = h.ERR_INVALID_ARG_TYPE, v = h.ERR_STREAM_PUSH_AFTER_EOF, g = h.ERR_METHOD_NOT_IMPLEMENTED, m = h.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, x, y, E;
  Je()(B, o);
  var N = a.errorOrDestroy, S = ["error", "close", "destroy", "pause", "resume"];
  function R(V, W, fe) {
    if (typeof V.prependListener == "function")
      return V.prependListener(W, fe);
    !V._events || !V._events[W] ? V.on(W, fe) : Array.isArray(V._events[W]) ? V._events[W].unshift(fe) : V._events[W] = [fe, V._events[W]];
  }
  function O(V, W, fe) {
    e = e || Wn(), V = V || {}, typeof fe != "boolean" && (fe = W instanceof e), this.objectMode = !!V.objectMode, fe && (this.objectMode = this.objectMode || !!V.readableObjectMode), this.highWaterMark = d(this, V, "readableHighWaterMark", fe), this.buffer = new s(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = V.emitClose !== !1, this.autoDestroy = !!V.autoDestroy, this.destroyed = !1, this.defaultEncoding = V.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, V.encoding && (x || (x = K0().StringDecoder), this.decoder = new x(V.encoding), this.encoding = V.encoding);
  }
  function B(V) {
    if (e = e || Wn(), !(this instanceof B))
      return new B(V);
    var W = this instanceof e;
    this._readableState = new O(V, this, W), this.readable = !0, V && (typeof V.read == "function" && (this._read = V.read), typeof V.destroy == "function" && (this._destroy = V.destroy)), o.call(this);
  }
  Object.defineProperty(B.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(W) {
      this._readableState && (this._readableState.destroyed = W);
    }
  }), B.prototype.destroy = a.destroy, B.prototype._undestroy = a.undestroy, B.prototype._destroy = function(V, W) {
    W(V);
  }, B.prototype.push = function(V, W) {
    var fe = this._readableState, pe;
    return fe.objectMode ? pe = !0 : typeof V == "string" && (W = W || fe.defaultEncoding, W !== fe.encoding && (V = n.from(V, W), W = ""), pe = !0), $(this, V, W, !1, pe);
  }, B.prototype.unshift = function(V) {
    return $(this, V, null, !0, !1);
  };
  function $(V, W, fe, pe, Y) {
    f("readableAddChunk", W);
    var k = V._readableState;
    if (W === null)
      k.reading = !1, M(V, k);
    else {
      var L;
      if (Y || (L = w(k, W)), L)
        N(V, L);
      else if (k.objectMode || W && W.length > 0)
        if (typeof W != "string" && !k.objectMode && Object.getPrototypeOf(W) !== n.prototype && (W = t(W)), pe)
          k.endEmitted ? N(V, new m()) : F(V, k, W, !0);
        else if (k.ended)
          N(V, new v());
        else {
          if (k.destroyed)
            return !1;
          k.reading = !1, k.decoder && !fe ? (W = k.decoder.write(W), k.objectMode || W.length !== 0 ? F(V, k, W, !1) : C(V, k)) : F(V, k, W, !1);
        }
      else
        pe || (k.reading = !1, C(V, k));
    }
    return !k.ended && (k.length < k.highWaterMark || k.length === 0);
  }
  function F(V, W, fe, pe) {
    W.flowing && W.length === 0 && !W.sync ? (W.awaitDrain = 0, V.emit("data", fe)) : (W.length += W.objectMode ? 1 : fe.length, pe ? W.buffer.unshift(fe) : W.buffer.push(fe), W.needReadable && _(V)), C(V, W);
  }
  function w(V, W) {
    var fe;
    return !u(W) && typeof W != "string" && W !== void 0 && !V.objectMode && (fe = new p("chunk", ["string", "Buffer", "Uint8Array"], W)), fe;
  }
  B.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, B.prototype.setEncoding = function(V) {
    x || (x = K0().StringDecoder);
    var W = new x(V);
    this._readableState.decoder = W, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var fe = this._readableState.buffer.head, pe = ""; fe !== null; )
      pe += W.write(fe.data), fe = fe.next;
    return this._readableState.buffer.clear(), pe !== "" && this._readableState.buffer.push(pe), this._readableState.length = pe.length, this;
  };
  var A = 1073741824;
  function b(V) {
    return V >= A ? V = A : (V--, V |= V >>> 1, V |= V >>> 2, V |= V >>> 4, V |= V >>> 8, V |= V >>> 16, V++), V;
  }
  function D(V, W) {
    return V <= 0 || W.length === 0 && W.ended ? 0 : W.objectMode ? 1 : V !== V ? W.flowing && W.length ? W.buffer.head.data.length : W.length : (V > W.highWaterMark && (W.highWaterMark = b(V)), V <= W.length ? V : W.ended ? W.length : (W.needReadable = !0, 0));
  }
  B.prototype.read = function(V) {
    f("read", V), V = parseInt(V, 10);
    var W = this._readableState, fe = V;
    if (V !== 0 && (W.emittedReadable = !1), V === 0 && W.needReadable && ((W.highWaterMark !== 0 ? W.length >= W.highWaterMark : W.length > 0) || W.ended))
      return f("read: emitReadable", W.length, W.ended), W.length === 0 && W.ended ? te(this) : _(this), null;
    if (V = D(V, W), V === 0 && W.ended)
      return W.length === 0 && te(this), null;
    var pe = W.needReadable;
    f("need readable", pe), (W.length === 0 || W.length - V < W.highWaterMark) && (pe = !0, f("length less than watermark", pe)), W.ended || W.reading ? (pe = !1, f("reading or ended", pe)) : pe && (f("do read"), W.reading = !0, W.sync = !0, W.length === 0 && (W.needReadable = !0), this._read(W.highWaterMark), W.sync = !1, W.reading || (V = D(fe, W)));
    var Y;
    return V > 0 ? Y = J(V, W) : Y = null, Y === null ? (W.needReadable = W.length <= W.highWaterMark, V = 0) : (W.length -= V, W.awaitDrain = 0), W.length === 0 && (W.ended || (W.needReadable = !0), fe !== V && W.ended && te(this)), Y !== null && this.emit("data", Y), Y;
  };
  function M(V, W) {
    if (f("onEofChunk"), !W.ended) {
      if (W.decoder) {
        var fe = W.decoder.end();
        fe && fe.length && (W.buffer.push(fe), W.length += W.objectMode ? 1 : fe.length);
      }
      W.ended = !0, W.sync ? _(V) : (W.needReadable = !1, W.emittedReadable || (W.emittedReadable = !0, q(V)));
    }
  }
  function _(V) {
    var W = V._readableState;
    f("emitReadable", W.needReadable, W.emittedReadable), W.needReadable = !1, W.emittedReadable || (f("emitReadable", W.flowing), W.emittedReadable = !0, process.nextTick(q, V));
  }
  function q(V) {
    var W = V._readableState;
    f("emitReadable_", W.destroyed, W.length, W.ended), !W.destroyed && (W.length || W.ended) && (V.emit("readable"), W.emittedReadable = !1), W.needReadable = !W.flowing && !W.ended && W.length <= W.highWaterMark, K(V);
  }
  function C(V, W) {
    W.readingMore || (W.readingMore = !0, process.nextTick(T, V, W));
  }
  function T(V, W) {
    for (; !W.reading && !W.ended && (W.length < W.highWaterMark || W.flowing && W.length === 0); ) {
      var fe = W.length;
      if (f("maybeReadMore read 0"), V.read(0), fe === W.length)
        break;
    }
    W.readingMore = !1;
  }
  B.prototype._read = function(V) {
    N(this, new g("_read()"));
  }, B.prototype.pipe = function(V, W) {
    var fe = this, pe = this._readableState;
    switch (pe.pipesCount) {
      case 0:
        pe.pipes = V;
        break;
      case 1:
        pe.pipes = [pe.pipes, V];
        break;
      default:
        pe.pipes.push(V);
        break;
    }
    pe.pipesCount += 1, f("pipe count=%d opts=%j", pe.pipesCount, W);
    var Y = (!W || W.end !== !1) && V !== process.stdout && V !== process.stderr, k = Y ? P : ce;
    pe.endEmitted ? process.nextTick(k) : fe.once("end", k), V.on("unpipe", L);
    function L(le, ve) {
      f("onunpipe"), le === fe && ve && ve.hasUnpiped === !1 && (ve.hasUnpiped = !0, re());
    }
    function P() {
      f("onend"), V.end();
    }
    var G = z(fe);
    V.on("drain", G);
    var j = !1;
    function re() {
      f("cleanup"), V.removeListener("close", X), V.removeListener("finish", oe), V.removeListener("drain", G), V.removeListener("error", Z), V.removeListener("unpipe", L), fe.removeListener("end", P), fe.removeListener("end", ce), fe.removeListener("data", ie), j = !0, pe.awaitDrain && (!V._writableState || V._writableState.needDrain) && G();
    }
    fe.on("data", ie);
    function ie(le) {
      f("ondata");
      var ve = V.write(le);
      f("dest.write", ve), ve === !1 && ((pe.pipesCount === 1 && pe.pipes === V || pe.pipesCount > 1 && ue(pe.pipes, V) !== -1) && !j && (f("false write response, pause", pe.awaitDrain), pe.awaitDrain++), fe.pause());
    }
    function Z(le) {
      f("onerror", le), ce(), V.removeListener("error", Z), r(V, "error") === 0 && N(V, le);
    }
    R(V, "error", Z);
    function X() {
      V.removeListener("finish", oe), ce();
    }
    V.once("close", X);
    function oe() {
      f("onfinish"), V.removeListener("close", X), ce();
    }
    V.once("finish", oe);
    function ce() {
      f("unpipe"), fe.unpipe(V);
    }
    return V.emit("pipe", fe), pe.flowing || (f("pipe resume"), fe.resume()), V;
  };
  function z(V) {
    return function() {
      var fe = V._readableState;
      f("pipeOnDrain", fe.awaitDrain), fe.awaitDrain && fe.awaitDrain--, fe.awaitDrain === 0 && r(V, "data") && (fe.flowing = !0, K(V));
    };
  }
  B.prototype.unpipe = function(V) {
    var W = this._readableState, fe = {
      hasUnpiped: !1
    };
    if (W.pipesCount === 0)
      return this;
    if (W.pipesCount === 1)
      return V && V !== W.pipes ? this : (V || (V = W.pipes), W.pipes = null, W.pipesCount = 0, W.flowing = !1, V && V.emit("unpipe", this, fe), this);
    if (!V) {
      var pe = W.pipes, Y = W.pipesCount;
      W.pipes = null, W.pipesCount = 0, W.flowing = !1;
      for (var k = 0; k < Y; k++)
        pe[k].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var L = ue(W.pipes, V);
    return L === -1 ? this : (W.pipes.splice(L, 1), W.pipesCount -= 1, W.pipesCount === 1 && (W.pipes = W.pipes[0]), V.emit("unpipe", this, fe), this);
  }, B.prototype.on = function(V, W) {
    var fe = o.prototype.on.call(this, V, W), pe = this._readableState;
    return V === "data" ? (pe.readableListening = this.listenerCount("readable") > 0, pe.flowing !== !1 && this.resume()) : V === "readable" && !pe.endEmitted && !pe.readableListening && (pe.readableListening = pe.needReadable = !0, pe.flowing = !1, pe.emittedReadable = !1, f("on readable", pe.length, pe.reading), pe.length ? _(this) : pe.reading || process.nextTick(U, this)), fe;
  }, B.prototype.addListener = B.prototype.on, B.prototype.removeListener = function(V, W) {
    var fe = o.prototype.removeListener.call(this, V, W);
    return V === "readable" && process.nextTick(I, this), fe;
  }, B.prototype.removeAllListeners = function(V) {
    var W = o.prototype.removeAllListeners.apply(this, arguments);
    return (V === "readable" || V === void 0) && process.nextTick(I, this), W;
  };
  function I(V) {
    var W = V._readableState;
    W.readableListening = V.listenerCount("readable") > 0, W.resumeScheduled && !W.paused ? W.flowing = !0 : V.listenerCount("data") > 0 && V.resume();
  }
  function U(V) {
    f("readable nexttick read 0"), V.read(0);
  }
  B.prototype.resume = function() {
    var V = this._readableState;
    return V.flowing || (f("resume"), V.flowing = !V.readableListening, ee(this, V)), V.paused = !1, this;
  };
  function ee(V, W) {
    W.resumeScheduled || (W.resumeScheduled = !0, process.nextTick(se, V, W));
  }
  function se(V, W) {
    f("resume", W.reading), W.reading || V.read(0), W.resumeScheduled = !1, V.emit("resume"), K(V), W.flowing && !W.reading && V.read(0);
  }
  B.prototype.pause = function() {
    return f("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (f("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function K(V) {
    var W = V._readableState;
    for (f("flow", W.flowing); W.flowing && V.read() !== null; )
      ;
  }
  B.prototype.wrap = function(V) {
    var W = this, fe = this._readableState, pe = !1;
    V.on("end", function() {
      if (f("wrapped end"), fe.decoder && !fe.ended) {
        var L = fe.decoder.end();
        L && L.length && W.push(L);
      }
      W.push(null);
    }), V.on("data", function(L) {
      if (f("wrapped data"), fe.decoder && (L = fe.decoder.write(L)), !(fe.objectMode && L == null) && !(!fe.objectMode && (!L || !L.length))) {
        var P = W.push(L);
        P || (pe = !0, V.pause());
      }
    });
    for (var Y in V)
      this[Y] === void 0 && typeof V[Y] == "function" && (this[Y] = /* @__PURE__ */ function(P) {
        return function() {
          return V[P].apply(V, arguments);
        };
      }(Y));
    for (var k = 0; k < S.length; k++)
      V.on(S[k], this.emit.bind(this, S[k]));
    return this._read = function(L) {
      f("wrapped _read", L), pe && (pe = !1, V.resume());
    }, this;
  }, typeof Symbol == "function" && (B.prototype[Symbol.asyncIterator] = function() {
    return y === void 0 && (y = lT()), y(this);
  }), Object.defineProperty(B.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(B.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(B.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(W) {
      this._readableState && (this._readableState.flowing = W);
    }
  }), B._fromList = J, Object.defineProperty(B.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function J(V, W) {
    if (W.length === 0)
      return null;
    var fe;
    return W.objectMode ? fe = W.buffer.shift() : !V || V >= W.length ? (W.decoder ? fe = W.buffer.join("") : W.buffer.length === 1 ? fe = W.buffer.first() : fe = W.buffer.concat(W.length), W.buffer.clear()) : fe = W.buffer.consume(V, W.decoder), fe;
  }
  function te(V) {
    var W = V._readableState;
    f("endReadable", W.endEmitted), W.endEmitted || (W.ended = !0, process.nextTick(ne, W, V));
  }
  function ne(V, W) {
    if (f("endReadableNT", V.endEmitted, V.length), !V.endEmitted && V.length === 0 && (V.endEmitted = !0, W.readable = !1, W.emit("end"), V.autoDestroy)) {
      var fe = W._writableState;
      (!fe || fe.autoDestroy && fe.finished) && W.destroy();
    }
  }
  typeof Symbol == "function" && (B.from = function(V, W) {
    return E === void 0 && (E = dT()), E(B, V, W);
  });
  function ue(V, W) {
    for (var fe = 0, pe = V.length; fe < pe; fe++)
      if (V[fe] === W)
        return fe;
    return -1;
  }
  return qo;
}
var $o, J0;
function Sb() {
  if (J0)
    return $o;
  J0 = 1, $o = l;
  var e = ii().codes, r = e.ERR_METHOD_NOT_IMPLEMENTED, o = e.ERR_MULTIPLE_CALLBACK, n = e.ERR_TRANSFORM_ALREADY_TRANSFORMING, i = e.ERR_TRANSFORM_WITH_LENGTH_0, t = Wn();
  Je()(l, t);
  function u(a, c) {
    var d = this._transformState;
    d.transforming = !1;
    var h = d.writecb;
    if (h === null)
      return this.emit("error", new o());
    d.writechunk = null, d.writecb = null, c != null && this.push(c), h(a);
    var p = this._readableState;
    p.reading = !1, (p.needReadable || p.length < p.highWaterMark) && this._read(p.highWaterMark);
  }
  function l(a) {
    if (!(this instanceof l))
      return new l(a);
    t.call(this, a), this._transformState = {
      afterTransform: u.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, a && (typeof a.transform == "function" && (this._transform = a.transform), typeof a.flush == "function" && (this._flush = a.flush)), this.on("prefinish", f);
  }
  function f() {
    var a = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(c, d) {
      s(a, c, d);
    }) : s(this, null, null);
  }
  l.prototype.push = function(a, c) {
    return this._transformState.needTransform = !1, t.prototype.push.call(this, a, c);
  }, l.prototype._transform = function(a, c, d) {
    d(new r("_transform()"));
  }, l.prototype._write = function(a, c, d) {
    var h = this._transformState;
    if (h.writecb = d, h.writechunk = a, h.writeencoding = c, !h.transforming) {
      var p = this._readableState;
      (h.needTransform || p.needReadable || p.length < p.highWaterMark) && this._read(p.highWaterMark);
    }
  }, l.prototype._read = function(a) {
    var c = this._transformState;
    c.writechunk !== null && !c.transforming ? (c.transforming = !0, this._transform(c.writechunk, c.writeencoding, c.afterTransform)) : c.needTransform = !0;
  }, l.prototype._destroy = function(a, c) {
    t.prototype._destroy.call(this, a, function(d) {
      c(d);
    });
  };
  function s(a, c, d) {
    if (c)
      return a.emit("error", c);
    if (d != null && a.push(d), a._writableState.length)
      throw new i();
    if (a._transformState.transforming)
      throw new n();
    return a.push(null);
  }
  return $o;
}
var zo, Q0;
function hT() {
  if (Q0)
    return zo;
  Q0 = 1, zo = r;
  var e = Sb();
  Je()(r, e);
  function r(o) {
    if (!(this instanceof r))
      return new r(o);
    e.call(this, o);
  }
  return r.prototype._transform = function(o, n, i) {
    i(null, o);
  }, zo;
}
var Lo, ep;
function pT() {
  if (ep)
    return Lo;
  ep = 1;
  var e;
  function r(d) {
    var h = !1;
    return function() {
      h || (h = !0, d.apply(void 0, arguments));
    };
  }
  var o = ii().codes, n = o.ERR_MISSING_ARGS, i = o.ERR_STREAM_DESTROYED;
  function t(d) {
    if (d)
      throw d;
  }
  function u(d) {
    return d.setHeader && typeof d.abort == "function";
  }
  function l(d, h, p, v) {
    v = r(v);
    var g = !1;
    d.on("close", function() {
      g = !0;
    }), e === void 0 && (e = jf()), e(d, {
      readable: h,
      writable: p
    }, function(x) {
      if (x)
        return v(x);
      g = !0, v();
    });
    var m = !1;
    return function(x) {
      if (!g && !m) {
        if (m = !0, u(d))
          return d.abort();
        if (typeof d.destroy == "function")
          return d.destroy();
        v(x || new i("pipe"));
      }
    };
  }
  function f(d) {
    d();
  }
  function s(d, h) {
    return d.pipe(h);
  }
  function a(d) {
    return !d.length || typeof d[d.length - 1] != "function" ? t : d.pop();
  }
  function c() {
    for (var d = arguments.length, h = new Array(d), p = 0; p < d; p++)
      h[p] = arguments[p];
    var v = a(h);
    if (Array.isArray(h[0]) && (h = h[0]), h.length < 2)
      throw new n("streams");
    var g, m = h.map(function(x, y) {
      var E = y < h.length - 1, N = y > 0;
      return l(x, E, N, function(S) {
        g || (g = S), S && m.forEach(f), !E && (m.forEach(f), v(g));
      });
    });
    return h.reduce(s);
  }
  return Lo = c, Lo;
}
var rp;
function Db() {
  return rp || (rp = 1, function(e, r) {
    r = e.exports = Ab(), r.Stream = r, r.Readable = r, r.Writable = Eb(), r.Duplex = Wn(), r.Transform = Sb(), r.PassThrough = hT(), r.finished = jf(), r.pipeline = pT();
  }(sa, sa.exports)), sa.exports;
}
var Uo, tp;
function Nb() {
  if (tp)
    return Uo;
  tp = 1;
  var e = Ye().Buffer, r = Db().Transform, o = Je();
  function n(t, u) {
    if (!e.isBuffer(t) && typeof t != "string")
      throw new TypeError(u + " must be a string or a buffer");
  }
  function i(t) {
    r.call(this), this._block = e.allocUnsafe(t), this._blockSize = t, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return o(i, r), i.prototype._transform = function(t, u, l) {
    var f = null;
    try {
      this.update(t, u);
    } catch (s) {
      f = s;
    }
    l(f);
  }, i.prototype._flush = function(t) {
    var u = null;
    try {
      this.push(this.digest());
    } catch (l) {
      u = l;
    }
    t(u);
  }, i.prototype.update = function(t, u) {
    if (n(t, "Data"), this._finalized)
      throw new Error("Digest already called");
    e.isBuffer(t) || (t = e.from(t, u));
    for (var l = this._block, f = 0; this._blockOffset + t.length - f >= this._blockSize; ) {
      for (var s = this._blockOffset; s < this._blockSize; )
        l[s++] = t[f++];
      this._update(), this._blockOffset = 0;
    }
    for (; f < t.length; )
      l[this._blockOffset++] = t[f++];
    for (var a = 0, c = t.length * 8; c > 0; ++a)
      this._length[a] += c, c = this._length[a] / 4294967296 | 0, c > 0 && (this._length[a] -= 4294967296 * c);
    return this;
  }, i.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, i.prototype.digest = function(t) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0;
    var u = this._digest();
    t !== void 0 && (u = u.toString(t)), this._block.fill(0), this._blockOffset = 0;
    for (var l = 0; l < 4; ++l)
      this._length[l] = 0;
    return u;
  }, i.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, Uo = i, Uo;
}
var ko, np;
function Yf() {
  if (np)
    return ko;
  np = 1;
  var e = Je(), r = Nb(), o = Ye().Buffer, n = new Array(16);
  function i() {
    r.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  e(i, r), i.prototype._update = function() {
    for (var a = n, c = 0; c < 16; ++c)
      a[c] = this._block.readInt32LE(c * 4);
    var d = this._a, h = this._b, p = this._c, v = this._d;
    d = u(d, h, p, v, a[0], 3614090360, 7), v = u(v, d, h, p, a[1], 3905402710, 12), p = u(p, v, d, h, a[2], 606105819, 17), h = u(h, p, v, d, a[3], 3250441966, 22), d = u(d, h, p, v, a[4], 4118548399, 7), v = u(v, d, h, p, a[5], 1200080426, 12), p = u(p, v, d, h, a[6], 2821735955, 17), h = u(h, p, v, d, a[7], 4249261313, 22), d = u(d, h, p, v, a[8], 1770035416, 7), v = u(v, d, h, p, a[9], 2336552879, 12), p = u(p, v, d, h, a[10], 4294925233, 17), h = u(h, p, v, d, a[11], 2304563134, 22), d = u(d, h, p, v, a[12], 1804603682, 7), v = u(v, d, h, p, a[13], 4254626195, 12), p = u(p, v, d, h, a[14], 2792965006, 17), h = u(h, p, v, d, a[15], 1236535329, 22), d = l(d, h, p, v, a[1], 4129170786, 5), v = l(v, d, h, p, a[6], 3225465664, 9), p = l(p, v, d, h, a[11], 643717713, 14), h = l(h, p, v, d, a[0], 3921069994, 20), d = l(d, h, p, v, a[5], 3593408605, 5), v = l(v, d, h, p, a[10], 38016083, 9), p = l(p, v, d, h, a[15], 3634488961, 14), h = l(h, p, v, d, a[4], 3889429448, 20), d = l(d, h, p, v, a[9], 568446438, 5), v = l(v, d, h, p, a[14], 3275163606, 9), p = l(p, v, d, h, a[3], 4107603335, 14), h = l(h, p, v, d, a[8], 1163531501, 20), d = l(d, h, p, v, a[13], 2850285829, 5), v = l(v, d, h, p, a[2], 4243563512, 9), p = l(p, v, d, h, a[7], 1735328473, 14), h = l(h, p, v, d, a[12], 2368359562, 20), d = f(d, h, p, v, a[5], 4294588738, 4), v = f(v, d, h, p, a[8], 2272392833, 11), p = f(p, v, d, h, a[11], 1839030562, 16), h = f(h, p, v, d, a[14], 4259657740, 23), d = f(d, h, p, v, a[1], 2763975236, 4), v = f(v, d, h, p, a[4], 1272893353, 11), p = f(p, v, d, h, a[7], 4139469664, 16), h = f(h, p, v, d, a[10], 3200236656, 23), d = f(d, h, p, v, a[13], 681279174, 4), v = f(v, d, h, p, a[0], 3936430074, 11), p = f(p, v, d, h, a[3], 3572445317, 16), h = f(h, p, v, d, a[6], 76029189, 23), d = f(d, h, p, v, a[9], 3654602809, 4), v = f(v, d, h, p, a[12], 3873151461, 11), p = f(p, v, d, h, a[15], 530742520, 16), h = f(h, p, v, d, a[2], 3299628645, 23), d = s(d, h, p, v, a[0], 4096336452, 6), v = s(v, d, h, p, a[7], 1126891415, 10), p = s(p, v, d, h, a[14], 2878612391, 15), h = s(h, p, v, d, a[5], 4237533241, 21), d = s(d, h, p, v, a[12], 1700485571, 6), v = s(v, d, h, p, a[3], 2399980690, 10), p = s(p, v, d, h, a[10], 4293915773, 15), h = s(h, p, v, d, a[1], 2240044497, 21), d = s(d, h, p, v, a[8], 1873313359, 6), v = s(v, d, h, p, a[15], 4264355552, 10), p = s(p, v, d, h, a[6], 2734768916, 15), h = s(h, p, v, d, a[13], 1309151649, 21), d = s(d, h, p, v, a[4], 4149444226, 6), v = s(v, d, h, p, a[11], 3174756917, 10), p = s(p, v, d, h, a[2], 718787259, 15), h = s(h, p, v, d, a[9], 3951481745, 21), this._a = this._a + d | 0, this._b = this._b + h | 0, this._c = this._c + p | 0, this._d = this._d + v | 0;
  }, i.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var a = o.allocUnsafe(16);
    return a.writeInt32LE(this._a, 0), a.writeInt32LE(this._b, 4), a.writeInt32LE(this._c, 8), a.writeInt32LE(this._d, 12), a;
  };
  function t(a, c) {
    return a << c | a >>> 32 - c;
  }
  function u(a, c, d, h, p, v, g) {
    return t(a + (c & d | ~c & h) + p + v | 0, g) + c | 0;
  }
  function l(a, c, d, h, p, v, g) {
    return t(a + (c & h | d & ~h) + p + v | 0, g) + c | 0;
  }
  function f(a, c, d, h, p, v, g) {
    return t(a + (c ^ d ^ h) + p + v | 0, g) + c | 0;
  }
  function s(a, c, d, h, p, v, g) {
    return t(a + (d ^ (c | ~h)) + p + v | 0, g) + c | 0;
  }
  return ko = i, ko;
}
var Ho, ip;
function Xf() {
  if (ip)
    return Ho;
  ip = 1;
  var e = Nn().Buffer, r = Je(), o = Nb(), n = new Array(16), i = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], t = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], u = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], l = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], f = [0, 1518500249, 1859775393, 2400959708, 2840853838], s = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function a() {
    o.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  r(a, o), a.prototype._update = function() {
    for (var m = n, x = 0; x < 16; ++x)
      m[x] = this._block.readInt32LE(x * 4);
    for (var y = this._a | 0, E = this._b | 0, N = this._c | 0, S = this._d | 0, R = this._e | 0, O = this._a | 0, B = this._b | 0, $ = this._c | 0, F = this._d | 0, w = this._e | 0, A = 0; A < 80; A += 1) {
      var b, D;
      A < 16 ? (b = d(y, E, N, S, R, m[i[A]], f[0], u[A]), D = g(O, B, $, F, w, m[t[A]], s[0], l[A])) : A < 32 ? (b = h(y, E, N, S, R, m[i[A]], f[1], u[A]), D = v(O, B, $, F, w, m[t[A]], s[1], l[A])) : A < 48 ? (b = p(y, E, N, S, R, m[i[A]], f[2], u[A]), D = p(O, B, $, F, w, m[t[A]], s[2], l[A])) : A < 64 ? (b = v(y, E, N, S, R, m[i[A]], f[3], u[A]), D = h(O, B, $, F, w, m[t[A]], s[3], l[A])) : (b = g(y, E, N, S, R, m[i[A]], f[4], u[A]), D = d(O, B, $, F, w, m[t[A]], s[4], l[A])), y = R, R = S, S = c(N, 10), N = E, E = b, O = w, w = F, F = c($, 10), $ = B, B = D;
    }
    var M = this._b + N + F | 0;
    this._b = this._c + S + w | 0, this._c = this._d + R + O | 0, this._d = this._e + y + B | 0, this._e = this._a + E + $ | 0, this._a = M;
  }, a.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var m = e.alloc ? e.alloc(20) : new e(20);
    return m.writeInt32LE(this._a, 0), m.writeInt32LE(this._b, 4), m.writeInt32LE(this._c, 8), m.writeInt32LE(this._d, 12), m.writeInt32LE(this._e, 16), m;
  };
  function c(m, x) {
    return m << x | m >>> 32 - x;
  }
  function d(m, x, y, E, N, S, R, O) {
    return c(m + (x ^ y ^ E) + S + R | 0, O) + N | 0;
  }
  function h(m, x, y, E, N, S, R, O) {
    return c(m + (x & y | ~x & E) + S + R | 0, O) + N | 0;
  }
  function p(m, x, y, E, N, S, R, O) {
    return c(m + ((x | ~y) ^ E) + S + R | 0, O) + N | 0;
  }
  function v(m, x, y, E, N, S, R, O) {
    return c(m + (x & E | y & ~E) + S + R | 0, O) + N | 0;
  }
  function g(m, x, y, E, N, S, R, O) {
    return c(m + (x ^ (y | ~E)) + S + R | 0, O) + N | 0;
  }
  return Ho = a, Ho;
}
var Go = { exports: {} }, Vo, ap;
function ai() {
  if (ap)
    return Vo;
  ap = 1;
  var e = Ye().Buffer;
  function r(o, n) {
    this._block = e.alloc(o), this._finalSize = n, this._blockSize = o, this._len = 0;
  }
  return r.prototype.update = function(o, n) {
    typeof o == "string" && (n = n || "utf8", o = e.from(o, n));
    for (var i = this._block, t = this._blockSize, u = o.length, l = this._len, f = 0; f < u; ) {
      for (var s = l % t, a = Math.min(u - f, t - s), c = 0; c < a; c++)
        i[s + c] = o[f + c];
      l += a, f += a, l % t === 0 && this._update(i);
    }
    return this._len += u, this;
  }, r.prototype.digest = function(o) {
    var n = this._len % this._blockSize;
    this._block[n] = 128, this._block.fill(0, n + 1), n >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var i = this._len * 8;
    if (i <= 4294967295)
      this._block.writeUInt32BE(i, this._blockSize - 4);
    else {
      var t = (i & 4294967295) >>> 0, u = (i - t) / 4294967296;
      this._block.writeUInt32BE(u, this._blockSize - 8), this._block.writeUInt32BE(t, this._blockSize - 4);
    }
    this._update(this._block);
    var l = this._hash();
    return o ? l.toString(o) : l;
  }, r.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
  }, Vo = r, Vo;
}
var Wo, op;
function vT() {
  if (op)
    return Wo;
  op = 1;
  var e = Je(), r = ai(), o = Ye().Buffer, n = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], i = new Array(80);
  function t() {
    this.init(), this._w = i, r.call(this, 64, 56);
  }
  e(t, r), t.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function u(s) {
    return s << 5 | s >>> 27;
  }
  function l(s) {
    return s << 30 | s >>> 2;
  }
  function f(s, a, c, d) {
    return s === 0 ? a & c | ~a & d : s === 2 ? a & c | a & d | c & d : a ^ c ^ d;
  }
  return t.prototype._update = function(s) {
    for (var a = this._w, c = this._a | 0, d = this._b | 0, h = this._c | 0, p = this._d | 0, v = this._e | 0, g = 0; g < 16; ++g)
      a[g] = s.readInt32BE(g * 4);
    for (; g < 80; ++g)
      a[g] = a[g - 3] ^ a[g - 8] ^ a[g - 14] ^ a[g - 16];
    for (var m = 0; m < 80; ++m) {
      var x = ~~(m / 20), y = u(c) + f(x, d, h, p) + v + a[m] + n[x] | 0;
      v = p, p = h, h = l(d), d = c, c = y;
    }
    this._a = c + this._a | 0, this._b = d + this._b | 0, this._c = h + this._c | 0, this._d = p + this._d | 0, this._e = v + this._e | 0;
  }, t.prototype._hash = function() {
    var s = o.allocUnsafe(20);
    return s.writeInt32BE(this._a | 0, 0), s.writeInt32BE(this._b | 0, 4), s.writeInt32BE(this._c | 0, 8), s.writeInt32BE(this._d | 0, 12), s.writeInt32BE(this._e | 0, 16), s;
  }, Wo = t, Wo;
}
var Ko, sp;
function mT() {
  if (sp)
    return Ko;
  sp = 1;
  var e = Je(), r = ai(), o = Ye().Buffer, n = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], i = new Array(80);
  function t() {
    this.init(), this._w = i, r.call(this, 64, 56);
  }
  e(t, r), t.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function u(a) {
    return a << 1 | a >>> 31;
  }
  function l(a) {
    return a << 5 | a >>> 27;
  }
  function f(a) {
    return a << 30 | a >>> 2;
  }
  function s(a, c, d, h) {
    return a === 0 ? c & d | ~c & h : a === 2 ? c & d | c & h | d & h : c ^ d ^ h;
  }
  return t.prototype._update = function(a) {
    for (var c = this._w, d = this._a | 0, h = this._b | 0, p = this._c | 0, v = this._d | 0, g = this._e | 0, m = 0; m < 16; ++m)
      c[m] = a.readInt32BE(m * 4);
    for (; m < 80; ++m)
      c[m] = u(c[m - 3] ^ c[m - 8] ^ c[m - 14] ^ c[m - 16]);
    for (var x = 0; x < 80; ++x) {
      var y = ~~(x / 20), E = l(d) + s(y, h, p, v) + g + c[x] + n[y] | 0;
      g = v, v = p, p = f(h), h = d, d = E;
    }
    this._a = d + this._a | 0, this._b = h + this._b | 0, this._c = p + this._c | 0, this._d = v + this._d | 0, this._e = g + this._e | 0;
  }, t.prototype._hash = function() {
    var a = o.allocUnsafe(20);
    return a.writeInt32BE(this._a | 0, 0), a.writeInt32BE(this._b | 0, 4), a.writeInt32BE(this._c | 0, 8), a.writeInt32BE(this._d | 0, 12), a.writeInt32BE(this._e | 0, 16), a;
  }, Ko = t, Ko;
}
var Zo, up;
function Mb() {
  if (up)
    return Zo;
  up = 1;
  var e = Je(), r = ai(), o = Ye().Buffer, n = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], i = new Array(64);
  function t() {
    this.init(), this._w = i, r.call(this, 64, 56);
  }
  e(t, r), t.prototype.init = function() {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  };
  function u(d, h, p) {
    return p ^ d & (h ^ p);
  }
  function l(d, h, p) {
    return d & h | p & (d | h);
  }
  function f(d) {
    return (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
  }
  function s(d) {
    return (d >>> 6 | d << 26) ^ (d >>> 11 | d << 21) ^ (d >>> 25 | d << 7);
  }
  function a(d) {
    return (d >>> 7 | d << 25) ^ (d >>> 18 | d << 14) ^ d >>> 3;
  }
  function c(d) {
    return (d >>> 17 | d << 15) ^ (d >>> 19 | d << 13) ^ d >>> 10;
  }
  return t.prototype._update = function(d) {
    for (var h = this._w, p = this._a | 0, v = this._b | 0, g = this._c | 0, m = this._d | 0, x = this._e | 0, y = this._f | 0, E = this._g | 0, N = this._h | 0, S = 0; S < 16; ++S)
      h[S] = d.readInt32BE(S * 4);
    for (; S < 64; ++S)
      h[S] = c(h[S - 2]) + h[S - 7] + a(h[S - 15]) + h[S - 16] | 0;
    for (var R = 0; R < 64; ++R) {
      var O = N + s(x) + u(x, y, E) + n[R] + h[R] | 0, B = f(p) + l(p, v, g) | 0;
      N = E, E = y, y = x, x = m + O | 0, m = g, g = v, v = p, p = O + B | 0;
    }
    this._a = p + this._a | 0, this._b = v + this._b | 0, this._c = g + this._c | 0, this._d = m + this._d | 0, this._e = x + this._e | 0, this._f = y + this._f | 0, this._g = E + this._g | 0, this._h = N + this._h | 0;
  }, t.prototype._hash = function() {
    var d = o.allocUnsafe(32);
    return d.writeInt32BE(this._a, 0), d.writeInt32BE(this._b, 4), d.writeInt32BE(this._c, 8), d.writeInt32BE(this._d, 12), d.writeInt32BE(this._e, 16), d.writeInt32BE(this._f, 20), d.writeInt32BE(this._g, 24), d.writeInt32BE(this._h, 28), d;
  }, Zo = t, Zo;
}
var jo, fp;
function gT() {
  if (fp)
    return jo;
  fp = 1;
  var e = Je(), r = Mb(), o = ai(), n = Ye().Buffer, i = new Array(64);
  function t() {
    this.init(), this._w = i, o.call(this, 64, 56);
  }
  return e(t, r), t.prototype.init = function() {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, t.prototype._hash = function() {
    var u = n.allocUnsafe(28);
    return u.writeInt32BE(this._a, 0), u.writeInt32BE(this._b, 4), u.writeInt32BE(this._c, 8), u.writeInt32BE(this._d, 12), u.writeInt32BE(this._e, 16), u.writeInt32BE(this._f, 20), u.writeInt32BE(this._g, 24), u;
  }, jo = t, jo;
}
var Yo, cp;
function _b() {
  if (cp)
    return Yo;
  cp = 1;
  var e = Je(), r = ai(), o = Ye().Buffer, n = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ], i = new Array(160);
  function t() {
    this.init(), this._w = i, r.call(this, 128, 112);
  }
  e(t, r), t.prototype.init = function() {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  };
  function u(v, g, m) {
    return m ^ v & (g ^ m);
  }
  function l(v, g, m) {
    return v & g | m & (v | g);
  }
  function f(v, g) {
    return (v >>> 28 | g << 4) ^ (g >>> 2 | v << 30) ^ (g >>> 7 | v << 25);
  }
  function s(v, g) {
    return (v >>> 14 | g << 18) ^ (v >>> 18 | g << 14) ^ (g >>> 9 | v << 23);
  }
  function a(v, g) {
    return (v >>> 1 | g << 31) ^ (v >>> 8 | g << 24) ^ v >>> 7;
  }
  function c(v, g) {
    return (v >>> 1 | g << 31) ^ (v >>> 8 | g << 24) ^ (v >>> 7 | g << 25);
  }
  function d(v, g) {
    return (v >>> 19 | g << 13) ^ (g >>> 29 | v << 3) ^ v >>> 6;
  }
  function h(v, g) {
    return (v >>> 19 | g << 13) ^ (g >>> 29 | v << 3) ^ (v >>> 6 | g << 26);
  }
  function p(v, g) {
    return v >>> 0 < g >>> 0 ? 1 : 0;
  }
  return t.prototype._update = function(v) {
    for (var g = this._w, m = this._ah | 0, x = this._bh | 0, y = this._ch | 0, E = this._dh | 0, N = this._eh | 0, S = this._fh | 0, R = this._gh | 0, O = this._hh | 0, B = this._al | 0, $ = this._bl | 0, F = this._cl | 0, w = this._dl | 0, A = this._el | 0, b = this._fl | 0, D = this._gl | 0, M = this._hl | 0, _ = 0; _ < 32; _ += 2)
      g[_] = v.readInt32BE(_ * 4), g[_ + 1] = v.readInt32BE(_ * 4 + 4);
    for (; _ < 160; _ += 2) {
      var q = g[_ - 30], C = g[_ - 15 * 2 + 1], T = a(q, C), z = c(C, q);
      q = g[_ - 2 * 2], C = g[_ - 2 * 2 + 1];
      var I = d(q, C), U = h(C, q), ee = g[_ - 7 * 2], se = g[_ - 7 * 2 + 1], K = g[_ - 16 * 2], J = g[_ - 16 * 2 + 1], te = z + se | 0, ne = T + ee + p(te, z) | 0;
      te = te + U | 0, ne = ne + I + p(te, U) | 0, te = te + J | 0, ne = ne + K + p(te, J) | 0, g[_] = ne, g[_ + 1] = te;
    }
    for (var ue = 0; ue < 160; ue += 2) {
      ne = g[ue], te = g[ue + 1];
      var V = l(m, x, y), W = l(B, $, F), fe = f(m, B), pe = f(B, m), Y = s(N, A), k = s(A, N), L = n[ue], P = n[ue + 1], G = u(N, S, R), j = u(A, b, D), re = M + k | 0, ie = O + Y + p(re, M) | 0;
      re = re + j | 0, ie = ie + G + p(re, j) | 0, re = re + P | 0, ie = ie + L + p(re, P) | 0, re = re + te | 0, ie = ie + ne + p(re, te) | 0;
      var Z = pe + W | 0, X = fe + V + p(Z, pe) | 0;
      O = R, M = D, R = S, D = b, S = N, b = A, A = w + re | 0, N = E + ie + p(A, w) | 0, E = y, w = F, y = x, F = $, x = m, $ = B, B = re + Z | 0, m = ie + X + p(B, re) | 0;
    }
    this._al = this._al + B | 0, this._bl = this._bl + $ | 0, this._cl = this._cl + F | 0, this._dl = this._dl + w | 0, this._el = this._el + A | 0, this._fl = this._fl + b | 0, this._gl = this._gl + D | 0, this._hl = this._hl + M | 0, this._ah = this._ah + m + p(this._al, B) | 0, this._bh = this._bh + x + p(this._bl, $) | 0, this._ch = this._ch + y + p(this._cl, F) | 0, this._dh = this._dh + E + p(this._dl, w) | 0, this._eh = this._eh + N + p(this._el, A) | 0, this._fh = this._fh + S + p(this._fl, b) | 0, this._gh = this._gh + R + p(this._gl, D) | 0, this._hh = this._hh + O + p(this._hl, M) | 0;
  }, t.prototype._hash = function() {
    var v = o.allocUnsafe(64);
    function g(m, x, y) {
      v.writeInt32BE(m, y), v.writeInt32BE(x, y + 4);
    }
    return g(this._ah, this._al, 0), g(this._bh, this._bl, 8), g(this._ch, this._cl, 16), g(this._dh, this._dl, 24), g(this._eh, this._el, 32), g(this._fh, this._fl, 40), g(this._gh, this._gl, 48), g(this._hh, this._hl, 56), v;
  }, Yo = t, Yo;
}
var Xo, lp;
function bT() {
  if (lp)
    return Xo;
  lp = 1;
  var e = Je(), r = _b(), o = ai(), n = Ye().Buffer, i = new Array(160);
  function t() {
    this.init(), this._w = i, o.call(this, 128, 112);
  }
  return e(t, r), t.prototype.init = function() {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, t.prototype._hash = function() {
    var u = n.allocUnsafe(48);
    function l(f, s, a) {
      u.writeInt32BE(f, a), u.writeInt32BE(s, a + 4);
    }
    return l(this._ah, this._al, 0), l(this._bh, this._bl, 8), l(this._ch, this._cl, 16), l(this._dh, this._dl, 24), l(this._eh, this._el, 32), l(this._fh, this._fl, 40), u;
  }, Xo = t, Xo;
}
var dp;
function Jf() {
  if (dp)
    return Go.exports;
  dp = 1;
  var e = Go.exports = function(o) {
    o = o.toLowerCase();
    var n = e[o];
    if (!n)
      throw new Error(o + " is not supported (we accept pull requests)");
    return new n();
  };
  return e.sha = vT(), e.sha1 = mT(), e.sha224 = gT(), e.sha256 = Mb(), e.sha384 = bT(), e.sha512 = _b(), Go.exports;
}
var Jo = {}, fa = { exports: {} }, hp;
function yT() {
  return hp || (hp = 1, function(e, r) {
    var o = Nn(), n = o.Buffer;
    function i(u, l) {
      for (var f in u)
        l[f] = u[f];
    }
    n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? e.exports = o : (i(o, r), r.Buffer = t);
    function t(u, l, f) {
      return n(u, l, f);
    }
    i(n, t), t.from = function(u, l, f) {
      if (typeof u == "number")
        throw new TypeError("Argument must not be a number");
      return n(u, l, f);
    }, t.alloc = function(u, l, f) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      var s = n(u);
      return l !== void 0 ? typeof f == "string" ? s.fill(l, f) : s.fill(l) : s.fill(0), s;
    }, t.allocUnsafe = function(u) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      return n(u);
    }, t.allocUnsafeSlow = function(u) {
      if (typeof u != "number")
        throw new TypeError("Argument must be a number");
      return o.SlowBuffer(u);
    };
  }(fa, fa.exports)), fa.exports;
}
var pp;
function wT() {
  if (pp)
    return Jo;
  pp = 1;
  var e = yT().Buffer, r = e.isEncoding || function(m) {
    switch (m = "" + m, m && m.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function o(m) {
    if (!m)
      return "utf8";
    for (var x; ; )
      switch (m) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return m;
        default:
          if (x)
            return;
          m = ("" + m).toLowerCase(), x = !0;
      }
  }
  function n(m) {
    var x = o(m);
    if (typeof x != "string" && (e.isEncoding === r || !r(m)))
      throw new Error("Unknown encoding: " + m);
    return x || m;
  }
  Jo.StringDecoder = i;
  function i(m) {
    this.encoding = n(m);
    var x;
    switch (this.encoding) {
      case "utf16le":
        this.text = c, this.end = d, x = 4;
        break;
      case "utf8":
        this.fillLast = f, x = 4;
        break;
      case "base64":
        this.text = h, this.end = p, x = 3;
        break;
      default:
        this.write = v, this.end = g;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = e.allocUnsafe(x);
  }
  i.prototype.write = function(m) {
    if (m.length === 0)
      return "";
    var x, y;
    if (this.lastNeed) {
      if (x = this.fillLast(m), x === void 0)
        return "";
      y = this.lastNeed, this.lastNeed = 0;
    } else
      y = 0;
    return y < m.length ? x ? x + this.text(m, y) : this.text(m, y) : x || "";
  }, i.prototype.end = a, i.prototype.text = s, i.prototype.fillLast = function(m) {
    if (this.lastNeed <= m.length)
      return m.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    m.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, m.length), this.lastNeed -= m.length;
  };
  function t(m) {
    return m <= 127 ? 0 : m >> 5 === 6 ? 2 : m >> 4 === 14 ? 3 : m >> 3 === 30 ? 4 : m >> 6 === 2 ? -1 : -2;
  }
  function u(m, x, y) {
    var E = x.length - 1;
    if (E < y)
      return 0;
    var N = t(x[E]);
    return N >= 0 ? (N > 0 && (m.lastNeed = N - 1), N) : --E < y || N === -2 ? 0 : (N = t(x[E]), N >= 0 ? (N > 0 && (m.lastNeed = N - 2), N) : --E < y || N === -2 ? 0 : (N = t(x[E]), N >= 0 ? (N > 0 && (N === 2 ? N = 0 : m.lastNeed = N - 3), N) : 0));
  }
  function l(m, x, y) {
    if ((x[0] & 192) !== 128)
      return m.lastNeed = 0, "�";
    if (m.lastNeed > 1 && x.length > 1) {
      if ((x[1] & 192) !== 128)
        return m.lastNeed = 1, "�";
      if (m.lastNeed > 2 && x.length > 2 && (x[2] & 192) !== 128)
        return m.lastNeed = 2, "�";
    }
  }
  function f(m) {
    var x = this.lastTotal - this.lastNeed, y = l(this, m);
    if (y !== void 0)
      return y;
    if (this.lastNeed <= m.length)
      return m.copy(this.lastChar, x, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    m.copy(this.lastChar, x, 0, m.length), this.lastNeed -= m.length;
  }
  function s(m, x) {
    var y = u(this, m, x);
    if (!this.lastNeed)
      return m.toString("utf8", x);
    this.lastTotal = y;
    var E = m.length - (y - this.lastNeed);
    return m.copy(this.lastChar, 0, E), m.toString("utf8", x, E);
  }
  function a(m) {
    var x = m && m.length ? this.write(m) : "";
    return this.lastNeed ? x + "�" : x;
  }
  function c(m, x) {
    if ((m.length - x) % 2 === 0) {
      var y = m.toString("utf16le", x);
      if (y) {
        var E = y.charCodeAt(y.length - 1);
        if (E >= 55296 && E <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = m[m.length - 2], this.lastChar[1] = m[m.length - 1], y.slice(0, -1);
      }
      return y;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = m[m.length - 1], m.toString("utf16le", x, m.length - 1);
  }
  function d(m) {
    var x = m && m.length ? this.write(m) : "";
    if (this.lastNeed) {
      var y = this.lastTotal - this.lastNeed;
      return x + this.lastChar.toString("utf16le", 0, y);
    }
    return x;
  }
  function h(m, x) {
    var y = (m.length - x) % 3;
    return y === 0 ? m.toString("base64", x) : (this.lastNeed = 3 - y, this.lastTotal = 3, y === 1 ? this.lastChar[0] = m[m.length - 1] : (this.lastChar[0] = m[m.length - 2], this.lastChar[1] = m[m.length - 1]), m.toString("base64", x, m.length - y));
  }
  function p(m) {
    var x = m && m.length ? this.write(m) : "";
    return this.lastNeed ? x + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : x;
  }
  function v(m) {
    return m.toString(this.encoding);
  }
  function g(m) {
    return m && m.length ? this.write(m) : "";
  }
  return Jo;
}
var Qo, vp;
function cn() {
  if (vp)
    return Qo;
  vp = 1;
  var e = Ye().Buffer, r = Ii.Transform, o = wT().StringDecoder, n = Je();
  function i(t) {
    r.call(this), this.hashMode = typeof t == "string", this.hashMode ? this[t] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  return n(i, r), i.prototype.update = function(t, u, l) {
    typeof t == "string" && (t = e.from(t, u));
    var f = this._update(t);
    return this.hashMode ? this : (l && (f = this._toString(f, l)), f);
  }, i.prototype.setAutoPadding = function() {
  }, i.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, i.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, i.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, i.prototype._transform = function(t, u, l) {
    var f;
    try {
      this.hashMode ? this._update(t) : this.push(this._update(t));
    } catch (s) {
      f = s;
    } finally {
      l(f);
    }
  }, i.prototype._flush = function(t) {
    var u;
    try {
      this.push(this.__final());
    } catch (l) {
      u = l;
    }
    t(u);
  }, i.prototype._finalOrDigest = function(t) {
    var u = this.__final() || e.alloc(0);
    return t && (u = this._toString(u, t, !0)), u;
  }, i.prototype._toString = function(t, u, l) {
    if (this._decoder || (this._decoder = new o(u), this._encoding = u), this._encoding !== u)
      throw new Error("can't switch encodings");
    var f = this._decoder.write(t);
    return l && (f += this._decoder.end()), f;
  }, Qo = i, Qo;
}
var es, mp;
function Oi() {
  if (mp)
    return es;
  mp = 1;
  var e = Je(), r = Yf(), o = Xf(), n = Jf(), i = cn();
  function t(u) {
    i.call(this, "digest"), this._hash = u;
  }
  return e(t, i), t.prototype._update = function(u) {
    this._hash.update(u);
  }, t.prototype._final = function() {
    return this._hash.digest();
  }, es = function(l) {
    return l = l.toLowerCase(), l === "md5" ? new r() : l === "rmd160" || l === "ripemd160" ? new o() : new t(n(l));
  }, es;
}
var rs, gp;
function xT() {
  if (gp)
    return rs;
  gp = 1;
  var e = Je(), r = Ye().Buffer, o = cn(), n = r.alloc(128), i = 64;
  function t(u, l) {
    o.call(this, "digest"), typeof l == "string" && (l = r.from(l)), this._alg = u, this._key = l, l.length > i ? l = u(l) : l.length < i && (l = r.concat([l, n], i));
    for (var f = this._ipad = r.allocUnsafe(i), s = this._opad = r.allocUnsafe(i), a = 0; a < i; a++)
      f[a] = l[a] ^ 54, s[a] = l[a] ^ 92;
    this._hash = [f];
  }
  return e(t, o), t.prototype._update = function(u) {
    this._hash.push(u);
  }, t.prototype._final = function() {
    var u = this._alg(r.concat(this._hash));
    return this._alg(r.concat([this._opad, u]));
  }, rs = t, rs;
}
var ts, bp;
function Cb() {
  if (bp)
    return ts;
  bp = 1;
  var e = Yf();
  return ts = function(r) {
    return new e().update(r).digest();
  }, ts;
}
var ns, yp;
function Tb() {
  if (yp)
    return ns;
  yp = 1;
  var e = Je(), r = xT(), o = cn(), n = Ye().Buffer, i = Cb(), t = Xf(), u = Jf(), l = n.alloc(128);
  function f(s, a) {
    o.call(this, "digest"), typeof a == "string" && (a = n.from(a));
    var c = s === "sha512" || s === "sha384" ? 128 : 64;
    if (this._alg = s, this._key = a, a.length > c) {
      var d = s === "rmd160" ? new t() : u(s);
      a = d.update(a).digest();
    } else
      a.length < c && (a = n.concat([a, l], c));
    for (var h = this._ipad = n.allocUnsafe(c), p = this._opad = n.allocUnsafe(c), v = 0; v < c; v++)
      h[v] = a[v] ^ 54, p[v] = a[v] ^ 92;
    this._hash = s === "rmd160" ? new t() : u(s), this._hash.update(h);
  }
  return e(f, o), f.prototype._update = function(s) {
    this._hash.update(s);
  }, f.prototype._final = function() {
    var s = this._hash.digest(), a = this._alg === "rmd160" ? new t() : u(this._alg);
    return a.update(this._opad).update(s).digest();
  }, ns = function(a, c) {
    return a = a.toLowerCase(), a === "rmd160" || a === "ripemd160" ? new f("rmd160", c) : a === "md5" ? new r(i, c) : new f(a, c);
  }, ns;
}
const ET = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, AT = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, ST = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, DT = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, NT = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, MT = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, _T = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, CT = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, TT = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, BT = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, FT = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, Bb = {
  sha224WithRSAEncryption: ET,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption: AT,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption: ST,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption: DT,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256: NT,
  sha224: MT,
  sha384: _T,
  sha512: CT,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA: TT,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA: BT,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption: FT,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var is, wp;
function IT() {
  return wp || (wp = 1, is = Bb), is;
}
var ca = {}, as, xp;
function Fb() {
  if (xp)
    return as;
  xp = 1;
  var e = Math.pow(2, 30) - 1;
  return as = function(r, o) {
    if (typeof r != "number")
      throw new TypeError("Iterations not a number");
    if (r < 0)
      throw new TypeError("Bad iterations");
    if (typeof o != "number")
      throw new TypeError("Key length not a number");
    if (o < 0 || o > e || o !== o)
      throw new TypeError("Bad key length");
  }, as;
}
var os, Ep;
function Ib() {
  if (Ep)
    return os;
  Ep = 1;
  var e;
  if (Xe.process && Xe.process.browser)
    e = "utf-8";
  else if (Xe.process && Xe.process.version) {
    var r = parseInt(process.version.split(".")[0].slice(1), 10);
    e = r >= 6 ? "utf-8" : "binary";
  } else
    e = "utf-8";
  return os = e, os;
}
var ss, Ap;
function Ob() {
  if (Ap)
    return ss;
  Ap = 1;
  var e = Ye().Buffer;
  return ss = function(r, o, n) {
    if (e.isBuffer(r))
      return r;
    if (typeof r == "string")
      return e.from(r, o);
    if (ArrayBuffer.isView(r))
      return e.from(r.buffer);
    throw new TypeError(n + " must be a string, a Buffer, a typed array or a DataView");
  }, ss;
}
var us, Sp;
function Rb() {
  if (Sp)
    return us;
  Sp = 1;
  var e = Cb(), r = Xf(), o = Jf(), n = Ye().Buffer, i = Fb(), t = Ib(), u = Ob(), l = n.alloc(128), f = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
  };
  function s(d, h, p) {
    var v = a(d), g = d === "sha512" || d === "sha384" ? 128 : 64;
    h.length > g ? h = v(h) : h.length < g && (h = n.concat([h, l], g));
    for (var m = n.allocUnsafe(g + f[d]), x = n.allocUnsafe(g + f[d]), y = 0; y < g; y++)
      m[y] = h[y] ^ 54, x[y] = h[y] ^ 92;
    var E = n.allocUnsafe(g + p + 4);
    m.copy(E, 0, 0, g), this.ipad1 = E, this.ipad2 = m, this.opad = x, this.alg = d, this.blocksize = g, this.hash = v, this.size = f[d];
  }
  s.prototype.run = function(d, h) {
    d.copy(h, this.blocksize);
    var p = this.hash(h);
    return p.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function a(d) {
    function h(v) {
      return o(d).update(v).digest();
    }
    function p(v) {
      return new r().update(v).digest();
    }
    return d === "rmd160" || d === "ripemd160" ? p : d === "md5" ? e : h;
  }
  function c(d, h, p, v, g) {
    i(p, v), d = u(d, t, "Password"), h = u(h, t, "Salt"), g = g || "sha1";
    var m = new s(g, d, h.length), x = n.allocUnsafe(v), y = n.allocUnsafe(h.length + 4);
    h.copy(y, 0, 0, h.length);
    for (var E = 0, N = f[g], S = Math.ceil(v / N), R = 1; R <= S; R++) {
      y.writeUInt32BE(R, h.length);
      for (var O = m.run(y, m.ipad1), B = O, $ = 1; $ < p; $++) {
        B = m.run(B, m.ipad2);
        for (var F = 0; F < N; F++)
          O[F] ^= B[F];
      }
      O.copy(x, E), E += N;
    }
    return x;
  }
  return us = c, us;
}
var fs, Dp;
function OT() {
  if (Dp)
    return fs;
  Dp = 1;
  var e = Ye().Buffer, r = Fb(), o = Ib(), n = Rb(), i = Ob(), t, u = Xe.crypto && Xe.crypto.subtle, l = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, f = [];
  function s(p) {
    if (Xe.process && !Xe.process.browser || !u || !u.importKey || !u.deriveBits)
      return Promise.resolve(!1);
    if (f[p] !== void 0)
      return f[p];
    t = t || e.alloc(8);
    var v = d(t, t, 10, 128, p).then(function() {
      return !0;
    }).catch(function() {
      return !1;
    });
    return f[p] = v, v;
  }
  var a;
  function c() {
    return a || (Xe.process && Xe.process.nextTick ? a = Xe.process.nextTick : Xe.queueMicrotask ? a = Xe.queueMicrotask : Xe.setImmediate ? a = Xe.setImmediate : a = Xe.setTimeout, a);
  }
  function d(p, v, g, m, x) {
    return u.importKey(
      "raw",
      p,
      { name: "PBKDF2" },
      !1,
      ["deriveBits"]
    ).then(function(y) {
      return u.deriveBits({
        name: "PBKDF2",
        salt: v,
        iterations: g,
        hash: {
          name: x
        }
      }, y, m << 3);
    }).then(function(y) {
      return e.from(y);
    });
  }
  function h(p, v) {
    p.then(function(g) {
      c()(function() {
        v(null, g);
      });
    }, function(g) {
      c()(function() {
        v(g);
      });
    });
  }
  return fs = function(p, v, g, m, x, y) {
    typeof x == "function" && (y = x, x = void 0), x = x || "sha1";
    var E = l[x.toLowerCase()];
    if (!E || typeof Xe.Promise != "function") {
      c()(function() {
        var N;
        try {
          N = n(p, v, g, m, x);
        } catch (S) {
          return y(S);
        }
        y(null, N);
      });
      return;
    }
    if (r(g, m), p = i(p, o, "Password"), v = i(v, o, "Salt"), typeof y != "function")
      throw new Error("No callback provided to pbkdf2");
    h(s(E).then(function(N) {
      return N ? d(p, v, g, m, E) : n(p, v, g, m, x);
    }), y);
  }, fs;
}
var Np;
function Pb() {
  return Np || (Np = 1, ca.pbkdf2 = OT(), ca.pbkdf2Sync = Rb()), ca;
}
var st = {}, mn = {}, et = {}, Mp;
function qb() {
  if (Mp)
    return et;
  Mp = 1, et.readUInt32BE = function(i, t) {
    var u = i[0 + t] << 24 | i[1 + t] << 16 | i[2 + t] << 8 | i[3 + t];
    return u >>> 0;
  }, et.writeUInt32BE = function(i, t, u) {
    i[0 + u] = t >>> 24, i[1 + u] = t >>> 16 & 255, i[2 + u] = t >>> 8 & 255, i[3 + u] = t & 255;
  }, et.ip = function(i, t, u, l) {
    for (var f = 0, s = 0, a = 6; a >= 0; a -= 2) {
      for (var c = 0; c <= 24; c += 8)
        f <<= 1, f |= t >>> c + a & 1;
      for (var c = 0; c <= 24; c += 8)
        f <<= 1, f |= i >>> c + a & 1;
    }
    for (var a = 6; a >= 0; a -= 2) {
      for (var c = 1; c <= 25; c += 8)
        s <<= 1, s |= t >>> c + a & 1;
      for (var c = 1; c <= 25; c += 8)
        s <<= 1, s |= i >>> c + a & 1;
    }
    u[l + 0] = f >>> 0, u[l + 1] = s >>> 0;
  }, et.rip = function(i, t, u, l) {
    for (var f = 0, s = 0, a = 0; a < 4; a++)
      for (var c = 24; c >= 0; c -= 8)
        f <<= 1, f |= t >>> c + a & 1, f <<= 1, f |= i >>> c + a & 1;
    for (var a = 4; a < 8; a++)
      for (var c = 24; c >= 0; c -= 8)
        s <<= 1, s |= t >>> c + a & 1, s <<= 1, s |= i >>> c + a & 1;
    u[l + 0] = f >>> 0, u[l + 1] = s >>> 0;
  }, et.pc1 = function(i, t, u, l) {
    for (var f = 0, s = 0, a = 7; a >= 5; a--) {
      for (var c = 0; c <= 24; c += 8)
        f <<= 1, f |= t >> c + a & 1;
      for (var c = 0; c <= 24; c += 8)
        f <<= 1, f |= i >> c + a & 1;
    }
    for (var c = 0; c <= 24; c += 8)
      f <<= 1, f |= t >> c + a & 1;
    for (var a = 1; a <= 3; a++) {
      for (var c = 0; c <= 24; c += 8)
        s <<= 1, s |= t >> c + a & 1;
      for (var c = 0; c <= 24; c += 8)
        s <<= 1, s |= i >> c + a & 1;
    }
    for (var c = 0; c <= 24; c += 8)
      s <<= 1, s |= i >> c + a & 1;
    u[l + 0] = f >>> 0, u[l + 1] = s >>> 0;
  }, et.r28shl = function(i, t) {
    return i << t & 268435455 | i >>> 28 - t;
  };
  var e = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  et.pc2 = function(i, t, u, l) {
    for (var f = 0, s = 0, a = e.length >>> 1, c = 0; c < a; c++)
      f <<= 1, f |= i >>> e[c] & 1;
    for (var c = a; c < e.length; c++)
      s <<= 1, s |= t >>> e[c] & 1;
    u[l + 0] = f >>> 0, u[l + 1] = s >>> 0;
  }, et.expand = function(i, t, u) {
    var l = 0, f = 0;
    l = (i & 1) << 5 | i >>> 27;
    for (var s = 23; s >= 15; s -= 4)
      l <<= 6, l |= i >>> s & 63;
    for (var s = 11; s >= 3; s -= 4)
      f |= i >>> s & 63, f <<= 6;
    f |= (i & 31) << 1 | i >>> 31, t[u + 0] = l >>> 0, t[u + 1] = f >>> 0;
  };
  var r = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  et.substitute = function(i, t) {
    for (var u = 0, l = 0; l < 4; l++) {
      var f = i >>> 18 - l * 6 & 63, s = r[l * 64 + f];
      u <<= 4, u |= s;
    }
    for (var l = 0; l < 4; l++) {
      var f = t >>> 18 - l * 6 & 63, s = r[4 * 64 + l * 64 + f];
      u <<= 4, u |= s;
    }
    return u >>> 0;
  };
  var o = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return et.permute = function(i) {
    for (var t = 0, u = 0; u < o.length; u++)
      t <<= 1, t |= i >>> o[u] & 1;
    return t >>> 0;
  }, et.padSplit = function(i, t, u) {
    for (var l = i.toString(2); l.length < t; )
      l = "0" + l;
    for (var f = [], s = 0; s < t; s += u)
      f.push(l.slice(s, s + u));
    return f.join(" ");
  }, et;
}
var cs, _p;
function ht() {
  if (_p)
    return cs;
  _p = 1, cs = e;
  function e(r, o) {
    if (!r)
      throw new Error(o || "Assertion failed");
  }
  return e.equal = function(o, n, i) {
    if (o != n)
      throw new Error(i || "Assertion failed: " + o + " != " + n);
  }, cs;
}
var ls, Cp;
function Qf() {
  if (Cp)
    return ls;
  Cp = 1;
  var e = ht();
  function r(o) {
    this.options = o, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = o.padding !== !1;
  }
  return ls = r, r.prototype._init = function() {
  }, r.prototype.update = function(n) {
    return n.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(n) : this._updateEncrypt(n);
  }, r.prototype._buffer = function(n, i) {
    for (var t = Math.min(this.buffer.length - this.bufferOff, n.length - i), u = 0; u < t; u++)
      this.buffer[this.bufferOff + u] = n[i + u];
    return this.bufferOff += t, t;
  }, r.prototype._flushBuffer = function(n, i) {
    return this._update(this.buffer, 0, n, i), this.bufferOff = 0, this.blockSize;
  }, r.prototype._updateEncrypt = function(n) {
    var i = 0, t = 0, u = (this.bufferOff + n.length) / this.blockSize | 0, l = new Array(u * this.blockSize);
    this.bufferOff !== 0 && (i += this._buffer(n, i), this.bufferOff === this.buffer.length && (t += this._flushBuffer(l, t)));
    for (var f = n.length - (n.length - i) % this.blockSize; i < f; i += this.blockSize)
      this._update(n, i, l, t), t += this.blockSize;
    for (; i < n.length; i++, this.bufferOff++)
      this.buffer[this.bufferOff] = n[i];
    return l;
  }, r.prototype._updateDecrypt = function(n) {
    for (var i = 0, t = 0, u = Math.ceil((this.bufferOff + n.length) / this.blockSize) - 1, l = new Array(u * this.blockSize); u > 0; u--)
      i += this._buffer(n, i), t += this._flushBuffer(l, t);
    return i += this._buffer(n, i), l;
  }, r.prototype.final = function(n) {
    var i;
    n && (i = this.update(n));
    var t;
    return this.type === "encrypt" ? t = this._finalEncrypt() : t = this._finalDecrypt(), i ? i.concat(t) : t;
  }, r.prototype._pad = function(n, i) {
    if (i === 0)
      return !1;
    for (; i < n.length; )
      n[i++] = 0;
    return !0;
  }, r.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var n = new Array(this.blockSize);
    return this._update(this.buffer, 0, n, 0), n;
  }, r.prototype._unpad = function(n) {
    return n;
  }, r.prototype._finalDecrypt = function() {
    e.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var n = new Array(this.blockSize);
    return this._flushBuffer(n, 0), this._unpad(n);
  }, ls;
}
var ds, Tp;
function $b() {
  if (Tp)
    return ds;
  Tp = 1;
  var e = ht(), r = Je(), o = qb(), n = Qf();
  function i() {
    this.tmp = new Array(2), this.keys = null;
  }
  function t(l) {
    n.call(this, l);
    var f = new i();
    this._desState = f, this.deriveKeys(f, l.key);
  }
  r(t, n), ds = t, t.create = function(f) {
    return new t(f);
  };
  var u = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return t.prototype.deriveKeys = function(f, s) {
    f.keys = new Array(16 * 2), e.equal(s.length, this.blockSize, "Invalid key length");
    var a = o.readUInt32BE(s, 0), c = o.readUInt32BE(s, 4);
    o.pc1(a, c, f.tmp, 0), a = f.tmp[0], c = f.tmp[1];
    for (var d = 0; d < f.keys.length; d += 2) {
      var h = u[d >>> 1];
      a = o.r28shl(a, h), c = o.r28shl(c, h), o.pc2(a, c, f.keys, d);
    }
  }, t.prototype._update = function(f, s, a, c) {
    var d = this._desState, h = o.readUInt32BE(f, s), p = o.readUInt32BE(f, s + 4);
    o.ip(h, p, d.tmp, 0), h = d.tmp[0], p = d.tmp[1], this.type === "encrypt" ? this._encrypt(d, h, p, d.tmp, 0) : this._decrypt(d, h, p, d.tmp, 0), h = d.tmp[0], p = d.tmp[1], o.writeUInt32BE(a, h, c), o.writeUInt32BE(a, p, c + 4);
  }, t.prototype._pad = function(f, s) {
    if (this.padding === !1)
      return !1;
    for (var a = f.length - s, c = s; c < f.length; c++)
      f[c] = a;
    return !0;
  }, t.prototype._unpad = function(f) {
    if (this.padding === !1)
      return f;
    for (var s = f[f.length - 1], a = f.length - s; a < f.length; a++)
      e.equal(f[a], s);
    return f.slice(0, f.length - s);
  }, t.prototype._encrypt = function(f, s, a, c, d) {
    for (var h = s, p = a, v = 0; v < f.keys.length; v += 2) {
      var g = f.keys[v], m = f.keys[v + 1];
      o.expand(p, f.tmp, 0), g ^= f.tmp[0], m ^= f.tmp[1];
      var x = o.substitute(g, m), y = o.permute(x), E = p;
      p = (h ^ y) >>> 0, h = E;
    }
    o.rip(p, h, c, d);
  }, t.prototype._decrypt = function(f, s, a, c, d) {
    for (var h = a, p = s, v = f.keys.length - 2; v >= 0; v -= 2) {
      var g = f.keys[v], m = f.keys[v + 1];
      o.expand(h, f.tmp, 0), g ^= f.tmp[0], m ^= f.tmp[1];
      var x = o.substitute(g, m), y = o.permute(x), E = h;
      h = (p ^ y) >>> 0, p = E;
    }
    o.rip(h, p, c, d);
  }, ds;
}
var hs = {}, Bp;
function RT() {
  if (Bp)
    return hs;
  Bp = 1;
  var e = ht(), r = Je(), o = {};
  function n(t) {
    e.equal(t.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var u = 0; u < this.iv.length; u++)
      this.iv[u] = t[u];
  }
  function i(t) {
    function u(a) {
      t.call(this, a), this._cbcInit();
    }
    r(u, t);
    for (var l = Object.keys(o), f = 0; f < l.length; f++) {
      var s = l[f];
      u.prototype[s] = o[s];
    }
    return u.create = function(c) {
      return new u(c);
    }, u;
  }
  return hs.instantiate = i, o._cbcInit = function() {
    var u = new n(this.options.iv);
    this._cbcState = u;
  }, o._update = function(u, l, f, s) {
    var a = this._cbcState, c = this.constructor.super_.prototype, d = a.iv;
    if (this.type === "encrypt") {
      for (var h = 0; h < this.blockSize; h++)
        d[h] ^= u[l + h];
      c._update.call(this, d, 0, f, s);
      for (var h = 0; h < this.blockSize; h++)
        d[h] = f[s + h];
    } else {
      c._update.call(this, u, l, f, s);
      for (var h = 0; h < this.blockSize; h++)
        f[s + h] ^= d[h];
      for (var h = 0; h < this.blockSize; h++)
        d[h] = u[l + h];
    }
  }, hs;
}
var ps, Fp;
function PT() {
  if (Fp)
    return ps;
  Fp = 1;
  var e = ht(), r = Je(), o = Qf(), n = $b();
  function i(u, l) {
    e.equal(l.length, 24, "Invalid key length");
    var f = l.slice(0, 8), s = l.slice(8, 16), a = l.slice(16, 24);
    u === "encrypt" ? this.ciphers = [
      n.create({ type: "encrypt", key: f }),
      n.create({ type: "decrypt", key: s }),
      n.create({ type: "encrypt", key: a })
    ] : this.ciphers = [
      n.create({ type: "decrypt", key: a }),
      n.create({ type: "encrypt", key: s }),
      n.create({ type: "decrypt", key: f })
    ];
  }
  function t(u) {
    o.call(this, u);
    var l = new i(this.type, this.options.key);
    this._edeState = l;
  }
  return r(t, o), ps = t, t.create = function(l) {
    return new t(l);
  }, t.prototype._update = function(l, f, s, a) {
    var c = this._edeState;
    c.ciphers[0]._update(l, f, s, a), c.ciphers[1]._update(s, a, s, a), c.ciphers[2]._update(s, a, s, a);
  }, t.prototype._pad = n.prototype._pad, t.prototype._unpad = n.prototype._unpad, ps;
}
var Ip;
function qT() {
  return Ip || (Ip = 1, mn.utils = qb(), mn.Cipher = Qf(), mn.DES = $b(), mn.CBC = RT(), mn.EDE = PT()), mn;
}
var vs, Op;
function $T() {
  if (Op)
    return vs;
  Op = 1;
  var e = cn(), r = qT(), o = Je(), n = Ye().Buffer, i = {
    "des-ede3-cbc": r.CBC.instantiate(r.EDE),
    "des-ede3": r.EDE,
    "des-ede-cbc": r.CBC.instantiate(r.EDE),
    "des-ede": r.EDE,
    "des-cbc": r.CBC.instantiate(r.DES),
    "des-ecb": r.DES
  };
  i.des = i["des-cbc"], i.des3 = i["des-ede3-cbc"], vs = t, o(t, e);
  function t(u) {
    e.call(this);
    var l = u.mode.toLowerCase(), f = i[l], s;
    u.decrypt ? s = "decrypt" : s = "encrypt";
    var a = u.key;
    n.isBuffer(a) || (a = n.from(a)), (l === "des-ede" || l === "des-ede-cbc") && (a = n.concat([a, a.slice(0, 8)]));
    var c = u.iv;
    n.isBuffer(c) || (c = n.from(c)), this._des = f.create({
      key: a,
      iv: c,
      type: s
    });
  }
  return t.prototype._update = function(u) {
    return n.from(this._des.update(u));
  }, t.prototype._final = function() {
    return n.from(this._des.final());
  }, vs;
}
var ut = {}, la = {}, da = {}, Rp;
function zT() {
  return Rp || (Rp = 1, da.encrypt = function(e, r) {
    return e._cipher.encryptBlock(r);
  }, da.decrypt = function(e, r) {
    return e._cipher.decryptBlock(r);
  }), da;
}
var ha = {}, ms, Pp;
function Ri() {
  return Pp || (Pp = 1, ms = function(r, o) {
    for (var n = Math.min(r.length, o.length), i = new Buffer(n), t = 0; t < n; ++t)
      i[t] = r[t] ^ o[t];
    return i;
  }), ms;
}
var qp;
function LT() {
  if (qp)
    return ha;
  qp = 1;
  var e = Ri();
  return ha.encrypt = function(r, o) {
    var n = e(o, r._prev);
    return r._prev = r._cipher.encryptBlock(n), r._prev;
  }, ha.decrypt = function(r, o) {
    var n = r._prev;
    r._prev = o;
    var i = r._cipher.decryptBlock(o);
    return e(i, n);
  }, ha;
}
var gs = {}, $p;
function UT() {
  if ($p)
    return gs;
  $p = 1;
  var e = Ye().Buffer, r = Ri();
  function o(n, i, t) {
    var u = i.length, l = r(i, n._cache);
    return n._cache = n._cache.slice(u), n._prev = e.concat([n._prev, t ? i : l]), l;
  }
  return gs.encrypt = function(n, i, t) {
    for (var u = e.allocUnsafe(0), l; i.length; )
      if (n._cache.length === 0 && (n._cache = n._cipher.encryptBlock(n._prev), n._prev = e.allocUnsafe(0)), n._cache.length <= i.length)
        l = n._cache.length, u = e.concat([u, o(n, i.slice(0, l), t)]), i = i.slice(l);
      else {
        u = e.concat([u, o(n, i, t)]);
        break;
      }
    return u;
  }, gs;
}
var bs = {}, zp;
function kT() {
  if (zp)
    return bs;
  zp = 1;
  var e = Ye().Buffer;
  function r(o, n, i) {
    var t = o._cipher.encryptBlock(o._prev), u = t[0] ^ n;
    return o._prev = e.concat([
      o._prev.slice(1),
      e.from([i ? n : u])
    ]), u;
  }
  return bs.encrypt = function(o, n, i) {
    for (var t = n.length, u = e.allocUnsafe(t), l = -1; ++l < t; )
      u[l] = r(o, n[l], i);
    return u;
  }, bs;
}
var ys = {}, Lp;
function HT() {
  if (Lp)
    return ys;
  Lp = 1;
  var e = Ye().Buffer;
  function r(n, i, t) {
    for (var u, l = -1, f = 8, s = 0, a, c; ++l < f; )
      u = n._cipher.encryptBlock(n._prev), a = i & 1 << 7 - l ? 128 : 0, c = u[0] ^ a, s += (c & 128) >> l % 8, n._prev = o(n._prev, t ? a : c);
    return s;
  }
  function o(n, i) {
    var t = n.length, u = -1, l = e.allocUnsafe(n.length);
    for (n = e.concat([n, e.from([i])]); ++u < t; )
      l[u] = n[u] << 1 | n[u + 1] >> 7;
    return l;
  }
  return ys.encrypt = function(n, i, t) {
    for (var u = i.length, l = e.allocUnsafe(u), f = -1; ++f < u; )
      l[f] = r(n, i[f], t);
    return l;
  }, ys;
}
var ws = {}, Up;
function GT() {
  if (Up)
    return ws;
  Up = 1;
  var e = Ri();
  function r(o) {
    return o._prev = o._cipher.encryptBlock(o._prev), o._prev;
  }
  return ws.encrypt = function(o, n) {
    for (; o._cache.length < n.length; )
      o._cache = Buffer.concat([o._cache, r(o)]);
    var i = o._cache.slice(0, n.length);
    return o._cache = o._cache.slice(n.length), e(n, i);
  }, ws;
}
var xs = {}, Es, kp;
function zb() {
  if (kp)
    return Es;
  kp = 1;
  function e(r) {
    for (var o = r.length, n; o--; )
      if (n = r.readUInt8(o), n === 255)
        r.writeUInt8(0, o);
      else {
        n++, r.writeUInt8(n, o);
        break;
      }
  }
  return Es = e, Es;
}
var Hp;
function Gp() {
  if (Hp)
    return xs;
  Hp = 1;
  var e = Ri(), r = Ye().Buffer, o = zb();
  function n(t) {
    var u = t._cipher.encryptBlockRaw(t._prev);
    return o(t._prev), u;
  }
  var i = 16;
  return xs.encrypt = function(t, u) {
    var l = Math.ceil(u.length / i), f = t._cache.length;
    t._cache = r.concat([
      t._cache,
      r.allocUnsafe(l * i)
    ]);
    for (var s = 0; s < l; s++) {
      var a = n(t), c = f + s * i;
      t._cache.writeUInt32BE(a[0], c + 0), t._cache.writeUInt32BE(a[1], c + 4), t._cache.writeUInt32BE(a[2], c + 8), t._cache.writeUInt32BE(a[3], c + 12);
    }
    var d = t._cache.slice(0, u.length);
    return t._cache = t._cache.slice(u.length), e(u, d);
  }, xs;
}
const VT = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, WT = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, KT = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, Lb = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128: VT,
  aes192: WT,
  aes256: KT,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var As, Vp;
function ec() {
  if (Vp)
    return As;
  Vp = 1;
  var e = {
    ECB: zT(),
    CBC: LT(),
    CFB: UT(),
    CFB8: kT(),
    CFB1: HT(),
    OFB: GT(),
    CTR: Gp(),
    GCM: Gp()
  }, r = Lb;
  for (var o in r)
    r[o].module = e[r[o].mode];
  return As = r, As;
}
var Ss = {}, Wp;
function so() {
  if (Wp)
    return Ss;
  Wp = 1;
  var e = Ye().Buffer;
  function r(l) {
    e.isBuffer(l) || (l = e.from(l));
    for (var f = l.length / 4 | 0, s = new Array(f), a = 0; a < f; a++)
      s[a] = l.readUInt32BE(a * 4);
    return s;
  }
  function o(l) {
    for (var f = 0; f < l.length; l++)
      l[f] = 0;
  }
  function n(l, f, s, a, c) {
    for (var d = s[0], h = s[1], p = s[2], v = s[3], g = l[0] ^ f[0], m = l[1] ^ f[1], x = l[2] ^ f[2], y = l[3] ^ f[3], E, N, S, R, O = 4, B = 1; B < c; B++)
      E = d[g >>> 24] ^ h[m >>> 16 & 255] ^ p[x >>> 8 & 255] ^ v[y & 255] ^ f[O++], N = d[m >>> 24] ^ h[x >>> 16 & 255] ^ p[y >>> 8 & 255] ^ v[g & 255] ^ f[O++], S = d[x >>> 24] ^ h[y >>> 16 & 255] ^ p[g >>> 8 & 255] ^ v[m & 255] ^ f[O++], R = d[y >>> 24] ^ h[g >>> 16 & 255] ^ p[m >>> 8 & 255] ^ v[x & 255] ^ f[O++], g = E, m = N, x = S, y = R;
    return E = (a[g >>> 24] << 24 | a[m >>> 16 & 255] << 16 | a[x >>> 8 & 255] << 8 | a[y & 255]) ^ f[O++], N = (a[m >>> 24] << 24 | a[x >>> 16 & 255] << 16 | a[y >>> 8 & 255] << 8 | a[g & 255]) ^ f[O++], S = (a[x >>> 24] << 24 | a[y >>> 16 & 255] << 16 | a[g >>> 8 & 255] << 8 | a[m & 255]) ^ f[O++], R = (a[y >>> 24] << 24 | a[g >>> 16 & 255] << 16 | a[m >>> 8 & 255] << 8 | a[x & 255]) ^ f[O++], E = E >>> 0, N = N >>> 0, S = S >>> 0, R = R >>> 0, [E, N, S, R];
  }
  var i = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], t = function() {
    for (var l = new Array(256), f = 0; f < 256; f++)
      f < 128 ? l[f] = f << 1 : l[f] = f << 1 ^ 283;
    for (var s = [], a = [], c = [[], [], [], []], d = [[], [], [], []], h = 0, p = 0, v = 0; v < 256; ++v) {
      var g = p ^ p << 1 ^ p << 2 ^ p << 3 ^ p << 4;
      g = g >>> 8 ^ g & 255 ^ 99, s[h] = g, a[g] = h;
      var m = l[h], x = l[m], y = l[x], E = l[g] * 257 ^ g * 16843008;
      c[0][h] = E << 24 | E >>> 8, c[1][h] = E << 16 | E >>> 16, c[2][h] = E << 8 | E >>> 24, c[3][h] = E, E = y * 16843009 ^ x * 65537 ^ m * 257 ^ h * 16843008, d[0][g] = E << 24 | E >>> 8, d[1][g] = E << 16 | E >>> 16, d[2][g] = E << 8 | E >>> 24, d[3][g] = E, h === 0 ? h = p = 1 : (h = m ^ l[l[l[y ^ m]]], p ^= l[l[p]]);
    }
    return {
      SBOX: s,
      INV_SBOX: a,
      SUB_MIX: c,
      INV_SUB_MIX: d
    };
  }();
  function u(l) {
    this._key = r(l), this._reset();
  }
  return u.blockSize = 4 * 4, u.keySize = 256 / 8, u.prototype.blockSize = u.blockSize, u.prototype.keySize = u.keySize, u.prototype._reset = function() {
    for (var l = this._key, f = l.length, s = f + 6, a = (s + 1) * 4, c = [], d = 0; d < f; d++)
      c[d] = l[d];
    for (d = f; d < a; d++) {
      var h = c[d - 1];
      d % f === 0 ? (h = h << 8 | h >>> 24, h = t.SBOX[h >>> 24] << 24 | t.SBOX[h >>> 16 & 255] << 16 | t.SBOX[h >>> 8 & 255] << 8 | t.SBOX[h & 255], h ^= i[d / f | 0] << 24) : f > 6 && d % f === 4 && (h = t.SBOX[h >>> 24] << 24 | t.SBOX[h >>> 16 & 255] << 16 | t.SBOX[h >>> 8 & 255] << 8 | t.SBOX[h & 255]), c[d] = c[d - f] ^ h;
    }
    for (var p = [], v = 0; v < a; v++) {
      var g = a - v, m = c[g - (v % 4 ? 0 : 4)];
      v < 4 || g <= 4 ? p[v] = m : p[v] = t.INV_SUB_MIX[0][t.SBOX[m >>> 24]] ^ t.INV_SUB_MIX[1][t.SBOX[m >>> 16 & 255]] ^ t.INV_SUB_MIX[2][t.SBOX[m >>> 8 & 255]] ^ t.INV_SUB_MIX[3][t.SBOX[m & 255]];
    }
    this._nRounds = s, this._keySchedule = c, this._invKeySchedule = p;
  }, u.prototype.encryptBlockRaw = function(l) {
    return l = r(l), n(l, this._keySchedule, t.SUB_MIX, t.SBOX, this._nRounds);
  }, u.prototype.encryptBlock = function(l) {
    var f = this.encryptBlockRaw(l), s = e.allocUnsafe(16);
    return s.writeUInt32BE(f[0], 0), s.writeUInt32BE(f[1], 4), s.writeUInt32BE(f[2], 8), s.writeUInt32BE(f[3], 12), s;
  }, u.prototype.decryptBlock = function(l) {
    l = r(l);
    var f = l[1];
    l[1] = l[3], l[3] = f;
    var s = n(l, this._invKeySchedule, t.INV_SUB_MIX, t.INV_SBOX, this._nRounds), a = e.allocUnsafe(16);
    return a.writeUInt32BE(s[0], 0), a.writeUInt32BE(s[3], 4), a.writeUInt32BE(s[2], 8), a.writeUInt32BE(s[1], 12), a;
  }, u.prototype.scrub = function() {
    o(this._keySchedule), o(this._invKeySchedule), o(this._key);
  }, Ss.AES = u, Ss;
}
var Ds, Kp;
function ZT() {
  if (Kp)
    return Ds;
  Kp = 1;
  var e = Ye().Buffer, r = e.alloc(16, 0);
  function o(t) {
    return [
      t.readUInt32BE(0),
      t.readUInt32BE(4),
      t.readUInt32BE(8),
      t.readUInt32BE(12)
    ];
  }
  function n(t) {
    var u = e.allocUnsafe(16);
    return u.writeUInt32BE(t[0] >>> 0, 0), u.writeUInt32BE(t[1] >>> 0, 4), u.writeUInt32BE(t[2] >>> 0, 8), u.writeUInt32BE(t[3] >>> 0, 12), u;
  }
  function i(t) {
    this.h = t, this.state = e.alloc(16, 0), this.cache = e.allocUnsafe(0);
  }
  return i.prototype.ghash = function(t) {
    for (var u = -1; ++u < t.length; )
      this.state[u] ^= t[u];
    this._multiply();
  }, i.prototype._multiply = function() {
    for (var t = o(this.h), u = [0, 0, 0, 0], l, f, s, a = -1; ++a < 128; ) {
      for (f = (this.state[~~(a / 8)] & 1 << 7 - a % 8) !== 0, f && (u[0] ^= t[0], u[1] ^= t[1], u[2] ^= t[2], u[3] ^= t[3]), s = (t[3] & 1) !== 0, l = 3; l > 0; l--)
        t[l] = t[l] >>> 1 | (t[l - 1] & 1) << 31;
      t[0] = t[0] >>> 1, s && (t[0] = t[0] ^ 225 << 24);
    }
    this.state = n(u);
  }, i.prototype.update = function(t) {
    this.cache = e.concat([this.cache, t]);
    for (var u; this.cache.length >= 16; )
      u = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(u);
  }, i.prototype.final = function(t, u) {
    return this.cache.length && this.ghash(e.concat([this.cache, r], 16)), this.ghash(n([0, t, 0, u])), this.state;
  }, Ds = i, Ds;
}
var Ns, Zp;
function Ub() {
  if (Zp)
    return Ns;
  Zp = 1;
  var e = so(), r = Ye().Buffer, o = cn(), n = Je(), i = ZT(), t = Ri(), u = zb();
  function l(a, c) {
    var d = 0;
    a.length !== c.length && d++;
    for (var h = Math.min(a.length, c.length), p = 0; p < h; ++p)
      d += a[p] ^ c[p];
    return d;
  }
  function f(a, c, d) {
    if (c.length === 12)
      return a._finID = r.concat([c, r.from([0, 0, 0, 1])]), r.concat([c, r.from([0, 0, 0, 2])]);
    var h = new i(d), p = c.length, v = p % 16;
    h.update(c), v && (v = 16 - v, h.update(r.alloc(v, 0))), h.update(r.alloc(8, 0));
    var g = p * 8, m = r.alloc(8);
    m.writeUIntBE(g, 0, 8), h.update(m), a._finID = h.state;
    var x = r.from(a._finID);
    return u(x), x;
  }
  function s(a, c, d, h) {
    o.call(this);
    var p = r.alloc(4, 0);
    this._cipher = new e.AES(c);
    var v = this._cipher.encryptBlock(p);
    this._ghash = new i(v), d = f(this, d, v), this._prev = r.from(d), this._cache = r.allocUnsafe(0), this._secCache = r.allocUnsafe(0), this._decrypt = h, this._alen = 0, this._len = 0, this._mode = a, this._authTag = null, this._called = !1;
  }
  return n(s, o), s.prototype._update = function(a) {
    if (!this._called && this._alen) {
      var c = 16 - this._alen % 16;
      c < 16 && (c = r.alloc(c, 0), this._ghash.update(c));
    }
    this._called = !0;
    var d = this._mode.encrypt(this, a);
    return this._decrypt ? this._ghash.update(a) : this._ghash.update(d), this._len += a.length, d;
  }, s.prototype._final = function() {
    if (this._decrypt && !this._authTag)
      throw new Error("Unsupported state or unable to authenticate data");
    var a = t(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && l(a, this._authTag))
      throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = a, this._cipher.scrub();
  }, s.prototype.getAuthTag = function() {
    if (this._decrypt || !r.isBuffer(this._authTag))
      throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, s.prototype.setAuthTag = function(c) {
    if (!this._decrypt)
      throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = c;
  }, s.prototype.setAAD = function(c) {
    if (this._called)
      throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(c), this._alen += c.length;
  }, Ns = s, Ns;
}
var Ms, jp;
function kb() {
  if (jp)
    return Ms;
  jp = 1;
  var e = so(), r = Ye().Buffer, o = cn(), n = Je();
  function i(t, u, l, f) {
    o.call(this), this._cipher = new e.AES(u), this._prev = r.from(l), this._cache = r.allocUnsafe(0), this._secCache = r.allocUnsafe(0), this._decrypt = f, this._mode = t;
  }
  return n(i, o), i.prototype._update = function(t) {
    return this._mode.encrypt(this, t, this._decrypt);
  }, i.prototype._final = function() {
    this._cipher.scrub();
  }, Ms = i, Ms;
}
var _s, Yp;
function uo() {
  if (Yp)
    return _s;
  Yp = 1;
  var e = Ye().Buffer, r = Yf();
  function o(n, i, t, u) {
    if (e.isBuffer(n) || (n = e.from(n, "binary")), i && (e.isBuffer(i) || (i = e.from(i, "binary")), i.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var l = t / 8, f = e.alloc(l), s = e.alloc(u || 0), a = e.alloc(0); l > 0 || u > 0; ) {
      var c = new r();
      c.update(a), c.update(n), i && c.update(i), a = c.digest();
      var d = 0;
      if (l > 0) {
        var h = f.length - l;
        d = Math.min(l, a.length), a.copy(f, h, 0, d), l -= d;
      }
      if (d < a.length && u > 0) {
        var p = s.length - u, v = Math.min(u, a.length - d);
        a.copy(s, p, d, d + v), u -= v;
      }
    }
    return a.fill(0), { key: f, iv: s };
  }
  return _s = o, _s;
}
var Xp;
function jT() {
  if (Xp)
    return la;
  Xp = 1;
  var e = ec(), r = Ub(), o = Ye().Buffer, n = kb(), i = cn(), t = so(), u = uo(), l = Je();
  function f(h, p, v) {
    i.call(this), this._cache = new a(), this._cipher = new t.AES(p), this._prev = o.from(v), this._mode = h, this._autopadding = !0;
  }
  l(f, i), f.prototype._update = function(h) {
    this._cache.add(h);
    for (var p, v, g = []; p = this._cache.get(); )
      v = this._mode.encrypt(this, p), g.push(v);
    return o.concat(g);
  };
  var s = o.alloc(16, 16);
  f.prototype._final = function() {
    var h = this._cache.flush();
    if (this._autopadding)
      return h = this._mode.encrypt(this, h), this._cipher.scrub(), h;
    if (!h.equals(s))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, f.prototype.setAutoPadding = function(h) {
    return this._autopadding = !!h, this;
  };
  function a() {
    this.cache = o.allocUnsafe(0);
  }
  a.prototype.add = function(h) {
    this.cache = o.concat([this.cache, h]);
  }, a.prototype.get = function() {
    if (this.cache.length > 15) {
      var h = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), h;
    }
    return null;
  }, a.prototype.flush = function() {
    for (var h = 16 - this.cache.length, p = o.allocUnsafe(h), v = -1; ++v < h; )
      p.writeUInt8(h, v);
    return o.concat([this.cache, p]);
  };
  function c(h, p, v) {
    var g = e[h.toLowerCase()];
    if (!g)
      throw new TypeError("invalid suite type");
    if (typeof p == "string" && (p = o.from(p)), p.length !== g.key / 8)
      throw new TypeError("invalid key length " + p.length);
    if (typeof v == "string" && (v = o.from(v)), g.mode !== "GCM" && v.length !== g.iv)
      throw new TypeError("invalid iv length " + v.length);
    return g.type === "stream" ? new n(g.module, p, v) : g.type === "auth" ? new r(g.module, p, v) : new f(g.module, p, v);
  }
  function d(h, p) {
    var v = e[h.toLowerCase()];
    if (!v)
      throw new TypeError("invalid suite type");
    var g = u(p, !1, v.key, v.iv);
    return c(h, g.key, g.iv);
  }
  return la.createCipheriv = c, la.createCipher = d, la;
}
var pa = {}, Jp;
function YT() {
  if (Jp)
    return pa;
  Jp = 1;
  var e = Ub(), r = Ye().Buffer, o = ec(), n = kb(), i = cn(), t = so(), u = uo(), l = Je();
  function f(h, p, v) {
    i.call(this), this._cache = new s(), this._last = void 0, this._cipher = new t.AES(p), this._prev = r.from(v), this._mode = h, this._autopadding = !0;
  }
  l(f, i), f.prototype._update = function(h) {
    this._cache.add(h);
    for (var p, v, g = []; p = this._cache.get(this._autopadding); )
      v = this._mode.decrypt(this, p), g.push(v);
    return r.concat(g);
  }, f.prototype._final = function() {
    var h = this._cache.flush();
    if (this._autopadding)
      return a(this._mode.decrypt(this, h));
    if (h)
      throw new Error("data not multiple of block length");
  }, f.prototype.setAutoPadding = function(h) {
    return this._autopadding = !!h, this;
  };
  function s() {
    this.cache = r.allocUnsafe(0);
  }
  s.prototype.add = function(h) {
    this.cache = r.concat([this.cache, h]);
  }, s.prototype.get = function(h) {
    var p;
    if (h) {
      if (this.cache.length > 16)
        return p = this.cache.slice(0, 16), this.cache = this.cache.slice(16), p;
    } else if (this.cache.length >= 16)
      return p = this.cache.slice(0, 16), this.cache = this.cache.slice(16), p;
    return null;
  }, s.prototype.flush = function() {
    if (this.cache.length)
      return this.cache;
  };
  function a(h) {
    var p = h[15];
    if (p < 1 || p > 16)
      throw new Error("unable to decrypt data");
    for (var v = -1; ++v < p; )
      if (h[v + (16 - p)] !== p)
        throw new Error("unable to decrypt data");
    if (p !== 16)
      return h.slice(0, 16 - p);
  }
  function c(h, p, v) {
    var g = o[h.toLowerCase()];
    if (!g)
      throw new TypeError("invalid suite type");
    if (typeof v == "string" && (v = r.from(v)), g.mode !== "GCM" && v.length !== g.iv)
      throw new TypeError("invalid iv length " + v.length);
    if (typeof p == "string" && (p = r.from(p)), p.length !== g.key / 8)
      throw new TypeError("invalid key length " + p.length);
    return g.type === "stream" ? new n(g.module, p, v, !0) : g.type === "auth" ? new e(g.module, p, v, !0) : new f(g.module, p, v);
  }
  function d(h, p) {
    var v = o[h.toLowerCase()];
    if (!v)
      throw new TypeError("invalid suite type");
    var g = u(p, !1, v.key, v.iv);
    return c(h, g.key, g.iv);
  }
  return pa.createDecipher = d, pa.createDecipheriv = c, pa;
}
var Qp;
function rc() {
  if (Qp)
    return ut;
  Qp = 1;
  var e = jT(), r = YT(), o = Lb;
  function n() {
    return Object.keys(o);
  }
  return ut.createCipher = ut.Cipher = e.createCipher, ut.createCipheriv = ut.Cipheriv = e.createCipheriv, ut.createDecipher = ut.Decipher = r.createDecipher, ut.createDecipheriv = ut.Decipheriv = r.createDecipheriv, ut.listCiphers = ut.getCiphers = n, ut;
}
var Cs = {}, ev;
function XT() {
  return ev || (ev = 1, function(e) {
    e["des-ecb"] = {
      key: 8,
      iv: 0
    }, e["des-cbc"] = e.des = {
      key: 8,
      iv: 8
    }, e["des-ede3-cbc"] = e.des3 = {
      key: 24,
      iv: 8
    }, e["des-ede3"] = {
      key: 24,
      iv: 0
    }, e["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, e["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(Cs)), Cs;
}
var rv;
function JT() {
  if (rv)
    return st;
  rv = 1;
  var e = $T(), r = rc(), o = ec(), n = XT(), i = uo();
  function t(a, c) {
    a = a.toLowerCase();
    var d, h;
    if (o[a])
      d = o[a].key, h = o[a].iv;
    else if (n[a])
      d = n[a].key * 8, h = n[a].iv;
    else
      throw new TypeError("invalid suite type");
    var p = i(c, !1, d, h);
    return l(a, p.key, p.iv);
  }
  function u(a, c) {
    a = a.toLowerCase();
    var d, h;
    if (o[a])
      d = o[a].key, h = o[a].iv;
    else if (n[a])
      d = n[a].key * 8, h = n[a].iv;
    else
      throw new TypeError("invalid suite type");
    var p = i(c, !1, d, h);
    return f(a, p.key, p.iv);
  }
  function l(a, c, d) {
    if (a = a.toLowerCase(), o[a])
      return r.createCipheriv(a, c, d);
    if (n[a])
      return new e({ key: c, iv: d, mode: a });
    throw new TypeError("invalid suite type");
  }
  function f(a, c, d) {
    if (a = a.toLowerCase(), o[a])
      return r.createDecipheriv(a, c, d);
    if (n[a])
      return new e({ key: c, iv: d, mode: a, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function s() {
    return Object.keys(n).concat(r.getCiphers());
  }
  return st.createCipher = st.Cipher = t, st.createCipheriv = st.Cipheriv = l, st.createDecipher = st.Decipher = u, st.createDecipheriv = st.Decipheriv = f, st.listCiphers = st.getCiphers = s, st;
}
var gn = {}, wa = { exports: {} };
wa.exports;
var tv;
function Rr() {
  return tv || (tv = 1, function(e) {
    (function(r, o) {
      function n(F, w) {
        if (!F)
          throw new Error(w || "Assertion failed");
      }
      function i(F, w) {
        F.super_ = w;
        var A = function() {
        };
        A.prototype = w.prototype, F.prototype = new A(), F.prototype.constructor = F;
      }
      function t(F, w, A) {
        if (t.isBN(F))
          return F;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, F !== null && ((w === "le" || w === "be") && (A = w, w = 10), this._init(F || 0, w || 10, A || "be"));
      }
      typeof r == "object" ? r.exports = t : o.BN = t, t.BN = t, t.wordSize = 26;
      var u;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? u = window.Buffer : u = Ii.Buffer;
      } catch {
      }
      t.isBN = function(w) {
        return w instanceof t ? !0 : w !== null && typeof w == "object" && w.constructor.wordSize === t.wordSize && Array.isArray(w.words);
      }, t.max = function(w, A) {
        return w.cmp(A) > 0 ? w : A;
      }, t.min = function(w, A) {
        return w.cmp(A) < 0 ? w : A;
      }, t.prototype._init = function(w, A, b) {
        if (typeof w == "number")
          return this._initNumber(w, A, b);
        if (typeof w == "object")
          return this._initArray(w, A, b);
        A === "hex" && (A = 16), n(A === (A | 0) && A >= 2 && A <= 36), w = w.toString().replace(/\s+/g, "");
        var D = 0;
        w[0] === "-" && (D++, this.negative = 1), D < w.length && (A === 16 ? this._parseHex(w, D, b) : (this._parseBase(w, A, D), b === "le" && this._initArray(this.toArray(), A, b)));
      }, t.prototype._initNumber = function(w, A, b) {
        w < 0 && (this.negative = 1, w = -w), w < 67108864 ? (this.words = [w & 67108863], this.length = 1) : w < 4503599627370496 ? (this.words = [
          w & 67108863,
          w / 67108864 & 67108863
        ], this.length = 2) : (n(w < 9007199254740992), this.words = [
          w & 67108863,
          w / 67108864 & 67108863,
          1
        ], this.length = 3), b === "le" && this._initArray(this.toArray(), A, b);
      }, t.prototype._initArray = function(w, A, b) {
        if (n(typeof w.length == "number"), w.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(w.length / 3), this.words = new Array(this.length);
        for (var D = 0; D < this.length; D++)
          this.words[D] = 0;
        var M, _, q = 0;
        if (b === "be")
          for (D = w.length - 1, M = 0; D >= 0; D -= 3)
            _ = w[D] | w[D - 1] << 8 | w[D - 2] << 16, this.words[M] |= _ << q & 67108863, this.words[M + 1] = _ >>> 26 - q & 67108863, q += 24, q >= 26 && (q -= 26, M++);
        else if (b === "le")
          for (D = 0, M = 0; D < w.length; D += 3)
            _ = w[D] | w[D + 1] << 8 | w[D + 2] << 16, this.words[M] |= _ << q & 67108863, this.words[M + 1] = _ >>> 26 - q & 67108863, q += 24, q >= 26 && (q -= 26, M++);
        return this.strip();
      };
      function l(F, w) {
        var A = F.charCodeAt(w);
        return A >= 65 && A <= 70 ? A - 55 : A >= 97 && A <= 102 ? A - 87 : A - 48 & 15;
      }
      function f(F, w, A) {
        var b = l(F, A);
        return A - 1 >= w && (b |= l(F, A - 1) << 4), b;
      }
      t.prototype._parseHex = function(w, A, b) {
        this.length = Math.ceil((w.length - A) / 6), this.words = new Array(this.length);
        for (var D = 0; D < this.length; D++)
          this.words[D] = 0;
        var M = 0, _ = 0, q;
        if (b === "be")
          for (D = w.length - 1; D >= A; D -= 2)
            q = f(w, A, D) << M, this.words[_] |= q & 67108863, M >= 18 ? (M -= 18, _ += 1, this.words[_] |= q >>> 26) : M += 8;
        else {
          var C = w.length - A;
          for (D = C % 2 === 0 ? A + 1 : A; D < w.length; D += 2)
            q = f(w, A, D) << M, this.words[_] |= q & 67108863, M >= 18 ? (M -= 18, _ += 1, this.words[_] |= q >>> 26) : M += 8;
        }
        this.strip();
      };
      function s(F, w, A, b) {
        for (var D = 0, M = Math.min(F.length, A), _ = w; _ < M; _++) {
          var q = F.charCodeAt(_) - 48;
          D *= b, q >= 49 ? D += q - 49 + 10 : q >= 17 ? D += q - 17 + 10 : D += q;
        }
        return D;
      }
      t.prototype._parseBase = function(w, A, b) {
        this.words = [0], this.length = 1;
        for (var D = 0, M = 1; M <= 67108863; M *= A)
          D++;
        D--, M = M / A | 0;
        for (var _ = w.length - b, q = _ % D, C = Math.min(_, _ - q) + b, T = 0, z = b; z < C; z += D)
          T = s(w, z, z + D, A), this.imuln(M), this.words[0] + T < 67108864 ? this.words[0] += T : this._iaddn(T);
        if (q !== 0) {
          var I = 1;
          for (T = s(w, z, w.length, A), z = 0; z < q; z++)
            I *= A;
          this.imuln(I), this.words[0] + T < 67108864 ? this.words[0] += T : this._iaddn(T);
        }
        this.strip();
      }, t.prototype.copy = function(w) {
        w.words = new Array(this.length);
        for (var A = 0; A < this.length; A++)
          w.words[A] = this.words[A];
        w.length = this.length, w.negative = this.negative, w.red = this.red;
      }, t.prototype.clone = function() {
        var w = new t(null);
        return this.copy(w), w;
      }, t.prototype._expand = function(w) {
        for (; this.length < w; )
          this.words[this.length++] = 0;
        return this;
      }, t.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, t.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, t.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var a = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], c = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], d = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      t.prototype.toString = function(w, A) {
        w = w || 10, A = A | 0 || 1;
        var b;
        if (w === 16 || w === "hex") {
          b = "";
          for (var D = 0, M = 0, _ = 0; _ < this.length; _++) {
            var q = this.words[_], C = ((q << D | M) & 16777215).toString(16);
            M = q >>> 24 - D & 16777215, M !== 0 || _ !== this.length - 1 ? b = a[6 - C.length] + C + b : b = C + b, D += 2, D >= 26 && (D -= 26, _--);
          }
          for (M !== 0 && (b = M.toString(16) + b); b.length % A !== 0; )
            b = "0" + b;
          return this.negative !== 0 && (b = "-" + b), b;
        }
        if (w === (w | 0) && w >= 2 && w <= 36) {
          var T = c[w], z = d[w];
          b = "";
          var I = this.clone();
          for (I.negative = 0; !I.isZero(); ) {
            var U = I.modn(z).toString(w);
            I = I.idivn(z), I.isZero() ? b = U + b : b = a[T - U.length] + U + b;
          }
          for (this.isZero() && (b = "0" + b); b.length % A !== 0; )
            b = "0" + b;
          return this.negative !== 0 && (b = "-" + b), b;
        }
        n(!1, "Base should be between 2 and 36");
      }, t.prototype.toNumber = function() {
        var w = this.words[0];
        return this.length === 2 ? w += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? w += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -w : w;
      }, t.prototype.toJSON = function() {
        return this.toString(16);
      }, t.prototype.toBuffer = function(w, A) {
        return n(typeof u < "u"), this.toArrayLike(u, w, A);
      }, t.prototype.toArray = function(w, A) {
        return this.toArrayLike(Array, w, A);
      }, t.prototype.toArrayLike = function(w, A, b) {
        var D = this.byteLength(), M = b || Math.max(1, D);
        n(D <= M, "byte array longer than desired length"), n(M > 0, "Requested array length <= 0"), this.strip();
        var _ = A === "le", q = new w(M), C, T, z = this.clone();
        if (_) {
          for (T = 0; !z.isZero(); T++)
            C = z.andln(255), z.iushrn(8), q[T] = C;
          for (; T < M; T++)
            q[T] = 0;
        } else {
          for (T = 0; T < M - D; T++)
            q[T] = 0;
          for (T = 0; !z.isZero(); T++)
            C = z.andln(255), z.iushrn(8), q[M - T - 1] = C;
        }
        return q;
      }, Math.clz32 ? t.prototype._countBits = function(w) {
        return 32 - Math.clz32(w);
      } : t.prototype._countBits = function(w) {
        var A = w, b = 0;
        return A >= 4096 && (b += 13, A >>>= 13), A >= 64 && (b += 7, A >>>= 7), A >= 8 && (b += 4, A >>>= 4), A >= 2 && (b += 2, A >>>= 2), b + A;
      }, t.prototype._zeroBits = function(w) {
        if (w === 0)
          return 26;
        var A = w, b = 0;
        return A & 8191 || (b += 13, A >>>= 13), A & 127 || (b += 7, A >>>= 7), A & 15 || (b += 4, A >>>= 4), A & 3 || (b += 2, A >>>= 2), A & 1 || b++, b;
      }, t.prototype.bitLength = function() {
        var w = this.words[this.length - 1], A = this._countBits(w);
        return (this.length - 1) * 26 + A;
      };
      function h(F) {
        for (var w = new Array(F.bitLength()), A = 0; A < w.length; A++) {
          var b = A / 26 | 0, D = A % 26;
          w[A] = (F.words[b] & 1 << D) >>> D;
        }
        return w;
      }
      t.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var w = 0, A = 0; A < this.length; A++) {
          var b = this._zeroBits(this.words[A]);
          if (w += b, b !== 26)
            break;
        }
        return w;
      }, t.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, t.prototype.toTwos = function(w) {
        return this.negative !== 0 ? this.abs().inotn(w).iaddn(1) : this.clone();
      }, t.prototype.fromTwos = function(w) {
        return this.testn(w - 1) ? this.notn(w).iaddn(1).ineg() : this.clone();
      }, t.prototype.isNeg = function() {
        return this.negative !== 0;
      }, t.prototype.neg = function() {
        return this.clone().ineg();
      }, t.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, t.prototype.iuor = function(w) {
        for (; this.length < w.length; )
          this.words[this.length++] = 0;
        for (var A = 0; A < w.length; A++)
          this.words[A] = this.words[A] | w.words[A];
        return this.strip();
      }, t.prototype.ior = function(w) {
        return n((this.negative | w.negative) === 0), this.iuor(w);
      }, t.prototype.or = function(w) {
        return this.length > w.length ? this.clone().ior(w) : w.clone().ior(this);
      }, t.prototype.uor = function(w) {
        return this.length > w.length ? this.clone().iuor(w) : w.clone().iuor(this);
      }, t.prototype.iuand = function(w) {
        var A;
        this.length > w.length ? A = w : A = this;
        for (var b = 0; b < A.length; b++)
          this.words[b] = this.words[b] & w.words[b];
        return this.length = A.length, this.strip();
      }, t.prototype.iand = function(w) {
        return n((this.negative | w.negative) === 0), this.iuand(w);
      }, t.prototype.and = function(w) {
        return this.length > w.length ? this.clone().iand(w) : w.clone().iand(this);
      }, t.prototype.uand = function(w) {
        return this.length > w.length ? this.clone().iuand(w) : w.clone().iuand(this);
      }, t.prototype.iuxor = function(w) {
        var A, b;
        this.length > w.length ? (A = this, b = w) : (A = w, b = this);
        for (var D = 0; D < b.length; D++)
          this.words[D] = A.words[D] ^ b.words[D];
        if (this !== A)
          for (; D < A.length; D++)
            this.words[D] = A.words[D];
        return this.length = A.length, this.strip();
      }, t.prototype.ixor = function(w) {
        return n((this.negative | w.negative) === 0), this.iuxor(w);
      }, t.prototype.xor = function(w) {
        return this.length > w.length ? this.clone().ixor(w) : w.clone().ixor(this);
      }, t.prototype.uxor = function(w) {
        return this.length > w.length ? this.clone().iuxor(w) : w.clone().iuxor(this);
      }, t.prototype.inotn = function(w) {
        n(typeof w == "number" && w >= 0);
        var A = Math.ceil(w / 26) | 0, b = w % 26;
        this._expand(A), b > 0 && A--;
        for (var D = 0; D < A; D++)
          this.words[D] = ~this.words[D] & 67108863;
        return b > 0 && (this.words[D] = ~this.words[D] & 67108863 >> 26 - b), this.strip();
      }, t.prototype.notn = function(w) {
        return this.clone().inotn(w);
      }, t.prototype.setn = function(w, A) {
        n(typeof w == "number" && w >= 0);
        var b = w / 26 | 0, D = w % 26;
        return this._expand(b + 1), A ? this.words[b] = this.words[b] | 1 << D : this.words[b] = this.words[b] & ~(1 << D), this.strip();
      }, t.prototype.iadd = function(w) {
        var A;
        if (this.negative !== 0 && w.negative === 0)
          return this.negative = 0, A = this.isub(w), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && w.negative !== 0)
          return w.negative = 0, A = this.isub(w), w.negative = 1, A._normSign();
        var b, D;
        this.length > w.length ? (b = this, D = w) : (b = w, D = this);
        for (var M = 0, _ = 0; _ < D.length; _++)
          A = (b.words[_] | 0) + (D.words[_] | 0) + M, this.words[_] = A & 67108863, M = A >>> 26;
        for (; M !== 0 && _ < b.length; _++)
          A = (b.words[_] | 0) + M, this.words[_] = A & 67108863, M = A >>> 26;
        if (this.length = b.length, M !== 0)
          this.words[this.length] = M, this.length++;
        else if (b !== this)
          for (; _ < b.length; _++)
            this.words[_] = b.words[_];
        return this;
      }, t.prototype.add = function(w) {
        var A;
        return w.negative !== 0 && this.negative === 0 ? (w.negative = 0, A = this.sub(w), w.negative ^= 1, A) : w.negative === 0 && this.negative !== 0 ? (this.negative = 0, A = w.sub(this), this.negative = 1, A) : this.length > w.length ? this.clone().iadd(w) : w.clone().iadd(this);
      }, t.prototype.isub = function(w) {
        if (w.negative !== 0) {
          w.negative = 0;
          var A = this.iadd(w);
          return w.negative = 1, A._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(w), this.negative = 1, this._normSign();
        var b = this.cmp(w);
        if (b === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var D, M;
        b > 0 ? (D = this, M = w) : (D = w, M = this);
        for (var _ = 0, q = 0; q < M.length; q++)
          A = (D.words[q] | 0) - (M.words[q] | 0) + _, _ = A >> 26, this.words[q] = A & 67108863;
        for (; _ !== 0 && q < D.length; q++)
          A = (D.words[q] | 0) + _, _ = A >> 26, this.words[q] = A & 67108863;
        if (_ === 0 && q < D.length && D !== this)
          for (; q < D.length; q++)
            this.words[q] = D.words[q];
        return this.length = Math.max(this.length, q), D !== this && (this.negative = 1), this.strip();
      }, t.prototype.sub = function(w) {
        return this.clone().isub(w);
      };
      function p(F, w, A) {
        A.negative = w.negative ^ F.negative;
        var b = F.length + w.length | 0;
        A.length = b, b = b - 1 | 0;
        var D = F.words[0] | 0, M = w.words[0] | 0, _ = D * M, q = _ & 67108863, C = _ / 67108864 | 0;
        A.words[0] = q;
        for (var T = 1; T < b; T++) {
          for (var z = C >>> 26, I = C & 67108863, U = Math.min(T, w.length - 1), ee = Math.max(0, T - F.length + 1); ee <= U; ee++) {
            var se = T - ee | 0;
            D = F.words[se] | 0, M = w.words[ee] | 0, _ = D * M + I, z += _ / 67108864 | 0, I = _ & 67108863;
          }
          A.words[T] = I | 0, C = z | 0;
        }
        return C !== 0 ? A.words[T] = C | 0 : A.length--, A.strip();
      }
      var v = function(w, A, b) {
        var D = w.words, M = A.words, _ = b.words, q = 0, C, T, z, I = D[0] | 0, U = I & 8191, ee = I >>> 13, se = D[1] | 0, K = se & 8191, J = se >>> 13, te = D[2] | 0, ne = te & 8191, ue = te >>> 13, V = D[3] | 0, W = V & 8191, fe = V >>> 13, pe = D[4] | 0, Y = pe & 8191, k = pe >>> 13, L = D[5] | 0, P = L & 8191, G = L >>> 13, j = D[6] | 0, re = j & 8191, ie = j >>> 13, Z = D[7] | 0, X = Z & 8191, oe = Z >>> 13, ce = D[8] | 0, le = ce & 8191, ve = ce >>> 13, ge = D[9] | 0, me = ge & 8191, we = ge >>> 13, be = M[0] | 0, Ae = be & 8191, _e = be >>> 13, Se = M[1] | 0, Me = Se & 8191, H = Se >>> 13, ae = M[2] | 0, de = ae & 8191, ye = ae >>> 13, Ne = M[3] | 0, Ee = Ne & 8191, Qe = Ne >>> 13, dr = M[4] | 0, Le = dr & 8191, mr = dr >>> 13, gr = M[5] | 0, Ue = gr & 8191, br = gr >>> 13, yr = M[6] | 0, ke = yr & 8191, wr = yr >>> 13, xr = M[7] | 0, He = xr & 8191, Er = xr >>> 13, Ar = M[8] | 0, Ge = Ar & 8191, Sr = Ar >>> 13, Dr = M[9] | 0, Ve = Dr & 8191, Nr = Dr >>> 13;
        b.negative = w.negative ^ A.negative, b.length = 19, C = Math.imul(U, Ae), T = Math.imul(U, _e), T = T + Math.imul(ee, Ae) | 0, z = Math.imul(ee, _e);
        var pr = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (pr >>> 26) | 0, pr &= 67108863, C = Math.imul(K, Ae), T = Math.imul(K, _e), T = T + Math.imul(J, Ae) | 0, z = Math.imul(J, _e), C = C + Math.imul(U, Me) | 0, T = T + Math.imul(U, H) | 0, T = T + Math.imul(ee, Me) | 0, z = z + Math.imul(ee, H) | 0;
        var vr = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (vr >>> 26) | 0, vr &= 67108863, C = Math.imul(ne, Ae), T = Math.imul(ne, _e), T = T + Math.imul(ue, Ae) | 0, z = Math.imul(ue, _e), C = C + Math.imul(K, Me) | 0, T = T + Math.imul(K, H) | 0, T = T + Math.imul(J, Me) | 0, z = z + Math.imul(J, H) | 0, C = C + Math.imul(U, de) | 0, T = T + Math.imul(U, ye) | 0, T = T + Math.imul(ee, de) | 0, z = z + Math.imul(ee, ye) | 0;
        var Ct = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (Ct >>> 26) | 0, Ct &= 67108863, C = Math.imul(W, Ae), T = Math.imul(W, _e), T = T + Math.imul(fe, Ae) | 0, z = Math.imul(fe, _e), C = C + Math.imul(ne, Me) | 0, T = T + Math.imul(ne, H) | 0, T = T + Math.imul(ue, Me) | 0, z = z + Math.imul(ue, H) | 0, C = C + Math.imul(K, de) | 0, T = T + Math.imul(K, ye) | 0, T = T + Math.imul(J, de) | 0, z = z + Math.imul(J, ye) | 0, C = C + Math.imul(U, Ee) | 0, T = T + Math.imul(U, Qe) | 0, T = T + Math.imul(ee, Ee) | 0, z = z + Math.imul(ee, Qe) | 0;
        var Tt = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, C = Math.imul(Y, Ae), T = Math.imul(Y, _e), T = T + Math.imul(k, Ae) | 0, z = Math.imul(k, _e), C = C + Math.imul(W, Me) | 0, T = T + Math.imul(W, H) | 0, T = T + Math.imul(fe, Me) | 0, z = z + Math.imul(fe, H) | 0, C = C + Math.imul(ne, de) | 0, T = T + Math.imul(ne, ye) | 0, T = T + Math.imul(ue, de) | 0, z = z + Math.imul(ue, ye) | 0, C = C + Math.imul(K, Ee) | 0, T = T + Math.imul(K, Qe) | 0, T = T + Math.imul(J, Ee) | 0, z = z + Math.imul(J, Qe) | 0, C = C + Math.imul(U, Le) | 0, T = T + Math.imul(U, mr) | 0, T = T + Math.imul(ee, Le) | 0, z = z + Math.imul(ee, mr) | 0;
        var Bt = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (Bt >>> 26) | 0, Bt &= 67108863, C = Math.imul(P, Ae), T = Math.imul(P, _e), T = T + Math.imul(G, Ae) | 0, z = Math.imul(G, _e), C = C + Math.imul(Y, Me) | 0, T = T + Math.imul(Y, H) | 0, T = T + Math.imul(k, Me) | 0, z = z + Math.imul(k, H) | 0, C = C + Math.imul(W, de) | 0, T = T + Math.imul(W, ye) | 0, T = T + Math.imul(fe, de) | 0, z = z + Math.imul(fe, ye) | 0, C = C + Math.imul(ne, Ee) | 0, T = T + Math.imul(ne, Qe) | 0, T = T + Math.imul(ue, Ee) | 0, z = z + Math.imul(ue, Qe) | 0, C = C + Math.imul(K, Le) | 0, T = T + Math.imul(K, mr) | 0, T = T + Math.imul(J, Le) | 0, z = z + Math.imul(J, mr) | 0, C = C + Math.imul(U, Ue) | 0, T = T + Math.imul(U, br) | 0, T = T + Math.imul(ee, Ue) | 0, z = z + Math.imul(ee, br) | 0;
        var Ft = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (Ft >>> 26) | 0, Ft &= 67108863, C = Math.imul(re, Ae), T = Math.imul(re, _e), T = T + Math.imul(ie, Ae) | 0, z = Math.imul(ie, _e), C = C + Math.imul(P, Me) | 0, T = T + Math.imul(P, H) | 0, T = T + Math.imul(G, Me) | 0, z = z + Math.imul(G, H) | 0, C = C + Math.imul(Y, de) | 0, T = T + Math.imul(Y, ye) | 0, T = T + Math.imul(k, de) | 0, z = z + Math.imul(k, ye) | 0, C = C + Math.imul(W, Ee) | 0, T = T + Math.imul(W, Qe) | 0, T = T + Math.imul(fe, Ee) | 0, z = z + Math.imul(fe, Qe) | 0, C = C + Math.imul(ne, Le) | 0, T = T + Math.imul(ne, mr) | 0, T = T + Math.imul(ue, Le) | 0, z = z + Math.imul(ue, mr) | 0, C = C + Math.imul(K, Ue) | 0, T = T + Math.imul(K, br) | 0, T = T + Math.imul(J, Ue) | 0, z = z + Math.imul(J, br) | 0, C = C + Math.imul(U, ke) | 0, T = T + Math.imul(U, wr) | 0, T = T + Math.imul(ee, ke) | 0, z = z + Math.imul(ee, wr) | 0;
        var It = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, C = Math.imul(X, Ae), T = Math.imul(X, _e), T = T + Math.imul(oe, Ae) | 0, z = Math.imul(oe, _e), C = C + Math.imul(re, Me) | 0, T = T + Math.imul(re, H) | 0, T = T + Math.imul(ie, Me) | 0, z = z + Math.imul(ie, H) | 0, C = C + Math.imul(P, de) | 0, T = T + Math.imul(P, ye) | 0, T = T + Math.imul(G, de) | 0, z = z + Math.imul(G, ye) | 0, C = C + Math.imul(Y, Ee) | 0, T = T + Math.imul(Y, Qe) | 0, T = T + Math.imul(k, Ee) | 0, z = z + Math.imul(k, Qe) | 0, C = C + Math.imul(W, Le) | 0, T = T + Math.imul(W, mr) | 0, T = T + Math.imul(fe, Le) | 0, z = z + Math.imul(fe, mr) | 0, C = C + Math.imul(ne, Ue) | 0, T = T + Math.imul(ne, br) | 0, T = T + Math.imul(ue, Ue) | 0, z = z + Math.imul(ue, br) | 0, C = C + Math.imul(K, ke) | 0, T = T + Math.imul(K, wr) | 0, T = T + Math.imul(J, ke) | 0, z = z + Math.imul(J, wr) | 0, C = C + Math.imul(U, He) | 0, T = T + Math.imul(U, Er) | 0, T = T + Math.imul(ee, He) | 0, z = z + Math.imul(ee, Er) | 0;
        var Ot = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (Ot >>> 26) | 0, Ot &= 67108863, C = Math.imul(le, Ae), T = Math.imul(le, _e), T = T + Math.imul(ve, Ae) | 0, z = Math.imul(ve, _e), C = C + Math.imul(X, Me) | 0, T = T + Math.imul(X, H) | 0, T = T + Math.imul(oe, Me) | 0, z = z + Math.imul(oe, H) | 0, C = C + Math.imul(re, de) | 0, T = T + Math.imul(re, ye) | 0, T = T + Math.imul(ie, de) | 0, z = z + Math.imul(ie, ye) | 0, C = C + Math.imul(P, Ee) | 0, T = T + Math.imul(P, Qe) | 0, T = T + Math.imul(G, Ee) | 0, z = z + Math.imul(G, Qe) | 0, C = C + Math.imul(Y, Le) | 0, T = T + Math.imul(Y, mr) | 0, T = T + Math.imul(k, Le) | 0, z = z + Math.imul(k, mr) | 0, C = C + Math.imul(W, Ue) | 0, T = T + Math.imul(W, br) | 0, T = T + Math.imul(fe, Ue) | 0, z = z + Math.imul(fe, br) | 0, C = C + Math.imul(ne, ke) | 0, T = T + Math.imul(ne, wr) | 0, T = T + Math.imul(ue, ke) | 0, z = z + Math.imul(ue, wr) | 0, C = C + Math.imul(K, He) | 0, T = T + Math.imul(K, Er) | 0, T = T + Math.imul(J, He) | 0, z = z + Math.imul(J, Er) | 0, C = C + Math.imul(U, Ge) | 0, T = T + Math.imul(U, Sr) | 0, T = T + Math.imul(ee, Ge) | 0, z = z + Math.imul(ee, Sr) | 0;
        var Jr = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (Jr >>> 26) | 0, Jr &= 67108863, C = Math.imul(me, Ae), T = Math.imul(me, _e), T = T + Math.imul(we, Ae) | 0, z = Math.imul(we, _e), C = C + Math.imul(le, Me) | 0, T = T + Math.imul(le, H) | 0, T = T + Math.imul(ve, Me) | 0, z = z + Math.imul(ve, H) | 0, C = C + Math.imul(X, de) | 0, T = T + Math.imul(X, ye) | 0, T = T + Math.imul(oe, de) | 0, z = z + Math.imul(oe, ye) | 0, C = C + Math.imul(re, Ee) | 0, T = T + Math.imul(re, Qe) | 0, T = T + Math.imul(ie, Ee) | 0, z = z + Math.imul(ie, Qe) | 0, C = C + Math.imul(P, Le) | 0, T = T + Math.imul(P, mr) | 0, T = T + Math.imul(G, Le) | 0, z = z + Math.imul(G, mr) | 0, C = C + Math.imul(Y, Ue) | 0, T = T + Math.imul(Y, br) | 0, T = T + Math.imul(k, Ue) | 0, z = z + Math.imul(k, br) | 0, C = C + Math.imul(W, ke) | 0, T = T + Math.imul(W, wr) | 0, T = T + Math.imul(fe, ke) | 0, z = z + Math.imul(fe, wr) | 0, C = C + Math.imul(ne, He) | 0, T = T + Math.imul(ne, Er) | 0, T = T + Math.imul(ue, He) | 0, z = z + Math.imul(ue, Er) | 0, C = C + Math.imul(K, Ge) | 0, T = T + Math.imul(K, Sr) | 0, T = T + Math.imul(J, Ge) | 0, z = z + Math.imul(J, Sr) | 0, C = C + Math.imul(U, Ve) | 0, T = T + Math.imul(U, Nr) | 0, T = T + Math.imul(ee, Ve) | 0, z = z + Math.imul(ee, Nr) | 0;
        var er = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (er >>> 26) | 0, er &= 67108863, C = Math.imul(me, Me), T = Math.imul(me, H), T = T + Math.imul(we, Me) | 0, z = Math.imul(we, H), C = C + Math.imul(le, de) | 0, T = T + Math.imul(le, ye) | 0, T = T + Math.imul(ve, de) | 0, z = z + Math.imul(ve, ye) | 0, C = C + Math.imul(X, Ee) | 0, T = T + Math.imul(X, Qe) | 0, T = T + Math.imul(oe, Ee) | 0, z = z + Math.imul(oe, Qe) | 0, C = C + Math.imul(re, Le) | 0, T = T + Math.imul(re, mr) | 0, T = T + Math.imul(ie, Le) | 0, z = z + Math.imul(ie, mr) | 0, C = C + Math.imul(P, Ue) | 0, T = T + Math.imul(P, br) | 0, T = T + Math.imul(G, Ue) | 0, z = z + Math.imul(G, br) | 0, C = C + Math.imul(Y, ke) | 0, T = T + Math.imul(Y, wr) | 0, T = T + Math.imul(k, ke) | 0, z = z + Math.imul(k, wr) | 0, C = C + Math.imul(W, He) | 0, T = T + Math.imul(W, Er) | 0, T = T + Math.imul(fe, He) | 0, z = z + Math.imul(fe, Er) | 0, C = C + Math.imul(ne, Ge) | 0, T = T + Math.imul(ne, Sr) | 0, T = T + Math.imul(ue, Ge) | 0, z = z + Math.imul(ue, Sr) | 0, C = C + Math.imul(K, Ve) | 0, T = T + Math.imul(K, Nr) | 0, T = T + Math.imul(J, Ve) | 0, z = z + Math.imul(J, Nr) | 0;
        var _r = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (_r >>> 26) | 0, _r &= 67108863, C = Math.imul(me, de), T = Math.imul(me, ye), T = T + Math.imul(we, de) | 0, z = Math.imul(we, ye), C = C + Math.imul(le, Ee) | 0, T = T + Math.imul(le, Qe) | 0, T = T + Math.imul(ve, Ee) | 0, z = z + Math.imul(ve, Qe) | 0, C = C + Math.imul(X, Le) | 0, T = T + Math.imul(X, mr) | 0, T = T + Math.imul(oe, Le) | 0, z = z + Math.imul(oe, mr) | 0, C = C + Math.imul(re, Ue) | 0, T = T + Math.imul(re, br) | 0, T = T + Math.imul(ie, Ue) | 0, z = z + Math.imul(ie, br) | 0, C = C + Math.imul(P, ke) | 0, T = T + Math.imul(P, wr) | 0, T = T + Math.imul(G, ke) | 0, z = z + Math.imul(G, wr) | 0, C = C + Math.imul(Y, He) | 0, T = T + Math.imul(Y, Er) | 0, T = T + Math.imul(k, He) | 0, z = z + Math.imul(k, Er) | 0, C = C + Math.imul(W, Ge) | 0, T = T + Math.imul(W, Sr) | 0, T = T + Math.imul(fe, Ge) | 0, z = z + Math.imul(fe, Sr) | 0, C = C + Math.imul(ne, Ve) | 0, T = T + Math.imul(ne, Nr) | 0, T = T + Math.imul(ue, Ve) | 0, z = z + Math.imul(ue, Nr) | 0;
        var Rt = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, C = Math.imul(me, Ee), T = Math.imul(me, Qe), T = T + Math.imul(we, Ee) | 0, z = Math.imul(we, Qe), C = C + Math.imul(le, Le) | 0, T = T + Math.imul(le, mr) | 0, T = T + Math.imul(ve, Le) | 0, z = z + Math.imul(ve, mr) | 0, C = C + Math.imul(X, Ue) | 0, T = T + Math.imul(X, br) | 0, T = T + Math.imul(oe, Ue) | 0, z = z + Math.imul(oe, br) | 0, C = C + Math.imul(re, ke) | 0, T = T + Math.imul(re, wr) | 0, T = T + Math.imul(ie, ke) | 0, z = z + Math.imul(ie, wr) | 0, C = C + Math.imul(P, He) | 0, T = T + Math.imul(P, Er) | 0, T = T + Math.imul(G, He) | 0, z = z + Math.imul(G, Er) | 0, C = C + Math.imul(Y, Ge) | 0, T = T + Math.imul(Y, Sr) | 0, T = T + Math.imul(k, Ge) | 0, z = z + Math.imul(k, Sr) | 0, C = C + Math.imul(W, Ve) | 0, T = T + Math.imul(W, Nr) | 0, T = T + Math.imul(fe, Ve) | 0, z = z + Math.imul(fe, Nr) | 0;
        var at = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (at >>> 26) | 0, at &= 67108863, C = Math.imul(me, Le), T = Math.imul(me, mr), T = T + Math.imul(we, Le) | 0, z = Math.imul(we, mr), C = C + Math.imul(le, Ue) | 0, T = T + Math.imul(le, br) | 0, T = T + Math.imul(ve, Ue) | 0, z = z + Math.imul(ve, br) | 0, C = C + Math.imul(X, ke) | 0, T = T + Math.imul(X, wr) | 0, T = T + Math.imul(oe, ke) | 0, z = z + Math.imul(oe, wr) | 0, C = C + Math.imul(re, He) | 0, T = T + Math.imul(re, Er) | 0, T = T + Math.imul(ie, He) | 0, z = z + Math.imul(ie, Er) | 0, C = C + Math.imul(P, Ge) | 0, T = T + Math.imul(P, Sr) | 0, T = T + Math.imul(G, Ge) | 0, z = z + Math.imul(G, Sr) | 0, C = C + Math.imul(Y, Ve) | 0, T = T + Math.imul(Y, Nr) | 0, T = T + Math.imul(k, Ve) | 0, z = z + Math.imul(k, Nr) | 0;
        var Qr = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (Qr >>> 26) | 0, Qr &= 67108863, C = Math.imul(me, Ue), T = Math.imul(me, br), T = T + Math.imul(we, Ue) | 0, z = Math.imul(we, br), C = C + Math.imul(le, ke) | 0, T = T + Math.imul(le, wr) | 0, T = T + Math.imul(ve, ke) | 0, z = z + Math.imul(ve, wr) | 0, C = C + Math.imul(X, He) | 0, T = T + Math.imul(X, Er) | 0, T = T + Math.imul(oe, He) | 0, z = z + Math.imul(oe, Er) | 0, C = C + Math.imul(re, Ge) | 0, T = T + Math.imul(re, Sr) | 0, T = T + Math.imul(ie, Ge) | 0, z = z + Math.imul(ie, Sr) | 0, C = C + Math.imul(P, Ve) | 0, T = T + Math.imul(P, Nr) | 0, T = T + Math.imul(G, Ve) | 0, z = z + Math.imul(G, Nr) | 0;
        var Pt = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, C = Math.imul(me, ke), T = Math.imul(me, wr), T = T + Math.imul(we, ke) | 0, z = Math.imul(we, wr), C = C + Math.imul(le, He) | 0, T = T + Math.imul(le, Er) | 0, T = T + Math.imul(ve, He) | 0, z = z + Math.imul(ve, Er) | 0, C = C + Math.imul(X, Ge) | 0, T = T + Math.imul(X, Sr) | 0, T = T + Math.imul(oe, Ge) | 0, z = z + Math.imul(oe, Sr) | 0, C = C + Math.imul(re, Ve) | 0, T = T + Math.imul(re, Nr) | 0, T = T + Math.imul(ie, Ve) | 0, z = z + Math.imul(ie, Nr) | 0;
        var dn = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, C = Math.imul(me, He), T = Math.imul(me, Er), T = T + Math.imul(we, He) | 0, z = Math.imul(we, Er), C = C + Math.imul(le, Ge) | 0, T = T + Math.imul(le, Sr) | 0, T = T + Math.imul(ve, Ge) | 0, z = z + Math.imul(ve, Sr) | 0, C = C + Math.imul(X, Ve) | 0, T = T + Math.imul(X, Nr) | 0, T = T + Math.imul(oe, Ve) | 0, z = z + Math.imul(oe, Nr) | 0;
        var hn = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (hn >>> 26) | 0, hn &= 67108863, C = Math.imul(me, Ge), T = Math.imul(me, Sr), T = T + Math.imul(we, Ge) | 0, z = Math.imul(we, Sr), C = C + Math.imul(le, Ve) | 0, T = T + Math.imul(le, Nr) | 0, T = T + Math.imul(ve, Ve) | 0, z = z + Math.imul(ve, Nr) | 0;
        var pn = (q + C | 0) + ((T & 8191) << 13) | 0;
        q = (z + (T >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, C = Math.imul(me, Ve), T = Math.imul(me, Nr), T = T + Math.imul(we, Ve) | 0, z = Math.imul(we, Nr);
        var vn = (q + C | 0) + ((T & 8191) << 13) | 0;
        return q = (z + (T >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, _[0] = pr, _[1] = vr, _[2] = Ct, _[3] = Tt, _[4] = Bt, _[5] = Ft, _[6] = It, _[7] = Ot, _[8] = Jr, _[9] = er, _[10] = _r, _[11] = Rt, _[12] = at, _[13] = Qr, _[14] = Pt, _[15] = dn, _[16] = hn, _[17] = pn, _[18] = vn, q !== 0 && (_[19] = q, b.length++), b;
      };
      Math.imul || (v = p);
      function g(F, w, A) {
        A.negative = w.negative ^ F.negative, A.length = F.length + w.length;
        for (var b = 0, D = 0, M = 0; M < A.length - 1; M++) {
          var _ = D;
          D = 0;
          for (var q = b & 67108863, C = Math.min(M, w.length - 1), T = Math.max(0, M - F.length + 1); T <= C; T++) {
            var z = M - T, I = F.words[z] | 0, U = w.words[T] | 0, ee = I * U, se = ee & 67108863;
            _ = _ + (ee / 67108864 | 0) | 0, se = se + q | 0, q = se & 67108863, _ = _ + (se >>> 26) | 0, D += _ >>> 26, _ &= 67108863;
          }
          A.words[M] = q, b = _, _ = D;
        }
        return b !== 0 ? A.words[M] = b : A.length--, A.strip();
      }
      function m(F, w, A) {
        var b = new x();
        return b.mulp(F, w, A);
      }
      t.prototype.mulTo = function(w, A) {
        var b, D = this.length + w.length;
        return this.length === 10 && w.length === 10 ? b = v(this, w, A) : D < 63 ? b = p(this, w, A) : D < 1024 ? b = g(this, w, A) : b = m(this, w, A), b;
      };
      function x(F, w) {
        this.x = F, this.y = w;
      }
      x.prototype.makeRBT = function(w) {
        for (var A = new Array(w), b = t.prototype._countBits(w) - 1, D = 0; D < w; D++)
          A[D] = this.revBin(D, b, w);
        return A;
      }, x.prototype.revBin = function(w, A, b) {
        if (w === 0 || w === b - 1)
          return w;
        for (var D = 0, M = 0; M < A; M++)
          D |= (w & 1) << A - M - 1, w >>= 1;
        return D;
      }, x.prototype.permute = function(w, A, b, D, M, _) {
        for (var q = 0; q < _; q++)
          D[q] = A[w[q]], M[q] = b[w[q]];
      }, x.prototype.transform = function(w, A, b, D, M, _) {
        this.permute(_, w, A, b, D, M);
        for (var q = 1; q < M; q <<= 1)
          for (var C = q << 1, T = Math.cos(2 * Math.PI / C), z = Math.sin(2 * Math.PI / C), I = 0; I < M; I += C)
            for (var U = T, ee = z, se = 0; se < q; se++) {
              var K = b[I + se], J = D[I + se], te = b[I + se + q], ne = D[I + se + q], ue = U * te - ee * ne;
              ne = U * ne + ee * te, te = ue, b[I + se] = K + te, D[I + se] = J + ne, b[I + se + q] = K - te, D[I + se + q] = J - ne, se !== C && (ue = T * U - z * ee, ee = T * ee + z * U, U = ue);
            }
      }, x.prototype.guessLen13b = function(w, A) {
        var b = Math.max(A, w) | 1, D = b & 1, M = 0;
        for (b = b / 2 | 0; b; b = b >>> 1)
          M++;
        return 1 << M + 1 + D;
      }, x.prototype.conjugate = function(w, A, b) {
        if (!(b <= 1))
          for (var D = 0; D < b / 2; D++) {
            var M = w[D];
            w[D] = w[b - D - 1], w[b - D - 1] = M, M = A[D], A[D] = -A[b - D - 1], A[b - D - 1] = -M;
          }
      }, x.prototype.normalize13b = function(w, A) {
        for (var b = 0, D = 0; D < A / 2; D++) {
          var M = Math.round(w[2 * D + 1] / A) * 8192 + Math.round(w[2 * D] / A) + b;
          w[D] = M & 67108863, M < 67108864 ? b = 0 : b = M / 67108864 | 0;
        }
        return w;
      }, x.prototype.convert13b = function(w, A, b, D) {
        for (var M = 0, _ = 0; _ < A; _++)
          M = M + (w[_] | 0), b[2 * _] = M & 8191, M = M >>> 13, b[2 * _ + 1] = M & 8191, M = M >>> 13;
        for (_ = 2 * A; _ < D; ++_)
          b[_] = 0;
        n(M === 0), n((M & -8192) === 0);
      }, x.prototype.stub = function(w) {
        for (var A = new Array(w), b = 0; b < w; b++)
          A[b] = 0;
        return A;
      }, x.prototype.mulp = function(w, A, b) {
        var D = 2 * this.guessLen13b(w.length, A.length), M = this.makeRBT(D), _ = this.stub(D), q = new Array(D), C = new Array(D), T = new Array(D), z = new Array(D), I = new Array(D), U = new Array(D), ee = b.words;
        ee.length = D, this.convert13b(w.words, w.length, q, D), this.convert13b(A.words, A.length, z, D), this.transform(q, _, C, T, D, M), this.transform(z, _, I, U, D, M);
        for (var se = 0; se < D; se++) {
          var K = C[se] * I[se] - T[se] * U[se];
          T[se] = C[se] * U[se] + T[se] * I[se], C[se] = K;
        }
        return this.conjugate(C, T, D), this.transform(C, T, ee, _, D, M), this.conjugate(ee, _, D), this.normalize13b(ee, D), b.negative = w.negative ^ A.negative, b.length = w.length + A.length, b.strip();
      }, t.prototype.mul = function(w) {
        var A = new t(null);
        return A.words = new Array(this.length + w.length), this.mulTo(w, A);
      }, t.prototype.mulf = function(w) {
        var A = new t(null);
        return A.words = new Array(this.length + w.length), m(this, w, A);
      }, t.prototype.imul = function(w) {
        return this.clone().mulTo(w, this);
      }, t.prototype.imuln = function(w) {
        n(typeof w == "number"), n(w < 67108864);
        for (var A = 0, b = 0; b < this.length; b++) {
          var D = (this.words[b] | 0) * w, M = (D & 67108863) + (A & 67108863);
          A >>= 26, A += D / 67108864 | 0, A += M >>> 26, this.words[b] = M & 67108863;
        }
        return A !== 0 && (this.words[b] = A, this.length++), this;
      }, t.prototype.muln = function(w) {
        return this.clone().imuln(w);
      }, t.prototype.sqr = function() {
        return this.mul(this);
      }, t.prototype.isqr = function() {
        return this.imul(this.clone());
      }, t.prototype.pow = function(w) {
        var A = h(w);
        if (A.length === 0)
          return new t(1);
        for (var b = this, D = 0; D < A.length && A[D] === 0; D++, b = b.sqr())
          ;
        if (++D < A.length)
          for (var M = b.sqr(); D < A.length; D++, M = M.sqr())
            A[D] !== 0 && (b = b.mul(M));
        return b;
      }, t.prototype.iushln = function(w) {
        n(typeof w == "number" && w >= 0);
        var A = w % 26, b = (w - A) / 26, D = 67108863 >>> 26 - A << 26 - A, M;
        if (A !== 0) {
          var _ = 0;
          for (M = 0; M < this.length; M++) {
            var q = this.words[M] & D, C = (this.words[M] | 0) - q << A;
            this.words[M] = C | _, _ = q >>> 26 - A;
          }
          _ && (this.words[M] = _, this.length++);
        }
        if (b !== 0) {
          for (M = this.length - 1; M >= 0; M--)
            this.words[M + b] = this.words[M];
          for (M = 0; M < b; M++)
            this.words[M] = 0;
          this.length += b;
        }
        return this.strip();
      }, t.prototype.ishln = function(w) {
        return n(this.negative === 0), this.iushln(w);
      }, t.prototype.iushrn = function(w, A, b) {
        n(typeof w == "number" && w >= 0);
        var D;
        A ? D = (A - A % 26) / 26 : D = 0;
        var M = w % 26, _ = Math.min((w - M) / 26, this.length), q = 67108863 ^ 67108863 >>> M << M, C = b;
        if (D -= _, D = Math.max(0, D), C) {
          for (var T = 0; T < _; T++)
            C.words[T] = this.words[T];
          C.length = _;
        }
        if (_ !== 0)
          if (this.length > _)
            for (this.length -= _, T = 0; T < this.length; T++)
              this.words[T] = this.words[T + _];
          else
            this.words[0] = 0, this.length = 1;
        var z = 0;
        for (T = this.length - 1; T >= 0 && (z !== 0 || T >= D); T--) {
          var I = this.words[T] | 0;
          this.words[T] = z << 26 - M | I >>> M, z = I & q;
        }
        return C && z !== 0 && (C.words[C.length++] = z), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, t.prototype.ishrn = function(w, A, b) {
        return n(this.negative === 0), this.iushrn(w, A, b);
      }, t.prototype.shln = function(w) {
        return this.clone().ishln(w);
      }, t.prototype.ushln = function(w) {
        return this.clone().iushln(w);
      }, t.prototype.shrn = function(w) {
        return this.clone().ishrn(w);
      }, t.prototype.ushrn = function(w) {
        return this.clone().iushrn(w);
      }, t.prototype.testn = function(w) {
        n(typeof w == "number" && w >= 0);
        var A = w % 26, b = (w - A) / 26, D = 1 << A;
        if (this.length <= b)
          return !1;
        var M = this.words[b];
        return !!(M & D);
      }, t.prototype.imaskn = function(w) {
        n(typeof w == "number" && w >= 0);
        var A = w % 26, b = (w - A) / 26;
        if (n(this.negative === 0, "imaskn works only with positive numbers"), this.length <= b)
          return this;
        if (A !== 0 && b++, this.length = Math.min(b, this.length), A !== 0) {
          var D = 67108863 ^ 67108863 >>> A << A;
          this.words[this.length - 1] &= D;
        }
        return this.strip();
      }, t.prototype.maskn = function(w) {
        return this.clone().imaskn(w);
      }, t.prototype.iaddn = function(w) {
        return n(typeof w == "number"), n(w < 67108864), w < 0 ? this.isubn(-w) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < w ? (this.words[0] = w - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(w), this.negative = 1, this) : this._iaddn(w);
      }, t.prototype._iaddn = function(w) {
        this.words[0] += w;
        for (var A = 0; A < this.length && this.words[A] >= 67108864; A++)
          this.words[A] -= 67108864, A === this.length - 1 ? this.words[A + 1] = 1 : this.words[A + 1]++;
        return this.length = Math.max(this.length, A + 1), this;
      }, t.prototype.isubn = function(w) {
        if (n(typeof w == "number"), n(w < 67108864), w < 0)
          return this.iaddn(-w);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(w), this.negative = 1, this;
        if (this.words[0] -= w, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var A = 0; A < this.length && this.words[A] < 0; A++)
            this.words[A] += 67108864, this.words[A + 1] -= 1;
        return this.strip();
      }, t.prototype.addn = function(w) {
        return this.clone().iaddn(w);
      }, t.prototype.subn = function(w) {
        return this.clone().isubn(w);
      }, t.prototype.iabs = function() {
        return this.negative = 0, this;
      }, t.prototype.abs = function() {
        return this.clone().iabs();
      }, t.prototype._ishlnsubmul = function(w, A, b) {
        var D = w.length + b, M;
        this._expand(D);
        var _, q = 0;
        for (M = 0; M < w.length; M++) {
          _ = (this.words[M + b] | 0) + q;
          var C = (w.words[M] | 0) * A;
          _ -= C & 67108863, q = (_ >> 26) - (C / 67108864 | 0), this.words[M + b] = _ & 67108863;
        }
        for (; M < this.length - b; M++)
          _ = (this.words[M + b] | 0) + q, q = _ >> 26, this.words[M + b] = _ & 67108863;
        if (q === 0)
          return this.strip();
        for (n(q === -1), q = 0, M = 0; M < this.length; M++)
          _ = -(this.words[M] | 0) + q, q = _ >> 26, this.words[M] = _ & 67108863;
        return this.negative = 1, this.strip();
      }, t.prototype._wordDiv = function(w, A) {
        var b = this.length - w.length, D = this.clone(), M = w, _ = M.words[M.length - 1] | 0, q = this._countBits(_);
        b = 26 - q, b !== 0 && (M = M.ushln(b), D.iushln(b), _ = M.words[M.length - 1] | 0);
        var C = D.length - M.length, T;
        if (A !== "mod") {
          T = new t(null), T.length = C + 1, T.words = new Array(T.length);
          for (var z = 0; z < T.length; z++)
            T.words[z] = 0;
        }
        var I = D.clone()._ishlnsubmul(M, 1, C);
        I.negative === 0 && (D = I, T && (T.words[C] = 1));
        for (var U = C - 1; U >= 0; U--) {
          var ee = (D.words[M.length + U] | 0) * 67108864 + (D.words[M.length + U - 1] | 0);
          for (ee = Math.min(ee / _ | 0, 67108863), D._ishlnsubmul(M, ee, U); D.negative !== 0; )
            ee--, D.negative = 0, D._ishlnsubmul(M, 1, U), D.isZero() || (D.negative ^= 1);
          T && (T.words[U] = ee);
        }
        return T && T.strip(), D.strip(), A !== "div" && b !== 0 && D.iushrn(b), {
          div: T || null,
          mod: D
        };
      }, t.prototype.divmod = function(w, A, b) {
        if (n(!w.isZero()), this.isZero())
          return {
            div: new t(0),
            mod: new t(0)
          };
        var D, M, _;
        return this.negative !== 0 && w.negative === 0 ? (_ = this.neg().divmod(w, A), A !== "mod" && (D = _.div.neg()), A !== "div" && (M = _.mod.neg(), b && M.negative !== 0 && M.iadd(w)), {
          div: D,
          mod: M
        }) : this.negative === 0 && w.negative !== 0 ? (_ = this.divmod(w.neg(), A), A !== "mod" && (D = _.div.neg()), {
          div: D,
          mod: _.mod
        }) : this.negative & w.negative ? (_ = this.neg().divmod(w.neg(), A), A !== "div" && (M = _.mod.neg(), b && M.negative !== 0 && M.isub(w)), {
          div: _.div,
          mod: M
        }) : w.length > this.length || this.cmp(w) < 0 ? {
          div: new t(0),
          mod: this
        } : w.length === 1 ? A === "div" ? {
          div: this.divn(w.words[0]),
          mod: null
        } : A === "mod" ? {
          div: null,
          mod: new t(this.modn(w.words[0]))
        } : {
          div: this.divn(w.words[0]),
          mod: new t(this.modn(w.words[0]))
        } : this._wordDiv(w, A);
      }, t.prototype.div = function(w) {
        return this.divmod(w, "div", !1).div;
      }, t.prototype.mod = function(w) {
        return this.divmod(w, "mod", !1).mod;
      }, t.prototype.umod = function(w) {
        return this.divmod(w, "mod", !0).mod;
      }, t.prototype.divRound = function(w) {
        var A = this.divmod(w);
        if (A.mod.isZero())
          return A.div;
        var b = A.div.negative !== 0 ? A.mod.isub(w) : A.mod, D = w.ushrn(1), M = w.andln(1), _ = b.cmp(D);
        return _ < 0 || M === 1 && _ === 0 ? A.div : A.div.negative !== 0 ? A.div.isubn(1) : A.div.iaddn(1);
      }, t.prototype.modn = function(w) {
        n(w <= 67108863);
        for (var A = (1 << 26) % w, b = 0, D = this.length - 1; D >= 0; D--)
          b = (A * b + (this.words[D] | 0)) % w;
        return b;
      }, t.prototype.idivn = function(w) {
        n(w <= 67108863);
        for (var A = 0, b = this.length - 1; b >= 0; b--) {
          var D = (this.words[b] | 0) + A * 67108864;
          this.words[b] = D / w | 0, A = D % w;
        }
        return this.strip();
      }, t.prototype.divn = function(w) {
        return this.clone().idivn(w);
      }, t.prototype.egcd = function(w) {
        n(w.negative === 0), n(!w.isZero());
        var A = this, b = w.clone();
        A.negative !== 0 ? A = A.umod(w) : A = A.clone();
        for (var D = new t(1), M = new t(0), _ = new t(0), q = new t(1), C = 0; A.isEven() && b.isEven(); )
          A.iushrn(1), b.iushrn(1), ++C;
        for (var T = b.clone(), z = A.clone(); !A.isZero(); ) {
          for (var I = 0, U = 1; !(A.words[0] & U) && I < 26; ++I, U <<= 1)
            ;
          if (I > 0)
            for (A.iushrn(I); I-- > 0; )
              (D.isOdd() || M.isOdd()) && (D.iadd(T), M.isub(z)), D.iushrn(1), M.iushrn(1);
          for (var ee = 0, se = 1; !(b.words[0] & se) && ee < 26; ++ee, se <<= 1)
            ;
          if (ee > 0)
            for (b.iushrn(ee); ee-- > 0; )
              (_.isOdd() || q.isOdd()) && (_.iadd(T), q.isub(z)), _.iushrn(1), q.iushrn(1);
          A.cmp(b) >= 0 ? (A.isub(b), D.isub(_), M.isub(q)) : (b.isub(A), _.isub(D), q.isub(M));
        }
        return {
          a: _,
          b: q,
          gcd: b.iushln(C)
        };
      }, t.prototype._invmp = function(w) {
        n(w.negative === 0), n(!w.isZero());
        var A = this, b = w.clone();
        A.negative !== 0 ? A = A.umod(w) : A = A.clone();
        for (var D = new t(1), M = new t(0), _ = b.clone(); A.cmpn(1) > 0 && b.cmpn(1) > 0; ) {
          for (var q = 0, C = 1; !(A.words[0] & C) && q < 26; ++q, C <<= 1)
            ;
          if (q > 0)
            for (A.iushrn(q); q-- > 0; )
              D.isOdd() && D.iadd(_), D.iushrn(1);
          for (var T = 0, z = 1; !(b.words[0] & z) && T < 26; ++T, z <<= 1)
            ;
          if (T > 0)
            for (b.iushrn(T); T-- > 0; )
              M.isOdd() && M.iadd(_), M.iushrn(1);
          A.cmp(b) >= 0 ? (A.isub(b), D.isub(M)) : (b.isub(A), M.isub(D));
        }
        var I;
        return A.cmpn(1) === 0 ? I = D : I = M, I.cmpn(0) < 0 && I.iadd(w), I;
      }, t.prototype.gcd = function(w) {
        if (this.isZero())
          return w.abs();
        if (w.isZero())
          return this.abs();
        var A = this.clone(), b = w.clone();
        A.negative = 0, b.negative = 0;
        for (var D = 0; A.isEven() && b.isEven(); D++)
          A.iushrn(1), b.iushrn(1);
        do {
          for (; A.isEven(); )
            A.iushrn(1);
          for (; b.isEven(); )
            b.iushrn(1);
          var M = A.cmp(b);
          if (M < 0) {
            var _ = A;
            A = b, b = _;
          } else if (M === 0 || b.cmpn(1) === 0)
            break;
          A.isub(b);
        } while (!0);
        return b.iushln(D);
      }, t.prototype.invm = function(w) {
        return this.egcd(w).a.umod(w);
      }, t.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, t.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, t.prototype.andln = function(w) {
        return this.words[0] & w;
      }, t.prototype.bincn = function(w) {
        n(typeof w == "number");
        var A = w % 26, b = (w - A) / 26, D = 1 << A;
        if (this.length <= b)
          return this._expand(b + 1), this.words[b] |= D, this;
        for (var M = D, _ = b; M !== 0 && _ < this.length; _++) {
          var q = this.words[_] | 0;
          q += M, M = q >>> 26, q &= 67108863, this.words[_] = q;
        }
        return M !== 0 && (this.words[_] = M, this.length++), this;
      }, t.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, t.prototype.cmpn = function(w) {
        var A = w < 0;
        if (this.negative !== 0 && !A)
          return -1;
        if (this.negative === 0 && A)
          return 1;
        this.strip();
        var b;
        if (this.length > 1)
          b = 1;
        else {
          A && (w = -w), n(w <= 67108863, "Number is too big");
          var D = this.words[0] | 0;
          b = D === w ? 0 : D < w ? -1 : 1;
        }
        return this.negative !== 0 ? -b | 0 : b;
      }, t.prototype.cmp = function(w) {
        if (this.negative !== 0 && w.negative === 0)
          return -1;
        if (this.negative === 0 && w.negative !== 0)
          return 1;
        var A = this.ucmp(w);
        return this.negative !== 0 ? -A | 0 : A;
      }, t.prototype.ucmp = function(w) {
        if (this.length > w.length)
          return 1;
        if (this.length < w.length)
          return -1;
        for (var A = 0, b = this.length - 1; b >= 0; b--) {
          var D = this.words[b] | 0, M = w.words[b] | 0;
          if (D !== M) {
            D < M ? A = -1 : D > M && (A = 1);
            break;
          }
        }
        return A;
      }, t.prototype.gtn = function(w) {
        return this.cmpn(w) === 1;
      }, t.prototype.gt = function(w) {
        return this.cmp(w) === 1;
      }, t.prototype.gten = function(w) {
        return this.cmpn(w) >= 0;
      }, t.prototype.gte = function(w) {
        return this.cmp(w) >= 0;
      }, t.prototype.ltn = function(w) {
        return this.cmpn(w) === -1;
      }, t.prototype.lt = function(w) {
        return this.cmp(w) === -1;
      }, t.prototype.lten = function(w) {
        return this.cmpn(w) <= 0;
      }, t.prototype.lte = function(w) {
        return this.cmp(w) <= 0;
      }, t.prototype.eqn = function(w) {
        return this.cmpn(w) === 0;
      }, t.prototype.eq = function(w) {
        return this.cmp(w) === 0;
      }, t.red = function(w) {
        return new B(w);
      }, t.prototype.toRed = function(w) {
        return n(!this.red, "Already a number in reduction context"), n(this.negative === 0, "red works only with positives"), w.convertTo(this)._forceRed(w);
      }, t.prototype.fromRed = function() {
        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, t.prototype._forceRed = function(w) {
        return this.red = w, this;
      }, t.prototype.forceRed = function(w) {
        return n(!this.red, "Already a number in reduction context"), this._forceRed(w);
      }, t.prototype.redAdd = function(w) {
        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, w);
      }, t.prototype.redIAdd = function(w) {
        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, w);
      }, t.prototype.redSub = function(w) {
        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, w);
      }, t.prototype.redISub = function(w) {
        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, w);
      }, t.prototype.redShl = function(w) {
        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, w);
      }, t.prototype.redMul = function(w) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, w), this.red.mul(this, w);
      }, t.prototype.redIMul = function(w) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, w), this.red.imul(this, w);
      }, t.prototype.redSqr = function() {
        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, t.prototype.redISqr = function() {
        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, t.prototype.redSqrt = function() {
        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, t.prototype.redInvm = function() {
        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, t.prototype.redNeg = function() {
        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, t.prototype.redPow = function(w) {
        return n(this.red && !w.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, w);
      };
      var y = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function E(F, w) {
        this.name = F, this.p = new t(w, 16), this.n = this.p.bitLength(), this.k = new t(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      E.prototype._tmp = function() {
        var w = new t(null);
        return w.words = new Array(Math.ceil(this.n / 13)), w;
      }, E.prototype.ireduce = function(w) {
        var A = w, b;
        do
          this.split(A, this.tmp), A = this.imulK(A), A = A.iadd(this.tmp), b = A.bitLength();
        while (b > this.n);
        var D = b < this.n ? -1 : A.ucmp(this.p);
        return D === 0 ? (A.words[0] = 0, A.length = 1) : D > 0 ? A.isub(this.p) : A.strip !== void 0 ? A.strip() : A._strip(), A;
      }, E.prototype.split = function(w, A) {
        w.iushrn(this.n, 0, A);
      }, E.prototype.imulK = function(w) {
        return w.imul(this.k);
      };
      function N() {
        E.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      i(N, E), N.prototype.split = function(w, A) {
        for (var b = 4194303, D = Math.min(w.length, 9), M = 0; M < D; M++)
          A.words[M] = w.words[M];
        if (A.length = D, w.length <= 9) {
          w.words[0] = 0, w.length = 1;
          return;
        }
        var _ = w.words[9];
        for (A.words[A.length++] = _ & b, M = 10; M < w.length; M++) {
          var q = w.words[M] | 0;
          w.words[M - 10] = (q & b) << 4 | _ >>> 22, _ = q;
        }
        _ >>>= 22, w.words[M - 10] = _, _ === 0 && w.length > 10 ? w.length -= 10 : w.length -= 9;
      }, N.prototype.imulK = function(w) {
        w.words[w.length] = 0, w.words[w.length + 1] = 0, w.length += 2;
        for (var A = 0, b = 0; b < w.length; b++) {
          var D = w.words[b] | 0;
          A += D * 977, w.words[b] = A & 67108863, A = D * 64 + (A / 67108864 | 0);
        }
        return w.words[w.length - 1] === 0 && (w.length--, w.words[w.length - 1] === 0 && w.length--), w;
      };
      function S() {
        E.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      i(S, E);
      function R() {
        E.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      i(R, E);
      function O() {
        E.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      i(O, E), O.prototype.imulK = function(w) {
        for (var A = 0, b = 0; b < w.length; b++) {
          var D = (w.words[b] | 0) * 19 + A, M = D & 67108863;
          D >>>= 26, w.words[b] = M, A = D;
        }
        return A !== 0 && (w.words[w.length++] = A), w;
      }, t._prime = function(w) {
        if (y[w])
          return y[w];
        var A;
        if (w === "k256")
          A = new N();
        else if (w === "p224")
          A = new S();
        else if (w === "p192")
          A = new R();
        else if (w === "p25519")
          A = new O();
        else
          throw new Error("Unknown prime " + w);
        return y[w] = A, A;
      };
      function B(F) {
        if (typeof F == "string") {
          var w = t._prime(F);
          this.m = w.p, this.prime = w;
        } else
          n(F.gtn(1), "modulus must be greater than 1"), this.m = F, this.prime = null;
      }
      B.prototype._verify1 = function(w) {
        n(w.negative === 0, "red works only with positives"), n(w.red, "red works only with red numbers");
      }, B.prototype._verify2 = function(w, A) {
        n((w.negative | A.negative) === 0, "red works only with positives"), n(
          w.red && w.red === A.red,
          "red works only with red numbers"
        );
      }, B.prototype.imod = function(w) {
        return this.prime ? this.prime.ireduce(w)._forceRed(this) : w.umod(this.m)._forceRed(this);
      }, B.prototype.neg = function(w) {
        return w.isZero() ? w.clone() : this.m.sub(w)._forceRed(this);
      }, B.prototype.add = function(w, A) {
        this._verify2(w, A);
        var b = w.add(A);
        return b.cmp(this.m) >= 0 && b.isub(this.m), b._forceRed(this);
      }, B.prototype.iadd = function(w, A) {
        this._verify2(w, A);
        var b = w.iadd(A);
        return b.cmp(this.m) >= 0 && b.isub(this.m), b;
      }, B.prototype.sub = function(w, A) {
        this._verify2(w, A);
        var b = w.sub(A);
        return b.cmpn(0) < 0 && b.iadd(this.m), b._forceRed(this);
      }, B.prototype.isub = function(w, A) {
        this._verify2(w, A);
        var b = w.isub(A);
        return b.cmpn(0) < 0 && b.iadd(this.m), b;
      }, B.prototype.shl = function(w, A) {
        return this._verify1(w), this.imod(w.ushln(A));
      }, B.prototype.imul = function(w, A) {
        return this._verify2(w, A), this.imod(w.imul(A));
      }, B.prototype.mul = function(w, A) {
        return this._verify2(w, A), this.imod(w.mul(A));
      }, B.prototype.isqr = function(w) {
        return this.imul(w, w.clone());
      }, B.prototype.sqr = function(w) {
        return this.mul(w, w);
      }, B.prototype.sqrt = function(w) {
        if (w.isZero())
          return w.clone();
        var A = this.m.andln(3);
        if (n(A % 2 === 1), A === 3) {
          var b = this.m.add(new t(1)).iushrn(2);
          return this.pow(w, b);
        }
        for (var D = this.m.subn(1), M = 0; !D.isZero() && D.andln(1) === 0; )
          M++, D.iushrn(1);
        n(!D.isZero());
        var _ = new t(1).toRed(this), q = _.redNeg(), C = this.m.subn(1).iushrn(1), T = this.m.bitLength();
        for (T = new t(2 * T * T).toRed(this); this.pow(T, C).cmp(q) !== 0; )
          T.redIAdd(q);
        for (var z = this.pow(T, D), I = this.pow(w, D.addn(1).iushrn(1)), U = this.pow(w, D), ee = M; U.cmp(_) !== 0; ) {
          for (var se = U, K = 0; se.cmp(_) !== 0; K++)
            se = se.redSqr();
          n(K < ee);
          var J = this.pow(z, new t(1).iushln(ee - K - 1));
          I = I.redMul(J), z = J.redSqr(), U = U.redMul(z), ee = K;
        }
        return I;
      }, B.prototype.invm = function(w) {
        var A = w._invmp(this.m);
        return A.negative !== 0 ? (A.negative = 0, this.imod(A).redNeg()) : this.imod(A);
      }, B.prototype.pow = function(w, A) {
        if (A.isZero())
          return new t(1).toRed(this);
        if (A.cmpn(1) === 0)
          return w.clone();
        var b = 4, D = new Array(1 << b);
        D[0] = new t(1).toRed(this), D[1] = w;
        for (var M = 2; M < D.length; M++)
          D[M] = this.mul(D[M - 1], w);
        var _ = D[0], q = 0, C = 0, T = A.bitLength() % 26;
        for (T === 0 && (T = 26), M = A.length - 1; M >= 0; M--) {
          for (var z = A.words[M], I = T - 1; I >= 0; I--) {
            var U = z >> I & 1;
            if (_ !== D[0] && (_ = this.sqr(_)), U === 0 && q === 0) {
              C = 0;
              continue;
            }
            q <<= 1, q |= U, C++, !(C !== b && (M !== 0 || I !== 0)) && (_ = this.mul(_, D[q]), C = 0, q = 0);
          }
          T = 26;
        }
        return _;
      }, B.prototype.convertTo = function(w) {
        var A = w.umod(this.m);
        return A === w ? A.clone() : A;
      }, B.prototype.convertFrom = function(w) {
        var A = w.clone();
        return A.red = null, A;
      }, t.mont = function(w) {
        return new $(w);
      };
      function $(F) {
        B.call(this, F), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new t(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      i($, B), $.prototype.convertTo = function(w) {
        return this.imod(w.ushln(this.shift));
      }, $.prototype.convertFrom = function(w) {
        var A = this.imod(w.mul(this.rinv));
        return A.red = null, A;
      }, $.prototype.imul = function(w, A) {
        if (w.isZero() || A.isZero())
          return w.words[0] = 0, w.length = 1, w;
        var b = w.imul(A), D = b.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), M = b.isub(D).iushrn(this.shift), _ = M;
        return M.cmp(this.m) >= 0 ? _ = M.isub(this.m) : M.cmpn(0) < 0 && (_ = M.iadd(this.m)), _._forceRed(this);
      }, $.prototype.mul = function(w, A) {
        if (w.isZero() || A.isZero())
          return new t(0)._forceRed(this);
        var b = w.mul(A), D = b.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), M = b.isub(D).iushrn(this.shift), _ = M;
        return M.cmp(this.m) >= 0 ? _ = M.isub(this.m) : M.cmpn(0) < 0 && (_ = M.iadd(this.m)), _._forceRed(this);
      }, $.prototype.invm = function(w) {
        var A = this.imod(w._invmp(this.m).mul(this.r2));
        return A._forceRed(this);
      };
    })(e, Xe);
  }(wa)), wa.exports;
}
var va = { exports: {} }, nv;
function tc() {
  if (nv)
    return va.exports;
  nv = 1;
  var e;
  va.exports = function(i) {
    return e || (e = new r(null)), e.generate(i);
  };
  function r(n) {
    this.rand = n;
  }
  if (va.exports.Rand = r, r.prototype.generate = function(i) {
    return this._rand(i);
  }, r.prototype._rand = function(i) {
    if (this.rand.getBytes)
      return this.rand.getBytes(i);
    for (var t = new Uint8Array(i), u = 0; u < t.length; u++)
      t[u] = this.rand.getByte();
    return t;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? r.prototype._rand = function(i) {
      var t = new Uint8Array(i);
      return self.crypto.getRandomValues(t), t;
    } : self.msCrypto && self.msCrypto.getRandomValues ? r.prototype._rand = function(i) {
      var t = new Uint8Array(i);
      return self.msCrypto.getRandomValues(t), t;
    } : typeof window == "object" && (r.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var o = ay();
      if (typeof o.randomBytes != "function")
        throw new Error("Not supported");
      r.prototype._rand = function(i) {
        return o.randomBytes(i);
      };
    } catch {
    }
  return va.exports;
}
var Ts, iv;
function Hb() {
  if (iv)
    return Ts;
  iv = 1;
  var e = Rr(), r = tc();
  function o(n) {
    this.rand = n || new r.Rand();
  }
  return Ts = o, o.create = function(i) {
    return new o(i);
  }, o.prototype._randbelow = function(i) {
    var t = i.bitLength(), u = Math.ceil(t / 8);
    do
      var l = new e(this.rand.generate(u));
    while (l.cmp(i) >= 0);
    return l;
  }, o.prototype._randrange = function(i, t) {
    var u = t.sub(i);
    return i.add(this._randbelow(u));
  }, o.prototype.test = function(i, t, u) {
    var l = i.bitLength(), f = e.mont(i), s = new e(1).toRed(f);
    t || (t = Math.max(1, l / 48 | 0));
    for (var a = i.subn(1), c = 0; !a.testn(c); c++)
      ;
    for (var d = i.shrn(c), h = a.toRed(f), p = !0; t > 0; t--) {
      var v = this._randrange(new e(2), a);
      u && u(v);
      var g = v.toRed(f).redPow(d);
      if (!(g.cmp(s) === 0 || g.cmp(h) === 0)) {
        for (var m = 1; m < c; m++) {
          if (g = g.redSqr(), g.cmp(s) === 0)
            return !1;
          if (g.cmp(h) === 0)
            break;
        }
        if (m === c)
          return !1;
      }
    }
    return p;
  }, o.prototype.getDivisor = function(i, t) {
    var u = i.bitLength(), l = e.mont(i), f = new e(1).toRed(l);
    t || (t = Math.max(1, u / 48 | 0));
    for (var s = i.subn(1), a = 0; !s.testn(a); a++)
      ;
    for (var c = i.shrn(a), d = s.toRed(l); t > 0; t--) {
      var h = this._randrange(new e(2), s), p = i.gcd(h);
      if (p.cmpn(1) !== 0)
        return p;
      var v = h.toRed(l).redPow(c);
      if (!(v.cmp(f) === 0 || v.cmp(d) === 0)) {
        for (var g = 1; g < a; g++) {
          if (v = v.redSqr(), v.cmp(f) === 0)
            return v.fromRed().subn(1).gcd(i);
          if (v.cmp(d) === 0)
            break;
        }
        if (g === a)
          return v = v.redSqr(), v.fromRed().subn(1).gcd(i);
      }
    }
    return !1;
  }, Ts;
}
var Bs, av;
function Gb() {
  if (av)
    return Bs;
  av = 1;
  var e = ni();
  Bs = g, g.simpleSieve = p, g.fermatTest = v;
  var r = Rr(), o = new r(24), n = Hb(), i = new n(), t = new r(1), u = new r(2), l = new r(5);
  new r(16), new r(8);
  var f = new r(10), s = new r(3);
  new r(7);
  var a = new r(11), c = new r(4);
  new r(12);
  var d = null;
  function h() {
    if (d !== null)
      return d;
    var m = 1048576, x = [];
    x[0] = 2;
    for (var y = 1, E = 3; E < m; E += 2) {
      for (var N = Math.ceil(Math.sqrt(E)), S = 0; S < y && x[S] <= N && E % x[S] !== 0; S++)
        ;
      y !== S && x[S] <= N || (x[y++] = E);
    }
    return d = x, x;
  }
  function p(m) {
    for (var x = h(), y = 0; y < x.length; y++)
      if (m.modn(x[y]) === 0)
        return m.cmpn(x[y]) === 0;
    return !0;
  }
  function v(m) {
    var x = r.mont(m);
    return u.toRed(x).redPow(m.subn(1)).fromRed().cmpn(1) === 0;
  }
  function g(m, x) {
    if (m < 16)
      return x === 2 || x === 5 ? new r([140, 123]) : new r([140, 39]);
    x = new r(x);
    for (var y, E; ; ) {
      for (y = new r(e(Math.ceil(m / 8))); y.bitLength() > m; )
        y.ishrn(1);
      if (y.isEven() && y.iadd(t), y.testn(1) || y.iadd(u), x.cmp(u)) {
        if (!x.cmp(l))
          for (; y.mod(f).cmp(s); )
            y.iadd(c);
      } else
        for (; y.mod(o).cmp(a); )
          y.iadd(c);
      if (E = y.shrn(1), p(E) && p(y) && v(E) && v(y) && i.test(E) && i.test(y))
        return y;
    }
  }
  return Bs;
}
const QT = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, eB = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, rB = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, tB = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, nB = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, iB = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, aB = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, oB = {
  gen: "02",
  prime: "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"
}, sB = {
  modp1: QT,
  modp2: eB,
  modp5: rB,
  modp14: tB,
  modp15: nB,
  modp16: iB,
  modp17: aB,
  modp18: oB
};
var Fs, ov;
function uB() {
  if (ov)
    return Fs;
  ov = 1;
  var e = Rr(), r = Hb(), o = new r(), n = new e(24), i = new e(11), t = new e(10), u = new e(3), l = new e(7), f = Gb(), s = ni();
  Fs = p;
  function a(g, m) {
    return m = m || "utf8", Buffer.isBuffer(g) || (g = new Buffer(g, m)), this._pub = new e(g), this;
  }
  function c(g, m) {
    return m = m || "utf8", Buffer.isBuffer(g) || (g = new Buffer(g, m)), this._priv = new e(g), this;
  }
  var d = {};
  function h(g, m) {
    var x = m.toString("hex"), y = [x, g.toString(16)].join("_");
    if (y in d)
      return d[y];
    var E = 0;
    if (g.isEven() || !f.simpleSieve || !f.fermatTest(g) || !o.test(g))
      return E += 1, x === "02" || x === "05" ? E += 8 : E += 4, d[y] = E, E;
    o.test(g.shrn(1)) || (E += 2);
    var N;
    switch (x) {
      case "02":
        g.mod(n).cmp(i) && (E += 8);
        break;
      case "05":
        N = g.mod(t), N.cmp(u) && N.cmp(l) && (E += 8);
        break;
      default:
        E += 4;
    }
    return d[y] = E, E;
  }
  function p(g, m, x) {
    this.setGenerator(m), this.__prime = new e(g), this._prime = e.mont(this.__prime), this._primeLen = g.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, x ? (this.setPublicKey = a, this.setPrivateKey = c) : this._primeCode = 8;
  }
  Object.defineProperty(p.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = h(this.__prime, this.__gen)), this._primeCode;
    }
  }), p.prototype.generateKeys = function() {
    return this._priv || (this._priv = new e(s(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, p.prototype.computeSecret = function(g) {
    g = new e(g), g = g.toRed(this._prime);
    var m = g.redPow(this._priv).fromRed(), x = new Buffer(m.toArray()), y = this.getPrime();
    if (x.length < y.length) {
      var E = new Buffer(y.length - x.length);
      E.fill(0), x = Buffer.concat([E, x]);
    }
    return x;
  }, p.prototype.getPublicKey = function(m) {
    return v(this._pub, m);
  }, p.prototype.getPrivateKey = function(m) {
    return v(this._priv, m);
  }, p.prototype.getPrime = function(g) {
    return v(this.__prime, g);
  }, p.prototype.getGenerator = function(g) {
    return v(this._gen, g);
  }, p.prototype.setGenerator = function(g, m) {
    return m = m || "utf8", Buffer.isBuffer(g) || (g = new Buffer(g, m)), this.__gen = g, this._gen = new e(g), this;
  };
  function v(g, m) {
    var x = new Buffer(g.toArray());
    return m ? x.toString(m) : x;
  }
  return Fs;
}
var sv;
function fB() {
  if (sv)
    return gn;
  sv = 1;
  var e = Gb(), r = sB, o = uB();
  function n(u) {
    var l = new Buffer(r[u].prime, "hex"), f = new Buffer(r[u].gen, "hex");
    return new o(l, f);
  }
  var i = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function t(u, l, f, s) {
    return Buffer.isBuffer(l) || i[l] === void 0 ? t(u, "binary", l, f) : (l = l || "binary", s = s || "binary", f = f || new Buffer([2]), Buffer.isBuffer(f) || (f = new Buffer(f, s)), typeof u == "number" ? new o(e(u, f), f, !0) : (Buffer.isBuffer(u) || (u = new Buffer(u, l)), new o(u, f, !0)));
  }
  return gn.DiffieHellmanGroup = gn.createDiffieHellmanGroup = gn.getDiffieHellman = n, gn.createDiffieHellman = gn.DiffieHellman = t, gn;
}
var ci = { exports: {} }, xa = { exports: {} };
xa.exports;
var uv;
function nc() {
  return uv || (uv = 1, function(e) {
    (function(r, o) {
      function n(A, b) {
        if (!A)
          throw new Error(b || "Assertion failed");
      }
      function i(A, b) {
        A.super_ = b;
        var D = function() {
        };
        D.prototype = b.prototype, A.prototype = new D(), A.prototype.constructor = A;
      }
      function t(A, b, D) {
        if (t.isBN(A))
          return A;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, A !== null && ((b === "le" || b === "be") && (D = b, b = 10), this._init(A || 0, b || 10, D || "be"));
      }
      typeof r == "object" ? r.exports = t : o.BN = t, t.BN = t, t.wordSize = 26;
      var u;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? u = window.Buffer : u = Ii.Buffer;
      } catch {
      }
      t.isBN = function(b) {
        return b instanceof t ? !0 : b !== null && typeof b == "object" && b.constructor.wordSize === t.wordSize && Array.isArray(b.words);
      }, t.max = function(b, D) {
        return b.cmp(D) > 0 ? b : D;
      }, t.min = function(b, D) {
        return b.cmp(D) < 0 ? b : D;
      }, t.prototype._init = function(b, D, M) {
        if (typeof b == "number")
          return this._initNumber(b, D, M);
        if (typeof b == "object")
          return this._initArray(b, D, M);
        D === "hex" && (D = 16), n(D === (D | 0) && D >= 2 && D <= 36), b = b.toString().replace(/\s+/g, "");
        var _ = 0;
        b[0] === "-" && (_++, this.negative = 1), _ < b.length && (D === 16 ? this._parseHex(b, _, M) : (this._parseBase(b, D, _), M === "le" && this._initArray(this.toArray(), D, M)));
      }, t.prototype._initNumber = function(b, D, M) {
        b < 0 && (this.negative = 1, b = -b), b < 67108864 ? (this.words = [b & 67108863], this.length = 1) : b < 4503599627370496 ? (this.words = [
          b & 67108863,
          b / 67108864 & 67108863
        ], this.length = 2) : (n(b < 9007199254740992), this.words = [
          b & 67108863,
          b / 67108864 & 67108863,
          1
        ], this.length = 3), M === "le" && this._initArray(this.toArray(), D, M);
      }, t.prototype._initArray = function(b, D, M) {
        if (n(typeof b.length == "number"), b.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(b.length / 3), this.words = new Array(this.length);
        for (var _ = 0; _ < this.length; _++)
          this.words[_] = 0;
        var q, C, T = 0;
        if (M === "be")
          for (_ = b.length - 1, q = 0; _ >= 0; _ -= 3)
            C = b[_] | b[_ - 1] << 8 | b[_ - 2] << 16, this.words[q] |= C << T & 67108863, this.words[q + 1] = C >>> 26 - T & 67108863, T += 24, T >= 26 && (T -= 26, q++);
        else if (M === "le")
          for (_ = 0, q = 0; _ < b.length; _ += 3)
            C = b[_] | b[_ + 1] << 8 | b[_ + 2] << 16, this.words[q] |= C << T & 67108863, this.words[q + 1] = C >>> 26 - T & 67108863, T += 24, T >= 26 && (T -= 26, q++);
        return this._strip();
      };
      function l(A, b) {
        var D = A.charCodeAt(b);
        if (D >= 48 && D <= 57)
          return D - 48;
        if (D >= 65 && D <= 70)
          return D - 55;
        if (D >= 97 && D <= 102)
          return D - 87;
        n(!1, "Invalid character in " + A);
      }
      function f(A, b, D) {
        var M = l(A, D);
        return D - 1 >= b && (M |= l(A, D - 1) << 4), M;
      }
      t.prototype._parseHex = function(b, D, M) {
        this.length = Math.ceil((b.length - D) / 6), this.words = new Array(this.length);
        for (var _ = 0; _ < this.length; _++)
          this.words[_] = 0;
        var q = 0, C = 0, T;
        if (M === "be")
          for (_ = b.length - 1; _ >= D; _ -= 2)
            T = f(b, D, _) << q, this.words[C] |= T & 67108863, q >= 18 ? (q -= 18, C += 1, this.words[C] |= T >>> 26) : q += 8;
        else {
          var z = b.length - D;
          for (_ = z % 2 === 0 ? D + 1 : D; _ < b.length; _ += 2)
            T = f(b, D, _) << q, this.words[C] |= T & 67108863, q >= 18 ? (q -= 18, C += 1, this.words[C] |= T >>> 26) : q += 8;
        }
        this._strip();
      };
      function s(A, b, D, M) {
        for (var _ = 0, q = 0, C = Math.min(A.length, D), T = b; T < C; T++) {
          var z = A.charCodeAt(T) - 48;
          _ *= M, z >= 49 ? q = z - 49 + 10 : z >= 17 ? q = z - 17 + 10 : q = z, n(z >= 0 && q < M, "Invalid character"), _ += q;
        }
        return _;
      }
      t.prototype._parseBase = function(b, D, M) {
        this.words = [0], this.length = 1;
        for (var _ = 0, q = 1; q <= 67108863; q *= D)
          _++;
        _--, q = q / D | 0;
        for (var C = b.length - M, T = C % _, z = Math.min(C, C - T) + M, I = 0, U = M; U < z; U += _)
          I = s(b, U, U + _, D), this.imuln(q), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
        if (T !== 0) {
          var ee = 1;
          for (I = s(b, U, b.length, D), U = 0; U < T; U++)
            ee *= D;
          this.imuln(ee), this.words[0] + I < 67108864 ? this.words[0] += I : this._iaddn(I);
        }
        this._strip();
      }, t.prototype.copy = function(b) {
        b.words = new Array(this.length);
        for (var D = 0; D < this.length; D++)
          b.words[D] = this.words[D];
        b.length = this.length, b.negative = this.negative, b.red = this.red;
      };
      function a(A, b) {
        A.words = b.words, A.length = b.length, A.negative = b.negative, A.red = b.red;
      }
      if (t.prototype._move = function(b) {
        a(b, this);
      }, t.prototype.clone = function() {
        var b = new t(null);
        return this.copy(b), b;
      }, t.prototype._expand = function(b) {
        for (; this.length < b; )
          this.words[this.length++] = 0;
        return this;
      }, t.prototype._strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, t.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, typeof Symbol < "u" && typeof Symbol.for == "function")
        try {
          t.prototype[Symbol.for("nodejs.util.inspect.custom")] = c;
        } catch {
          t.prototype.inspect = c;
        }
      else
        t.prototype.inspect = c;
      function c() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      }
      var d = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], h = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], p = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      t.prototype.toString = function(b, D) {
        b = b || 10, D = D | 0 || 1;
        var M;
        if (b === 16 || b === "hex") {
          M = "";
          for (var _ = 0, q = 0, C = 0; C < this.length; C++) {
            var T = this.words[C], z = ((T << _ | q) & 16777215).toString(16);
            q = T >>> 24 - _ & 16777215, _ += 2, _ >= 26 && (_ -= 26, C--), q !== 0 || C !== this.length - 1 ? M = d[6 - z.length] + z + M : M = z + M;
          }
          for (q !== 0 && (M = q.toString(16) + M); M.length % D !== 0; )
            M = "0" + M;
          return this.negative !== 0 && (M = "-" + M), M;
        }
        if (b === (b | 0) && b >= 2 && b <= 36) {
          var I = h[b], U = p[b];
          M = "";
          var ee = this.clone();
          for (ee.negative = 0; !ee.isZero(); ) {
            var se = ee.modrn(U).toString(b);
            ee = ee.idivn(U), ee.isZero() ? M = se + M : M = d[I - se.length] + se + M;
          }
          for (this.isZero() && (M = "0" + M); M.length % D !== 0; )
            M = "0" + M;
          return this.negative !== 0 && (M = "-" + M), M;
        }
        n(!1, "Base should be between 2 and 36");
      }, t.prototype.toNumber = function() {
        var b = this.words[0];
        return this.length === 2 ? b += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? b += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -b : b;
      }, t.prototype.toJSON = function() {
        return this.toString(16, 2);
      }, u && (t.prototype.toBuffer = function(b, D) {
        return this.toArrayLike(u, b, D);
      }), t.prototype.toArray = function(b, D) {
        return this.toArrayLike(Array, b, D);
      };
      var v = function(b, D) {
        return b.allocUnsafe ? b.allocUnsafe(D) : new b(D);
      };
      t.prototype.toArrayLike = function(b, D, M) {
        this._strip();
        var _ = this.byteLength(), q = M || Math.max(1, _);
        n(_ <= q, "byte array longer than desired length"), n(q > 0, "Requested array length <= 0");
        var C = v(b, q), T = D === "le" ? "LE" : "BE";
        return this["_toArrayLike" + T](C, _), C;
      }, t.prototype._toArrayLikeLE = function(b, D) {
        for (var M = 0, _ = 0, q = 0, C = 0; q < this.length; q++) {
          var T = this.words[q] << C | _;
          b[M++] = T & 255, M < b.length && (b[M++] = T >> 8 & 255), M < b.length && (b[M++] = T >> 16 & 255), C === 6 ? (M < b.length && (b[M++] = T >> 24 & 255), _ = 0, C = 0) : (_ = T >>> 24, C += 2);
        }
        if (M < b.length)
          for (b[M++] = _; M < b.length; )
            b[M++] = 0;
      }, t.prototype._toArrayLikeBE = function(b, D) {
        for (var M = b.length - 1, _ = 0, q = 0, C = 0; q < this.length; q++) {
          var T = this.words[q] << C | _;
          b[M--] = T & 255, M >= 0 && (b[M--] = T >> 8 & 255), M >= 0 && (b[M--] = T >> 16 & 255), C === 6 ? (M >= 0 && (b[M--] = T >> 24 & 255), _ = 0, C = 0) : (_ = T >>> 24, C += 2);
        }
        if (M >= 0)
          for (b[M--] = _; M >= 0; )
            b[M--] = 0;
      }, Math.clz32 ? t.prototype._countBits = function(b) {
        return 32 - Math.clz32(b);
      } : t.prototype._countBits = function(b) {
        var D = b, M = 0;
        return D >= 4096 && (M += 13, D >>>= 13), D >= 64 && (M += 7, D >>>= 7), D >= 8 && (M += 4, D >>>= 4), D >= 2 && (M += 2, D >>>= 2), M + D;
      }, t.prototype._zeroBits = function(b) {
        if (b === 0)
          return 26;
        var D = b, M = 0;
        return D & 8191 || (M += 13, D >>>= 13), D & 127 || (M += 7, D >>>= 7), D & 15 || (M += 4, D >>>= 4), D & 3 || (M += 2, D >>>= 2), D & 1 || M++, M;
      }, t.prototype.bitLength = function() {
        var b = this.words[this.length - 1], D = this._countBits(b);
        return (this.length - 1) * 26 + D;
      };
      function g(A) {
        for (var b = new Array(A.bitLength()), D = 0; D < b.length; D++) {
          var M = D / 26 | 0, _ = D % 26;
          b[D] = A.words[M] >>> _ & 1;
        }
        return b;
      }
      t.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var b = 0, D = 0; D < this.length; D++) {
          var M = this._zeroBits(this.words[D]);
          if (b += M, M !== 26)
            break;
        }
        return b;
      }, t.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, t.prototype.toTwos = function(b) {
        return this.negative !== 0 ? this.abs().inotn(b).iaddn(1) : this.clone();
      }, t.prototype.fromTwos = function(b) {
        return this.testn(b - 1) ? this.notn(b).iaddn(1).ineg() : this.clone();
      }, t.prototype.isNeg = function() {
        return this.negative !== 0;
      }, t.prototype.neg = function() {
        return this.clone().ineg();
      }, t.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, t.prototype.iuor = function(b) {
        for (; this.length < b.length; )
          this.words[this.length++] = 0;
        for (var D = 0; D < b.length; D++)
          this.words[D] = this.words[D] | b.words[D];
        return this._strip();
      }, t.prototype.ior = function(b) {
        return n((this.negative | b.negative) === 0), this.iuor(b);
      }, t.prototype.or = function(b) {
        return this.length > b.length ? this.clone().ior(b) : b.clone().ior(this);
      }, t.prototype.uor = function(b) {
        return this.length > b.length ? this.clone().iuor(b) : b.clone().iuor(this);
      }, t.prototype.iuand = function(b) {
        var D;
        this.length > b.length ? D = b : D = this;
        for (var M = 0; M < D.length; M++)
          this.words[M] = this.words[M] & b.words[M];
        return this.length = D.length, this._strip();
      }, t.prototype.iand = function(b) {
        return n((this.negative | b.negative) === 0), this.iuand(b);
      }, t.prototype.and = function(b) {
        return this.length > b.length ? this.clone().iand(b) : b.clone().iand(this);
      }, t.prototype.uand = function(b) {
        return this.length > b.length ? this.clone().iuand(b) : b.clone().iuand(this);
      }, t.prototype.iuxor = function(b) {
        var D, M;
        this.length > b.length ? (D = this, M = b) : (D = b, M = this);
        for (var _ = 0; _ < M.length; _++)
          this.words[_] = D.words[_] ^ M.words[_];
        if (this !== D)
          for (; _ < D.length; _++)
            this.words[_] = D.words[_];
        return this.length = D.length, this._strip();
      }, t.prototype.ixor = function(b) {
        return n((this.negative | b.negative) === 0), this.iuxor(b);
      }, t.prototype.xor = function(b) {
        return this.length > b.length ? this.clone().ixor(b) : b.clone().ixor(this);
      }, t.prototype.uxor = function(b) {
        return this.length > b.length ? this.clone().iuxor(b) : b.clone().iuxor(this);
      }, t.prototype.inotn = function(b) {
        n(typeof b == "number" && b >= 0);
        var D = Math.ceil(b / 26) | 0, M = b % 26;
        this._expand(D), M > 0 && D--;
        for (var _ = 0; _ < D; _++)
          this.words[_] = ~this.words[_] & 67108863;
        return M > 0 && (this.words[_] = ~this.words[_] & 67108863 >> 26 - M), this._strip();
      }, t.prototype.notn = function(b) {
        return this.clone().inotn(b);
      }, t.prototype.setn = function(b, D) {
        n(typeof b == "number" && b >= 0);
        var M = b / 26 | 0, _ = b % 26;
        return this._expand(M + 1), D ? this.words[M] = this.words[M] | 1 << _ : this.words[M] = this.words[M] & ~(1 << _), this._strip();
      }, t.prototype.iadd = function(b) {
        var D;
        if (this.negative !== 0 && b.negative === 0)
          return this.negative = 0, D = this.isub(b), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && b.negative !== 0)
          return b.negative = 0, D = this.isub(b), b.negative = 1, D._normSign();
        var M, _;
        this.length > b.length ? (M = this, _ = b) : (M = b, _ = this);
        for (var q = 0, C = 0; C < _.length; C++)
          D = (M.words[C] | 0) + (_.words[C] | 0) + q, this.words[C] = D & 67108863, q = D >>> 26;
        for (; q !== 0 && C < M.length; C++)
          D = (M.words[C] | 0) + q, this.words[C] = D & 67108863, q = D >>> 26;
        if (this.length = M.length, q !== 0)
          this.words[this.length] = q, this.length++;
        else if (M !== this)
          for (; C < M.length; C++)
            this.words[C] = M.words[C];
        return this;
      }, t.prototype.add = function(b) {
        var D;
        return b.negative !== 0 && this.negative === 0 ? (b.negative = 0, D = this.sub(b), b.negative ^= 1, D) : b.negative === 0 && this.negative !== 0 ? (this.negative = 0, D = b.sub(this), this.negative = 1, D) : this.length > b.length ? this.clone().iadd(b) : b.clone().iadd(this);
      }, t.prototype.isub = function(b) {
        if (b.negative !== 0) {
          b.negative = 0;
          var D = this.iadd(b);
          return b.negative = 1, D._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(b), this.negative = 1, this._normSign();
        var M = this.cmp(b);
        if (M === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var _, q;
        M > 0 ? (_ = this, q = b) : (_ = b, q = this);
        for (var C = 0, T = 0; T < q.length; T++)
          D = (_.words[T] | 0) - (q.words[T] | 0) + C, C = D >> 26, this.words[T] = D & 67108863;
        for (; C !== 0 && T < _.length; T++)
          D = (_.words[T] | 0) + C, C = D >> 26, this.words[T] = D & 67108863;
        if (C === 0 && T < _.length && _ !== this)
          for (; T < _.length; T++)
            this.words[T] = _.words[T];
        return this.length = Math.max(this.length, T), _ !== this && (this.negative = 1), this._strip();
      }, t.prototype.sub = function(b) {
        return this.clone().isub(b);
      };
      function m(A, b, D) {
        D.negative = b.negative ^ A.negative;
        var M = A.length + b.length | 0;
        D.length = M, M = M - 1 | 0;
        var _ = A.words[0] | 0, q = b.words[0] | 0, C = _ * q, T = C & 67108863, z = C / 67108864 | 0;
        D.words[0] = T;
        for (var I = 1; I < M; I++) {
          for (var U = z >>> 26, ee = z & 67108863, se = Math.min(I, b.length - 1), K = Math.max(0, I - A.length + 1); K <= se; K++) {
            var J = I - K | 0;
            _ = A.words[J] | 0, q = b.words[K] | 0, C = _ * q + ee, U += C / 67108864 | 0, ee = C & 67108863;
          }
          D.words[I] = ee | 0, z = U | 0;
        }
        return z !== 0 ? D.words[I] = z | 0 : D.length--, D._strip();
      }
      var x = function(b, D, M) {
        var _ = b.words, q = D.words, C = M.words, T = 0, z, I, U, ee = _[0] | 0, se = ee & 8191, K = ee >>> 13, J = _[1] | 0, te = J & 8191, ne = J >>> 13, ue = _[2] | 0, V = ue & 8191, W = ue >>> 13, fe = _[3] | 0, pe = fe & 8191, Y = fe >>> 13, k = _[4] | 0, L = k & 8191, P = k >>> 13, G = _[5] | 0, j = G & 8191, re = G >>> 13, ie = _[6] | 0, Z = ie & 8191, X = ie >>> 13, oe = _[7] | 0, ce = oe & 8191, le = oe >>> 13, ve = _[8] | 0, ge = ve & 8191, me = ve >>> 13, we = _[9] | 0, be = we & 8191, Ae = we >>> 13, _e = q[0] | 0, Se = _e & 8191, Me = _e >>> 13, H = q[1] | 0, ae = H & 8191, de = H >>> 13, ye = q[2] | 0, Ne = ye & 8191, Ee = ye >>> 13, Qe = q[3] | 0, dr = Qe & 8191, Le = Qe >>> 13, mr = q[4] | 0, gr = mr & 8191, Ue = mr >>> 13, br = q[5] | 0, yr = br & 8191, ke = br >>> 13, wr = q[6] | 0, xr = wr & 8191, He = wr >>> 13, Er = q[7] | 0, Ar = Er & 8191, Ge = Er >>> 13, Sr = q[8] | 0, Dr = Sr & 8191, Ve = Sr >>> 13, Nr = q[9] | 0, pr = Nr & 8191, vr = Nr >>> 13;
        M.negative = b.negative ^ D.negative, M.length = 19, z = Math.imul(se, Se), I = Math.imul(se, Me), I = I + Math.imul(K, Se) | 0, U = Math.imul(K, Me);
        var Ct = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (Ct >>> 26) | 0, Ct &= 67108863, z = Math.imul(te, Se), I = Math.imul(te, Me), I = I + Math.imul(ne, Se) | 0, U = Math.imul(ne, Me), z = z + Math.imul(se, ae) | 0, I = I + Math.imul(se, de) | 0, I = I + Math.imul(K, ae) | 0, U = U + Math.imul(K, de) | 0;
        var Tt = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (Tt >>> 26) | 0, Tt &= 67108863, z = Math.imul(V, Se), I = Math.imul(V, Me), I = I + Math.imul(W, Se) | 0, U = Math.imul(W, Me), z = z + Math.imul(te, ae) | 0, I = I + Math.imul(te, de) | 0, I = I + Math.imul(ne, ae) | 0, U = U + Math.imul(ne, de) | 0, z = z + Math.imul(se, Ne) | 0, I = I + Math.imul(se, Ee) | 0, I = I + Math.imul(K, Ne) | 0, U = U + Math.imul(K, Ee) | 0;
        var Bt = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (Bt >>> 26) | 0, Bt &= 67108863, z = Math.imul(pe, Se), I = Math.imul(pe, Me), I = I + Math.imul(Y, Se) | 0, U = Math.imul(Y, Me), z = z + Math.imul(V, ae) | 0, I = I + Math.imul(V, de) | 0, I = I + Math.imul(W, ae) | 0, U = U + Math.imul(W, de) | 0, z = z + Math.imul(te, Ne) | 0, I = I + Math.imul(te, Ee) | 0, I = I + Math.imul(ne, Ne) | 0, U = U + Math.imul(ne, Ee) | 0, z = z + Math.imul(se, dr) | 0, I = I + Math.imul(se, Le) | 0, I = I + Math.imul(K, dr) | 0, U = U + Math.imul(K, Le) | 0;
        var Ft = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (Ft >>> 26) | 0, Ft &= 67108863, z = Math.imul(L, Se), I = Math.imul(L, Me), I = I + Math.imul(P, Se) | 0, U = Math.imul(P, Me), z = z + Math.imul(pe, ae) | 0, I = I + Math.imul(pe, de) | 0, I = I + Math.imul(Y, ae) | 0, U = U + Math.imul(Y, de) | 0, z = z + Math.imul(V, Ne) | 0, I = I + Math.imul(V, Ee) | 0, I = I + Math.imul(W, Ne) | 0, U = U + Math.imul(W, Ee) | 0, z = z + Math.imul(te, dr) | 0, I = I + Math.imul(te, Le) | 0, I = I + Math.imul(ne, dr) | 0, U = U + Math.imul(ne, Le) | 0, z = z + Math.imul(se, gr) | 0, I = I + Math.imul(se, Ue) | 0, I = I + Math.imul(K, gr) | 0, U = U + Math.imul(K, Ue) | 0;
        var It = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, z = Math.imul(j, Se), I = Math.imul(j, Me), I = I + Math.imul(re, Se) | 0, U = Math.imul(re, Me), z = z + Math.imul(L, ae) | 0, I = I + Math.imul(L, de) | 0, I = I + Math.imul(P, ae) | 0, U = U + Math.imul(P, de) | 0, z = z + Math.imul(pe, Ne) | 0, I = I + Math.imul(pe, Ee) | 0, I = I + Math.imul(Y, Ne) | 0, U = U + Math.imul(Y, Ee) | 0, z = z + Math.imul(V, dr) | 0, I = I + Math.imul(V, Le) | 0, I = I + Math.imul(W, dr) | 0, U = U + Math.imul(W, Le) | 0, z = z + Math.imul(te, gr) | 0, I = I + Math.imul(te, Ue) | 0, I = I + Math.imul(ne, gr) | 0, U = U + Math.imul(ne, Ue) | 0, z = z + Math.imul(se, yr) | 0, I = I + Math.imul(se, ke) | 0, I = I + Math.imul(K, yr) | 0, U = U + Math.imul(K, ke) | 0;
        var Ot = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (Ot >>> 26) | 0, Ot &= 67108863, z = Math.imul(Z, Se), I = Math.imul(Z, Me), I = I + Math.imul(X, Se) | 0, U = Math.imul(X, Me), z = z + Math.imul(j, ae) | 0, I = I + Math.imul(j, de) | 0, I = I + Math.imul(re, ae) | 0, U = U + Math.imul(re, de) | 0, z = z + Math.imul(L, Ne) | 0, I = I + Math.imul(L, Ee) | 0, I = I + Math.imul(P, Ne) | 0, U = U + Math.imul(P, Ee) | 0, z = z + Math.imul(pe, dr) | 0, I = I + Math.imul(pe, Le) | 0, I = I + Math.imul(Y, dr) | 0, U = U + Math.imul(Y, Le) | 0, z = z + Math.imul(V, gr) | 0, I = I + Math.imul(V, Ue) | 0, I = I + Math.imul(W, gr) | 0, U = U + Math.imul(W, Ue) | 0, z = z + Math.imul(te, yr) | 0, I = I + Math.imul(te, ke) | 0, I = I + Math.imul(ne, yr) | 0, U = U + Math.imul(ne, ke) | 0, z = z + Math.imul(se, xr) | 0, I = I + Math.imul(se, He) | 0, I = I + Math.imul(K, xr) | 0, U = U + Math.imul(K, He) | 0;
        var Jr = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (Jr >>> 26) | 0, Jr &= 67108863, z = Math.imul(ce, Se), I = Math.imul(ce, Me), I = I + Math.imul(le, Se) | 0, U = Math.imul(le, Me), z = z + Math.imul(Z, ae) | 0, I = I + Math.imul(Z, de) | 0, I = I + Math.imul(X, ae) | 0, U = U + Math.imul(X, de) | 0, z = z + Math.imul(j, Ne) | 0, I = I + Math.imul(j, Ee) | 0, I = I + Math.imul(re, Ne) | 0, U = U + Math.imul(re, Ee) | 0, z = z + Math.imul(L, dr) | 0, I = I + Math.imul(L, Le) | 0, I = I + Math.imul(P, dr) | 0, U = U + Math.imul(P, Le) | 0, z = z + Math.imul(pe, gr) | 0, I = I + Math.imul(pe, Ue) | 0, I = I + Math.imul(Y, gr) | 0, U = U + Math.imul(Y, Ue) | 0, z = z + Math.imul(V, yr) | 0, I = I + Math.imul(V, ke) | 0, I = I + Math.imul(W, yr) | 0, U = U + Math.imul(W, ke) | 0, z = z + Math.imul(te, xr) | 0, I = I + Math.imul(te, He) | 0, I = I + Math.imul(ne, xr) | 0, U = U + Math.imul(ne, He) | 0, z = z + Math.imul(se, Ar) | 0, I = I + Math.imul(se, Ge) | 0, I = I + Math.imul(K, Ar) | 0, U = U + Math.imul(K, Ge) | 0;
        var er = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (er >>> 26) | 0, er &= 67108863, z = Math.imul(ge, Se), I = Math.imul(ge, Me), I = I + Math.imul(me, Se) | 0, U = Math.imul(me, Me), z = z + Math.imul(ce, ae) | 0, I = I + Math.imul(ce, de) | 0, I = I + Math.imul(le, ae) | 0, U = U + Math.imul(le, de) | 0, z = z + Math.imul(Z, Ne) | 0, I = I + Math.imul(Z, Ee) | 0, I = I + Math.imul(X, Ne) | 0, U = U + Math.imul(X, Ee) | 0, z = z + Math.imul(j, dr) | 0, I = I + Math.imul(j, Le) | 0, I = I + Math.imul(re, dr) | 0, U = U + Math.imul(re, Le) | 0, z = z + Math.imul(L, gr) | 0, I = I + Math.imul(L, Ue) | 0, I = I + Math.imul(P, gr) | 0, U = U + Math.imul(P, Ue) | 0, z = z + Math.imul(pe, yr) | 0, I = I + Math.imul(pe, ke) | 0, I = I + Math.imul(Y, yr) | 0, U = U + Math.imul(Y, ke) | 0, z = z + Math.imul(V, xr) | 0, I = I + Math.imul(V, He) | 0, I = I + Math.imul(W, xr) | 0, U = U + Math.imul(W, He) | 0, z = z + Math.imul(te, Ar) | 0, I = I + Math.imul(te, Ge) | 0, I = I + Math.imul(ne, Ar) | 0, U = U + Math.imul(ne, Ge) | 0, z = z + Math.imul(se, Dr) | 0, I = I + Math.imul(se, Ve) | 0, I = I + Math.imul(K, Dr) | 0, U = U + Math.imul(K, Ve) | 0;
        var _r = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (_r >>> 26) | 0, _r &= 67108863, z = Math.imul(be, Se), I = Math.imul(be, Me), I = I + Math.imul(Ae, Se) | 0, U = Math.imul(Ae, Me), z = z + Math.imul(ge, ae) | 0, I = I + Math.imul(ge, de) | 0, I = I + Math.imul(me, ae) | 0, U = U + Math.imul(me, de) | 0, z = z + Math.imul(ce, Ne) | 0, I = I + Math.imul(ce, Ee) | 0, I = I + Math.imul(le, Ne) | 0, U = U + Math.imul(le, Ee) | 0, z = z + Math.imul(Z, dr) | 0, I = I + Math.imul(Z, Le) | 0, I = I + Math.imul(X, dr) | 0, U = U + Math.imul(X, Le) | 0, z = z + Math.imul(j, gr) | 0, I = I + Math.imul(j, Ue) | 0, I = I + Math.imul(re, gr) | 0, U = U + Math.imul(re, Ue) | 0, z = z + Math.imul(L, yr) | 0, I = I + Math.imul(L, ke) | 0, I = I + Math.imul(P, yr) | 0, U = U + Math.imul(P, ke) | 0, z = z + Math.imul(pe, xr) | 0, I = I + Math.imul(pe, He) | 0, I = I + Math.imul(Y, xr) | 0, U = U + Math.imul(Y, He) | 0, z = z + Math.imul(V, Ar) | 0, I = I + Math.imul(V, Ge) | 0, I = I + Math.imul(W, Ar) | 0, U = U + Math.imul(W, Ge) | 0, z = z + Math.imul(te, Dr) | 0, I = I + Math.imul(te, Ve) | 0, I = I + Math.imul(ne, Dr) | 0, U = U + Math.imul(ne, Ve) | 0, z = z + Math.imul(se, pr) | 0, I = I + Math.imul(se, vr) | 0, I = I + Math.imul(K, pr) | 0, U = U + Math.imul(K, vr) | 0;
        var Rt = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (Rt >>> 26) | 0, Rt &= 67108863, z = Math.imul(be, ae), I = Math.imul(be, de), I = I + Math.imul(Ae, ae) | 0, U = Math.imul(Ae, de), z = z + Math.imul(ge, Ne) | 0, I = I + Math.imul(ge, Ee) | 0, I = I + Math.imul(me, Ne) | 0, U = U + Math.imul(me, Ee) | 0, z = z + Math.imul(ce, dr) | 0, I = I + Math.imul(ce, Le) | 0, I = I + Math.imul(le, dr) | 0, U = U + Math.imul(le, Le) | 0, z = z + Math.imul(Z, gr) | 0, I = I + Math.imul(Z, Ue) | 0, I = I + Math.imul(X, gr) | 0, U = U + Math.imul(X, Ue) | 0, z = z + Math.imul(j, yr) | 0, I = I + Math.imul(j, ke) | 0, I = I + Math.imul(re, yr) | 0, U = U + Math.imul(re, ke) | 0, z = z + Math.imul(L, xr) | 0, I = I + Math.imul(L, He) | 0, I = I + Math.imul(P, xr) | 0, U = U + Math.imul(P, He) | 0, z = z + Math.imul(pe, Ar) | 0, I = I + Math.imul(pe, Ge) | 0, I = I + Math.imul(Y, Ar) | 0, U = U + Math.imul(Y, Ge) | 0, z = z + Math.imul(V, Dr) | 0, I = I + Math.imul(V, Ve) | 0, I = I + Math.imul(W, Dr) | 0, U = U + Math.imul(W, Ve) | 0, z = z + Math.imul(te, pr) | 0, I = I + Math.imul(te, vr) | 0, I = I + Math.imul(ne, pr) | 0, U = U + Math.imul(ne, vr) | 0;
        var at = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (at >>> 26) | 0, at &= 67108863, z = Math.imul(be, Ne), I = Math.imul(be, Ee), I = I + Math.imul(Ae, Ne) | 0, U = Math.imul(Ae, Ee), z = z + Math.imul(ge, dr) | 0, I = I + Math.imul(ge, Le) | 0, I = I + Math.imul(me, dr) | 0, U = U + Math.imul(me, Le) | 0, z = z + Math.imul(ce, gr) | 0, I = I + Math.imul(ce, Ue) | 0, I = I + Math.imul(le, gr) | 0, U = U + Math.imul(le, Ue) | 0, z = z + Math.imul(Z, yr) | 0, I = I + Math.imul(Z, ke) | 0, I = I + Math.imul(X, yr) | 0, U = U + Math.imul(X, ke) | 0, z = z + Math.imul(j, xr) | 0, I = I + Math.imul(j, He) | 0, I = I + Math.imul(re, xr) | 0, U = U + Math.imul(re, He) | 0, z = z + Math.imul(L, Ar) | 0, I = I + Math.imul(L, Ge) | 0, I = I + Math.imul(P, Ar) | 0, U = U + Math.imul(P, Ge) | 0, z = z + Math.imul(pe, Dr) | 0, I = I + Math.imul(pe, Ve) | 0, I = I + Math.imul(Y, Dr) | 0, U = U + Math.imul(Y, Ve) | 0, z = z + Math.imul(V, pr) | 0, I = I + Math.imul(V, vr) | 0, I = I + Math.imul(W, pr) | 0, U = U + Math.imul(W, vr) | 0;
        var Qr = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (Qr >>> 26) | 0, Qr &= 67108863, z = Math.imul(be, dr), I = Math.imul(be, Le), I = I + Math.imul(Ae, dr) | 0, U = Math.imul(Ae, Le), z = z + Math.imul(ge, gr) | 0, I = I + Math.imul(ge, Ue) | 0, I = I + Math.imul(me, gr) | 0, U = U + Math.imul(me, Ue) | 0, z = z + Math.imul(ce, yr) | 0, I = I + Math.imul(ce, ke) | 0, I = I + Math.imul(le, yr) | 0, U = U + Math.imul(le, ke) | 0, z = z + Math.imul(Z, xr) | 0, I = I + Math.imul(Z, He) | 0, I = I + Math.imul(X, xr) | 0, U = U + Math.imul(X, He) | 0, z = z + Math.imul(j, Ar) | 0, I = I + Math.imul(j, Ge) | 0, I = I + Math.imul(re, Ar) | 0, U = U + Math.imul(re, Ge) | 0, z = z + Math.imul(L, Dr) | 0, I = I + Math.imul(L, Ve) | 0, I = I + Math.imul(P, Dr) | 0, U = U + Math.imul(P, Ve) | 0, z = z + Math.imul(pe, pr) | 0, I = I + Math.imul(pe, vr) | 0, I = I + Math.imul(Y, pr) | 0, U = U + Math.imul(Y, vr) | 0;
        var Pt = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, z = Math.imul(be, gr), I = Math.imul(be, Ue), I = I + Math.imul(Ae, gr) | 0, U = Math.imul(Ae, Ue), z = z + Math.imul(ge, yr) | 0, I = I + Math.imul(ge, ke) | 0, I = I + Math.imul(me, yr) | 0, U = U + Math.imul(me, ke) | 0, z = z + Math.imul(ce, xr) | 0, I = I + Math.imul(ce, He) | 0, I = I + Math.imul(le, xr) | 0, U = U + Math.imul(le, He) | 0, z = z + Math.imul(Z, Ar) | 0, I = I + Math.imul(Z, Ge) | 0, I = I + Math.imul(X, Ar) | 0, U = U + Math.imul(X, Ge) | 0, z = z + Math.imul(j, Dr) | 0, I = I + Math.imul(j, Ve) | 0, I = I + Math.imul(re, Dr) | 0, U = U + Math.imul(re, Ve) | 0, z = z + Math.imul(L, pr) | 0, I = I + Math.imul(L, vr) | 0, I = I + Math.imul(P, pr) | 0, U = U + Math.imul(P, vr) | 0;
        var dn = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (dn >>> 26) | 0, dn &= 67108863, z = Math.imul(be, yr), I = Math.imul(be, ke), I = I + Math.imul(Ae, yr) | 0, U = Math.imul(Ae, ke), z = z + Math.imul(ge, xr) | 0, I = I + Math.imul(ge, He) | 0, I = I + Math.imul(me, xr) | 0, U = U + Math.imul(me, He) | 0, z = z + Math.imul(ce, Ar) | 0, I = I + Math.imul(ce, Ge) | 0, I = I + Math.imul(le, Ar) | 0, U = U + Math.imul(le, Ge) | 0, z = z + Math.imul(Z, Dr) | 0, I = I + Math.imul(Z, Ve) | 0, I = I + Math.imul(X, Dr) | 0, U = U + Math.imul(X, Ve) | 0, z = z + Math.imul(j, pr) | 0, I = I + Math.imul(j, vr) | 0, I = I + Math.imul(re, pr) | 0, U = U + Math.imul(re, vr) | 0;
        var hn = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (hn >>> 26) | 0, hn &= 67108863, z = Math.imul(be, xr), I = Math.imul(be, He), I = I + Math.imul(Ae, xr) | 0, U = Math.imul(Ae, He), z = z + Math.imul(ge, Ar) | 0, I = I + Math.imul(ge, Ge) | 0, I = I + Math.imul(me, Ar) | 0, U = U + Math.imul(me, Ge) | 0, z = z + Math.imul(ce, Dr) | 0, I = I + Math.imul(ce, Ve) | 0, I = I + Math.imul(le, Dr) | 0, U = U + Math.imul(le, Ve) | 0, z = z + Math.imul(Z, pr) | 0, I = I + Math.imul(Z, vr) | 0, I = I + Math.imul(X, pr) | 0, U = U + Math.imul(X, vr) | 0;
        var pn = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (pn >>> 26) | 0, pn &= 67108863, z = Math.imul(be, Ar), I = Math.imul(be, Ge), I = I + Math.imul(Ae, Ar) | 0, U = Math.imul(Ae, Ge), z = z + Math.imul(ge, Dr) | 0, I = I + Math.imul(ge, Ve) | 0, I = I + Math.imul(me, Dr) | 0, U = U + Math.imul(me, Ve) | 0, z = z + Math.imul(ce, pr) | 0, I = I + Math.imul(ce, vr) | 0, I = I + Math.imul(le, pr) | 0, U = U + Math.imul(le, vr) | 0;
        var vn = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (vn >>> 26) | 0, vn &= 67108863, z = Math.imul(be, Dr), I = Math.imul(be, Ve), I = I + Math.imul(Ae, Dr) | 0, U = Math.imul(Ae, Ve), z = z + Math.imul(ge, pr) | 0, I = I + Math.imul(ge, vr) | 0, I = I + Math.imul(me, pr) | 0, U = U + Math.imul(me, vr) | 0;
        var mo = (T + z | 0) + ((I & 8191) << 13) | 0;
        T = (U + (I >>> 13) | 0) + (mo >>> 26) | 0, mo &= 67108863, z = Math.imul(be, pr), I = Math.imul(be, vr), I = I + Math.imul(Ae, pr) | 0, U = Math.imul(Ae, vr);
        var go = (T + z | 0) + ((I & 8191) << 13) | 0;
        return T = (U + (I >>> 13) | 0) + (go >>> 26) | 0, go &= 67108863, C[0] = Ct, C[1] = Tt, C[2] = Bt, C[3] = Ft, C[4] = It, C[5] = Ot, C[6] = Jr, C[7] = er, C[8] = _r, C[9] = Rt, C[10] = at, C[11] = Qr, C[12] = Pt, C[13] = dn, C[14] = hn, C[15] = pn, C[16] = vn, C[17] = mo, C[18] = go, T !== 0 && (C[19] = T, M.length++), M;
      };
      Math.imul || (x = m);
      function y(A, b, D) {
        D.negative = b.negative ^ A.negative, D.length = A.length + b.length;
        for (var M = 0, _ = 0, q = 0; q < D.length - 1; q++) {
          var C = _;
          _ = 0;
          for (var T = M & 67108863, z = Math.min(q, b.length - 1), I = Math.max(0, q - A.length + 1); I <= z; I++) {
            var U = q - I, ee = A.words[U] | 0, se = b.words[I] | 0, K = ee * se, J = K & 67108863;
            C = C + (K / 67108864 | 0) | 0, J = J + T | 0, T = J & 67108863, C = C + (J >>> 26) | 0, _ += C >>> 26, C &= 67108863;
          }
          D.words[q] = T, M = C, C = _;
        }
        return M !== 0 ? D.words[q] = M : D.length--, D._strip();
      }
      function E(A, b, D) {
        return y(A, b, D);
      }
      t.prototype.mulTo = function(b, D) {
        var M, _ = this.length + b.length;
        return this.length === 10 && b.length === 10 ? M = x(this, b, D) : _ < 63 ? M = m(this, b, D) : _ < 1024 ? M = y(this, b, D) : M = E(this, b, D), M;
      }, t.prototype.mul = function(b) {
        var D = new t(null);
        return D.words = new Array(this.length + b.length), this.mulTo(b, D);
      }, t.prototype.mulf = function(b) {
        var D = new t(null);
        return D.words = new Array(this.length + b.length), E(this, b, D);
      }, t.prototype.imul = function(b) {
        return this.clone().mulTo(b, this);
      }, t.prototype.imuln = function(b) {
        var D = b < 0;
        D && (b = -b), n(typeof b == "number"), n(b < 67108864);
        for (var M = 0, _ = 0; _ < this.length; _++) {
          var q = (this.words[_] | 0) * b, C = (q & 67108863) + (M & 67108863);
          M >>= 26, M += q / 67108864 | 0, M += C >>> 26, this.words[_] = C & 67108863;
        }
        return M !== 0 && (this.words[_] = M, this.length++), D ? this.ineg() : this;
      }, t.prototype.muln = function(b) {
        return this.clone().imuln(b);
      }, t.prototype.sqr = function() {
        return this.mul(this);
      }, t.prototype.isqr = function() {
        return this.imul(this.clone());
      }, t.prototype.pow = function(b) {
        var D = g(b);
        if (D.length === 0)
          return new t(1);
        for (var M = this, _ = 0; _ < D.length && D[_] === 0; _++, M = M.sqr())
          ;
        if (++_ < D.length)
          for (var q = M.sqr(); _ < D.length; _++, q = q.sqr())
            D[_] !== 0 && (M = M.mul(q));
        return M;
      }, t.prototype.iushln = function(b) {
        n(typeof b == "number" && b >= 0);
        var D = b % 26, M = (b - D) / 26, _ = 67108863 >>> 26 - D << 26 - D, q;
        if (D !== 0) {
          var C = 0;
          for (q = 0; q < this.length; q++) {
            var T = this.words[q] & _, z = (this.words[q] | 0) - T << D;
            this.words[q] = z | C, C = T >>> 26 - D;
          }
          C && (this.words[q] = C, this.length++);
        }
        if (M !== 0) {
          for (q = this.length - 1; q >= 0; q--)
            this.words[q + M] = this.words[q];
          for (q = 0; q < M; q++)
            this.words[q] = 0;
          this.length += M;
        }
        return this._strip();
      }, t.prototype.ishln = function(b) {
        return n(this.negative === 0), this.iushln(b);
      }, t.prototype.iushrn = function(b, D, M) {
        n(typeof b == "number" && b >= 0);
        var _;
        D ? _ = (D - D % 26) / 26 : _ = 0;
        var q = b % 26, C = Math.min((b - q) / 26, this.length), T = 67108863 ^ 67108863 >>> q << q, z = M;
        if (_ -= C, _ = Math.max(0, _), z) {
          for (var I = 0; I < C; I++)
            z.words[I] = this.words[I];
          z.length = C;
        }
        if (C !== 0)
          if (this.length > C)
            for (this.length -= C, I = 0; I < this.length; I++)
              this.words[I] = this.words[I + C];
          else
            this.words[0] = 0, this.length = 1;
        var U = 0;
        for (I = this.length - 1; I >= 0 && (U !== 0 || I >= _); I--) {
          var ee = this.words[I] | 0;
          this.words[I] = U << 26 - q | ee >>> q, U = ee & T;
        }
        return z && U !== 0 && (z.words[z.length++] = U), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
      }, t.prototype.ishrn = function(b, D, M) {
        return n(this.negative === 0), this.iushrn(b, D, M);
      }, t.prototype.shln = function(b) {
        return this.clone().ishln(b);
      }, t.prototype.ushln = function(b) {
        return this.clone().iushln(b);
      }, t.prototype.shrn = function(b) {
        return this.clone().ishrn(b);
      }, t.prototype.ushrn = function(b) {
        return this.clone().iushrn(b);
      }, t.prototype.testn = function(b) {
        n(typeof b == "number" && b >= 0);
        var D = b % 26, M = (b - D) / 26, _ = 1 << D;
        if (this.length <= M)
          return !1;
        var q = this.words[M];
        return !!(q & _);
      }, t.prototype.imaskn = function(b) {
        n(typeof b == "number" && b >= 0);
        var D = b % 26, M = (b - D) / 26;
        if (n(this.negative === 0, "imaskn works only with positive numbers"), this.length <= M)
          return this;
        if (D !== 0 && M++, this.length = Math.min(M, this.length), D !== 0) {
          var _ = 67108863 ^ 67108863 >>> D << D;
          this.words[this.length - 1] &= _;
        }
        return this._strip();
      }, t.prototype.maskn = function(b) {
        return this.clone().imaskn(b);
      }, t.prototype.iaddn = function(b) {
        return n(typeof b == "number"), n(b < 67108864), b < 0 ? this.isubn(-b) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= b ? (this.words[0] = b - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(b), this.negative = 1, this) : this._iaddn(b);
      }, t.prototype._iaddn = function(b) {
        this.words[0] += b;
        for (var D = 0; D < this.length && this.words[D] >= 67108864; D++)
          this.words[D] -= 67108864, D === this.length - 1 ? this.words[D + 1] = 1 : this.words[D + 1]++;
        return this.length = Math.max(this.length, D + 1), this;
      }, t.prototype.isubn = function(b) {
        if (n(typeof b == "number"), n(b < 67108864), b < 0)
          return this.iaddn(-b);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(b), this.negative = 1, this;
        if (this.words[0] -= b, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var D = 0; D < this.length && this.words[D] < 0; D++)
            this.words[D] += 67108864, this.words[D + 1] -= 1;
        return this._strip();
      }, t.prototype.addn = function(b) {
        return this.clone().iaddn(b);
      }, t.prototype.subn = function(b) {
        return this.clone().isubn(b);
      }, t.prototype.iabs = function() {
        return this.negative = 0, this;
      }, t.prototype.abs = function() {
        return this.clone().iabs();
      }, t.prototype._ishlnsubmul = function(b, D, M) {
        var _ = b.length + M, q;
        this._expand(_);
        var C, T = 0;
        for (q = 0; q < b.length; q++) {
          C = (this.words[q + M] | 0) + T;
          var z = (b.words[q] | 0) * D;
          C -= z & 67108863, T = (C >> 26) - (z / 67108864 | 0), this.words[q + M] = C & 67108863;
        }
        for (; q < this.length - M; q++)
          C = (this.words[q + M] | 0) + T, T = C >> 26, this.words[q + M] = C & 67108863;
        if (T === 0)
          return this._strip();
        for (n(T === -1), T = 0, q = 0; q < this.length; q++)
          C = -(this.words[q] | 0) + T, T = C >> 26, this.words[q] = C & 67108863;
        return this.negative = 1, this._strip();
      }, t.prototype._wordDiv = function(b, D) {
        var M = this.length - b.length, _ = this.clone(), q = b, C = q.words[q.length - 1] | 0, T = this._countBits(C);
        M = 26 - T, M !== 0 && (q = q.ushln(M), _.iushln(M), C = q.words[q.length - 1] | 0);
        var z = _.length - q.length, I;
        if (D !== "mod") {
          I = new t(null), I.length = z + 1, I.words = new Array(I.length);
          for (var U = 0; U < I.length; U++)
            I.words[U] = 0;
        }
        var ee = _.clone()._ishlnsubmul(q, 1, z);
        ee.negative === 0 && (_ = ee, I && (I.words[z] = 1));
        for (var se = z - 1; se >= 0; se--) {
          var K = (_.words[q.length + se] | 0) * 67108864 + (_.words[q.length + se - 1] | 0);
          for (K = Math.min(K / C | 0, 67108863), _._ishlnsubmul(q, K, se); _.negative !== 0; )
            K--, _.negative = 0, _._ishlnsubmul(q, 1, se), _.isZero() || (_.negative ^= 1);
          I && (I.words[se] = K);
        }
        return I && I._strip(), _._strip(), D !== "div" && M !== 0 && _.iushrn(M), {
          div: I || null,
          mod: _
        };
      }, t.prototype.divmod = function(b, D, M) {
        if (n(!b.isZero()), this.isZero())
          return {
            div: new t(0),
            mod: new t(0)
          };
        var _, q, C;
        return this.negative !== 0 && b.negative === 0 ? (C = this.neg().divmod(b, D), D !== "mod" && (_ = C.div.neg()), D !== "div" && (q = C.mod.neg(), M && q.negative !== 0 && q.iadd(b)), {
          div: _,
          mod: q
        }) : this.negative === 0 && b.negative !== 0 ? (C = this.divmod(b.neg(), D), D !== "mod" && (_ = C.div.neg()), {
          div: _,
          mod: C.mod
        }) : this.negative & b.negative ? (C = this.neg().divmod(b.neg(), D), D !== "div" && (q = C.mod.neg(), M && q.negative !== 0 && q.isub(b)), {
          div: C.div,
          mod: q
        }) : b.length > this.length || this.cmp(b) < 0 ? {
          div: new t(0),
          mod: this
        } : b.length === 1 ? D === "div" ? {
          div: this.divn(b.words[0]),
          mod: null
        } : D === "mod" ? {
          div: null,
          mod: new t(this.modrn(b.words[0]))
        } : {
          div: this.divn(b.words[0]),
          mod: new t(this.modrn(b.words[0]))
        } : this._wordDiv(b, D);
      }, t.prototype.div = function(b) {
        return this.divmod(b, "div", !1).div;
      }, t.prototype.mod = function(b) {
        return this.divmod(b, "mod", !1).mod;
      }, t.prototype.umod = function(b) {
        return this.divmod(b, "mod", !0).mod;
      }, t.prototype.divRound = function(b) {
        var D = this.divmod(b);
        if (D.mod.isZero())
          return D.div;
        var M = D.div.negative !== 0 ? D.mod.isub(b) : D.mod, _ = b.ushrn(1), q = b.andln(1), C = M.cmp(_);
        return C < 0 || q === 1 && C === 0 ? D.div : D.div.negative !== 0 ? D.div.isubn(1) : D.div.iaddn(1);
      }, t.prototype.modrn = function(b) {
        var D = b < 0;
        D && (b = -b), n(b <= 67108863);
        for (var M = (1 << 26) % b, _ = 0, q = this.length - 1; q >= 0; q--)
          _ = (M * _ + (this.words[q] | 0)) % b;
        return D ? -_ : _;
      }, t.prototype.modn = function(b) {
        return this.modrn(b);
      }, t.prototype.idivn = function(b) {
        var D = b < 0;
        D && (b = -b), n(b <= 67108863);
        for (var M = 0, _ = this.length - 1; _ >= 0; _--) {
          var q = (this.words[_] | 0) + M * 67108864;
          this.words[_] = q / b | 0, M = q % b;
        }
        return this._strip(), D ? this.ineg() : this;
      }, t.prototype.divn = function(b) {
        return this.clone().idivn(b);
      }, t.prototype.egcd = function(b) {
        n(b.negative === 0), n(!b.isZero());
        var D = this, M = b.clone();
        D.negative !== 0 ? D = D.umod(b) : D = D.clone();
        for (var _ = new t(1), q = new t(0), C = new t(0), T = new t(1), z = 0; D.isEven() && M.isEven(); )
          D.iushrn(1), M.iushrn(1), ++z;
        for (var I = M.clone(), U = D.clone(); !D.isZero(); ) {
          for (var ee = 0, se = 1; !(D.words[0] & se) && ee < 26; ++ee, se <<= 1)
            ;
          if (ee > 0)
            for (D.iushrn(ee); ee-- > 0; )
              (_.isOdd() || q.isOdd()) && (_.iadd(I), q.isub(U)), _.iushrn(1), q.iushrn(1);
          for (var K = 0, J = 1; !(M.words[0] & J) && K < 26; ++K, J <<= 1)
            ;
          if (K > 0)
            for (M.iushrn(K); K-- > 0; )
              (C.isOdd() || T.isOdd()) && (C.iadd(I), T.isub(U)), C.iushrn(1), T.iushrn(1);
          D.cmp(M) >= 0 ? (D.isub(M), _.isub(C), q.isub(T)) : (M.isub(D), C.isub(_), T.isub(q));
        }
        return {
          a: C,
          b: T,
          gcd: M.iushln(z)
        };
      }, t.prototype._invmp = function(b) {
        n(b.negative === 0), n(!b.isZero());
        var D = this, M = b.clone();
        D.negative !== 0 ? D = D.umod(b) : D = D.clone();
        for (var _ = new t(1), q = new t(0), C = M.clone(); D.cmpn(1) > 0 && M.cmpn(1) > 0; ) {
          for (var T = 0, z = 1; !(D.words[0] & z) && T < 26; ++T, z <<= 1)
            ;
          if (T > 0)
            for (D.iushrn(T); T-- > 0; )
              _.isOdd() && _.iadd(C), _.iushrn(1);
          for (var I = 0, U = 1; !(M.words[0] & U) && I < 26; ++I, U <<= 1)
            ;
          if (I > 0)
            for (M.iushrn(I); I-- > 0; )
              q.isOdd() && q.iadd(C), q.iushrn(1);
          D.cmp(M) >= 0 ? (D.isub(M), _.isub(q)) : (M.isub(D), q.isub(_));
        }
        var ee;
        return D.cmpn(1) === 0 ? ee = _ : ee = q, ee.cmpn(0) < 0 && ee.iadd(b), ee;
      }, t.prototype.gcd = function(b) {
        if (this.isZero())
          return b.abs();
        if (b.isZero())
          return this.abs();
        var D = this.clone(), M = b.clone();
        D.negative = 0, M.negative = 0;
        for (var _ = 0; D.isEven() && M.isEven(); _++)
          D.iushrn(1), M.iushrn(1);
        do {
          for (; D.isEven(); )
            D.iushrn(1);
          for (; M.isEven(); )
            M.iushrn(1);
          var q = D.cmp(M);
          if (q < 0) {
            var C = D;
            D = M, M = C;
          } else if (q === 0 || M.cmpn(1) === 0)
            break;
          D.isub(M);
        } while (!0);
        return M.iushln(_);
      }, t.prototype.invm = function(b) {
        return this.egcd(b).a.umod(b);
      }, t.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, t.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, t.prototype.andln = function(b) {
        return this.words[0] & b;
      }, t.prototype.bincn = function(b) {
        n(typeof b == "number");
        var D = b % 26, M = (b - D) / 26, _ = 1 << D;
        if (this.length <= M)
          return this._expand(M + 1), this.words[M] |= _, this;
        for (var q = _, C = M; q !== 0 && C < this.length; C++) {
          var T = this.words[C] | 0;
          T += q, q = T >>> 26, T &= 67108863, this.words[C] = T;
        }
        return q !== 0 && (this.words[C] = q, this.length++), this;
      }, t.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, t.prototype.cmpn = function(b) {
        var D = b < 0;
        if (this.negative !== 0 && !D)
          return -1;
        if (this.negative === 0 && D)
          return 1;
        this._strip();
        var M;
        if (this.length > 1)
          M = 1;
        else {
          D && (b = -b), n(b <= 67108863, "Number is too big");
          var _ = this.words[0] | 0;
          M = _ === b ? 0 : _ < b ? -1 : 1;
        }
        return this.negative !== 0 ? -M | 0 : M;
      }, t.prototype.cmp = function(b) {
        if (this.negative !== 0 && b.negative === 0)
          return -1;
        if (this.negative === 0 && b.negative !== 0)
          return 1;
        var D = this.ucmp(b);
        return this.negative !== 0 ? -D | 0 : D;
      }, t.prototype.ucmp = function(b) {
        if (this.length > b.length)
          return 1;
        if (this.length < b.length)
          return -1;
        for (var D = 0, M = this.length - 1; M >= 0; M--) {
          var _ = this.words[M] | 0, q = b.words[M] | 0;
          if (_ !== q) {
            _ < q ? D = -1 : _ > q && (D = 1);
            break;
          }
        }
        return D;
      }, t.prototype.gtn = function(b) {
        return this.cmpn(b) === 1;
      }, t.prototype.gt = function(b) {
        return this.cmp(b) === 1;
      }, t.prototype.gten = function(b) {
        return this.cmpn(b) >= 0;
      }, t.prototype.gte = function(b) {
        return this.cmp(b) >= 0;
      }, t.prototype.ltn = function(b) {
        return this.cmpn(b) === -1;
      }, t.prototype.lt = function(b) {
        return this.cmp(b) === -1;
      }, t.prototype.lten = function(b) {
        return this.cmpn(b) <= 0;
      }, t.prototype.lte = function(b) {
        return this.cmp(b) <= 0;
      }, t.prototype.eqn = function(b) {
        return this.cmpn(b) === 0;
      }, t.prototype.eq = function(b) {
        return this.cmp(b) === 0;
      }, t.red = function(b) {
        return new F(b);
      }, t.prototype.toRed = function(b) {
        return n(!this.red, "Already a number in reduction context"), n(this.negative === 0, "red works only with positives"), b.convertTo(this)._forceRed(b);
      }, t.prototype.fromRed = function() {
        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, t.prototype._forceRed = function(b) {
        return this.red = b, this;
      }, t.prototype.forceRed = function(b) {
        return n(!this.red, "Already a number in reduction context"), this._forceRed(b);
      }, t.prototype.redAdd = function(b) {
        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, b);
      }, t.prototype.redIAdd = function(b) {
        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, b);
      }, t.prototype.redSub = function(b) {
        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, b);
      }, t.prototype.redISub = function(b) {
        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, b);
      }, t.prototype.redShl = function(b) {
        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, b);
      }, t.prototype.redMul = function(b) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, b), this.red.mul(this, b);
      }, t.prototype.redIMul = function(b) {
        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, b), this.red.imul(this, b);
      }, t.prototype.redSqr = function() {
        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, t.prototype.redISqr = function() {
        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, t.prototype.redSqrt = function() {
        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, t.prototype.redInvm = function() {
        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, t.prototype.redNeg = function() {
        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, t.prototype.redPow = function(b) {
        return n(this.red && !b.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, b);
      };
      var N = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function S(A, b) {
        this.name = A, this.p = new t(b, 16), this.n = this.p.bitLength(), this.k = new t(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      S.prototype._tmp = function() {
        var b = new t(null);
        return b.words = new Array(Math.ceil(this.n / 13)), b;
      }, S.prototype.ireduce = function(b) {
        var D = b, M;
        do
          this.split(D, this.tmp), D = this.imulK(D), D = D.iadd(this.tmp), M = D.bitLength();
        while (M > this.n);
        var _ = M < this.n ? -1 : D.ucmp(this.p);
        return _ === 0 ? (D.words[0] = 0, D.length = 1) : _ > 0 ? D.isub(this.p) : D.strip !== void 0 ? D.strip() : D._strip(), D;
      }, S.prototype.split = function(b, D) {
        b.iushrn(this.n, 0, D);
      }, S.prototype.imulK = function(b) {
        return b.imul(this.k);
      };
      function R() {
        S.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      i(R, S), R.prototype.split = function(b, D) {
        for (var M = 4194303, _ = Math.min(b.length, 9), q = 0; q < _; q++)
          D.words[q] = b.words[q];
        if (D.length = _, b.length <= 9) {
          b.words[0] = 0, b.length = 1;
          return;
        }
        var C = b.words[9];
        for (D.words[D.length++] = C & M, q = 10; q < b.length; q++) {
          var T = b.words[q] | 0;
          b.words[q - 10] = (T & M) << 4 | C >>> 22, C = T;
        }
        C >>>= 22, b.words[q - 10] = C, C === 0 && b.length > 10 ? b.length -= 10 : b.length -= 9;
      }, R.prototype.imulK = function(b) {
        b.words[b.length] = 0, b.words[b.length + 1] = 0, b.length += 2;
        for (var D = 0, M = 0; M < b.length; M++) {
          var _ = b.words[M] | 0;
          D += _ * 977, b.words[M] = D & 67108863, D = _ * 64 + (D / 67108864 | 0);
        }
        return b.words[b.length - 1] === 0 && (b.length--, b.words[b.length - 1] === 0 && b.length--), b;
      };
      function O() {
        S.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      i(O, S);
      function B() {
        S.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      i(B, S);
      function $() {
        S.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      i($, S), $.prototype.imulK = function(b) {
        for (var D = 0, M = 0; M < b.length; M++) {
          var _ = (b.words[M] | 0) * 19 + D, q = _ & 67108863;
          _ >>>= 26, b.words[M] = q, D = _;
        }
        return D !== 0 && (b.words[b.length++] = D), b;
      }, t._prime = function(b) {
        if (N[b])
          return N[b];
        var D;
        if (b === "k256")
          D = new R();
        else if (b === "p224")
          D = new O();
        else if (b === "p192")
          D = new B();
        else if (b === "p25519")
          D = new $();
        else
          throw new Error("Unknown prime " + b);
        return N[b] = D, D;
      };
      function F(A) {
        if (typeof A == "string") {
          var b = t._prime(A);
          this.m = b.p, this.prime = b;
        } else
          n(A.gtn(1), "modulus must be greater than 1"), this.m = A, this.prime = null;
      }
      F.prototype._verify1 = function(b) {
        n(b.negative === 0, "red works only with positives"), n(b.red, "red works only with red numbers");
      }, F.prototype._verify2 = function(b, D) {
        n((b.negative | D.negative) === 0, "red works only with positives"), n(
          b.red && b.red === D.red,
          "red works only with red numbers"
        );
      }, F.prototype.imod = function(b) {
        return this.prime ? this.prime.ireduce(b)._forceRed(this) : (a(b, b.umod(this.m)._forceRed(this)), b);
      }, F.prototype.neg = function(b) {
        return b.isZero() ? b.clone() : this.m.sub(b)._forceRed(this);
      }, F.prototype.add = function(b, D) {
        this._verify2(b, D);
        var M = b.add(D);
        return M.cmp(this.m) >= 0 && M.isub(this.m), M._forceRed(this);
      }, F.prototype.iadd = function(b, D) {
        this._verify2(b, D);
        var M = b.iadd(D);
        return M.cmp(this.m) >= 0 && M.isub(this.m), M;
      }, F.prototype.sub = function(b, D) {
        this._verify2(b, D);
        var M = b.sub(D);
        return M.cmpn(0) < 0 && M.iadd(this.m), M._forceRed(this);
      }, F.prototype.isub = function(b, D) {
        this._verify2(b, D);
        var M = b.isub(D);
        return M.cmpn(0) < 0 && M.iadd(this.m), M;
      }, F.prototype.shl = function(b, D) {
        return this._verify1(b), this.imod(b.ushln(D));
      }, F.prototype.imul = function(b, D) {
        return this._verify2(b, D), this.imod(b.imul(D));
      }, F.prototype.mul = function(b, D) {
        return this._verify2(b, D), this.imod(b.mul(D));
      }, F.prototype.isqr = function(b) {
        return this.imul(b, b.clone());
      }, F.prototype.sqr = function(b) {
        return this.mul(b, b);
      }, F.prototype.sqrt = function(b) {
        if (b.isZero())
          return b.clone();
        var D = this.m.andln(3);
        if (n(D % 2 === 1), D === 3) {
          var M = this.m.add(new t(1)).iushrn(2);
          return this.pow(b, M);
        }
        for (var _ = this.m.subn(1), q = 0; !_.isZero() && _.andln(1) === 0; )
          q++, _.iushrn(1);
        n(!_.isZero());
        var C = new t(1).toRed(this), T = C.redNeg(), z = this.m.subn(1).iushrn(1), I = this.m.bitLength();
        for (I = new t(2 * I * I).toRed(this); this.pow(I, z).cmp(T) !== 0; )
          I.redIAdd(T);
        for (var U = this.pow(I, _), ee = this.pow(b, _.addn(1).iushrn(1)), se = this.pow(b, _), K = q; se.cmp(C) !== 0; ) {
          for (var J = se, te = 0; J.cmp(C) !== 0; te++)
            J = J.redSqr();
          n(te < K);
          var ne = this.pow(U, new t(1).iushln(K - te - 1));
          ee = ee.redMul(ne), U = ne.redSqr(), se = se.redMul(U), K = te;
        }
        return ee;
      }, F.prototype.invm = function(b) {
        var D = b._invmp(this.m);
        return D.negative !== 0 ? (D.negative = 0, this.imod(D).redNeg()) : this.imod(D);
      }, F.prototype.pow = function(b, D) {
        if (D.isZero())
          return new t(1).toRed(this);
        if (D.cmpn(1) === 0)
          return b.clone();
        var M = 4, _ = new Array(1 << M);
        _[0] = new t(1).toRed(this), _[1] = b;
        for (var q = 2; q < _.length; q++)
          _[q] = this.mul(_[q - 1], b);
        var C = _[0], T = 0, z = 0, I = D.bitLength() % 26;
        for (I === 0 && (I = 26), q = D.length - 1; q >= 0; q--) {
          for (var U = D.words[q], ee = I - 1; ee >= 0; ee--) {
            var se = U >> ee & 1;
            if (C !== _[0] && (C = this.sqr(C)), se === 0 && T === 0) {
              z = 0;
              continue;
            }
            T <<= 1, T |= se, z++, !(z !== M && (q !== 0 || ee !== 0)) && (C = this.mul(C, _[T]), z = 0, T = 0);
          }
          I = 26;
        }
        return C;
      }, F.prototype.convertTo = function(b) {
        var D = b.umod(this.m);
        return D === b ? D.clone() : D;
      }, F.prototype.convertFrom = function(b) {
        var D = b.clone();
        return D.red = null, D;
      }, t.mont = function(b) {
        return new w(b);
      };
      function w(A) {
        F.call(this, A), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new t(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      i(w, F), w.prototype.convertTo = function(b) {
        return this.imod(b.ushln(this.shift));
      }, w.prototype.convertFrom = function(b) {
        var D = this.imod(b.mul(this.rinv));
        return D.red = null, D;
      }, w.prototype.imul = function(b, D) {
        if (b.isZero() || D.isZero())
          return b.words[0] = 0, b.length = 1, b;
        var M = b.imul(D), _ = M.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), q = M.isub(_).iushrn(this.shift), C = q;
        return q.cmp(this.m) >= 0 ? C = q.isub(this.m) : q.cmpn(0) < 0 && (C = q.iadd(this.m)), C._forceRed(this);
      }, w.prototype.mul = function(b, D) {
        if (b.isZero() || D.isZero())
          return new t(0)._forceRed(this);
        var M = b.mul(D), _ = M.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), q = M.isub(_).iushrn(this.shift), C = q;
        return q.cmp(this.m) >= 0 ? C = q.isub(this.m) : q.cmpn(0) < 0 && (C = q.iadd(this.m)), C._forceRed(this);
      }, w.prototype.invm = function(b) {
        var D = this.imod(b._invmp(this.m).mul(this.r2));
        return D._forceRed(this);
      };
    })(e, Xe);
  }(xa)), xa.exports;
}
var Is, fv;
function ic() {
  if (fv)
    return Is;
  fv = 1;
  var e = nc(), r = ni();
  function o(t) {
    var u = n(t), l = u.toRed(e.mont(t.modulus)).redPow(new e(t.publicExponent)).fromRed();
    return { blinder: l, unblinder: u.invm(t.modulus) };
  }
  function n(t) {
    var u = t.modulus.byteLength(), l;
    do
      l = new e(r(u));
    while (l.cmp(t.modulus) >= 0 || !l.umod(t.prime1) || !l.umod(t.prime2));
    return l;
  }
  function i(t, u) {
    var l = o(u), f = u.modulus.byteLength(), s = new e(t).mul(l.blinder).umod(u.modulus), a = s.toRed(e.mont(u.prime1)), c = s.toRed(e.mont(u.prime2)), d = u.coefficient, h = u.prime1, p = u.prime2, v = a.redPow(u.exponent1).fromRed(), g = c.redPow(u.exponent2).fromRed(), m = v.isub(g).imul(d).umod(h).imul(p);
    return g.iadd(m).imul(l.unblinder).umod(u.modulus).toArrayLike(Buffer, "be", f);
  }
  return i.getr = n, Is = i, Is;
}
var Os = {};
const cB = "elliptic", lB = "6.5.4", dB = "EC cryptography", hB = "lib/elliptic.js", pB = [
  "lib"
], vB = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, mB = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, gB = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], bB = "Fedor Indutny <fedor@indutny.com>", yB = "MIT", wB = {
  url: "https://github.com/indutny/elliptic/issues"
}, xB = "https://github.com/indutny/elliptic", EB = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, AB = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, SB = {
  name: cB,
  version: lB,
  description: dB,
  main: hB,
  files: pB,
  scripts: vB,
  repository: mB,
  keywords: gB,
  author: bB,
  license: yB,
  bugs: wB,
  homepage: xB,
  devDependencies: EB,
  dependencies: AB
};
var Rs = {}, Ps = {}, cv;
function Vb() {
  return cv || (cv = 1, function(e) {
    var r = e;
    function o(t, u) {
      if (Array.isArray(t))
        return t.slice();
      if (!t)
        return [];
      var l = [];
      if (typeof t != "string") {
        for (var f = 0; f < t.length; f++)
          l[f] = t[f] | 0;
        return l;
      }
      if (u === "hex") {
        t = t.replace(/[^a-z0-9]+/ig, ""), t.length % 2 !== 0 && (t = "0" + t);
        for (var f = 0; f < t.length; f += 2)
          l.push(parseInt(t[f] + t[f + 1], 16));
      } else
        for (var f = 0; f < t.length; f++) {
          var s = t.charCodeAt(f), a = s >> 8, c = s & 255;
          a ? l.push(a, c) : l.push(c);
        }
      return l;
    }
    r.toArray = o;
    function n(t) {
      return t.length === 1 ? "0" + t : t;
    }
    r.zero2 = n;
    function i(t) {
      for (var u = "", l = 0; l < t.length; l++)
        u += n(t[l].toString(16));
      return u;
    }
    r.toHex = i, r.encode = function(u, l) {
      return l === "hex" ? i(u) : u;
    };
  }(Ps)), Ps;
}
var lv;
function pt() {
  return lv || (lv = 1, function(e) {
    var r = e, o = Rr(), n = ht(), i = Vb();
    r.assert = n, r.toArray = i.toArray, r.zero2 = i.zero2, r.toHex = i.toHex, r.encode = i.encode;
    function t(a, c, d) {
      var h = new Array(Math.max(a.bitLength(), d) + 1);
      h.fill(0);
      for (var p = 1 << c + 1, v = a.clone(), g = 0; g < h.length; g++) {
        var m, x = v.andln(p - 1);
        v.isOdd() ? (x > (p >> 1) - 1 ? m = (p >> 1) - x : m = x, v.isubn(m)) : m = 0, h[g] = m, v.iushrn(1);
      }
      return h;
    }
    r.getNAF = t;
    function u(a, c) {
      var d = [
        [],
        []
      ];
      a = a.clone(), c = c.clone();
      for (var h = 0, p = 0, v; a.cmpn(-h) > 0 || c.cmpn(-p) > 0; ) {
        var g = a.andln(3) + h & 3, m = c.andln(3) + p & 3;
        g === 3 && (g = -1), m === 3 && (m = -1);
        var x;
        g & 1 ? (v = a.andln(7) + h & 7, (v === 3 || v === 5) && m === 2 ? x = -g : x = g) : x = 0, d[0].push(x);
        var y;
        m & 1 ? (v = c.andln(7) + p & 7, (v === 3 || v === 5) && g === 2 ? y = -m : y = m) : y = 0, d[1].push(y), 2 * h === x + 1 && (h = 1 - h), 2 * p === y + 1 && (p = 1 - p), a.iushrn(1), c.iushrn(1);
      }
      return d;
    }
    r.getJSF = u;
    function l(a, c, d) {
      var h = "_" + c;
      a.prototype[c] = function() {
        return this[h] !== void 0 ? this[h] : this[h] = d.call(this);
      };
    }
    r.cachedProperty = l;
    function f(a) {
      return typeof a == "string" ? r.toArray(a, "hex") : a;
    }
    r.parseBytes = f;
    function s(a) {
      return new o(a, "hex", "le");
    }
    r.intFromLE = s;
  }(Rs)), Rs;
}
var qs = {}, $s, dv;
function fo() {
  if (dv)
    return $s;
  dv = 1;
  var e = Rr(), r = pt(), o = r.getNAF, n = r.getJSF, i = r.assert;
  function t(l, f) {
    this.type = l, this.p = new e(f.p, 16), this.red = f.prime ? e.red(f.prime) : e.mont(this.p), this.zero = new e(0).toRed(this.red), this.one = new e(1).toRed(this.red), this.two = new e(2).toRed(this.red), this.n = f.n && new e(f.n, 16), this.g = f.g && this.pointFromJSON(f.g, f.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var s = this.n && this.p.div(this.n);
    !s || s.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  $s = t, t.prototype.point = function() {
    throw new Error("Not implemented");
  }, t.prototype.validate = function() {
    throw new Error("Not implemented");
  }, t.prototype._fixedNafMul = function(f, s) {
    i(f.precomputed);
    var a = f._getDoubles(), c = o(s, 1, this._bitLength), d = (1 << a.step + 1) - (a.step % 2 === 0 ? 2 : 1);
    d /= 3;
    var h = [], p, v;
    for (p = 0; p < c.length; p += a.step) {
      v = 0;
      for (var g = p + a.step - 1; g >= p; g--)
        v = (v << 1) + c[g];
      h.push(v);
    }
    for (var m = this.jpoint(null, null, null), x = this.jpoint(null, null, null), y = d; y > 0; y--) {
      for (p = 0; p < h.length; p++)
        v = h[p], v === y ? x = x.mixedAdd(a.points[p]) : v === -y && (x = x.mixedAdd(a.points[p].neg()));
      m = m.add(x);
    }
    return m.toP();
  }, t.prototype._wnafMul = function(f, s) {
    var a = 4, c = f._getNAFPoints(a);
    a = c.wnd;
    for (var d = c.points, h = o(s, a, this._bitLength), p = this.jpoint(null, null, null), v = h.length - 1; v >= 0; v--) {
      for (var g = 0; v >= 0 && h[v] === 0; v--)
        g++;
      if (v >= 0 && g++, p = p.dblp(g), v < 0)
        break;
      var m = h[v];
      i(m !== 0), f.type === "affine" ? m > 0 ? p = p.mixedAdd(d[m - 1 >> 1]) : p = p.mixedAdd(d[-m - 1 >> 1].neg()) : m > 0 ? p = p.add(d[m - 1 >> 1]) : p = p.add(d[-m - 1 >> 1].neg());
    }
    return f.type === "affine" ? p.toP() : p;
  }, t.prototype._wnafMulAdd = function(f, s, a, c, d) {
    var h = this._wnafT1, p = this._wnafT2, v = this._wnafT3, g = 0, m, x, y;
    for (m = 0; m < c; m++) {
      y = s[m];
      var E = y._getNAFPoints(f);
      h[m] = E.wnd, p[m] = E.points;
    }
    for (m = c - 1; m >= 1; m -= 2) {
      var N = m - 1, S = m;
      if (h[N] !== 1 || h[S] !== 1) {
        v[N] = o(a[N], h[N], this._bitLength), v[S] = o(a[S], h[S], this._bitLength), g = Math.max(v[N].length, g), g = Math.max(v[S].length, g);
        continue;
      }
      var R = [
        s[N],
        /* 1 */
        null,
        /* 3 */
        null,
        /* 5 */
        s[S]
        /* 7 */
      ];
      s[N].y.cmp(s[S].y) === 0 ? (R[1] = s[N].add(s[S]), R[2] = s[N].toJ().mixedAdd(s[S].neg())) : s[N].y.cmp(s[S].y.redNeg()) === 0 ? (R[1] = s[N].toJ().mixedAdd(s[S]), R[2] = s[N].add(s[S].neg())) : (R[1] = s[N].toJ().mixedAdd(s[S]), R[2] = s[N].toJ().mixedAdd(s[S].neg()));
      var O = [
        -3,
        /* -1 -1 */
        -1,
        /* -1 0 */
        -5,
        /* -1 1 */
        -7,
        /* 0 -1 */
        0,
        /* 0 0 */
        7,
        /* 0 1 */
        5,
        /* 1 -1 */
        1,
        /* 1 0 */
        3
        /* 1 1 */
      ], B = n(a[N], a[S]);
      for (g = Math.max(B[0].length, g), v[N] = new Array(g), v[S] = new Array(g), x = 0; x < g; x++) {
        var $ = B[0][x] | 0, F = B[1][x] | 0;
        v[N][x] = O[($ + 1) * 3 + (F + 1)], v[S][x] = 0, p[N] = R;
      }
    }
    var w = this.jpoint(null, null, null), A = this._wnafT4;
    for (m = g; m >= 0; m--) {
      for (var b = 0; m >= 0; ) {
        var D = !0;
        for (x = 0; x < c; x++)
          A[x] = v[x][m] | 0, A[x] !== 0 && (D = !1);
        if (!D)
          break;
        b++, m--;
      }
      if (m >= 0 && b++, w = w.dblp(b), m < 0)
        break;
      for (x = 0; x < c; x++) {
        var M = A[x];
        M !== 0 && (M > 0 ? y = p[x][M - 1 >> 1] : M < 0 && (y = p[x][-M - 1 >> 1].neg()), y.type === "affine" ? w = w.mixedAdd(y) : w = w.add(y));
      }
    }
    for (m = 0; m < c; m++)
      p[m] = null;
    return d ? w : w.toP();
  };
  function u(l, f) {
    this.curve = l, this.type = f, this.precomputed = null;
  }
  return t.BasePoint = u, u.prototype.eq = function() {
    throw new Error("Not implemented");
  }, u.prototype.validate = function() {
    return this.curve.validate(this);
  }, t.prototype.decodePoint = function(f, s) {
    f = r.toArray(f, s);
    var a = this.p.byteLength();
    if ((f[0] === 4 || f[0] === 6 || f[0] === 7) && f.length - 1 === 2 * a) {
      f[0] === 6 ? i(f[f.length - 1] % 2 === 0) : f[0] === 7 && i(f[f.length - 1] % 2 === 1);
      var c = this.point(
        f.slice(1, 1 + a),
        f.slice(1 + a, 1 + 2 * a)
      );
      return c;
    } else if ((f[0] === 2 || f[0] === 3) && f.length - 1 === a)
      return this.pointFromX(f.slice(1, 1 + a), f[0] === 3);
    throw new Error("Unknown point format");
  }, u.prototype.encodeCompressed = function(f) {
    return this.encode(f, !0);
  }, u.prototype._encode = function(f) {
    var s = this.curve.p.byteLength(), a = this.getX().toArray("be", s);
    return f ? [this.getY().isEven() ? 2 : 3].concat(a) : [4].concat(a, this.getY().toArray("be", s));
  }, u.prototype.encode = function(f, s) {
    return r.encode(this._encode(s), f);
  }, u.prototype.precompute = function(f) {
    if (this.precomputed)
      return this;
    var s = {
      doubles: null,
      naf: null,
      beta: null
    };
    return s.naf = this._getNAFPoints(8), s.doubles = this._getDoubles(4, f), s.beta = this._getBeta(), this.precomputed = s, this;
  }, u.prototype._hasDoubles = function(f) {
    if (!this.precomputed)
      return !1;
    var s = this.precomputed.doubles;
    return s ? s.points.length >= Math.ceil((f.bitLength() + 1) / s.step) : !1;
  }, u.prototype._getDoubles = function(f, s) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var a = [this], c = this, d = 0; d < s; d += f) {
      for (var h = 0; h < f; h++)
        c = c.dbl();
      a.push(c);
    }
    return {
      step: f,
      points: a
    };
  }, u.prototype._getNAFPoints = function(f) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var s = [this], a = (1 << f) - 1, c = a === 1 ? null : this.dbl(), d = 1; d < a; d++)
      s[d] = s[d - 1].add(c);
    return {
      wnd: f,
      points: s
    };
  }, u.prototype._getBeta = function() {
    return null;
  }, u.prototype.dblp = function(f) {
    for (var s = this, a = 0; a < f; a++)
      s = s.dbl();
    return s;
  }, $s;
}
var zs, hv;
function DB() {
  if (hv)
    return zs;
  hv = 1;
  var e = pt(), r = Rr(), o = Je(), n = fo(), i = e.assert;
  function t(f) {
    n.call(this, "short", f), this.a = new r(f.a, 16).toRed(this.red), this.b = new r(f.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(f), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  o(t, n), zs = t, t.prototype._getEndomorphism = function(s) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var a, c;
      if (s.beta)
        a = new r(s.beta, 16).toRed(this.red);
      else {
        var d = this._getEndoRoots(this.p);
        a = d[0].cmp(d[1]) < 0 ? d[0] : d[1], a = a.toRed(this.red);
      }
      if (s.lambda)
        c = new r(s.lambda, 16);
      else {
        var h = this._getEndoRoots(this.n);
        this.g.mul(h[0]).x.cmp(this.g.x.redMul(a)) === 0 ? c = h[0] : (c = h[1], i(this.g.mul(c).x.cmp(this.g.x.redMul(a)) === 0));
      }
      var p;
      return s.basis ? p = s.basis.map(function(v) {
        return {
          a: new r(v.a, 16),
          b: new r(v.b, 16)
        };
      }) : p = this._getEndoBasis(c), {
        beta: a,
        lambda: c,
        basis: p
      };
    }
  }, t.prototype._getEndoRoots = function(s) {
    var a = s === this.p ? this.red : r.mont(s), c = new r(2).toRed(a).redInvm(), d = c.redNeg(), h = new r(3).toRed(a).redNeg().redSqrt().redMul(c), p = d.redAdd(h).fromRed(), v = d.redSub(h).fromRed();
    return [p, v];
  }, t.prototype._getEndoBasis = function(s) {
    for (var a = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), c = s, d = this.n.clone(), h = new r(1), p = new r(0), v = new r(0), g = new r(1), m, x, y, E, N, S, R, O = 0, B, $; c.cmpn(0) !== 0; ) {
      var F = d.div(c);
      B = d.sub(F.mul(c)), $ = v.sub(F.mul(h));
      var w = g.sub(F.mul(p));
      if (!y && B.cmp(a) < 0)
        m = R.neg(), x = h, y = B.neg(), E = $;
      else if (y && ++O === 2)
        break;
      R = B, d = c, c = B, v = h, h = $, g = p, p = w;
    }
    N = B.neg(), S = $;
    var A = y.sqr().add(E.sqr()), b = N.sqr().add(S.sqr());
    return b.cmp(A) >= 0 && (N = m, S = x), y.negative && (y = y.neg(), E = E.neg()), N.negative && (N = N.neg(), S = S.neg()), [
      { a: y, b: E },
      { a: N, b: S }
    ];
  }, t.prototype._endoSplit = function(s) {
    var a = this.endo.basis, c = a[0], d = a[1], h = d.b.mul(s).divRound(this.n), p = c.b.neg().mul(s).divRound(this.n), v = h.mul(c.a), g = p.mul(d.a), m = h.mul(c.b), x = p.mul(d.b), y = s.sub(v).sub(g), E = m.add(x).neg();
    return { k1: y, k2: E };
  }, t.prototype.pointFromX = function(s, a) {
    s = new r(s, 16), s.red || (s = s.toRed(this.red));
    var c = s.redSqr().redMul(s).redIAdd(s.redMul(this.a)).redIAdd(this.b), d = c.redSqrt();
    if (d.redSqr().redSub(c).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var h = d.fromRed().isOdd();
    return (a && !h || !a && h) && (d = d.redNeg()), this.point(s, d);
  }, t.prototype.validate = function(s) {
    if (s.inf)
      return !0;
    var a = s.x, c = s.y, d = this.a.redMul(a), h = a.redSqr().redMul(a).redIAdd(d).redIAdd(this.b);
    return c.redSqr().redISub(h).cmpn(0) === 0;
  }, t.prototype._endoWnafMulAdd = function(s, a, c) {
    for (var d = this._endoWnafT1, h = this._endoWnafT2, p = 0; p < s.length; p++) {
      var v = this._endoSplit(a[p]), g = s[p], m = g._getBeta();
      v.k1.negative && (v.k1.ineg(), g = g.neg(!0)), v.k2.negative && (v.k2.ineg(), m = m.neg(!0)), d[p * 2] = g, d[p * 2 + 1] = m, h[p * 2] = v.k1, h[p * 2 + 1] = v.k2;
    }
    for (var x = this._wnafMulAdd(1, d, h, p * 2, c), y = 0; y < p * 2; y++)
      d[y] = null, h[y] = null;
    return x;
  };
  function u(f, s, a, c) {
    n.BasePoint.call(this, f, "affine"), s === null && a === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new r(s, 16), this.y = new r(a, 16), c && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  o(u, n.BasePoint), t.prototype.point = function(s, a, c) {
    return new u(this, s, a, c);
  }, t.prototype.pointFromJSON = function(s, a) {
    return u.fromJSON(this, s, a);
  }, u.prototype._getBeta = function() {
    if (this.curve.endo) {
      var s = this.precomputed;
      if (s && s.beta)
        return s.beta;
      var a = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (s) {
        var c = this.curve, d = function(h) {
          return c.point(h.x.redMul(c.endo.beta), h.y);
        };
        s.beta = a, a.precomputed = {
          beta: null,
          naf: s.naf && {
            wnd: s.naf.wnd,
            points: s.naf.points.map(d)
          },
          doubles: s.doubles && {
            step: s.doubles.step,
            points: s.doubles.points.map(d)
          }
        };
      }
      return a;
    }
  }, u.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, u.fromJSON = function(s, a, c) {
    typeof a == "string" && (a = JSON.parse(a));
    var d = s.point(a[0], a[1], c);
    if (!a[2])
      return d;
    function h(v) {
      return s.point(v[0], v[1], c);
    }
    var p = a[2];
    return d.precomputed = {
      beta: null,
      doubles: p.doubles && {
        step: p.doubles.step,
        points: [d].concat(p.doubles.points.map(h))
      },
      naf: p.naf && {
        wnd: p.naf.wnd,
        points: [d].concat(p.naf.points.map(h))
      }
    }, d;
  }, u.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, u.prototype.isInfinity = function() {
    return this.inf;
  }, u.prototype.add = function(s) {
    if (this.inf)
      return s;
    if (s.inf)
      return this;
    if (this.eq(s))
      return this.dbl();
    if (this.neg().eq(s))
      return this.curve.point(null, null);
    if (this.x.cmp(s.x) === 0)
      return this.curve.point(null, null);
    var a = this.y.redSub(s.y);
    a.cmpn(0) !== 0 && (a = a.redMul(this.x.redSub(s.x).redInvm()));
    var c = a.redSqr().redISub(this.x).redISub(s.x), d = a.redMul(this.x.redSub(c)).redISub(this.y);
    return this.curve.point(c, d);
  }, u.prototype.dbl = function() {
    if (this.inf)
      return this;
    var s = this.y.redAdd(this.y);
    if (s.cmpn(0) === 0)
      return this.curve.point(null, null);
    var a = this.curve.a, c = this.x.redSqr(), d = s.redInvm(), h = c.redAdd(c).redIAdd(c).redIAdd(a).redMul(d), p = h.redSqr().redISub(this.x.redAdd(this.x)), v = h.redMul(this.x.redSub(p)).redISub(this.y);
    return this.curve.point(p, v);
  }, u.prototype.getX = function() {
    return this.x.fromRed();
  }, u.prototype.getY = function() {
    return this.y.fromRed();
  }, u.prototype.mul = function(s) {
    return s = new r(s, 16), this.isInfinity() ? this : this._hasDoubles(s) ? this.curve._fixedNafMul(this, s) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [s]) : this.curve._wnafMul(this, s);
  }, u.prototype.mulAdd = function(s, a, c) {
    var d = [this, a], h = [s, c];
    return this.curve.endo ? this.curve._endoWnafMulAdd(d, h) : this.curve._wnafMulAdd(1, d, h, 2);
  }, u.prototype.jmulAdd = function(s, a, c) {
    var d = [this, a], h = [s, c];
    return this.curve.endo ? this.curve._endoWnafMulAdd(d, h, !0) : this.curve._wnafMulAdd(1, d, h, 2, !0);
  }, u.prototype.eq = function(s) {
    return this === s || this.inf === s.inf && (this.inf || this.x.cmp(s.x) === 0 && this.y.cmp(s.y) === 0);
  }, u.prototype.neg = function(s) {
    if (this.inf)
      return this;
    var a = this.curve.point(this.x, this.y.redNeg());
    if (s && this.precomputed) {
      var c = this.precomputed, d = function(h) {
        return h.neg();
      };
      a.precomputed = {
        naf: c.naf && {
          wnd: c.naf.wnd,
          points: c.naf.points.map(d)
        },
        doubles: c.doubles && {
          step: c.doubles.step,
          points: c.doubles.points.map(d)
        }
      };
    }
    return a;
  }, u.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var s = this.curve.jpoint(this.x, this.y, this.curve.one);
    return s;
  };
  function l(f, s, a, c) {
    n.BasePoint.call(this, f, "jacobian"), s === null && a === null && c === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new r(0)) : (this.x = new r(s, 16), this.y = new r(a, 16), this.z = new r(c, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return o(l, n.BasePoint), t.prototype.jpoint = function(s, a, c) {
    return new l(this, s, a, c);
  }, l.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var s = this.z.redInvm(), a = s.redSqr(), c = this.x.redMul(a), d = this.y.redMul(a).redMul(s);
    return this.curve.point(c, d);
  }, l.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, l.prototype.add = function(s) {
    if (this.isInfinity())
      return s;
    if (s.isInfinity())
      return this;
    var a = s.z.redSqr(), c = this.z.redSqr(), d = this.x.redMul(a), h = s.x.redMul(c), p = this.y.redMul(a.redMul(s.z)), v = s.y.redMul(c.redMul(this.z)), g = d.redSub(h), m = p.redSub(v);
    if (g.cmpn(0) === 0)
      return m.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var x = g.redSqr(), y = x.redMul(g), E = d.redMul(x), N = m.redSqr().redIAdd(y).redISub(E).redISub(E), S = m.redMul(E.redISub(N)).redISub(p.redMul(y)), R = this.z.redMul(s.z).redMul(g);
    return this.curve.jpoint(N, S, R);
  }, l.prototype.mixedAdd = function(s) {
    if (this.isInfinity())
      return s.toJ();
    if (s.isInfinity())
      return this;
    var a = this.z.redSqr(), c = this.x, d = s.x.redMul(a), h = this.y, p = s.y.redMul(a).redMul(this.z), v = c.redSub(d), g = h.redSub(p);
    if (v.cmpn(0) === 0)
      return g.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var m = v.redSqr(), x = m.redMul(v), y = c.redMul(m), E = g.redSqr().redIAdd(x).redISub(y).redISub(y), N = g.redMul(y.redISub(E)).redISub(h.redMul(x)), S = this.z.redMul(v);
    return this.curve.jpoint(E, N, S);
  }, l.prototype.dblp = function(s) {
    if (s === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!s)
      return this.dbl();
    var a;
    if (this.curve.zeroA || this.curve.threeA) {
      var c = this;
      for (a = 0; a < s; a++)
        c = c.dbl();
      return c;
    }
    var d = this.curve.a, h = this.curve.tinv, p = this.x, v = this.y, g = this.z, m = g.redSqr().redSqr(), x = v.redAdd(v);
    for (a = 0; a < s; a++) {
      var y = p.redSqr(), E = x.redSqr(), N = E.redSqr(), S = y.redAdd(y).redIAdd(y).redIAdd(d.redMul(m)), R = p.redMul(E), O = S.redSqr().redISub(R.redAdd(R)), B = R.redISub(O), $ = S.redMul(B);
      $ = $.redIAdd($).redISub(N);
      var F = x.redMul(g);
      a + 1 < s && (m = m.redMul(N)), p = O, g = F, x = $;
    }
    return this.curve.jpoint(p, x.redMul(h), g);
  }, l.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, l.prototype._zeroDbl = function() {
    var s, a, c;
    if (this.zOne) {
      var d = this.x.redSqr(), h = this.y.redSqr(), p = h.redSqr(), v = this.x.redAdd(h).redSqr().redISub(d).redISub(p);
      v = v.redIAdd(v);
      var g = d.redAdd(d).redIAdd(d), m = g.redSqr().redISub(v).redISub(v), x = p.redIAdd(p);
      x = x.redIAdd(x), x = x.redIAdd(x), s = m, a = g.redMul(v.redISub(m)).redISub(x), c = this.y.redAdd(this.y);
    } else {
      var y = this.x.redSqr(), E = this.y.redSqr(), N = E.redSqr(), S = this.x.redAdd(E).redSqr().redISub(y).redISub(N);
      S = S.redIAdd(S);
      var R = y.redAdd(y).redIAdd(y), O = R.redSqr(), B = N.redIAdd(N);
      B = B.redIAdd(B), B = B.redIAdd(B), s = O.redISub(S).redISub(S), a = R.redMul(S.redISub(s)).redISub(B), c = this.y.redMul(this.z), c = c.redIAdd(c);
    }
    return this.curve.jpoint(s, a, c);
  }, l.prototype._threeDbl = function() {
    var s, a, c;
    if (this.zOne) {
      var d = this.x.redSqr(), h = this.y.redSqr(), p = h.redSqr(), v = this.x.redAdd(h).redSqr().redISub(d).redISub(p);
      v = v.redIAdd(v);
      var g = d.redAdd(d).redIAdd(d).redIAdd(this.curve.a), m = g.redSqr().redISub(v).redISub(v);
      s = m;
      var x = p.redIAdd(p);
      x = x.redIAdd(x), x = x.redIAdd(x), a = g.redMul(v.redISub(m)).redISub(x), c = this.y.redAdd(this.y);
    } else {
      var y = this.z.redSqr(), E = this.y.redSqr(), N = this.x.redMul(E), S = this.x.redSub(y).redMul(this.x.redAdd(y));
      S = S.redAdd(S).redIAdd(S);
      var R = N.redIAdd(N);
      R = R.redIAdd(R);
      var O = R.redAdd(R);
      s = S.redSqr().redISub(O), c = this.y.redAdd(this.z).redSqr().redISub(E).redISub(y);
      var B = E.redSqr();
      B = B.redIAdd(B), B = B.redIAdd(B), B = B.redIAdd(B), a = S.redMul(R.redISub(s)).redISub(B);
    }
    return this.curve.jpoint(s, a, c);
  }, l.prototype._dbl = function() {
    var s = this.curve.a, a = this.x, c = this.y, d = this.z, h = d.redSqr().redSqr(), p = a.redSqr(), v = c.redSqr(), g = p.redAdd(p).redIAdd(p).redIAdd(s.redMul(h)), m = a.redAdd(a);
    m = m.redIAdd(m);
    var x = m.redMul(v), y = g.redSqr().redISub(x.redAdd(x)), E = x.redISub(y), N = v.redSqr();
    N = N.redIAdd(N), N = N.redIAdd(N), N = N.redIAdd(N);
    var S = g.redMul(E).redISub(N), R = c.redAdd(c).redMul(d);
    return this.curve.jpoint(y, S, R);
  }, l.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var s = this.x.redSqr(), a = this.y.redSqr(), c = this.z.redSqr(), d = a.redSqr(), h = s.redAdd(s).redIAdd(s), p = h.redSqr(), v = this.x.redAdd(a).redSqr().redISub(s).redISub(d);
    v = v.redIAdd(v), v = v.redAdd(v).redIAdd(v), v = v.redISub(p);
    var g = v.redSqr(), m = d.redIAdd(d);
    m = m.redIAdd(m), m = m.redIAdd(m), m = m.redIAdd(m);
    var x = h.redIAdd(v).redSqr().redISub(p).redISub(g).redISub(m), y = a.redMul(x);
    y = y.redIAdd(y), y = y.redIAdd(y);
    var E = this.x.redMul(g).redISub(y);
    E = E.redIAdd(E), E = E.redIAdd(E);
    var N = this.y.redMul(x.redMul(m.redISub(x)).redISub(v.redMul(g)));
    N = N.redIAdd(N), N = N.redIAdd(N), N = N.redIAdd(N);
    var S = this.z.redAdd(v).redSqr().redISub(c).redISub(g);
    return this.curve.jpoint(E, N, S);
  }, l.prototype.mul = function(s, a) {
    return s = new r(s, a), this.curve._wnafMul(this, s);
  }, l.prototype.eq = function(s) {
    if (s.type === "affine")
      return this.eq(s.toJ());
    if (this === s)
      return !0;
    var a = this.z.redSqr(), c = s.z.redSqr();
    if (this.x.redMul(c).redISub(s.x.redMul(a)).cmpn(0) !== 0)
      return !1;
    var d = a.redMul(this.z), h = c.redMul(s.z);
    return this.y.redMul(h).redISub(s.y.redMul(d)).cmpn(0) === 0;
  }, l.prototype.eqXToP = function(s) {
    var a = this.z.redSqr(), c = s.toRed(this.curve.red).redMul(a);
    if (this.x.cmp(c) === 0)
      return !0;
    for (var d = s.clone(), h = this.curve.redN.redMul(a); ; ) {
      if (d.iadd(this.curve.n), d.cmp(this.curve.p) >= 0)
        return !1;
      if (c.redIAdd(h), this.x.cmp(c) === 0)
        return !0;
    }
  }, l.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, l.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, zs;
}
var Ls, pv;
function NB() {
  if (pv)
    return Ls;
  pv = 1;
  var e = Rr(), r = Je(), o = fo(), n = pt();
  function i(u) {
    o.call(this, "mont", u), this.a = new e(u.a, 16).toRed(this.red), this.b = new e(u.b, 16).toRed(this.red), this.i4 = new e(4).toRed(this.red).redInvm(), this.two = new e(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  r(i, o), Ls = i, i.prototype.validate = function(l) {
    var f = l.normalize().x, s = f.redSqr(), a = s.redMul(f).redAdd(s.redMul(this.a)).redAdd(f), c = a.redSqrt();
    return c.redSqr().cmp(a) === 0;
  };
  function t(u, l, f) {
    o.BasePoint.call(this, u, "projective"), l === null && f === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new e(l, 16), this.z = new e(f, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return r(t, o.BasePoint), i.prototype.decodePoint = function(l, f) {
    return this.point(n.toArray(l, f), 1);
  }, i.prototype.point = function(l, f) {
    return new t(this, l, f);
  }, i.prototype.pointFromJSON = function(l) {
    return t.fromJSON(this, l);
  }, t.prototype.precompute = function() {
  }, t.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, t.fromJSON = function(l, f) {
    return new t(l, f[0], f[1] || l.one);
  }, t.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, t.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, t.prototype.dbl = function() {
    var l = this.x.redAdd(this.z), f = l.redSqr(), s = this.x.redSub(this.z), a = s.redSqr(), c = f.redSub(a), d = f.redMul(a), h = c.redMul(a.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(d, h);
  }, t.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, t.prototype.diffAdd = function(l, f) {
    var s = this.x.redAdd(this.z), a = this.x.redSub(this.z), c = l.x.redAdd(l.z), d = l.x.redSub(l.z), h = d.redMul(s), p = c.redMul(a), v = f.z.redMul(h.redAdd(p).redSqr()), g = f.x.redMul(h.redISub(p).redSqr());
    return this.curve.point(v, g);
  }, t.prototype.mul = function(l) {
    for (var f = l.clone(), s = this, a = this.curve.point(null, null), c = this, d = []; f.cmpn(0) !== 0; f.iushrn(1))
      d.push(f.andln(1));
    for (var h = d.length - 1; h >= 0; h--)
      d[h] === 0 ? (s = s.diffAdd(a, c), a = a.dbl()) : (a = s.diffAdd(a, c), s = s.dbl());
    return a;
  }, t.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, t.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, t.prototype.eq = function(l) {
    return this.getX().cmp(l.getX()) === 0;
  }, t.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, t.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, Ls;
}
var Us, vv;
function MB() {
  if (vv)
    return Us;
  vv = 1;
  var e = pt(), r = Rr(), o = Je(), n = fo(), i = e.assert;
  function t(l) {
    this.twisted = (l.a | 0) !== 1, this.mOneA = this.twisted && (l.a | 0) === -1, this.extended = this.mOneA, n.call(this, "edwards", l), this.a = new r(l.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new r(l.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new r(l.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), i(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (l.c | 0) === 1;
  }
  o(t, n), Us = t, t.prototype._mulA = function(f) {
    return this.mOneA ? f.redNeg() : this.a.redMul(f);
  }, t.prototype._mulC = function(f) {
    return this.oneC ? f : this.c.redMul(f);
  }, t.prototype.jpoint = function(f, s, a, c) {
    return this.point(f, s, a, c);
  }, t.prototype.pointFromX = function(f, s) {
    f = new r(f, 16), f.red || (f = f.toRed(this.red));
    var a = f.redSqr(), c = this.c2.redSub(this.a.redMul(a)), d = this.one.redSub(this.c2.redMul(this.d).redMul(a)), h = c.redMul(d.redInvm()), p = h.redSqrt();
    if (p.redSqr().redSub(h).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var v = p.fromRed().isOdd();
    return (s && !v || !s && v) && (p = p.redNeg()), this.point(f, p);
  }, t.prototype.pointFromY = function(f, s) {
    f = new r(f, 16), f.red || (f = f.toRed(this.red));
    var a = f.redSqr(), c = a.redSub(this.c2), d = a.redMul(this.d).redMul(this.c2).redSub(this.a), h = c.redMul(d.redInvm());
    if (h.cmp(this.zero) === 0) {
      if (s)
        throw new Error("invalid point");
      return this.point(this.zero, f);
    }
    var p = h.redSqrt();
    if (p.redSqr().redSub(h).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return p.fromRed().isOdd() !== s && (p = p.redNeg()), this.point(p, f);
  }, t.prototype.validate = function(f) {
    if (f.isInfinity())
      return !0;
    f.normalize();
    var s = f.x.redSqr(), a = f.y.redSqr(), c = s.redMul(this.a).redAdd(a), d = this.c2.redMul(this.one.redAdd(this.d.redMul(s).redMul(a)));
    return c.cmp(d) === 0;
  };
  function u(l, f, s, a, c) {
    n.BasePoint.call(this, l, "projective"), f === null && s === null && a === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new r(f, 16), this.y = new r(s, 16), this.z = a ? new r(a, 16) : this.curve.one, this.t = c && new r(c, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return o(u, n.BasePoint), t.prototype.pointFromJSON = function(f) {
    return u.fromJSON(this, f);
  }, t.prototype.point = function(f, s, a, c) {
    return new u(this, f, s, a, c);
  }, u.fromJSON = function(f, s) {
    return new u(f, s[0], s[1], s[2]);
  }, u.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, u.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, u.prototype._extDbl = function() {
    var f = this.x.redSqr(), s = this.y.redSqr(), a = this.z.redSqr();
    a = a.redIAdd(a);
    var c = this.curve._mulA(f), d = this.x.redAdd(this.y).redSqr().redISub(f).redISub(s), h = c.redAdd(s), p = h.redSub(a), v = c.redSub(s), g = d.redMul(p), m = h.redMul(v), x = d.redMul(v), y = p.redMul(h);
    return this.curve.point(g, m, y, x);
  }, u.prototype._projDbl = function() {
    var f = this.x.redAdd(this.y).redSqr(), s = this.x.redSqr(), a = this.y.redSqr(), c, d, h, p, v, g;
    if (this.curve.twisted) {
      p = this.curve._mulA(s);
      var m = p.redAdd(a);
      this.zOne ? (c = f.redSub(s).redSub(a).redMul(m.redSub(this.curve.two)), d = m.redMul(p.redSub(a)), h = m.redSqr().redSub(m).redSub(m)) : (v = this.z.redSqr(), g = m.redSub(v).redISub(v), c = f.redSub(s).redISub(a).redMul(g), d = m.redMul(p.redSub(a)), h = m.redMul(g));
    } else
      p = s.redAdd(a), v = this.curve._mulC(this.z).redSqr(), g = p.redSub(v).redSub(v), c = this.curve._mulC(f.redISub(p)).redMul(g), d = this.curve._mulC(p).redMul(s.redISub(a)), h = p.redMul(g);
    return this.curve.point(c, d, h);
  }, u.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, u.prototype._extAdd = function(f) {
    var s = this.y.redSub(this.x).redMul(f.y.redSub(f.x)), a = this.y.redAdd(this.x).redMul(f.y.redAdd(f.x)), c = this.t.redMul(this.curve.dd).redMul(f.t), d = this.z.redMul(f.z.redAdd(f.z)), h = a.redSub(s), p = d.redSub(c), v = d.redAdd(c), g = a.redAdd(s), m = h.redMul(p), x = v.redMul(g), y = h.redMul(g), E = p.redMul(v);
    return this.curve.point(m, x, E, y);
  }, u.prototype._projAdd = function(f) {
    var s = this.z.redMul(f.z), a = s.redSqr(), c = this.x.redMul(f.x), d = this.y.redMul(f.y), h = this.curve.d.redMul(c).redMul(d), p = a.redSub(h), v = a.redAdd(h), g = this.x.redAdd(this.y).redMul(f.x.redAdd(f.y)).redISub(c).redISub(d), m = s.redMul(p).redMul(g), x, y;
    return this.curve.twisted ? (x = s.redMul(v).redMul(d.redSub(this.curve._mulA(c))), y = p.redMul(v)) : (x = s.redMul(v).redMul(d.redSub(c)), y = this.curve._mulC(p).redMul(v)), this.curve.point(m, x, y);
  }, u.prototype.add = function(f) {
    return this.isInfinity() ? f : f.isInfinity() ? this : this.curve.extended ? this._extAdd(f) : this._projAdd(f);
  }, u.prototype.mul = function(f) {
    return this._hasDoubles(f) ? this.curve._fixedNafMul(this, f) : this.curve._wnafMul(this, f);
  }, u.prototype.mulAdd = function(f, s, a) {
    return this.curve._wnafMulAdd(1, [this, s], [f, a], 2, !1);
  }, u.prototype.jmulAdd = function(f, s, a) {
    return this.curve._wnafMulAdd(1, [this, s], [f, a], 2, !0);
  }, u.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var f = this.z.redInvm();
    return this.x = this.x.redMul(f), this.y = this.y.redMul(f), this.t && (this.t = this.t.redMul(f)), this.z = this.curve.one, this.zOne = !0, this;
  }, u.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, u.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, u.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, u.prototype.eq = function(f) {
    return this === f || this.getX().cmp(f.getX()) === 0 && this.getY().cmp(f.getY()) === 0;
  }, u.prototype.eqXToP = function(f) {
    var s = f.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(s) === 0)
      return !0;
    for (var a = f.clone(), c = this.curve.redN.redMul(this.z); ; ) {
      if (a.iadd(this.curve.n), a.cmp(this.curve.p) >= 0)
        return !1;
      if (s.redIAdd(c), this.x.cmp(s) === 0)
        return !0;
    }
  }, u.prototype.toP = u.prototype.normalize, u.prototype.mixedAdd = u.prototype.add, Us;
}
var mv;
function Wb() {
  return mv || (mv = 1, function(e) {
    var r = e;
    r.base = fo(), r.short = DB(), r.mont = NB(), r.edwards = MB();
  }(qs)), qs;
}
var ks = {}, Hs = {}, cr = {}, gv;
function _t() {
  if (gv)
    return cr;
  gv = 1;
  var e = ht(), r = Je();
  cr.inherits = r;
  function o(w, A) {
    return (w.charCodeAt(A) & 64512) !== 55296 || A < 0 || A + 1 >= w.length ? !1 : (w.charCodeAt(A + 1) & 64512) === 56320;
  }
  function n(w, A) {
    if (Array.isArray(w))
      return w.slice();
    if (!w)
      return [];
    var b = [];
    if (typeof w == "string")
      if (A) {
        if (A === "hex")
          for (w = w.replace(/[^a-z0-9]+/ig, ""), w.length % 2 !== 0 && (w = "0" + w), M = 0; M < w.length; M += 2)
            b.push(parseInt(w[M] + w[M + 1], 16));
      } else
        for (var D = 0, M = 0; M < w.length; M++) {
          var _ = w.charCodeAt(M);
          _ < 128 ? b[D++] = _ : _ < 2048 ? (b[D++] = _ >> 6 | 192, b[D++] = _ & 63 | 128) : o(w, M) ? (_ = 65536 + ((_ & 1023) << 10) + (w.charCodeAt(++M) & 1023), b[D++] = _ >> 18 | 240, b[D++] = _ >> 12 & 63 | 128, b[D++] = _ >> 6 & 63 | 128, b[D++] = _ & 63 | 128) : (b[D++] = _ >> 12 | 224, b[D++] = _ >> 6 & 63 | 128, b[D++] = _ & 63 | 128);
        }
    else
      for (M = 0; M < w.length; M++)
        b[M] = w[M] | 0;
    return b;
  }
  cr.toArray = n;
  function i(w) {
    for (var A = "", b = 0; b < w.length; b++)
      A += l(w[b].toString(16));
    return A;
  }
  cr.toHex = i;
  function t(w) {
    var A = w >>> 24 | w >>> 8 & 65280 | w << 8 & 16711680 | (w & 255) << 24;
    return A >>> 0;
  }
  cr.htonl = t;
  function u(w, A) {
    for (var b = "", D = 0; D < w.length; D++) {
      var M = w[D];
      A === "little" && (M = t(M)), b += f(M.toString(16));
    }
    return b;
  }
  cr.toHex32 = u;
  function l(w) {
    return w.length === 1 ? "0" + w : w;
  }
  cr.zero2 = l;
  function f(w) {
    return w.length === 7 ? "0" + w : w.length === 6 ? "00" + w : w.length === 5 ? "000" + w : w.length === 4 ? "0000" + w : w.length === 3 ? "00000" + w : w.length === 2 ? "000000" + w : w.length === 1 ? "0000000" + w : w;
  }
  cr.zero8 = f;
  function s(w, A, b, D) {
    var M = b - A;
    e(M % 4 === 0);
    for (var _ = new Array(M / 4), q = 0, C = A; q < _.length; q++, C += 4) {
      var T;
      D === "big" ? T = w[C] << 24 | w[C + 1] << 16 | w[C + 2] << 8 | w[C + 3] : T = w[C + 3] << 24 | w[C + 2] << 16 | w[C + 1] << 8 | w[C], _[q] = T >>> 0;
    }
    return _;
  }
  cr.join32 = s;
  function a(w, A) {
    for (var b = new Array(w.length * 4), D = 0, M = 0; D < w.length; D++, M += 4) {
      var _ = w[D];
      A === "big" ? (b[M] = _ >>> 24, b[M + 1] = _ >>> 16 & 255, b[M + 2] = _ >>> 8 & 255, b[M + 3] = _ & 255) : (b[M + 3] = _ >>> 24, b[M + 2] = _ >>> 16 & 255, b[M + 1] = _ >>> 8 & 255, b[M] = _ & 255);
    }
    return b;
  }
  cr.split32 = a;
  function c(w, A) {
    return w >>> A | w << 32 - A;
  }
  cr.rotr32 = c;
  function d(w, A) {
    return w << A | w >>> 32 - A;
  }
  cr.rotl32 = d;
  function h(w, A) {
    return w + A >>> 0;
  }
  cr.sum32 = h;
  function p(w, A, b) {
    return w + A + b >>> 0;
  }
  cr.sum32_3 = p;
  function v(w, A, b, D) {
    return w + A + b + D >>> 0;
  }
  cr.sum32_4 = v;
  function g(w, A, b, D, M) {
    return w + A + b + D + M >>> 0;
  }
  cr.sum32_5 = g;
  function m(w, A, b, D) {
    var M = w[A], _ = w[A + 1], q = D + _ >>> 0, C = (q < D ? 1 : 0) + b + M;
    w[A] = C >>> 0, w[A + 1] = q;
  }
  cr.sum64 = m;
  function x(w, A, b, D) {
    var M = A + D >>> 0, _ = (M < A ? 1 : 0) + w + b;
    return _ >>> 0;
  }
  cr.sum64_hi = x;
  function y(w, A, b, D) {
    var M = A + D;
    return M >>> 0;
  }
  cr.sum64_lo = y;
  function E(w, A, b, D, M, _, q, C) {
    var T = 0, z = A;
    z = z + D >>> 0, T += z < A ? 1 : 0, z = z + _ >>> 0, T += z < _ ? 1 : 0, z = z + C >>> 0, T += z < C ? 1 : 0;
    var I = w + b + M + q + T;
    return I >>> 0;
  }
  cr.sum64_4_hi = E;
  function N(w, A, b, D, M, _, q, C) {
    var T = A + D + _ + C;
    return T >>> 0;
  }
  cr.sum64_4_lo = N;
  function S(w, A, b, D, M, _, q, C, T, z) {
    var I = 0, U = A;
    U = U + D >>> 0, I += U < A ? 1 : 0, U = U + _ >>> 0, I += U < _ ? 1 : 0, U = U + C >>> 0, I += U < C ? 1 : 0, U = U + z >>> 0, I += U < z ? 1 : 0;
    var ee = w + b + M + q + T + I;
    return ee >>> 0;
  }
  cr.sum64_5_hi = S;
  function R(w, A, b, D, M, _, q, C, T, z) {
    var I = A + D + _ + C + z;
    return I >>> 0;
  }
  cr.sum64_5_lo = R;
  function O(w, A, b) {
    var D = A << 32 - b | w >>> b;
    return D >>> 0;
  }
  cr.rotr64_hi = O;
  function B(w, A, b) {
    var D = w << 32 - b | A >>> b;
    return D >>> 0;
  }
  cr.rotr64_lo = B;
  function $(w, A, b) {
    return w >>> b;
  }
  cr.shr64_hi = $;
  function F(w, A, b) {
    var D = w << 32 - b | A >>> b;
    return D >>> 0;
  }
  return cr.shr64_lo = F, cr;
}
var Gs = {}, bv;
function Pi() {
  if (bv)
    return Gs;
  bv = 1;
  var e = _t(), r = ht();
  function o() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }
  return Gs.BlockHash = o, o.prototype.update = function(i, t) {
    if (i = e.toArray(i, t), this.pending ? this.pending = this.pending.concat(i) : this.pending = i, this.pendingTotal += i.length, this.pending.length >= this._delta8) {
      i = this.pending;
      var u = i.length % this._delta8;
      this.pending = i.slice(i.length - u, i.length), this.pending.length === 0 && (this.pending = null), i = e.join32(i, 0, i.length - u, this.endian);
      for (var l = 0; l < i.length; l += this._delta32)
        this._update(i, l, l + this._delta32);
    }
    return this;
  }, o.prototype.digest = function(i) {
    return this.update(this._pad()), r(this.pending === null), this._digest(i);
  }, o.prototype._pad = function() {
    var i = this.pendingTotal, t = this._delta8, u = t - (i + this.padLength) % t, l = new Array(u + this.padLength);
    l[0] = 128;
    for (var f = 1; f < u; f++)
      l[f] = 0;
    if (i <<= 3, this.endian === "big") {
      for (var s = 8; s < this.padLength; s++)
        l[f++] = 0;
      l[f++] = 0, l[f++] = 0, l[f++] = 0, l[f++] = 0, l[f++] = i >>> 24 & 255, l[f++] = i >>> 16 & 255, l[f++] = i >>> 8 & 255, l[f++] = i & 255;
    } else
      for (l[f++] = i & 255, l[f++] = i >>> 8 & 255, l[f++] = i >>> 16 & 255, l[f++] = i >>> 24 & 255, l[f++] = 0, l[f++] = 0, l[f++] = 0, l[f++] = 0, s = 8; s < this.padLength; s++)
        l[f++] = 0;
    return l;
  }, Gs;
}
var bn = {}, St = {}, yv;
function Kb() {
  if (yv)
    return St;
  yv = 1;
  var e = _t(), r = e.rotr32;
  function o(a, c, d, h) {
    if (a === 0)
      return n(c, d, h);
    if (a === 1 || a === 3)
      return t(c, d, h);
    if (a === 2)
      return i(c, d, h);
  }
  St.ft_1 = o;
  function n(a, c, d) {
    return a & c ^ ~a & d;
  }
  St.ch32 = n;
  function i(a, c, d) {
    return a & c ^ a & d ^ c & d;
  }
  St.maj32 = i;
  function t(a, c, d) {
    return a ^ c ^ d;
  }
  St.p32 = t;
  function u(a) {
    return r(a, 2) ^ r(a, 13) ^ r(a, 22);
  }
  St.s0_256 = u;
  function l(a) {
    return r(a, 6) ^ r(a, 11) ^ r(a, 25);
  }
  St.s1_256 = l;
  function f(a) {
    return r(a, 7) ^ r(a, 18) ^ a >>> 3;
  }
  St.g0_256 = f;
  function s(a) {
    return r(a, 17) ^ r(a, 19) ^ a >>> 10;
  }
  return St.g1_256 = s, St;
}
var Vs, wv;
function _B() {
  if (wv)
    return Vs;
  wv = 1;
  var e = _t(), r = Pi(), o = Kb(), n = e.rotl32, i = e.sum32, t = e.sum32_5, u = o.ft_1, l = r.BlockHash, f = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
  ];
  function s() {
    if (!(this instanceof s))
      return new s();
    l.call(this), this.h = [
      1732584193,
      4023233417,
      2562383102,
      271733878,
      3285377520
    ], this.W = new Array(80);
  }
  return e.inherits(s, l), Vs = s, s.blockSize = 512, s.outSize = 160, s.hmacStrength = 80, s.padLength = 64, s.prototype._update = function(c, d) {
    for (var h = this.W, p = 0; p < 16; p++)
      h[p] = c[d + p];
    for (; p < h.length; p++)
      h[p] = n(h[p - 3] ^ h[p - 8] ^ h[p - 14] ^ h[p - 16], 1);
    var v = this.h[0], g = this.h[1], m = this.h[2], x = this.h[3], y = this.h[4];
    for (p = 0; p < h.length; p++) {
      var E = ~~(p / 20), N = t(n(v, 5), u(E, g, m, x), y, h[p], f[E]);
      y = x, x = m, m = n(g, 30), g = v, v = N;
    }
    this.h[0] = i(this.h[0], v), this.h[1] = i(this.h[1], g), this.h[2] = i(this.h[2], m), this.h[3] = i(this.h[3], x), this.h[4] = i(this.h[4], y);
  }, s.prototype._digest = function(c) {
    return c === "hex" ? e.toHex32(this.h, "big") : e.split32(this.h, "big");
  }, Vs;
}
var Ws, xv;
function Zb() {
  if (xv)
    return Ws;
  xv = 1;
  var e = _t(), r = Pi(), o = Kb(), n = ht(), i = e.sum32, t = e.sum32_4, u = e.sum32_5, l = o.ch32, f = o.maj32, s = o.s0_256, a = o.s1_256, c = o.g0_256, d = o.g1_256, h = r.BlockHash, p = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ];
  function v() {
    if (!(this instanceof v))
      return new v();
    h.call(this), this.h = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ], this.k = p, this.W = new Array(64);
  }
  return e.inherits(v, h), Ws = v, v.blockSize = 512, v.outSize = 256, v.hmacStrength = 192, v.padLength = 64, v.prototype._update = function(m, x) {
    for (var y = this.W, E = 0; E < 16; E++)
      y[E] = m[x + E];
    for (; E < y.length; E++)
      y[E] = t(d(y[E - 2]), y[E - 7], c(y[E - 15]), y[E - 16]);
    var N = this.h[0], S = this.h[1], R = this.h[2], O = this.h[3], B = this.h[4], $ = this.h[5], F = this.h[6], w = this.h[7];
    for (n(this.k.length === y.length), E = 0; E < y.length; E++) {
      var A = u(w, a(B), l(B, $, F), this.k[E], y[E]), b = i(s(N), f(N, S, R));
      w = F, F = $, $ = B, B = i(O, A), O = R, R = S, S = N, N = i(A, b);
    }
    this.h[0] = i(this.h[0], N), this.h[1] = i(this.h[1], S), this.h[2] = i(this.h[2], R), this.h[3] = i(this.h[3], O), this.h[4] = i(this.h[4], B), this.h[5] = i(this.h[5], $), this.h[6] = i(this.h[6], F), this.h[7] = i(this.h[7], w);
  }, v.prototype._digest = function(m) {
    return m === "hex" ? e.toHex32(this.h, "big") : e.split32(this.h, "big");
  }, Ws;
}
var Ks, Ev;
function CB() {
  if (Ev)
    return Ks;
  Ev = 1;
  var e = _t(), r = Zb();
  function o() {
    if (!(this instanceof o))
      return new o();
    r.call(this), this.h = [
      3238371032,
      914150663,
      812702999,
      4144912697,
      4290775857,
      1750603025,
      1694076839,
      3204075428
    ];
  }
  return e.inherits(o, r), Ks = o, o.blockSize = 512, o.outSize = 224, o.hmacStrength = 192, o.padLength = 64, o.prototype._digest = function(i) {
    return i === "hex" ? e.toHex32(this.h.slice(0, 7), "big") : e.split32(this.h.slice(0, 7), "big");
  }, Ks;
}
var Zs, Av;
function jb() {
  if (Av)
    return Zs;
  Av = 1;
  var e = _t(), r = Pi(), o = ht(), n = e.rotr64_hi, i = e.rotr64_lo, t = e.shr64_hi, u = e.shr64_lo, l = e.sum64, f = e.sum64_hi, s = e.sum64_lo, a = e.sum64_4_hi, c = e.sum64_4_lo, d = e.sum64_5_hi, h = e.sum64_5_lo, p = r.BlockHash, v = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ];
  function g() {
    if (!(this instanceof g))
      return new g();
    p.call(this), this.h = [
      1779033703,
      4089235720,
      3144134277,
      2227873595,
      1013904242,
      4271175723,
      2773480762,
      1595750129,
      1359893119,
      2917565137,
      2600822924,
      725511199,
      528734635,
      4215389547,
      1541459225,
      327033209
    ], this.k = v, this.W = new Array(160);
  }
  e.inherits(g, p), Zs = g, g.blockSize = 1024, g.outSize = 512, g.hmacStrength = 192, g.padLength = 128, g.prototype._prepareBlock = function(b, D) {
    for (var M = this.W, _ = 0; _ < 32; _++)
      M[_] = b[D + _];
    for (; _ < M.length; _ += 2) {
      var q = F(M[_ - 4], M[_ - 3]), C = w(M[_ - 4], M[_ - 3]), T = M[_ - 14], z = M[_ - 13], I = B(M[_ - 30], M[_ - 29]), U = $(M[_ - 30], M[_ - 29]), ee = M[_ - 32], se = M[_ - 31];
      M[_] = a(
        q,
        C,
        T,
        z,
        I,
        U,
        ee,
        se
      ), M[_ + 1] = c(
        q,
        C,
        T,
        z,
        I,
        U,
        ee,
        se
      );
    }
  }, g.prototype._update = function(b, D) {
    this._prepareBlock(b, D);
    var M = this.W, _ = this.h[0], q = this.h[1], C = this.h[2], T = this.h[3], z = this.h[4], I = this.h[5], U = this.h[6], ee = this.h[7], se = this.h[8], K = this.h[9], J = this.h[10], te = this.h[11], ne = this.h[12], ue = this.h[13], V = this.h[14], W = this.h[15];
    o(this.k.length === M.length);
    for (var fe = 0; fe < M.length; fe += 2) {
      var pe = V, Y = W, k = R(se, K), L = O(se, K), P = m(se, K, J, te, ne), G = x(se, K, J, te, ne, ue), j = this.k[fe], re = this.k[fe + 1], ie = M[fe], Z = M[fe + 1], X = d(
        pe,
        Y,
        k,
        L,
        P,
        G,
        j,
        re,
        ie,
        Z
      ), oe = h(
        pe,
        Y,
        k,
        L,
        P,
        G,
        j,
        re,
        ie,
        Z
      );
      pe = N(_, q), Y = S(_, q), k = y(_, q, C, T, z), L = E(_, q, C, T, z, I);
      var ce = f(pe, Y, k, L), le = s(pe, Y, k, L);
      V = ne, W = ue, ne = J, ue = te, J = se, te = K, se = f(U, ee, X, oe), K = s(ee, ee, X, oe), U = z, ee = I, z = C, I = T, C = _, T = q, _ = f(X, oe, ce, le), q = s(X, oe, ce, le);
    }
    l(this.h, 0, _, q), l(this.h, 2, C, T), l(this.h, 4, z, I), l(this.h, 6, U, ee), l(this.h, 8, se, K), l(this.h, 10, J, te), l(this.h, 12, ne, ue), l(this.h, 14, V, W);
  }, g.prototype._digest = function(b) {
    return b === "hex" ? e.toHex32(this.h, "big") : e.split32(this.h, "big");
  };
  function m(A, b, D, M, _) {
    var q = A & D ^ ~A & _;
    return q < 0 && (q += 4294967296), q;
  }
  function x(A, b, D, M, _, q) {
    var C = b & M ^ ~b & q;
    return C < 0 && (C += 4294967296), C;
  }
  function y(A, b, D, M, _) {
    var q = A & D ^ A & _ ^ D & _;
    return q < 0 && (q += 4294967296), q;
  }
  function E(A, b, D, M, _, q) {
    var C = b & M ^ b & q ^ M & q;
    return C < 0 && (C += 4294967296), C;
  }
  function N(A, b) {
    var D = n(A, b, 28), M = n(b, A, 2), _ = n(b, A, 7), q = D ^ M ^ _;
    return q < 0 && (q += 4294967296), q;
  }
  function S(A, b) {
    var D = i(A, b, 28), M = i(b, A, 2), _ = i(b, A, 7), q = D ^ M ^ _;
    return q < 0 && (q += 4294967296), q;
  }
  function R(A, b) {
    var D = n(A, b, 14), M = n(A, b, 18), _ = n(b, A, 9), q = D ^ M ^ _;
    return q < 0 && (q += 4294967296), q;
  }
  function O(A, b) {
    var D = i(A, b, 14), M = i(A, b, 18), _ = i(b, A, 9), q = D ^ M ^ _;
    return q < 0 && (q += 4294967296), q;
  }
  function B(A, b) {
    var D = n(A, b, 1), M = n(A, b, 8), _ = t(A, b, 7), q = D ^ M ^ _;
    return q < 0 && (q += 4294967296), q;
  }
  function $(A, b) {
    var D = i(A, b, 1), M = i(A, b, 8), _ = u(A, b, 7), q = D ^ M ^ _;
    return q < 0 && (q += 4294967296), q;
  }
  function F(A, b) {
    var D = n(A, b, 19), M = n(b, A, 29), _ = t(A, b, 6), q = D ^ M ^ _;
    return q < 0 && (q += 4294967296), q;
  }
  function w(A, b) {
    var D = i(A, b, 19), M = i(b, A, 29), _ = u(A, b, 6), q = D ^ M ^ _;
    return q < 0 && (q += 4294967296), q;
  }
  return Zs;
}
var js, Sv;
function TB() {
  if (Sv)
    return js;
  Sv = 1;
  var e = _t(), r = jb();
  function o() {
    if (!(this instanceof o))
      return new o();
    r.call(this), this.h = [
      3418070365,
      3238371032,
      1654270250,
      914150663,
      2438529370,
      812702999,
      355462360,
      4144912697,
      1731405415,
      4290775857,
      2394180231,
      1750603025,
      3675008525,
      1694076839,
      1203062813,
      3204075428
    ];
  }
  return e.inherits(o, r), js = o, o.blockSize = 1024, o.outSize = 384, o.hmacStrength = 192, o.padLength = 128, o.prototype._digest = function(i) {
    return i === "hex" ? e.toHex32(this.h.slice(0, 12), "big") : e.split32(this.h.slice(0, 12), "big");
  }, js;
}
var Dv;
function BB() {
  return Dv || (Dv = 1, bn.sha1 = _B(), bn.sha224 = CB(), bn.sha256 = Zb(), bn.sha384 = TB(), bn.sha512 = jb()), bn;
}
var Ys = {}, Nv;
function FB() {
  if (Nv)
    return Ys;
  Nv = 1;
  var e = _t(), r = Pi(), o = e.rotl32, n = e.sum32, i = e.sum32_3, t = e.sum32_4, u = r.BlockHash;
  function l() {
    if (!(this instanceof l))
      return new l();
    u.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }
  e.inherits(l, u), Ys.ripemd160 = l, l.blockSize = 512, l.outSize = 160, l.hmacStrength = 192, l.padLength = 64, l.prototype._update = function(g, m) {
    for (var x = this.h[0], y = this.h[1], E = this.h[2], N = this.h[3], S = this.h[4], R = x, O = y, B = E, $ = N, F = S, w = 0; w < 80; w++) {
      var A = n(
        o(
          t(x, f(w, y, E, N), g[c[w] + m], s(w)),
          h[w]
        ),
        S
      );
      x = S, S = N, N = o(E, 10), E = y, y = A, A = n(
        o(
          t(R, f(79 - w, O, B, $), g[d[w] + m], a(w)),
          p[w]
        ),
        F
      ), R = F, F = $, $ = o(B, 10), B = O, O = A;
    }
    A = i(this.h[1], E, $), this.h[1] = i(this.h[2], N, F), this.h[2] = i(this.h[3], S, R), this.h[3] = i(this.h[4], x, O), this.h[4] = i(this.h[0], y, B), this.h[0] = A;
  }, l.prototype._digest = function(g) {
    return g === "hex" ? e.toHex32(this.h, "little") : e.split32(this.h, "little");
  };
  function f(v, g, m, x) {
    return v <= 15 ? g ^ m ^ x : v <= 31 ? g & m | ~g & x : v <= 47 ? (g | ~m) ^ x : v <= 63 ? g & x | m & ~x : g ^ (m | ~x);
  }
  function s(v) {
    return v <= 15 ? 0 : v <= 31 ? 1518500249 : v <= 47 ? 1859775393 : v <= 63 ? 2400959708 : 2840853838;
  }
  function a(v) {
    return v <= 15 ? 1352829926 : v <= 31 ? 1548603684 : v <= 47 ? 1836072691 : v <= 63 ? 2053994217 : 0;
  }
  var c = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], d = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], h = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], p = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ];
  return Ys;
}
var Xs, Mv;
function IB() {
  if (Mv)
    return Xs;
  Mv = 1;
  var e = _t(), r = ht();
  function o(n, i, t) {
    if (!(this instanceof o))
      return new o(n, i, t);
    this.Hash = n, this.blockSize = n.blockSize / 8, this.outSize = n.outSize / 8, this.inner = null, this.outer = null, this._init(e.toArray(i, t));
  }
  return Xs = o, o.prototype._init = function(i) {
    i.length > this.blockSize && (i = new this.Hash().update(i).digest()), r(i.length <= this.blockSize);
    for (var t = i.length; t < this.blockSize; t++)
      i.push(0);
    for (t = 0; t < i.length; t++)
      i[t] ^= 54;
    for (this.inner = new this.Hash().update(i), t = 0; t < i.length; t++)
      i[t] ^= 106;
    this.outer = new this.Hash().update(i);
  }, o.prototype.update = function(i, t) {
    return this.inner.update(i, t), this;
  }, o.prototype.digest = function(i) {
    return this.outer.update(this.inner.digest()), this.outer.digest(i);
  }, Xs;
}
var _v;
function ac() {
  return _v || (_v = 1, function(e) {
    var r = e;
    r.utils = _t(), r.common = Pi(), r.sha = BB(), r.ripemd = FB(), r.hmac = IB(), r.sha1 = r.sha.sha1, r.sha256 = r.sha.sha256, r.sha224 = r.sha.sha224, r.sha384 = r.sha.sha384, r.sha512 = r.sha.sha512, r.ripemd160 = r.ripemd.ripemd160;
  }(Hs)), Hs;
}
var Js, Cv;
function OB() {
  return Cv || (Cv = 1, Js = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), Js;
}
var Tv;
function oc() {
  return Tv || (Tv = 1, function(e) {
    var r = e, o = ac(), n = Wb(), i = pt(), t = i.assert;
    function u(s) {
      s.type === "short" ? this.curve = new n.short(s) : s.type === "edwards" ? this.curve = new n.edwards(s) : this.curve = new n.mont(s), this.g = this.curve.g, this.n = this.curve.n, this.hash = s.hash, t(this.g.validate(), "Invalid curve"), t(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    r.PresetCurve = u;
    function l(s, a) {
      Object.defineProperty(r, s, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var c = new u(a);
          return Object.defineProperty(r, s, {
            configurable: !0,
            enumerable: !0,
            value: c
          }), c;
        }
      });
    }
    l("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: o.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), l("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: o.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), l("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: o.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), l("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: o.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), l("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: o.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), l("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: o.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), l("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      // -121665 * (121666^(-1)) (mod P)
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: o.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var f;
    try {
      f = OB();
    } catch {
      f = void 0;
    }
    l("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: o.sha256,
      // Precomputed endomorphism
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        f
      ]
    });
  }(ks)), ks;
}
var Qs, Bv;
function RB() {
  if (Bv)
    return Qs;
  Bv = 1;
  var e = ac(), r = Vb(), o = ht();
  function n(i) {
    if (!(this instanceof n))
      return new n(i);
    this.hash = i.hash, this.predResist = !!i.predResist, this.outLen = this.hash.outSize, this.minEntropy = i.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var t = r.toArray(i.entropy, i.entropyEnc || "hex"), u = r.toArray(i.nonce, i.nonceEnc || "hex"), l = r.toArray(i.pers, i.persEnc || "hex");
    o(
      t.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._init(t, u, l);
  }
  return Qs = n, n.prototype._init = function(t, u, l) {
    var f = t.concat(u).concat(l);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for (var s = 0; s < this.V.length; s++)
      this.K[s] = 0, this.V[s] = 1;
    this._update(f), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, n.prototype._hmac = function() {
    return new e.hmac(this.hash, this.K);
  }, n.prototype._update = function(t) {
    var u = this._hmac().update(this.V).update([0]);
    t && (u = u.update(t)), this.K = u.digest(), this.V = this._hmac().update(this.V).digest(), t && (this.K = this._hmac().update(this.V).update([1]).update(t).digest(), this.V = this._hmac().update(this.V).digest());
  }, n.prototype.reseed = function(t, u, l, f) {
    typeof u != "string" && (f = l, l = u, u = null), t = r.toArray(t, u), l = r.toArray(l, f), o(
      t.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._update(t.concat(l || [])), this._reseed = 1;
  }, n.prototype.generate = function(t, u, l, f) {
    if (this._reseed > this.reseedInterval)
      throw new Error("Reseed is required");
    typeof u != "string" && (f = l, l = u, u = null), l && (l = r.toArray(l, f || "hex"), this._update(l));
    for (var s = []; s.length < t; )
      this.V = this._hmac().update(this.V).digest(), s = s.concat(this.V);
    var a = s.slice(0, t);
    return this._update(l), this._reseed++, r.encode(a, u);
  }, Qs;
}
var eu, Fv;
function PB() {
  if (Fv)
    return eu;
  Fv = 1;
  var e = Rr(), r = pt(), o = r.assert;
  function n(i, t) {
    this.ec = i, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
  }
  return eu = n, n.fromPublic = function(t, u, l) {
    return u instanceof n ? u : new n(t, {
      pub: u,
      pubEnc: l
    });
  }, n.fromPrivate = function(t, u, l) {
    return u instanceof n ? u : new n(t, {
      priv: u,
      privEnc: l
    });
  }, n.prototype.validate = function() {
    var t = this.getPublic();
    return t.isInfinity() ? { result: !1, reason: "Invalid public key" } : t.validate() ? t.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, n.prototype.getPublic = function(t, u) {
    return typeof t == "string" && (u = t, t = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), u ? this.pub.encode(u, t) : this.pub;
  }, n.prototype.getPrivate = function(t) {
    return t === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, n.prototype._importPrivate = function(t, u) {
    this.priv = new e(t, u || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, n.prototype._importPublic = function(t, u) {
    if (t.x || t.y) {
      this.ec.curve.type === "mont" ? o(t.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && o(t.x && t.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(t.x, t.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(t, u);
  }, n.prototype.derive = function(t) {
    return t.validate() || o(t.validate(), "public point not validated"), t.mul(this.priv).getX();
  }, n.prototype.sign = function(t, u, l) {
    return this.ec.sign(t, this, u, l);
  }, n.prototype.verify = function(t, u) {
    return this.ec.verify(t, u, this);
  }, n.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, eu;
}
var ru, Iv;
function qB() {
  if (Iv)
    return ru;
  Iv = 1;
  var e = Rr(), r = pt(), o = r.assert;
  function n(f, s) {
    if (f instanceof n)
      return f;
    this._importDER(f, s) || (o(f.r && f.s, "Signature without r or s"), this.r = new e(f.r, 16), this.s = new e(f.s, 16), f.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = f.recoveryParam);
  }
  ru = n;
  function i() {
    this.place = 0;
  }
  function t(f, s) {
    var a = f[s.place++];
    if (!(a & 128))
      return a;
    var c = a & 15;
    if (c === 0 || c > 4)
      return !1;
    for (var d = 0, h = 0, p = s.place; h < c; h++, p++)
      d <<= 8, d |= f[p], d >>>= 0;
    return d <= 127 ? !1 : (s.place = p, d);
  }
  function u(f) {
    for (var s = 0, a = f.length - 1; !f[s] && !(f[s + 1] & 128) && s < a; )
      s++;
    return s === 0 ? f : f.slice(s);
  }
  n.prototype._importDER = function(s, a) {
    s = r.toArray(s, a);
    var c = new i();
    if (s[c.place++] !== 48)
      return !1;
    var d = t(s, c);
    if (d === !1 || d + c.place !== s.length || s[c.place++] !== 2)
      return !1;
    var h = t(s, c);
    if (h === !1)
      return !1;
    var p = s.slice(c.place, h + c.place);
    if (c.place += h, s[c.place++] !== 2)
      return !1;
    var v = t(s, c);
    if (v === !1 || s.length !== v + c.place)
      return !1;
    var g = s.slice(c.place, v + c.place);
    if (p[0] === 0)
      if (p[1] & 128)
        p = p.slice(1);
      else
        return !1;
    if (g[0] === 0)
      if (g[1] & 128)
        g = g.slice(1);
      else
        return !1;
    return this.r = new e(p), this.s = new e(g), this.recoveryParam = null, !0;
  };
  function l(f, s) {
    if (s < 128) {
      f.push(s);
      return;
    }
    var a = 1 + (Math.log(s) / Math.LN2 >>> 3);
    for (f.push(a | 128); --a; )
      f.push(s >>> (a << 3) & 255);
    f.push(s);
  }
  return n.prototype.toDER = function(s) {
    var a = this.r.toArray(), c = this.s.toArray();
    for (a[0] & 128 && (a = [0].concat(a)), c[0] & 128 && (c = [0].concat(c)), a = u(a), c = u(c); !c[0] && !(c[1] & 128); )
      c = c.slice(1);
    var d = [2];
    l(d, a.length), d = d.concat(a), d.push(2), l(d, c.length);
    var h = d.concat(c), p = [48];
    return l(p, h.length), p = p.concat(h), r.encode(p, s);
  }, ru;
}
var tu, Ov;
function $B() {
  if (Ov)
    return tu;
  Ov = 1;
  var e = Rr(), r = RB(), o = pt(), n = oc(), i = tc(), t = o.assert, u = PB(), l = qB();
  function f(s) {
    if (!(this instanceof f))
      return new f(s);
    typeof s == "string" && (t(
      Object.prototype.hasOwnProperty.call(n, s),
      "Unknown curve " + s
    ), s = n[s]), s instanceof n.PresetCurve && (s = { curve: s }), this.curve = s.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = s.curve.g, this.g.precompute(s.curve.n.bitLength() + 1), this.hash = s.hash || s.curve.hash;
  }
  return tu = f, f.prototype.keyPair = function(a) {
    return new u(this, a);
  }, f.prototype.keyFromPrivate = function(a, c) {
    return u.fromPrivate(this, a, c);
  }, f.prototype.keyFromPublic = function(a, c) {
    return u.fromPublic(this, a, c);
  }, f.prototype.genKeyPair = function(a) {
    a || (a = {});
    for (var c = new r({
      hash: this.hash,
      pers: a.pers,
      persEnc: a.persEnc || "utf8",
      entropy: a.entropy || i(this.hash.hmacStrength),
      entropyEnc: a.entropy && a.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), d = this.n.byteLength(), h = this.n.sub(new e(2)); ; ) {
      var p = new e(c.generate(d));
      if (!(p.cmp(h) > 0))
        return p.iaddn(1), this.keyFromPrivate(p);
    }
  }, f.prototype._truncateToN = function(a, c) {
    var d = a.byteLength() * 8 - this.n.bitLength();
    return d > 0 && (a = a.ushrn(d)), !c && a.cmp(this.n) >= 0 ? a.sub(this.n) : a;
  }, f.prototype.sign = function(a, c, d, h) {
    typeof d == "object" && (h = d, d = null), h || (h = {}), c = this.keyFromPrivate(c, d), a = this._truncateToN(new e(a, 16));
    for (var p = this.n.byteLength(), v = c.getPrivate().toArray("be", p), g = a.toArray("be", p), m = new r({
      hash: this.hash,
      entropy: v,
      nonce: g,
      pers: h.pers,
      persEnc: h.persEnc || "utf8"
    }), x = this.n.sub(new e(1)), y = 0; ; y++) {
      var E = h.k ? h.k(y) : new e(m.generate(this.n.byteLength()));
      if (E = this._truncateToN(E, !0), !(E.cmpn(1) <= 0 || E.cmp(x) >= 0)) {
        var N = this.g.mul(E);
        if (!N.isInfinity()) {
          var S = N.getX(), R = S.umod(this.n);
          if (R.cmpn(0) !== 0) {
            var O = E.invm(this.n).mul(R.mul(c.getPrivate()).iadd(a));
            if (O = O.umod(this.n), O.cmpn(0) !== 0) {
              var B = (N.getY().isOdd() ? 1 : 0) | (S.cmp(R) !== 0 ? 2 : 0);
              return h.canonical && O.cmp(this.nh) > 0 && (O = this.n.sub(O), B ^= 1), new l({ r: R, s: O, recoveryParam: B });
            }
          }
        }
      }
    }
  }, f.prototype.verify = function(a, c, d, h) {
    a = this._truncateToN(new e(a, 16)), d = this.keyFromPublic(d, h), c = new l(c, "hex");
    var p = c.r, v = c.s;
    if (p.cmpn(1) < 0 || p.cmp(this.n) >= 0 || v.cmpn(1) < 0 || v.cmp(this.n) >= 0)
      return !1;
    var g = v.invm(this.n), m = g.mul(a).umod(this.n), x = g.mul(p).umod(this.n), y;
    return this.curve._maxwellTrick ? (y = this.g.jmulAdd(m, d.getPublic(), x), y.isInfinity() ? !1 : y.eqXToP(p)) : (y = this.g.mulAdd(m, d.getPublic(), x), y.isInfinity() ? !1 : y.getX().umod(this.n).cmp(p) === 0);
  }, f.prototype.recoverPubKey = function(s, a, c, d) {
    t((3 & c) === c, "The recovery param is more than two bits"), a = new l(a, d);
    var h = this.n, p = new e(s), v = a.r, g = a.s, m = c & 1, x = c >> 1;
    if (v.cmp(this.curve.p.umod(this.curve.n)) >= 0 && x)
      throw new Error("Unable to find sencond key candinate");
    x ? v = this.curve.pointFromX(v.add(this.curve.n), m) : v = this.curve.pointFromX(v, m);
    var y = a.r.invm(h), E = h.sub(p).mul(y).umod(h), N = g.mul(y).umod(h);
    return this.g.mulAdd(E, v, N);
  }, f.prototype.getKeyRecoveryParam = function(s, a, c, d) {
    if (a = new l(a, d), a.recoveryParam !== null)
      return a.recoveryParam;
    for (var h = 0; h < 4; h++) {
      var p;
      try {
        p = this.recoverPubKey(s, a, h);
      } catch {
        continue;
      }
      if (p.eq(c))
        return h;
    }
    throw new Error("Unable to find valid recovery factor");
  }, tu;
}
var nu, Rv;
function zB() {
  if (Rv)
    return nu;
  Rv = 1;
  var e = pt(), r = e.assert, o = e.parseBytes, n = e.cachedProperty;
  function i(t, u) {
    this.eddsa = t, this._secret = o(u.secret), t.isPoint(u.pub) ? this._pub = u.pub : this._pubBytes = o(u.pub);
  }
  return i.fromPublic = function(u, l) {
    return l instanceof i ? l : new i(u, { pub: l });
  }, i.fromSecret = function(u, l) {
    return l instanceof i ? l : new i(u, { secret: l });
  }, i.prototype.secret = function() {
    return this._secret;
  }, n(i, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), n(i, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), n(i, "privBytes", function() {
    var u = this.eddsa, l = this.hash(), f = u.encodingLength - 1, s = l.slice(0, u.encodingLength);
    return s[0] &= 248, s[f] &= 127, s[f] |= 64, s;
  }), n(i, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), n(i, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), n(i, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), i.prototype.sign = function(u) {
    return r(this._secret, "KeyPair can only verify"), this.eddsa.sign(u, this);
  }, i.prototype.verify = function(u, l) {
    return this.eddsa.verify(u, l, this);
  }, i.prototype.getSecret = function(u) {
    return r(this._secret, "KeyPair is public only"), e.encode(this.secret(), u);
  }, i.prototype.getPublic = function(u) {
    return e.encode(this.pubBytes(), u);
  }, nu = i, nu;
}
var iu, Pv;
function LB() {
  if (Pv)
    return iu;
  Pv = 1;
  var e = Rr(), r = pt(), o = r.assert, n = r.cachedProperty, i = r.parseBytes;
  function t(u, l) {
    this.eddsa = u, typeof l != "object" && (l = i(l)), Array.isArray(l) && (l = {
      R: l.slice(0, u.encodingLength),
      S: l.slice(u.encodingLength)
    }), o(l.R && l.S, "Signature without R or S"), u.isPoint(l.R) && (this._R = l.R), l.S instanceof e && (this._S = l.S), this._Rencoded = Array.isArray(l.R) ? l.R : l.Rencoded, this._Sencoded = Array.isArray(l.S) ? l.S : l.Sencoded;
  }
  return n(t, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), n(t, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), n(t, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), n(t, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), t.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, t.prototype.toHex = function() {
    return r.encode(this.toBytes(), "hex").toUpperCase();
  }, iu = t, iu;
}
var au, qv;
function UB() {
  if (qv)
    return au;
  qv = 1;
  var e = ac(), r = oc(), o = pt(), n = o.assert, i = o.parseBytes, t = zB(), u = LB();
  function l(f) {
    if (n(f === "ed25519", "only tested with ed25519 so far"), !(this instanceof l))
      return new l(f);
    f = r[f].curve, this.curve = f, this.g = f.g, this.g.precompute(f.n.bitLength() + 1), this.pointClass = f.point().constructor, this.encodingLength = Math.ceil(f.n.bitLength() / 8), this.hash = e.sha512;
  }
  return au = l, l.prototype.sign = function(s, a) {
    s = i(s);
    var c = this.keyFromSecret(a), d = this.hashInt(c.messagePrefix(), s), h = this.g.mul(d), p = this.encodePoint(h), v = this.hashInt(p, c.pubBytes(), s).mul(c.priv()), g = d.add(v).umod(this.curve.n);
    return this.makeSignature({ R: h, S: g, Rencoded: p });
  }, l.prototype.verify = function(s, a, c) {
    s = i(s), a = this.makeSignature(a);
    var d = this.keyFromPublic(c), h = this.hashInt(a.Rencoded(), d.pubBytes(), s), p = this.g.mul(a.S()), v = a.R().add(d.pub().mul(h));
    return v.eq(p);
  }, l.prototype.hashInt = function() {
    for (var s = this.hash(), a = 0; a < arguments.length; a++)
      s.update(arguments[a]);
    return o.intFromLE(s.digest()).umod(this.curve.n);
  }, l.prototype.keyFromPublic = function(s) {
    return t.fromPublic(this, s);
  }, l.prototype.keyFromSecret = function(s) {
    return t.fromSecret(this, s);
  }, l.prototype.makeSignature = function(s) {
    return s instanceof u ? s : new u(this, s);
  }, l.prototype.encodePoint = function(s) {
    var a = s.getY().toArray("le", this.encodingLength);
    return a[this.encodingLength - 1] |= s.getX().isOdd() ? 128 : 0, a;
  }, l.prototype.decodePoint = function(s) {
    s = o.parseBytes(s);
    var a = s.length - 1, c = s.slice(0, a).concat(s[a] & -129), d = (s[a] & 128) !== 0, h = o.intFromLE(c);
    return this.curve.pointFromY(h, d);
  }, l.prototype.encodeInt = function(s) {
    return s.toArray("le", this.encodingLength);
  }, l.prototype.decodeInt = function(s) {
    return o.intFromLE(s);
  }, l.prototype.isPoint = function(s) {
    return s instanceof this.pointClass;
  }, au;
}
var $v;
function sc() {
  return $v || ($v = 1, function(e) {
    var r = e;
    r.version = SB.version, r.utils = pt(), r.rand = tc(), r.curve = Wb(), r.curves = oc(), r.ec = $B(), r.eddsa = UB();
  }(Os)), Os;
}
var ft = {}, ou = {}, su = {}, uu = {}, fu, zv;
function uc() {
  if (zv)
    return fu;
  zv = 1;
  var e = Nn(), r = e.Buffer, o = {}, n;
  for (n in e)
    e.hasOwnProperty(n) && (n === "SlowBuffer" || n === "Buffer" || (o[n] = e[n]));
  var i = o.Buffer = {};
  for (n in r)
    r.hasOwnProperty(n) && (n === "allocUnsafe" || n === "allocUnsafeSlow" || (i[n] = r[n]));
  if (o.Buffer.prototype = r.prototype, (!i.from || i.from === Uint8Array.from) && (i.from = function(t, u, l) {
    if (typeof t == "number")
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof t);
    if (t && typeof t.length > "u")
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof t);
    return r(t, u, l);
  }), i.alloc || (i.alloc = function(t, u, l) {
    if (typeof t != "number")
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof t);
    if (t < 0 || t >= 2 * (1 << 30))
      throw new RangeError('The value "' + t + '" is invalid for option "size"');
    var f = r(t);
    return !u || u.length === 0 ? f.fill(0) : typeof l == "string" ? f.fill(u, l) : f.fill(u), f;
  }), !o.kStringMaxLength)
    try {
      o.kStringMaxLength = process.binding("buffer").kStringMaxLength;
    } catch {
    }
  return o.constants || (o.constants = {
    MAX_LENGTH: o.kMaxLength
  }, o.kStringMaxLength && (o.constants.MAX_STRING_LENGTH = o.kStringMaxLength)), fu = o, fu;
}
var cu = {}, Lv;
function fc() {
  if (Lv)
    return cu;
  Lv = 1;
  const e = Je();
  function r(n) {
    this._reporterState = {
      obj: null,
      path: [],
      options: n || {},
      errors: []
    };
  }
  cu.Reporter = r, r.prototype.isError = function(i) {
    return i instanceof o;
  }, r.prototype.save = function() {
    const i = this._reporterState;
    return { obj: i.obj, pathLen: i.path.length };
  }, r.prototype.restore = function(i) {
    const t = this._reporterState;
    t.obj = i.obj, t.path = t.path.slice(0, i.pathLen);
  }, r.prototype.enterKey = function(i) {
    return this._reporterState.path.push(i);
  }, r.prototype.exitKey = function(i) {
    const t = this._reporterState;
    t.path = t.path.slice(0, i - 1);
  }, r.prototype.leaveKey = function(i, t, u) {
    const l = this._reporterState;
    this.exitKey(i), l.obj !== null && (l.obj[t] = u);
  }, r.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, r.prototype.enterObject = function() {
    const i = this._reporterState, t = i.obj;
    return i.obj = {}, t;
  }, r.prototype.leaveObject = function(i) {
    const t = this._reporterState, u = t.obj;
    return t.obj = i, u;
  }, r.prototype.error = function(i) {
    let t;
    const u = this._reporterState, l = i instanceof o;
    if (l ? t = i : t = new o(u.path.map(function(f) {
      return "[" + JSON.stringify(f) + "]";
    }).join(""), i.message || i, i.stack), !u.options.partial)
      throw t;
    return l || u.errors.push(t), t;
  }, r.prototype.wrapResult = function(i) {
    const t = this._reporterState;
    return t.options.partial ? {
      result: this.isError(i) ? null : i,
      errors: t.errors
    } : i;
  };
  function o(n, i) {
    this.path = n, this.rethrow(i);
  }
  return e(o, Error), o.prototype.rethrow = function(i) {
    if (this.message = i + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, o), !this.stack)
      try {
        throw new Error(this.message);
      } catch (t) {
        this.stack = t.stack;
      }
    return this;
  }, cu;
}
var ma = {}, Uv;
function Ai() {
  if (Uv)
    return ma;
  Uv = 1;
  const e = Je(), r = fc().Reporter, o = uc().Buffer;
  function n(t, u) {
    if (r.call(this, u), !o.isBuffer(t)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = t, this.offset = 0, this.length = t.length;
  }
  e(n, r), ma.DecoderBuffer = n, n.isDecoderBuffer = function(u) {
    return u instanceof n ? !0 : typeof u == "object" && o.isBuffer(u.base) && u.constructor.name === "DecoderBuffer" && typeof u.offset == "number" && typeof u.length == "number" && typeof u.save == "function" && typeof u.restore == "function" && typeof u.isEmpty == "function" && typeof u.readUInt8 == "function" && typeof u.skip == "function" && typeof u.raw == "function";
  }, n.prototype.save = function() {
    return { offset: this.offset, reporter: r.prototype.save.call(this) };
  }, n.prototype.restore = function(u) {
    const l = new n(this.base);
    return l.offset = u.offset, l.length = this.offset, this.offset = u.offset, r.prototype.restore.call(this, u.reporter), l;
  }, n.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, n.prototype.readUInt8 = function(u) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(u || "DecoderBuffer overrun");
  }, n.prototype.skip = function(u, l) {
    if (!(this.offset + u <= this.length))
      return this.error(l || "DecoderBuffer overrun");
    const f = new n(this.base);
    return f._reporterState = this._reporterState, f.offset = this.offset, f.length = this.offset + u, this.offset += u, f;
  }, n.prototype.raw = function(u) {
    return this.base.slice(u ? u.offset : this.offset, this.length);
  };
  function i(t, u) {
    if (Array.isArray(t))
      this.length = 0, this.value = t.map(function(l) {
        return i.isEncoderBuffer(l) || (l = new i(l, u)), this.length += l.length, l;
      }, this);
    else if (typeof t == "number") {
      if (!(0 <= t && t <= 255))
        return u.error("non-byte EncoderBuffer value");
      this.value = t, this.length = 1;
    } else if (typeof t == "string")
      this.value = t, this.length = o.byteLength(t);
    else if (o.isBuffer(t))
      this.value = t, this.length = t.length;
    else
      return u.error("Unsupported type: " + typeof t);
  }
  return ma.EncoderBuffer = i, i.isEncoderBuffer = function(u) {
    return u instanceof i ? !0 : typeof u == "object" && u.constructor.name === "EncoderBuffer" && typeof u.length == "number" && typeof u.join == "function";
  }, i.prototype.join = function(u, l) {
    return u || (u = o.alloc(this.length)), l || (l = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(f) {
      f.join(u, l), l += f.length;
    }) : (typeof this.value == "number" ? u[l] = this.value : typeof this.value == "string" ? u.write(this.value, l) : o.isBuffer(this.value) && this.value.copy(u, l), l += this.length)), u;
  }, ma;
}
var lu, kv;
function cc() {
  if (kv)
    return lu;
  kv = 1;
  const e = fc().Reporter, r = Ai().EncoderBuffer, o = Ai().DecoderBuffer, n = ht(), i = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], t = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(i), u = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function l(s, a, c) {
    const d = {};
    this._baseState = d, d.name = c, d.enc = s, d.parent = a || null, d.children = null, d.tag = null, d.args = null, d.reverseArgs = null, d.choice = null, d.optional = !1, d.any = !1, d.obj = !1, d.use = null, d.useDecoder = null, d.key = null, d.default = null, d.explicit = null, d.implicit = null, d.contains = null, d.parent || (d.children = [], this._wrap());
  }
  lu = l;
  const f = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return l.prototype.clone = function() {
    const a = this._baseState, c = {};
    f.forEach(function(h) {
      c[h] = a[h];
    });
    const d = new this.constructor(c.parent);
    return d._baseState = c, d;
  }, l.prototype._wrap = function() {
    const a = this._baseState;
    t.forEach(function(c) {
      this[c] = function() {
        const h = new this.constructor(this);
        return a.children.push(h), h[c].apply(h, arguments);
      };
    }, this);
  }, l.prototype._init = function(a) {
    const c = this._baseState;
    n(c.parent === null), a.call(this), c.children = c.children.filter(function(d) {
      return d._baseState.parent === this;
    }, this), n.equal(c.children.length, 1, "Root node can have only one child");
  }, l.prototype._useArgs = function(a) {
    const c = this._baseState, d = a.filter(function(h) {
      return h instanceof this.constructor;
    }, this);
    a = a.filter(function(h) {
      return !(h instanceof this.constructor);
    }, this), d.length !== 0 && (n(c.children === null), c.children = d, d.forEach(function(h) {
      h._baseState.parent = this;
    }, this)), a.length !== 0 && (n(c.args === null), c.args = a, c.reverseArgs = a.map(function(h) {
      if (typeof h != "object" || h.constructor !== Object)
        return h;
      const p = {};
      return Object.keys(h).forEach(function(v) {
        v == (v | 0) && (v |= 0);
        const g = h[v];
        p[g] = v;
      }), p;
    }));
  }, u.forEach(function(s) {
    l.prototype[s] = function() {
      const c = this._baseState;
      throw new Error(s + " not implemented for encoding: " + c.enc);
    };
  }), i.forEach(function(s) {
    l.prototype[s] = function() {
      const c = this._baseState, d = Array.prototype.slice.call(arguments);
      return n(c.tag === null), c.tag = s, this._useArgs(d), this;
    };
  }), l.prototype.use = function(a) {
    n(a);
    const c = this._baseState;
    return n(c.use === null), c.use = a, this;
  }, l.prototype.optional = function() {
    const a = this._baseState;
    return a.optional = !0, this;
  }, l.prototype.def = function(a) {
    const c = this._baseState;
    return n(c.default === null), c.default = a, c.optional = !0, this;
  }, l.prototype.explicit = function(a) {
    const c = this._baseState;
    return n(c.explicit === null && c.implicit === null), c.explicit = a, this;
  }, l.prototype.implicit = function(a) {
    const c = this._baseState;
    return n(c.explicit === null && c.implicit === null), c.implicit = a, this;
  }, l.prototype.obj = function() {
    const a = this._baseState, c = Array.prototype.slice.call(arguments);
    return a.obj = !0, c.length !== 0 && this._useArgs(c), this;
  }, l.prototype.key = function(a) {
    const c = this._baseState;
    return n(c.key === null), c.key = a, this;
  }, l.prototype.any = function() {
    const a = this._baseState;
    return a.any = !0, this;
  }, l.prototype.choice = function(a) {
    const c = this._baseState;
    return n(c.choice === null), c.choice = a, this._useArgs(Object.keys(a).map(function(d) {
      return a[d];
    })), this;
  }, l.prototype.contains = function(a) {
    const c = this._baseState;
    return n(c.use === null), c.contains = a, this;
  }, l.prototype._decode = function(a, c) {
    const d = this._baseState;
    if (d.parent === null)
      return a.wrapResult(d.children[0]._decode(a, c));
    let h = d.default, p = !0, v = null;
    if (d.key !== null && (v = a.enterKey(d.key)), d.optional) {
      let m = null;
      if (d.explicit !== null ? m = d.explicit : d.implicit !== null ? m = d.implicit : d.tag !== null && (m = d.tag), m === null && !d.any) {
        const x = a.save();
        try {
          d.choice === null ? this._decodeGeneric(d.tag, a, c) : this._decodeChoice(a, c), p = !0;
        } catch {
          p = !1;
        }
        a.restore(x);
      } else if (p = this._peekTag(a, m, d.any), a.isError(p))
        return p;
    }
    let g;
    if (d.obj && p && (g = a.enterObject()), p) {
      if (d.explicit !== null) {
        const x = this._decodeTag(a, d.explicit);
        if (a.isError(x))
          return x;
        a = x;
      }
      const m = a.offset;
      if (d.use === null && d.choice === null) {
        let x;
        d.any && (x = a.save());
        const y = this._decodeTag(
          a,
          d.implicit !== null ? d.implicit : d.tag,
          d.any
        );
        if (a.isError(y))
          return y;
        d.any ? h = a.raw(x) : a = y;
      }
      if (c && c.track && d.tag !== null && c.track(a.path(), m, a.length, "tagged"), c && c.track && d.tag !== null && c.track(a.path(), a.offset, a.length, "content"), d.any || (d.choice === null ? h = this._decodeGeneric(d.tag, a, c) : h = this._decodeChoice(a, c)), a.isError(h))
        return h;
      if (!d.any && d.choice === null && d.children !== null && d.children.forEach(function(y) {
        y._decode(a, c);
      }), d.contains && (d.tag === "octstr" || d.tag === "bitstr")) {
        const x = new o(h);
        h = this._getUse(d.contains, a._reporterState.obj)._decode(x, c);
      }
    }
    return d.obj && p && (h = a.leaveObject(g)), d.key !== null && (h !== null || p === !0) ? a.leaveKey(v, d.key, h) : v !== null && a.exitKey(v), h;
  }, l.prototype._decodeGeneric = function(a, c, d) {
    const h = this._baseState;
    return a === "seq" || a === "set" ? null : a === "seqof" || a === "setof" ? this._decodeList(c, a, h.args[0], d) : /str$/.test(a) ? this._decodeStr(c, a, d) : a === "objid" && h.args ? this._decodeObjid(c, h.args[0], h.args[1], d) : a === "objid" ? this._decodeObjid(c, null, null, d) : a === "gentime" || a === "utctime" ? this._decodeTime(c, a, d) : a === "null_" ? this._decodeNull(c, d) : a === "bool" ? this._decodeBool(c, d) : a === "objDesc" ? this._decodeStr(c, a, d) : a === "int" || a === "enum" ? this._decodeInt(c, h.args && h.args[0], d) : h.use !== null ? this._getUse(h.use, c._reporterState.obj)._decode(c, d) : c.error("unknown tag: " + a);
  }, l.prototype._getUse = function(a, c) {
    const d = this._baseState;
    return d.useDecoder = this._use(a, c), n(d.useDecoder._baseState.parent === null), d.useDecoder = d.useDecoder._baseState.children[0], d.implicit !== d.useDecoder._baseState.implicit && (d.useDecoder = d.useDecoder.clone(), d.useDecoder._baseState.implicit = d.implicit), d.useDecoder;
  }, l.prototype._decodeChoice = function(a, c) {
    const d = this._baseState;
    let h = null, p = !1;
    return Object.keys(d.choice).some(function(v) {
      const g = a.save(), m = d.choice[v];
      try {
        const x = m._decode(a, c);
        if (a.isError(x))
          return !1;
        h = { type: v, value: x }, p = !0;
      } catch {
        return a.restore(g), !1;
      }
      return !0;
    }, this), p ? h : a.error("Choice not matched");
  }, l.prototype._createEncoderBuffer = function(a) {
    return new r(a, this.reporter);
  }, l.prototype._encode = function(a, c, d) {
    const h = this._baseState;
    if (h.default !== null && h.default === a)
      return;
    const p = this._encodeValue(a, c, d);
    if (p !== void 0 && !this._skipDefault(p, c, d))
      return p;
  }, l.prototype._encodeValue = function(a, c, d) {
    const h = this._baseState;
    if (h.parent === null)
      return h.children[0]._encode(a, c || new e());
    let p = null;
    if (this.reporter = c, h.optional && a === void 0)
      if (h.default !== null)
        a = h.default;
      else
        return;
    let v = null, g = !1;
    if (h.any)
      p = this._createEncoderBuffer(a);
    else if (h.choice)
      p = this._encodeChoice(a, c);
    else if (h.contains)
      v = this._getUse(h.contains, d)._encode(a, c), g = !0;
    else if (h.children)
      v = h.children.map(function(m) {
        if (m._baseState.tag === "null_")
          return m._encode(null, c, a);
        if (m._baseState.key === null)
          return c.error("Child should have a key");
        const x = c.enterKey(m._baseState.key);
        if (typeof a != "object")
          return c.error("Child expected, but input is not object");
        const y = m._encode(a[m._baseState.key], c, a);
        return c.leaveKey(x), y;
      }, this).filter(function(m) {
        return m;
      }), v = this._createEncoderBuffer(v);
    else if (h.tag === "seqof" || h.tag === "setof") {
      if (!(h.args && h.args.length === 1))
        return c.error("Too many args for : " + h.tag);
      if (!Array.isArray(a))
        return c.error("seqof/setof, but data is not Array");
      const m = this.clone();
      m._baseState.implicit = null, v = this._createEncoderBuffer(a.map(function(x) {
        const y = this._baseState;
        return this._getUse(y.args[0], a)._encode(x, c);
      }, m));
    } else
      h.use !== null ? p = this._getUse(h.use, d)._encode(a, c) : (v = this._encodePrimitive(h.tag, a), g = !0);
    if (!h.any && h.choice === null) {
      const m = h.implicit !== null ? h.implicit : h.tag, x = h.implicit === null ? "universal" : "context";
      m === null ? h.use === null && c.error("Tag could be omitted only for .use()") : h.use === null && (p = this._encodeComposite(m, g, x, v));
    }
    return h.explicit !== null && (p = this._encodeComposite(h.explicit, !1, "context", p)), p;
  }, l.prototype._encodeChoice = function(a, c) {
    const d = this._baseState, h = d.choice[a.type];
    return h || n(
      !1,
      a.type + " not found in " + JSON.stringify(Object.keys(d.choice))
    ), h._encode(a.value, c);
  }, l.prototype._encodePrimitive = function(a, c) {
    const d = this._baseState;
    if (/str$/.test(a))
      return this._encodeStr(c, a);
    if (a === "objid" && d.args)
      return this._encodeObjid(c, d.reverseArgs[0], d.args[1]);
    if (a === "objid")
      return this._encodeObjid(c, null, null);
    if (a === "gentime" || a === "utctime")
      return this._encodeTime(c, a);
    if (a === "null_")
      return this._encodeNull();
    if (a === "int" || a === "enum")
      return this._encodeInt(c, d.args && d.reverseArgs[0]);
    if (a === "bool")
      return this._encodeBool(c);
    if (a === "objDesc")
      return this._encodeStr(c, a);
    throw new Error("Unsupported tag: " + a);
  }, l.prototype._isNumstr = function(a) {
    return /^[0-9 ]*$/.test(a);
  }, l.prototype._isPrintstr = function(a) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(a);
  }, lu;
}
var du = {}, Hv;
function lc() {
  return Hv || (Hv = 1, function(e) {
    function r(o) {
      const n = {};
      return Object.keys(o).forEach(function(i) {
        (i | 0) == i && (i = i | 0);
        const t = o[i];
        n[t] = i;
      }), n;
    }
    e.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, e.tagClassByName = r(e.tagClass), e.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, e.tagByName = r(e.tag);
  }(du)), du;
}
var hu, Gv;
function Yb() {
  if (Gv)
    return hu;
  Gv = 1;
  const e = Je(), r = uc().Buffer, o = cc(), n = lc();
  function i(f) {
    this.enc = "der", this.name = f.name, this.entity = f, this.tree = new t(), this.tree._init(f.body);
  }
  hu = i, i.prototype.encode = function(s, a) {
    return this.tree._encode(s, a).join();
  };
  function t(f) {
    o.call(this, "der", f);
  }
  e(t, o), t.prototype._encodeComposite = function(s, a, c, d) {
    const h = l(s, a, c, this.reporter);
    if (d.length < 128) {
      const g = r.alloc(2);
      return g[0] = h, g[1] = d.length, this._createEncoderBuffer([g, d]);
    }
    let p = 1;
    for (let g = d.length; g >= 256; g >>= 8)
      p++;
    const v = r.alloc(2 + p);
    v[0] = h, v[1] = 128 | p;
    for (let g = 1 + p, m = d.length; m > 0; g--, m >>= 8)
      v[g] = m & 255;
    return this._createEncoderBuffer([v, d]);
  }, t.prototype._encodeStr = function(s, a) {
    if (a === "bitstr")
      return this._createEncoderBuffer([s.unused | 0, s.data]);
    if (a === "bmpstr") {
      const c = r.alloc(s.length * 2);
      for (let d = 0; d < s.length; d++)
        c.writeUInt16BE(s.charCodeAt(d), d * 2);
      return this._createEncoderBuffer(c);
    } else
      return a === "numstr" ? this._isNumstr(s) ? this._createEncoderBuffer(s) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : a === "printstr" ? this._isPrintstr(s) ? this._createEncoderBuffer(s) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(a) ? this._createEncoderBuffer(s) : a === "objDesc" ? this._createEncoderBuffer(s) : this.reporter.error("Encoding of string type: " + a + " unsupported");
  }, t.prototype._encodeObjid = function(s, a, c) {
    if (typeof s == "string") {
      if (!a)
        return this.reporter.error("string objid given, but no values map found");
      if (!a.hasOwnProperty(s))
        return this.reporter.error("objid not found in values map");
      s = a[s].split(/[\s.]+/g);
      for (let v = 0; v < s.length; v++)
        s[v] |= 0;
    } else if (Array.isArray(s)) {
      s = s.slice();
      for (let v = 0; v < s.length; v++)
        s[v] |= 0;
    }
    if (!Array.isArray(s))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(s));
    if (!c) {
      if (s[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      s.splice(0, 2, s[0] * 40 + s[1]);
    }
    let d = 0;
    for (let v = 0; v < s.length; v++) {
      let g = s[v];
      for (d++; g >= 128; g >>= 7)
        d++;
    }
    const h = r.alloc(d);
    let p = h.length - 1;
    for (let v = s.length - 1; v >= 0; v--) {
      let g = s[v];
      for (h[p--] = g & 127; (g >>= 7) > 0; )
        h[p--] = 128 | g & 127;
    }
    return this._createEncoderBuffer(h);
  };
  function u(f) {
    return f < 10 ? "0" + f : f;
  }
  t.prototype._encodeTime = function(s, a) {
    let c;
    const d = new Date(s);
    return a === "gentime" ? c = [
      u(d.getUTCFullYear()),
      u(d.getUTCMonth() + 1),
      u(d.getUTCDate()),
      u(d.getUTCHours()),
      u(d.getUTCMinutes()),
      u(d.getUTCSeconds()),
      "Z"
    ].join("") : a === "utctime" ? c = [
      u(d.getUTCFullYear() % 100),
      u(d.getUTCMonth() + 1),
      u(d.getUTCDate()),
      u(d.getUTCHours()),
      u(d.getUTCMinutes()),
      u(d.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + a + " time is not supported yet"), this._encodeStr(c, "octstr");
  }, t.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, t.prototype._encodeInt = function(s, a) {
    if (typeof s == "string") {
      if (!a)
        return this.reporter.error("String int or enum given, but no values map");
      if (!a.hasOwnProperty(s))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(s));
      s = a[s];
    }
    if (typeof s != "number" && !r.isBuffer(s)) {
      const h = s.toArray();
      !s.sign && h[0] & 128 && h.unshift(0), s = r.from(h);
    }
    if (r.isBuffer(s)) {
      let h = s.length;
      s.length === 0 && h++;
      const p = r.alloc(h);
      return s.copy(p), s.length === 0 && (p[0] = 0), this._createEncoderBuffer(p);
    }
    if (s < 128)
      return this._createEncoderBuffer(s);
    if (s < 256)
      return this._createEncoderBuffer([0, s]);
    let c = 1;
    for (let h = s; h >= 256; h >>= 8)
      c++;
    const d = new Array(c);
    for (let h = d.length - 1; h >= 0; h--)
      d[h] = s & 255, s >>= 8;
    return d[0] & 128 && d.unshift(0), this._createEncoderBuffer(r.from(d));
  }, t.prototype._encodeBool = function(s) {
    return this._createEncoderBuffer(s ? 255 : 0);
  }, t.prototype._use = function(s, a) {
    return typeof s == "function" && (s = s(a)), s._getEncoder("der").tree;
  }, t.prototype._skipDefault = function(s, a, c) {
    const d = this._baseState;
    let h;
    if (d.default === null)
      return !1;
    const p = s.join();
    if (d.defaultBuffer === void 0 && (d.defaultBuffer = this._encodeValue(d.default, a, c).join()), p.length !== d.defaultBuffer.length)
      return !1;
    for (h = 0; h < p.length; h++)
      if (p[h] !== d.defaultBuffer[h])
        return !1;
    return !0;
  };
  function l(f, s, a, c) {
    let d;
    if (f === "seqof" ? f = "seq" : f === "setof" && (f = "set"), n.tagByName.hasOwnProperty(f))
      d = n.tagByName[f];
    else if (typeof f == "number" && (f | 0) === f)
      d = f;
    else
      return c.error("Unknown tag: " + f);
    return d >= 31 ? c.error("Multi-octet tag encoding unsupported") : (s || (d |= 32), d |= n.tagClassByName[a || "universal"] << 6, d);
  }
  return hu;
}
var pu, Vv;
function kB() {
  if (Vv)
    return pu;
  Vv = 1;
  const e = Je(), r = Yb();
  function o(n) {
    r.call(this, n), this.enc = "pem";
  }
  return e(o, r), pu = o, o.prototype.encode = function(i, t) {
    const l = r.prototype.encode.call(this, i).toString("base64"), f = ["-----BEGIN " + t.label + "-----"];
    for (let s = 0; s < l.length; s += 64)
      f.push(l.slice(s, s + 64));
    return f.push("-----END " + t.label + "-----"), f.join(`
`);
  }, pu;
}
var Wv;
function Xb() {
  return Wv || (Wv = 1, function(e) {
    const r = e;
    r.der = Yb(), r.pem = kB();
  }(uu)), uu;
}
var vu = {}, mu, Kv;
function Jb() {
  if (Kv)
    return mu;
  Kv = 1;
  const e = Je(), r = Rr(), o = Ai().DecoderBuffer, n = cc(), i = lc();
  function t(s) {
    this.enc = "der", this.name = s.name, this.entity = s, this.tree = new u(), this.tree._init(s.body);
  }
  mu = t, t.prototype.decode = function(a, c) {
    return o.isDecoderBuffer(a) || (a = new o(a, c)), this.tree._decode(a, c);
  };
  function u(s) {
    n.call(this, "der", s);
  }
  e(u, n), u.prototype._peekTag = function(a, c, d) {
    if (a.isEmpty())
      return !1;
    const h = a.save(), p = l(a, 'Failed to peek tag: "' + c + '"');
    return a.isError(p) ? p : (a.restore(h), p.tag === c || p.tagStr === c || p.tagStr + "of" === c || d);
  }, u.prototype._decodeTag = function(a, c, d) {
    const h = l(
      a,
      'Failed to decode tag of "' + c + '"'
    );
    if (a.isError(h))
      return h;
    let p = f(
      a,
      h.primitive,
      'Failed to get length of "' + c + '"'
    );
    if (a.isError(p))
      return p;
    if (!d && h.tag !== c && h.tagStr !== c && h.tagStr + "of" !== c)
      return a.error('Failed to match tag: "' + c + '"');
    if (h.primitive || p !== null)
      return a.skip(p, 'Failed to match body of: "' + c + '"');
    const v = a.save(), g = this._skipUntilEnd(
      a,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return a.isError(g) ? g : (p = a.offset - v.offset, a.restore(v), a.skip(p, 'Failed to match body of: "' + c + '"'));
  }, u.prototype._skipUntilEnd = function(a, c) {
    for (; ; ) {
      const d = l(a, c);
      if (a.isError(d))
        return d;
      const h = f(a, d.primitive, c);
      if (a.isError(h))
        return h;
      let p;
      if (d.primitive || h !== null ? p = a.skip(h) : p = this._skipUntilEnd(a, c), a.isError(p))
        return p;
      if (d.tagStr === "end")
        break;
    }
  }, u.prototype._decodeList = function(a, c, d, h) {
    const p = [];
    for (; !a.isEmpty(); ) {
      const v = this._peekTag(a, "end");
      if (a.isError(v))
        return v;
      const g = d.decode(a, "der", h);
      if (a.isError(g) && v)
        break;
      p.push(g);
    }
    return p;
  }, u.prototype._decodeStr = function(a, c) {
    if (c === "bitstr") {
      const d = a.readUInt8();
      return a.isError(d) ? d : { unused: d, data: a.raw() };
    } else if (c === "bmpstr") {
      const d = a.raw();
      if (d.length % 2 === 1)
        return a.error("Decoding of string type: bmpstr length mismatch");
      let h = "";
      for (let p = 0; p < d.length / 2; p++)
        h += String.fromCharCode(d.readUInt16BE(p * 2));
      return h;
    } else if (c === "numstr") {
      const d = a.raw().toString("ascii");
      return this._isNumstr(d) ? d : a.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (c === "octstr")
        return a.raw();
      if (c === "objDesc")
        return a.raw();
      if (c === "printstr") {
        const d = a.raw().toString("ascii");
        return this._isPrintstr(d) ? d : a.error("Decoding of string type: printstr unsupported characters");
      } else
        return /str$/.test(c) ? a.raw().toString() : a.error("Decoding of string type: " + c + " unsupported");
    }
  }, u.prototype._decodeObjid = function(a, c, d) {
    let h;
    const p = [];
    let v = 0, g = 0;
    for (; !a.isEmpty(); )
      g = a.readUInt8(), v <<= 7, v |= g & 127, g & 128 || (p.push(v), v = 0);
    g & 128 && p.push(v);
    const m = p[0] / 40 | 0, x = p[0] % 40;
    if (d ? h = p : h = [m, x].concat(p.slice(1)), c) {
      let y = c[h.join(" ")];
      y === void 0 && (y = c[h.join(".")]), y !== void 0 && (h = y);
    }
    return h;
  }, u.prototype._decodeTime = function(a, c) {
    const d = a.raw().toString();
    let h, p, v, g, m, x;
    if (c === "gentime")
      h = d.slice(0, 4) | 0, p = d.slice(4, 6) | 0, v = d.slice(6, 8) | 0, g = d.slice(8, 10) | 0, m = d.slice(10, 12) | 0, x = d.slice(12, 14) | 0;
    else if (c === "utctime")
      h = d.slice(0, 2) | 0, p = d.slice(2, 4) | 0, v = d.slice(4, 6) | 0, g = d.slice(6, 8) | 0, m = d.slice(8, 10) | 0, x = d.slice(10, 12) | 0, h < 70 ? h = 2e3 + h : h = 1900 + h;
    else
      return a.error("Decoding " + c + " time is not supported yet");
    return Date.UTC(h, p - 1, v, g, m, x, 0);
  }, u.prototype._decodeNull = function() {
    return null;
  }, u.prototype._decodeBool = function(a) {
    const c = a.readUInt8();
    return a.isError(c) ? c : c !== 0;
  }, u.prototype._decodeInt = function(a, c) {
    const d = a.raw();
    let h = new r(d);
    return c && (h = c[h.toString(10)] || h), h;
  }, u.prototype._use = function(a, c) {
    return typeof a == "function" && (a = a(c)), a._getDecoder("der").tree;
  };
  function l(s, a) {
    let c = s.readUInt8(a);
    if (s.isError(c))
      return c;
    const d = i.tagClass[c >> 6], h = (c & 32) === 0;
    if ((c & 31) === 31) {
      let v = c;
      for (c = 0; (v & 128) === 128; ) {
        if (v = s.readUInt8(a), s.isError(v))
          return v;
        c <<= 7, c |= v & 127;
      }
    } else
      c &= 31;
    const p = i.tag[c];
    return {
      cls: d,
      primitive: h,
      tag: c,
      tagStr: p
    };
  }
  function f(s, a, c) {
    let d = s.readUInt8(c);
    if (s.isError(d))
      return d;
    if (!a && d === 128)
      return null;
    if (!(d & 128))
      return d;
    const h = d & 127;
    if (h > 4)
      return s.error("length octect is too long");
    d = 0;
    for (let p = 0; p < h; p++) {
      d <<= 8;
      const v = s.readUInt8(c);
      if (s.isError(v))
        return v;
      d |= v;
    }
    return d;
  }
  return mu;
}
var gu, Zv;
function HB() {
  if (Zv)
    return gu;
  Zv = 1;
  const e = Je(), r = uc().Buffer, o = Jb();
  function n(i) {
    o.call(this, i), this.enc = "pem";
  }
  return e(n, o), gu = n, n.prototype.decode = function(t, u) {
    const l = t.toString().split(/[\r\n]+/g), f = u.label.toUpperCase(), s = /^-----(BEGIN|END) ([^-]+)-----$/;
    let a = -1, c = -1;
    for (let p = 0; p < l.length; p++) {
      const v = l[p].match(s);
      if (v !== null && v[2] === f)
        if (a === -1) {
          if (v[1] !== "BEGIN")
            break;
          a = p;
        } else {
          if (v[1] !== "END")
            break;
          c = p;
          break;
        }
    }
    if (a === -1 || c === -1)
      throw new Error("PEM section not found for: " + f);
    const d = l.slice(a + 1, c).join("");
    d.replace(/[^a-z0-9+/=]+/gi, "");
    const h = r.from(d, "base64");
    return o.prototype.decode.call(this, h, u);
  }, gu;
}
var jv;
function Qb() {
  return jv || (jv = 1, function(e) {
    const r = e;
    r.der = Jb(), r.pem = HB();
  }(vu)), vu;
}
var Yv;
function GB() {
  return Yv || (Yv = 1, function(e) {
    const r = Xb(), o = Qb(), n = Je(), i = e;
    i.define = function(l, f) {
      return new t(l, f);
    };
    function t(u, l) {
      this.name = u, this.body = l, this.decoders = {}, this.encoders = {};
    }
    t.prototype._createNamed = function(l) {
      const f = this.name;
      function s(a) {
        this._initNamed(a, f);
      }
      return n(s, l), s.prototype._initNamed = function(c, d) {
        l.call(this, c, d);
      }, new s(this);
    }, t.prototype._getDecoder = function(l) {
      return l = l || "der", this.decoders.hasOwnProperty(l) || (this.decoders[l] = this._createNamed(o[l])), this.decoders[l];
    }, t.prototype.decode = function(l, f, s) {
      return this._getDecoder(f).decode(l, s);
    }, t.prototype._getEncoder = function(l) {
      return l = l || "der", this.encoders.hasOwnProperty(l) || (this.encoders[l] = this._createNamed(r[l])), this.encoders[l];
    }, t.prototype.encode = function(l, f, s) {
      return this._getEncoder(f).encode(l, s);
    };
  }(su)), su;
}
var bu = {}, Xv;
function VB() {
  return Xv || (Xv = 1, function(e) {
    const r = e;
    r.Reporter = fc().Reporter, r.DecoderBuffer = Ai().DecoderBuffer, r.EncoderBuffer = Ai().EncoderBuffer, r.Node = cc();
  }(bu)), bu;
}
var yu = {}, Jv;
function WB() {
  return Jv || (Jv = 1, function(e) {
    const r = e;
    r._reverse = function(n) {
      const i = {};
      return Object.keys(n).forEach(function(t) {
        (t | 0) == t && (t = t | 0);
        const u = n[t];
        i[u] = t;
      }), i;
    }, r.der = lc();
  }(yu)), yu;
}
var Qv;
function ey() {
  return Qv || (Qv = 1, function(e) {
    const r = e;
    r.bignum = Rr(), r.define = GB().define, r.base = VB(), r.constants = WB(), r.decoders = Qb(), r.encoders = Xb();
  }(ou)), ou;
}
var wu, em;
function KB() {
  if (em)
    return wu;
  em = 1;
  var e = ey(), r = e.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), o = e.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), n = e.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), i = e.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(n),
      this.key("subjectPublicKey").bitstr()
    );
  }), t = e.define("RelativeDistinguishedName", function() {
    this.setof(o);
  }), u = e.define("RDNSequence", function() {
    this.seqof(t);
  }), l = e.define("Name", function() {
    this.choice({
      rdnSequence: this.use(u)
    });
  }), f = e.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(r),
      this.key("notAfter").use(r)
    );
  }), s = e.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), a = e.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(n),
      this.key("issuer").use(l),
      this.key("validity").use(f),
      this.key("subject").use(l),
      this.key("subjectPublicKeyInfo").use(i),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(s).optional()
    );
  }), c = e.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(a),
      this.key("signatureAlgorithm").use(n),
      this.key("signatureValue").bitstr()
    );
  });
  return wu = c, wu;
}
var rm;
function ZB() {
  if (rm)
    return ft;
  rm = 1;
  var e = ey();
  ft.certificate = KB();
  var r = e.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  ft.RSAPrivateKey = r;
  var o = e.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  ft.RSAPublicKey = o;
  var n = e.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(i),
      this.key("subjectPublicKey").bitstr()
    );
  });
  ft.PublicKey = n;
  var i = e.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), t = e.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(i),
      this.key("subjectPrivateKey").octstr()
    );
  });
  ft.PrivateKey = t;
  var u = e.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  ft.EncryptedPrivateKey = u;
  var l = e.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  ft.DSAPrivateKey = l, ft.DSAparam = e.define("DSAparam", function() {
    this.int();
  });
  var f = e.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(s),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  ft.ECPrivateKey = f;
  var s = e.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  });
  return ft.signature = e.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), ft;
}
const jB = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var xu, tm;
function YB() {
  if (tm)
    return xu;
  tm = 1;
  var e = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, r = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, o = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, n = uo(), i = rc(), t = Ye().Buffer;
  return xu = function(u, l) {
    var f = u.toString(), s = f.match(e), a;
    if (s) {
      var d = "aes" + s[1], h = t.from(s[2], "hex"), p = t.from(s[3].replace(/[\r\n]/g, ""), "base64"), v = n(l, h.slice(0, 8), parseInt(s[1], 10)).key, g = [], m = i.createDecipheriv(d, v, h);
      g.push(m.update(p)), g.push(m.final()), a = t.concat(g);
    } else {
      var c = f.match(o);
      a = t.from(c[2].replace(/[\r\n]/g, ""), "base64");
    }
    var x = f.match(r)[1];
    return {
      tag: x,
      data: a
    };
  }, xu;
}
var Eu, nm;
function co() {
  if (nm)
    return Eu;
  nm = 1;
  var e = ZB(), r = jB, o = YB(), n = rc(), i = Pb(), t = Ye().Buffer;
  Eu = u;
  function u(f) {
    var s;
    typeof f == "object" && !t.isBuffer(f) && (s = f.passphrase, f = f.key), typeof f == "string" && (f = t.from(f));
    var a = o(f, s), c = a.tag, d = a.data, h, p;
    switch (c) {
      case "CERTIFICATE":
        p = e.certificate.decode(d, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (p || (p = e.PublicKey.decode(d, "der")), h = p.algorithm.algorithm.join("."), h) {
          case "1.2.840.113549.1.1.1":
            return e.RSAPublicKey.decode(p.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return p.subjectPrivateKey = p.subjectPublicKey, {
              type: "ec",
              data: p
            };
          case "1.2.840.10040.4.1":
            return p.algorithm.params.pub_key = e.DSAparam.decode(p.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: p.algorithm.params
            };
          default:
            throw new Error("unknown key id " + h);
        }
      case "ENCRYPTED PRIVATE KEY":
        d = e.EncryptedPrivateKey.decode(d, "der"), d = l(d, s);
      case "PRIVATE KEY":
        switch (p = e.PrivateKey.decode(d, "der"), h = p.algorithm.algorithm.join("."), h) {
          case "1.2.840.113549.1.1.1":
            return e.RSAPrivateKey.decode(p.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: p.algorithm.curve,
              privateKey: e.ECPrivateKey.decode(p.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return p.algorithm.params.priv_key = e.DSAparam.decode(p.subjectPrivateKey, "der"), {
              type: "dsa",
              params: p.algorithm.params
            };
          default:
            throw new Error("unknown key id " + h);
        }
      case "RSA PUBLIC KEY":
        return e.RSAPublicKey.decode(d, "der");
      case "RSA PRIVATE KEY":
        return e.RSAPrivateKey.decode(d, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: e.DSAPrivateKey.decode(d, "der")
        };
      case "EC PRIVATE KEY":
        return d = e.ECPrivateKey.decode(d, "der"), {
          curve: d.parameters.value,
          privateKey: d.privateKey
        };
      default:
        throw new Error("unknown key type " + c);
    }
  }
  u.signature = e.signature;
  function l(f, s) {
    var a = f.algorithm.decrypt.kde.kdeparams.salt, c = parseInt(f.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), d = r[f.algorithm.decrypt.cipher.algo.join(".")], h = f.algorithm.decrypt.cipher.iv, p = f.subjectPrivateKey, v = parseInt(d.split("-")[1], 10) / 8, g = i.pbkdf2Sync(s, a, c, v, "sha1"), m = n.createDecipheriv(d, g, h), x = [];
    return x.push(m.update(p)), x.push(m.final()), t.concat(x);
  }
  return Eu;
}
const ry = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var im;
function XB() {
  if (im)
    return ci.exports;
  im = 1;
  var e = Ye().Buffer, r = Tb(), o = ic(), n = sc().ec, i = nc(), t = co(), u = ry, l = 1;
  function f(m, x, y, E, N) {
    var S = t(x);
    if (S.curve) {
      if (E !== "ecdsa" && E !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return s(m, S);
    } else if (S.type === "dsa") {
      if (E !== "dsa")
        throw new Error("wrong private key type");
      return a(m, S, y);
    }
    if (E !== "rsa" && E !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (x.padding !== void 0 && x.padding !== l)
      throw new Error("illegal or unsupported padding mode");
    m = e.concat([N, m]);
    for (var R = S.modulus.byteLength(), O = [0, 1]; m.length + O.length + 1 < R; )
      O.push(255);
    O.push(0);
    for (var B = -1; ++B < m.length; )
      O.push(m[B]);
    var $ = o(O, S);
    return $;
  }
  function s(m, x) {
    var y = u[x.curve.join(".")];
    if (!y)
      throw new Error("unknown curve " + x.curve.join("."));
    var E = new n(y), N = E.keyFromPrivate(x.privateKey), S = N.sign(m);
    return e.from(S.toDER());
  }
  function a(m, x, y) {
    for (var E = x.params.priv_key, N = x.params.p, S = x.params.q, R = x.params.g, O = new i(0), B, $ = h(m, S).mod(S), F = !1, w = d(E, S, m, y); F === !1; )
      B = v(S, w, y), O = g(R, B, N, S), F = B.invm(S).imul($.add(E.mul(O))).mod(S), F.cmpn(0) === 0 && (F = !1, O = new i(0));
    return c(O, F);
  }
  function c(m, x) {
    m = m.toArray(), x = x.toArray(), m[0] & 128 && (m = [0].concat(m)), x[0] & 128 && (x = [0].concat(x));
    var y = m.length + x.length + 4, E = [
      48,
      y,
      2,
      m.length
    ];
    return E = E.concat(m, [2, x.length], x), e.from(E);
  }
  function d(m, x, y, E) {
    if (m = e.from(m.toArray()), m.length < x.byteLength()) {
      var N = e.alloc(x.byteLength() - m.length);
      m = e.concat([N, m]);
    }
    var S = y.length, R = p(y, x), O = e.alloc(S);
    O.fill(1);
    var B = e.alloc(S);
    return B = r(E, B).update(O).update(e.from([0])).update(m).update(R).digest(), O = r(E, B).update(O).digest(), B = r(E, B).update(O).update(e.from([1])).update(m).update(R).digest(), O = r(E, B).update(O).digest(), { k: B, v: O };
  }
  function h(m, x) {
    var y = new i(m), E = (m.length << 3) - x.bitLength();
    return E > 0 && y.ishrn(E), y;
  }
  function p(m, x) {
    m = h(m, x), m = m.mod(x);
    var y = e.from(m.toArray());
    if (y.length < x.byteLength()) {
      var E = e.alloc(x.byteLength() - y.length);
      y = e.concat([E, y]);
    }
    return y;
  }
  function v(m, x, y) {
    var E, N;
    do {
      for (E = e.alloc(0); E.length * 8 < m.bitLength(); )
        x.v = r(y, x.k).update(x.v).digest(), E = e.concat([E, x.v]);
      N = h(E, m), x.k = r(y, x.k).update(x.v).update(e.from([0])).digest(), x.v = r(y, x.k).update(x.v).digest();
    } while (N.cmp(m) !== -1);
    return N;
  }
  function g(m, x, y, E) {
    return m.toRed(i.mont(y)).redPow(x).fromRed().mod(E);
  }
  return ci.exports = f, ci.exports.getKey = d, ci.exports.makeKey = v, ci.exports;
}
var Au, am;
function JB() {
  if (am)
    return Au;
  am = 1;
  var e = Ye().Buffer, r = nc(), o = sc().ec, n = co(), i = ry;
  function t(s, a, c, d, h) {
    var p = n(c);
    if (p.type === "ec") {
      if (d !== "ecdsa" && d !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return u(s, a, p);
    } else if (p.type === "dsa") {
      if (d !== "dsa")
        throw new Error("wrong public key type");
      return l(s, a, p);
    }
    if (d !== "rsa" && d !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    a = e.concat([h, a]);
    for (var v = p.modulus.byteLength(), g = [1], m = 0; a.length + g.length + 2 < v; )
      g.push(255), m += 1;
    g.push(0);
    for (var x = -1; ++x < a.length; )
      g.push(a[x]);
    g = e.from(g);
    var y = r.mont(p.modulus);
    s = new r(s).toRed(y), s = s.redPow(new r(p.publicExponent)), s = e.from(s.fromRed().toArray());
    var E = m < 8 ? 1 : 0;
    for (v = Math.min(s.length, g.length), s.length !== g.length && (E = 1), x = -1; ++x < v; )
      E |= s[x] ^ g[x];
    return E === 0;
  }
  function u(s, a, c) {
    var d = i[c.data.algorithm.curve.join(".")];
    if (!d)
      throw new Error("unknown curve " + c.data.algorithm.curve.join("."));
    var h = new o(d), p = c.data.subjectPrivateKey.data;
    return h.verify(a, s, p);
  }
  function l(s, a, c) {
    var d = c.data.p, h = c.data.q, p = c.data.g, v = c.data.pub_key, g = n.signature.decode(s, "der"), m = g.s, x = g.r;
    f(m, h), f(x, h);
    var y = r.mont(d), E = m.invm(h), N = p.toRed(y).redPow(new r(a).mul(E).mod(h)).fromRed().mul(v.toRed(y).redPow(x.mul(E).mod(h)).fromRed()).mod(d).mod(h);
    return N.cmp(x) === 0;
  }
  function f(s, a) {
    if (s.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (s.cmp(a) >= 0)
      throw new Error("invalid sig");
  }
  return Au = t, Au;
}
var Su, om;
function QB() {
  if (om)
    return Su;
  om = 1;
  var e = Ye().Buffer, r = Oi(), o = Db(), n = Je(), i = XB(), t = JB(), u = Bb;
  Object.keys(u).forEach(function(c) {
    u[c].id = e.from(u[c].id, "hex"), u[c.toLowerCase()] = u[c];
  });
  function l(c) {
    o.Writable.call(this);
    var d = u[c];
    if (!d)
      throw new Error("Unknown message digest");
    this._hashType = d.hash, this._hash = r(d.hash), this._tag = d.id, this._signType = d.sign;
  }
  n(l, o.Writable), l.prototype._write = function(d, h, p) {
    this._hash.update(d), p();
  }, l.prototype.update = function(d, h) {
    return this._hash.update(typeof d == "string" ? e.from(d, h) : d), this;
  }, l.prototype.sign = function(d, h) {
    this.end();
    var p = this._hash.digest(), v = i(p, d, this._hashType, this._signType, this._tag);
    return h ? v.toString(h) : v;
  };
  function f(c) {
    o.Writable.call(this);
    var d = u[c];
    if (!d)
      throw new Error("Unknown message digest");
    this._hash = r(d.hash), this._tag = d.id, this._signType = d.sign;
  }
  n(f, o.Writable), f.prototype._write = function(d, h, p) {
    this._hash.update(d), p();
  }, f.prototype.update = function(d, h) {
    return this._hash.update(typeof d == "string" ? e.from(d, h) : d), this;
  }, f.prototype.verify = function(d, h, p) {
    var v = typeof h == "string" ? e.from(h, p) : h;
    this.end();
    var g = this._hash.digest();
    return t(v, g, d, this._signType, this._tag);
  };
  function s(c) {
    return new l(c);
  }
  function a(c) {
    return new f(c);
  }
  return Su = {
    Sign: s,
    Verify: a,
    createSign: s,
    createVerify: a
  }, Su;
}
var Du, sm;
function eF() {
  if (sm)
    return Du;
  sm = 1;
  var e = sc(), r = Rr();
  Du = function(u) {
    return new n(u);
  };
  var o = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  o.p224 = o.secp224r1, o.p256 = o.secp256r1 = o.prime256v1, o.p192 = o.secp192r1 = o.prime192v1, o.p384 = o.secp384r1, o.p521 = o.secp521r1;
  function n(t) {
    this.curveType = o[t], this.curveType || (this.curveType = {
      name: t
    }), this.curve = new e.ec(this.curveType.name), this.keys = void 0;
  }
  n.prototype.generateKeys = function(t, u) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(t, u);
  }, n.prototype.computeSecret = function(t, u, l) {
    u = u || "utf8", Buffer.isBuffer(t) || (t = new Buffer(t, u));
    var f = this.curve.keyFromPublic(t).getPublic(), s = f.mul(this.keys.getPrivate()).getX();
    return i(s, l, this.curveType.byteLength);
  }, n.prototype.getPublicKey = function(t, u) {
    var l = this.keys.getPublic(u === "compressed", !0);
    return u === "hybrid" && (l[l.length - 1] % 2 ? l[0] = 7 : l[0] = 6), i(l, t);
  }, n.prototype.getPrivateKey = function(t) {
    return i(this.keys.getPrivate(), t);
  }, n.prototype.setPublicKey = function(t, u) {
    return u = u || "utf8", Buffer.isBuffer(t) || (t = new Buffer(t, u)), this.keys._importPublic(t), this;
  }, n.prototype.setPrivateKey = function(t, u) {
    u = u || "utf8", Buffer.isBuffer(t) || (t = new Buffer(t, u));
    var l = new r(t);
    return l = l.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(l), this;
  };
  function i(t, u, l) {
    Array.isArray(t) || (t = t.toArray());
    var f = new Buffer(t);
    if (l && f.length < l) {
      var s = new Buffer(l - f.length);
      s.fill(0), f = Buffer.concat([s, f]);
    }
    return u ? f.toString(u) : f;
  }
  return Du;
}
var Nu = {}, Mu, um;
function ty() {
  if (um)
    return Mu;
  um = 1;
  var e = Oi(), r = Ye().Buffer;
  Mu = function(n, i) {
    for (var t = r.alloc(0), u = 0, l; t.length < i; )
      l = o(u++), t = r.concat([t, e("sha1").update(n).update(l).digest()]);
    return t.slice(0, i);
  };
  function o(n) {
    var i = r.allocUnsafe(4);
    return i.writeUInt32BE(n, 0), i;
  }
  return Mu;
}
var _u, fm;
function ny() {
  return fm || (fm = 1, _u = function(r, o) {
    for (var n = r.length, i = -1; ++i < n; )
      r[i] ^= o[i];
    return r;
  }), _u;
}
var Cu, cm;
function iy() {
  if (cm)
    return Cu;
  cm = 1;
  var e = Rr(), r = Ye().Buffer;
  function o(n, i) {
    return r.from(n.toRed(e.mont(i.modulus)).redPow(new e(i.publicExponent)).fromRed().toArray());
  }
  return Cu = o, Cu;
}
var Tu, lm;
function rF() {
  if (lm)
    return Tu;
  lm = 1;
  var e = co(), r = ni(), o = Oi(), n = ty(), i = ny(), t = Rr(), u = iy(), l = ic(), f = Ye().Buffer;
  Tu = function(h, p, v) {
    var g;
    h.padding ? g = h.padding : v ? g = 1 : g = 4;
    var m = e(h), x;
    if (g === 4)
      x = s(m, p);
    else if (g === 1)
      x = a(m, p, v);
    else if (g === 3) {
      if (x = new t(p), x.cmp(m.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return v ? l(x, m) : u(x, m);
  };
  function s(d, h) {
    var p = d.modulus.byteLength(), v = h.length, g = o("sha1").update(f.alloc(0)).digest(), m = g.length, x = 2 * m;
    if (v > p - x - 2)
      throw new Error("message too long");
    var y = f.alloc(p - v - x - 2), E = p - m - 1, N = r(m), S = i(f.concat([g, y, f.alloc(1, 1), h], E), n(N, E)), R = i(N, n(S, m));
    return new t(f.concat([f.alloc(1), R, S], p));
  }
  function a(d, h, p) {
    var v = h.length, g = d.modulus.byteLength();
    if (v > g - 11)
      throw new Error("message too long");
    var m;
    return p ? m = f.alloc(g - v - 3, 255) : m = c(g - v - 3), new t(f.concat([f.from([0, p ? 1 : 2]), m, f.alloc(1), h], g));
  }
  function c(d) {
    for (var h = f.allocUnsafe(d), p = 0, v = r(d * 2), g = 0, m; p < d; )
      g === v.length && (v = r(d * 2), g = 0), m = v[g++], m && (h[p++] = m);
    return h;
  }
  return Tu;
}
var Bu, dm;
function tF() {
  if (dm)
    return Bu;
  dm = 1;
  var e = co(), r = ty(), o = ny(), n = Rr(), i = ic(), t = Oi(), u = iy(), l = Ye().Buffer;
  Bu = function(d, h, p) {
    var v;
    d.padding ? v = d.padding : p ? v = 1 : v = 4;
    var g = e(d), m = g.modulus.byteLength();
    if (h.length > m || new n(h).cmp(g.modulus) >= 0)
      throw new Error("decryption error");
    var x;
    p ? x = u(new n(h), g) : x = i(h, g);
    var y = l.alloc(m - x.length);
    if (x = l.concat([y, x], m), v === 4)
      return f(g, x);
    if (v === 1)
      return s(g, x, p);
    if (v === 3)
      return x;
    throw new Error("unknown padding");
  };
  function f(c, d) {
    var h = c.modulus.byteLength(), p = t("sha1").update(l.alloc(0)).digest(), v = p.length;
    if (d[0] !== 0)
      throw new Error("decryption error");
    var g = d.slice(1, v + 1), m = d.slice(v + 1), x = o(g, r(m, v)), y = o(m, r(x, h - v - 1));
    if (a(p, y.slice(0, v)))
      throw new Error("decryption error");
    for (var E = v; y[E] === 0; )
      E++;
    if (y[E++] !== 1)
      throw new Error("decryption error");
    return y.slice(E);
  }
  function s(c, d, h) {
    for (var p = d.slice(0, 2), v = 2, g = 0; d[v++] !== 0; )
      if (v >= d.length) {
        g++;
        break;
      }
    var m = d.slice(2, v - 1);
    if ((p.toString("hex") !== "0002" && !h || p.toString("hex") !== "0001" && h) && g++, m.length < 8 && g++, g)
      throw new Error("decryption error");
    return d.slice(v);
  }
  function a(c, d) {
    c = l.from(c), d = l.from(d);
    var h = 0, p = c.length;
    c.length !== d.length && (h++, p = Math.min(c.length, d.length));
    for (var v = -1; ++v < p; )
      h += c[v] ^ d[v];
    return h;
  }
  return Bu;
}
var hm;
function nF() {
  return hm || (hm = 1, function(e) {
    e.publicEncrypt = rF(), e.privateDecrypt = tF(), e.privateEncrypt = function(o, n) {
      return e.publicEncrypt(o, n, !0);
    }, e.publicDecrypt = function(o, n) {
      return e.privateDecrypt(o, n, !0);
    };
  }(Nu)), Nu;
}
var Fn = {}, pm;
function iF() {
  if (pm)
    return Fn;
  pm = 1;
  function e() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var r = Ye(), o = ni(), n = r.Buffer, i = r.kMaxLength, t = Xe.crypto || Xe.msCrypto, u = Math.pow(2, 32) - 1;
  function l(d, h) {
    if (typeof d != "number" || d !== d)
      throw new TypeError("offset must be a number");
    if (d > u || d < 0)
      throw new TypeError("offset must be a uint32");
    if (d > i || d > h)
      throw new RangeError("offset out of range");
  }
  function f(d, h, p) {
    if (typeof d != "number" || d !== d)
      throw new TypeError("size must be a number");
    if (d > u || d < 0)
      throw new TypeError("size must be a uint32");
    if (d + h > p || d > i)
      throw new RangeError("buffer too small");
  }
  t && t.getRandomValues || !process.browser ? (Fn.randomFill = s, Fn.randomFillSync = c) : (Fn.randomFill = e, Fn.randomFillSync = e);
  function s(d, h, p, v) {
    if (!n.isBuffer(d) && !(d instanceof Xe.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof h == "function")
      v = h, h = 0, p = d.length;
    else if (typeof p == "function")
      v = p, p = d.length - h;
    else if (typeof v != "function")
      throw new TypeError('"cb" argument must be a function');
    return l(h, d.length), f(p, h, d.length), a(d, h, p, v);
  }
  function a(d, h, p, v) {
    if (process.browser) {
      var g = d.buffer, m = new Uint8Array(g, h, p);
      if (t.getRandomValues(m), v) {
        process.nextTick(function() {
          v(null, d);
        });
        return;
      }
      return d;
    }
    if (v) {
      o(p, function(y, E) {
        if (y)
          return v(y);
        E.copy(d, h), v(null, d);
      });
      return;
    }
    var x = o(p);
    return x.copy(d, h), d;
  }
  function c(d, h, p) {
    if (typeof h > "u" && (h = 0), !n.isBuffer(d) && !(d instanceof Xe.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return l(h, d.length), p === void 0 && (p = d.length - h), f(p, h, d.length), a(d, h, p);
  }
  return Fn;
}
var vm;
function ay() {
  if (vm)
    return je;
  vm = 1, je.randomBytes = je.rng = je.pseudoRandomBytes = je.prng = ni(), je.createHash = je.Hash = Oi(), je.createHmac = je.Hmac = Tb();
  var e = IT(), r = Object.keys(e), o = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(r);
  je.getHashes = function() {
    return o;
  };
  var n = Pb();
  je.pbkdf2 = n.pbkdf2, je.pbkdf2Sync = n.pbkdf2Sync;
  var i = JT();
  je.Cipher = i.Cipher, je.createCipher = i.createCipher, je.Cipheriv = i.Cipheriv, je.createCipheriv = i.createCipheriv, je.Decipher = i.Decipher, je.createDecipher = i.createDecipher, je.Decipheriv = i.Decipheriv, je.createDecipheriv = i.createDecipheriv, je.getCiphers = i.getCiphers, je.listCiphers = i.listCiphers;
  var t = fB();
  je.DiffieHellmanGroup = t.DiffieHellmanGroup, je.createDiffieHellmanGroup = t.createDiffieHellmanGroup, je.getDiffieHellman = t.getDiffieHellman, je.createDiffieHellman = t.createDiffieHellman, je.DiffieHellman = t.DiffieHellman;
  var u = QB();
  je.createSign = u.createSign, je.Sign = u.Sign, je.createVerify = u.createVerify, je.Verify = u.Verify, je.createECDH = eF();
  var l = nF();
  je.publicEncrypt = l.publicEncrypt, je.privateEncrypt = l.privateEncrypt, je.publicDecrypt = l.publicDecrypt, je.privateDecrypt = l.privateDecrypt;
  var f = iF();
  return je.randomFill = f.randomFill, je.randomFillSync = f.randomFillSync, je.createCredentials = function() {
    throw new Error([
      "sorry, createCredentials is not implemented yet",
      "we accept pull requests",
      "https://github.com/crypto-browserify/crypto-browserify"
    ].join(`
`));
  }, je.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, je;
}
(function(e) {
  (function(r, o, n) {
    var i = 256, t = 6, u = 52, l = "random", f = n.pow(i, t), s = n.pow(2, u), a = s * 2, c = i - 1, d;
    function h(E, N, S) {
      var R = [];
      N = N == !0 ? { entropy: !0 } : N || {};
      var O = m(g(
        N.entropy ? [E, y(o)] : E ?? x(),
        3
      ), R), B = new p(R), $ = function() {
        for (var F = B.g(t), w = f, A = 0; F < s; )
          F = (F + A) * i, w *= i, A = B.g(1);
        for (; F >= a; )
          F /= 2, w /= 2, A >>>= 1;
        return (F + A) / w;
      };
      return $.int32 = function() {
        return B.g(4) | 0;
      }, $.quick = function() {
        return B.g(4) / 4294967296;
      }, $.double = $, m(y(B.S), o), (N.pass || S || function(F, w, A, b) {
        return b && (b.S && v(b, B), F.state = function() {
          return v(B, {});
        }), A ? (n[l] = F, w) : F;
      })(
        $,
        O,
        "global" in N ? N.global : this == n,
        N.state
      );
    }
    function p(E) {
      var N, S = E.length, R = this, O = 0, B = R.i = R.j = 0, $ = R.S = [];
      for (S || (E = [S++]); O < i; )
        $[O] = O++;
      for (O = 0; O < i; O++)
        $[O] = $[B = c & B + E[O % S] + (N = $[O])], $[B] = N;
      (R.g = function(F) {
        for (var w, A = 0, b = R.i, D = R.j, M = R.S; F--; )
          w = M[b = c & b + 1], A = A * i + M[c & (M[b] = M[D = c & D + w]) + (M[D] = w)];
        return R.i = b, R.j = D, A;
      })(i);
    }
    function v(E, N) {
      return N.i = E.i, N.j = E.j, N.S = E.S.slice(), N;
    }
    function g(E, N) {
      var S = [], R = typeof E, O;
      if (N && R == "object")
        for (O in E)
          try {
            S.push(g(E[O], N - 1));
          } catch {
          }
      return S.length ? S : R == "string" ? E : E + "\0";
    }
    function m(E, N) {
      for (var S = E + "", R, O = 0; O < S.length; )
        N[c & O] = c & (R ^= N[c & O] * 19) + S.charCodeAt(O++);
      return y(N);
    }
    function x() {
      try {
        var E;
        return d && (E = d.randomBytes) ? E = E(i) : (E = new Uint8Array(i), (r.crypto || r.msCrypto).getRandomValues(E)), y(E);
      } catch {
        var N = r.navigator, S = N && N.plugins;
        return [+/* @__PURE__ */ new Date(), r, S, r.screen, y(o)];
      }
    }
    function y(E) {
      return String.fromCharCode.apply(0, E);
    }
    if (m(n.random(), o), e.exports) {
      e.exports = h;
      try {
        d = ay();
      } catch {
      }
    } else
      n["seed" + l] = h;
  })(
    // global: `self` in browsers (including strict mode and web workers),
    // otherwise `this` in Node and other environments
    typeof self < "u" ? self : Xe,
    [],
    // pool: entropy pool starts empty
    Math
    // math: package containing random, pow, and seedrandom
  );
})(gb);
var aF = gb.exports, oF = QC, sF = eT, uF = rT, fF = tT, cF = nT, lF = iT, Mn = aF;
Mn.alea = oF;
Mn.xor128 = sF;
Mn.xorwow = uF;
Mn.xorshift7 = fF;
Mn.xor4096 = cF;
Mn.tychei = lF;
var dF = Mn;
const oy = /* @__PURE__ */ Ti(dF);
var hF = /* @__PURE__ */ oy(Date.now());
function Kn(e) {
  var r;
  function o(i) {
    r = i === null ? hF : oy(String(i));
  }
  o(e);
  function n() {
    return r();
  }
  return n;
}
var mm = "pickRandom", pF = ["typed", "config", "?on"], vF = /* @__PURE__ */ Q(mm, pF, (e) => {
  var {
    typed: r,
    config: o,
    on: n
  } = e, i = Kn(o.randomSeed);
  return n && n("config", function(u, l) {
    u.randomSeed !== l.randomSeed && (i = Kn(u.randomSeed));
  }), r(mm, {
    "Array | Matrix": function(l) {
      return t(l, {});
    },
    "Array | Matrix, Object": function(l, f) {
      return t(l, f);
    },
    "Array | Matrix, number": function(l, f) {
      return t(l, {
        number: f
      });
    },
    "Array | Matrix, Array | Matrix": function(l, f) {
      return t(l, {
        weights: f
      });
    },
    "Array | Matrix, Array | Matrix, number": function(l, f, s) {
      return t(l, {
        number: s,
        weights: f
      });
    },
    "Array | Matrix, number, Array | Matrix": function(l, f, s) {
      return t(l, {
        number: f,
        weights: s
      });
    }
  });
  function t(u, l) {
    var {
      number: f,
      weights: s,
      elementWise: a = !0
    } = l, c = typeof f > "u";
    c && (f = 1);
    var d = Fe(u) ? u.create : Fe(s) ? s.create : null;
    u = u.valueOf(), s && (s = s.valueOf()), a === !0 && (u = ir(u), s = ir(s));
    var h = 0;
    if (typeof s < "u") {
      if (s.length !== u.length)
        throw new Error("Weights must have the same length as possibles");
      for (var p = 0, v = s.length; p < v; p++) {
        if (!$e(s[p]) || s[p] < 0)
          throw new Error("Weights must be an array of positive numbers");
        h += s[p];
      }
    }
    for (var g = u.length, m = [], x; m.length < f; ) {
      if (typeof s > "u")
        x = u[Math.floor(i() * g)];
      else
        for (var y = i() * h, E = 0, N = u.length; E < N; E++)
          if (y -= s[E], y < 0) {
            x = u[E];
            break;
          }
      m.push(x);
    }
    return c ? m[0] : d ? d(m) : m;
  }
});
function dc(e, r) {
  var o = [];
  if (e = e.slice(0), e.length > 1)
    for (var n = 0, i = e.shift(); n < i; n++)
      o.push(dc(e, r));
  else
    for (var t = 0, u = e.shift(); t < u; t++)
      o.push(r());
  return o;
}
var gm = "random", mF = ["typed", "config", "?on"], gF = /* @__PURE__ */ Q(gm, mF, (e) => {
  var {
    typed: r,
    config: o,
    on: n
  } = e, i = Kn(o.randomSeed);
  return n && n("config", function(l, f) {
    l.randomSeed !== f.randomSeed && (i = Kn(l.randomSeed));
  }), r(gm, {
    "": () => u(0, 1),
    number: (l) => u(0, l),
    "number, number": (l, f) => u(l, f),
    "Array | Matrix": (l) => t(l, 0, 1),
    "Array | Matrix, number": (l, f) => t(l, 0, f),
    "Array | Matrix, number, number": (l, f, s) => t(l, f, s)
  });
  function t(l, f, s) {
    var a = dc(l.valueOf(), () => u(f, s));
    return Fe(l) ? l.create(a) : a;
  }
  function u(l, f) {
    return l + i() * (f - l);
  }
}), bm = "randomInt", bF = ["typed", "config", "?on"], yF = /* @__PURE__ */ Q(bm, bF, (e) => {
  var {
    typed: r,
    config: o,
    on: n
  } = e, i = Kn(o.randomSeed);
  return n && n("config", function(l, f) {
    l.randomSeed !== f.randomSeed && (i = Kn(l.randomSeed));
  }), r(bm, {
    "": () => u(0, 1),
    number: (l) => u(0, l),
    "number, number": (l, f) => u(l, f),
    "Array | Matrix": (l) => t(l, 0, 1),
    "Array | Matrix, number": (l, f) => t(l, 0, f),
    "Array | Matrix, number, number": (l, f, s) => t(l, f, s)
  });
  function t(l, f, s) {
    var a = dc(l.valueOf(), () => u(f, s));
    return Fe(l) ? l.create(a) : a;
  }
  function u(l, f) {
    return Math.floor(l + i() * (f - l));
  }
}), ym = "stirlingS2", wF = ["typed", "addScalar", "subtractScalar", "multiplyScalar", "divideScalar", "pow", "factorial", "combinations", "isNegative", "isInteger", "number", "?bignumber", "larger"], xF = /* @__PURE__ */ Q(ym, wF, (e) => {
  var {
    typed: r,
    addScalar: o,
    subtractScalar: n,
    multiplyScalar: i,
    divideScalar: t,
    pow: u,
    factorial: l,
    combinations: f,
    isNegative: s,
    isInteger: a,
    number: c,
    bignumber: d,
    larger: h
  } = e, p = [], v = [];
  return r(ym, {
    "number | BigNumber, number | BigNumber": function(m, x) {
      if (!a(m) || s(m) || !a(x) || s(x))
        throw new TypeError("Non-negative integer value expected in function stirlingS2");
      if (h(x, m))
        throw new TypeError("k must be less than or equal to n in function stirlingS2");
      var y = !($e(m) && $e(x)), E = y ? v : p, N = y ? d : c, S = c(m), R = c(x);
      if (E[S] && E[S].length > R)
        return E[S][R];
      for (var O = 0; O <= S; ++O)
        if (E[O] || (E[O] = [N(O === 0 ? 1 : 0)]), O !== 0)
          for (var B = E[O], $ = E[O - 1], F = B.length; F <= O && F <= R; ++F)
            F === O ? B[F] = 1 : B[F] = o(i(N(F), $[F]), $[F - 1]);
      return E[S][R];
    }
  });
}), wm = "bellNumbers", EF = ["typed", "addScalar", "isNegative", "isInteger", "stirlingS2"], AF = /* @__PURE__ */ Q(wm, EF, (e) => {
  var {
    typed: r,
    addScalar: o,
    isNegative: n,
    isInteger: i,
    stirlingS2: t
  } = e;
  return r(wm, {
    "number | BigNumber": function(l) {
      if (!i(l) || n(l))
        throw new TypeError("Non-negative integer value expected in function bellNumbers");
      for (var f = 0, s = 0; s <= l; s++)
        f = o(f, t(l, s));
      return f;
    }
  });
}), xm = "catalan", SF = ["typed", "addScalar", "divideScalar", "multiplyScalar", "combinations", "isNegative", "isInteger"], DF = /* @__PURE__ */ Q(xm, SF, (e) => {
  var {
    typed: r,
    addScalar: o,
    divideScalar: n,
    multiplyScalar: i,
    combinations: t,
    isNegative: u,
    isInteger: l
  } = e;
  return r(xm, {
    "number | BigNumber": function(s) {
      if (!l(s) || u(s))
        throw new TypeError("Non-negative integer value expected in function catalan");
      return n(t(i(s, 2), s), o(s, 1));
    }
  });
}), Em = "composition", NF = ["typed", "addScalar", "combinations", "isNegative", "isPositive", "isInteger", "larger"], MF = /* @__PURE__ */ Q(Em, NF, (e) => {
  var {
    typed: r,
    addScalar: o,
    combinations: n,
    isPositive: i,
    isNegative: t,
    isInteger: u,
    larger: l
  } = e;
  return r(Em, {
    "number | BigNumber, number | BigNumber": function(s, a) {
      if (!u(s) || !i(s) || !u(a) || !i(a))
        throw new TypeError("Positive integer value expected in function composition");
      if (l(a, s))
        throw new TypeError("k must be less than or equal to n in function composition");
      return n(o(s, -1), o(a, -1));
    }
  });
}), Am = "leafCount", _F = ["parse", "typed"], CF = /* @__PURE__ */ Q(Am, _F, (e) => {
  var {
    parse: r,
    typed: o
  } = e;
  function n(i) {
    var t = 0;
    return i.forEach((u) => {
      t += n(u);
    }), t || 1;
  }
  return o(Am, {
    Node: function(t) {
      return n(t);
    }
  });
});
function Sm(e) {
  return rr(e) || Cr(e) && e.isUnary() && rr(e.args[0]);
}
function Ua(e) {
  return !!(rr(e) || (Gt(e) || Cr(e)) && e.args.every(Ua) || Dt(e) && Ua(e.content));
}
function Dm(e, r) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), o.push.apply(o, n);
  }
  return o;
}
function Fu(e) {
  for (var r = 1; r < arguments.length; r++) {
    var o = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Dm(Object(o), !0).forEach(function(n) {
      Fr(e, n, o[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : Dm(Object(o)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(o, n));
    });
  }
  return e;
}
var TF = "simplifyUtil", BF = ["FunctionNode", "OperatorNode", "SymbolNode"], hc = /* @__PURE__ */ Q(TF, BF, (e) => {
  var {
    FunctionNode: r,
    OperatorNode: o,
    SymbolNode: n
  } = e, i = !0, t = !1, u = "defaultF", l = {
    /*      */
    add: {
      trivial: i,
      total: i,
      commutative: i,
      associative: i
    },
    /**/
    unaryPlus: {
      trivial: i,
      total: i,
      commutative: i,
      associative: i
    },
    /* */
    subtract: {
      trivial: t,
      total: i,
      commutative: t,
      associative: t
    },
    /* */
    multiply: {
      trivial: i,
      total: i,
      commutative: i,
      associative: i
    },
    /*   */
    divide: {
      trivial: t,
      total: i,
      commutative: t,
      associative: t
    },
    /*    */
    paren: {
      trivial: i,
      total: i,
      commutative: i,
      associative: t
    },
    /* */
    defaultF: {
      trivial: t,
      total: i,
      commutative: t,
      associative: t
    }
  }, f = {
    divide: {
      total: t
    },
    log: {
      total: t
    }
  }, s = {
    subtract: {
      total: t
    },
    abs: {
      trivial: i
    },
    log: {
      total: i
    }
  };
  function a(y, E) {
    var N = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : l, S = u;
    if (typeof y == "string" ? S = y : Cr(y) ? S = y.fn.toString() : Gt(y) ? S = y.name : Dt(y) && (S = "paren"), De(N, S)) {
      var R = N[S];
      if (De(R, E))
        return R[E];
      if (De(l, S))
        return l[S][E];
    }
    if (De(N, u)) {
      var O = N[u];
      return De(O, E) ? O[E] : l[u][E];
    }
    if (De(l, S)) {
      var B = l[S];
      if (De(B, E))
        return B[E];
    }
    return l[u][E];
  }
  function c(y) {
    var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l;
    return a(y, "commutative", E);
  }
  function d(y) {
    var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l;
    return a(y, "associative", E);
  }
  function h(y, E) {
    var N = Fu({}, y);
    for (var S in E)
      De(y, S) ? N[S] = Fu(Fu({}, E[S]), y[S]) : N[S] = E[S];
    return N;
  }
  function p(y, E) {
    if (!y.args || y.args.length === 0)
      return y;
    y.args = v(y, E);
    for (var N = 0; N < y.args.length; N++)
      p(y.args[N], E);
  }
  function v(y, E) {
    var N, S = [], R = function O(B) {
      for (var $ = 0; $ < B.args.length; $++) {
        var F = B.args[$];
        Cr(F) && N === F.op ? O(F) : S.push(F);
      }
    };
    return d(y, E) ? (N = y.op, R(y), S) : y.args;
  }
  function g(y, E) {
    if (!(!y.args || y.args.length === 0)) {
      for (var N = x(y), S = y.args.length, R = 0; R < S; R++)
        g(y.args[R], E);
      if (S > 2 && d(y, E)) {
        for (var O = y.args.pop(); y.args.length > 0; )
          O = N([y.args.pop(), O]);
        y.args = O.args;
      }
    }
  }
  function m(y, E) {
    if (!(!y.args || y.args.length === 0)) {
      for (var N = x(y), S = y.args.length, R = 0; R < S; R++)
        m(y.args[R], E);
      if (S > 2 && d(y, E)) {
        for (var O = y.args.shift(); y.args.length > 0; )
          O = N([O, y.args.shift()]);
        y.args = O.args;
      }
    }
  }
  function x(y) {
    return Cr(y) ? function(E) {
      try {
        return new o(y.op, y.fn, E, y.implicit);
      } catch (N) {
        return console.error(N), [];
      }
    } : function(E) {
      return new r(new n(y.name), E);
    };
  }
  return {
    createMakeNodeFunction: x,
    hasProperty: a,
    isCommutative: c,
    isAssociative: d,
    mergeContext: h,
    flatten: p,
    allChildren: v,
    unflattenr: g,
    unflattenl: m,
    defaultContext: l,
    realContext: f,
    positiveContext: s
  };
}), FF = "simplify", IF = ["config", "typed", "parse", "add", "subtract", "multiply", "divide", "pow", "isZero", "equal", "resolve", "simplifyConstant", "simplifyCore", "?fraction", "?bignumber", "mathWithTransform", "matrix", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], OF = /* @__PURE__ */ Q(FF, IF, (e) => {
  var {
    config: r,
    typed: o,
    parse: n,
    add: i,
    subtract: t,
    multiply: u,
    divide: l,
    pow: f,
    isZero: s,
    equal: a,
    resolve: c,
    simplifyConstant: d,
    simplifyCore: h,
    fraction: p,
    bignumber: v,
    mathWithTransform: g,
    matrix: m,
    AccessorNode: x,
    ArrayNode: y,
    ConstantNode: E,
    FunctionNode: N,
    IndexNode: S,
    ObjectNode: R,
    OperatorNode: O,
    ParenthesisNode: B,
    SymbolNode: $
  } = e, {
    hasProperty: F,
    isCommutative: w,
    isAssociative: A,
    mergeContext: b,
    flatten: D,
    unflattenr: M,
    unflattenl: _,
    createMakeNodeFunction: q,
    defaultContext: C,
    realContext: T,
    positiveContext: z
  } = hc({
    FunctionNode: N,
    OperatorNode: O,
    SymbolNode: $
  });
  o.addConversion({
    from: "Object",
    to: "Map",
    convert: zn
  });
  var I = o("simplify", {
    Node: ne,
    "Node, Map": (P, G) => ne(P, !1, G),
    "Node, Map, Object": (P, G, j) => ne(P, !1, G, j),
    "Node, Array": ne,
    "Node, Array, Map": ne,
    "Node, Array, Map, Object": ne
  });
  o.removeConversion({
    from: "Object",
    to: "Map",
    convert: zn
  }), I.defaultContext = C, I.realContext = T, I.positiveContext = z;
  function U(P) {
    return P.transform(function(G, j, re) {
      return Dt(G) ? U(G.content) : G;
    });
  }
  var ee = {
    true: !0,
    false: !0,
    e: !0,
    i: !0,
    Infinity: !0,
    LN2: !0,
    LN10: !0,
    LOG2E: !0,
    LOG10E: !0,
    NaN: !0,
    phi: !0,
    pi: !0,
    SQRT1_2: !0,
    SQRT2: !0,
    tau: !0
    // null: false,
    // undefined: false,
    // version: false,
  };
  I.rules = [
    h,
    // { l: 'n+0', r: 'n' },     // simplifyCore
    // { l: 'n^0', r: '1' },     // simplifyCore
    // { l: '0*n', r: '0' },     // simplifyCore
    // { l: 'n/n', r: '1'},      // simplifyCore
    // { l: 'n^1', r: 'n' },     // simplifyCore
    // { l: '+n1', r:'n1' },     // simplifyCore
    // { l: 'n--n1', r:'n+n1' }, // simplifyCore
    {
      l: "log(e)",
      r: "1"
    },
    // temporary rules
    // Note initially we tend constants to the right because like-term
    // collection prefers the left, and we would rather collect nonconstants
    {
      s: "n-n1 -> n+-n1",
      // temporarily replace 'subtract' so we can further flatten the 'add' operator
      assuming: {
        subtract: {
          total: !0
        }
      }
    },
    {
      s: "n-n -> 0",
      // partial alternative when we can't always subtract
      assuming: {
        subtract: {
          total: !1
        }
      }
    },
    {
      s: "-(cl*v) -> v * (-cl)",
      // make non-constant terms positive
      assuming: {
        multiply: {
          commutative: !0
        },
        subtract: {
          total: !0
        }
      }
    },
    {
      s: "-(cl*v) -> (-cl) * v",
      // non-commutative version, part 1
      assuming: {
        multiply: {
          commutative: !1
        },
        subtract: {
          total: !0
        }
      }
    },
    {
      s: "-(v*cl) -> v * (-cl)",
      // non-commutative version, part 2
      assuming: {
        multiply: {
          commutative: !1
        },
        subtract: {
          total: !0
        }
      }
    },
    {
      l: "-(n1/n2)",
      r: "-n1/n2"
    },
    {
      l: "-v",
      r: "v * (-1)"
    },
    // finish making non-constant terms positive
    {
      l: "(n1 + n2)*(-1)",
      r: "n1*(-1) + n2*(-1)",
      repeat: !0
    },
    // expand negations to achieve as much sign cancellation as possible
    {
      l: "n/n1^n2",
      r: "n*n1^-n2"
    },
    // temporarily replace 'divide' so we can further flatten the 'multiply' operator
    {
      l: "n/n1",
      r: "n*n1^-1"
    },
    {
      s: "(n1*n2)^n3 -> n1^n3 * n2^n3",
      assuming: {
        multiply: {
          commutative: !0
        }
      }
    },
    {
      s: "(n1*n2)^(-1) -> n2^(-1) * n1^(-1)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    // expand nested exponentiation
    {
      s: "(n ^ n1) ^ n2 -> n ^ (n1 * n2)",
      assuming: {
        divide: {
          total: !0
        }
      }
      // 1/(1/n) = n needs 1/n to exist
    },
    // collect like factors; into a sum, only do this for nonconstants
    {
      l: " vd   * ( vd   * n1 + n2)",
      r: "vd^2       * n1 +  vd   * n2"
    },
    {
      s: " vd   * (vd^n4 * n1 + n2)   ->  vd^(1+n4)  * n1 +  vd   * n2",
      assuming: {
        divide: {
          total: !0
        }
      }
      // v*1/v = v^(1+-1) needs 1/v
    },
    {
      s: "vd^n3 * ( vd   * n1 + n2)   ->  vd^(n3+1)  * n1 + vd^n3 * n2",
      assuming: {
        divide: {
          total: !0
        }
      }
    },
    {
      s: "vd^n3 * (vd^n4 * n1 + n2)   ->  vd^(n3+n4) * n1 + vd^n3 * n2",
      assuming: {
        divide: {
          total: !0
        }
      }
    },
    {
      l: "n*n",
      r: "n^2"
    },
    {
      s: "n * n^n1 -> n^(n1+1)",
      assuming: {
        divide: {
          total: !0
        }
      }
      // n*1/n = n^(-1+1) needs 1/n
    },
    {
      s: "n^n1 * n^n2 -> n^(n1+n2)",
      assuming: {
        divide: {
          total: !0
        }
      }
      // ditto for n^2*1/n^2
    },
    // Unfortunately, to deal with more complicated cancellations, it
    // becomes necessary to simplify constants twice per pass. It's not
    // terribly expensive compared to matching rules, so this should not
    // pose a performance problem.
    d,
    // First: before collecting like terms
    // collect like terms
    {
      s: "n+n -> 2*n",
      assuming: {
        add: {
          total: !0
        }
      }
      // 2 = 1 + 1 needs to exist
    },
    {
      l: "n+-n",
      r: "0"
    },
    {
      l: "vd*n + vd",
      r: "vd*(n+1)"
    },
    // NOTE: leftmost position is special:
    {
      l: "n3*n1 + n3*n2",
      r: "n3*(n1+n2)"
    },
    // All sub-monomials tried there.
    {
      l: "n3^(-n4)*n1 +   n3  * n2",
      r: "n3^(-n4)*(n1 + n3^(n4+1) *n2)"
    },
    {
      l: "n3^(-n4)*n1 + n3^n5 * n2",
      r: "n3^(-n4)*(n1 + n3^(n4+n5)*n2)"
    },
    // noncommutative additional cases (term collection & factoring)
    {
      s: "n*vd + vd -> (n+1)*vd",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "vd + n*vd -> (1+n)*vd",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "n1*n3 + n2*n3 -> (n1+n2)*n3",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "n^n1 * n -> n^(n1+1)",
      assuming: {
        divide: {
          total: !0
        },
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "n1*n3^(-n4) + n2 * n3    -> (n1 + n2*n3^(n4 +  1))*n3^(-n4)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "n1*n3^(-n4) + n2 * n3^n5 -> (n1 + n2*n3^(n4 + n5))*n3^(-n4)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      l: "n*cd + cd",
      r: "(n+1)*cd"
    },
    {
      s: "cd*n + cd -> cd*(n+1)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    {
      s: "cd + cd*n -> cd*(1+n)",
      assuming: {
        multiply: {
          commutative: !1
        }
      }
    },
    d,
    // Second: before returning expressions to "standard form"
    // make factors positive (and undo 'make non-constant terms positive')
    {
      s: "(-n)*n1 -> -(n*n1)",
      assuming: {
        subtract: {
          total: !0
        }
      }
    },
    {
      s: "n1*(-n) -> -(n1*n)",
      // in case * non-commutative
      assuming: {
        subtract: {
          total: !0
        },
        multiply: {
          commutative: !1
        }
      }
    },
    // final ordering of constants
    {
      s: "ce+ve -> ve+ce",
      assuming: {
        add: {
          commutative: !0
        }
      },
      imposeContext: {
        add: {
          commutative: !1
        }
      }
    },
    {
      s: "vd*cd -> cd*vd",
      assuming: {
        multiply: {
          commutative: !0
        }
      },
      imposeContext: {
        multiply: {
          commutative: !1
        }
      }
    },
    // undo temporary rules
    // { l: '(-1) * n', r: '-n' }, // #811 added test which proved this is redundant
    {
      l: "n+-n1",
      r: "n-n1"
    },
    // undo replace 'subtract'
    {
      l: "n+-(n1)",
      r: "n-(n1)"
    },
    {
      s: "n*(n1^-1) -> n/n1",
      // undo replace 'divide'; for * commutative
      assuming: {
        multiply: {
          commutative: !0
        }
      }
      // o.w. / not conventional
    },
    {
      s: "n*n1^-n2 -> n/n1^n2",
      assuming: {
        multiply: {
          commutative: !0
        }
      }
      // o.w. / not conventional
    },
    {
      s: "n^-1 -> 1/n",
      assuming: {
        multiply: {
          commutative: !0
        }
      }
      // o.w. / not conventional
    },
    {
      l: "n^1",
      r: "n"
    },
    // can be produced by power cancellation
    {
      s: "n*(n1/n2) -> (n*n1)/n2",
      // '*' before '/'
      assuming: {
        multiply: {
          associative: !0
        }
      }
    },
    {
      s: "n-(n1+n2) -> n-n1-n2",
      // '-' before '+'
      assuming: {
        addition: {
          associative: !0,
          commutative: !0
        }
      }
    },
    // { l: '(n1/n2)/n3', r: 'n1/(n2*n3)' },
    // { l: '(n*n1)/(n*n2)', r: 'n1/n2' },
    // simplifyConstant can leave an extra factor of 1, which can always
    // be eliminated, since the identity always commutes
    {
      l: "1*n",
      r: "n",
      imposeContext: {
        multiply: {
          commutative: !0
        }
      }
    },
    {
      s: "n1/(n2/n3) -> (n1*n3)/n2",
      assuming: {
        multiply: {
          associative: !0
        }
      }
    },
    {
      l: "n1/(-n2)",
      r: "-n1/n2"
    }
  ];
  function se(P, G) {
    var j = {};
    if (P.s) {
      var re = P.s.split("->");
      if (re.length === 2)
        j.l = re[0], j.r = re[1];
      else
        throw SyntaxError("Could not parse rule: " + P.s);
    } else
      j.l = P.l, j.r = P.r;
    j.l = U(n(j.l)), j.r = U(n(j.r));
    for (var ie of ["imposeContext", "repeat", "assuming"])
      ie in P && (j[ie] = P[ie]);
    if (P.evaluate && (j.evaluate = n(P.evaluate)), A(j.l, G)) {
      var Z = !w(j.l, G), X;
      Z && (X = te());
      var oe = q(j.l), ce = te();
      j.expanded = {}, j.expanded.l = oe([j.l, ce]), D(j.expanded.l, G), M(j.expanded.l, G), j.expanded.r = oe([j.r, ce]), Z && (j.expandedNC1 = {}, j.expandedNC1.l = oe([X, j.l]), j.expandedNC1.r = oe([X, j.r]), j.expandedNC2 = {}, j.expandedNC2.l = oe([X, j.expanded.l]), j.expandedNC2.r = oe([X, j.expanded.r]));
    }
    return j;
  }
  function K(P, G) {
    for (var j = [], re = 0; re < P.length; re++) {
      var ie = P[re], Z = void 0, X = typeof ie;
      switch (X) {
        case "string":
          ie = {
            s: ie
          };
        case "object":
          Z = se(ie, G);
          break;
        case "function":
          Z = ie;
          break;
        default:
          throw TypeError("Unsupported type of rule: " + X);
      }
      j.push(Z);
    }
    return j;
  }
  var J = 0;
  function te() {
    return new $("_p" + J++);
  }
  function ne(P, G) {
    var j = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : bi(), re = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, ie = re.consoleDebug;
    G = K(G || I.rules, re.context);
    var Z = c(P, j);
    Z = U(Z);
    for (var X = {}, oe = Z.toString({
      parenthesis: "all"
    }); !X[oe]; ) {
      X[oe] = !0, J = 0;
      var ce = oe;
      ie && console.log("Working on: ", oe);
      for (var le = 0; le < G.length; le++) {
        var ve = "";
        if (typeof G[le] == "function" ? (Z = G[le](Z, re), ie && (ve = G[le].name)) : (D(Z, re.context), Z = V(Z, G[le], re.context), ie && (ve = "".concat(G[le].l.toString(), " -> ").concat(G[le].r.toString()))), ie) {
          var ge = Z.toString({
            parenthesis: "all"
          });
          ge !== ce && (console.log("Applying", ve, "produced", ge), ce = ge);
        }
        _(Z, re.context);
      }
      oe = Z.toString({
        parenthesis: "all"
      });
    }
    return Z;
  }
  function ue(P, G, j) {
    var re = P;
    if (P)
      for (var ie = 0; ie < P.length; ++ie) {
        var Z = V(P[ie], G, j);
        Z !== P[ie] && (re === P && (re = P.slice()), re[ie] = Z);
      }
    return re;
  }
  function V(P, G, j) {
    if (G.assuming) {
      for (var re in G.assuming)
        for (var ie in G.assuming[re])
          if (F(re, ie, j) !== G.assuming[re][ie])
            return P;
    }
    var Z = b(G.imposeContext, j), X = P;
    if (X instanceof O || X instanceof N) {
      var oe = ue(X.args, G, j);
      oe !== X.args && (X = X.clone(), X.args = oe);
    } else if (X instanceof B) {
      if (X.content) {
        var ce = V(X.content, G, j);
        ce !== X.content && (X = new B(ce));
      }
    } else if (X instanceof y) {
      var le = ue(X.items, G, j);
      le !== X.items && (X = new y(le));
    } else if (X instanceof x) {
      var ve = X.object;
      X.object && (ve = V(X.object, G, j));
      var ge = X.index;
      X.index && (ge = V(X.index, G, j)), (ve !== X.object || ge !== X.index) && (X = new x(ve, ge));
    } else if (X instanceof S) {
      var me = ue(X.dimensions, G, j);
      me !== X.dimensions && (X = new S(me));
    } else if (X instanceof R) {
      var we = !1, be = {};
      for (var Ae in X.properties)
        be[Ae] = V(X.properties[Ae], G, j), be[Ae] !== X.properties[Ae] && (we = !0);
      we && (X = new R(be));
    }
    var _e = G.r, Se = k(G.l, X, Z)[0];
    if (!Se && G.expanded && (_e = G.expanded.r, Se = k(G.expanded.l, X, Z)[0]), !Se && G.expandedNC1 && (_e = G.expandedNC1.r, Se = k(G.expandedNC1.l, X, Z)[0], Se || (_e = G.expandedNC2.r, Se = k(G.expandedNC2.l, X, Z)[0])), Se) {
      var Me = X.implicit;
      X = _e.clone(), Me && "implicit" in _e && (X.implicit = !0), X = X.transform(function(H) {
        return H.isSymbolNode && De(Se.placeholders, H.name) ? Se.placeholders[H.name].clone() : H;
      });
    }
    return G.repeat && X !== P && (X = V(X, G, j)), X;
  }
  function W(P, G) {
    var j = [], re, ie, Z = q(P);
    if (w(P, G))
      for (var X = 0; X < P.args.length; X++)
        ie = P.args.slice(0), ie.splice(X, 1), re = ie.length === 1 ? ie[0] : Z(ie), j.push(Z([P.args[X], re]));
    else
      for (var oe = 1; oe < P.args.length; oe++) {
        var ce = P.args[0];
        oe > 1 && (ce = Z(P.args.slice(0, oe))), ie = P.args.slice(oe), re = ie.length === 1 ? ie[0] : Z(ie), j.push(Z([ce, re]));
      }
    return j;
  }
  function fe(P, G) {
    var j = {
      placeholders: {}
    };
    if (!P.placeholders && !G.placeholders)
      return j;
    if (P.placeholders) {
      if (!G.placeholders)
        return P;
    } else
      return G;
    for (var re in P.placeholders)
      if (De(P.placeholders, re) && (j.placeholders[re] = P.placeholders[re], De(G.placeholders, re) && !L(P.placeholders[re], G.placeholders[re])))
        return null;
    for (var ie in G.placeholders)
      De(G.placeholders, ie) && (j.placeholders[ie] = G.placeholders[ie]);
    return j;
  }
  function pe(P, G) {
    var j = [];
    if (P.length === 0 || G.length === 0)
      return j;
    for (var re, ie = 0; ie < P.length; ie++)
      for (var Z = 0; Z < G.length; Z++)
        re = fe(P[ie], G[Z]), re && j.push(re);
    return j;
  }
  function Y(P) {
    if (P.length === 0)
      return P;
    for (var G = P.reduce(pe), j = [], re = {}, ie = 0; ie < G.length; ie++) {
      var Z = JSON.stringify(G[ie]);
      re[Z] || (re[Z] = !0, j.push(G[ie]));
    }
    return j;
  }
  function k(P, G, j, re) {
    var ie = [{
      placeholders: {}
    }];
    if (P instanceof O && G instanceof O || P instanceof N && G instanceof N) {
      if (P instanceof O) {
        if (P.op !== G.op || P.fn !== G.fn)
          return [];
      } else if (P instanceof N && P.name !== G.name)
        return [];
      if (G.args.length === 1 && P.args.length === 1 || !A(G, j) && G.args.length === P.args.length || re) {
        for (var Z = [], X = 0; X < P.args.length; X++) {
          var oe = k(P.args[X], G.args[X], j);
          if (oe.length === 0)
            break;
          Z.push(oe);
        }
        if (Z.length !== P.args.length) {
          if (!w(G, j) || // exact match in order needed
          P.args.length === 1)
            return [];
          if (P.args.length > 2)
            throw new Error("permuting >2 commutative non-associative rule arguments not yet implemented");
          var ce = k(P.args[0], G.args[1], j);
          if (ce.length === 0)
            return [];
          var le = k(P.args[1], G.args[0], j);
          if (le.length === 0)
            return [];
          Z = [ce, le];
        }
        ie = Y(Z);
      } else if (G.args.length >= 2 && P.args.length === 2) {
        for (var ve = W(G, j), ge = [], me = 0; me < ve.length; me++) {
          var we = k(P, ve[me], j, !0);
          ge = ge.concat(we);
        }
        return ge;
      } else {
        if (P.args.length > 2)
          throw Error("Unexpected non-binary associative function: " + P.toString());
        return [];
      }
    } else if (P instanceof $) {
      if (P.name.length === 0)
        throw new Error("Symbol in rule has 0 length...!?");
      if (ee[P.name]) {
        if (P.name !== G.name)
          return [];
      } else
        switch (P.name[1] >= "a" && P.name[1] <= "z" ? P.name.substring(0, 2) : P.name[0]) {
          case "n":
          case "_p":
            ie[0].placeholders[P.name] = G;
            break;
          case "c":
          case "cl":
            if (rr(G))
              ie[0].placeholders[P.name] = G;
            else
              return [];
            break;
          case "v":
            if (!rr(G))
              ie[0].placeholders[P.name] = G;
            else
              return [];
            break;
          case "vl":
            if (Br(G))
              ie[0].placeholders[P.name] = G;
            else
              return [];
            break;
          case "cd":
            if (Sm(G))
              ie[0].placeholders[P.name] = G;
            else
              return [];
            break;
          case "vd":
            if (!Sm(G))
              ie[0].placeholders[P.name] = G;
            else
              return [];
            break;
          case "ce":
            if (Ua(G))
              ie[0].placeholders[P.name] = G;
            else
              return [];
            break;
          case "ve":
            if (!Ua(G))
              ie[0].placeholders[P.name] = G;
            else
              return [];
            break;
          default:
            throw new Error("Invalid symbol in rule: " + P.name);
        }
    } else if (P instanceof E) {
      if (!a(P.value, G.value))
        return [];
    } else
      return [];
    return ie;
  }
  function L(P, G) {
    if (P instanceof E && G instanceof E) {
      if (!a(P.value, G.value))
        return !1;
    } else if (P instanceof $ && G instanceof $) {
      if (P.name !== G.name)
        return !1;
    } else if (P instanceof O && G instanceof O || P instanceof N && G instanceof N) {
      if (P instanceof O) {
        if (P.op !== G.op || P.fn !== G.fn)
          return !1;
      } else if (P instanceof N && P.name !== G.name)
        return !1;
      if (P.args.length !== G.args.length)
        return !1;
      for (var j = 0; j < P.args.length; j++)
        if (!L(P.args[j], G.args[j]))
          return !1;
    } else
      return !1;
    return !0;
  }
  return I;
}), RF = "simplifyConstant", PF = ["typed", "config", "mathWithTransform", "matrix", "?fraction", "?bignumber", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "SymbolNode"], qF = /* @__PURE__ */ Q(RF, PF, (e) => {
  var {
    typed: r,
    config: o,
    mathWithTransform: n,
    matrix: i,
    fraction: t,
    bignumber: u,
    AccessorNode: l,
    ArrayNode: f,
    ConstantNode: s,
    FunctionNode: a,
    IndexNode: c,
    ObjectNode: d,
    OperatorNode: h,
    SymbolNode: p
  } = e, {
    isCommutative: v,
    isAssociative: g,
    allChildren: m,
    createMakeNodeFunction: x
  } = hc({
    FunctionNode: a,
    OperatorNode: h,
    SymbolNode: p
  }), y = r("simplifyConstant", {
    Node: (D) => R(b(D, {})),
    "Node, Object": function(M, _) {
      return R(b(M, _));
    }
  });
  function E(D) {
    return An(D) ? D.valueOf() : D instanceof Array ? D.map(E) : Fe(D) ? i(E(D.valueOf())) : D;
  }
  function N(D, M, _) {
    try {
      return n[D].apply(null, M);
    } catch {
      return M = M.map(E), B(n[D].apply(null, M), _);
    }
  }
  var S = r({
    Fraction: F,
    number: function(M) {
      return M < 0 ? $(new s(-M)) : new s(M);
    },
    BigNumber: function(M) {
      return M < 0 ? $(new s(-M)) : new s(M);
    },
    bigint: function(M) {
      return M < 0n ? $(new s(-M)) : new s(M);
    },
    Complex: function(M) {
      throw new Error("Cannot convert Complex number to Node");
    },
    string: function(M) {
      return new s(M);
    },
    Matrix: function(M) {
      return new f(M.valueOf().map((_) => S(_)));
    }
  });
  function R(D) {
    return or(D) ? D : S(D);
  }
  function O(D, M) {
    var _ = M && M.exactFractions !== !1;
    if (_ && isFinite(D) && t) {
      var q = t(D), C = M && typeof M.fractionsLimit == "number" ? M.fractionsLimit : 1 / 0;
      if (q.valueOf() === D && q.n < C && q.d < C)
        return q;
    }
    return D;
  }
  var B = r({
    "string, Object": function(M, _) {
      var q = sn(M, o);
      if (q === "BigNumber")
        return u === void 0 && zf(), u(M);
      if (q === "bigint")
        return BigInt(M);
      if (q === "Fraction")
        return t === void 0 && Yg(), t(M);
      var C = parseFloat(M);
      return O(C, _);
    },
    "Fraction, Object": function(M, _) {
      return M;
    },
    // we don't need options here
    "BigNumber, Object": function(M, _) {
      return M;
    },
    // we don't need options here
    "number, Object": function(M, _) {
      return O(M, _);
    },
    "bigint, Object": function(M, _) {
      return M;
    },
    "Complex, Object": function(M, _) {
      return M.im !== 0 ? M : O(M.re, _);
    },
    "Matrix, Object": function(M, _) {
      return i(O(M.valueOf()));
    },
    "Array, Object": function(M, _) {
      return M.map(O);
    }
  });
  function $(D) {
    return new h("-", "unaryMinus", [D]);
  }
  function F(D) {
    var M, _ = D.s * D.n;
    return _ < 0 ? M = new h("-", "unaryMinus", [new s(-_)]) : M = new s(_), D.d === 1 ? M : new h("/", "divide", [M, new s(D.d)]);
  }
  function w(D, M, _) {
    if (!Sn(M))
      return new l(R(D), R(M));
    if (tt(D) || Fe(D)) {
      for (var q = Array.from(M.dimensions); q.length > 0; )
        if (rr(q[0]) && typeof q[0].value != "string") {
          var C = B(q.shift().value, _);
          tt(D) ? D = D.items[C - 1] : (D = D.valueOf()[C - 1], D instanceof Array && (D = i(D)));
        } else if (q.length > 1 && rr(q[1]) && typeof q[1].value != "string") {
          var T = B(q[1].value, _), z = [], I = tt(D) ? D.items : D.valueOf();
          for (var U of I)
            if (tt(U))
              z.push(U.items[T - 1]);
            else if (Fe(D))
              z.push(U[T - 1]);
            else
              break;
          if (z.length === I.length)
            tt(D) ? D = new f(z) : D = i(z), q.splice(1, 1);
          else
            break;
        } else
          break;
      return q.length === M.dimensions.length ? new l(R(D), M) : q.length > 0 ? (M = new c(q), new l(R(D), M)) : D;
    }
    if (_i(D) && M.dimensions.length === 1 && rr(M.dimensions[0])) {
      var ee = M.dimensions[0].value;
      return ee in D.properties ? D.properties[ee] : new s();
    }
    return new l(R(D), M);
  }
  function A(D, M, _, q) {
    var C = M.shift(), T = M.reduce((z, I) => {
      if (!or(I)) {
        var U = z.pop();
        if (or(U))
          return [U, I];
        try {
          return z.push(N(D, [U, I], q)), z;
        } catch {
          z.push(U);
        }
      }
      z.push(R(z.pop()));
      var ee = z.length === 1 ? z[0] : _(z);
      return [_([ee, R(I)])];
    }, [C]);
    return T.length === 1 ? T[0] : _([T[0], S(T[1])]);
  }
  function b(D, M) {
    switch (D.type) {
      case "SymbolNode":
        return D;
      case "ConstantNode":
        switch (typeof D.value) {
          case "number":
            return B(D.value, M);
          case "bigint":
            return B(D.value, M);
          case "string":
            return D.value;
          default:
            if (!isNaN(D.value))
              return B(D.value, M);
        }
        return D;
      case "FunctionNode":
        if (n[D.name] && n[D.name].rawArgs)
          return D;
        {
          var _ = ["add", "multiply"];
          if (!_.includes(D.name)) {
            var q = D.args.map((V) => b(V, M));
            if (!q.some(or))
              try {
                return N(D.name, q, M);
              } catch {
              }
            if (D.name === "size" && q.length === 1 && tt(q[0])) {
              for (var C = [], T = q[0]; tt(T); )
                C.push(T.items.length), T = T.items[0];
              return i(C);
            }
            return new a(D.name, q.map(R));
          }
        }
      case "OperatorNode": {
        var z = D.fn.toString(), I, U, ee = x(D);
        if (Cr(D) && D.isUnary())
          I = [b(D.args[0], M)], or(I[0]) ? U = ee(I) : U = N(z, I, M);
        else if (g(D, M.context))
          if (I = m(D, M.context), I = I.map((V) => b(V, M)), v(z, M.context)) {
            for (var se = [], K = [], J = 0; J < I.length; J++)
              or(I[J]) ? K.push(I[J]) : se.push(I[J]);
            se.length > 1 ? (U = A(z, se, ee, M), K.unshift(U), U = A(z, K, ee, M)) : U = A(z, I, ee, M);
          } else
            U = A(z, I, ee, M);
        else
          I = D.args.map((V) => b(V, M)), U = A(z, I, ee, M);
        return U;
      }
      case "ParenthesisNode":
        return b(D.content, M);
      case "AccessorNode":
        return w(b(D.object, M), b(D.index, M), M);
      case "ArrayNode": {
        var te = D.items.map((V) => b(V, M));
        return te.some(or) ? new f(te.map(R)) : i(te);
      }
      case "IndexNode":
        return new c(D.dimensions.map((V) => y(V, M)));
      case "ObjectNode": {
        var ne = {};
        for (var ue in D.properties)
          ne[ue] = y(D.properties[ue], M);
        return new d(ne);
      }
      case "AssignmentNode":
      case "BlockNode":
      case "FunctionAssignmentNode":
      case "RangeNode":
      case "ConditionalNode":
      default:
        throw new Error("Unimplemented node type in simplifyConstant: ".concat(D.type));
    }
  }
  return y;
}), Nm = "simplifyCore", $F = ["typed", "parse", "equal", "isZero", "add", "subtract", "multiply", "divide", "pow", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], zF = /* @__PURE__ */ Q(Nm, $F, (e) => {
  var {
    typed: r,
    parse: o,
    equal: n,
    isZero: i,
    add: t,
    subtract: u,
    multiply: l,
    divide: f,
    pow: s,
    AccessorNode: a,
    ArrayNode: c,
    ConstantNode: d,
    FunctionNode: h,
    IndexNode: p,
    ObjectNode: v,
    OperatorNode: g,
    ParenthesisNode: m,
    SymbolNode: x
  } = e, y = new d(0), E = new d(1), N = new d(!0), S = new d(!1);
  function R(F) {
    return Cr(F) && ["and", "not", "or"].includes(F.op);
  }
  var {
    hasProperty: O,
    isCommutative: B
  } = hc({
    FunctionNode: h,
    OperatorNode: g,
    SymbolNode: x
  });
  function $(F) {
    var w = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, A = w ? w.context : void 0;
    if (O(F, "trivial", A)) {
      if (Gt(F) && F.args.length === 1)
        return $(F.args[0], w);
      var b = !1, D = 0;
      if (F.forEach((K) => {
        ++D, D === 1 && (b = $(K, w));
      }), D === 1)
        return b;
    }
    var M = F;
    if (Gt(M)) {
      var _ = G7(M.name);
      if (_) {
        if (M.args.length > 2 && O(M, "associative", A))
          for (; M.args.length > 2; ) {
            var q = M.args.pop(), C = M.args.pop();
            M.args.push(new g(_, M.name, [q, C]));
          }
        M = new g(_, M.name, M.args);
      } else
        return new h($(M.fn), M.args.map((K) => $(K, w)));
    }
    if (Cr(M) && M.isUnary()) {
      var T = $(M.args[0], w);
      if (M.op === "~" && Cr(T) && T.isUnary() && T.op === "~" || M.op === "not" && Cr(T) && T.isUnary() && T.op === "not" && R(T.args[0]))
        return T.args[0];
      var z = !0;
      if (M.op === "-" && Cr(T) && (T.isBinary() && T.fn === "subtract" && (M = new g("-", "subtract", [T.args[1], T.args[0]]), z = !1), T.isUnary() && T.op === "-"))
        return T.args[0];
      if (z)
        return new g(M.op, M.fn, [T]);
    }
    if (Cr(M) && M.isBinary()) {
      var I = $(M.args[0], w), U = $(M.args[1], w);
      if (M.op === "+") {
        if (rr(I) && i(I.value))
          return U;
        if (rr(U) && i(U.value))
          return I;
        Cr(U) && U.isUnary() && U.op === "-" && (U = U.args[0], M = new g("-", "subtract", [I, U]));
      }
      if (M.op === "-")
        return Cr(U) && U.isUnary() && U.op === "-" ? $(new g("+", "add", [I, U.args[0]]), w) : rr(I) && i(I.value) ? $(new g("-", "unaryMinus", [U])) : rr(U) && i(U.value) ? I : new g(M.op, M.fn, [I, U]);
      if (M.op === "*") {
        if (rr(I)) {
          if (i(I.value))
            return y;
          if (n(I.value, 1))
            return U;
        }
        if (rr(U)) {
          if (i(U.value))
            return y;
          if (n(U.value, 1))
            return I;
          if (B(M, A))
            return new g(M.op, M.fn, [U, I], M.implicit);
        }
        return new g(M.op, M.fn, [I, U], M.implicit);
      }
      if (M.op === "/")
        return rr(I) && i(I.value) ? y : rr(U) && n(U.value, 1) ? I : new g(M.op, M.fn, [I, U]);
      if (M.op === "^" && rr(U)) {
        if (i(U.value))
          return E;
        if (n(U.value, 1))
          return I;
      }
      if (M.op === "and") {
        if (rr(I))
          if (I.value) {
            if (R(U))
              return U;
            if (rr(U))
              return U.value ? N : S;
          } else
            return S;
        if (rr(U))
          if (U.value) {
            if (R(I))
              return I;
          } else
            return S;
      }
      if (M.op === "or") {
        if (rr(I)) {
          if (I.value)
            return N;
          if (R(U))
            return U;
        }
        if (rr(U)) {
          if (U.value)
            return N;
          if (R(I))
            return I;
        }
      }
      return new g(M.op, M.fn, [I, U]);
    }
    if (Cr(M))
      return new g(M.op, M.fn, M.args.map((K) => $(K, w)));
    if (tt(M))
      return new c(M.items.map((K) => $(K, w)));
    if (nn(M))
      return new a($(M.object, w), $(M.index, w));
    if (Sn(M))
      return new p(M.dimensions.map((K) => $(K, w)));
    if (_i(M)) {
      var ee = {};
      for (var se in M.properties)
        ee[se] = $(M.properties[se], w);
      return new v(ee);
    }
    return M;
  }
  return r(Nm, {
    Node: $,
    "Node,Object": $
  });
}), LF = "resolve", UF = ["typed", "parse", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode"], kF = /* @__PURE__ */ Q(LF, UF, (e) => {
  var {
    typed: r,
    parse: o,
    ConstantNode: n,
    FunctionNode: i,
    OperatorNode: t,
    ParenthesisNode: u
  } = e;
  function l(f, s) {
    var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : /* @__PURE__ */ new Set();
    if (!s)
      return f;
    if (Br(f)) {
      if (a.has(f.name)) {
        var c = Array.from(a).join(", ");
        throw new ReferenceError("recursive loop of variable definitions among {".concat(c, "}"));
      }
      var d = s.get(f.name);
      if (or(d)) {
        var h = new Set(a);
        return h.add(f.name), l(d, s, h);
      } else
        return typeof d == "number" ? o(String(d)) : d !== void 0 ? new n(d) : f;
    } else if (Cr(f)) {
      var p = f.args.map(function(g) {
        return l(g, s, a);
      });
      return new t(f.op, f.fn, p, f.implicit);
    } else {
      if (Dt(f))
        return new u(l(f.content, s, a));
      if (Gt(f)) {
        var v = f.args.map(function(g) {
          return l(g, s, a);
        });
        return new i(f.name, v);
      }
    }
    return f.map((g) => l(g, s, a));
  }
  return r("resolve", {
    Node: l,
    "Node, Map | null | undefined": l,
    "Node, Object": (f, s) => l(f, zn(s)),
    // For arrays and matrices, we map `self` rather than `_resolve`
    // because resolve is fairly expensive anyway, and this way
    // we get nice error messages if one entry in the array has wrong type.
    "Array | Matrix": r.referToSelf((f) => (s) => s.map((a) => f(a))),
    "Array | Matrix, null | undefined": r.referToSelf((f) => (s) => s.map((a) => f(a))),
    "Array, Object": r.referTo("Array,Map", (f) => (s, a) => f(s, zn(a))),
    "Matrix, Object": r.referTo("Matrix,Map", (f) => (s, a) => f(s, zn(a))),
    "Array | Matrix, Map": r.referToSelf((f) => (s, a) => s.map((c) => f(c, a)))
  });
}), Mm = "symbolicEqual", HF = ["parse", "simplify", "typed", "OperatorNode"], GF = /* @__PURE__ */ Q(Mm, HF, (e) => {
  var {
    parse: r,
    simplify: o,
    typed: n,
    OperatorNode: i
  } = e;
  function t(u, l) {
    var f = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = new i("-", "subtract", [u, l]), a = o(s, {}, f);
    return rr(a) && !a.value;
  }
  return n(Mm, {
    "Node, Node": t,
    "Node, Node, Object": t
  });
}), _m = "derivative", VF = ["typed", "config", "parse", "simplify", "equal", "isZero", "numeric", "ConstantNode", "FunctionNode", "OperatorNode", "ParenthesisNode", "SymbolNode"], WF = /* @__PURE__ */ Q(_m, VF, (e) => {
  var {
    typed: r,
    config: o,
    parse: n,
    simplify: i,
    equal: t,
    isZero: u,
    numeric: l,
    ConstantNode: f,
    FunctionNode: s,
    OperatorNode: a,
    ParenthesisNode: c,
    SymbolNode: d
  } = e;
  function h(y, E) {
    var N = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
      simplify: !0
    }, S = {};
    g(S, y, E.name);
    var R = m(y, S);
    return N.simplify ? i(R) : R;
  }
  r.addConversion({
    from: "identifier",
    to: "SymbolNode",
    convert: n
  });
  var p = r(_m, {
    "Node, SymbolNode": h,
    "Node, SymbolNode, Object": h
    /* TODO: implement and test syntax with order of derivatives -> implement as an option {order: number}
    'Node, SymbolNode, ConstantNode': function (expr, variable, {order}) {
      let res = expr
      for (let i = 0; i < order; i++) {
        let constNodes = {}
        constTag(constNodes, expr, variable.name)
        res = _derivative(res, constNodes)
      }
      return res
    }
    */
  });
  r.removeConversion({
    from: "identifier",
    to: "SymbolNode",
    convert: n
  }), p._simplify = !0, p.toTex = function(y) {
    return v.apply(null, y.args);
  };
  var v = r("_derivTex", {
    "Node, SymbolNode": function(E, N) {
      return rr(E) && fr(E.value) === "string" ? v(n(E.value).toString(), N.toString(), 1) : v(E.toTex(), N.toString(), 1);
    },
    "Node, ConstantNode": function(E, N) {
      if (fr(N.value) === "string")
        return v(E, n(N.value));
      throw new Error("The second parameter to 'derivative' is a non-string constant");
    },
    "Node, SymbolNode, ConstantNode": function(E, N, S) {
      return v(E.toString(), N.name, S.value);
    },
    "string, string, number": function(E, N, S) {
      var R;
      return S === 1 ? R = "{d\\over d" + N + "}" : R = "{d^{" + S + "}\\over d" + N + "^{" + S + "}}", R + "\\left[".concat(E, "\\right]");
    }
  }), g = r("constTag", {
    "Object, ConstantNode, string": function(E, N) {
      return E[N] = !0, !0;
    },
    "Object, SymbolNode, string": function(E, N, S) {
      return N.name !== S ? (E[N] = !0, !0) : !1;
    },
    "Object, ParenthesisNode, string": function(E, N, S) {
      return g(E, N.content, S);
    },
    "Object, FunctionAssignmentNode, string": function(E, N, S) {
      return N.params.includes(S) ? g(E, N.expr, S) : (E[N] = !0, !0);
    },
    "Object, FunctionNode | OperatorNode, string": function(E, N, S) {
      if (N.args.length > 0) {
        for (var R = g(E, N.args[0], S), O = 1; O < N.args.length; ++O)
          R = g(E, N.args[O], S) && R;
        if (R)
          return E[N] = !0, !0;
      }
      return !1;
    }
  }), m = r("_derivative", {
    "ConstantNode, Object": function(E) {
      return x(0);
    },
    "SymbolNode, Object": function(E, N) {
      return N[E] !== void 0 ? x(0) : x(1);
    },
    "ParenthesisNode, Object": function(E, N) {
      return new c(m(E.content, N));
    },
    "FunctionAssignmentNode, Object": function(E, N) {
      return N[E] !== void 0 ? x(0) : m(E.expr, N);
    },
    "FunctionNode, Object": function(E, N) {
      if (N[E] !== void 0)
        return x(0);
      var S = E.args[0], R, O = !1, B = !1, $;
      switch (E.name) {
        case "cbrt":
          O = !0, $ = new a("*", "multiply", [x(3), new a("^", "pow", [S, new a("/", "divide", [x(2), x(3)])])]);
          break;
        case "sqrt":
        case "nthRoot":
          if (E.args.length === 1)
            O = !0, $ = new a("*", "multiply", [x(2), new s("sqrt", [S])]);
          else if (E.args.length === 2)
            return R = new a("/", "divide", [x(1), E.args[1]]), N[R] = N[E.args[1]], m(new a("^", "pow", [S, R]), N);
          break;
        case "log10":
          R = x(10);
        case "log":
          if (!R && E.args.length === 1)
            $ = S.clone(), O = !0;
          else if (E.args.length === 1 && R || E.args.length === 2 && N[E.args[1]] !== void 0)
            $ = new a("*", "multiply", [S.clone(), new s("log", [R || E.args[1]])]), O = !0;
          else if (E.args.length === 2)
            return m(new a("/", "divide", [new s("log", [S]), new s("log", [E.args[1]])]), N);
          break;
        case "pow":
          if (E.args.length === 2)
            return N[R] = N[E.args[1]], m(new a("^", "pow", [S, E.args[1]]), N);
          break;
        case "exp":
          $ = new s("exp", [S.clone()]);
          break;
        case "sin":
          $ = new s("cos", [S.clone()]);
          break;
        case "cos":
          $ = new a("-", "unaryMinus", [new s("sin", [S.clone()])]);
          break;
        case "tan":
          $ = new a("^", "pow", [new s("sec", [S.clone()]), x(2)]);
          break;
        case "sec":
          $ = new a("*", "multiply", [E, new s("tan", [S.clone()])]);
          break;
        case "csc":
          B = !0, $ = new a("*", "multiply", [E, new s("cot", [S.clone()])]);
          break;
        case "cot":
          B = !0, $ = new a("^", "pow", [new s("csc", [S.clone()]), x(2)]);
          break;
        case "asin":
          O = !0, $ = new s("sqrt", [new a("-", "subtract", [x(1), new a("^", "pow", [S.clone(), x(2)])])]);
          break;
        case "acos":
          O = !0, B = !0, $ = new s("sqrt", [new a("-", "subtract", [x(1), new a("^", "pow", [S.clone(), x(2)])])]);
          break;
        case "atan":
          O = !0, $ = new a("+", "add", [new a("^", "pow", [S.clone(), x(2)]), x(1)]);
          break;
        case "asec":
          O = !0, $ = new a("*", "multiply", [new s("abs", [S.clone()]), new s("sqrt", [new a("-", "subtract", [new a("^", "pow", [S.clone(), x(2)]), x(1)])])]);
          break;
        case "acsc":
          O = !0, B = !0, $ = new a("*", "multiply", [new s("abs", [S.clone()]), new s("sqrt", [new a("-", "subtract", [new a("^", "pow", [S.clone(), x(2)]), x(1)])])]);
          break;
        case "acot":
          O = !0, B = !0, $ = new a("+", "add", [new a("^", "pow", [S.clone(), x(2)]), x(1)]);
          break;
        case "sinh":
          $ = new s("cosh", [S.clone()]);
          break;
        case "cosh":
          $ = new s("sinh", [S.clone()]);
          break;
        case "tanh":
          $ = new a("^", "pow", [new s("sech", [S.clone()]), x(2)]);
          break;
        case "sech":
          B = !0, $ = new a("*", "multiply", [E, new s("tanh", [S.clone()])]);
          break;
        case "csch":
          B = !0, $ = new a("*", "multiply", [E, new s("coth", [S.clone()])]);
          break;
        case "coth":
          B = !0, $ = new a("^", "pow", [new s("csch", [S.clone()]), x(2)]);
          break;
        case "asinh":
          O = !0, $ = new s("sqrt", [new a("+", "add", [new a("^", "pow", [S.clone(), x(2)]), x(1)])]);
          break;
        case "acosh":
          O = !0, $ = new s("sqrt", [new a("-", "subtract", [new a("^", "pow", [S.clone(), x(2)]), x(1)])]);
          break;
        case "atanh":
          O = !0, $ = new a("-", "subtract", [x(1), new a("^", "pow", [S.clone(), x(2)])]);
          break;
        case "asech":
          O = !0, B = !0, $ = new a("*", "multiply", [S.clone(), new s("sqrt", [new a("-", "subtract", [x(1), new a("^", "pow", [S.clone(), x(2)])])])]);
          break;
        case "acsch":
          O = !0, B = !0, $ = new a("*", "multiply", [new s("abs", [S.clone()]), new s("sqrt", [new a("+", "add", [new a("^", "pow", [S.clone(), x(2)]), x(1)])])]);
          break;
        case "acoth":
          O = !0, B = !0, $ = new a("-", "subtract", [x(1), new a("^", "pow", [S.clone(), x(2)])]);
          break;
        case "abs":
          $ = new a("/", "divide", [new s(new d("abs"), [S.clone()]), S.clone()]);
          break;
        case "gamma":
        default:
          throw new Error('Cannot process function "' + E.name + '" in derivative: the function is not supported, undefined, or the number of arguments passed to it are not supported');
      }
      var F, w;
      O ? (F = "/", w = "divide") : (F = "*", w = "multiply");
      var A = m(S, N);
      return B && (A = new a("-", "unaryMinus", [A])), new a(F, w, [A, $]);
    },
    "OperatorNode, Object": function(E, N) {
      if (N[E] !== void 0)
        return x(0);
      if (E.op === "+")
        return new a(E.op, E.fn, E.args.map(function(D) {
          return m(D, N);
        }));
      if (E.op === "-") {
        if (E.isUnary())
          return new a(E.op, E.fn, [m(E.args[0], N)]);
        if (E.isBinary())
          return new a(E.op, E.fn, [m(E.args[0], N), m(E.args[1], N)]);
      }
      if (E.op === "*") {
        var S = E.args.filter(function(D) {
          return N[D] !== void 0;
        });
        if (S.length > 0) {
          var R = E.args.filter(function(D) {
            return N[D] === void 0;
          }), O = R.length === 1 ? R[0] : new a("*", "multiply", R), B = S.concat(m(O, N));
          return new a("*", "multiply", B);
        }
        return new a("+", "add", E.args.map(function(D) {
          return new a("*", "multiply", E.args.map(function(M) {
            return M === D ? m(M, N) : M.clone();
          }));
        }));
      }
      if (E.op === "/" && E.isBinary()) {
        var $ = E.args[0], F = E.args[1];
        return N[F] !== void 0 ? new a("/", "divide", [m($, N), F]) : N[$] !== void 0 ? new a("*", "multiply", [new a("-", "unaryMinus", [$]), new a("/", "divide", [m(F, N), new a("^", "pow", [F.clone(), x(2)])])]) : new a("/", "divide", [new a("-", "subtract", [new a("*", "multiply", [m($, N), F.clone()]), new a("*", "multiply", [$.clone(), m(F, N)])]), new a("^", "pow", [F.clone(), x(2)])]);
      }
      if (E.op === "^" && E.isBinary()) {
        var w = E.args[0], A = E.args[1];
        if (N[w] !== void 0)
          return rr(w) && (u(w.value) || t(w.value, 1)) ? x(0) : new a("*", "multiply", [E, new a("*", "multiply", [new s("log", [w.clone()]), m(A.clone(), N)])]);
        if (N[A] !== void 0) {
          if (rr(A)) {
            if (u(A.value))
              return x(0);
            if (t(A.value, 1))
              return m(w, N);
          }
          var b = new a("^", "pow", [w.clone(), new a("-", "subtract", [A, x(1)])]);
          return new a("*", "multiply", [A.clone(), new a("*", "multiply", [m(w, N), b])]);
        }
        return new a("*", "multiply", [new a("^", "pow", [w.clone(), A.clone()]), new a("+", "add", [new a("*", "multiply", [m(w, N), new a("/", "divide", [A.clone(), w.clone()])]), new a("*", "multiply", [m(A, N), new s("log", [w.clone()])])])]);
      }
      throw new Error('Cannot process operator "' + E.op + '" in derivative: the operator is not supported, undefined, or the number of arguments passed to it are not supported');
    }
  });
  function x(y, E) {
    return new f(l(y, E || sn(String(y), o)));
  }
  return p;
}), Cm = "rationalize", KF = ["config", "typed", "equal", "isZero", "add", "subtract", "multiply", "divide", "pow", "parse", "simplifyConstant", "simplifyCore", "simplify", "?bignumber", "?fraction", "mathWithTransform", "matrix", "AccessorNode", "ArrayNode", "ConstantNode", "FunctionNode", "IndexNode", "ObjectNode", "OperatorNode", "SymbolNode", "ParenthesisNode"], ZF = /* @__PURE__ */ Q(Cm, KF, (e) => {
  var {
    config: r,
    typed: o,
    equal: n,
    isZero: i,
    add: t,
    subtract: u,
    multiply: l,
    divide: f,
    pow: s,
    parse: a,
    simplifyConstant: c,
    simplifyCore: d,
    simplify: h,
    fraction: p,
    bignumber: v,
    mathWithTransform: g,
    matrix: m,
    AccessorNode: x,
    ArrayNode: y,
    ConstantNode: E,
    FunctionNode: N,
    IndexNode: S,
    ObjectNode: R,
    OperatorNode: O,
    SymbolNode: B,
    ParenthesisNode: $
  } = e;
  function F(M) {
    var _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, C = A(), T = w(M, _, !0, C.firstRules), z = T.variables.length, I = {
      exactFractions: !1
    }, U = {
      exactFractions: !0
    };
    if (M = T.expression, z >= 1) {
      M = b(M);
      var ee, se, K = !0, J = !1;
      M = h(M, C.firstRules, {}, I);
      for (var te; se = K ? C.distrDivRules : C.sucDivRules, M = h(M, se, {}, U), K = !K, te = M.toString(), te !== ee; )
        J = !0, ee = te;
      J && (M = h(M, C.firstRulesAgain, {}, I)), M = h(M, C.finalRules, {}, I);
    }
    var ne = [], ue = {};
    return M.type === "OperatorNode" && M.isBinary() && M.op === "/" ? (z === 1 && (M.args[0] = D(M.args[0], ne), M.args[1] = D(M.args[1])), q && (ue.numerator = M.args[0], ue.denominator = M.args[1])) : (z === 1 && (M = D(M, ne)), q && (ue.numerator = M, ue.denominator = null)), q ? (ue.coefficients = ne, ue.variables = T.variables, ue.expression = M, ue) : M;
  }
  return o(Cm, {
    Node: F,
    "Node, boolean": (M, _) => F(M, {}, _),
    "Node, Object": F,
    "Node, Object, boolean": F
  });
  function w(M, _, q, C) {
    var T = [], z = h(M, C, _, {
      exactFractions: !1
    });
    q = !!q;
    var I = "+-*" + (q ? "/" : "");
    ee(z);
    var U = {};
    return U.expression = z, U.variables = T, U;
    function ee(se) {
      var K = se.type;
      if (K === "FunctionNode")
        throw new Error("There is an unsolved function call");
      if (K === "OperatorNode")
        if (se.op === "^") {
          if (se.args[1].type !== "ConstantNode" || !Te(parseFloat(se.args[1].value)))
            throw new Error("There is a non-integer exponent");
          ee(se.args[0]);
        } else {
          if (!I.includes(se.op))
            throw new Error("Operator " + se.op + " invalid in polynomial expression");
          for (var J = 0; J < se.args.length; J++)
            ee(se.args[J]);
        }
      else if (K === "SymbolNode") {
        var te = se.name, ne = T.indexOf(te);
        ne === -1 && T.push(te);
      } else if (K === "ParenthesisNode")
        ee(se.content);
      else if (K !== "ConstantNode")
        throw new Error("type " + K + " is not allowed in polynomial expression");
    }
  }
  function A() {
    var M = [
      d,
      // sCore
      {
        l: "n+n",
        r: "2*n"
      },
      {
        l: "n+-n",
        r: "0"
      },
      c,
      // sConstant
      {
        l: "n*(n1^-1)",
        r: "n/n1"
      },
      {
        l: "n*n1^-n2",
        r: "n/n1^n2"
      },
      {
        l: "n1^-1",
        r: "1/n1"
      },
      {
        l: "n*(n1/n2)",
        r: "(n*n1)/n2"
      },
      {
        l: "1*n",
        r: "n"
      }
    ], _ = [
      {
        l: "(-n1)/(-n2)",
        r: "n1/n2"
      },
      // Unary division
      {
        l: "(-n1)*(-n2)",
        r: "n1*n2"
      },
      // Unary multiplication
      {
        l: "n1--n2",
        r: "n1+n2"
      },
      // '--' elimination
      {
        l: "n1-n2",
        r: "n1+(-n2)"
      },
      // Subtraction turn into add with un�ry minus
      {
        l: "(n1+n2)*n3",
        r: "(n1*n3 + n2*n3)"
      },
      // Distributive 1
      {
        l: "n1*(n2+n3)",
        r: "(n1*n2+n1*n3)"
      },
      // Distributive 2
      {
        l: "c1*n + c2*n",
        r: "(c1+c2)*n"
      },
      // Joining constants
      {
        l: "c1*n + n",
        r: "(c1+1)*n"
      },
      // Joining constants
      {
        l: "c1*n - c2*n",
        r: "(c1-c2)*n"
      },
      // Joining constants
      {
        l: "c1*n - n",
        r: "(c1-1)*n"
      },
      // Joining constants
      {
        l: "v/c",
        r: "(1/c)*v"
      },
      // variable/constant (new!)
      {
        l: "v/-c",
        r: "-(1/c)*v"
      },
      // variable/constant (new!)
      {
        l: "-v*-c",
        r: "c*v"
      },
      // Inversion constant and variable 1
      {
        l: "-v*c",
        r: "-c*v"
      },
      // Inversion constant and variable 2
      {
        l: "v*-c",
        r: "-c*v"
      },
      // Inversion constant and variable 3
      {
        l: "v*c",
        r: "c*v"
      },
      // Inversion constant and variable 4
      {
        l: "-(-n1*n2)",
        r: "(n1*n2)"
      },
      // Unary propagation
      {
        l: "-(n1*n2)",
        r: "(-n1*n2)"
      },
      // Unary propagation
      {
        l: "-(-n1+n2)",
        r: "(n1-n2)"
      },
      // Unary propagation
      {
        l: "-(n1+n2)",
        r: "(-n1-n2)"
      },
      // Unary propagation
      {
        l: "(n1^n2)^n3",
        r: "(n1^(n2*n3))"
      },
      // Power to Power
      {
        l: "-(-n1/n2)",
        r: "(n1/n2)"
      },
      // Division and Unary
      {
        l: "-(n1/n2)",
        r: "(-n1/n2)"
      }
    ], q = [
      {
        l: "(n1/n2 + n3/n4)",
        r: "((n1*n4 + n3*n2)/(n2*n4))"
      },
      // Sum of fractions
      {
        l: "(n1/n2 + n3)",
        r: "((n1 + n3*n2)/n2)"
      },
      // Sum fraction with number 1
      {
        l: "(n1 + n2/n3)",
        r: "((n1*n3 + n2)/n3)"
      }
    ], C = [
      {
        l: "(n1/(n2/n3))",
        r: "((n1*n3)/n2)"
      },
      // Division simplification
      {
        l: "(n1/n2/n3)",
        r: "(n1/(n2*n3))"
      }
    ], T = {};
    return T.firstRules = M.concat(_, C), T.distrDivRules = q, T.sucDivRules = C, T.firstRulesAgain = M.concat(_), T.finalRules = [
      d,
      // simplify.rules[0]
      {
        l: "n*-n",
        r: "-n^2"
      },
      // Joining multiply with power 1
      {
        l: "n*n",
        r: "n^2"
      },
      // Joining multiply with power 2
      c,
      // simplify.rules[14] old 3rd index in oldRules
      {
        l: "n*-n^n1",
        r: "-n^(n1+1)"
      },
      // Joining multiply with power 3
      {
        l: "n*n^n1",
        r: "n^(n1+1)"
      },
      // Joining multiply with power 4
      {
        l: "n^n1*-n^n2",
        r: "-n^(n1+n2)"
      },
      // Joining multiply with power 5
      {
        l: "n^n1*n^n2",
        r: "n^(n1+n2)"
      },
      // Joining multiply with power 6
      {
        l: "n^n1*-n",
        r: "-n^(n1+1)"
      },
      // Joining multiply with power 7
      {
        l: "n^n1*n",
        r: "n^(n1+1)"
      },
      // Joining multiply with power 8
      {
        l: "n^n1/-n",
        r: "-n^(n1-1)"
      },
      // Joining multiply with power 8
      {
        l: "n^n1/n",
        r: "n^(n1-1)"
      },
      // Joining division with power 1
      {
        l: "n/-n^n1",
        r: "-n^(1-n1)"
      },
      // Joining division with power 2
      {
        l: "n/n^n1",
        r: "n^(1-n1)"
      },
      // Joining division with power 3
      {
        l: "n^n1/-n^n2",
        r: "n^(n1-n2)"
      },
      // Joining division with power 4
      {
        l: "n^n1/n^n2",
        r: "n^(n1-n2)"
      },
      // Joining division with power 5
      {
        l: "n1+(-n2*n3)",
        r: "n1-n2*n3"
      },
      // Solving useless parenthesis 1
      {
        l: "v*(-c)",
        r: "-c*v"
      },
      // Solving useless unary 2
      {
        l: "n1+-n2",
        r: "n1-n2"
      },
      // Solving +- together (new!)
      {
        l: "v*c",
        r: "c*v"
      },
      // inversion constant with variable
      {
        l: "(n1^n2)^n3",
        r: "(n1^(n2*n3))"
      }
      // Power to Power
    ], T;
  }
  function b(M, _, q) {
    var C = M.type, T = arguments.length > 1;
    if (C === "OperatorNode" && M.isBinary()) {
      var z = !1, I;
      if (M.op === "^" && (M.args[0].type === "ParenthesisNode" || M.args[0].type === "OperatorNode") && M.args[1].type === "ConstantNode" && (I = parseFloat(M.args[1].value), z = I >= 2 && Te(I)), z) {
        if (I > 2) {
          var U = M.args[0], ee = new O("^", "pow", [M.args[0].cloneDeep(), new E(I - 1)]);
          M = new O("*", "multiply", [U, ee]);
        } else
          M = new O("*", "multiply", [M.args[0], M.args[0].cloneDeep()]);
        T && (q === "content" ? _.content = M : _.args[q] = M);
      }
    }
    if (C === "ParenthesisNode")
      b(M.content, M, "content");
    else if (C !== "ConstantNode" && C !== "SymbolNode")
      for (var se = 0; se < M.args.length; se++)
        b(M.args[se], M, se);
    if (!T)
      return M;
  }
  function D(M, _) {
    _ === void 0 && (_ = []), _[0] = 0;
    var q = {};
    q.cte = 1, q.oper = "+", q.fire = "";
    var C = 0, T = "";
    te(M, null, q), C = _.length - 1;
    for (var z = !0, I, U = C; U >= 0; U--)
      if (_[U] !== 0) {
        var ee = new E(z ? _[U] : Math.abs(_[U])), se = _[U] < 0 ? "-" : "+";
        if (U > 0) {
          var K = new B(T);
          if (U > 1) {
            var J = new E(U);
            K = new O("^", "pow", [K, J]);
          }
          _[U] === -1 && z ? ee = new O("-", "unaryMinus", [K]) : Math.abs(_[U]) === 1 ? ee = K : ee = new O("*", "multiply", [ee, K]);
        }
        z ? I = ee : se === "+" ? I = new O("+", "add", [I, ee]) : I = new O("-", "subtract", [I, ee]), z = !1;
      }
    if (z)
      return new E(0);
    return I;
    function te(ne, ue, V) {
      var W = ne.type;
      if (W === "FunctionNode")
        throw new Error("There is an unsolved function call");
      if (W === "OperatorNode") {
        if (!"+-*^".includes(ne.op))
          throw new Error("Operator " + ne.op + " invalid");
        if (ue !== null) {
          if ((ne.fn === "unaryMinus" || ne.fn === "pow") && ue.fn !== "add" && ue.fn !== "subtract" && ue.fn !== "multiply")
            throw new Error("Invalid " + ne.op + " placing");
          if ((ne.fn === "subtract" || ne.fn === "add" || ne.fn === "multiply") && ue.fn !== "add" && ue.fn !== "subtract")
            throw new Error("Invalid " + ne.op + " placing");
          if ((ne.fn === "subtract" || ne.fn === "add" || ne.fn === "unaryMinus") && V.noFil !== 0)
            throw new Error("Invalid " + ne.op + " placing");
        }
        (ne.op === "^" || ne.op === "*") && (V.fire = ne.op);
        for (var fe = 0; fe < ne.args.length; fe++)
          ne.fn === "unaryMinus" && (V.oper = "-"), (ne.op === "+" || ne.fn === "subtract") && (V.fire = "", V.cte = 1, V.oper = fe === 0 ? "+" : ne.op), V.noFil = fe, te(ne.args[fe], ne, V);
      } else if (W === "SymbolNode") {
        if (ne.name !== T && T !== "")
          throw new Error("There is more than one variable");
        if (T = ne.name, ue === null) {
          _[1] = 1;
          return;
        }
        if (ue.op === "^" && V.noFil !== 0)
          throw new Error("In power the variable should be the first parameter");
        if (ue.op === "*" && V.noFil !== 1)
          throw new Error("In multiply the variable should be the second parameter");
        (V.fire === "" || V.fire === "*") && (C < 1 && (_[1] = 0), _[1] += V.cte * (V.oper === "+" ? 1 : -1), C = Math.max(1, C));
      } else if (W === "ConstantNode") {
        var pe = parseFloat(ne.value);
        if (ue === null) {
          _[0] = pe;
          return;
        }
        if (ue.op === "^") {
          if (V.noFil !== 1)
            throw new Error("Constant cannot be powered");
          if (!Te(pe) || pe <= 0)
            throw new Error("Non-integer exponent is not allowed");
          for (var Y = C + 1; Y < pe; Y++)
            _[Y] = 0;
          pe > C && (_[pe] = 0), _[pe] += V.cte * (V.oper === "+" ? 1 : -1), C = Math.max(pe, C);
          return;
        }
        V.cte = pe, V.fire === "" && (_[0] += V.cte * (V.oper === "+" ? 1 : -1));
      } else
        throw new Error("Type " + W + " is not allowed");
    }
  }
}), Tm = "zpk2tf", jF = ["typed", "add", "multiply", "Complex", "number"], YF = /* @__PURE__ */ Q(Tm, jF, (e) => {
  var {
    typed: r,
    add: o,
    multiply: n,
    Complex: i,
    number: t
  } = e;
  return r(Tm, {
    "Array,Array,number": function(s, a, c) {
      return u(s, a, c);
    },
    "Array,Array": function(s, a) {
      return u(s, a, 1);
    },
    "Matrix,Matrix,number": function(s, a, c) {
      return u(s.valueOf(), a.valueOf(), c);
    },
    "Matrix,Matrix": function(s, a) {
      return u(s.valueOf(), a.valueOf(), 1);
    }
  });
  function u(f, s, a) {
    f.some((x) => x.type === "BigNumber") && (f = f.map((x) => t(x))), s.some((x) => x.type === "BigNumber") && (s = s.map((x) => t(x)));
    for (var c = [i(1, 0)], d = [i(1, 0)], h = 0; h < f.length; h++) {
      var p = f[h];
      typeof p == "number" && (p = i(p, 0)), c = l(c, [i(1, 0), i(-p.re, -p.im)]);
    }
    for (var v = 0; v < s.length; v++) {
      var g = s[v];
      typeof g == "number" && (g = i(g, 0)), d = l(d, [i(1, 0), i(-g.re, -g.im)]);
    }
    for (var m = 0; m < c.length; m++)
      c[m] = n(c[m], a);
    return [c, d];
  }
  function l(f, s) {
    for (var a = [], c = 0; c < f.length + s.length - 1; c++) {
      a[c] = i(0, 0);
      for (var d = 0; d < f.length; d++)
        c - d >= 0 && c - d < s.length && (a[c] = o(a[c], n(f[d], s[c - d])));
    }
    return a;
  }
}), Bm = "freqz", XF = ["typed", "add", "multiply", "Complex", "divide", "matrix"], JF = /* @__PURE__ */ Q(Bm, XF, (e) => {
  var {
    typed: r,
    add: o,
    multiply: n,
    Complex: i,
    divide: t,
    matrix: u
  } = e;
  return r(Bm, {
    "Array, Array": function(a, c) {
      var d = f(512);
      return l(a, c, d);
    },
    "Array, Array, Array": function(a, c, d) {
      return l(a, c, d);
    },
    "Array, Array, number": function(a, c, d) {
      if (d < 0)
        throw new Error("w must be a positive number");
      var h = f(d);
      return l(a, c, h);
    },
    "Matrix, Matrix": function(a, c) {
      var d = f(512), {
        w: h,
        h: p
      } = l(a.valueOf(), c.valueOf(), d);
      return {
        w: u(h),
        h: u(p)
      };
    },
    "Matrix, Matrix, Matrix": function(a, c, d) {
      var {
        h
      } = l(a.valueOf(), c.valueOf(), d.valueOf());
      return {
        h: u(h),
        w: u(d)
      };
    },
    "Matrix, Matrix, number": function(a, c, d) {
      if (d < 0)
        throw new Error("w must be a positive number");
      var h = f(d), {
        h: p
      } = l(a.valueOf(), c.valueOf(), h);
      return {
        h: u(p),
        w: u(h)
      };
    }
  });
  function l(s, a, c) {
    for (var d = [], h = [], p = 0; p < c.length; p++) {
      for (var v = i(0, 0), g = i(0, 0), m = 0; m < s.length; m++)
        v = o(v, n(s[m], i(Math.cos(-m * c[p]), Math.sin(-m * c[p]))));
      for (var x = 0; x < a.length; x++)
        g = o(g, n(a[x], i(Math.cos(-x * c[p]), Math.sin(-x * c[p]))));
      d.push(v), h.push(g);
    }
    for (var y = [], E = 0; E < d.length; E++)
      y.push(t(d[E], h[E]));
    return {
      h: y,
      w: c
    };
  }
  function f(s) {
    for (var a = [], c = 0; c < s; c++)
      a.push(c / s * Math.PI);
    return a;
  }
}), QF = "reviver", eI = ["classes"], rI = /* @__PURE__ */ Q(QF, eI, (e) => {
  var {
    classes: r
  } = e;
  return function(n, i) {
    var t = r[i && i.mathjs];
    return t && typeof t.fromJSON == "function" ? t.fromJSON(i) : i;
  };
}), tI = "replacer", nI = [], iI = /* @__PURE__ */ Q(tI, nI, () => function(r, o) {
  return typeof o == "number" && (!isFinite(o) || isNaN(o)) ? {
    mathjs: "number",
    value: String(o)
  } : typeof o == "bigint" ? {
    mathjs: "bigint",
    value: String(o)
  } : o;
}), aI = "13.0.3", oI = /* @__PURE__ */ Q("true", [], () => !0), sI = /* @__PURE__ */ Q("false", [], () => !1), uI = /* @__PURE__ */ Q("null", [], () => null), fI = /* @__PURE__ */ it("Infinity", ["config", "?BigNumber"], (e) => {
  var {
    config: r,
    BigNumber: o
  } = e;
  return r.number === "BigNumber" ? new o(1 / 0) : 1 / 0;
}), cI = /* @__PURE__ */ it("NaN", ["config", "?BigNumber"], (e) => {
  var {
    config: r,
    BigNumber: o
  } = e;
  return r.number === "BigNumber" ? new o(NaN) : NaN;
}), lI = /* @__PURE__ */ it("pi", ["config", "?BigNumber"], (e) => {
  var {
    config: r,
    BigNumber: o
  } = e;
  return r.number === "BigNumber" ? kf(o) : Sx;
}), dI = /* @__PURE__ */ it("tau", ["config", "?BigNumber"], (e) => {
  var {
    config: r,
    BigNumber: o
  } = e;
  return r.number === "BigNumber" ? ZE(o) : Dx;
}), hI = /* @__PURE__ */ it("e", ["config", "?BigNumber"], (e) => {
  var {
    config: r,
    BigNumber: o
  } = e;
  return r.number === "BigNumber" ? WE(o) : Nx;
}), pI = /* @__PURE__ */ it("phi", ["config", "?BigNumber"], (e) => {
  var {
    config: r,
    BigNumber: o
  } = e;
  return r.number === "BigNumber" ? KE(o) : Mx;
}), vI = /* @__PURE__ */ it("LN2", ["config", "?BigNumber"], (e) => {
  var {
    config: r,
    BigNumber: o
  } = e;
  return r.number === "BigNumber" ? new o(2).ln() : Math.LN2;
}), mI = /* @__PURE__ */ it("LN10", ["config", "?BigNumber"], (e) => {
  var {
    config: r,
    BigNumber: o
  } = e;
  return r.number === "BigNumber" ? new o(10).ln() : Math.LN10;
}), gI = /* @__PURE__ */ it("LOG2E", ["config", "?BigNumber"], (e) => {
  var {
    config: r,
    BigNumber: o
  } = e;
  return r.number === "BigNumber" ? new o(1).div(new o(2).ln()) : Math.LOG2E;
}), bI = /* @__PURE__ */ it("LOG10E", ["config", "?BigNumber"], (e) => {
  var {
    config: r,
    BigNumber: o
  } = e;
  return r.number === "BigNumber" ? new o(1).div(new o(10).ln()) : Math.LOG10E;
}), yI = /* @__PURE__ */ it(
  // eslint-disable-line camelcase
  "SQRT1_2",
  ["config", "?BigNumber"],
  (e) => {
    var {
      config: r,
      BigNumber: o
    } = e;
    return r.number === "BigNumber" ? new o("0.5").sqrt() : Math.SQRT1_2;
  }
), wI = /* @__PURE__ */ it("SQRT2", ["config", "?BigNumber"], (e) => {
  var {
    config: r,
    BigNumber: o
  } = e;
  return r.number === "BigNumber" ? new o(2).sqrt() : Math.SQRT2;
}), xI = /* @__PURE__ */ it("i", ["Complex"], (e) => {
  var {
    Complex: r
  } = e;
  return r.I;
}), EI = /* @__PURE__ */ Q("PI", ["pi"], (e) => {
  var {
    pi: r
  } = e;
  return r;
}), AI = /* @__PURE__ */ Q("E", ["e"], (e) => {
  var {
    e: r
  } = e;
  return r;
}), SI = /* @__PURE__ */ Q("version", [], () => aI);
function it(e, r, o) {
  return Q(e, r, o, {
    recreateOnConfigChange: !0
  });
}
var DI = /* @__PURE__ */ qe("speedOfLight", "299792458", "m s^-1"), NI = /* @__PURE__ */ qe("gravitationConstant", "6.67430e-11", "m^3 kg^-1 s^-2"), MI = /* @__PURE__ */ qe("planckConstant", "6.62607015e-34", "J s"), _I = /* @__PURE__ */ qe("reducedPlanckConstant", "1.0545718176461565e-34", "J s"), CI = /* @__PURE__ */ qe("magneticConstant", "1.25663706212e-6", "N A^-2"), TI = /* @__PURE__ */ qe("electricConstant", "8.8541878128e-12", "F m^-1"), BI = /* @__PURE__ */ qe("vacuumImpedance", "376.730313667", "ohm"), FI = /* @__PURE__ */ qe("coulomb", "8.987551792261171e9", "N m^2 C^-2"), II = /* @__PURE__ */ qe("elementaryCharge", "1.602176634e-19", "C"), OI = /* @__PURE__ */ qe("bohrMagneton", "9.2740100783e-24", "J T^-1"), RI = /* @__PURE__ */ qe("conductanceQuantum", "7.748091729863649e-5", "S"), PI = /* @__PURE__ */ qe("inverseConductanceQuantum", "12906.403729652257", "ohm"), qI = /* @__PURE__ */ qe("magneticFluxQuantum", "2.0678338484619295e-15", "Wb"), $I = /* @__PURE__ */ qe("nuclearMagneton", "5.0507837461e-27", "J T^-1"), zI = /* @__PURE__ */ qe("klitzing", "25812.807459304513", "ohm"), LI = /* @__PURE__ */ qe("bohrRadius", "5.29177210903e-11", "m"), UI = /* @__PURE__ */ qe("classicalElectronRadius", "2.8179403262e-15", "m"), kI = /* @__PURE__ */ qe("electronMass", "9.1093837015e-31", "kg"), HI = /* @__PURE__ */ qe("fermiCoupling", "1.1663787e-5", "GeV^-2"), GI = lo("fineStructure", 0.0072973525693), VI = /* @__PURE__ */ qe("hartreeEnergy", "4.3597447222071e-18", "J"), WI = /* @__PURE__ */ qe("protonMass", "1.67262192369e-27", "kg"), KI = /* @__PURE__ */ qe("deuteronMass", "3.3435830926e-27", "kg"), ZI = /* @__PURE__ */ qe("neutronMass", "1.6749271613e-27", "kg"), jI = /* @__PURE__ */ qe("quantumOfCirculation", "3.6369475516e-4", "m^2 s^-1"), YI = /* @__PURE__ */ qe("rydberg", "10973731.568160", "m^-1"), XI = /* @__PURE__ */ qe("thomsonCrossSection", "6.6524587321e-29", "m^2"), JI = lo("weakMixingAngle", 0.2229), QI = lo("efimovFactor", 22.7), eO = /* @__PURE__ */ qe("atomicMass", "1.66053906660e-27", "kg"), rO = /* @__PURE__ */ qe("avogadro", "6.02214076e23", "mol^-1"), tO = /* @__PURE__ */ qe("boltzmann", "1.380649e-23", "J K^-1"), nO = /* @__PURE__ */ qe("faraday", "96485.33212331001", "C mol^-1"), iO = /* @__PURE__ */ qe("firstRadiation", "3.7417718521927573e-16", "W m^2"), aO = /* @__PURE__ */ qe("loschmidt", "2.686780111798444e25", "m^-3"), oO = /* @__PURE__ */ qe("gasConstant", "8.31446261815324", "J K^-1 mol^-1"), sO = /* @__PURE__ */ qe("molarPlanckConstant", "3.990312712893431e-10", "J s mol^-1"), uO = /* @__PURE__ */ qe("molarVolume", "0.022413969545014137", "m^3 mol^-1"), fO = lo("sackurTetrode", -1.16487052358), cO = /* @__PURE__ */ qe("secondRadiation", "0.014387768775039337", "m K"), lO = /* @__PURE__ */ qe("stefanBoltzmann", "5.67037441918443e-8", "W m^-2 K^-4"), dO = /* @__PURE__ */ qe("wienDisplacement", "2.897771955e-3", "m K"), hO = /* @__PURE__ */ qe("molarMass", "0.99999999965e-3", "kg mol^-1"), pO = /* @__PURE__ */ qe("molarMassC12", "11.9999999958e-3", "kg mol^-1"), vO = /* @__PURE__ */ qe("gravity", "9.80665", "m s^-2"), mO = /* @__PURE__ */ qe("planckLength", "1.616255e-35", "m"), gO = /* @__PURE__ */ qe("planckMass", "2.176435e-8", "kg"), bO = /* @__PURE__ */ qe("planckTime", "5.391245e-44", "s"), yO = /* @__PURE__ */ qe("planckCharge", "1.87554603778e-18", "C"), wO = /* @__PURE__ */ qe("planckTemperature", "1.416785e+32", "K");
function qe(e, r, o) {
  var n = ["config", "Unit", "BigNumber"];
  return Q(e, n, (i) => {
    var {
      config: t,
      Unit: u,
      BigNumber: l
    } = i, f = t.number === "BigNumber" ? new l(r) : parseFloat(r), s = new u(f, o);
    return s.fixPrefix = !0, s;
  });
}
function lo(e, r) {
  var o = ["config", "BigNumber"];
  return Q(e, o, (n) => {
    var {
      config: i,
      BigNumber: t
    } = n;
    return i.number === "BigNumber" ? new t(r) : r;
  });
}
var xO = "apply", EO = ["typed", "isInteger"], AO = /* @__PURE__ */ Q(xO, EO, (e) => {
  var {
    typed: r,
    isInteger: o
  } = e, n = Pf({
    typed: r,
    isInteger: o
  });
  return r("apply", {
    "...any": function(t) {
      var u = t[1];
      $e(u) ? t[1] = u - 1 : Re(u) && (t[1] = u.minus(1));
      try {
        return n.apply(null, t);
      } catch (l) {
        throw Zr(l);
      }
    }
  });
}, {
  isTransformFunction: !0
}), SO = "column", DO = ["typed", "Index", "matrix", "range"], NO = /* @__PURE__ */ Q(SO, DO, (e) => {
  var {
    typed: r,
    Index: o,
    matrix: n,
    range: i
  } = e, t = Zg({
    typed: r,
    Index: o,
    matrix: n,
    range: i
  });
  return r("column", {
    "...any": function(l) {
      var f = l.length - 1, s = l[f];
      $e(s) && (l[f] = s - 1);
      try {
        return t.apply(null, l);
      } catch (a) {
        throw Zr(a);
      }
    }
  });
}, {
  isTransformFunction: !0
});
function pc(e, r, o) {
  var n = e.filter(function(f) {
    return Br(f) && !(f.name in r) && !o.has(f.name);
  })[0];
  if (!n)
    throw new Error('No undefined variable found in inline expression "' + e + '"');
  var i = n.name, t = /* @__PURE__ */ new Map(), u = new x1(o, t, /* @__PURE__ */ new Set([i])), l = e.compile();
  return function(s) {
    return t.set(i, s), l.evaluate(u);
  };
}
var MO = "filter", _O = ["typed"], CO = /* @__PURE__ */ Q(MO, _O, (e) => {
  var {
    typed: r
  } = e;
  function o(i, t, u) {
    var l, f;
    return i[0] && (l = i[0].compile().evaluate(u)), i[1] && (Br(i[1]) || Yn(i[1]) ? f = i[1].compile().evaluate(u) : f = pc(i[1], t, u)), n(l, f);
  }
  o.rawArgs = !0;
  var n = r("filter", {
    "Array, function": Fm,
    "Matrix, function": function(t, u) {
      return t.create(Fm(t.toArray(), u));
    },
    "Array, RegExp": Ma,
    "Matrix, RegExp": function(t, u) {
      return t.create(Ma(t.toArray(), u));
    }
  });
  return o;
}, {
  isTransformFunction: !0
});
function Fm(e, r) {
  return H1(e, function(o, n, i) {
    return ri(r, o, [n + 1], i, "filter");
  });
}
var TO = "forEach", BO = ["typed"], FO = /* @__PURE__ */ Q(TO, BO, (e) => {
  var {
    typed: r
  } = e;
  function o(i, t, u) {
    var l, f;
    return i[0] && (l = i[0].compile().evaluate(u)), i[1] && (Br(i[1]) || Yn(i[1]) ? f = i[1].compile().evaluate(u) : f = pc(i[1], t, u)), n(l, f);
  }
  o.rawArgs = !0;
  var n = r("forEach", {
    "Array | Matrix, function": function(t, u) {
      var l = function f(s, a) {
        if (Array.isArray(s))
          to(s, function(c, d) {
            f(c, a.concat(d + 1));
          });
        else
          return ri(u, s, a, t, "forEach");
      };
      l(t.valueOf(), []);
    }
  });
  return o;
}, {
  isTransformFunction: !0
}), IO = "index", OO = ["Index", "getMatrixDataType"], RO = /* @__PURE__ */ Q(IO, OO, (e) => {
  var {
    Index: r,
    getMatrixDataType: o
  } = e;
  return function() {
    for (var i = [], t = 0, u = arguments.length; t < u; t++) {
      var l = arguments[t];
      if (Ya(l))
        l.start--, l.end -= l.step > 0 ? 0 : 2;
      else if (l && l.isSet === !0)
        l = l.map(function(s) {
          return s - 1;
        });
      else if (ar(l) || Fe(l))
        o(l) !== "boolean" && (l = l.map(function(s) {
          return s - 1;
        }));
      else if ($e(l))
        l--;
      else if (Re(l))
        l = l.toNumber() - 1;
      else if (typeof l != "string")
        throw new TypeError("Dimension must be an Array, Matrix, number, string, or Range");
      i[t] = l;
    }
    var f = new r();
    return r.apply(f, i), f;
  };
}, {
  isTransformFunction: !0
}), PO = "map", qO = ["typed"], $O = /* @__PURE__ */ Q(PO, qO, (e) => {
  var {
    typed: r
  } = e;
  function o(i, t, u) {
    var l, f;
    return i[0] && (l = i[0].compile().evaluate(u)), i[1] && (Br(i[1]) || Yn(i[1]) ? f = i[1].compile().evaluate(u) : f = pc(i[1], t, u)), n(l, f);
  }
  o.rawArgs = !0;
  var n = r("map", {
    "Array, function": function(t, u) {
      return Im(t, u, t);
    },
    "Matrix, function": function(t, u) {
      return t.create(Im(t.valueOf(), u, t));
    }
  });
  return o;
}, {
  isTransformFunction: !0
});
function Im(e, r, o) {
  function n(i, t) {
    return Array.isArray(i) ? Ht(i, function(u, l) {
      return n(u, t.concat(l + 1));
    }) : ri(r, i, t, o, "map");
  }
  return n(e, []);
}
function ln(e) {
  if (e.length === 2 && nt(e[0])) {
    e = e.slice();
    var r = e[1];
    $e(r) ? e[1] = r - 1 : Re(r) && (e[1] = r.minus(1));
  }
  return e;
}
var zO = "max", LO = ["typed", "config", "numeric", "larger"], UO = /* @__PURE__ */ Q(zO, LO, (e) => {
  var {
    typed: r,
    config: o,
    numeric: n,
    larger: i
  } = e, t = ib({
    typed: r,
    config: o,
    numeric: n,
    larger: i
  });
  return r("max", {
    "...any": function(l) {
      l = ln(l);
      try {
        return t.apply(null, l);
      } catch (f) {
        throw Zr(f);
      }
    }
  });
}, {
  isTransformFunction: !0
}), kO = "mean", HO = ["typed", "add", "divide"], GO = /* @__PURE__ */ Q(kO, HO, (e) => {
  var {
    typed: r,
    add: o,
    divide: n
  } = e, i = hb({
    typed: r,
    add: o,
    divide: n
  });
  return r("mean", {
    "...any": function(u) {
      u = ln(u);
      try {
        return i.apply(null, u);
      } catch (l) {
        throw Zr(l);
      }
    }
  });
}, {
  isTransformFunction: !0
}), VO = "min", WO = ["typed", "config", "numeric", "smaller"], KO = /* @__PURE__ */ Q(VO, WO, (e) => {
  var {
    typed: r,
    config: o,
    numeric: n,
    smaller: i
  } = e, t = ab({
    typed: r,
    config: o,
    numeric: n,
    smaller: i
  });
  return r("min", {
    "...any": function(l) {
      l = ln(l);
      try {
        return t.apply(null, l);
      } catch (f) {
        throw Zr(f);
      }
    }
  });
}, {
  isTransformFunction: !0
}), ZO = "range", jO = ["typed", "config", "?matrix", "?bignumber", "smaller", "smallerEq", "larger", "largerEq", "add", "isPositive"], YO = /* @__PURE__ */ Q(ZO, jO, (e) => {
  var {
    typed: r,
    config: o,
    matrix: n,
    bignumber: i,
    smaller: t,
    smallerEq: u,
    larger: l,
    largerEq: f,
    add: s,
    isPositive: a
  } = e, c = Jg({
    typed: r,
    config: o,
    matrix: n,
    bignumber: i,
    smaller: t,
    smallerEq: u,
    larger: l,
    largerEq: f,
    add: s,
    isPositive: a
  });
  return r("range", {
    "...any": function(h) {
      var p = h.length - 1, v = h[p];
      return typeof v != "boolean" && h.push(!0), c.apply(null, h);
    }
  });
}, {
  isTransformFunction: !0
}), XO = "row", JO = ["typed", "Index", "matrix", "range"], QO = /* @__PURE__ */ Q(XO, JO, (e) => {
  var {
    typed: r,
    Index: o,
    matrix: n,
    range: i
  } = e, t = Qg({
    typed: r,
    Index: o,
    matrix: n,
    range: i
  });
  return r("row", {
    "...any": function(l) {
      var f = l.length - 1, s = l[f];
      $e(s) && (l[f] = s - 1);
      try {
        return t.apply(null, l);
      } catch (a) {
        throw Zr(a);
      }
    }
  });
}, {
  isTransformFunction: !0
}), eR = "subset", rR = ["typed", "matrix", "zeros", "add"], tR = /* @__PURE__ */ Q(eR, rR, (e) => {
  var {
    typed: r,
    matrix: o,
    zeros: n,
    add: i
  } = e, t = eb({
    typed: r,
    matrix: o,
    zeros: n,
    add: i
  });
  return r("subset", {
    "...any": function(l) {
      try {
        return t.apply(null, l);
      } catch (f) {
        throw Zr(f);
      }
    }
  });
}, {
  isTransformFunction: !0
}), nR = "concat", iR = ["typed", "matrix", "isInteger"], aR = /* @__PURE__ */ Q(nR, iR, (e) => {
  var {
    typed: r,
    matrix: o,
    isInteger: n
  } = e, i = Kg({
    typed: r,
    matrix: o,
    isInteger: n
  });
  return r("concat", {
    "...any": function(u) {
      var l = u.length - 1, f = u[l];
      $e(f) ? u[l] = f - 1 : Re(f) && (u[l] = f.minus(1));
      try {
        return i.apply(null, u);
      } catch (s) {
        throw Zr(s);
      }
    }
  });
}, {
  isTransformFunction: !0
}), Om = "diff", oR = ["typed", "matrix", "subtract", "number", "bignumber"], sR = /* @__PURE__ */ Q(Om, oR, (e) => {
  var {
    typed: r,
    matrix: o,
    subtract: n,
    number: i,
    bignumber: t
  } = e, u = jg({
    typed: r,
    matrix: o,
    subtract: n,
    number: i,
    bignumber: t
  });
  return r(Om, {
    "...any": function(f) {
      f = ln(f);
      try {
        return u.apply(null, f);
      } catch (s) {
        throw Zr(s);
      }
    }
  });
}, {
  isTransformFunction: !0
}), uR = "std", fR = ["typed", "map", "sqrt", "variance"], cR = /* @__PURE__ */ Q(uR, fR, (e) => {
  var {
    typed: r,
    map: o,
    sqrt: n,
    variance: i
  } = e, t = mb({
    typed: r,
    map: o,
    sqrt: n,
    variance: i
  });
  return r("std", {
    "...any": function(l) {
      l = ln(l);
      try {
        return t.apply(null, l);
      } catch (f) {
        throw Zr(f);
      }
    }
  });
}, {
  isTransformFunction: !0
}), Rm = "sum", lR = ["typed", "config", "add", "numeric"], dR = /* @__PURE__ */ Q(Rm, lR, (e) => {
  var {
    typed: r,
    config: o,
    add: n,
    numeric: i
  } = e, t = lb({
    typed: r,
    config: o,
    add: n,
    numeric: i
  });
  return r(Rm, {
    "...any": function(l) {
      l = ln(l);
      try {
        return t.apply(null, l);
      } catch (f) {
        throw Zr(f);
      }
    }
  });
}, {
  isTransformFunction: !0
}), hR = "quantileSeq", pR = ["typed", "bignumber", "add", "subtract", "divide", "multiply", "partitionSelect", "compare", "isInteger", "smaller", "smallerEq", "larger"], vR = /* @__PURE__ */ Q(hR, pR, (e) => {
  var {
    typed: r,
    bignumber: o,
    add: n,
    subtract: i,
    divide: t,
    multiply: u,
    partitionSelect: l,
    compare: f,
    isInteger: s,
    smaller: a,
    smallerEq: c,
    larger: d
  } = e, h = vb({
    typed: r,
    bignumber: o,
    add: n,
    subtract: i,
    divide: t,
    multiply: u,
    partitionSelect: l,
    compare: f,
    isInteger: s,
    smaller: a,
    smallerEq: c,
    larger: d
  });
  return r("quantileSeq", {
    "Array | Matrix, number | BigNumber": h,
    "Array | Matrix, number | BigNumber, number": (v, g, m) => h(v, g, p(m)),
    "Array | Matrix, number | BigNumber, boolean": h,
    "Array | Matrix, number | BigNumber, boolean, number": (v, g, m, x) => h(v, g, m, p(x)),
    "Array | Matrix, Array | Matrix": h,
    "Array | Matrix, Array | Matrix, number": (v, g, m) => h(v, g, p(m)),
    "Array | Matrix, Array | Matrix, boolean": h,
    "Array | Matrix, Array | Matrix, boolean, number": (v, g, m, x) => h(v, g, m, p(x))
  });
  function p(v) {
    return ln([[], v])[1];
  }
}, {
  isTransformFunction: !0
}), Pm = "cumsum", mR = ["typed", "add", "unaryPlus"], gR = /* @__PURE__ */ Q(Pm, mR, (e) => {
  var {
    typed: r,
    add: o,
    unaryPlus: n
  } = e, i = db({
    typed: r,
    add: o,
    unaryPlus: n
  });
  return r(Pm, {
    "...any": function(u) {
      if (u.length === 2 && nt(u[0])) {
        var l = u[1];
        $e(l) ? u[1] = l - 1 : Re(l) && (u[1] = l.minus(1));
      }
      try {
        return i.apply(null, u);
      } catch (f) {
        throw Zr(f);
      }
    }
  });
}, {
  isTransformFunction: !0
}), qm = "variance", bR = ["typed", "add", "subtract", "multiply", "divide", "apply", "isNaN"], yR = /* @__PURE__ */ Q(qm, bR, (e) => {
  var {
    typed: r,
    add: o,
    subtract: n,
    multiply: i,
    divide: t,
    apply: u,
    isNaN: l
  } = e, f = pb({
    typed: r,
    add: o,
    subtract: n,
    multiply: i,
    divide: t,
    apply: u,
    isNaN: l
  });
  return r(qm, {
    "...any": function(a) {
      a = ln(a);
      try {
        return f.apply(null, a);
      } catch (c) {
        throw Zr(c);
      }
    }
  });
}, {
  isTransformFunction: !0
}), $m = "print", wR = ["typed", "matrix", "zeros", "add"], xR = /* @__PURE__ */ Q($m, wR, (e) => {
  var {
    typed: r,
    matrix: o,
    zeros: n,
    add: i
  } = e, t = tb({
    typed: r,
    matrix: o,
    zeros: n,
    add: i
  });
  return r($m, {
    "string, Object | Array": function(f, s) {
      return t(u(f), s);
    },
    "string, Object | Array, number | Object": function(f, s, a) {
      return t(u(f), s, a);
    }
  });
  function u(l) {
    return l.replace(rb, (f) => {
      var s = f.slice(1).split("."), a = s.map(function(c) {
        return !isNaN(c) && c.length > 0 ? parseInt(c) - 1 : c;
      });
      return "$" + a.join(".");
    });
  }
}, {
  isTransformFunction: !0
}), ER = "and", AR = ["typed", "matrix", "zeros", "add", "equalScalar", "not", "concat"], SR = /* @__PURE__ */ Q(ER, AR, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    zeros: i,
    not: t,
    concat: u
  } = e, l = nb({
    typed: r,
    matrix: o,
    equalScalar: n,
    zeros: i,
    not: t,
    concat: u
  });
  function f(s, a, c) {
    var d = s[0].compile().evaluate(c);
    if (!nt(d) && !l(d, !0))
      return !1;
    var h = s[1].compile().evaluate(c);
    return l(d, h);
  }
  return f.rawArgs = !0, f;
}, {
  isTransformFunction: !0
}), DR = "or", NR = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], MR = /* @__PURE__ */ Q(DR, NR, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    DenseMatrix: i,
    concat: t
  } = e, u = Wg({
    typed: r,
    matrix: o,
    equalScalar: n,
    DenseMatrix: i,
    concat: t
  });
  function l(f, s, a) {
    var c = f[0].compile().evaluate(a);
    if (!nt(c) && u(c, !1))
      return !0;
    var d = f[1].compile().evaluate(a);
    return u(c, d);
  }
  return l.rawArgs = !0, l;
}, {
  isTransformFunction: !0
}), _R = "bitAnd", CR = ["typed", "matrix", "zeros", "add", "equalScalar", "not", "concat"], TR = /* @__PURE__ */ Q(_R, CR, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    zeros: i,
    not: t,
    concat: u
  } = e, l = Gg({
    typed: r,
    matrix: o,
    equalScalar: n,
    zeros: i,
    not: t,
    concat: u
  });
  function f(s, a, c) {
    var d = s[0].compile().evaluate(c);
    if (!nt(d)) {
      if (isNaN(d))
        return NaN;
      if (d === 0 || d === !1)
        return 0;
    }
    var h = s[1].compile().evaluate(c);
    return l(d, h);
  }
  return f.rawArgs = !0, f;
}, {
  isTransformFunction: !0
}), BR = "bitOr", FR = ["typed", "matrix", "equalScalar", "DenseMatrix", "concat"], IR = /* @__PURE__ */ Q(BR, FR, (e) => {
  var {
    typed: r,
    matrix: o,
    equalScalar: n,
    DenseMatrix: i,
    concat: t
  } = e, u = Vg({
    typed: r,
    matrix: o,
    equalScalar: n,
    DenseMatrix: i,
    concat: t
  });
  function l(f, s, a) {
    var c = f[0].compile().evaluate(a);
    if (!nt(c)) {
      if (isNaN(c))
        return NaN;
      if (c === -1)
        return -1;
      if (c === !0)
        return 1;
    }
    var d = f[1].compile().evaluate(a);
    return u(c, d);
  }
  return l.rawArgs = !0, l;
}, {
  isTransformFunction: !0
});
const OR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createAbs: I3,
  createAccessorNode: L7,
  createAcos: aA,
  createAcosh: sA,
  createAcot: fA,
  createAcoth: lA,
  createAcsc: hA,
  createAcsch: vA,
  createAdd: S7,
  createAddScalar: q3,
  createAnd: nb,
  createAndTransform: SR,
  createApply: Pf,
  createApplyTransform: AO,
  createArg: E6,
  createArrayNode: k7,
  createAsec: gA,
  createAsech: yA,
  createAsin: xA,
  createAsinh: SA,
  createAssignmentNode: W7,
  createAtan: MA,
  createAtan2: CA,
  createAtanh: BA,
  createAtomicMass: eO,
  createAvogadro: rO,
  createBellNumbers: AF,
  createBigNumberClass: zw,
  createBigint: i3,
  createBignumber: l3,
  createBin: a5,
  createBitAnd: Gg,
  createBitAndTransform: TR,
  createBitNot: v6,
  createBitOr: Vg,
  createBitOrTransform: IR,
  createBitXor: w6,
  createBlockNode: Z7,
  createBohrMagneton: OI,
  createBohrRadius: LI,
  createBoltzmann: tO,
  createBoolean: u3,
  createCatalan: DF,
  createCbrt: U3,
  createCeil: Y3,
  createChain: j_,
  createChainClass: bS,
  createClassicalElectronRadius: UI,
  createClone: yx,
  createColumn: Zg,
  createColumnTransform: NO,
  createCombinations: $C,
  createCombinationsWithRep: LC,
  createCompare: J5,
  createCompareNatural: tE,
  createCompareText: aE,
  createCompile: M9,
  createComplex: p3,
  createComplexClass: Gw,
  createComposition: MF,
  createConcat: Kg,
  createConcatTransform: aR,
  createConditionalNode: Y7,
  createConductanceQuantum: RI,
  createConj: S6,
  createConstantNode: i9,
  createCorr: PC,
  createCos: IA,
  createCosh: RA,
  createCot: qA,
  createCoth: zA,
  createCoulomb: FI,
  createCount: q6,
  createCreateUnit: nA,
  createCross: z6,
  createCsc: UA,
  createCsch: HA,
  createCtranspose: B8,
  createCube: J3,
  createCumSum: db,
  createCumSumTransform: gR,
  createDeepEqual: SE,
  createDenseMatrixClass: gx,
  createDerivative: WF,
  createDet: X_,
  createDeuteronMass: KI,
  createDiag: U6,
  createDiff: jg,
  createDiffTransform: sR,
  createDistance: xC,
  createDivide: yC,
  createDivideScalar: y5,
  createDot: T7,
  createDotDivide: I5,
  createDotMultiply: s6,
  createDotPow: B5,
  createE: hI,
  createEfimovFactor: QI,
  createEigs: oC,
  createElectricConstant: TI,
  createElectronMass: kI,
  createElementaryCharge: II,
  createEqual: sE,
  createEqualScalar: Kx,
  createEqualText: cE,
  createErf: W8,
  createEvaluate: C9,
  createExp: e4,
  createExpm: uC,
  createExpm1: t4,
  createFactorial: WC,
  createFalse: sI,
  createFaraday: nO,
  createFermiCoupling: HI,
  createFft: R8,
  createFibonacciHeapClass: kE,
  createFilter: G6,
  createFilterTransform: CO,
  createFineStructure: GI,
  createFirstRadiation: iO,
  createFix: a4,
  createFlatten: W6,
  createFloor: Ug,
  createForEach: Z6,
  createForEachTransform: FO,
  createFormat: n5,
  createFraction: g3,
  createFractionClass: Jw,
  createFreqz: JF,
  createFunctionAssignmentNode: o9,
  createFunctionNode: A9,
  createGamma: kC,
  createGasConstant: oO,
  createGcd: C4,
  createGetMatrixDataType: X6,
  createGravitationConstant: NI,
  createGravity: vO,
  createHartreeEnergy: VI,
  createHasNumericValue: Px,
  createHelp: K_,
  createHelpClass: vS,
  createHex: f5,
  createHypot: N7,
  createI: xI,
  createIdentity: Q6,
  createIfft: q8,
  createIm: N6,
  createImmutableDenseMatrixClass: PE,
  createIndex: R7,
  createIndexClass: zE,
  createIndexNode: u9,
  createIndexTransform: RO,
  createInfinity: fI,
  createIntersect: SC,
  createInv: Q_,
  createInverseConductanceQuantum: PI,
  createInvmod: n6,
  createIsInteger: xx,
  createIsNaN: kx,
  createIsNegative: Fx,
  createIsNumeric: Ox,
  createIsPositive: $x,
  createIsPrime: p5,
  createIsZero: Lx,
  createKldivergence: ZC,
  createKlitzing: zI,
  createKron: r8,
  createLN10: mI,
  createLN2: vI,
  createLOG10E: bI,
  createLOG2E: gI,
  createLarger: bE,
  createLargerEq: xE,
  createLcm: I4,
  createLeafCount: CF,
  createLeftShift: V5,
  createLgamma: GC,
  createLog: D5,
  createLog10: R4,
  createLog1p: M5,
  createLog2: q4,
  createLoschmidt: aO,
  createLsolve: R5,
  createLsolveAll: z5,
  createLup: P9,
  createLusolve: cS,
  createLyap: mC,
  createMad: BC,
  createMagneticConstant: CI,
  createMagneticFluxQuantum: qI,
  createMap: n8,
  createMapTransform: $O,
  createMatrix: y3,
  createMatrixClass: ix,
  createMatrixFromColumns: D3,
  createMatrixFromFunction: x3,
  createMatrixFromRows: A3,
  createMax: ib,
  createMaxTransform: UO,
  createMean: hb,
  createMeanTransform: GO,
  createMedian: CC,
  createMin: ab,
  createMinTransform: KO,
  createMod: kg,
  createMode: Q8,
  createMolarMass: hO,
  createMolarMassC12: pO,
  createMolarPlanckConstant: sO,
  createMolarVolume: uO,
  createMultinomial: YC,
  createMultiply: k4,
  createMultiplyScalar: L4,
  createNaN: cI,
  createNeutronMass: ZI,
  createNode: $7,
  createNorm: _7,
  createNot: T6,
  createNthRoot: G4,
  createNthRoots: C5,
  createNuclearMagneton: $I,
  createNull: uI,
  createNumber: r3,
  createNumeric: g5,
  createObjectNode: c9,
  createOct: s5,
  createOnes: u8,
  createOperatorNode: d9,
  createOr: Wg,
  createOrTransform: MR,
  createParenthesisNode: p9,
  createParse: D9,
  createParser: O9,
  createParserClass: F9,
  createPartitionSelect: CE,
  createPermutations: JC,
  createPhi: pI,
  createPi: lI,
  createPickRandom: vF,
  createPinv: rC,
  createPlanckCharge: yO,
  createPlanckConstant: MI,
  createPlanckLength: mO,
  createPlanckMass: gO,
  createPlanckTemperature: wO,
  createPlanckTime: bO,
  createPolynomialRoot: dS,
  createPow: x5,
  createPrint: tb,
  createPrintTransform: xR,
  createProd: r5,
  createProtonMass: WI,
  createQr: $9,
  createQuantileSeq: vb,
  createQuantileSeqTransform: vR,
  createQuantumOfCirculation: jI,
  createRandom: gF,
  createRandomInt: yF,
  createRange: Jg,
  createRangeClass: rx,
  createRangeNode: m9,
  createRangeTransform: YO,
  createRationalize: ZF,
  createRe: _6,
  createReducedPlanckConstant: _I,
  createRelationalNode: b9,
  createReplacer: iI,
  createReshape: l8,
  createResize: p8,
  createResolve: kF,
  createResultSet: H2,
  createReviver: rI,
  createRightArithShift: K5,
  createRightLogShift: j5,
  createRotate: m8,
  createRotationMatrix: b8,
  createRound: A5,
  createRow: Qg,
  createRowTransform: QO,
  createRydberg: YI,
  createSQRT1_2: yI,
  createSQRT2: wI,
  createSackurTetrode: fO,
  createSchur: pC,
  createSec: VA,
  createSech: KA,
  createSecondRadiation: cO,
  createSetCartesian: i7,
  createSetDifference: o7,
  createSetDistinct: u7,
  createSetIntersect: c7,
  createSetIsSubset: d7,
  createSetMultiplicity: p7,
  createSetPowerset: m7,
  createSetSize: b7,
  createSetSymDifference: w7,
  createSetUnion: E7,
  createSign: W4,
  createSimplify: OF,
  createSimplifyConstant: qF,
  createSimplifyCore: zF,
  createSin: jA,
  createSinh: XA,
  createSize: x8,
  createSlu: uS,
  createSmaller: dE,
  createSmallerEq: vE,
  createSolveODE: H8,
  createSort: BE,
  createSpaClass: VE,
  createSparse: rA,
  createSparseMatrixClass: Yx,
  createSpeedOfLight: DI,
  createSplitUnit: M3,
  createSqrt: j4,
  createSqrtm: cC,
  createSquare: X4,
  createSqueeze: A8,
  createStd: mb,
  createStdTransform: cR,
  createStefanBoltzmann: lO,
  createStirlingS2: xF,
  createString: o3,
  createSubset: eb,
  createSubsetTransform: tR,
  createSubtract: Q4,
  createSubtractScalar: z3,
  createSum: lb,
  createSumTransform: dR,
  createSylvester: dC,
  createSymbolNode: x9,
  createSymbolicEqual: GF,
  createTan: QA,
  createTanh: t7,
  createTau: dI,
  createThomsonCrossSection: XI,
  createTo: d5,
  createTrace: I7,
  createTranspose: C8,
  createTrue: oI,
  createTypeOf: Gx,
  createTyped: z2,
  createUnaryMinus: C3,
  createUnaryPlus: B3,
  createUnequal: NE,
  createUnitClass: XE,
  createUnitFunction: QE,
  createUppercaseE: AI,
  createUppercasePi: EI,
  createUsolve: q5,
  createUsolveAll: U5,
  createVacuumImpedance: BI,
  createVariance: pb,
  createVarianceTransform: yR,
  createVersion: SI,
  createWeakMixingAngle: JI,
  createWienDisplacement: dO,
  createXgcd: r6,
  createXor: I6,
  createZeros: I8,
  createZeta: X8,
  createZpk2tf: YF
}, Symbol.toStringTag, { value: "Module" }));
var RR = OR, vc = { exports: {} };
function mc() {
}
mc.prototype = {
  on: function(e, r, o) {
    var n = this.e || (this.e = {});
    return (n[e] || (n[e] = [])).push({
      fn: r,
      ctx: o
    }), this;
  },
  once: function(e, r, o) {
    var n = this;
    function i() {
      n.off(e, i), r.apply(o, arguments);
    }
    return i._ = r, this.on(e, i, o);
  },
  emit: function(e) {
    var r = [].slice.call(arguments, 1), o = ((this.e || (this.e = {}))[e] || []).slice(), n = 0, i = o.length;
    for (n; n < i; n++)
      o[n].fn.apply(o[n].ctx, r);
    return this;
  },
  off: function(e, r) {
    var o = this.e || (this.e = {}), n = o[e], i = [];
    if (n && r)
      for (var t = 0, u = n.length; t < u; t++)
        n[t].fn !== r && n[t].fn._ !== r && i.push(n[t]);
    return i.length ? o[e] = i : delete o[e], this;
  }
};
vc.exports = mc;
vc.exports.TinyEmitter = mc;
var PR = vc.exports;
const qR = /* @__PURE__ */ Ti(PR);
function $R(e) {
  var r = new qR();
  return e.on = r.on.bind(r), e.off = r.off.bind(r), e.once = r.once.bind(r), e.emit = r.emit.bind(r), e;
}
function zR(e, r, o, n) {
  function i(g, m) {
    var x = arguments.length;
    if (x !== 1 && x !== 2)
      throw new Zt("import", x, 1, 2);
    m || (m = {});
    function y(R, O, B) {
      if (Array.isArray(O))
        O.forEach((w) => y(R, w));
      else if (typeof O == "object")
        for (var $ in O)
          De(O, $) && y(R, O[$], $);
      else if (pi(O) || B !== void 0) {
        var F = pi(O) ? p(O) ? O.fn + ".transform" : O.fn : B;
        if (De(R, F) && R[F] !== O && !m.silent)
          throw new Error('Cannot import "' + F + '" twice');
        R[F] = O;
      } else if (!m.silent)
        throw new TypeError("Factory, Object, or Array expected");
    }
    var E = {};
    y(E, g);
    for (var N in E)
      if (De(E, N)) {
        var S = E[N];
        if (pi(S))
          s(S, m);
        else if (a(S))
          t(N, S, m);
        else if (!m.silent)
          throw new TypeError("Factory, Object, or Array expected");
      }
  }
  function t(g, m, x) {
    if (x.wrap && typeof m == "function" && (m = f(m)), c(m) && (m = e(g, {
      [m.signature]: m
    })), e.isTypedFunction(o[g]) && e.isTypedFunction(m)) {
      x.override ? m = e(g, m.signatures) : m = e(o[g], m), o[g] = m, delete n[g], u(g, m), o.emit("import", g, function() {
        return m;
      });
      return;
    }
    if (o[g] === void 0 || x.override) {
      o[g] = m, delete n[g], u(g, m), o.emit("import", g, function() {
        return m;
      });
      return;
    }
    if (!x.silent)
      throw new Error('Cannot import "' + g + '": already exists');
  }
  function u(g, m) {
    m && typeof m.transform == "function" ? (o.expression.transform[g] = m.transform, d(g) && (o.expression.mathWithTransform[g] = m.transform)) : (delete o.expression.transform[g], d(g) && (o.expression.mathWithTransform[g] = m));
  }
  function l(g) {
    delete o.expression.transform[g], d(g) ? o.expression.mathWithTransform[g] = o[g] : delete o.expression.mathWithTransform[g];
  }
  function f(g) {
    var m = function() {
      for (var y = [], E = 0, N = arguments.length; E < N; E++) {
        var S = arguments[E];
        y[E] = S && S.valueOf();
      }
      return g.apply(o, y);
    };
    return g.transform && (m.transform = g.transform), m;
  }
  function s(g, m) {
    var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : g.fn;
    if (x.includes("."))
      throw new Error("Factory name should not contain a nested path. Name: " + JSON.stringify(x));
    var y = p(g) ? o.expression.transform : o, E = x in o.expression.transform, N = De(y, x) ? y[x] : void 0, S = function() {
      var O = {};
      g.dependencies.map(b1).forEach(($) => {
        if ($.includes("."))
          throw new Error("Factory dependency should not contain a nested path. Name: " + JSON.stringify($));
        $ === "math" ? O.math = o : $ === "mathWithTransform" ? O.mathWithTransform = o.expression.mathWithTransform : $ === "classes" ? O.classes = o : O[$] = o[$];
      });
      var B = /* @__PURE__ */ g(O);
      if (B && typeof B.transform == "function")
        throw new Error('Transforms cannot be attached to factory functions. Please create a separate function for it with export const path = "expression.transform"');
      if (N === void 0 || m.override)
        return B;
      if (e.isTypedFunction(N) && e.isTypedFunction(B))
        return e(N, B);
      if (m.silent)
        return N;
      throw new Error('Cannot import "' + x + '": already exists');
    };
    !g.meta || g.meta.lazy !== !1 ? (ga(y, x, S), N && E ? l(x) : (p(g) || h(g)) && ga(o.expression.mathWithTransform, x, () => y[x])) : (y[x] = S(), N && E ? l(x) : (p(g) || h(g)) && ga(o.expression.mathWithTransform, x, () => y[x])), n[x] = g, o.emit("import", x, S);
  }
  function a(g) {
    return typeof g == "function" || typeof g == "number" || typeof g == "string" || typeof g == "boolean" || g === null || jr(g) || yt(g) || Re(g) || An(g) || Fe(g) || Array.isArray(g);
  }
  function c(g) {
    return typeof g == "function" && typeof g.signature == "string";
  }
  function d(g) {
    return !De(v, g);
  }
  function h(g) {
    return !g.fn.includes(".") && // FIXME: make checking on path redundant, check on meta data instead
    !De(v, g.fn) && (!g.meta || !g.meta.isClass);
  }
  function p(g) {
    return g !== void 0 && g.meta !== void 0 && g.meta.isTransformFunction === !0 || !1;
  }
  var v = {
    expression: !0,
    type: !0,
    docs: !0,
    error: !0,
    json: !0,
    chain: !0
    // chain method not supported. Note that there is a unit chain too.
  };
  return i;
}
function sy(e, r) {
  var o = kr({}, Xm, r);
  if (typeof Object.create != "function")
    throw new Error("ES5 not supported by this JavaScript engine. Please load the es5-shim and es5-sham library for compatibility.");
  var n = $R({
    // only here for backward compatibility for legacy factory functions
    isNumber: $e,
    isComplex: yt,
    isBigNumber: Re,
    isBigInt: Jm,
    isFraction: An,
    isUnit: jr,
    isString: qr,
    isArray: ar,
    isMatrix: Fe,
    isCollection: nt,
    isDenseMatrix: gi,
    isSparseMatrix: en,
    isRange: Ya,
    isIndex: Ni,
    isBoolean: Qm,
    isResultSet: e1,
    isHelp: Mf,
    isFunction: r1,
    isDate: t1,
    isRegExp: n1,
    isObject: Mi,
    isNull: i1,
    isUndefined: a1,
    isAccessorNode: nn,
    isArrayNode: tt,
    isAssignmentNode: o1,
    isBlockNode: s1,
    isConditionalNode: u1,
    isConstantNode: rr,
    isFunctionAssignmentNode: Yn,
    isFunctionNode: Gt,
    isIndexNode: Sn,
    isNode: or,
    isObjectNode: _i,
    isOperatorNode: Cr,
    isParenthesisNode: Dt,
    isRangeNode: f1,
    isRelationalNode: c1,
    isSymbolNode: Br,
    isChain: _f
  });
  n.config = p2(o, n.emit), n.expression = {
    transform: {},
    mathWithTransform: {
      config: n.config
    }
  };
  var i = [], t = [];
  function u(a) {
    if (pi(a))
      return a(n);
    var c = a[Object.keys(a)[0]];
    if (pi(c))
      return c(n);
    if (!d2(a))
      throw console.warn("Factory object with properties `type`, `name`, and `factory` expected", a), new Error("Factory object with properties `type`, `name`, and `factory` expected");
    var d = i.indexOf(a), h;
    return d === -1 ? (a.math === !0 ? h = a.factory(n.type, o, u, n.typed, n) : h = a.factory(n.type, o, u, n.typed), i.push(a), t.push(h)) : h = t[d], h;
  }
  var l = {};
  function f() {
    for (var a = arguments.length, c = new Array(a), d = 0; d < a; d++)
      c[d] = arguments[d];
    return n.typed.apply(n.typed, c);
  }
  f.isTypedFunction = wn.isTypedFunction;
  var s = zR(f, u, n, l);
  return n.import = s, n.on("config", () => {
    Object.values(l).forEach((a) => {
      a && a.meta && a.meta.recreateOnConfigChange && s(a, {
        override: !0
      });
    });
  }), n.create = sy.bind(null, e), n.factory = Q, n.import(Object.values(l2(e))), n.ArgumentsError = Zt, n.DimensionError = We, n.IndexError = dt, n;
}
const uy = "PrincipalDraw", fy = "PrincipalReturn", lt = "AssetPurchase", Kt = "AssetSale", gc = "InterestIncome", bc = "InterestPayment", yc = "FeesIncome", wc = "FeesPayment", zm = "fixedIncomeTransaction", LR = [wc, yc], UR = {
  [Kt]: 1,
  [lt]: -1,
  [uy]: 1,
  [fy]: -1,
  [yc]: 1,
  [wc]: -1,
  [gc]: 1,
  [bc]: -1
}, nr = sy(RR, {
  number: "BigNumber"
});
function cy(e) {
  const r = ly(e), o = xc(e).toNumber(), n = dy(e).toNumber(), i = ho(e).toNumber(), t = po(e).toNumber(), u = Ec(e).toNumber(), l = hy(e).toNumber(), f = py(e).toNumber();
  return {
    purchaseDate: r,
    notional: o,
    assetProceeds: n,
    purchaseProceeds: i,
    salesProceeds: t,
    purchasePrice: u,
    totalDiscount: l,
    realizedSurplus: f
  };
}
function ly(e, r = "iso", o = !0) {
  const n = e.filter(
    ({ type: f }) => f === lt
  );
  if (!n.length)
    return "";
  const i = Ha(n), u = by(n).div(i), l = o ? nr.bignumber(
    vy(new Date(u.toNumber())).getTime()
  ) : u;
  return r === "iso" ? new Date(l.toNumber()).toISOString() : l;
}
function xc(e) {
  const r = Ec(e), o = ka(
    e,
    lt
  ), n = ka(
    e,
    Kt
  );
  return o.sub(n).eq(0) ? nr.bignumber(0) : r.add(
    nr.bignumber(o).sub(nr.bignumber(n))
  );
}
function dy(e) {
  return Zn(e, Kt).sub(
    Zn(e, lt)
  );
}
function ho(e) {
  const r = Zn(
    e,
    lt
  ), o = Ac(e, lt);
  return r.add(o);
}
function po(e) {
  const r = Zn(
    e,
    Kt
  ), o = Ac(e, Kt);
  return r.sub(o);
}
function Ec(e) {
  const r = ka(
    e,
    lt
  ), o = Zn(
    e,
    lt
  );
  return r.equals(0) ? nr.bignumber(0) : o.div(
    r
  );
}
function hy(e) {
  const r = xc(e), o = ho(e), n = po(e);
  return r.sub(o.sub(n));
}
function py(e) {
  const r = po(e), o = ho(e), n = r.sub(o);
  return n.greaterThan(0) ? n : nr.bignumber(0);
}
function Ac(e, r) {
  return e.reduce((o, { type: n, fees: i }) => !i || r && n !== r ? o : o.add(
    i.reduce(
      (t, { amount: u }) => nr.bignumber(t).add(nr.bignumber(u)),
      nr.bignumber(0)
    )
  ), nr.bignumber(0));
}
function Zn(e, r) {
  return e.reduce((o, n) => {
    if (n.type !== r)
      return o;
    const i = nr.bignumber(n.cashTransaction.amount);
    return o.add(i);
  }, nr.bignumber(0));
}
function ka(e, r) {
  return e.reduce((o, n) => {
    var t;
    if (n.type !== r)
      return o;
    const i = nr.bignumber(
      ((t = n.fixedIncomeTransaction) == null ? void 0 : t.amount) ?? 0
    );
    return o.add(i);
  }, nr.bignumber(0));
}
function vy(e) {
  const r = e.getUTCFullYear(), o = e.getUTCMonth(), n = e.getUTCDate(), i = e.getUTCHours();
  let t = new Date(Date.UTC(r, o, n));
  return i >= 12 && (t = new Date(t.getTime() + 24 * 60 * 60 * 1e3)), t;
}
function On(e, r, o) {
  if (!e)
    throw new Error("Missing required fields: transactionType");
  const n = UR[e], i = yn(o);
  return nr.bignumber((r ?? 0) * n).sub(i);
}
function yn(e) {
  return ((e == null ? void 0 : e.map((n) => n.amount).filter(Boolean)) ?? []).reduce(
    (n, i) => n.add(nr.bignumber(i)),
    nr.bignumber(0)
  );
}
function my(e, r) {
  return !e || !r ? nr.bignumber(0) : nr.bignumber(e).div(nr.bignumber(r));
}
function gy(e) {
  const {
    asset: r,
    transactions: o,
    fixedIncomeTypes: n,
    currentDate: i = /* @__PURE__ */ new Date()
  } = e;
  if (!r.maturity || n.find(
    ({ id: x }) => x === r.fixedIncomeTypeId
  ).name !== "Treasury Bill")
    return null;
  const u = o.filter(
    ({ type: x, fixedIncomeTransaction: y }) => x === lt && (y == null ? void 0 : y.assetId) === r.id
  ), l = o.filter(
    ({ type: x, fixedIncomeTransaction: y }) => x === Kt && (y == null ? void 0 : y.assetId) === r.id
  );
  if (!u.length && !l.length)
    return null;
  const f = nr.bignumber(i.getTime()), s = nr.bignumber(new Date(r.maturity).getTime());
  if (s.lessThan(f))
    return null;
  const a = nr.bignumber(
    new Date(r.purchaseDate).getTime()
  ), c = Ha(
    u
  ).sub(Ha(l)), d = nr.bignumber(r.salesProceeds), h = nr.bignumber(r.realizedSurplus), v = nr.bignumber(r.purchaseProceeds).sub(d).add(h), g = c.sub(v);
  return f.sub(a).div(s.sub(a)).mul(g).add(v).toNumber();
}
function Ha(e) {
  return e.reduce((r, { fixedIncomeTransaction: o }) => o ? r.add(nr.bignumber(o.amount)) : r, nr.bignumber(0));
}
function by(e) {
  return e.reduce((r, { fixedIncomeTransaction: o }) => {
    if (!o)
      return r;
    const { entryTime: n, amount: i } = o, t = nr.bignumber(new Date(n).getTime());
    return r.add(t.mul(nr.bignumber(i)));
  }, nr.bignumber(0));
}
function kR(e, r) {
  if (!e || !r)
    return {};
  const o = {};
  function n(t) {
    return !!t && typeof t == "object" && !Array.isArray(t);
  }
  const i = (t, u) => {
    if (n(t) && n(u)) {
      const l = Object.keys(t).sort(), f = Object.keys(u).sort();
      return !!(JSON.stringify(l) !== JSON.stringify(f) || l.some(
        (s) => i(
          t[s],
          u[s]
        )
      ));
    } else
      return Array.isArray(t) && Array.isArray(u) ? JSON.stringify(t) !== JSON.stringify(u) : t !== u;
  };
  for (const t of /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(r)]))
    i(
      e[t],
      r[t]
    ) && (o[t] = r[t]);
  return Object.entries(o).reduce(
    (t, [u, l]) => (l !== void 0 && (t[u] = l), t),
    {}
  );
}
function yy(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function Lm(e) {
  return yy(e) === "Array";
}
function HR(e) {
  if (yy(e) !== "Object")
    return !1;
  const r = Object.getPrototypeOf(e);
  return !!r && r.constructor === Object && r === Object.prototype;
}
function GR(e, r, o, n, i) {
  const t = {}.propertyIsEnumerable.call(n, r) ? "enumerable" : "nonenumerable";
  t === "enumerable" && (e[r] = o), i && t === "nonenumerable" && Object.defineProperty(e, r, {
    value: o,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function Si(e, r = {}) {
  if (Lm(e))
    return e.map((i) => Si(i, r));
  if (!HR(e))
    return e;
  const o = Object.getOwnPropertyNames(e), n = Object.getOwnPropertySymbols(e);
  return [...o, ...n].reduce((i, t) => {
    if (Lm(r.props) && !r.props.includes(t))
      return i;
    const u = e[t], l = Si(u, r);
    return GR(i, t, l, e, r.nonenumerable), i;
  }, {});
}
function hi(e, r) {
  const o = e.portfolio.find((u) => u.id === r);
  if (!o)
    throw new Error(`Asset with id ${r} does not exist!`);
  const n = wy(e, r), i = cy(n);
  return xy(i), {
    ...o,
    ...i
  };
}
function VR(e, r = /* @__PURE__ */ new Date()) {
  const o = Si(e), n = o.state.global.transactions, i = o.state.global.fixedIncomeTypes, u = o.state.global.portfolio.map((l) => ({
    ...l,
    ...vo(l) && {
      currentValue: gy({
        asset: l,
        transactions: n,
        fixedIncomeTypes: i,
        currentDate: r
      })
    }
  }));
  return o.state.global.portfolio = u, o;
}
function wy(e, r) {
  var n;
  const o = [];
  for (const i of e.transactions)
    zm in i && ((n = i[zm]) == null ? void 0 : n.assetId) === r && o.push(i);
  return o;
}
function WR(e) {
  return e.filter(
    (r) => r.type === lt || r.type === Kt
  ).map((r) => r.fixedIncomeTransaction);
}
function KR(e) {
  return e.filter((r) => r.type === Kt);
}
function ZR(e) {
  return e.filter(
    (r) => r.type === lt
  );
}
const En = he.coerce.date(), gt = he.number();
function vo(e) {
  return e ? e.type === "FixedIncome" || "fixedIncomeId" in e : !1;
}
function Qt(e) {
  return e ? e.type === "Cash" || "currency" in e : !1;
}
function ef(e, r) {
  if (r) {
    if (r.fixedIncomeTypeId && !e.fixedIncomeTypes.find(
      (o) => o.id === r.fixedIncomeTypeId
    ))
      throw new Error(
        `Fixed income type with id ${r.fixedIncomeTypeId} does not exist!`
      );
    if (r.spvId && !e.spvs.find((o) => o.id === r.spvId))
      throw new Error(`SPV with id ${r.spvId} does not exist!`);
    if (r.maturity && !En.safeParse(r.maturity).success)
      throw new Error("Maturity must be a valid date");
  }
}
function xy(e) {
  if (e.purchaseDate && !En.safeParse(e.purchaseDate).success)
    throw new Error("Purchase date must be a valid date");
  if (e.notional && !gt.safeParse(e.notional).success)
    throw new Error("Notional must be a number");
  if (e.purchaseProceeds && !gt.safeParse(e.purchaseProceeds).success)
    throw new Error("Purchase proceeds must be a number");
  if (e.purchasePrice && !gt.safeParse(e.purchasePrice).success)
    throw new Error("Purchase price must be a number");
  if (e.totalDiscount && !gt.safeParse(e.totalDiscount).success)
    throw new Error("Total discount must be a number");
  if (e.salesProceeds && !gt.safeParse(e.salesProceeds).success)
    throw new Error("Annualized yield must be a number");
  if (e.realizedSurplus && !gt.safeParse(e.realizedSurplus).success)
    throw new Error("Realized surplus must be a number");
}
function Ey(e) {
  return e.type ? [lt, Kt].includes(e.type) : !1;
}
function Ay(e) {
  return e.type ? [uy, fy].includes(e.type) : !1;
}
function Sy(e) {
  return e.type ? [bc, gc].includes(e.type) : !1;
}
function Dy(e) {
  return e.type ? [wc, yc].includes(e.type) : !1;
}
function Ny(e) {
  if (!e.id)
    throw new Error("Transaction must have an id");
  if (!e.type)
    throw new Error("Transaction must have a type");
  if (!e.entryTime)
    throw new Error("Transaction must have an entry time");
  if (!En.safeParse(e.entryTime).success)
    throw new Error("Entry time must be a valid date");
}
function rf(e, r) {
  Ny(r), Fy(e, r.cashTransaction), Ay(r) && My(e, r), Ey(r) && _y(e, r), Sy(r) && Cy(e, r), Dy(r) && Ty(e, r);
}
function My(e, r) {
  jn(e, r.fees);
}
function _y(e, r) {
  if (!r.fixedIncomeTransaction)
    throw new Error(
      "Asset transaction must have a fixed income transaction"
    );
  if (r.unitPrice === null)
    throw new Error("Asset transaction must have a unit price");
  if (By(e, r.fixedIncomeTransaction), jn(e, r.fees), !gt.safeParse(r.unitPrice).success)
    throw new Error("Unit price must be a number");
  if (!gt.positive().safeParse(r.unitPrice).success)
    throw new Error("Unit price must be positive");
}
function Cy(e, r) {
  const o = r.cashTransaction.counterPartyAccountId;
  if (!o)
    throw new Error(
      "Interest transaction must have a counter party account"
    );
  if (r.type === bc && o !== e.principalLenderAccountId)
    throw new Error(
      "Interest payment must have the principal lender as the counter party"
    );
  if (r.type === gc && !e.accounts.find((n) => n.id === o))
    throw new Error(
      `Counter party with account id ${o} does not exist!`
    );
  jn(e, r.fees);
}
function Ty(e, r) {
  if (!r.serviceProviderFeeTypeId)
    return;
  if (!e.serviceProviderFeeTypes.find(
    (n) => n.id === r.serviceProviderFeeTypeId
  ))
    throw new Error(
      `Service provider with id ${r.serviceProviderFeeTypeId} does not exist!`
    );
}
function Sc(e, r) {
  if (!r.assetId)
    throw new Error("Transaction must have an asset");
  if (!e.portfolio.find((o) => o.id === r.assetId))
    throw new Error(`Asset with id ${r.assetId} does not exist!`);
  if (!r.amount)
    throw new Error("Transaction must have an amount");
  if (!gt.positive().safeParse(r.amount).success)
    throw new Error("Transaction amount must be positive");
  if (!r.entryTime)
    throw new Error("Transaction must have an entry time");
  if (!En.safeParse(r.entryTime).success)
    throw new Error("Entry time must be a valid date");
  if (r.tradeTime && !En.safeParse(r.tradeTime).success)
    throw new Error("Trade time must be a valid date");
  if (r.settlementTime && !En.safeParse(r.settlementTime).success)
    throw new Error("Settlement time must be a valid date");
  if (r.accountId && !e.accounts.find((o) => o.id === r.accountId))
    throw new Error(
      `Account with id ${r.accountId} does not exist!`
    );
  if (r.counterPartyAccountId && !e.accounts.find((o) => o.id === r.counterPartyAccountId))
    throw new Error(
      `Counter party account with id ${r.counterPartyAccountId} does not exist!`
    );
}
function By(e, r) {
  if (r.assetType !== "FixedIncome")
    throw new Error(
      "Fixed income transaction must have a fixed income type"
    );
  if (Sc(e, r), !vo(
    e.portfolio.find((o) => o.id === r.assetId)
  ))
    throw new Error(
      "Fixed income transaction must have a fixed income type"
    );
}
function Fy(e, r) {
  if (r.assetType !== "Cash")
    throw new Error("Cash transaction must have a cash type");
  if (Sc(e, r), r.counterPartyAccountId !== e.principalLenderAccountId)
    throw new Error(
      "Cash transaction must have the principal lender as the counter party"
    );
  if (!Qt(e.portfolio.find((o) => o.id === r.assetId)))
    throw new Error("Cash transaction must have a cash asset as the asset");
}
function Dc(e, r) {
  if (!r)
    throw new Error("Fee does not exist");
  if (!r.serviceProviderFeeTypeId)
    throw new Error("Transaction fee must have a service provider");
  if (!r.amount)
    throw new Error("Transaction fee must have an amount");
  if (r.serviceProviderFeeTypeId && !e.serviceProviderFeeTypes.find(
    (o) => o.id === r.serviceProviderFeeTypeId
  ))
    throw new Error(
      `Service provider with account id ${r.serviceProviderFeeTypeId} does not exist!`
    );
  if (!gt.positive().safeParse(r.amount).success)
    throw new Error("Fee amount must be a number");
}
function jn(e, r) {
  if (r !== null) {
    if (!Array.isArray(r))
      throw new Error("Transaction fees must be an array");
    r.forEach((o) => {
      Dc(e, o);
    });
  }
}
const jR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  calculateAssetProceeds: dy,
  calculateCashBalanceChange: On,
  calculateCurrentValue: gy,
  calculateNotional: xc,
  calculatePurchaseDate: ly,
  calculatePurchasePrice: Ec,
  calculatePurchaseProceeds: ho,
  calculateRealizedSurplus: py,
  calculateSalesProceeds: po,
  calculateSumQuantity: Ha,
  calculateSumQuantityTimesDate: by,
  calculateTotalDiscount: hy,
  calculateTotalFees: yn,
  calculateUnitPrice: my,
  computeFixedIncomeAssetDerivedFields: cy,
  dateValidator: En,
  getAssetPurchaseTransactionsFromFixedIncomeTransactions: ZR,
  getAssetSaleTransactionsFromFixedIncomeTransactions: KR,
  getDifferences: kR,
  getFixedIncomeTransactionsFromGroupTransactions: WR,
  getGroupTransactionsForAsset: wy,
  isAssetGroupTransaction: Ey,
  isCashAsset: Qt,
  isFeesGroupTransaction: Dy,
  isFixedIncomeAsset: vo,
  isInterestGroupTransaction: Sy,
  isPrincipalGroupTransaction: Ay,
  makeFixedIncomeAssetWithDerivedFields: hi,
  makeRwaDocumentWithAssetCurrentValues: VR,
  math: nr,
  numberValidator: gt,
  roundToNearestDay: vy,
  sumAssetTransactionsForType: ka,
  sumCashTransactionsForType: Zn,
  sumGroupTransactionFees: Ac,
  validateAssetGroupTransaction: _y,
  validateBaseTransaction: Sc,
  validateCashTransaction: Fy,
  validateFeesGroupTransaction: Ty,
  validateFixedIncomeAsset: ef,
  validateFixedIncomeAssetDerivedFields: xy,
  validateFixedIncomeTransaction: By,
  validateGroupTransaction: rf,
  validateInterestGroupTransaction: Cy,
  validatePrincipalGroupTransaction: My,
  validateSharedGroupTransactionFields: Ny,
  validateTransactionFee: Dc,
  validateTransactionFees: jn
}, Symbol.toStringTag, { value: "Module" })), Lt = {
  createFixedIncomeTypeOperation(e, r, o) {
    if (!r.input.id)
      throw new Error("Fixed income type must have an id");
    if (!r.input.name)
      throw new Error("Fixed income type must have a name");
    if (e.fixedIncomeTypes.find((n) => n.id === r.input.id))
      throw new Error(`Type with id ${r.input.id} already exists!`);
    e.fixedIncomeTypes.push(r.input);
  },
  editFixedIncomeTypeOperation(e, r, o) {
    if (!r.input.id)
      throw new Error("Fixed income type must have an id");
    if (!e.fixedIncomeTypes.find(
      (i) => i.id === r.input.id
    ))
      throw new Error(`Type with id ${r.input.id} does not exist!`);
    e.fixedIncomeTypes = e.fixedIncomeTypes.map(
      (i) => i.id === r.input.id ? {
        ...i,
        name: r.input.name ?? i.name
      } : i
    );
  },
  deleteFixedIncomeTypeOperation(e, r, o) {
    const n = r.input.id;
    if (!n)
      throw new Error("Fixed income type must have an id");
    if (!e.fixedIncomeTypes.find(
      (u) => u.id === n
    ))
      throw new Error(`Type with id ${n} does not exist!`);
    if (e.portfolio.filter(
      (u) => vo(u) && u.fixedIncomeTypeId === n
    ).length !== 0)
      throw new Error(
        "Cannot delete fixed income type because it has assets that depend on it. Please change or delete those assets first."
      );
    e.fixedIncomeTypes = e.fixedIncomeTypes.filter(
      (u) => u.id !== n
    );
  },
  createFixedIncomeAssetOperation(e, r, o) {
    if (!r.input.id)
      throw new Error("Fixed income asset must have an id");
    if (e.portfolio.find((i) => i.id === r.input.id))
      throw new Error(`Asset with id ${r.input.id} already exists!`);
    if (!r.input.fixedIncomeTypeId)
      throw new Error("Fixed income asset must have a type");
    if (!r.input.name)
      throw new Error("Fixed income asset must have a name");
    if (!r.input.spvId)
      throw new Error("Fixed income asset must have an SPV");
    ef(e, r.input);
    const n = {
      ...r.input,
      type: "FixedIncome",
      maturity: r.input.maturity ?? null,
      ISIN: r.input.ISIN ?? null,
      CUSIP: r.input.CUSIP ?? null,
      coupon: r.input.coupon ?? null,
      // the following values are all derived from underlying fixed income transactions
      // and are set to 0 by default
      purchasePrice: 0,
      totalDiscount: 0,
      notional: 0,
      purchaseDate: "",
      purchaseProceeds: 0,
      assetProceeds: 0,
      salesProceeds: 0,
      realizedSurplus: 0
    };
    e.portfolio.push(n);
  },
  createCashAssetOperation(e, r, o) {
    if (!r.input.id)
      throw new Error("Cash asset must have an id");
    if (!r.input.spvId)
      throw new Error("Cash asset must have a spv");
    if (!r.input.currency)
      throw new Error("Cash asset must have a currency");
    if (!r.input.balance)
      throw new Error("Cash asset must have a balance");
    if (!e.spvs.find((n) => n.id === r.input.spvId))
      throw new Error(`SPV with id ${r.input.id} does not exist!`);
    if (r.input.currency !== "USD")
      throw new Error("Only USD currency is supported");
    if (e.portfolio.find((n) => n.id === r.input.id))
      throw new Error(`Asset with id ${r.input.id} already exists!`);
    e.portfolio.push(r.input);
  },
  editFixedIncomeAssetOperation(e, r, o) {
    if (!r.input.id)
      throw new Error("Fixed income asset must have an id");
    if (!e.portfolio.find(
      (i) => i.id === r.input.id
    ))
      throw new Error(`Asset with id ${r.input.id} does not exist!`);
    ef(e, r.input), e.portfolio = e.portfolio.map(
      (i) => i.id === r.input.id ? {
        ...i,
        ...r.input
      } : i
    );
  },
  editCashAssetOperation(e, r, o) {
    if (!r.input.id)
      throw new Error("Cash asset must have an id");
    if (!e.portfolio.find(
      (i) => i.id === r.input.id
    ))
      throw new Error(`Asset with id ${r.input.id} does not exist!`);
    if (r.input.spvId && !e.spvs.find((i) => i.id === r.input.spvId))
      throw new Error(`SPV with id ${r.input.id} does not exist!`);
    if (r.input.currency && r.input.currency !== "USD")
      throw new Error("Only USD currency is supported");
    e.portfolio = e.portfolio.map(
      (i) => i.id === r.input.id ? {
        ...i,
        ...r.input
      } : i
    );
  },
  deleteFixedIncomeAssetOperation(e, r, o) {
    const n = r.input.id;
    if (!n)
      throw new Error("Fixed income asset must have an id");
    if (!e.portfolio.find((u) => u.id === n))
      throw new Error(`Asset with id ${n} does not exist!`);
    if (e.transactions.filter(
      (u) => {
        var l;
        return ((l = u.fixedIncomeTransaction) == null ? void 0 : l.assetId) === n;
      }
    ).length !== 0)
      throw new Error(
        "Cannot delete asset because it has dependent transactions. Please change or delete those transactions first."
      );
    e.portfolio = e.portfolio.filter((u) => u.id !== n);
  },
  deleteCashAssetOperation(e, r, o) {
    const n = r.input.id;
    if (!n)
      throw new Error("Fixed income asset must have an id");
    if (!e.portfolio.find((u) => u.id === n))
      throw new Error(`Asset with id ${n} does not exist!`);
    if (e.transactions.filter(
      (u) => u.cashTransaction.assetId === n
    ).length !== 0)
      throw new Error(
        "Cannot delete asset because it has dependent transactions. Please change or delete those transactions first."
      );
    e.portfolio = e.portfolio.filter((u) => u.id !== n);
  }
}, In = {
  createGroupTransactionOperation(e, r, o) {
    const n = r.input.id;
    if (!n)
      throw new Error("Group transaction must have an id");
    const i = r.input.type, t = r.input.entryTime, u = r.input.fees ?? null, l = r.input.serviceProviderFeeTypeId ?? null, f = r.input.txRef ?? null;
    let s = r.input.cashTransaction, a = r.input.fixedIncomeTransaction ?? null;
    const c = On(
      i,
      s.amount,
      u
    ).toNumber(), d = a ? my(
      s.amount,
      a.amount
    ).toNumber() : null;
    s = {
      ...s,
      entryTime: t
    }, a && (a = {
      ...a,
      entryTime: t
    });
    const h = {
      id: n,
      type: i,
      entryTime: t,
      cashBalanceChange: c,
      unitPrice: d,
      serviceProviderFeeTypeId: l,
      txRef: f,
      fees: u,
      cashTransaction: s,
      fixedIncomeTransaction: a
    };
    rf(e, h), e.transactions.push(h);
    const p = e.portfolio.find((x) => Qt(x)), v = {
      ...p,
      balance: p.balance + c
    };
    e.portfolio = e.portfolio.map(
      (x) => x.id === p.id ? v : x
    );
    const g = a == null ? void 0 : a.assetId;
    if (!g)
      return;
    const m = hi(
      e,
      g
    );
    e.portfolio = e.portfolio.map(
      (x) => x.id === g ? m : x
    );
  },
  editGroupTransactionOperation(e, r, o) {
    var d;
    if (!r.input.id)
      throw new Error("Group transaction must have an id");
    const i = e.transactions.find(
      (h) => h.id === r.input.id
    );
    if (!i)
      throw new Error(
        `Group transaction with id ${r.input.id} does not exist!`
      );
    const t = Si(i), {
      type: u,
      entryTime: l,
      serviceProviderFeeTypeId: f,
      txRef: s,
      cashTransaction: a,
      fixedIncomeTransaction: c
    } = r.input;
    if (u && (t.type = u), l && (t.entryTime = l, t.cashTransaction.entryTime = l), f && (t.serviceProviderFeeTypeId = f), s && (t.txRef = s), a != null && a.amount && (t.cashTransaction.amount = a.amount), (a != null && a.amount || u) && (t.cashBalanceChange = On(
      t.type,
      t.cashTransaction.amount,
      t.fees
    ).toNumber()), t.fixedIncomeTransaction && (c != null && c.amount && (t.fixedIncomeTransaction.amount = c.amount), c != null && c.assetId && (t.fixedIncomeTransaction.assetId = c.assetId), t.fixedIncomeTransaction.entryTime = t.entryTime), rf(e, t), e.transactions = e.transactions.map(
      (h) => h.id === t.id ? t : h
    ), a != null && a.amount || u) {
      const h = e.portfolio.find((p) => Qt(p));
      h.balance += t.cashBalanceChange - i.cashBalanceChange, e.portfolio = e.portfolio.map(
        (p) => p.id === h.id ? h : p
      );
    }
    if ((d = i.fixedIncomeTransaction) != null && d.assetId) {
      const h = hi(
        e,
        i.fixedIncomeTransaction.assetId
      );
      e.portfolio = e.portfolio.map(
        (p) => p.id === h.id ? h : p
      );
    }
    if (c != null && c.assetId) {
      const h = hi(
        e,
        c.assetId
      );
      e.portfolio = e.portfolio.map(
        (p) => p.id === h.id ? h : p
      );
    }
  },
  deleteGroupTransactionOperation(e, r, o) {
    var s;
    const n = r.input.id;
    if (!n)
      throw new Error("Group transaction must have an id");
    const i = e.transactions.find(
      (a) => a.id === n
    );
    if (!i)
      throw new Error("Transaction does not exist");
    e.transactions = e.transactions.filter(
      (a) => a.id !== n
    );
    const t = e.portfolio.find((a) => Qt(a)), u = {
      ...t,
      balance: t.balance - i.cashBalanceChange
    };
    e.portfolio = e.portfolio.map(
      (a) => a.id === t.id ? u : a
    );
    const l = (s = i.fixedIncomeTransaction) == null ? void 0 : s.assetId;
    if (!l)
      return;
    const f = hi(
      e,
      l
    );
    e.portfolio = e.portfolio.map(
      (a) => a.id === l ? f : a
    );
  },
  addFeesToGroupTransactionOperation(e, r, o) {
    const n = r.input.id, i = e.transactions.find(
      (a) => a.id === n
    );
    if (!i)
      throw new Error(`Group transaction with id ${n} does not exist!`);
    if (LR.includes(i.type))
      throw new Error(
        `Cannot add fees to a transaction of type ${i.type}`
      );
    jn(e, r.input.fees);
    const t = Si(i.fees ?? []), u = yn(t);
    i.fees || (i.fees = []), i.fees.push(...r.input.fees);
    const l = yn(i.fees);
    i.cashBalanceChange = On(
      i.type,
      i.cashTransaction.amount,
      i.fees
    ).toNumber(), e.transactions = e.transactions.map(
      (a) => a.id === r.input.id ? i : a
    );
    const f = e.portfolio.find((a) => Qt(a)), s = {
      ...f,
      balance: nr.bignumber(f.balance).add(u.sub(l)).toNumber()
    };
    e.portfolio = e.portfolio.map(
      (a) => a.id === f.id ? s : a
    );
  },
  removeFeesFromGroupTransactionOperation(e, r, o) {
    const n = r.input.id, i = r.input.feeIds, t = e.transactions.find(
      (s) => s.id === n
    );
    if (!t)
      throw new Error("Transaction does not exist");
    if (!t.fees)
      throw new Error("Transaction has no fees to remove");
    const u = yn(t.fees);
    t.fees = t.fees.filter(
      (s) => !(i != null && i.includes(s.id))
    ), t.cashBalanceChange = On(
      t.type,
      t.cashTransaction.amount,
      t.fees
    ).toNumber(), e.transactions = e.transactions.map(
      (s) => s.id === n ? t : s
    );
    const l = e.portfolio.find((s) => Qt(s)), f = {
      ...l,
      balance: nr.bignumber(l.balance).add(u).toNumber()
    };
    e.portfolio = e.portfolio.map(
      (s) => s.id === l.id ? f : s
    );
  },
  editGroupTransactionFeesOperation(e, r, o) {
    const n = r.input.id, i = r.input.fees;
    if (!i)
      throw new Error("Fees must be provided");
    const t = e.transactions.find(
      (a) => a.id === n
    );
    if (!t)
      throw new Error("Transaction does not exist");
    if (jn(e, r.input.fees), !t.fees)
      throw new Error("This transaction has no fees to update");
    const u = yn(t.fees);
    t.fees = t.fees.map((a) => {
      const c = i.find((d) => d.id === a.id);
      if (c)
        return Dc(e, c), { ...a, ...c };
    }).filter(Boolean);
    const l = yn(t.fees);
    t.cashBalanceChange = On(
      t.type,
      t.cashTransaction.amount,
      t.fees
    ).toNumber(), e.transactions = e.transactions.map(
      (a) => a.id === n ? t : a
    );
    const f = e.portfolio.find((a) => Qt(a)), s = {
      ...f,
      balance: nr.bignumber(f.balance).add(u.sub(l)).toNumber()
    };
    e.portfolio = e.portfolio.map(
      (a) => a.id === f.id ? s : a
    );
  }
}, YR = (e, r, o) => {
  if (vt.isBaseAction(r))
    return e;
  switch (r.type) {
    case "CREATE_SPV":
      cf().parse(r.input), qt.createSpvOperation(e[r.scope], r, o);
      break;
    case "EDIT_SPV":
      Df().parse(r.input), qt.editSpvOperation(e[r.scope], r, o);
      break;
    case "DELETE_SPV":
      gf().parse(r.input), qt.deleteSpvOperation(e[r.scope], r, o);
      break;
    case "CREATE_SERVICE_PROVIDER_FEE_TYPE":
      ff().parse(r.input), qt.createServiceProviderFeeTypeOperation(e[r.scope], r, o);
      break;
    case "EDIT_SERVICE_PROVIDER_FEE_TYPE":
      Sf().parse(r.input), qt.editServiceProviderFeeTypeOperation(e[r.scope], r, o);
      break;
    case "DELETE_SERVICE_PROVIDER_FEE_TYPE":
      mf().parse(r.input), qt.deleteServiceProviderFeeTypeOperation(e[r.scope], r, o);
      break;
    case "CREATE_ACCOUNT":
      nf().parse(r.input), qt.createAccountOperation(e[r.scope], r, o);
      break;
    case "EDIT_ACCOUNT":
      bf().parse(r.input), qt.editAccountOperation(e[r.scope], r, o);
      break;
    case "DELETE_ACCOUNT":
      lf().parse(r.input), qt.deleteAccountOperation(e[r.scope], r, o);
      break;
    case "CREATE_FIXED_INCOME_TYPE":
      sf().parse(r.input), Lt.createFixedIncomeTypeOperation(e[r.scope], r, o);
      break;
    case "EDIT_FIXED_INCOME_TYPE":
      xf().parse(r.input), Lt.editFixedIncomeTypeOperation(e[r.scope], r, o);
      break;
    case "DELETE_FIXED_INCOME_TYPE":
      pf().parse(r.input), Lt.deleteFixedIncomeTypeOperation(e[r.scope], r, o);
      break;
    case "CREATE_FIXED_INCOME_ASSET":
      of().parse(r.input), Lt.createFixedIncomeAssetOperation(e[r.scope], r, o);
      break;
    case "CREATE_CASH_ASSET":
      af().parse(r.input), Lt.createCashAssetOperation(e[r.scope], r, o);
      break;
    case "EDIT_FIXED_INCOME_ASSET":
      wf().parse(r.input), Lt.editFixedIncomeAssetOperation(e[r.scope], r, o);
      break;
    case "EDIT_CASH_ASSET":
      yf().parse(r.input), Lt.editCashAssetOperation(e[r.scope], r, o);
      break;
    case "DELETE_FIXED_INCOME_ASSET":
      hf().parse(r.input), Lt.deleteFixedIncomeAssetOperation(e[r.scope], r, o);
      break;
    case "DELETE_CASH_ASSET":
      df().parse(r.input), Lt.deleteCashAssetOperation(e[r.scope], r, o);
      break;
    case "CREATE_GROUP_TRANSACTION":
      uf().parse(r.input), In.createGroupTransactionOperation(e[r.scope], r, o);
      break;
    case "EDIT_GROUP_TRANSACTION":
      Af().parse(r.input), In.editGroupTransactionOperation(e[r.scope], r, o);
      break;
    case "ADD_FEES_TO_GROUP_TRANSACTION":
      tf().parse(r.input), In.addFeesToGroupTransactionOperation(e[r.scope], r, o);
      break;
    case "EDIT_GROUP_TRANSACTION_FEES":
      Ef().parse(r.input), In.editGroupTransactionFeesOperation(e[r.scope], r, o);
      break;
    case "REMOVE_FEES_FROM_GROUP_TRANSACTION":
      Nf().parse(r.input), In.removeFeesFromGroupTransactionOperation(e[r.scope], r, o);
      break;
    case "DELETE_GROUP_TRANSACTION":
      vf().parse(r.input), In.deleteGroupTransactionOperation(e[r.scope], r, o);
      break;
    default:
      return e;
  }
}, Ga = vt.createReducer(YR), XR = { accounts: [{ id: "principal-lender-account-id", reference: "0x", label: "Principal Lender" }], principalLenderAccountId: "principal-lender-account-id", spvs: [], serviceProviderFeeTypes: [{ id: "principal-fee-type-id", name: "Principal", feeType: "Principal", accountId: "principal-lender-account-id" }], fixedIncomeTypes: [{ id: "treasury-bill", name: "Treasury Bill" }], portfolio: [{ id: "principal-asset-id", type: "Cash", spvId: "1", currency: "USD", balance: 0 }], transactions: [] }, JR = {}, vi = {
  fileExtension: "",
  createState(e) {
    return { global: { ...XR, ...e == null ? void 0 : e.global }, local: { ...JR, ...e == null ? void 0 : e.local } };
  },
  createExtendedState(e) {
    return vt.createExtendedState(
      { ...e, documentType: "makerdao/rwa-portfolio" },
      vi.createState
    );
  },
  createDocument(e) {
    return vt.createDocument(
      vi.createExtendedState(e),
      vi.createState
    );
  },
  saveToFile(e, r, o) {
    return vt.saveToFile(e, r, "", o);
  },
  saveToFileHandle(e, r) {
    return vt.saveToFileHandle(e, r);
  },
  loadFromFile(e) {
    return vt.loadFromFile(e, Ga);
  },
  loadFromInput(e) {
    return vt.loadFromInput(e, Ga);
  }
}, { createAction: jt } = vt, Iy = (e) => jt(
  "CREATE_SPV",
  { ...e },
  void 0,
  cf,
  "global"
), Oy = (e) => jt(
  "EDIT_SPV",
  { ...e },
  void 0,
  Df,
  "global"
), Ry = (e) => jt(
  "DELETE_SPV",
  { ...e },
  void 0,
  gf,
  "global"
), Py = (e) => jt(
  "CREATE_SERVICE_PROVIDER_FEE_TYPE",
  { ...e },
  void 0,
  ff,
  "global"
), qy = (e) => jt(
  "EDIT_SERVICE_PROVIDER_FEE_TYPE",
  { ...e },
  void 0,
  Sf,
  "global"
), $y = (e) => jt(
  "DELETE_SERVICE_PROVIDER_FEE_TYPE",
  { ...e },
  void 0,
  mf,
  "global"
), zy = (e) => jt(
  "CREATE_ACCOUNT",
  { ...e },
  void 0,
  nf,
  "global"
), Ly = (e) => jt(
  "EDIT_ACCOUNT",
  { ...e },
  void 0,
  bf,
  "global"
), Uy = (e) => jt(
  "DELETE_ACCOUNT",
  { ...e },
  void 0,
  lf,
  "global"
);
class QR extends Ka {
  createSpv(r) {
    return this.dispatch(Iy(r));
  }
  editSpv(r) {
    return this.dispatch(Oy(r));
  }
  deleteSpv(r) {
    return this.dispatch(Ry(r));
  }
  createServiceProviderFeeType(r) {
    return this.dispatch(Py(r));
  }
  editServiceProviderFeeType(r) {
    return this.dispatch(qy(r));
  }
  deleteServiceProviderFeeType(r) {
    return this.dispatch($y(r));
  }
  createAccount(r) {
    return this.dispatch(zy(r));
  }
  editAccount(r) {
    return this.dispatch(Ly(r));
  }
  deleteAccount(r) {
    return this.dispatch(Uy(r));
  }
}
const { createAction: Yt } = vt, ky = (e) => Yt(
  "CREATE_FIXED_INCOME_TYPE",
  { ...e },
  void 0,
  sf,
  "global"
), Hy = (e) => Yt(
  "EDIT_FIXED_INCOME_TYPE",
  { ...e },
  void 0,
  xf,
  "global"
), Gy = (e) => Yt(
  "DELETE_FIXED_INCOME_TYPE",
  { ...e },
  void 0,
  pf,
  "global"
), Vy = (e) => Yt(
  "CREATE_FIXED_INCOME_ASSET",
  { ...e },
  void 0,
  of,
  "global"
), Wy = (e) => Yt(
  "CREATE_CASH_ASSET",
  { ...e },
  void 0,
  af,
  "global"
), Ky = (e) => Yt(
  "EDIT_FIXED_INCOME_ASSET",
  { ...e },
  void 0,
  wf,
  "global"
), Zy = (e) => Yt(
  "EDIT_CASH_ASSET",
  { ...e },
  void 0,
  yf,
  "global"
), jy = (e) => Yt(
  "DELETE_FIXED_INCOME_ASSET",
  { ...e },
  void 0,
  hf,
  "global"
), Yy = (e) => Yt(
  "DELETE_CASH_ASSET",
  { ...e },
  void 0,
  df,
  "global"
);
class eP extends Ka {
  createFixedIncomeType(r) {
    return this.dispatch(ky(r));
  }
  editFixedIncomeType(r) {
    return this.dispatch(Hy(r));
  }
  deleteFixedIncomeType(r) {
    return this.dispatch(Gy(r));
  }
  createFixedIncomeAsset(r) {
    return this.dispatch(Vy(r));
  }
  createCashAsset(r) {
    return this.dispatch(Wy(r));
  }
  editFixedIncomeAsset(r) {
    return this.dispatch(Ky(r));
  }
  editCashAsset(r) {
    return this.dispatch(Zy(r));
  }
  deleteFixedIncomeAsset(r) {
    return this.dispatch(jy(r));
  }
  deleteCashAsset(r) {
    return this.dispatch(Yy(r));
  }
}
const { createAction: oi } = vt, Xy = (e) => oi(
  "CREATE_GROUP_TRANSACTION",
  { ...e },
  void 0,
  uf,
  "global"
), Jy = (e) => oi(
  "EDIT_GROUP_TRANSACTION",
  { ...e },
  void 0,
  Af,
  "global"
), Qy = (e) => oi(
  "ADD_FEES_TO_GROUP_TRANSACTION",
  { ...e },
  void 0,
  tf,
  "global"
), e2 = (e) => oi(
  "EDIT_GROUP_TRANSACTION_FEES",
  { ...e },
  void 0,
  Ef,
  "global"
), r2 = (e) => oi(
  "REMOVE_FEES_FROM_GROUP_TRANSACTION",
  { ...e },
  void 0,
  Nf,
  "global"
), t2 = (e) => oi(
  "DELETE_GROUP_TRANSACTION",
  { ...e },
  void 0,
  vf,
  "global"
);
class rP extends Ka {
  createGroupTransaction(r) {
    return this.dispatch(Xy(r));
  }
  editGroupTransaction(r) {
    return this.dispatch(Jy(r));
  }
  addFeesToGroupTransaction(r) {
    return this.dispatch(Qy(r));
  }
  editGroupTransactionFees(r) {
    return this.dispatch(e2(r));
  }
  removeFeesFromGroupTransaction(r) {
    return this.dispatch(r2(r));
  }
  deleteGroupTransaction(r) {
    return this.dispatch(t2(r));
  }
}
const Wa = class Wa extends Ka {
  constructor(r, o) {
    super(Ga, vi.createDocument(r), o);
  }
  saveToFile(r, o) {
    return super.saveToFile(r, Wa.fileExtension, o);
  }
  loadFromFile(r) {
    return super.loadFromFile(r);
  }
  static async fromFile(r) {
    const o = new this();
    return await o.loadFromFile(r), o;
  }
};
Nc(Wa, "fileExtension", "");
let Va = Wa;
a2(Va, [
  QR,
  eP,
  rP
]);
const tP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addFeesToGroupTransaction: Qy,
  createAccount: zy,
  createCashAsset: Wy,
  createFixedIncomeAsset: Vy,
  createFixedIncomeType: ky,
  createGroupTransaction: Xy,
  createServiceProviderFeeType: Py,
  createSpv: Iy,
  deleteAccount: Uy,
  deleteCashAsset: Yy,
  deleteFixedIncomeAsset: jy,
  deleteFixedIncomeType: Gy,
  deleteGroupTransaction: t2,
  deleteServiceProviderFeeType: $y,
  deleteSpv: Ry,
  editAccount: Ly,
  editCashAsset: Zy,
  editFixedIncomeAsset: Ky,
  editFixedIncomeType: Hy,
  editGroupTransaction: Jy,
  editGroupTransactionFees: e2,
  editServiceProviderFeeType: qy,
  editSpv: Oy,
  removeFeesFromGroupTransaction: r2
}, Symbol.toStringTag, { value: "Module" })), nP = Va, iP = { ...vi, ...jR }, aP = { ...o2, ...tP }, cP = {
  Document: nP,
  reducer: Ga,
  actions: aP,
  utils: iP,
  documentModel: s2
};
export {
  xy as $,
  ly as A,
  xc as B,
  dy as C,
  nP as D,
  ho as E,
  po as F,
  Ec as G,
  hy as H,
  py as I,
  Ac as J,
  Zn as K,
  ka as L,
  vy as M,
  On as N,
  yn as O,
  my as P,
  Ha as Q,
  Va as R,
  by as S,
  hi as T,
  VR as U,
  wy as V,
  WR as W,
  KR as X,
  ZR as Y,
  vo as Z,
  ef as _,
  Lw as a,
  Ey as a0,
  Ay as a1,
  Sy as a2,
  Dy as a3,
  Ny as a4,
  rf as a5,
  My as a6,
  _y as a7,
  Cy as a8,
  Ty as a9,
  Sc as aa,
  By as ab,
  Fy as ac,
  Dc as ad,
  En as ae,
  gt as af,
  Si as b,
  Xe as c,
  kR as d,
  aP as e,
  gy as f,
  Ti as g,
  Qy as h,
  Qt as i,
  e2 as j,
  Jy as k,
  Xy as l,
  t2 as m,
  Vy as n,
  Py as o,
  cP as p,
  ay as q,
  r2 as r,
  Ii as s,
  Ga as t,
  iP as u,
  jn as v,
  s2 as w,
  nr as x,
  cy as y,
  fP as z
};
